import * as i0 from '@angular/core';
import { Injectable, inject, Pipe, Component, EventEmitter, Input, Output, Directive, HostListener, RendererFactory2, ChangeDetectorRef, ElementRef, NgZone, ContentChild, isDevMode, ViewChild, forwardRef, Renderer2, SecurityContext, ViewEncapsulation, ViewContainerRef, Injector, Self, Optional, Inject, NgModule, input, signal, computed, ChangeDetectionStrategy, ContentChildren, ErrorHandler, provideAppInitializer, InjectionToken, QueryList, ViewChildren } from '@angular/core';
import * as i1$3 from '@angular/router';
import { Router, RoutesRecognized, ActivatedRoute, NavigationEnd, Scroll, RouterModule } from '@angular/router';
import * as _ from 'lodash';
import ___default, { differenceWith, isEqual, cloneDeep as cloneDeep$1, isEmpty as isEmpty$1 } from 'lodash';
import { filter, pairwise, finalize, tap, map, shareReplay, catchError as catchError$1, last } from 'rxjs/operators';
import { BehaviorSubject, Subject, of, ReplaySubject, Observable, catchError, map as map$1, debounceTime, forkJoin, tap as tap$1, lastValueFrom, shareReplay as shareReplay$1, throwError, finalize as finalize$1 } from 'rxjs';
import * as i1$2 from '@angular/common';
import { Location, DatePipe, CommonModule, registerLocaleData, formatNumber } from '@angular/common';
import * as i1$1 from '@angular/forms';
import { UntypedFormControl, Validators, NG_VALIDATORS, NgModel, FormControlDirective, FormControlName, UntypedFormGroup, NG_VALUE_ACCESSOR, NgForm, FormControl, NgControl, FormsModule, ReactiveFormsModule, FormGroupDirective, FormGroup, FormBuilder } from '@angular/forms';
import * as i1 from 'primeng/breadcrumb';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import * as i2$4 from 'primeng/confirmdialog';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import * as i3 from 'primeng/dialog';
import { Dialog, DialogModule } from 'primeng/dialog';
import * as i4$1 from 'primeng/panel';
import { Panel, PanelModule } from 'primeng/panel';
import { OrderList, OrderListModule } from 'primeng/orderlist';
import * as i2$2 from 'primeng/calendar';
import { Calendar, CalendarModule } from 'primeng/calendar';
import * as i1$4 from '@angular/common/http';
import { HttpClient, HttpParams, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import * as i2 from 'primeng/api';
import { PrimeNGConfig, ConfirmationService, Header, PrimeTemplate } from 'primeng/api';
import * as i4 from 'primeng/editor';
import { EditorModule } from 'primeng/editor';
import * as i2$1 from 'primeng/autocomplete';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import * as i2$5 from 'primeng/chips';
import { Chips, ChipsModule } from 'primeng/chips';
import * as i13 from 'primeng/multiselect';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { TabView, TabPanel, TabViewModule } from 'primeng/tabview';
import * as i2$3 from 'primeng/dataview';
import { DataView, DataViewModule } from 'primeng/dataview';
import cloneDeep from 'lodash/cloneDeep';
import { AngularIndexedDB } from 'angular2-indexeddb';
import * as i4$3 from 'primeng/overlaypanel';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import * as i5 from 'primeng/treetable';
import { TreeTableToggler, TreeTable, TTSortIcon, TreeTableModule } from 'primeng/treetable';
import { PickList } from 'primeng/picklist';
import * as i3$1 from 'primeng/table';
import { Table, SortIcon, TableModule } from 'primeng/table';
import { Steps, StepsModule } from 'primeng/steps';
import * as i1$5 from '@angular/platform-browser';
import { Title, DomSanitizer } from '@angular/platform-browser';
import * as i26 from 'primeng/radiobutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import * as i7 from 'primeng/progressspinner';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import clone from 'lodash/clone';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import { html } from 'js-beautify';
import * as i4$2 from 'ngx-summernote';
import { NgxSummernoteModule } from 'ngx-summernote';
import * as i7$1 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import { trigger, transition, style, sequence, animate, query, animateChild, state } from '@angular/animations';
import { v4 } from 'uuid';
import * as i3$2 from 'primeng/fileupload';
import { FileUploadModule } from 'primeng/fileupload';
import * as i2$6 from 'ckeditor4-angular';
import { CKEditorModule } from 'ckeditor4-angular';
import { InputTextareaModule } from 'primeng/inputtextarea';
import * as i9 from 'primeng/accordion';
import { AccordionModule } from 'primeng/accordion';
import * as i2$7 from 'primeng/menu';
import { MenuModule } from 'primeng/menu';
import * as i4$4 from 'primeng/tooltip';
import * as i10 from 'primeng/chip';
import { ChipModule } from 'primeng/chip';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import localeEN from '@angular/common/locales/en';
import localeDE from '@angular/common/locales/de';
import { tick, ComponentFixtureAutoDetect, TestBed } from '@angular/core/testing';
import * as i7$2 from 'primeng/sidebar';
import { SidebarModule } from 'primeng/sidebar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputMaskModule } from 'primeng/inputmask';
import { FocusTrapModule } from 'primeng/focustrap';
import { FieldsetModule } from 'primeng/fieldset';
class HisMapUtils {
  static mapFromObject(obj, level = 1) {
    if (!obj) {
      return null;
    }
    let map = new Map();
    for (let key of Object.keys(obj)) {
      if (level <= 1) {
        map.set(key, obj[key]);
      } else {
        map.set(key, HisMapUtils.mapFromObject(obj[key], level - 1));
      }
    }
    return map;
  }
}

/**
 * provides authentication and authorisation information
 */
let HisAuthService = /*#__PURE__*/(() => {
  class HisAuthService {
    constructor() {
      this.rightsAndParameters = new Map();
      this.availableRoles = []; // initialization required for karma tests
      this.currentRole = undefined;
      this.asi = undefined;
    }
    /**
     * used internally to initialize the service
     *
     * @param userinfo user-information as provided by AngularServlet
     */
    init(userinfo) {
      this.rightsAndParameters = HisMapUtils.mapFromObject(userinfo.rightsAndParameters, 2);
      this.currentAuthority = userinfo.currentAuthority;
      this.orgunitId = userinfo.orgunitId;
      this.orgunitLid = userinfo.orgunitLid;
      this.orgunitDefaultText = userinfo.orgunitDefaultText;
      this.username = userinfo.username;
      this.fullname = userinfo.fullname;
      this.isAnonymous = userinfo.isAnonymous;
      this.roles = userinfo.roles;
      this.availableRoles = userinfo.availableRoles;
      this.asi = userinfo.asi;
      this.personId = userinfo.personId;
      // determine current role object; it is undefined if the user is not logged in
      for (let role of userinfo.availableRoles) {
        if (role.authorityName === this.currentAuthority) {
          this.currentRole = role;
          break;
        }
      }
      console.log('username = ' + this.username + ', fullname = ' + this.fullname + ', personId = ' + this.personId + ', isAnonymous = ' + this.isAnonymous + ', currentRole = ' + this.currentRole);
      console.log('rightsAndParameters: ', this.rightsAndParameters);
    }
    /**
     * does the user have all required authorities?
     *
     * @param requiredAuthorities list of required rights
     */
    hasAll(...requiredAuthorities) {
      for (let requiredAuthority of requiredAuthorities) {
        if (!this.rightsAndParameters.has(requiredAuthority)) {
          return false;
        }
      }
      return true;
    }
    /**
     * does the user have all required authorities?
     *
     * @param requiredAuthorities list of required rights
     */
    // Angular templates to not support ...-spread operator
    hasAllArray(requiredAuthorities) {
      return this.hasAll(...requiredAuthorities);
    }
    /**
     * does the user have at least one of the required authorities?
     *
     * @param requiredAuthorities list of required rights
     */
    hasAny(...requiredAuthorities) {
      for (let requiredAuthority of requiredAuthorities) {
        if (this.rightsAndParameters.has(requiredAuthority)) {
          return true;
        }
      }
      return false;
    }
    /**
     * does the user have at least one of the required authorities?
     *
     * @param requiredAuthorities list of required rights
     */
    // Angular templates to not support ...-spread operator
    hasAnyArray(requiredAuthorities) {
      return this.hasAny(...requiredAuthorities);
    }
    /**
     * gets the value of a rightsparameter.
     *
     * @param right name of right
     * @param parameter name of parameter
     * @return rightsparameter value or <code>null</code>
     */
    getRightsParameterValue(right, parameter) {
      let params = this.rightsAndParameters.get(right);
      if (!params) {
        return null;
      }
      return params.get(parameter);
    }
    static {
      this.ɵfac = function HisAuthService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAuthService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisAuthService,
        factory: HisAuthService.ɵfac
      });
    }
  }
  return HisAuthService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SystemProperties {
  constructor() {
    this.images = {};
  }
}

/**
 * All the keys we use in the HTML5 SessionStorage.
 */
var HisSessionStorageKeys = /*#__PURE__*/function (HisSessionStorageKeys) {
  // cs.sys
  HisSessionStorageKeys["CS_SYS_LAST_USERNAME"] = "his_cs_sys_lastUsername";
  HisSessionStorageKeys["CS_SYS_LAST_MENU_ITEM"] = "his_cs_sys_last_menu_item";
  HisSessionStorageKeys["CS_SYS_LAST_SEARCH_URL"] = "his_cs_sys_last_search_url";
  HisSessionStorageKeys["CS_SYS_LAST_SEARCHRESULT_URL"] = "his_cs_sys_last_searchresult_url";
  HisSessionStorageKeys["CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID"] = "his_cs_sys_search_criteria_set_component_id";
  HisSessionStorageKeys["CS_SYS_LAST_SEARCH_BUTTON"] = "his_cs_sys_last_search_button";
  HisSessionStorageKeys["CS_SYS_LAST_SEARCH_CRITERIA_SET"] = "his_cs_sys_last_search_criteria_set";
  HisSessionStorageKeys["CS_SYS_ANONYMOUS_PAGE_SIZE"] = "his_cs_sys_anonymous_page_size";
  HisSessionStorageKeys["CS_SYS_ANONYMOUS_DEFAULT_TABLE_PAGE_SIZE"] = "his_cs_sys_anonymous_default_table_page_size";
  HisSessionStorageKeys["CS_SYS_ANONYMOUS_HIDDEN_COLS"] = "his_cs_sys_anonymous_hidden_cols";
  HisSessionStorageKeys["CS_SYS_ANONYMOUS_PAGINATOR_POSITION"] = "his_cs_sys_anonymous_paginator_position";
  HisSessionStorageKeys["CS_SYS_LAST_BACK_URL"] = "his_cs_sys_last_back_url";
  HisSessionStorageKeys["CS_SYS_SORT_LAST_COLUMN_SORTORDER"] = "his_cs_sys_last_column_sortorder";
  // fs.res
  // cs.bia
  // etc.
  return HisSessionStorageKeys;
}(HisSessionStorageKeys || {});
/**
 * Service to access the HTML5 SessionStorage.
 * This storage has a separate "session cache" for each tab.
 */
let HisSessionStorageService = /*#__PURE__*/(() => {
  class HisSessionStorageService {
    constructor() {
      this.auth = inject(HisAuthService);
    }
    clearOnUserChange(auth) {
      let lastUsernameKey = HisSessionStorageKeys.CS_SYS_LAST_USERNAME;
      let lastUsername = sessionStorage.getItem(lastUsernameKey);
      // username is the unique login name and allows us to recognize a login/logout
      console.log('username =', auth.username, ', lastUsername =', lastUsername);
      if (this.auth.username !== lastUsername) {
        // delete Angular keys
        this.clearAngularSessionStorageKeys();
        // update account info
        sessionStorage.setItem(lastUsernameKey, auth.username);
      }
    }
    /**
     * Store a value in the HTML5 SessionStorage.
     *
     * This method should only be used for simple variables or small data structures. It makes particularly sense
     * for variables that might get lost on redirects (e.g. refresh of browser content).
     *
     * @param key Should start with prefix 'his_' and the segment, e.g. 'his_cs_sys_'
     * @param value the value to store, or null
     */
    put(key, value) {
      if (value) {
        sessionStorage.setItem(key, JSON.stringify(value));
      } else {
        sessionStorage.removeItem(key);
      }
    }
    /**
     * Retrieve a value from the HTML5 SessionStorage.
     *
     * @param key the lookup key
     * @return the value or null
     */
    get(key) {
      return JSON.parse(sessionStorage.getItem(key));
    }
    /**
     * Clear all Angular keys except his_cs_sys_lastUsername, but not the JSF keys.
     * XXX It might be useful to delete some JSF keys, too, but we do not have enough information about that.
     */
    clearAngularSessionStorageKeys() {
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_MENU_ITEM);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL);
    }
    removeSearchKeys() {
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL);
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL);
    }
    removeLastBackUrlKey() {
      sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL);
    }
    static {
      this.ɵfac = function HisSessionStorageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSessionStorageService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSessionStorageService,
        factory: HisSessionStorageService.ɵfac
      });
    }
  }
  return HisSessionStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Diese Klasse enthält die effektiven Datadictionary-Metadaten
 * für einen bestimmten Metadatenschlüssel und einen bestimmten Kontext.
 * Über die Konfigurationsquellen wurde schon gemergt.
 */
class DdEntryMerged {
  // TODO: Optionale Struktur, welche erklärt, wie die gemergeten Werte zustandekommen (wenn HIS_DEVELOPMENT oder CUST)
  // all defined boolean properties of this class DdEntryMerged.
  // boolean properties with value false or undefined ware not mapped to instance of object.
  // This is unfavorable while merging DD-Entry with differnet context within
  // "#HisDdService.getMergedEntry()" when false or undefined actually should ovrride property
  static {
    this.allDdBooleanAttributes = Object.getOwnPropertyNames({
      hidden: null,
      required: null,
      readonly: null,
      backendErrorIdentifier: null
    });
  }
}
/**
 * Eine Map von Kontexten auf die jeweiligen Metadaten.
 */
class DdContextEntriesMap {}
/**
 * Das gesamte DataDictionary ist eine Map von keys auf (Maps von Kontexten auf die jeweiligen Metadaten)
 */
class DataDictionary {}

/**
 * Service zur Abfrage des HISinOne DataDictionary.
 * Beim DataDictionary handelt es sich um Metadaten, die sich in der Regel auf Entity-Attribute beziehen.
 * Über die Metadaten können z.B. einfache Validierungen deklariert werden.
 */
let HisDdService = /*#__PURE__*/(() => {
  class HisDdService {
    constructor() {
      this.dd = {};
    }
    setDd(dd) {
      console.log('HisDdService: set dd');
      this.dd = dd;
    }
    setDdEntry(key, entry, context) {
      let contextMetas = this.dd[key];
      if (!contextMetas) {
        contextMetas = this.dd[key] = {};
      }
      if (!context || context.length === 0) {
        context = 'DEFAULT';
      }
      contextMetas[context] = entry;
    }
    /**
     * Sets required to the DD entry with the given key, for all contexts.
     *
     * @param key the DD key
     * @param value the required value to set
     */
    setRequiredToDdEntry(key, value) {
      let contextMetas = this.dd[key];
      if (!contextMetas) {
        contextMetas = this.dd[key] = {};
      }
      if (Object.keys(contextMetas).length === 0) {
        let ddEntry = new DdEntryMerged();
        ddEntry.identifier = key;
        contextMetas.DEFAULT = ddEntry;
      }
      for (let context of Object.keys(contextMetas)) {
        let ddEntry = contextMetas[context];
        ddEntry.required = value;
      }
    }
    /**
     * Sets required to the DD entry with the given key and the given context.
     *
     * @param key the DD key
     * @param value the required value to set
     * @param context the context
     */
    setRequiredToDdEntryContext(key, value, context) {
      let contextMetas = this.dd[key];
      if (!contextMetas) {
        contextMetas = this.dd[key] = {};
      }
      let ddEntry = contextMetas[context];
      if (!ddEntry) {
        ddEntry = contextMetas[context] = new DdEntryMerged();
        ddEntry.identifier = key;
      }
      ddEntry.required = value;
    }
    getMergedEntry(ddKey, contexts) {
      let contextMetas = this.dd[ddKey];
      if (!contextMetas) {
        return null;
      }
      // contexts sollen immer DEFAULT als erstes Element enthalten
      if (!contexts || contexts.length === 0) {
        contexts = ['DEFAULT'];
      } else if (contexts[0] !== 'DEFAULT') {
        contexts = ['DEFAULT', ...contexts];
      }
      let ddMerged = new DdEntryMerged();
      for (let context of contexts) {
        let ddEntry = contextMetas[context];
        if (ddEntry) {
          ddEntry = this.setUndefinedBooleanAtttributeValue(ddEntry);
          _.merge(ddMerged, ddEntry); // modifies ddMerged
        }
      }
      return ddMerged;
    }
    /** sets DdEntryMerged boolean properties where values are undefined explizit to false */
    setUndefinedBooleanAtttributeValue(ddEntry) {
      DdEntryMerged.allDdBooleanAttributes.forEach(booleanAttribute => {
        if (ddEntry[booleanAttribute] === undefined) {
          ddEntry[booleanAttribute] = false;
        }
      });
      return ddEntry;
    }
    static {
      this.ɵfac = function HisDdService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDdService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDdService,
        factory: HisDdService.ɵfac
      });
    }
  }
  return HisDdService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * provides application wide global variables used by the infrastructure.
 */
let HisBaseGlobalsService = /*#__PURE__*/(() => {
  class HisBaseGlobalsService {
    constructor() {
      this.auth = inject(HisAuthService);
      this.sessionStorageService = inject(HisSessionStorageService);
      this.ddService = inject(HisDdService);
      this.ui = {};
      this.lastId = 1;
      this.system = new SystemProperties();
      this.dataDictionaryEditMode = false;
      this.conf = {};
      // TODO hier lieber gleich nur die Children-List speichern? Dann bräuchten wir keine Dummy-Daten!
      this.navigation = {
        name: 'dummy name',
        link: 'dummy link',
        linkType: 'dummy linktype',
        target: 'dummy target',
        text: 'dummy text',
        title: 'dummy title',
        iconName: 'dummy iconName',
        iconWidth: 'dummy icon width',
        cssclass: 'dummy css class',
        description: 'dummy description',
        shortcut: 'dummy shortcut',
        children: []
      };
      // TODO hier lieber gleich nur die Children-List speichern? Dann bräuchten wir keine Dummy-Daten!
      this.bookmarks = {
        name: 'dummy name',
        link: 'dummy link',
        linkType: 'dummy linktype',
        target: 'dummy target',
        text: 'dummy text',
        title: 'dummy title',
        iconName: 'dummy iconName',
        iconWidth: 'dummy icon width',
        cssclass: 'dummy css class',
        description: 'dummy description',
        shortcut: 'dummy shortcut',
        children: []
      };
    }
    static pad0(n) {
      let text = '';
      for (let i = 0; i < n; i++) {
        text = text + '0';
      }
      return text;
    }
    setLanguage(lang) {
      console.log('HisBaseGlobalsService: set lang = ' + lang);
      this.lang = lang;
    }
    getLanguage() {
      return this.lang;
    }
    /**
     * Da Angular neben 'en-US' nur die in der 'his-core-module.ts' explizit importierten Locales unterstützt,
     * passiert hier ein Mapping der HISinOne-Locales auf diese Locales.
     * Das kann / muss bei Bedarf erweitert werden
     */
    getNearestLocaleSupportedByClient() {
      if (this.lang === 'de' || this.lang.startsWith('de-')) {
        return 'de';
      } else {
        return 'en';
      }
    }
    /**
     * @return the languages supported by the server
     */
    getSupportedLanguages() {
      return this.system.languages;
    }
    /**
     * @return wmenu "megaMenu" is to be displayed
     */
    getMenuType() {
      return this.system.menuType;
    }
    getCurrentDevice() {
      return this.currentDevice;
    }
    getNavigation() {
      return this.navigation;
    }
    getBookmarks() {
      return this.bookmarks;
    }
    setUi(ui) {
      console.log('HisBaseGlobalsService: set ui');
      this.ui = ui;
    }
    getUi(key) {
      let label = this.ui[key];
      return label;
    }
    setDd(dd) {
      this.ddService.setDd(dd);
    }
    setDdEntry(key, entry, context) {
      this.ddService.setDdEntry(key, entry, context);
    }
    setRequiredToDdEntry(key, value) {
      this.ddService.setRequiredToDdEntry(key, value);
    }
    /**
     * get data dictionary entry for given key and an optional list of contexts. The last context has the highest priority.
     */
    getDd(key, contexts) {
      return this.ddService.getMergedEntry(key, contexts);
    }
    setGlobalProperties(globalProperties) {
      // console.log( 'global properties', globalProperties );
      this.lang = globalProperties.user.language;
      this.translationLanguages = globalProperties.translationLanguages;
      this.currentDevice = globalProperties.user.currentDevice;
      this.auth.init(globalProperties.user);
      this.sessionStorageService.clearOnUserChange(this.auth);
      this.conf = globalProperties.conf;
      this.system = globalProperties.system;
      this.modules = new Set(globalProperties.system.modules.split(/\s*,\s*/));
      console.log('set global properties: navigation', globalProperties.navigation);
      this.navigation = globalProperties.navigation;
      this.bookmarks = globalProperties.user.bookmarks;
      console.log('the bookmarks', this.bookmarks);
    }
    getImage(name) {
      if (!name) {
        return null;
      }
      return this.system.images['IMG_' + name.toUpperCase()];
    }
    isAnyModuleActive(...modules) {
      for (let module2 of modules) {
        if (this.modules.has(module2)) {
          return true;
        }
      }
      return false;
    }
    /**
     * returns a counter usable as suffix in html id attributes
     */
    nextId() {
      this.lastId++;
      return this.lastId;
    }
    /**
     * Creates a new unique ID using the current date/time and a sequence number.
     * The created ID is guaranteed to be unique only for the current browser session.
     * If no prefix and no postfix are defined, the length of the created ID is 16.
     *
     * @param prefix The prefix of the ID (may be undefined)
     * @param postfix The postfix of the ID (may be undefined)
     */
    uid(prefix, postfix) {
      let radix = 36;
      let now = new Date().getTime().toString(radix);
      let counter = this.nextId().toString(radix);
      let id = now;
      let n = 16 - now.length - counter.length;
      if (n > 0) {
        id = id + HisBaseGlobalsService.pad0(n);
      }
      id = id + counter;
      if (prefix) {
        id = prefix + id;
      }
      if (postfix) {
        id = id + postfix;
      }
      return id;
    }
    static {
      this.ɵfac = function HisBaseGlobalsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisBaseGlobalsService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisBaseGlobalsService,
        factory: HisBaseGlobalsService.ɵfac
      });
    }
  }
  return HisBaseGlobalsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Service that allows to navigate to previous pages further back in history.
 *
 * All keys are stored in the browser sessionStorage to avoid that they get lost on redirects (refresh, language switch etc.).
 */
let HisNavigationService = /*#__PURE__*/(() => {
  class HisNavigationService {
    static {
      this.ANGULAR_CONTEXT = '/a/';
    }
    // Workaround: define dirty as static because HisNavigationService is provided multiple times
    static {
      this.dirty_ = false;
    }
    set dirty(d) {
      HisNavigationService.dirty_ = d;
    }
    get dirty() {
      return HisNavigationService.dirty_;
    }
    constructor() {
      this.router = inject(Router);
      this.sessionStorageService = inject(HisSessionStorageService);
      this.location = inject(Location);
      this.baseGlobalsService = inject(HisBaseGlobalsService);
      // save the previous route
      this.previousRoutePath = new BehaviorSubject('');
      this.dirtyTracking = false;
      // ..initial prvious route will be the current path for now
      this.previousRoutePath.next(this.location.path());
      // on every route change take the two events of two routes changed(using pairwise)
      // and save the old one in a behavious subject to access it in another component
      // we can use if another component like intro-advertise need the previous route
      // because he need to redirect the user to where he did came from.
      this.router.events.pipe(filter(e => e instanceof RoutesRecognized), pairwise()).subscribe(event => {
        this.previousRoutePath.next(event[0].urlAfterRedirects);
      });
    }
    /** redirect to JSF access-denied page, but forward current url via "re" parameter */
    navigateToAccessDenied() {
      let url = window.location.href;
      let idx = url.indexOf(HisNavigationService.ANGULAR_CONTEXT);
      let prefix = url.substring(0, idx);
      let suffix = url.substring(idx);
      window.location.href = prefix + '/pages/access-denied.faces?re=' + escape(suffix);
    }
    /** gets URl with qisserver path,
     * is used to calculate path to ckeditor scripts,
     * which are passed via argument in ckeditor-angular integration */
    getQisserverUrl() {
      let url = window.location.href;
      let idx = url.indexOf(HisNavigationService.ANGULAR_CONTEXT);
      return url.substring(0, idx);
    }
    setSearchUrl(searchUrl) {
      this.sessionStorageService.put(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL, searchUrl);
    }
    getPreviousSearchUrl() {
      return this.sessionStorageService.get(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_URL);
    }
    hasPreviousSearchUrl() {
      return !!this.getPreviousSearchUrl(); // !! converts null to false
    }
    navigateToLastSearchUrl() {
      let lastSearchUrl = this.getPreviousSearchUrl();
      if (lastSearchUrl) {
        let shortUrl = this.extractShortUrl(lastSearchUrl);
        console.log('HisNavigationService: navigate to ' + shortUrl);
        this.router.navigateByUrl(shortUrl).catch(e => {
          console.log('HisNavigationService: route not found for ' + shortUrl + ', using redirect');
          window.location.href = lastSearchUrl;
        });
      } else {
        console.error('HisNavigationService: Navigation to last search form requested, but there was no previous search.');
      }
    }
    setSearchResultUrl(searchResultUrl) {
      this.sessionStorageService.put(HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL, searchResultUrl);
    }
    getPreviousSearchResultUrl() {
      return this.sessionStorageService.get(HisSessionStorageKeys.CS_SYS_LAST_SEARCHRESULT_URL);
    }
    hasPreviousSearchResultUrl() {
      return !!this.getPreviousSearchResultUrl(); // !! converts null to false
    }
    navigateToLastSearchResultUrl() {
      let lastSearchResultUrl = this.getPreviousSearchResultUrl();
      if (lastSearchResultUrl) {
        let shortUrl = this.extractShortUrl(lastSearchResultUrl);
        console.log('HisNavigationService: navigate to ' + shortUrl);
        this.router.navigateByUrl(shortUrl).catch(e => {
          console.log('HisNavigationService: route not found for ' + shortUrl + ', using redirect');
          window.location.href = lastSearchResultUrl;
        });
      } else {
        // Fallback
        let lastSearchUrl = this.getPreviousSearchUrl();
        if (lastSearchUrl) {
          let shortUrl = this.extractShortUrl(lastSearchUrl);
          console.log('HisNavigationService: navigate to ' + shortUrl);
          this.router.navigateByUrl(shortUrl).catch(e => {
            console.log('HisNavigationService: route not found for ' + shortUrl + ', using redirect');
            window.location.href = lastSearchUrl;
          });
        } else {
          console.error('HisNavigationService: Navigation to last search result requested, but there was no previous search.');
        }
      }
    }
    /**
     * Extract the part required by the router from a complete URL
     *
     * @param url full URL
     * @return the route part of the URL
     */
    extractShortUrl(url) {
      let idx = url.indexOf(HisNavigationService.ANGULAR_CONTEXT);
      let idx2 = url.indexOf('/', idx + 3);
      return url.substring(idx2);
    }
    hasLastBackUrl() {
      let backUrlList = this.getLastBackUrl();
      return backUrlList && backUrlList.length > 0 || window.history.length > 1;
    }
    /**
     * using router for back navigation on router.navigateByUrl
     * using back URL saved in session storage service
     * default fallback using location.back() -> not working reliable
     */
    navigateToLastBackUrl() {
      let backUrlList = this.getLastBackUrl();
      if (backUrlList && backUrlList.length > 0) {
        let lastBackUrl = backUrlList[backUrlList.length - 1];
        if (this.location.path() !== this.previousRoutePath.value && this.isSameContext(window.location.href, lastBackUrl)) {
          // navigate by route part of the URL
          this.router.navigateByUrl(this.extractShortUrl(lastBackUrl));
        } else {
          console.log('Using window location href for navigation back');
          // from other module context using window location href
          window.location.href = lastBackUrl;
        }
        // update storage
        backUrlList.pop(); // remove last entry
        console.log('Update session storage for last back URL list');
        this.sessionStorageService.put(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL, backUrlList);
      } else {
        // Fallback
        console.log('Fallback using window.history.back() as default');
        window.history.back();
      }
    }
    isSameContext(currentUrl, navigateToUrl) {
      let currentUrlAIndex = currentUrl.indexOf(HisNavigationService.ANGULAR_CONTEXT);
      let navigateToUrlAIndex = navigateToUrl.indexOf(HisNavigationService.ANGULAR_CONTEXT);
      if (currentUrlAIndex && navigateToUrlAIndex) {
        if (this.getUrlContext(currentUrl, currentUrlAIndex) === this.getUrlContext(navigateToUrl, navigateToUrlAIndex)) {
          return true;
        }
      }
      return false;
    }
    getUrlContext(url, angularIndex) {
      return url.substring(angularIndex, angularIndex + 19);
    }
    setLastBackUrl(backUrl) {
      let backUrlList = this.sessionStorageService.get(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL);
      if (!backUrlList) {
        backUrlList = [];
      }
      backUrlList.push(backUrl);
      this.sessionStorageService.put(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL, backUrlList);
    }
    getLastBackUrl() {
      return this.sessionStorageService.get(HisSessionStorageKeys.CS_SYS_LAST_BACK_URL);
    }
    getUrlBasePath() {
      let url = window.location.href;
      let idx = url.indexOf(HisNavigationService.ANGULAR_CONTEXT);
      let idx2 = url.indexOf('/', idx + 3);
      // http://localhost:8080/qisserver/a/cs.sys.hisng/genericSearchLiveDemo
      let urlBasePath = url.substring(0, idx2);
      console.log('his-navigation.service#getUrlBasePath() #urlBasePath', urlBasePath);
      return urlBasePath;
    }
    startDirtyTracking() {
      this.dirty = false;
      if (this.baseGlobalsService.conf['core.sys.ui.confirm_unsaved']) {
        this.dirtyTracking = true;
      }
    }
    stopDirtyTracking() {
      this.dirtyTracking = false;
    }
    static {
      this.ɵfac = function HisNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisNavigationService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisNavigationService,
        factory: HisNavigationService.ɵfac
      });
    }
  }
  return HisNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisAuthGuard = /*#__PURE__*/(() => {
  class HisAuthGuard {
    constructor() {
      this.hisAuthService = inject(HisAuthService);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisNavigationService = inject(HisNavigationService);
      this.router = inject(Router);
    }
    canActivate(route, state) {
      let enabled = this.isEnabled(route);
      if (!enabled) {
        this.router.navigate(['/hisng/access-disabled'], {
          skipLocationChange: true
        });
      }
      let granted = this.isGranted(route);
      if (!granted) {
        this.hisNavigationService.navigateToAccessDenied();
      }
      return enabled && granted;
    }
    isEnabled(route) {
      if (!route.data) {
        return true;
      }
      let data = route.data;
      if (!data.modules) {
        return true;
      }
      if (this.hisAuthService.isAnonymous && data.anonmodules) {
        return this.hisBaseGlobalsService.isAnyModuleActive(...data.anonmodules);
      }
      return this.hisBaseGlobalsService.isAnyModuleActive(...data.modules);
    }
    isGranted(route) {
      if (!route.data) {
        console.error('HisAuthGuard without configuration data in route definition.');
        return false;
      }
      let data = route.data;
      // check hasAll
      if (data.hasAll) {
        let granted = this.hisAuthService.hasAll(...data.hasAll);
        if (!granted) {
          return false;
        }
      }
      // check hasAny
      if (data.hasAny) {
        return this.hisAuthService.hasAny(...data.hasAny);
      }
      // check hasAll was true, and hasAny was not defined
      return true;
    }
    static {
      this.ɵfac = function HisAuthGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAuthGuard)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisAuthGuard,
        factory: HisAuthGuard.ɵfac
      });
    }
  }
  return HisAuthGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisNavigationMenuService = /*#__PURE__*/(() => {
  class HisNavigationMenuService {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.router = inject(Router);
      this.route = inject(ActivatedRoute);
      this.currentAngularAppPrefix = '';
      this.initCurrentAngularAppPrefix();
      this.createFlatNavigation();
    }
    initCurrentAngularAppPrefix() {
      let temp = window.location.pathname;
      let idx = temp.indexOf('/a/');
      if (idx > -1) {
        let idx2 = temp.indexOf('/', idx + 3);
        if (idx2 > -1) {
          this.currentAngularAppPrefix = temp.substring(idx, idx2 + 1);
        } else {
          this.currentAngularAppPrefix = temp.substring(idx) + '/';
        }
      }
    }
    // all Menu Items with their parent hashed by id
    createFlatNavigation() {
      this.flatNavigation = {};
      let navigation = this.getNavigation();
      for (let item of navigation) {
        this.flatItem(item, this.flatNavigation, '');
      }
    }
    flatItem(item, flatNavigation, parent) {
      if (item.id) {
        flatNavigation[item.id] = {
          item,
          parent
        };
      }
      if (item.items && item.items.length > 0) {
        for (let child of item.items) {
          this.flatItem(child, flatNavigation, item.id);
        }
      }
    }
    getNavigation() {
      let navigation = this.hisBaseGlobalsService.getNavigation();
      // console.log('navigation =', navigation);
      let menuItems = this.translateItems(navigation.children);
      let bookmarks = this.getBookmarks();
      if (bookmarks.length > 0) {
        menuItems.push(...bookmarks);
      }
      return menuItems;
    }
    getBookmarks() {
      let bookmarks = this.hisBaseGlobalsService.getBookmarks();
      if (bookmarks) {
        let items = this.translateItems([bookmarks]);
        return items;
      } else {
        return [];
      }
    }
    /*
     * Initial translation from NavigationItem to menu item
     */
    translateItems(items) {
      return items.map(item => this.translateItem(item));
    }
    translateItem(item) {
      let menuItem = {};
      // default values
      menuItem.routerLinkActiveOptions = {
        exact: false
      };
      menuItem.styleClass = '';
      if (item.text) {
        menuItem.label = item.text;
      }
      if (item.iconName) {
        menuItem.icon = item.iconName;
      }
      if (item.cssclass) {
        menuItem.styleClass = item.cssclass;
      }
      if (item.target) {
        menuItem.target = item.target;
      }
      if (item.title || item.description) {
        menuItem.title = item.title || item.description;
      }
      if (item.name) {
        menuItem.id = item.name;
      }
      // if child pages exist
      if (item.children && item.children.length > 0) {
        menuItem.items = this.translateItems(item.children);
      }
      if (item.linkType === 'SUBMENU' || item.linkType === 'IMAGE' || item.children && item.children.length > 0) {
        // item is a submenu -> link to Submenu Component
        menuItem.routerLink = ['/hisng/submenu'];
        // set navigation Position to distinguish every submenu
        menuItem.queryParams = {
          navigationPosition: item.name
        };
        menuItem.routerLinkActiveOptions = {
          exact: true
        };
        // console.log("submenu or image: menuItem =", menuItem);
      } else if (!item.link) {
        // ignore menu items without link
      } else if (item.link.startsWith('state=')) {
        // QIS/LSF page
        menuItem.url = '../../rds?' + item.link;
        // console.log("RDS page: menuItem =", menuItem);
      } else if (item.link.startsWith(this.currentAngularAppPrefix)) {
        // item is a link to an angular page of the same servlet mapping -> create routerlink.
        // Note that a router link would not work if we are in one servlet mapping like /a/cs.sys.hisng/
        // and want to call a page from another servlet mapping like /a/fs.res.frontend/
        menuItem.routerLink = this.createRouterLink(item);
        menuItem.queryParams = this.router.parseUrl(item.link).queryParams;
        // console.log("routerlink to angularpage: menuItem =", menuItem);
      } else {
        // for JSF pages, Angular pages from other servlet mappings or external links we create a simple link
        menuItem.url = '../..' + item.link;
        // console.log("other page type: menuItem =", menuItem);
      }
      // console.log("item linktype", item.linkType);
      // console.log("item link", item.link);
      // console.log("menuItem URL", menuItem.url);
      return menuItem;
    }
    createRouterLink(item) {
      let strippedUrl = item.link.substring(this.currentAngularAppPrefix.length);
      let urlPrefix = strippedUrl;
      let pos = strippedUrl.indexOf('?');
      if (pos > -1) {
        urlPrefix = strippedUrl.substring(0, pos);
      }
      return ['/' + urlPrefix];
    }
    createUrlTree(routerLink, queryParams) {
      let commands = [];
      if (routerLink != null) {
        commands = Array.isArray(routerLink) ? routerLink : [routerLink];
      } else {
        commands = [];
      }
      return this.router.createUrlTree(commands, {
        relativeTo: this.route,
        queryParams
      });
    }
    getFlatNavigation() {
      return this.flatNavigation;
    }
    getMenuItem(name) {
      let allItems = this.getFlatNavigation();
      console.log('getMenuItem: name =', name, ', allItems =', allItems);
      return allItems[name] ? allItems[name].item : null;
    }
    getActiveMenuItem() {
      let allItems = this.getFlatNavigation();
      // console.log( 'allItems =', allItems );
      let urlMatchItems = [];
      for (let key of Object.keys(allItems)) {
        let item = allItems[key].item;
        if (this.isUrlMatch(item)) {
          urlMatchItems.push(item);
        }
      }
      if (urlMatchItems.length === 0) {
        console.log('Active menu item test: Nothing found');
        return null;
      }
      if (urlMatchItems.length === 1) {
        console.log('Active menu item test: Found active menu item by unique URL', urlMatchItems[0]);
        return urlMatchItems[0];
      }
      // The URL is ambiguous. Compare navigationPosition with menuItem.id, too
      console.log('Active menu item test: Found several URL matches', urlMatchItems);
      let navigationPositionMatchItems = [];
      for (let item of urlMatchItems) {
        if (this.isNavigationPositionMatch(item)) {
          navigationPositionMatchItems.push(item);
        }
      }
      if (navigationPositionMatchItems.length === 0) {
        console.log('Active menu item test: No navigationPosition matches, return first URL match', urlMatchItems[0]);
        return urlMatchItems[0];
      }
      if (navigationPositionMatchItems.length === 1) {
        console.log('Active menu item test: Found active menu item by unique navigationPosition', navigationPositionMatchItems[0]);
        return navigationPositionMatchItems[0];
      }
      // Still ambiguous! (can this happen at all?)
      console.log('Active menu item test: Disambiguation by navigationPosition failed, return first navigationPosition match', navigationPositionMatchItems[0]);
      return navigationPositionMatchItems[0];
    }
    isUrlMatch(item) {
      let currentUrlTree = this.router.parseUrl(this.router.url);
      // console.log( 'check isActive: currentUrlTree=', currentUrlTree );
      let menuItemUrlTree;
      // ignore menu items without link (e. g. bookmark popup) because an empty relative
      // url would match the current address
      if (!item.routerLink && !item.url) {
        console.log('Active menu item test: ignore item', item);
        return false;
      }
      if (item.routerLinkActiveOptions.exact) {
        // Take queryParams into account, except for the parameters noDBAction and init
        // which may be added by redirects e.g. triggered by switching language.
        // See https://hiszilla.his.de/hiszilla/show_bug.cgi?id=199667
        let allParams = currentUrlTree.queryParams;
        let reducedParams = {};
        for (let key of Object.keys(allParams)) {
          if (key !== 'noDBAction' && key !== 'init') {
            reducedParams[key] = allParams[key];
          }
        }
        currentUrlTree.queryParams = reducedParams;
        menuItemUrlTree = this.createUrlTree(item.routerLink || item.url, item.queryParams);
      } else {
        // Ignore queryParams.
        // https://github.com/angular/angular/issues/13205#issuecomment-327703678
        currentUrlTree.queryParams = {};
        menuItemUrlTree = this.createUrlTree(item.routerLink || item.url, {});
      }
      // console.log( 'Active menu item test: menuItemUrlTree=', menuItemUrlTree );
      if (currentUrlTree.toString() === menuItemUrlTree.toString()) {
        console.log('Active menu item test: Found URL match:', item);
        return true;
      }
      return false;
    }
    isNavigationPositionMatch(item) {
      // In case that several menu points have the same URL, we can also compare the navigationPosition if given
      let navigationPositionUrlParam = this.route.snapshot.queryParams.navigationPosition;
      if (navigationPositionUrlParam) {
        console.log('Active menu item test: Explicit navigationPosition =', navigationPositionUrlParam);
        let navigationItemNames = navigationPositionUrlParam.split(',').map(elem => elem.trim());
        console.log('Active menu item test: navigationItemNames =', navigationItemNames, ', item.id =', item.id);
        if (navigationItemNames.length > 0) {
          let lastItemName = navigationItemNames[navigationItemNames.length - 1];
          console.log('Active menu item test: lastItemName =', lastItemName);
          if (lastItemName === item.id) {
            console.log('Active menu item test: Found navigationPositionMatch', item);
            return true;
          } else {
            console.log('Active menu item test: navigationPosition does not match for', item);
            return false;
          }
        }
      }
      console.log('Active menu item test: Could not compare navigationPosition for', item);
      return false;
    }
    getParentsOfMenuItem(item) {
      let navigation = this.getFlatNavigation();
      let menuItemKey = item ? item.id : '';
      let items = new Array();
      while (menuItemKey !== '' && navigation[menuItemKey]) {
        items.push(navigation[menuItemKey].item);
        menuItemKey = navigation[menuItemKey].parent;
      }
      items = items.reverse();
      return items;
    }
    static {
      this.ɵfac = function HisNavigationMenuService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisNavigationMenuService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisNavigationMenuService,
        factory: HisNavigationMenuService.ɵfac
      });
    }
  }
  return HisNavigationMenuService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Service zur Ersetzung von i18n-Schlüsseln durch den Ausdruck in der aktuellen Sprache.
 *
 * Dieser Service sollte überall da verwendet werden, wo es kein HTML gibt und deshalb die ui-pipe
 * nicht anwendbar ist, zum Beispiel bei Notifications.
 */
let HisUiService = /*#__PURE__*/(() => {
  class HisUiService {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    /**
     * Ersetzung von i18n-Keys mit Parametern.
     * Parameter, die selbst i18n-Schlüssel sind, müssen vor Aufruf dieser Methode ersetzt worden sein!
     *
     * @param key der zu ersetzende i18n-Key
     * @param params Array mit weiteren Parametern welche in die Placeholder gesetzt werden sollen.
     * Die varargs-Definition erlaubt, einen oder mehrere Parameter ohne Array-Definition zu übergeben.
     */
    translate(key, ...params) {
      return this.doTranslate(key, false, ...params);
    }
    /**
     * Übersetzt den gegebenen i18n-Schlüssel oder gibt einen leeren String zurück, falls keine Übersetzung existiert.
     *
     * @param key Der i18n-Schlüssel.
     * @param params Optionale Parameter für Platzhalter in der Übersetzung.
     * @returns Die übersetzte Zeichenkette oder ein leerer String, falls keine Übersetzung gefunden wurde.
     */
    translateOrEmpty(key, ...params) {
      return this.doTranslate(key, true, ...params);
    }
    doTranslate(key, returnEmptyIfNotFound, ...params) {
      if (this.hisBaseGlobalsService.system.editUiTexts) {
        // nur den Schlüssel formatieren
        return key + ' ' + params.join();
      }
      // leere Werte bleiben leer
      if (key == null || key.length === 0) {
        return key;
      }
      let label = this.hisBaseGlobalsService.getUi(key);
      let hisdev = this.hisBaseGlobalsService.system.hisDevelopmentMode;
      if (!label) {
        if (returnEmptyIfNotFound) {
          return '';
        }
        if (hisdev === true) {
          label = '???' + key + '???';
        } else {
          label = key;
        }
      }
      // console.log(params);
      if (label === 'EMPTY') {
        label = '';
      }
      // the following replacement algorithm is capable to replace parameters in any order and
      // the same parameter several times
      let paramCount = params ? params.length : 0;
      let pos2 = -1;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        let pos = label.indexOf('{', pos2 + 1);
        if (pos < 0) {
          break; // done
        }
        pos2 = label.indexOf('}', pos + 1);
        if (pos2 < 0) {
          console.log('Error:', label, 'contains unmatched opening parameter bracket \'{\'');
          break;
        }
        let paramStr = label.substring(pos + 1, pos2);
        let placeHolder = '{' + paramStr + '}';
        let paramIndex = parseInt(paramStr, 10);
        if (paramIndex >= paramCount) {
          console.log('Error:', label, 'contains', placeHolder, ', but only', paramCount, 'parameters have been passed.');
          continue; // omit this param, but continue with others
        }
        // Param je nach Datentyp in string konvertieren
        let substring = '';
        let param = params[paramIndex];
        if (param) {
          let paramTypeStr = Object.prototype.toString.call(param);
          switch (paramTypeStr) {
            case '[object Date]':
              substring = this.formatDate(param);
              break;
            case '[object Number]':
              substring = '' + param;
              break;
            case '[object String]':
              substring = param;
              break;
            default:
              console.log('ERROR: Unexpected param type:', paramTypeStr);
          }
        }
        // Ersetzung des Placeholders
        label = label.replace(placeHolder, substring);
        // #348309 erst nach dem ersetzten String weitersuchen, damit es keine Rekursion geben kann,
        // wenn ein Parameter selbst vermeintliche Placeholder enthält
        pos2 += substring.length - placeHolder.length;
      }
      return label;
    }
    translateCommaSeparated(keys) {
      let combinedLabel = null;
      keys.forEach(key => {
        combinedLabel = combinedLabel == null ? this.translate(key) : combinedLabel + (key === keys[keys.length - 1] ? ' ' + this.translate('de.his.javang.und') : ',') + ' ' + this.translate(key);
      });
      return combinedLabel;
    }
    formatDate(param) {
      // Vorläufiges Format wie ein Datum angezeigt wird: dd.mm.yyyy
      let formatedDate = param.getDate() + '.' + (param.getMonth() + 1) + '.' + param.getFullYear();
      return formatedDate;
    }
    static {
      this.ɵfac = function HisUiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUiService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisUiService,
        factory: HisUiService.ɵfac
      });
    }
  }
  return HisUiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * looks up uitext.
 */
let HisUiPipe = /*#__PURE__*/(() => {
  class HisUiPipe {
    constructor() {
      this.hisUiService = inject(HisUiService);
    }
    transform(key, ...params) {
      return this.hisUiService.translate(key, ...params);
    }
    static {
      this.ɵfac = function HisUiPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUiPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisUi",
        type: HisUiPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisUiPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisBreadcrumbComponent = /*#__PURE__*/(() => {
  class HisBreadcrumbComponent {
    constructor() {
      this.router = inject(Router);
      this.route = inject(ActivatedRoute);
      this.navService = inject(HisNavigationMenuService);
      this.sessionStorageService = inject(HisSessionStorageService);
      this.items = new Array();
    }
    ngOnInit() {
      let navigation = this.navService.getFlatNavigation();
      this.rootItem = navigation.link_homepage ? navigation.link_homepage.item : null;
      this.setItems(); // required for navigation bypassing the router (first call, redirects etc.)
      this.router.events.subscribe(routerEvent => {
        // type Event or RouterEvent would not compile, see https://github.com/angular/angular/issues/43124
        // https://angular.io/api/router/Event: There are 15 router events permitting to track the router lifecycle.
        // We only want to pick one; the best choice is NavigationEnd, because then all initializations are complete.
        if (routerEvent instanceof NavigationEnd) {
          this.setItems();
        }
      });
    }
    setItems() {
      console.log('HisBreadcrumbComponent setItems()');
      // first priority: an explicit navigationPosition.
      // Its value may be the whole path of menu item names or just the leaf element.
      let navigationPositionUrlParam = this.route.snapshot.queryParams.navigationPosition;
      if (navigationPositionUrlParam) {
        let navigationItemNames = navigationPositionUrlParam.split(',').map(elem => elem.trim()).filter(Boolean);
        if (navigationItemNames.length > 0) {
          let lastItemName = navigationItemNames[navigationItemNames.length - 1];
          console.log('breadcrumb: lastItemName =', lastItemName);
          let menuItem = this.navService.getMenuItem(lastItemName);
          console.log('breadcrumb: explicit menuItem =', menuItem);
          if (menuItem) {
            this.setBreadcrumbFromMenuItem(menuItem);
            console.log('HisBreadcrumbComponent menuItem: ', menuItem);
            return;
          }
        }
      }
      // second priority: items that have a menu entry
      let activeMenuItem = this.navService.getActiveMenuItem();
      console.log('breadcrumb: activeMenuItem =', activeMenuItem);
      if (activeMenuItem) {
        this.setBreadcrumbFromMenuItem(activeMenuItem);
        return;
      }
      // The active page does not have a navigation menu entry (e.g. search results)
      // and possible items got lost because of a redirect -> derive the breadcrumb from the last menu item.
      // This creates the entries in the right language after language changes, too. #214545
      let lastMenuItem = this.sessionStorageService.get(HisSessionStorageKeys.CS_SYS_LAST_MENU_ITEM);
      if (lastMenuItem) {
        this.setBreadcrumbFromMenuItem(lastMenuItem);
      }
    }
    setBreadcrumbFromMenuItem(menuItem) {
      this.items = [];
      let parents = this.navService.getParentsOfMenuItem(menuItem);
      if (parents.filter(item => item.id === 'link_homepage').length === 0) {
        if (this.rootItem) {
          this.items.push(this.rootItem);
        }
      }
      this.items.push(...parents);
      this.sessionStorageService.put(HisSessionStorageKeys.CS_SYS_LAST_MENU_ITEM, menuItem);
    }
    onItemClick(event) {
      console.log('Clear angular session storage keys onItemClick');
      this.sessionStorageService.clearAngularSessionStorageKeys();
    }
    static {
      this.ɵfac = function HisBreadcrumbComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisBreadcrumbComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisBreadcrumbComponent,
        selectors: [["his-breadcrumb"]],
        standalone: false,
        decls: 4,
        vars: 4,
        consts: [[1, "breadcrumb-text"], [3, "onItemClick", "model"]],
        template: function HisBreadcrumbComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p-breadcrumb", 1);
            i0.ɵɵlistener("onItemClick", function HisBreadcrumbComponent_Template_p_breadcrumb_onItemClick_3_listener($event) {
              return ctx.onItemClick($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "de.his.portal.breadcrumb"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.items);
          }
        },
        dependencies: [i1.Breadcrumb, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisBreadcrumbComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisHeaderComponent = /*#__PURE__*/(() => {
  class HisHeaderComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisAuthService = inject(HisAuthService);
      this.menuButton = new EventEmitter();
    }
    ngOnInit() {
      this.isAnonymous = this.hisAuthService.isAnonymous;
      this.hasMegaMenu = this.hisBaseGlobalsService.getMenuType() === 'megaMenu';
      this.isMobile = this.hisBaseGlobalsService.getCurrentDevice() === 'mobile';
    }
    onMenuButton() {
      this.menuButton.emit(null);
    }
    static {
      this.ɵfac = function HisHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisHeaderComponent,
        selectors: [["his-header"]],
        inputs: {
          menuButtonText: "menuButtonText"
        },
        outputs: {
          menuButton: "menuButton"
        },
        standalone: false,
        decls: 2,
        vars: 0,
        consts: [["id", "hisinoneHeader"]],
        template: function HisHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "his-breadcrumb");
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [HisBreadcrumbComponent],
        styles: [".logosHisinone[_ngcontent-%COMP%]{float:left;margin-right:20px}.logosHisinone[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:block}.logosHisinone[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{height:42px}"]
      });
    }
  }
  return HisHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisModificationDetectionDirective = /*#__PURE__*/(() => {
  class HisModificationDetectionDirective {
    constructor() {
      this.hisNavigationService = inject(HisNavigationService);
    }
    static {
      this.KNOWN_HIS_IMAGES = ['ARROW_DOWN', 'ARROW_UP', 'DELETE'];
    }
    changed() {
      this.hisNavigationService.dirty = true;
    }
    clicked(event) {
      let target = event.target;
      if (target.classList?.contains('p-chips-token-icon')) {
        this.hisNavigationService.dirty = true;
        return;
      }
      // click target is a svg graphic element, so we need to look at
      // the parent button element instead.
      let button = target.closest('button');
      if (button) {
        let attribute = button.getAttribute('hisimage');
        if (HisModificationDetectionDirective.KNOWN_HIS_IMAGES.indexOf(attribute) > -1) {
          this.hisNavigationService.dirty = true;
        }
      }
    }
    onBeforeUnload() {
      return !this.hisNavigationService.dirtyTracking || !this.hisNavigationService.dirty;
    }
    static {
      this.ɵfac = function HisModificationDetectionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisModificationDetectionDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisModificationDetectionDirective,
        selectors: [["input"], ["textarea"], ["button"], ["p-autoComplete"], ["p-calendar"], ["p-checkbox"], ["p-chips"], ["p-editor"], ["p-inputNumber"], ["p-multiSelect"], ["p-radioButton"], ["his-multiselect"], ["his-search-select-popup"], ["his-tree-select-popup"]],
        hostBindings: function HisModificationDetectionDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function HisModificationDetectionDirective_input_HostBindingHandler() {
              return ctx.changed();
            })("onInput", function HisModificationDetectionDirective_onInput_HostBindingHandler() {
              return ctx.changed();
            })("onDropdownClick", function HisModificationDetectionDirective_onDropdownClick_HostBindingHandler($event) {
              return ctx.changed($event);
            })("chipsChange", function HisModificationDetectionDirective_chipsChange_HostBindingHandler($event) {
              return ctx.changed($event);
            })("click", function HisModificationDetectionDirective_click_HostBindingHandler($event) {
              return ctx.clicked($event);
            })("keyup", function HisModificationDetectionDirective_keyup_HostBindingHandler($event) {
              return ctx.changed($event);
            })("selectedDataChange", function HisModificationDetectionDirective_selectedDataChange_HostBindingHandler($event) {
              return ctx.changed($event);
            })("selectedOptionsChange", function HisModificationDetectionDirective_selectedOptionsChange_HostBindingHandler($event) {
              return ctx.changed($event);
            })("beforeunload", function HisModificationDetectionDirective_beforeunload_HostBindingHandler() {
              return ctx.onBeforeUnload();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        standalone: false
      });
    }
  }
  return HisModificationDetectionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisPageOptionPanelComponent = /*#__PURE__*/(() => {
  class HisPageOptionPanelComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    static {
      this.ɵfac = function HisPageOptionPanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPageOptionPanelComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisPageOptionPanelComponent,
        selectors: [["his-page-option-panel"]],
        standalone: false,
        decls: 4,
        vars: 1,
        consts: [[1, "pageOptionPanelContainer"], ["id", "pageOptionPanel", "type", "checkbox", 1, "editDatadictionaryCheckbox", 3, "ngModelChange", "ngModel"], ["for", "pageOptionPanel", 1, "editDatadictionaryLabel"]],
        template: function HisPageOptionPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function HisPageOptionPanelComponent_Template_input_ngModelChange_1_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.hisBaseGlobalsService.dataDictionaryEditMode, $event) || (ctx.hisBaseGlobalsService.dataDictionaryEditMode = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "label", 2);
            i0.ɵɵtext(3, "Edit Datadictionary");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.hisBaseGlobalsService.dataDictionaryEditMode);
          }
        },
        dependencies: [i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return HisPageOptionPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HTTPStatus = /*#__PURE__*/(() => {
  class HTTPStatus {
    constructor() {
      this.requestInFlight$ = new BehaviorSubject(true);
    }
    updateHttpStatus(inFlight) {
      this.requestInFlight$.next(inFlight);
    }
    getHttpStatus() {
      return this.requestInFlight$.asObservable();
    }
    static {
      this.ɵfac = function HTTPStatus_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HTTPStatus)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HTTPStatus,
        factory: HTTPStatus.ɵfac
      });
    }
  }
  return HTTPStatus;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Status = /*#__PURE__*/function (Status) {
  Status[Status["Idle"] = 0] = "Idle";
  Status[Status["WaitingForCurtain"] = 1] = "WaitingForCurtain";
  Status[Status["WaitingForClear"] = 2] = "WaitingForClear";
  return Status;
}(Status || {});
let HTTPListener = /*#__PURE__*/(() => {
  class HTTPListener {
    constructor() {
      this.httpStatus = inject(HTTPStatus);
      this.count = 0;
      this.status = Status.Idle;
    }
    intercept(req, next) {
      let shouldRequestBlock = !req.headers.get('X-HIS-Block-UI') || req.headers.get('X-HIS-Block-UI') !== 'false';
      if (shouldRequestBlock) {
        if (this.count === 0) {
          this.scheduleCurtainAction(true, Status.WaitingForCurtain, Status.WaitingForClear, 500);
        }
        this.count++;
      }
      return next.handle(req).pipe(finalize(() => {
        if (shouldRequestBlock) {
          this.count--;
          if (this.count === 0) {
            this.scheduleCurtainAction(false, Status.WaitingForClear, Status.WaitingForCurtain, 20);
          }
        }
      }));
    }
    /**
     * schedules showing or hiding the curtain
     *
     * @param loading show the curtain? (e. g. true)
     * @param desiredStatus the desired status (e. g. WaitingForCurtain)
     * @param opositeStatus the oposite status (e. g. WaitingForClear)
     * @param delay number of milliseconds to wait
     */
    scheduleCurtainAction(loading, desiredStatus, opositeStatus, delay) {
      // Are we already waiting for the desired curtain state?
      if (this.status === desiredStatus) {
        return;
      }
      // Are we waiting for the oposite curtain status? => Cancel
      if (this.status === opositeStatus) {
        window.clearTimeout(this.timeoutId);
      }
      this.status = desiredStatus;
      this.timeoutId = setTimeout(() => {
        this.httpStatus.updateHttpStatus(loading);
        this.status = Status.Idle;
      }, delay);
    }
    static {
      this.ɵfac = function HTTPListener_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HTTPListener)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HTTPListener,
        factory: HTTPListener.ɵfac
      });
    }
  }
  return HTTPListener;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisHttplistenerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 2)(3, "g", 3);
    i0.ɵɵelement(4, "path", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "g", 5);
    i0.ɵɵelement(6, "path", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "g", 7);
    i0.ɵɵelement(8, "path", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "g", 7);
    i0.ɵɵelement(10, "path", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "g", 7);
    i0.ɵɵelement(12, "path", 10);
    i0.ɵɵelementEnd()()()();
  }
}
let HisHttplistenerComponent = /*#__PURE__*/(() => {
  class HisHttplistenerComponent {
    constructor() {
      this.httpStatus = inject(HTTPStatus);
      this.rendererFactory = inject(RendererFactory2);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.loading = false;
      this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    ngOnInit() {
      this.httpStatus.getHttpStatus().subscribe(loading => {
        this.loading = loading;
        if (loading) {
          this.renderer.setStyle(document.body, 'cursor', 'wait');
        } else {
          this.renderer.setStyle(document.body, 'cursor', 'default');
        }
        this.changeDetectorRef.detectChanges();
      });
    }
    static {
      this.ɵfac = function HisHttplistenerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisHttplistenerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisHttplistenerComponent,
        selectors: [["his-httplistener"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "httpOverlay"], [1, "logo-httpOverlay"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "version", "1.1", "id", "Ebene_1", "x", "0px", "y", "0px", "viewBox", "0 0 64 64", 0, "xml", "space", "preserve", "height", "100%", "width", "100%", 1, "one-color", "his-icon", "his-icon-his1_logo_software", 2, "enable-background", "new 0 0 64 64"], [1, "icon-style-wrapper", "icon-fill--rgb255-255-255", "icon-stroke--rgb0-106-178", "icon-stroke-miterlimit--10", 2, "fill", "#FFFFFF", "stroke", "#006AB2", "stroke-miterlimit", "10"], ["d", "M17,44.7", 1, "st0"], [1, "icon-style-wrapper", "icon-fill--rgb0-106-178", 2, "fill", "#006AB2"], ["d", "M52.1,6H11.9C8.7,6,6,8.7,6,12.1v39.8c0,3.4,2.7,6.1,5.9,6.1h40.2c3.3,0,5.9-2.7,5.9-6.1V12.1  C58,8.7,55.3,6,52.1,6z", 1, "st1"], [1, "icon-style-wrapper", "icon-fill--rgb255-255-255", 2, "fill", "#FFFFFF"], ["d", "M50,26H40c-1.1,0-2-0.9-2-2V14c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C52,25.1,51.1,26,50,26z", 1, "st2"], ["d", "M50,46H40c-1.1,0-2-0.9-2-2V34c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C52,45.1,51.1,46,50,46z", 1, "st2"], ["d", "M30,26H20c-1.1,0-2-0.9-2-2V14c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C32,25.1,31.1,26,30,26z", 1, "st2"]],
        template: function HisHttplistenerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisHttplistenerComponent_Conditional_0_Template, 13, 0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.loading ? 0 : -1);
          }
        },
        styles: ["@keyframes _ngcontent-%COMP%_rotate{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.logo-httpOverlay[_ngcontent-%COMP%]{animation-name:_ngcontent-%COMP%_rotate;animation-duration:4s;animation-iteration-count:infinite;animation-timing-function:linear;height:150px;width:150px;position:fixed;left:50%;top:50%;margin:-75px 0 0 -75px}.httpOverlay[_ngcontent-%COMP%]{width:100%;height:100%;background-color:#cccccc4d;position:fixed;top:0;left:0;z-index:1000}"]
      });
    }
  }
  return HisHttplistenerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var HisDynamicFieldType = /*#__PURE__*/function (HisDynamicFieldType) {
  HisDynamicFieldType["Text"] = "Text";
  HisDynamicFieldType["Select"] = "Select";
  HisDynamicFieldType["MultiSelect"] = "MultiSelect";
  HisDynamicFieldType["Checkbox"] = "Checkbox";
  HisDynamicFieldType["Password"] = "Password";
  HisDynamicFieldType["TreeSelect"] = "TreeSelect";
  HisDynamicFieldType["MultiTreeSelect"] = "MultiTreeSelect";
  HisDynamicFieldType["DatePicker"] = "DatePicker";
  HisDynamicFieldType["TextArea"] = "TextArea";
  HisDynamicFieldType["RadioButton"] = "RadioButton";
  // eslint-disable-next-line @typescript-eslint/naming-convention
  HisDynamicFieldType["TreeSelect_Institution_Person"] = "TreeSelect_Institution_Person";
  HisDynamicFieldType["Comment"] = "Comment";
  HisDynamicFieldType["Label"] = "Label";
  HisDynamicFieldType["HiddenField"] = "HiddenField";
  HisDynamicFieldType["Anchor"] = "Anchor";
  HisDynamicFieldType["FileUpload"] = "FileUpload";
  HisDynamicFieldType["Form"] = "Form";
  HisDynamicFieldType["Fieldset"] = "Fieldset";
  // eslint-disable-next-line @typescript-eslint/naming-convention
  HisDynamicFieldType["CurrentlyUnknown_999"] = "CurrentlyUnknown_999";
  HisDynamicFieldType["KeytableSelect"] = "KeytableSelect";
  HisDynamicFieldType["KeytableMultiSelect"] = "KeytableMultiSelect";
  HisDynamicFieldType["Chips"] = "Chips";
  HisDynamicFieldType["YesNoSelect"] = "YesNoSelect";
  HisDynamicFieldType["YesNoWithTextArea"] = "YesNoWithTextArea";
  HisDynamicFieldType["DeclarationFieldset"] = "Declaration-Fieldset";
  return HisDynamicFieldType;
}(HisDynamicFieldType || {});
class HisDynamicFieldConfig {}
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function searchFieldConfig(fieldConfigTree, searchCriterion) {
  // if ( !fieldConfigTree ) {
  //     return null;
  // } else
  if (searchCriterion(fieldConfigTree)) {
    return fieldConfigTree;
  } else if (fieldConfigTree.children !== undefined) {
    for (let config of fieldConfigTree.children) {
      let matchingConfig = searchFieldConfig(config, searchCriterion);
      if (matchingConfig !== null) {
        return matchingConfig;
      }
    }
  }
  return null;
}
const DAYS_PER_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
class HisDateUtils {
  static {
    this.languageToDateFormatsMap = new Map([['de', 'dd.mm.yy'], ['en', 'mm/dd/yy']]);
  }
  /**
   * get dateFormat by language locale
   */
  static getDateFormatByLanguageLocale(lang) {
    return this.languageToDateFormatsMap.get(lang);
  }
  /**
   * formats a Date object as string to english fromat - 'yyyy-mm-dd'
   */
  static formatEnglishDateFromString(date) {
    if (!date) {
      return null;
    }
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let dayStr = day > 9 ? day : '0' + day;
    let monthStr = month > 9 ? month : '0' + month;
    return year + '-' + monthStr + '-' + dayStr;
  }
  /**
   * formats a Date object as string to german fromat - 'dd.mm.yyyy'
   */
  static formatGermanDateFromString(date) {
    if (!date) {
      return null;
    }
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let dayStr = day > 9 ? day : '0' + day;
    let monthStr = month > 9 ? month : '0' + month;
    return dayStr + '.' + monthStr + '.' + year;
  }
  /**
   * Convert the given input to a pure date value, where hours and below are truncated,
   * in the timezone given by the browser locale.
   *
   * @param value
   * @return date in browser locale
   */
  static convertToLocalDate(value) {
    let dateStr = HisDateUtils.convertToIsoDateString(value); // truncates hours and below
    if (dateStr === null || dateStr === undefined) {
      return null;
    }
    let intermediateDate = new Date(dateStr);
    // new Date ( dateStr ) creates the given Date in UTC time.
    // To get the correct date for the timezone given by the browser locale we must add the "timezone offset".
    return new Date(intermediateDate.getTime() + intermediateDate.getTimezoneOffset() * 60000);
  }
  /**
   * Convert the given input to a pure date string in ISO format, where hours and below are truncated.
   *
   * @param value
   * @return date string in ISO format
   */
  static convertToIsoDateString(value) {
    try {
      if (value instanceof Date || typeof value === 'number') {
        return new DatePipe('en-US').transform(value, 'yyyy-MM-dd');
      }
      if (typeof value === 'string') {
        return HisDateUtils.parseAndConvertToIsoDateString(value);
      }
    } catch (error) {
      console.log('Error parsing date string', value, ':', error);
      return null;
    }
    console.log('Could not parse date', value, 'of type', typeof value);
    return null;
  }
  /**
   * Convert a date string into a date string in ISO format.
   *
   * Permitted input formats are ISO format yyyy-mm-dd,  german format dd.mm.yyyy and american english format mm/dd/yyyy,
   * optionally followed by a time component which will be truncated.
   *
   * @param value the date string to parse
   * @return the date string in IOS format, or null if the input could not be parsed
   */
  static parseAndConvertToIsoDateString(value) {
    // strip time component if present
    if (value.indexOf(' ') > 0) {
      // date&time format like yyyy-mm-dd hh:mm:ss
      value = value.split(' ')[0];
    }
    if (value.indexOf('T') > 0) {
      // date&time format like yyyy-mm-ddThh:mm:ss
      value = value.split('T')[0];
    }
    // read day, month and year
    let dd;
    let mm;
    let yyyy;
    if (value.indexOf('-') >= 0) {
      // the value is in ISO format
      let p1 = value.indexOf('-');
      yyyy = value.substring(0, p1);
      let p2 = value.indexOf('-', p1 + 1);
      mm = value.substring(p1 + 1, p2);
      dd = value.substring(p2 + 1);
    } else if (value.indexOf('/') >= 0) {
      // the value is in american english date format
      let p1 = value.indexOf('/');
      mm = value.substring(0, p1);
      let p2 = value.indexOf('/', p1 + 1);
      dd = value.substring(p1 + 1, p2);
      yyyy = value.substring(p2 + 1);
    } else if (value.indexOf('.') >= 0) {
      // the value is in german date format
      let p1 = value.indexOf('.');
      dd = value.substring(0, p1);
      let p2 = value.indexOf('.', p1 + 1);
      mm = value.substring(p1 + 1, p2);
      yyyy = value.substring(p2 + 1);
    }
    if (!dd || !mm || !yyyy) {
      return null;
    }
    // validate year
    if (!HisDateUtils.isInteger(yyyy)) {
      return null;
    }
    let yyyyi = parseInt(yyyy, 10);
    if (yyyyi < 1000 || yyyyi > 9999) {
      // ensure 4 digits year
      console.log('Date string containing invalid year value:', value);
      return null;
    }
    let isLeapYear = yyyyi % 4 === 0 || yyyyi % 4 === 0 && yyyyi % 100 !== 0;
    // validate month
    if (!HisDateUtils.isInteger(mm)) {
      return null;
    }
    let mmi = parseInt(mm, 10);
    if (mmi <= 0 || mmi > 12) {
      console.log('Date string containing invalid month value:', value);
      return null;
    }
    let daysOfMonth = DAYS_PER_MONTH[mmi - 1];
    if (mmi === 2 && isLeapYear) {
      daysOfMonth = 29;
    }
    // validate day
    if (!HisDateUtils.isInteger(dd)) {
      return null;
    }
    let ddi = parseInt(dd, 10);
    if (ddi <= 0 || ddi > daysOfMonth) {
      // abhängig von Monat, Schaltjahre
      console.log('Date string containing invalid day value:', value);
      return null;
    }
    // return date in ISO format
    return yyyy + '-' + mm + '-' + dd;
  }
  static isInteger(s) {
    for (let c of s) {
      if (c < '0' || c > '9') {
        return false;
      }
    }
    return true;
  }
}
class HisDynamicFieldBase {
  constructor(formGroup, options, valueGroup, hisBaseGlobalsService) {
    this.hisBaseGlobalsService = hisBaseGlobalsService;
    this.value = this.getValue(options.defaultValue);
    this.name = options.name;
    this.required = !!options.required;
    this.ddKey = options.ddKey;
    this.controlType = options.controlType;
    this.formGroup = formGroup;
    this.valueGroup = valueGroup;
    this.disabled = !!options.disabled;
  }
  initFormControl(value) {
    this.defaultValue = _.cloneDeep(value);
    if (this.formGroup) {
      if (this.required) {
        if (this.ddKey) {
          this.formControl = new UntypedFormControl(value);
          this.hisBaseGlobalsService.setRequiredToDdEntry(this.ddKey, true);
        } else {
          this.formControl = new UntypedFormControl(value, {
            validators: [Validators.required]
          });
        }
      } else {
        this.formControl = new UntypedFormControl(value);
      }
      if (this.disabled) {
        this.formControl.disable();
      }
      this.registerSelfWithGroups();
    }
  }
  getValue(value) {
    if (!!value || value === 0 || value === false) {
      return value;
    }
    return '';
  }
  registerSelfWithGroups() {
    this.formGroup.registerControl(this.name, this.formControl);
    this.valueGroup.registerDynamicField(this, this.formControl.valueChanges);
  }
  searchFieldConfig(fieldConfigTree) {
    let searchCriterion = config => config.name === this.name;
    return searchFieldConfig(fieldConfigTree, searchCriterion);
  }
  reset() {
    if (this.formGroup) {
      this.formControl.reset(this.defaultValue);
    }
  }
}
let HisUidService = /*#__PURE__*/(() => {
  class HisUidService {
    static {
      this.counter = 0;
    }
    static get(prefix, postfix) {
      let radix = 36;
      let now = Date.now().toString(radix);
      HisUidService.counter++;
      let counter = HisUidService.counter.toString(radix);
      let id = now + counter;
      if (prefix) {
        id = prefix + id;
      }
      if (postfix) {
        id = id + postfix;
      }
      return id;
    }
  }
  return HisUidService;
})();
/**
 * Validatoren für Date-Werte
 * Unterstützte Operatoren:
 * - minDate
 * - maxDate
 */
class HisDateValidator {
  static minDate(refDate) {
    let localDate = HisDateUtils.convertToLocalDate(refDate);
    return control => {
      return this.doValidate('minDate', localDate, control);
    };
  }
  static maxDate(refDate) {
    let localDate = HisDateUtils.convertToLocalDate(refDate);
    return control => {
      return this.doValidate('maxDate', localDate, control);
    };
  }
  /**
   * Validiere den Input eines form controls c.
   * c.value kann ein string sein (aus Eingabefeldern) oder ein Date-Objekt (aus der p-calendar-Komponente).
   */
  static doValidate(operator, refDate, c) {
    if (c.value === null || c.value === undefined || c.value === '') {
      // leeres Input-Feld -> keine Validierung
      return null;
    }
    let currentDate = HisDateUtils.convertToLocalDate(c.value);
    if (currentDate == null) {
      // Verhindere falsche minDate-Fehlermeldung bei nicht parsebarem Datumsstring
      return null;
    }
    let valid = true;
    if (operator === 'minDate') {
      valid = currentDate.getTime() >= refDate.getTime();
    } else if (operator === 'maxDate') {
      valid = currentDate.getTime() <= refDate.getTime();
    }
    if (valid) {
      return null;
    }
    let errorObject = {};
    errorObject.valid = false;
    errorObject.actualValue = currentDate;
    errorObject.refValue = refDate;
    let errorState = {}; // können wir den Generic-Typ besser eingrenzen?
    errorState[operator] = errorObject;
    return errorState;
  }
}

/**
 * Wrapper für einen Validator bzw. Validator-Function, um bei Fehlschlag den ValidationState
 * mit einer internationailsierbaren Meldung anzureichen.
 * Dabei können die Fehlerinformationen des gewrappeten Validators als Parameter eingesetzt werden.
 *
 * TODO: wie kann ich hier statisch auf den HisUiService zugreifen?
 */
class HisValidatorAndMessage {
  /**
   * Konstruktor
   *
   * @param name Schlüssel, unter dem die Validator-Funktion ihre Fehlerinformationen im ErrorState ablegt
   * @param validatorFn Validator-Funktion
   * @param hisUiService HisUiService
   */
  constructor(name, validatorFn, hisUiService) {
    this.name = name;
    this.validatorFn = validatorFn;
    this.hisUiService = hisUiService;
    this.dirtyOnly = true;
  }
  /**
   * Wiederverwendbare Methode zum erzeugen der Fehlermeldung aus errorState und Konfiguration
   */
  static createErrorMessage(stateObject, messageKey, paramNames, hisUiService) {
    let params = [];
    if (paramNames) {
      paramNames.forEach(name => {
        params.push(stateObject[name]);
      });
    }
    return hisUiService.translate(messageKey, ...params);
  }
  getValidatorFn() {
    return this.validatorFn;
  }
  /**
   * Führt die Validierung aus und reichert im Fehlerfall den State mit einer Message an
   */
  validate(c) {
    if (this.dirtyOnly && !c.dirty) {
      return null;
    }
    let state = this.validatorFn(c);
    if (state) {
      state = this.fillValidationState(state);
    }
    return state;
  }
  /**
   * Reichert den ValidationState mit einer ggf. parametrierten I18n-Message an.
   */
  fillValidationState(state) {
    state = this.normalizeState(state);
    let stateObject = state[this.name];
    if (stateObject) {
      stateObject.valid = false;
      stateObject.message = HisValidatorAndMessage.createErrorMessage(stateObject, this.messageKey, this.paramNames, this.hisUiService);
    }
    return state;
  }
  /**
   * Einige Validatoren weichen von der Systematik ab, ein Error-Objekt mit 'valid=false'
   * anzulegen. Für diese wird der state so umgeformt, dass er darauf passt.
   * Das dient insb. dazu, später die Message dem Error-Objekt hinzufügen zu können.
   */
  normalizeState(state) {
    if (state.required === true) {
      state.required = {};
    }
    return state;
  }
}
class MessageConfig {}
class ValidatorConfig {}
/**
 * Factory für Validator(en) der DataDictionary - Datentypen
 *
 * TODO: Konfiguration vom Server holen oder Globale Konfigurationsschlüssel auflösen können
 */
let HisDdValidatorFactory = /*#__PURE__*/(() => {
  class HisDdValidatorFactory {
    constructor() {
      this.hisUiService = inject(HisUiService);
      this.msgConfigs = {
        required: {
          msgKey: 'validation.required'
        },
        maxlength: {
          msgKey: 'de.his.validator.LengthValidator.MAXIMUM',
          msgParams: ['actualLength', 'requiredLength']
        },
        minlength: {
          msgKey: 'de.his.validator.LengthValidator.MINIMUM',
          msgParams: ['actualLength', 'requiredLength']
        },
        min: {
          msgKey: 'de.his.faces.validator.NumberValidator.min',
          msgParams: ['actual', 'min']
        },
        max: {
          msgKey: 'de.his.faces.validator.NumberValidator.max',
          msgParams: ['actual', 'max']
        },
        pattern: {
          msgKey: 'de.his.validator.regex',
          msgParams: ['actualValue', 'requiredPattern']
        },
        minDate: {
          msgKey: 'de.his.validator.PastDateValidator.MINIMUM',
          msgParams: ['refValue', 'actualValue']
        },
        maxDate: {
          msgKey: 'de.his.validator.FutureDateValidator.MAXIMUM',
          msgParams: ['refValue', 'actualValue']
        }
      };
      this.validatorConfigs = {
        required: {
          type: 'required'
        },
        minLength: {
          type: 'minLength'
        },
        maxLength: {
          type: 'maxLength'
        },
        minValueInteger: {
          type: 'min'
        },
        maxValueInteger: {
          type: 'max'
        },
        maxValueDouble: {
          refTo: 'maxValueInteger'
        },
        minValueDouble: {
          refTo: 'minValueInteger'
        },
        pattern: {
          type: 'pattern'
        },
        minValueDate: {
          type: 'minDate'
        },
        maxValueDate: {
          type: 'maxDate'
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        FUTURE_DATE: {
          refTo: 'minValueDate',
          validatorParam: new Date(),
          // now()
          msgKey: 'de.his.validator.FutureDateValidator.PAST'
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        PAST_DATE: {
          refTo: 'maxValueDate',
          validatorParam: new Date(),
          // now()
          msgKey: 'de.his.validator.PastDateValidator.FUTURE'
        },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        PERSON_NAME: {
          refTo: 'pattern',
          msgKey: 'error.psv.Person.invalidName',
          validatorParam: '.{2,}' // (zu) vereinfachtes Pattern
          // regexKey: 'core.sys.metadata.types.person_name.regexp',
          // regex: '(?=.{2,})(?:[a-zA-ZÖÄÜöäüß’\'´`\u00C0-\u00FF\u0100-\u017F\u0180-\u024F&&[^\u00D7\u00F7]]+\\.?)'
          //  + '(?>(?>[ \\-]?[a-zA-ZÖÄÜöäüß’'´`\u00C0-\u00FF\u0100-\u017F\u0180-\u024F&&[^\u00D7\u00F7]]+\\.?)*)'
          // regex: '[A-Z][a-z]*'
        }
        // ,
        // 'EMAIL': { // Pattern funktioniert so nicht
        //     refTo: 'pattern',
        //     msgKey: 'de.his.validator.email.message',
        //     validatorParam: '[A-Za-z0-9_][a-zA-Z0-9+_\.\-\%]*@[A-Za-z0-9][a-zA-Z0-9\.\-]*\.[A-Za-z]{2,}'
        // }
      };
      this.mergedConfigCache = {};
    }
    /**
     * Erzeugt den hier für den configName konfigurierten Validator
     *
     * @param configName Name des Validators ('required', 'min', ...)
     * @param param Validator-Parameter oder null wenn der Validator keinen Parameter hat
     */
    createValidator(configName, param) {
      let config = this.getAndMergeConfig(configName);
      return config ? this.createValidatorFromConfig(config, param) : null;
    }
    /**
     * Erzeugt einen Validator anhand der gegebenen Konfiguration
     */
    createValidatorFromConfig(config, validatorParam) {
      // Wenn in der Config ein Parameter angegeben ist und hier nicht überschrieben, diesen verwenden.
      if (validatorParam == null && config.validatorParam != null) {
        validatorParam = config.validatorParam;
      }
      let validatorFn = null;
      switch (config.type) {
        case 'required':
          validatorFn = Validators.required;
          break;
        case 'minLength':
          validatorFn = Validators.minLength(validatorParam);
          break;
        case 'maxLength':
          validatorFn = Validators.maxLength(validatorParam);
          break;
        case 'min':
          validatorFn = Validators.min(validatorParam);
          break;
        case 'max':
          validatorFn = Validators.max(validatorParam);
          break;
        case 'pattern':
          validatorFn = Validators.pattern(validatorParam);
          break;
        case 'minDate':
          validatorFn = HisDateValidator.minDate(validatorParam);
          break;
        case 'maxDate':
          validatorFn = HisDateValidator.maxDate(validatorParam);
          break;
      }
      let validator = new HisValidatorAndMessage(config.type, validatorFn, this.hisUiService);
      validator.messageKey = config.msgKey;
      validator.paramNames = config.msgParams;
      return validator;
    }
    /**
     * Berechnet Fehlermeldungen für Validierungs-Zustände, die nicht über HisValidatorAndMessage entstanden sind.
     */
    getMessageForError(msgConfigName, state) {
      let msgConfig = this.msgConfigs[msgConfigName];
      if (msgConfig != null) {
        return HisValidatorAndMessage.createErrorMessage(state, msgConfig.msgKey, msgConfig.msgParams, this.hisUiService);
      }
      return 'undefined message for error type: ' + msgConfigName;
    }
    /**
     * Holt die Validator-Konfiguration unter dem configName.
     * Wenn dort per 'refTo' ein Verweis auf eine Basiskonfiguration
     * hinterlegt wurde, wird diese zunächst geholt und mit der eigentlichen
     * Konfiguration gemerged.
     * Es wird auf Clonen gearbeitet, um die originalen Konfigurationen nicht zu verändern.
     */
    getAndMergeConfig(configName) {
      // Versuchen, die Konfiguration aus dem Cache zu holen
      let config = this.mergedConfigCache[configName];
      if (config) {
        return config;
      }
      config = this.validatorConfigs[configName];
      if (!config) {
        console.warn('No Validator registered for Type: ' + configName);
        return null;
      }
      // Neu berechnen: MessageConfig-Attribute kommen zuerst, damit sie durch ValidatorConfig-Attribute überschrieben werden können.
      let mergedConfig = new ValidatorConfig();
      let msgConfig = this.msgConfigs[config.type];
      Object.assign(mergedConfig, msgConfig);
      // Jetzt die Attribute aus der ValidatorConfig hinzufügen, evtl. auch über refTo
      Object.assign(mergedConfig, config);
      if (config.refTo != null) {
        let baseConfig = this.getAndMergeConfig(config.refTo);
        if (baseConfig != null) {
          Object.assign(mergedConfig, baseConfig);
        }
      }
      // Errechnete Konfiguration in den Cache legen
      this.mergedConfigCache[configName] = mergedConfig;
      return mergedConfig;
    }
    static {
      this.ɵfac = function HisDdValidatorFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDdValidatorFactory)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDdValidatorFactory,
        factory: HisDdValidatorFactory.ɵfac
      });
    }
  }
  return HisDdValidatorFactory;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * DataDictionary validator.
 */
let HisDdValidator = /*#__PURE__*/(() => {
  class HisDdValidator {
    constructor() {
      this.validatorFactory = inject(HisDdValidatorFactory);
      this.validatorCalls = [];
    }
    getValidators() {
      let vals = [];
      this.validatorCalls.forEach(val => {
        vals.push(val.getValidatorFn());
      });
      return vals;
    }
    registerValidators(ddEntry) {
      this.validatorCalls = [];
      // Erstellt einfache Validierungen über die ValidatorFactory, falls im DD konfiguriert
      this.createSimpleValidator('required', ddEntry.required);
      this.createSimpleValidator('minLength', ddEntry.minLength);
      this.createSimpleValidator('maxLength', ddEntry.maxLength);
      this.createSimpleValidator('minValueInteger', ddEntry.minValueInteger);
      this.createSimpleValidator('maxValueInteger', ddEntry.maxValueInteger);
      this.createSimpleValidator('minValueDouble', ddEntry.minValueDouble);
      this.createSimpleValidator('maxValueDouble', ddEntry.maxValueDouble);
      this.createSimpleValidator('minValueDate', ddEntry.minValueDate);
      this.createSimpleValidator('maxValueDate', ddEntry.maxValueDate);
      // regexValidation
      if (ddEntry.regexPattern != null) {
        let regex = ddEntry.regexPattern;
        // Der Pattern-Validator ergänzt selbst noch ^ am Anfang und $ am Ende
        if (regex.startsWith('^')) {
          regex = regex.substring(1);
        }
        if (regex.endsWith('$')) {
          regex = regex.slice(0, -1);
        }
        let call = this.validatorFactory.createValidator('pattern', regex);
        if (ddEntry.regexErrortextIdentifier) {
          call.messageKey = ddEntry.regexErrortextIdentifier;
        }
        this.validatorCalls.push(call);
      }
      // Datatype-Validation
      if (ddEntry.datatype != null) {
        let call = this.validatorFactory.createValidator(ddEntry.datatype, null);
        if (call) {
          this.validatorCalls.push(call);
        }
      }
    }
    createSimpleValidator(ddAttributeName, ddAttributeValue) {
      if (ddAttributeValue != null && ddAttributeValue !== false) {
        let call = this.validatorFactory.createValidator(ddAttributeName, ddAttributeValue);
        this.validatorCalls.push(call);
      }
    }
    /**
     * Führt die oben erzeugten DD-Validierungen aus.
     */
    validate(c) {
      for (let call of this.validatorCalls) {
        let state = call.validate(c);
        if (state) {
          return state;
        }
      }
      return null;
    }
    static {
      this.ɵfac = function HisDdValidator_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDdValidator)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisDdValidator,
        selectors: [["", "hisDdKey", ""]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALIDATORS,
          useExisting: HisDdValidator,
          multi: true
        }])]
      });
    }
  }
  return HisDdValidator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Notification {
  constructor() {
    // new = displayed for the first time; showagain = a hidden notification is displayed again
    this.state = 'new';
  }
}
var NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType[NotificationType["Success"] = 0] = "Success";
  NotificationType[NotificationType["Error"] = 1] = "Error";
  NotificationType[NotificationType["Info"] = 2] = "Info";
  NotificationType[NotificationType["Warning"] = 3] = "Warning";
  return NotificationType;
}(NotificationType || {});
let HisNotificationService = /*#__PURE__*/(() => {
  class HisNotificationService {
    constructor() {
      this.hisUiService = inject(HisUiService);
      this.hisAuthService = inject(HisAuthService);
      this.hisNavigationService = inject(HisNavigationService);
      this.subject = new BehaviorSubject(undefined);
      // Benachrichtigungsmechanismus für FieldMessages
      this.fieldMessages = new Subject();
      this.fieldMessages$ = this.fieldMessages.asObservable();
    }
    notifyFieldMessage(message) {
      this.fieldMessages.next(message);
    }
    getNotification() {
      return this.subject.asObservable();
    }
    notify(notification) {
      this.notification(notification.type, notification.messages, notification.header, notification.timeOut);
    }
    success(message, header, timeOut) {
      this.hisNavigationService.dirty = false;
      if (!timeOut) {
        timeOut = 4000;
      }
      if (this.hisAuthService.hasAll('RIGHT_CS_SYS_USABILITY_SHOW_OCCASIONAL_USER')) {
        timeOut = undefined;
      }
      this.notification(NotificationType.Success, message, header, timeOut);
    }
    error(message, header, timeOut) {
      this.notification(NotificationType.Error, message, header, timeOut);
    }
    info(message, header, timeOut) {
      this.notification(NotificationType.Info, message, header, timeOut);
    }
    warn(message, header, timeOut) {
      this.notification(NotificationType.Warning, message, header, timeOut);
    }
    notification(type, message, header, timeOut) {
      // convert single elements to array with one element
      message = [].concat(message);
      // wenn in iFrame, dann Meldung weiter reichen an jsf und hier unterbinden
      if (window !== window.parent) {
        const messages = [];
        const notificationTypeLowerCase = NotificationType[type].toLowerCase();
        for (let m of message) {
          messages.push({
            text: m,
            type: notificationTypeLowerCase,
            title: header
          });
        }
        const stringNotification = JSON.stringify(messages);
        window.parent.postMessage(stringNotification, window.location.origin);
        return;
      }
      this.subject.next({
        type,
        messages: message,
        header,
        timeOut,
        state: 'new'
      });
    }
    clear() {
      this.subject.next(undefined);
    }
    errorI18nRes(messageKey, ...params) {
      this.error(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('fs.res.common.service.error'));
    }
    errorI18n(messageKey, ...params) {
      this.error(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('view.messages.error'));
    }
    warnI18nRes(messageKey, ...params) {
      this.warn(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('fs.res.common.service.warn'));
    }
    warnI18n(messageKey, ...params) {
      this.warn(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('view.messages.warning'));
    }
    infoI18nRes(messageKey, ...params) {
      this.info(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('fs.res.common.service.information'));
    }
    infoI18n(messageKey, ...params) {
      this.info(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('view.messages.information'));
    }
    successI18nRes(messageKey, ...params) {
      this.success(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('fs.res.common.success'));
    }
    successI18n(messageKey, ...params) {
      this.success(this.hisUiService.translate(messageKey, ...params), this.hisUiService.translate('view.messages.success'));
    }
    deleteSuccessI18nRes() {
      this.success(this.hisUiService.translate('view.success.delete'), this.hisUiService.translate('fs.res.common.confirmation.delete'));
    }
    deleteSuccessI18n() {
      this.success(this.hisUiService.translate('view.success.delete'), this.hisUiService.translate('fs.res.common.confirmation.delete'));
    }
    static {
      this.ɵfac = function HisNotificationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisNotificationService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisNotificationService,
        factory: HisNotificationService.ɵfac
      });
    }
  }
  return HisNotificationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * communication with the HISinOne server
 */
let HisBackendService = /*#__PURE__*/(() => {
  class HisBackendService {
    constructor() {
      this.http = inject(HttpClient);
      this.notificationService = inject(HisNotificationService);
      this.hisUiService = inject(HisUiService);
      this.prefix = '../../';
    }
    /**
     * displays an error message as notification and logs the details of the error
     *
     * @param requestOptions specified when making the request
     * @param err internal error message
     */
    handleError(requestOptions, err) {
      let body = err.error;
      if (!body) {
        body = {};
      }
      if (err.status === 401 || err.status === 403) {
        // Unauthorized
        if (!requestOptions || requestOptions.showPermissionError !== false) {
          let errorMessageTitle = this.hisUiService.translate('common.errorpage.title') || 'Unauthorized';
          let errorMessageText = this.hisUiService.translate('common.service.accessDenied') || 'No permisions';
          this.notificationService.clear();
          this.notificationService.error(errorMessageText, errorMessageTitle);
        }
      } else if (err.status === 422) {
        // Validation error
        if (!requestOptions || requestOptions.showValidationError !== false) {
          let errorMessageTitle = this.hisUiService.translate('view.messages.error') || 'Validation Error';
          let errorMessageText = null;
          let errorException = body;
          if (errorException.messages && errorException.messages.length > 0) {
            errorMessageText = [];
            for (let entry of errorException.messages) {
              this.notificationService.notifyFieldMessage(entry);
              if (entry.message) {
                errorMessageText.push(entry.message);
              } else if (entry.messageKey && entry.messageParameters) {
                let messageParameters = this.adaptMessageParameters(entry.messageParameters);
                errorMessageText.push(this.hisUiService.translate(entry.messageKey, ...messageParameters) || 'Not found');
              } else if (entry.messageKey) {
                errorMessageText.push(this.hisUiService.translate(entry.messageKey) || 'Not found');
              } else {
                errorMessageText.push('Not found');
              }
            }
          } else {
            if (errorException.description) {
              errorMessageText = errorException.description;
            } else if (errorException.descriptionKey && errorException.descriptionParameters) {
              let descriptionParameters = this.adaptMessageParameters(errorException.descriptionParameters);
              errorMessageText = this.hisUiService.translate(errorException.descriptionKey, ...descriptionParameters) || 'Not found';
            } else if (errorException.descriptionKey) {
              errorMessageText = this.hisUiService.translate(errorException.descriptionKey) || 'Not found';
            } else {
              errorMessageText = errorMessageTitle;
            }
          }
          this.notificationService.clear();
          this.notificationService.error(errorMessageText, errorMessageTitle);
        }
      } else if (err.status === 404) {
        if (!requestOptions || requestOptions.showNotFoundError !== false) {
          let errorMessageTitle = this.hisUiService.translate('common.errorpage.title') || 'Not found';
          let errorMessageText = this.hisUiService.translate('common.errorpage.notfound') || 'Not found';
          this.notificationService.clear();
          this.notificationService.error(errorMessageText, errorMessageTitle);
        }
      } else {
        // Any other kind of error: Display general message. Do not include err.statusText
        // (e.g. "Internal Server Error") because it may be "OK", for example on 422.
        if (!requestOptions || requestOptions.showUnexpectedError !== false) {
          let errorMessageTitle = this.hisUiService.translate('common.errorpage.title') || 'Internal error';
          let errorMessageText = [this.hisUiService.translate('common.errorpage.text', '') || 'An internal error occured'];
          if (body.description) {
            errorMessageText.push('Detail: ' + body.description);
          } else if (body.descriptionKey && body.descriptionParameters) {
            let descriptionParameters = this.adaptMessageParameters(body.descriptionParameters);
            errorMessageText.push(this.hisUiService.translate(body.descriptionKey, ...descriptionParameters) || 'Not found');
          } else if (body.descriptionKey) {
            errorMessageText.push(this.hisUiService.translate(body.descriptionKey) || 'Not found');
          }
          console.error('backend returned error:', err);
          this.notificationService.clear();
          this.notificationService.error(errorMessageText, errorMessageTitle);
        }
      }
    }
    adaptMessageParameters(paramsObject) {
      let result = [];
      let parameterKeys = Object.keys(paramsObject).map(Number);
      let parameterNumber = parameterKeys.reduce((a, b) => Math.max(a, b), -Infinity);
      if (isFinite(parameterNumber)) {
        parameterNumber += 1;
        let parIdx = 0;
        while (parIdx < parameterNumber) {
          if (parIdx in parameterKeys) {
            result[parIdx] = paramsObject[parIdx];
          } else {
            result[parIdx] = '';
          }
          parIdx += 1;
        }
      }
      return result;
    }
    createOptions(requestOptions) {
      let header = {};
      if (this.bearerToken) {
        header = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization: 'Bearer ' + this.bearerToken
        };
      }
      if (this.testcase) {
        header['X-HIS-Testcase'] = this.testcase;
      }
      if (requestOptions && requestOptions.blockUI === false) {
        header['X-HIS-Block-Ui'] = 'false';
      }
      let options = {
        headers: header
      };
      return options;
    }
    /**
     * invokes a HISinOne REST service to read data
     */
    getData(url, requestOptions) {
      this.updateLastRefresh();
      let options = this.createOptions(requestOptions);
      console.log('getData #options', options);
      let result = this.http.get(this.prefix + url, options);
      console.log('getData #this.prefix', this.prefix, '#url', url);
      //console.log('getData #result', result);
      return result.pipe(tap({
        error: err => this.handleError(requestOptions, err)
      }));
    }
    postData(url, data, requestOptions) {
      this.updateLastRefresh();
      let options = this.createOptions(requestOptions);
      console.log('postData #this.prefix', this.prefix, '#url', url, '#data', data, '#options', options);
      let result = this.http.post(this.prefix + url, data, options);
      return result.pipe(tap({
        error: err => this.handleError(requestOptions, err)
      }));
    }
    putData(url, data, requestOptions) {
      this.updateLastRefresh();
      let options = this.createOptions(requestOptions);
      let result = this.http.put(this.prefix + url, data, options);
      return result.pipe(tap({
        error: err => this.handleError(requestOptions, err)
      }));
    }
    saveData(url, data, requestOptions) {
      if (data.id) {
        return this.putData(url + '/' + data.id, data, requestOptions);
      } else {
        return this.postData(url, data, requestOptions);
      }
    }
    delete(url, requestOptions) {
      this.updateLastRefresh();
      let options = this.createOptions(requestOptions);
      let result = this.http.delete(this.prefix + url, options);
      return result.pipe(tap({
        error: err => this.handleError(requestOptions, err)
      }));
    }
    /**
     * update the lastRefresh cookie which is used for the countdown and client side logout.
     */
    updateLastRefresh() {
      let lastRefresh = new Date().getTime();
      // set path to the contextPath of the web application
      let path = document.location.pathname;
      let endPosition = path.indexOf('/', 1);
      document.cookie = 'lastRefresh=' + lastRefresh + ';path=' + path.substring(0, endPosition) + ';SameSite=Lax;Secure';
    }
    initTestMode(prefix, testcase, bearerToken) {
      this.prefix = prefix;
      if (testcase) {
        if (testcase.indexOf(' ') < 0) {
          console.log('Deprecated initTestMode invokation');
          this.bearerToken = testcase;
          return;
        }
      }
      this.testcase = testcase;
      this.bearerToken = bearerToken;
    }
    static {
      this.ɵfac = function HisBackendService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisBackendService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisBackendService,
        factory: HisBackendService.ɵfac
      });
    }
  }
  return HisBackendService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisBackendRequestOptions {
  constructor() {
    this.showPermissionError = true;
    this.showValidationError = true;
    this.showNotFoundError = true;
    this.showUnexpectedError = true;
    this.blockUI = true;
  }
}
class ErrorMessage {}
class ExceptionResponse {}
class Language {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  constructor(id, text, uniquename, iso_639_1) {
    this.id = id;
    this.text = text;
    this.uniquename = uniquename;
    this.iso_639_1 = iso_639_1;
  }
}

/* eslint-disable no-underscore-dangle */
let HisTranslationService = /*#__PURE__*/(() => {
  class HisTranslationService {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisBackendService = inject(HisBackendService);
      this.hisUiService = inject(HisUiService);
      this.translationLanguage = new BehaviorSubject(undefined);
      this.translationLanguage$ = this.translationLanguage.asObservable();
    }
    /**
     * Translates the attribute from an object to another language if the _foreigntext is correctly filled
     *
     * @param object - the object with translatable attributes
     * @param attributeName - name of the attribute
     * @param language - the language to translate to (if not given the currently selected language from HisBaseGlobalsService is used)
     */
    translate(hisObject, hisAttribute, language) {
      // if language is not given, we'll use the language from hisBaseGlobalsService
      if (!language) {
        language = this.hisBaseGlobalsService.getLanguage();
      }
      // if the wanted language is not existing, the default value will be returned
      if (this.isTranslationExisting(hisObject, hisAttribute, language)) {
        return hisObject._foreigntext[language][hisAttribute];
      } else if (hisObject[hisAttribute]) {
        return hisObject[hisAttribute];
      } else {
        console.warn('No attribute named \'', hisAttribute, '\' present in object ', hisObject);
        return undefined;
      }
    }
    /**
     * Returns all possible translation languages as an array.
     * First entry of this array always contains the manipulated defaultLanguage (defaultLanguage.text + translation.defaultLanguagePrefix)
     */
    translationsLanguages(defaultLanguage) {
      let languages = [];
      // add the defaultLanguage at index 0
      languages.push(new Language(defaultLanguage.id, defaultLanguage.text + ' ' + this.hisUiService.translate('translation.defaultLanguage.suffix'), defaultLanguage.uniquename, defaultLanguage.uniquename));
      let langCodes = this.hisBaseGlobalsService.translationLanguages.split(',');
      for (let langCode of langCodes) {
        this.hisBackendService.getData('api/v1/cs/sys/values/languageValue?q=' + langCode).subscribe(langs => {
          for (let lang of langs) {
            if (lang.uniquename === langCode && lang.id !== defaultLanguage.id) {
              languages.push(new Language(lang.id, lang.text, lang.uniquename, lang.uniquename));
            }
          }
        });
      }
      return languages;
    }
    setTranslationLanguage(translationLanguage) {
      this.translationLanguage.next(translationLanguage);
    }
    /** Set the value of the given hisAttribute in the currently active language. */
    setHisObjectActiveAttribute(hisObject, hisAttribute, newValue) {
      if (!this.translationLanguage.value) {
        hisObject[hisAttribute] = newValue;
      } else {
        this.ensureForeigntextNotNull(hisObject, hisAttribute);
        hisObject._foreigntext[this.translationLanguage.value.iso_639_1][hisAttribute] = newValue;
        this.deleteEmptyForeigntext(hisObject, hisAttribute);
      }
    }
    /** Return the value of the given hisAttribute in the currently active language.
     *  If it is not existing yet, it will be initialized as empty string
     */
    getHisObjectActiveAttribute(hisObject, hisAttribute) {
      if (!this.translationLanguage.value) {
        // return hisAttribute in defaultLanguage
        return hisObject[hisAttribute] ? hisObject[hisAttribute] : '';
      } else {
        if (this.isTranslationExisting(hisObject, hisAttribute, this.translationLanguage.value.uniquename)) {
          // return hisAttribute in translationLanguage
          return hisObject._foreigntext[this.translationLanguage.value.iso_639_1][hisAttribute];
        }
        // return empty string
        return '';
      }
    }
    /** Ensures that the given attribute is given for the current translationLanguage */
    ensureForeigntextNotNull(hisObject, hisAttribute) {
      if (!hisObject._foreigntext) {
        hisObject._foreigntext = {};
      }
      if (!hisObject._foreigntext[this.translationLanguage.value.iso_639_1]) {
        // initialize empty object for the specific language
        hisObject._foreigntext[this.translationLanguage.value.iso_639_1] = {};
      }
      if (!hisObject._foreigntext[this.translationLanguage.value.iso_639_1][hisAttribute]) {
        // initialize it as empty string
        hisObject._foreigntext[this.translationLanguage.value.iso_639_1][hisAttribute] = '';
      }
    }
    /** Removes empty foreigntext */
    deleteEmptyForeigntext(hisObject, hisAttribute) {
      if (!hisObject._foreigntext) {
        return;
      }
      if (hisObject._foreigntext[this.translationLanguage.value.iso_639_1][hisAttribute] === '') {
        // delete empty translation on lowest level (attribute)
        delete hisObject._foreigntext[this.translationLanguage.value.iso_639_1][hisAttribute];
      }
      if (Object.keys(hisObject._foreigntext[this.translationLanguage.value.iso_639_1]).length === 0) {
        // delete empty translation on mid level (language)
        delete hisObject._foreigntext[this.translationLanguage.value.iso_639_1];
      }
    }
    /**
     * Returns true if the wanted translation is given in _foreigntexts
     */
    isTranslationExisting(hisObject, hisAttribute, language) {
      return hisObject._foreigntext && hisObject._foreigntext[language] && hisObject._foreigntext[language][hisAttribute] && hisObject._foreigntext[language][hisAttribute].length > 0;
    }
    static {
      this.ɵfac = function HisTranslationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslationService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisTranslationService,
        factory: HisTranslationService.ɵfac
      });
    }
  }
  return HisTranslationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class SvgService {
  constructor() {
    this.http = inject(HttpClient);
  }
  static {
    this.cache = new Map();
  }
  // get a SVGElement wrapped in an Observable
  getSVG(url) {
    if (SvgService.cache.has(url)) {
      // svg is in cache -> load it from cache
      return SvgService.cache.get(url);
    } else {
      // svg is not in cache -> load it from url
      let req = this.loadSVG(url);
      SvgService.cache.set(url, req);
      return req;
    }
  }
  // loads an SVG file from an URL
  loadSVG(url) {
    let obs = new BehaviorSubject(null);
    this.http.get(url, {
      responseType: 'text'
    }).subscribe(svgText => {
      let svg = this.svgElementFromString(svgText);
      obs.next(svg);
    });
    return obs;
  }
  // converts textcontent of a SVG file to a SVGElement
  svgElementFromString(str) {
    const div = document.createElement('div');
    div.innerHTML = str;
    const svg = div.querySelector('svg');
    if (!svg) {
      throw new Error('Cannot parse SVG-Element from string');
    }
    return svg;
  }
  static {
    this.ɵfac = function SvgService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SvgService)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: SvgService,
      factory: SvgService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * looks up an image file key in DispatcherProperties.txt.
 *
 * hisImage may be used directly on img-elements or on any element which may accept
 * a dynamically generated img-element as child.
 */
let HisImageDirective = /*#__PURE__*/(() => {
  class HisImageDirective {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.el = inject(ElementRef);
      this.svgService = inject(SvgService);
      this.inlineSVGEnabled = true;
      this.forceIMG = false;
    }
    ngOnChanges(changes) {
      if (changes.hisImage) {
        // The title attribute must be attached to the element declaring the hisImage directive.
        if (this.title) {
          this.el.nativeElement.title = this.title;
        }
        let image = this.hisBaseGlobalsService.getImage(this.hisImage);
        if (!image) {
          return;
        }
        // If no SVG file or img-Element is forced -> use img-tag
        if (this.getFileExtension(image) !== 'svg' || this.forceIMG || !this.inlineSVGEnabled) {
          this.createOrCompleteImageElement(this.el.nativeElement, image);
        } else {
          this.svgService.getSVG('/HISinOne/images/' + image).subscribe(svgEl => {
            if (svgEl) {
              svgEl = svgEl.cloneNode(true);
              // only use svg-files with the class 'his-icon'
              if (svgEl.classList.contains('his-icon')) {
                if (this.el.nativeElement.tagName === 'SPAN' || this.el.nativeElement.tagName === 'DIV') {
                  // replacing svg-files not working for <img> / <button> / <a> tags
                  this.addOrReplaceSVGElementToElement(svgEl, this.el.nativeElement);
                } else {
                  this.addSVGElementToElement(svgEl, this.el.nativeElement);
                }
                svgEl.setAttribute('aria-hidden', 'true');
              } else {
                this.createOrCompleteImageElement(this.el.nativeElement, image);
              }
            }
          });
        }
      }
    }
    /**
     * Find or create the HTML img element, and set all required attributes.
     *
     * @param image the name of the image
     */
    createOrCompleteImageElement(element, image) {
      let img = this.findOrCreateImageElement(element);
      img.src = '/HISinOne/images/' + image;
      // We need alt="" to avoid that a screenreader reads the src-attribute
      img.alt = '';
    }
    /**
     * find the img-element to operate on. Create an img-element child, if necessary
     *
     * @param element element this directive is defined on
     */
    findOrCreateImageElement(element) {
      // if we are defined on an img-element, use it directly
      if (element.tagName === 'IMG') {
        return element;
      }
      // is the first child-element an img-element for us to use?
      let child = element.firstElementChild;
      if (child && child.tagName === 'IMG') {
        return child;
      }
      // insert an img-element as first child
      let img = element.ownerDocument.createElement('img');
      img.className = 'inlineicon';
      element.insertBefore(img, element.firstChild);
      return img;
    }
    /**
     * add inline SVG to a HTMLElement
     *
     * @param svgEl SVGElement
     * @param el HTMLElement
     */
    addSVGElementToElement(svgEl, el) {
      // replace <img>-tag
      if (el.tagName === 'IMG') {
        // create an outer span with a title attribute because title is not valid on <svg>
        let outerSpan = document.createElement('span');
        outerSpan.appendChild(svgEl);
        this.copyAttributes(el, outerSpan);
        // create an inner span after the <svg>-tag because screenreaders ignore title on outer <span>
        let span = document.createElement('span');
        span.className = 'visibilityOnlyForScreenreader';
        span.innerText = el.title;
        outerSpan.appendChild(span);
        if (el.parentNode) {
          el.parentNode.insertBefore(outerSpan, el);
          el.parentNode.removeChild(el);
        } else {
          console.log('Oops, no parentNode! Is the image displayed in dependency of a condition involving lazy loaded data?');
        }
      } else {
        // otherwise add <svg> as child
        svgEl.classList.add('inlineicon');
        el.insertBefore(svgEl, el.firstChild);
      }
    }
    /**
     * add or replace inline SVG to a HTMLElement for <span> / <div> tags
     *
     * @param svgEl SVGElement
     * @param el HTMLElement
     */
    addOrReplaceSVGElementToElement(svgEl, el) {
      // add or replace <svg> as child
      if (el.firstChild !== null) {
        el.firstChild.remove();
      }
      svgEl.classList.add('inlineicon');
      el.insertBefore(svgEl, el.firstChild);
    }
    getFileExtension(filename) {
      return filename.split('.').pop();
    }
    copyAttributes(source, destination) {
      const attributes = source.attributes;
      // A for-of loop does not work with NamedNodeMap because it has no iterator
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let index = 0; index < attributes.length; index++) {
        let attribute = attributes[index];
        if (attribute.name !== 'hisimage') {
          console.log('attribute: ', attribute.name, attribute.value);
          destination.setAttribute(attribute.name, attribute.value);
        }
      }
    }
    static {
      this.ɵfac = function HisImageDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisImageDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisImageDirective,
        selectors: [["", "hisImage", ""]],
        inputs: {
          title: "title",
          hisImage: "hisImage",
          forceIMG: "forceIMG"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisImageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * // HIS-PATCH #266927: Barrierefreiheit Fokus auf den Button, welcher den p-dialog öffnet, nach dem Schließen des Overlays
 * // HIS-Patch: #299831 Fokus auf Verschieben-Button in Tabellen und Treetable nah Klick
 */
let HisFocusableButtonDirective = /*#__PURE__*/(() => {
  class HisFocusableButtonDirective {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.visible = false;
      // Emitter is required because two way binding is used elsewhere
      this.visibleChange = new EventEmitter();
      this.isVisible = false;
      this.isClosed = false;
    }
    ngOnChanges(changes) {
      if (!changes.visible.currentValue && changes.visible.previousValue) {
        this.isVisible = true;
        setTimeout(this.onCloseOverlay, 25);
      }
    }
    onCloseOverlay() {
      if (document.getElementById('openingOverlayButton')) {
        document.getElementById('openingOverlayButton').focus();
        document.getElementById('openingOverlayButton').removeAttribute('id');
      }
    }
    clickEvent(event) {
      if (!this.isVisible && this.elementRef.nativeElement.name !== 'reorderTable' && this.elementRef.nativeElement.name !== 'dialogHeaderButton') {
        this.elementRef.nativeElement.setAttribute('id', 'openingOverlayButton');
      }
      if (this.elementRef.nativeElement.name === 'reorderTable') {
        setTimeout(() => {
          this.elementRef.nativeElement.focus();
        });
      }
    }
    onHideEvent(event) {
      /* eslint-disable max-len */
      if (this.elementRef.nativeElement.outerHTML.indexOf('p-overlaypanel') > -1 || this.elementRef.nativeElement.outerHTML.indexOf('p-confirmdialog') > -1) {
        setTimeout(this.onCloseOverlay, 25);
      }
    }
    static {
      this.ɵfac = function HisFocusableButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFocusableButtonDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisFocusableButtonDirective,
        selectors: [["p-dialog"], ["button"], ["p-overlayPanel"], ["p-confirmDialog"], ["button", 8, "reorder-icon"]],
        hostBindings: function HisFocusableButtonDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function HisFocusableButtonDirective_click_HostBindingHandler($event) {
              return ctx.clickEvent($event);
            })("onHide", function HisFocusableButtonDirective_onHide_HostBindingHandler($event) {
              return ctx.onHideEvent($event);
            });
          }
        },
        inputs: {
          visible: "visible"
        },
        outputs: {
          visibleChange: "visibleChange"
        },
        exportAs: ["p-dialog", "p-overlayPanel", "p-confirmDialog", "button.reorder-icon"],
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisFocusableButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$H = ["content"];
const _c1$d = [[["", "customPlamButtons", ""]], "*"];
const _c2$6 = ["[customPlamButtons]", "*"];
const _c3$4 = () => ({
  toolbar: false
});
const _c4$4 = a0 => ({
  "visibilityOnlyForScreenreader": a0
});
function HisPlamComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "common.error"), ": ", ctx_r0.getFirstErrorMessage(), "");
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "common.error"), ": ", ctx_r0.getFirstErrorMessage(), "");
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "common.error"), ": ", ctx_r0.getErrorMessageBeforeSave(), "");
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisPlamComponent_Conditional_0_Conditional_2_Conditional_1_Conditional_3_Template, 3, 4, "div", 6)(4, HisPlamComponent_Conditional_0_Conditional_2_Conditional_1_Conditional_4_Template, 3, 4, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("for", ctx_r0.contentId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r0.requiredIndicator, " ", ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(2, 5, ctx_r0.getLabeltext()), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.hasBackendErrors && !ctx_r0.isHidden() && ctx_r0.getFirstErrorMessage() !== null ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasErrorMessageBeforeSave() ? 4 : -1);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "common.error"), ": ", ctx_r0.getErrorMessageBeforeSave(), "");
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisPlamComponent_Conditional_0_Conditional_2_Conditional_2_Conditional_3_Template, 3, 4, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("for", ctx_r0.contentId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(2, 3, ctx_r0.getLabeltext()), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.hasErrorMessageBeforeSave() ? 3 : -1);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.contentRef.nativeElement.className);
    i0.ɵɵpropertyInterpolate("value", ctx_r0.contentRef.nativeElement.defaultLanguageValue);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "textarea", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.contentRef.nativeElement.className);
    i0.ɵɵpropertyInterpolate("rows", ctx_r0.contentRef.nativeElement.rows);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.contentRef.nativeElement.defaultLanguageValue);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-editor", 19);
    i0.ɵɵelement(1, "p-header");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.contentRef.nativeElement.className);
    i0.ɵɵproperty("readonly", true)("ngModel", ctx_r0.contentRef.nativeElement.defaultLanguageValue)("modules", i0.ɵɵpureFunction0(6, _c3$4));
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Conditional_0_Template, 1, 4, "input", 14)(1, HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Conditional_1_Template, 2, 5, "textarea", 15)(2, HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Conditional_2_Template, 2, 7, "p-editor", 16);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r0.contentRef.nativeElement.tagName === "INPUT" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.contentRef.nativeElement.tagName === "TEXTAREA" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.contentRef.nativeElement.tagName === "HIS-EDITOR" ? 2 : -1);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisPlamComponent_Conditional_0_Conditional_2_Conditional_5_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const contentTpl_r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", contentTpl_r2);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_6_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "label", 12);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵtemplate(6, HisPlamComponent_Conditional_0_Conditional_2_Conditional_6_ng_container_6_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const contentTpl_r2 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.showLabelTop ? "labelTopLayout" : " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r0.contentId);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("hisImage", "FLAG_", ctx_r0.translationLanguage.uniquename, "");
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(4, 8, ctx_r0.getTranslationLabel(ctx_r0.translationLanguage.uniquename), ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(3, 6, ctx_r0.getLabeltext())));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", contentTpl_r2);
  }
}
function HisPlamComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, HisPlamComponent_Conditional_0_Conditional_2_Conditional_1_Template, 5, 7, "label", 12)(2, HisPlamComponent_Conditional_0_Conditional_2_Conditional_2_Template, 4, 5, "label", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtemplate(4, HisPlamComponent_Conditional_0_Conditional_2_Conditional_4_Template, 3, 3)(5, HisPlamComponent_Conditional_0_Conditional_2_Conditional_5_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, HisPlamComponent_Conditional_0_Conditional_2_Conditional_6_Template, 7, 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.showLabelTop ? "labelTopLayout" : " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isRequired() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.isRequired() ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.isTranslatable() && ctx_r0.translationLanguage ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.isTranslatable() || !ctx_r0.translationLanguage ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isTranslatable() && ctx_r0.translationLanguage ? 6 : -1);
  }
}
function HisPlamComponent_Conditional_0_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisPlamComponent_Conditional_0_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function HisPlamComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, HisPlamComponent_Conditional_0_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementStart(2, "label", 12);
    i0.ɵɵtemplate(3, HisPlamComponent_Conditional_0_Conditional_3_Conditional_3_Template, 2, 0, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "div", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTpl_r2 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.showLabelTop ? "labelTopLayout" : " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", contentTpl_r2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r0.contentId);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isRequired() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(5, 5, ctx_r0.getLabeltext()), " ");
  }
}
function HisPlamComponent_Conditional_0_Conditional_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisPlamComponent_Conditional_0_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function HisPlamComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtemplate(2, HisPlamComponent_Conditional_0_Conditional_4_ng_container_2_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementStart(3, "label", 12);
    i0.ɵɵtemplate(4, HisPlamComponent_Conditional_0_Conditional_4_Conditional_4_Template, 2, 0, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const contentTpl_r2 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.showLabelTop ? "labelTopLayout" : " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", contentTpl_r2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r0.contentId);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isRequired() ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(6, 5, ctx_r0.getLabeltext()), " ");
  }
}
function HisPlamComponent_Conditional_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function HisPlamComponent_Conditional_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HisPlamComponent_Conditional_0_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggleShowDebug());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", "Debuginfos");
  }
}
function HisPlamComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function HisPlamComponent_Conditional_0_Conditional_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggleShowHelptext());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "common.components.info") + " " + (ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(2, 4, ctx_r0.getLabeltext())));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 6, "common.components.info") + " " + (ctx_r0.label ? ctx_r0.label : i0.ɵɵpipeBind1(4, 8, ctx_r0.getLabeltext())));
  }
}
function HisPlamComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, HisPlamComponent_Conditional_0_Conditional_1_Template, 3, 4, "div", 6)(2, HisPlamComponent_Conditional_0_Conditional_2_Template, 7, 6)(3, HisPlamComponent_Conditional_0_Conditional_3_Template, 7, 7)(4, HisPlamComponent_Conditional_0_Conditional_4_Template, 7, 7)(5, HisPlamComponent_Conditional_0_ng_template_5_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(7, "div", 7)(8, "div", 8);
    i0.ɵɵprojection(9);
    i0.ɵɵtemplate(10, HisPlamComponent_Conditional_0_Conditional_10_Template, 1, 1, "button", 9)(11, HisPlamComponent_Conditional_0_Conditional_11_Template, 5, 10, "button", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tabindex", ctx_r0.tabindex);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.tabindex === 0 && ctx_r0.hasBackendErrors && !ctx_r0.isHidden() && ctx_r0.getFirstErrorMessage() !== null ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.isCheckboxRadio ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isCheckboxRadioAfterLable && ctx_r0.isCheckboxRadio ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.isCheckboxRadioAfterLable && ctx_r0.isCheckboxRadio ? 4 : -1);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r0.debugAvailable ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.getHelptext() ? 11 : -1);
  }
}
function HisPlamComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.getFirstErrorMessage());
  }
}
function HisPlamComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 28);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.contentId, "_errortext");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 4, "common.error"), ": ", ctx_r0.getFirstErrorMessage(), "");
  }
}
function HisPlamComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "div", 29)(2, "div", 30);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 1, "common.error") + ": " + ctx_r0.getBackendError(), i0.ɵɵsanitizeHtml);
  }
}
function HisPlamComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 28);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.contentId, "_errormessage");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 4, "common.error"), ": ", ctx_r0.getErrorMessageBeforeSave(), "");
  }
}
function HisPlamComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div", 29)(2, "div", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4$4, !ctx_r0.displayHelptext || ctx_r0.isHidden()));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r0.contentId, "_helptext");
    i0.ɵɵproperty("innerHTML", ctx_r0.getHelptext(), i0.ɵɵsanitizeHtml);
  }
}
function HisPlamComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "pre");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "pre");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "pre");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Value: ", i0.ɵɵpipeBind1(3, 3, ctx_r0.getModelValue()), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Errors: ", i0.ɵɵpipeBind1(6, 5, ctx_r0.getErrors()), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("ValidationMessage: ", ctx_r0.getValidationMessage(), "");
  }
}
function HisPlamComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Data-Dictionary: ", i0.ɵɵpipeBind1(2, 1, ctx_r0.getDdEntry()), "");
  }
}
function HisPlamComponent_Conditional_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Contexts: ", i0.ɵɵpipeBind1(2, 1, ctx_r0.getDdContexts()), "");
  }
}
function HisPlamComponent_Conditional_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Data-Source: ", ctx_r0.getDataSource(), "");
  }
}
function HisPlamComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HisPlamComponent_Conditional_7_Conditional_1_Template, 3, 3, "pre")(2, HisPlamComponent_Conditional_7_Conditional_2_Template, 3, 3, "pre")(3, HisPlamComponent_Conditional_7_Conditional_3_Template, 2, 1, "pre");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.getDdIdentifier() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.getDdContexts() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.getDataSource() ? 3 : -1);
  }
}
/**
 * Panel, Label and message component for input elements.
 */
let HisPlamComponent = /*#__PURE__*/(() => {
  class HisPlamComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisDdService = inject(HisDdService);
      this.validatorFactory = inject(HisDdValidatorFactory);
      this.hisTranslationService = inject(HisTranslationService);
      this.zone = inject(NgZone);
      this.uiService = inject(HisUiService);
      this.displayHelptext = false;
      this.showDebug = false;
      this.debugAvailable = false;
      this.showLabelTop = false;
      this.tabindex = -1;
      this.noPlamStyle = false;
      /**
       * iff <pre>false</pre>, no helptext will ever be shown for this plam
       */
      this.showHelptext = true;
      this.errorMessageBeforeSave = '';
    }
    static {
      this.REQUIRED_INDICATOR = '*';
    }
    get requiredIndicator() {
      return HisPlamComponent.REQUIRED_INDICATOR;
    }
    ngAfterContentInit() {
      this.formControl = !!this.ctrlRef ? this.ctrlRef.form : undefined;
      if (!this.formControl) {
        this.formControl = !!this.ctrlNameRef ? this.ctrlNameRef.control : undefined;
      }
      // if translatable subscribe to changes on translationLanguage
      if (this.isTranslatable()) {
        this.initializeTranslatable();
      }
      // if Input is checkbox
      if (this.contentRef.nativeElement) {
        if (this.contentRef.nativeElement.type === 'checkbox' || this.contentRef.nativeElement.type === 'radio') {
          this.isCheckboxRadio = true;
          this.isCheckboxRadioAfterLable = this.contentRef.nativeElement.classList.contains('checkboxAfterLabel');
        }
      }
      // console.log( 'contentRef =', this.contentRef );
      if (this.contentRef.widget) {
        // The component is used within a generic search page -> extract attributes from the search config file.
        this.helptext = this.contentRef.widget.helptext;
        this.required = this.contentRef.widget.required;
      }
      // Get the id to be used by the plam label 'for' attribute from the content element if provided.
      if (this.contentRef.getHtmlFocusElementId) {
        this.contentId = this.contentRef.getHtmlFocusElementId();
        // console.log( 'PLAM obtained content id', this.contentId );
        return;
      }
      // No id provided by the content -> generate one and put it into the content element.
      this.contentId = HisUidService.get('plam.');
      if (this.contentRef.nativeElement) {
        // Text input fields have the 'id' attribute.
        this.contentRef.nativeElement.id = this.contentId;
        return;
      }
      // p-dropdown, p-autocomplete etc. expect the id in the 'inputId' attribute.
      this.contentRef.inputId = this.contentId;
    }
    toggleShowHelptext() {
      this.displayHelptext = !this.displayHelptext;
      this.zone.runOutsideAngular(() => {
        setTimeout(() => this.focus(), 5);
      });
    }
    focus() {
      if (this.contentRef.nativeElement) {
        if (this.contentRef.nativeElement.parentNode.parentNode) {
          if (this.contentRef.nativeElement.parentNode.parentNode.nextElementSibling) {
            if (this.contentRef.nativeElement.parentNode.parentNode.nextElementSibling.innerHTML.indexOf('plamHelptext') > -1) {
              this.contentRef.nativeElement.parentNode.parentNode.nextElementSibling.children[1].focus();
            }
          }
        }
      } else if (this.contentRef.el.nativeElement) {
        if (this.contentRef.el.nativeElement.parentElement.parentNode) {
          if (this.contentRef.el.nativeElement.parentElement.parentNode.nextElementSibling) {
            // eslint-disable-next-line max-len
            if (this.contentRef.el.nativeElement.parentElement.parentNode.nextElementSibling.innerHTML.indexOf('plamHelptext') > -1) {
              this.contentRef.el.nativeElement.parentElement.parentNode.nextElementSibling.children[1].focus();
            }
          }
        }
      }
    }
    toggleShowDebug() {
      this.showDebug = !this.showDebug;
    }
    isRequired() {
      try {
        /*
        * This seems to only be true when required Validator is present.
        * Keep an eye on it, though.
        */
        return !!this.formControl.validator(new UntypedFormControl());
      } catch (e) {
        //
      }
      return this.required || this.getContentElement().required;
    }
    getHelptext() {
      if (!this.showHelptext) {
        return '';
      }
      if (this.contentRef.widget && this.contentRef.widget.multiSearchCriterion && this.contentRef.widget.multiSearchCriterionLabels) {
        return this.getHelptextForMultiSearchCriterion(this.contentRef.widget.multiSearchCriterionLabels);
      }
      if (this.helptext || this.getContentElement().ddHelptext) {
        return this.uiService.translate(this.helptext) || this.uiService.translate(this.getContentElement().ddHelptext);
      }
      const labelKey = this.contentRef.widget?.label || this.getLabeltext();
      if (labelKey) {
        const helptextKey = `${labelKey}:helptext`;
        //XXX use elvis here to not break tests which use mocks for HisUiService (https://hiszilla.his.de/hiszilla/show_bug.cgi?id=312525#c9)
        return this.uiService.translateOrEmpty?.(helptextKey);
      }
      return '';
    }
    getHelptextForMultiSearchCriterion(multiSearchCriterionLabels) {
      const labelsAsI18n = multiSearchCriterionLabels.split('|');
      let texts = [];
      for (let labelAsI18n of labelsAsI18n) {
        texts.push(this.uiService.translate(labelAsI18n));
      }
      const params = texts.join(', ');
      let helptext = this.uiService.translate('genericSearch.fieldIsMultiSearchCriterion', params);
      return helptext;
    }
    getLabeltext() {
      if (!this.noPlamStyle) {
        return this.key || this.getContentElement().ddLabeltext;
      }
      return '';
    }
    getBackendError() {
      return this.backendError || this.getContentElement().ddBackendError;
    }
    isHidden() {
      return this.ddHidden || this.getContentElement().ddHidden;
    }
    getContentElement() {
      if (this.contentRef instanceof ElementRef) {
        return this.contentRef.nativeElement;
      }
      return this.contentRef;
    }
    getErrors() {
      if (this.ngModelRef) {
        return this.ngModelRef.control.errors;
      } else if (this.isReactiveForm()) {
        if (this.ddValidator) {
          return this.ddValidator.validate(this.formControl) || this.formControl.errors;
        }
        return this.formControl.errors;
      }
      return null;
    }
    // deprecated
    // ValidationMessages wollen wir nicht verwenden
    getValidationMessage() {
      if (this.getContentElement()) {
        let msg = this.getContentElement().validationMessage;
        if (msg != null && msg.length > 0) {
          return msg;
        }
      }
      return null;
    }
    hasErrors() {
      return this.getErrors() != null;
      // return this.getValidationMessage() != null || this.getErrors() != null;
    }
    shouldDisplayErrors() {
      return this.isControlDirty();
    }
    isControlDirty() {
      if (this.ngModelRef && !this.ngModelRef.control.errors?.backendError) {
        this.hasBackendErrors = false;
        this.tabindex = -1;
        return this.ngModelRef.control.dirty;
      } else if (this.ngModelRef && this.ngModelRef.control.errors?.backendError) {
        this.hasBackendErrors = true;
        if (this.noPlamStyle) {
          this.tabindex = 0;
        }
      } else if (this.isReactiveForm()) {
        return this.formControl.dirty;
      }
      return false;
    }
    /**
     * Sucht die erste Validierungs- bzw. Fehlermeldung für das Inputfield heraus
     * Achtung: Neuerdings wollen wir ValidationMessages nicht verwenden!
     */
    getFirstErrorMessage() {
      let msg = null; // this.getValidationMessage();
      if (!msg) {
        let errors = this.getErrors();
        if (errors && Object.keys(errors).length > 0) {
          let errorType = Object.keys(errors)[0]; // standardmäßig ersten Fehler anzeigen
          if (errors.backendError) {
            errorType = 'backendError'; // ... aber Backend-Fehler bevorzugen, falls vorhanden
            this.hasBackendErrors = true;
            if (this.noPlamStyle) {
              this.tabindex = 0;
            }
          }
          // Message ermitteln
          let state = errors[errorType];
          if (state.message) {
            msg = state.message;
          } else {
            msg = this.validatorFactory.getMessageForError(errorType, state);
          }
        }
      }
      return msg;
    }
    getModelValue() {
      if (this.ngModelRef) {
        return this.ngModelRef.value;
      } else if (this.isReactiveForm()) {
        return this.formControl.value;
      }
      return null;
    }
    // wird nur zum Debuggen aufgerufen...
    getDdEntry() {
      let ddKey = this.getDdIdentifier();
      if (ddKey) {
        return this.hisDdService.getMergedEntry(ddKey, this.getDdContexts());
      }
      return null;
    }
    getDdIdentifier() {
      return this.ddIdentifier || this.getContentElement().ddIdentifier;
    }
    getDdContexts() {
      return this.hisDdContexts || this.getContentElement().hisDdContexts;
    }
    getDataSource() {
      let contentElement = this.getContentElement();
      if (contentElement) {
        let key = 'hisDataSource';
        return contentElement[key];
      }
      return null;
    }
    isTranslatable() {
      return this.contentRef && this.contentRef.nativeElement && this.contentRef.nativeElement.isTranslatable;
    }
    initializeTranslatable() {
      this.hisTranslationService.translationLanguage$.subscribe(translationLanguage => {
        this.translationLanguage = translationLanguage;
      });
    }
    getTranslationLabel(translationLanguage) {
      let labelKey = 'cs.sys.hisng.translationLabel_' + translationLanguage;
      return labelKey;
    }
    isReactiveForm() {
      return !!this.formControl;
    }
    hasErrorMessageBeforeSave() {
      return this.errorMessageBeforeSave?.length > 0 || false;
    }
    getErrorMessageBeforeSave() {
      return this.errorMessageBeforeSave;
    }
    setErrorMessageBeforeSave(msgs) {
      this.errorMessageBeforeSave = msgs;
    }
    static {
      this.ɵfac = function HisPlamComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPlamComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisPlamComponent,
        selectors: [["his-plam"]],
        contentQueries: function HisPlamComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c0$H, 5);
            i0.ɵɵcontentQuery(dirIndex, NgModel, 5);
            i0.ɵɵcontentQuery(dirIndex, HisDdValidator, 5);
            i0.ɵɵcontentQuery(dirIndex, FormControlDirective, 5);
            i0.ɵɵcontentQuery(dirIndex, FormControlName, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngModelRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ddValidator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ctrlRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ctrlNameRef = _t.first);
          }
        },
        inputs: {
          key: "key",
          label: "label",
          required: "required",
          helptext: "helptext",
          displayHelptext: "displayHelptext",
          showDebug: "showDebug",
          debugAvailable: "debugAvailable",
          showLabelTop: "showLabelTop",
          backendError: "backendError",
          tabindex: "tabindex",
          noPlamStyle: "noPlamStyle",
          showHelptext: "showHelptext",
          isCheckboxRadio: "isCheckboxRadio"
        },
        standalone: false,
        ngContentSelectors: _c2$6,
        decls: 8,
        vars: 8,
        consts: [["contentTpl", ""], [1, "plamRow", "layoutBlock", 3, "tabindex"], [1, "plamRow", "plamWarningtextContainer", "ui-g"], [1, "plamRow", "ui-g"], [1, "plamRow", "plamHelptextContainer", "ui-g", 3, "ngClass"], [1, "plamRow"], [1, "unsichtbar"], [1, "plamButtonContainer"], [2, "white-space", "nowrap"], ["hisImage", "debug", "type", "button", 1, "plamButton", "icon", 3, "title"], ["hisImage", "information", "type", "button", 1, "plamButton", "icon", 3, "title"], [1, "plamLabelContainer", 3, "ngClass"], [1, "plamLabel", "formLabel", 3, "for"], [1, "plamContent"], ["readonly", "", 3, "class", "value"], ["disabled", "", 3, "class", "rows"], [3, "readonly", "class", "ngModel", "modules"], ["readonly", "", 3, "value"], ["disabled", "", 3, "rows"], [3, "readonly", "ngModel", "modules"], [4, "ngTemplateOutlet"], [3, "hisImage", "title"], [1, "plamLabelContainer", "plamLabelCheckboxBefore", 3, "ngClass"], [1, "plamContent", "plamContent-checkboxBefore"], ["hisImage", "debug", "type", "button", 1, "plamButton", "icon", 3, "click", "title"], ["hisImage", "information", "type", "button", 1, "plamButton", "icon", 3, "click", "title"], [1, "plamWarningtextSpacer", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-4"], ["role", "alert", 1, "plamWarningtext", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-7"], [1, "errortext", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-7", 3, "id"], [1, "plamHelptextSpacer", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-4"], [1, "errortext", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-7", 3, "innerHTML"], [1, "plamHelptext", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-7", 3, "id", "innerHTML"]],
        template: function HisPlamComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$d);
            i0.ɵɵtemplate(0, HisPlamComponent_Conditional_0_Template, 12, 7, "div", 1)(1, HisPlamComponent_Conditional_1_Template, 4, 1, "div", 2)(2, HisPlamComponent_Conditional_2_Template, 5, 6, "div", 3)(3, HisPlamComponent_Conditional_3_Template, 4, 3, "div", 3)(4, HisPlamComponent_Conditional_4_Template, 5, 6, "div", 3)(5, HisPlamComponent_Conditional_5_Template, 3, 6, "div", 4)(6, HisPlamComponent_Conditional_6_Template, 9, 7, "div", 5)(7, HisPlamComponent_Conditional_7_Template, 4, 3, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isHidden() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.shouldDisplayErrors() && ctx.hasErrors() && !ctx.isHidden() && !ctx.hasErrorMessageBeforeSave() && !ctx.getBackendError() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasBackendErrors && !ctx.isHidden() && ctx.getFirstErrorMessage() !== null ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.getBackendError() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasErrorMessageBeforeSave() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isHidden() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDebug && !ctx.isHidden() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDebug && !ctx.isHidden() || ctx.hisBaseGlobalsService.dataDictionaryEditMode ? 7 : -1);
          }
        },
        dependencies: [i1$2.NgClass, i1$2.NgTemplateOutlet, i1$1.NgControlStatus, i1$1.NgModel, i2.Header, i4.Editor, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, i1$2.JsonPipe, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisPlamComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisArrayUtils {
  /**
   * Checks if value is instance of Array && value.length === 0
   *
   * @param value the array to check
   */
  static isEmptyArray(value) {
    return value instanceof Array && value.length === 0;
  }
  /**
   * Checks if every element in array1 is also contained in array2
   *
   * @return true, if every element in array1 is also contained in array2, false otherwise
   */
  static containsAll(array1, array2) {
    if (array1 === null || array1 === undefined) {
      throw new Error('array1 must not be null or undefined');
    }
    if (array2 === null || array2 === undefined) {
      throw new Error('array2 must not be null or undefined');
    }
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    function containsAll(arr1, arr2) {
      return arr1.every(i => arr2.includes(i));
    }
    return containsAll(array1, array2);
  }
  /**
   * Compares two arrays to get all not contained element in array2
   *
   * @return all elements that doesn't exist in array2
   */
  static getNotContainedElements(array1, array2) {
    if (array1 === null || array1 === undefined) {
      throw new Error('array1 must not be null or undefined');
    }
    if (array2 === null || array2 === undefined) {
      throw new Error('array2 must not be null or undefined');
    }
    let notContainedElements = [];
    for (let element1 of array1) {
      if (!array2.includes(element1)) {
        notContainedElements.push(element1);
      }
    }
    return notContainedElements;
  }
  /**
   * sets all elements of a string array to lower case
   *
   * @return an array of string with all elemnts set to lower case
   */
  static toLowerCase(stringArray) {
    return stringArray.map(str => str.toLowerCase());
  }
}
class HisSearchCriteriagroup {
  constructor() {
    this.notInCriteriaGroup = false;
    this.widgets = [];
  }
  equals(other) {
    if (other === this) {
      return true;
    }
    if (other && other.constructor === this.constructor && other.notInCriteriaGroup === this.notInCriteriaGroup && this.areArraysEqual(other.widgets, this.widgets)) {
      return true;
    }
    return false;
  }
  areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }
}
let HisBrowserDetectionService = /*#__PURE__*/(() => {
  class HisBrowserDetectionService {
    constructor() {
      this.browserName = undefined;
      this.browserVersion = undefined;
    }
    detectBrowser() {
      let ua = window.navigator.userAgent;
      console.log('HisBrowserDetectionService.detectBrowser(): userAgent =', ua);
      this.detectNameAndVersion(ua);
      if (this.browserName && this.browserVersion) {
        // detection was successful
        this.deriveMajorAndminorVersion();
        console.log('HisBrowserDetectionService.detectBrowser(): Detected ' + this.browserName + ' ' + this.browserVersion + ' (majorVersion = ' + this.majorVersion + ', minorVersion = ' + this.minorVersion + ')');
      } else {
        console.warn('HisBrowserDetectionService.detectBrowser(): Browser detection failed');
      }
    }
    detectNameAndVersion(ua) {
      // detect browser name and version
      // Microsoft browsers following https://codepen.io/gapcode/pen/vEJNZN
      let msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older: ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        this.browserName = 'IE';
        this.browserVersion = ua.substring(msie + 5, ua.indexOf(';', msie));
        return;
      }
      let trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11: ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        this.browserName = 'IE';
        let rv = ua.indexOf('rv:');
        this.browserVersion = ua.substring(rv + 3, ua.indexOf(')', rv));
        return;
      }
      // Edge must be checked before Chrome and Safari because its userAgent string contains both of them.
      // Old Edge:
      let edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+)
        // Edge 12: ua = 'Mozilla/5.0
        //   (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // Edge 13: ua = 'Mozilla/5.0
        //   (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
        this.browserName = 'Edge';
        this.browserVersion = ua.substring(edge + 5);
        return;
      }
      // Edge-Chromium
      let edgeChromium = ua.indexOf('Edg/');
      if (edgeChromium > 0) {
        // Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko)
        // Chrome/83.0.4103.116 Safari/537.36 Edg/83.0.478.58
        this.browserName = 'Edge-Chromium';
        this.browserVersion = ua.substring(edgeChromium + 4);
        return;
      }
      let ff = ua.indexOf('Firefox/');
      if (ff > 0) {
        // Firefox: ua = Mozilla/5.0 (Windows NT 6.3; WOW64; rv:59.0) Gecko/20100101 Firefox/59.0
        this.browserName = 'Firefox';
        this.browserVersion = ua.substring(ff + 8);
        return;
      }
      // Chrome must be checked before Safari ?
      let chrome = ua.indexOf('Chrome/');
      if (chrome > 0) {
        // Chrome: Mozilla/5.0 (Windows NT 6.3; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.181 Safari/537.36
        this.browserName = 'Chrome';
        this.browserVersion = ua.substring(chrome + 7, ua.indexOf(' ', chrome));
        return;
      }
      // TODO: Test Safari
    }
    deriveMajorAndminorVersion() {
      // console.log( 'browserVersion =', this.browserVersion );
      let dotIndex = this.browserVersion.indexOf('.');
      this.majorVersion = parseInt(this.browserVersion.substring(0, dotIndex), 10);
      this.minorVersion = this.browserVersion.substring(dotIndex + 1);
    }
    static {
      this.ɵfac = function HisBrowserDetectionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisBrowserDetectionService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisBrowserDetectionService,
        factory: HisBrowserDetectionService.ɵfac
      });
    }
  }
  return HisBrowserDetectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * caches REST service invocations.
 */
let HisCacheService = /*#__PURE__*/(() => {
  class HisCacheService {
    // Server-side cache keys, matching their counterparts in class AngularCacheController.
    static {
      this.UITEXTS_SERVER_VERSION_KEY = 'version:api/v1/cs/sys/uitexts';
    }
    constructor() {
      this.hisBackendService = inject(HisBackendService);
      this.browserDetectionService = inject(HisBrowserDetectionService);
      // "In memory" cache
      this.inMemoryCache = new Map();
      this.useIndexedDB = this.canUseIndexedDB();
      if (this.useIndexedDB) {
        this.db = new AngularIndexedDB('cache', 5);
        this.dbOpenPromise = this.db.openDatabase(5, evt => {
          console.log('HisCacheService: create cache');
          evt.currentTarget.result.createObjectStore('cache', {});
        });
      }
    }
    /**
     * Can we use the indexedDB to cache uitexts ?
     * There is an issue with MS IE and Edge: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14372843/
     */
    canUseIndexedDB() {
      this.browserDetectionService.detectBrowser();
      let browserName = this.browserDetectionService.browserName;
      if (browserName === 'Edge') {
        return false;
      }
      if (browserName === 'IE') {
        let majorVersion = this.browserDetectionService.majorVersion;
        if (majorVersion <= 9) {
          // IE 8, 9 have no indexedDB support at all
          return false;
        }
        let minorVersion = this.browserDetectionService.minorVersion;
        if (majorVersion === 11 && minorVersion >= '15.') {
          // TODO wouldn't work for minor versions like "100.xxx"
          return false;
        }
      }
      // TODO further refinement by major/minor version when more data gets known
      // all other browsers should support it
      return true;
    }
    setServerVersions(serverVersions) {
      this.serverVersions = serverVersions;
    }
    /**
     * Retrieves data from the server or the cache, deriving the versionKey from the url parameter.
     *
     * @param url the URL of the REST service to call
     */
    getDataCachedByIndexedDB(url) {
      return this.getDataCachedByIndexedDB2(url, 'version:' + url, 'version:' + url);
    }
    /**
     * Retrieves data from the server or the cache, using an explicit versionKey.
     *
     * @param url the URL of the REST service to call
     * @param versionKey a special version key
     */
    getDataCachedByIndexedDB2(url, clientVersionKey, serverVersionKey) {
      console.log('his-cache-service#getDataCachedByIndexedDB2() #serverVersionKey', serverVersionKey);
      let uitextServerVersion = this.serverVersions[serverVersionKey];
      console.log('his-cache-service#getDataCachedByIndexedDB2() #uitextServerVersion', uitextServerVersion);
      // When indexedDB is ready, read the url from the database
      // If there is no appropriate object, ask the server and store it
      let subject = new BehaviorSubject({});
      if (this.useIndexedDB) {
        this.dbOpenPromise.then(() => {
          this.db.getByKey('cache', clientVersionKey).then(uitextClientVersion => {
            console.log('his-cache-service#getDataCachedByIndexedDB2() #uitextClientVersion', uitextClientVersion);
            console.log('his-cache-service#getDataCachedByIndexedDB2() #uitextServerVersion', uitextServerVersion);
            if (!uitextClientVersion || !uitextServerVersion || uitextClientVersion !== uitextServerVersion) {
              // cache is empty or outdated
              console.log('his-cache-service#getDataCachedByIndexedDB2() #updateIndexedDb_1 for url', url);
              console.log('his-cache-service#getDataCachedByIndexedDB2() #updateIndexedDb_1 clientVersionKey', clientVersionKey);
              console.log('his-cache-service#getDataCachedByIndexedDB2() #updateIndexedDb_1 uitextServerVersion', uitextServerVersion);
              console.log('his-cache-service#getDataCachedByIndexedDB2() #updateIndexedDb_1 subject', subject);
              this.updateIndexedDb(url, clientVersionKey, uitextServerVersion, subject);
            } else {
              let cacheEntry = this.db.getByKey('cache', url);
              cacheEntry.then(object => {
                if (object) {
                  console.log('his-cache-service#getDataCachedByIndexedDB2() #return cached object for', url);
                  console.log('his-cache-service#getDataCachedByIndexedDB2() #returned object', object);
                  subject.next(object);
                } else {
                  console.log('his-cache-service#getDataCachedByIndexedDB2() #updateIndexedDb_2');
                  this.updateIndexedDb(url, clientVersionKey, uitextServerVersion, subject);
                }
              });
            }
          });
        }, error => {
          console.error('Failed to initialize indexeddb cache: ', error);
          this.hisBackendService.getData(url).subscribe(object => {
            if (Object.keys(object).length !== 0) {
              console.log('Cache error, return backendService object for', url);
              subject.next(object);
            }
          });
        });
      } else {
        // IndexedDB is not working, always get texts from backend
        console.warn('IndexedDB is not properly supported by the browser; uitexts are read from the backend always...');
        this.hisBackendService.getData(url).subscribe(object => {
          if (Object.keys(object).length !== 0) {
            console.log('Cache error, return backendService object for', url);
            subject.next(object);
          }
        });
      }
      return subject;
    }
    updateIndexedDb(url, versionKey, uitextServerVersion, subject) {
      this.hisBackendService.getData(url).subscribe(object => {
        if (object && Object.keys(object).length !== 0) {
          this.db.update('cache', object, url);
          this.db.update('cache', uitextServerVersion, versionKey);
          console.log('Update indexedDB with backendService object for url', url);
          subject.next(object);
        }
      });
    }
    /**
     * Retrieves data from the server or in-memory cache.
     *
     * @param url the URL of the REST service to call
     */
    getDataCachedInMemory(url) {
      // console.log( self.inMemoryCache.size, 'inMemoryCache =', self.inMemoryCache );
      let observable = this.inMemoryCache.get(url);
      // console.log( 'observable=', observable );
      if (observable) {
        console.log('Retrieved data for', url, 'from in-memory cache.');
        return observable;
      }
      console.log('Load data for', url, 'from backend!');
      let subject = new BehaviorSubject(null);
      this.inMemoryCache.set(url, subject);
      this.hisBackendService.getData(url).subscribe(data => {
        if (data) {
          console.log('Finished loading data for', url, 'from backend.');
          subject.next(data);
          if (isDevMode()) {
            console.log(JSON.stringify(data, null, 2));
          }
        }
      });
      return subject;
    }
    static {
      this.ɵfac = function HisCacheService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCacheService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisCacheService,
        factory: HisCacheService.ɵfac
      });
    }
  }
  return HisCacheService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The result of a search operation as delivered by the server.
 */
class RestSearchResult {}
class HisSearchResultRow {
  constructor(values, metadata) {
    this.values = values;
    this.metadata = metadata;
  }
  /**
   * Get the index of the column with the given id.
   *
   * @param columnId the column id
   * @return the index of the column with the gi
   */
  getIndex(columnId) {
    for (let i = 0; i < this.metadata.length; i++) {
      if (this.metadata[i].id === columnId) {
        return i;
      }
    }
    // Use the following line only for debugging. In general, we don't want an error message because columns may be added lazely.
    // console.error( 'could not find row id \'' + id + '\' in the current search metadata', this.metadata );
    return null;
  }
  /**
   * Get the value of this row at the given column index.
   *
   * @param columnIndex the column index
   * @result the value at the given column index
   */
  getAt(columnIndex) {
    return this.values[columnIndex];
  }
  /**
   * Get the value of this row's column with the given columnId.
   *
   * @param columnId the column id
   * @return the value of the column, or null if the columnId is not known.
   */
  get(columnId) {
    let columnIndex = this.getIndex(columnId);
    return columnIndex !== null ? this.values[columnIndex] : null;
  }
  /**
   * Set the value of the column with id 'columnId' to 'value'.
   *
   * @param columnId the column id
   * @param value the new value to set
   */
  set(columnId, value, theSortPath, theLabel, theDataType, theFormat, theFilterPath) {
    let columnIndex = this.getIndex(columnId);
    if (columnIndex !== null) {
      this.values[columnIndex] = value;
    } else {
      // new column!
      this.metadata.push({
        id: columnId,
        label: theLabel,
        dataType: theDataType,
        format: theFormat,
        width: null,
        visible: true,
        sortPath: theSortPath,
        filterPath: theFilterPath
      });
      this.values.push(value);
    }
  }
  /**
   * Find the column id containing the given substring.
   *
   * @param substr the string to search for
   * @return the id containing 'substr'
   */
  findIdByContent(substr) {
    let foundId = null;
    this.metadata.forEach(rowMetadata => {
      if (rowMetadata.id.includes(substr)) {
        foundId = rowMetadata.id;
      }
    });
    return foundId;
  }
  toFlatSearchResultRow(theId, theLabel) {
    let flatRow = {
      id: theId,
      label: theLabel
    };
    let i = 0;
    for (let columnMeta of this.metadata) {
      let value = this.values[i];
      if (value) {
        flatRow[columnMeta.id] = value;
      } // else we dont need to set it, requesting a non-existing attribute will give undefined, too
      i++;
    }
    return flatRow;
  }
}
/**
 * The result of a search operation.
 */
class HisSearchResult {
  constructor(from) {
    // console.error( "creating from ", from );
    this.name = from.name;
    if (from.cacheVersion) {
      this.cacheVersion = from.cacheVersion;
    }
    this.columns = from.columns;
    this.data = from.data.map(row => new HisSearchResultRow(row, from.columns));
    this.offset = from.offset;
    this.limit = from.limit;
    this.maxResultRows = from.maxResultRows;
    this.totalCount = from.totalCount;
  }
}
let HisSearchSelectfromService = /*#__PURE__*/(() => {
  class HisSearchSelectfromService {
    constructor() {
      this.cache = new Map();
    }
    // TODO Since addEntry() is never used, there is no write access to the cache...
    addEntry(k, v, opts) {
      let versioned = {
        vkey: {
          version: v,
          key: k
        },
        options: opts
      };
      this.cache.set(k, versioned);
    }
    getKnownSelectfromLists(keys) {
      let m = new Map();
      for (let k of keys) {
        let o = this.cache.get(k);
        if (!o) {
          // insert dummy options with version "-1" for each key that is requested but not registered in the cache
          o = {
            vkey: {
              key: k,
              version: -1
            },
            options: null
          };
        }
        m.set(k, o);
      }
      return of(m);
    }
    static {
      this.ɵfac = function HisSearchSelectfromService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchSelectfromService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSearchSelectfromService,
        factory: HisSearchSelectfromService.ɵfac
      });
    }
  }
  return HisSearchSelectfromService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FilteredOptionsRequest {
  constructor(configFile, whereValue, limit) {
    this.configFile = configFile;
    this.whereValue = whereValue;
    this.limit = limit;
  }
}
class FilteredSelectOptionsRequest {
  constructor(configFile, selectFrom, optionFilter, limit) {
    this.configFile = configFile;
    this.selectFrom = selectFrom;
    this.optionFilter = optionFilter;
    this.limit = limit;
  }
}
class LoadOptionsByIdsRequest {
  constructor(configFile, optionByIdRequests) {
    this.configFile = configFile;
    this.optionByIdRequests = optionByIdRequests;
  }
}
let HisSearchService = /*#__PURE__*/(() => {
  class HisSearchService {
    constructor() {
      this.hisBackendService = inject(HisBackendService);
      this.hisCacheService = inject(HisCacheService);
      this.hisSearchSelectfromService = inject(HisSearchSelectfromService);
      this.resetInputs = new BehaviorSubject(undefined);
      this.selectOperator = new BehaviorSubject(undefined);
    }
    /**
     * Retrieves a search configuration from in-memory cache or loads it from the backend.
     * The cache is very useful in case that we have many sub-searches on a page,
     * like the author sub-searches in "edit publication".
     *
     * @param configFile name of the search configuration file
     * @return Observable<HisSearchConfiguration>
     */
    loadSearchConfiguration(configFile) {
      return this.hisCacheService.getDataCachedInMemory('api/v1/cs/sys/genericSearch/loadSearchConfig?configFile=' + configFile);
    }
    /**
     * loads dropdown-list content for a specific search configuration from the backend
     *
     * @param searchConfig HisSearchConfiguration
     * @return map of selectFrom identifiers to Observables
     */
    // TODO we only need the config file name, not the complete search configuration
    loadDataForSearchForm(searchConfig, requiredKeys) {
      // let x = null;console.log( 'this is an error', x[7] );
      let result = new Map();
      for (let key of requiredKeys) {
        let observable = new BehaviorSubject([]);
        result.set(key, observable);
      }
      console.log('loadDataForSearchForm searchConfig', searchConfig);
      console.log('loadDataForSearchForm requiredKeys', requiredKeys);
      if (searchConfig.configFile === 'customOptions.xml') {
        return result;
      }
      let cachedSelectsObservable = this.hisSearchSelectfromService.getKnownSelectfromLists(requiredKeys);
      cachedSelectsObservable.subscribe(cachedSelects => {
        let versionedKeys = [];
        cachedSelects.forEach((value, key) => {
          versionedKeys.push(value.vkey);
        });
        let request = {
          configFile: searchConfig.configFile,
          requestedKeys: versionedKeys
        };
        let serverResponse = this.hisBackendService.postData('api/v1/cs/sys/genericSearch/loadSearchFormData', request);
        serverResponse.subscribe(optionsList => {
          for (let options of optionsList) {
            let observer = result.get(options.vkey.key);
            let cachedOptions = cachedSelects.get(options.vkey.key);
            if (options.options) {
              // send options from server to view
              observer.next(options.options);
            } else {
              observer.next(cachedOptions.options);
            }
            let nOptions = options.options.length;
            let nOptionsNil = 0;
            for (let i = 0; i < nOptions; i++) {
              let option = options.options[i];
              if (option && (!option.id || option.id === 'NULL')) {
                nOptionsNil++;
              }
            }
            console.log('Data for options \'' + options.vkey.key + '\' loaded [' + nOptions + ' option(s), ' + nOptionsNil + ' nil option(s)].');
          }
        });
      });
      return result;
    }
    /**
     * Loads filtered options for autocomplete fields. Constraints apply so far hardcoded on the
     * defaulttext column of the given search entity.
     *
     * Caching makes little sense here because there are too many possibilities for the where part.
     *
     * @param configFile searchConfiguration file
     * @param searchEntity the entity from which to select the data
     * @param whereValue: constraint on the whereColumn of that entity
     * @param limit maximum number of select options to load
     * @return Observable<HisOption[]>
     */
    loadFilteredOptions(configFile, whereValue, limit) {
      let request = new FilteredOptionsRequest(configFile, whereValue, limit);
      console.log('HisSearchService.loadFilteredOptions(): request =', request);
      return this.hisBackendService.postData('api/v1/cs/sys/genericSearch/loadFilteredOptions', request);
    }
    /**
     * Loads filtered options for autocomplete fields with selectFrom-methods.
     *
     * Caching makes little sense here because there are too many possibilities for the where part.
     *
     * @param configFile searchConfiguration file
     * @param selectFrom the selectFrom method
     * @param optionFilter: filter on the received options
     * @param limit maximum number of select options to load
     * @return Observable<HisOption[]>
     */
    loadFilteredSelectOptions(configFile, selectFrom, optionFilter, limit) {
      let request = new FilteredSelectOptionsRequest(configFile, selectFrom, optionFilter, limit);
      console.log('HisSearchService.loadFilteredOptionsBySelect(): request =', request);
      return this.hisBackendService.postData('api/v1/cs/sys/genericSearch/loadFilteredOptionsBySelect', request);
    }
    /**
     * Lets the backend validate the inputs of the search form.
     *
     * @param search search constraints
     * @return resultCode as Observable:
     * 0: empty search result
     * 1: non-empty search result, grouping failed
     * 2: non-empty search result, grouping worked
     */
    validateInputs(search) {
      console.log('Validating search form inputs', search, ' for \'' + search.configFile + '\'...');
      if (!search.configFile) {
        throw new Error('No search configuration file defined.');
      }
      let sortCriteria = [];
      let request = {
        search,
        offset: 0,
        limit: -1,
        sortCriteria
      };
      return this.hisBackendService.postData('api/v1/cs/sys/genericSearch/validateInputs', request);
    }
    /**
     * Loads a search result from the backend.
     *
     * @param search search constraints
     * @param offset the first result row to load
     * @param limit the maximum number of result rows to load
     */
    loadSearchResult(search, offset = 0, limit = 10, sortCriteria) {
      console.log('Loading search results with constraints:', search);
      if (!search) {
        throw new Error('Search must not be null or undefined');
      }
      if (!search.configFile) {
        throw new Error('No search configuration file defined.');
      }
      if (!sortCriteria) {
        sortCriteria = [];
      }
      console.log('his-search.servie#loadSearchResult() #sortCriterion', sortCriteria);
      let request = {
        search,
        offset,
        limit,
        sortCriteria
      };
      let serverResponse = this.hisBackendService.postData('api/v1/cs/sys/genericSearch/loadSearchResult', request).pipe(map(x => x ? new HisSearchResult(x) : null));
      return serverResponse;
    }
    /**
     * @param resetInputs true, if the inputs should be reseted,
     * to use for fields like the select field of search criteria sets,
     * that is not part of the form
     *
     * @returns a HisSearchService.resetInputs: BehaviorSubject<boolean>
     */
    setResetInputs(resetInputs) {
      this.resetInputs.next(resetInputs);
    }
    /**
     * Sets the {@link HisOperatorTrigger} while loading a search set
     *
     * @param operatorTrigger a {@link HisOperatorTrigger}
     * @returns a {@link HisSearchService.selectOperator} as a BehaviorSubject<HisOperatorTrigger>
     */
    setOperator(operatorTrigger) {
      console.log('HisSearchService.setOperator: trigger=', operatorTrigger);
      this.selectOperator.next(operatorTrigger);
    }
    /**
     * Loads options by given ids.
     * @param configFile searchConfiguration file
     * @param optionByIdRequests the list of options
      * @return Observable<Map<string, HisOption>> a map, with keys
     */
    loadOptionsByIds(configFile, optionByIdRequests) {
      const request = new LoadOptionsByIdsRequest(configFile, optionByIdRequests);
      console.log('HisSearchService.loadOptionsByIds(): request =', request);
      //should we cache this?
      //return this.hisCacheService.getDataCachedInMemory( 'api/v1/cs/sys/genericSearch/loadOptionsByIds' + request );
      return this.hisBackendService.postData('api/v1/cs/sys/genericSearch/loadOptionsByIds', request);
    }
    static {
      this.ɵfac = function HisSearchService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSearchService,
        factory: HisSearchService.ɵfac
      });
    }
  }
  return HisSearchService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisTreeService = /*#__PURE__*/(() => {
  class HisTreeService {
    constructor() {
      this.hisBackendService = inject(HisBackendService);
    }
    loadTree(treeName, treeDataUrl) {
      let subject = new BehaviorSubject(null);
      // Initialize tree
      console.log('HisTreeService: treeName =', treeName, ', treeDataUrl =', treeDataUrl);
      if (treeDataUrl) {
        this.hisBackendService.getData(treeDataUrl).subscribe(tree => {
          if (tree) {
            // console.log("HisTreeService.loadTree(): tree is not null");
            this.addMissingChildrenAttributes(tree);
            // PrimeNG treeTable requires an array of tree nodes
            subject.next([tree]);
          } else {
            console.warn('HisTreeService.loadTree(): tree is null !');
          }
        });
      } else {
        console.error('HisTreeService: No REST service URL registered for tree', treeName);
      }
      return subject;
    }
    /**
     * @param node the tree node to modify
     */
    addMissingChildrenAttributes(node) {
      // console.log("node =", node);
      // generate unique checkbox html id's, required for "Barrierefreiheit"
      let uid = HisUidService.get('checkbox.');
      node.data.checkbox1Id = uid + '.1';
      node.data.checkbox2Id = uid + '.2';
      let children = node.children;
      if (children) {
        for (let child of children) {
          if (child) {
            this.addMissingChildrenAttributes(child);
          } else {
            // this should not happen; but it is good to know if the tree data generation on the backend was erroneous
            console.error('node ', node, 'contains a null child!!');
          }
        }
      } else {
        // create "children" attribute required by PrimeNg treeTable
        node.children = [];
      }
    }
    static {
      this.ɵfac = function HisTreeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTreeService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisTreeService,
        factory: HisTreeService.ɵfac
      });
    }
  }
  return HisTreeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisStringUtils {
  static isBlank(value) {
    // check if is blank, null or undefined
    if (!value || /^\s*$/.test(value)) {
      return true;
    }
    // check for white-spaces
    if (value.length === 0 || !value.trim()) {
      return true;
    }
    return false;
  }
  /**
   * Removes whitespace from the left, the middle and right
   *
   * @param value any string value
   */
  static trimAll(value) {
    let trimmed = value.replace(/\s+/g, ' ').replace(/^\s+|\s+$/, '').trim();
    return trimmed;
  }
  /**
   * Replaces all occurences of {@code searchValue} with {@code replaceValue} from {@code originalValue}
   *
   * @param originalValue the string from which to perplace {@code searchValue} with {@code replaceValue}
   * @param searchValue the value that should be replaced
   * @param replaceValue the replacement
   */
  static replaceAll(originalValue, searchValue, replaceValue) {
    return originalValue.split(searchValue).join(replaceValue);
  }
  static getHashCode(str) {
    let hash;
    for (let i = 0; i < str.length; i++) {
      let imul = Math.imul(31, hash);
      // console.log('his-string-utils#getHashCode(), imul', imul);
      let charCodeAt = str.charCodeAt(i);
      // console.log('his-string-utils#getHashCode(), charCodeAt', charCodeAt);
      hash = imul + charCodeAt;
      // console.log('his-string-utils#getHashCode(), hash', hash);
    }
    console.log('his-string-utils#getHashCode(), #hash', String(HisStringUtils.toInt32(hash)));
    return String(HisStringUtils.toInt32(hash));
  }
  static toInteger(x) {
    x = Number(x);
    return x < 0 ? Math.ceil(x) : Math.floor(x);
  }
  static modulo(a, b) {
    return a - Math.floor(a / b) * b;
  }
  static toUint32(x) {
    return HisStringUtils.modulo(HisStringUtils.toInteger(x), Math.pow(2, 32));
  }
  static toInt32(x) {
    let uint32 = HisStringUtils.toUint32(x);
    if (uint32 >= Math.pow(2, 31)) {
      return uint32 - Math.pow(2, 32);
    } else {
      return uint32;
    }
  }
  /**
   *Removes the last occurence of 'replacement' from the 'value', if present
   *
   * @param value the string from which replacement is to be removed
   * @param replacement the replacement to remove
   * @returns the value without the last occurence of the replacement
   * @throw ERROR if value is null or undefined
   * @throw ERROR if replacement is null or undefined
   */
  static removeLast(value, replacement) {
    if (value === null || value === undefined) {
      throw new Error('value must not be null or undefined');
    }
    if (!replacement) {
      throw new Error('replacement must not be null or undefined');
    }
    if (!value.endsWith(replacement)) {
      return value;
    }
    return value.substr(0, value.length - 1);
  }
}
let HisSearchConstants = /*#__PURE__*/(() => {
  class HisSearchConstants {
    static {
      this.SEARCH_CONFIG_FILE = 'configFile';
    }
    static {
      this.GROUPS = 'groups';
    }
    static {
      this.GROUP_LABEL = 'label';
    }
    static {
      this.CRITERIA_GROUP_AND = 'and';
    }
    static {
      this.CRITERIA = 'criteria';
    }
    static {
      this.FIELD = 'field';
    }
    static {
      this.NOT = 'not';
    }
    static {
      this.OPERATOR = 'operator';
    }
    static {
      this.VALUE = 'value';
    }
    static {
      this.CRITERIA_GROUPS = 'criteriaGroups';
    }
    static {
      this.EXCLUDING = 'excluding';
    }
    static {
      this.FILTER = 'filter';
    }
  }
  return HisSearchConstants;
})();
class HisWidgetUtils {
  static getWidgetGroupWithLabel(groupLabel, widgetGroups) {
    for (let widgetGroup of widgetGroups) {
      if (widgetGroup.label === groupLabel) {
        return widgetGroup;
      }
    }
    return undefined;
  }
  static getWidgetGroupContainingWidgetWithId(id, widgetGroups) {
    for (let widgetGroup of widgetGroups) {
      let widget = HisWidgetUtils.getWidgetWithIdFromGroup(id, widgetGroup);
      if (widget) {
        return widgetGroup;
      }
    }
    return undefined;
  }
  static getWidgetWithIdFromWidgetGroups(id, widgetGroups) {
    for (let widgetGroup of widgetGroups) {
      if (id.startsWith('EXIST')) {
        // widget.id: de.his.javang.suchen.personendaten[0]CONCAT(Person.firstname,' ',Person.surname)
        // id: EXIST_de_his_javang_suchen_personendaten_1:CONCAT(Person.firstname,' ',Person.surname)
        // group.label: de.his.javang.suchen.personendaten
        // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #id', id);
        // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #widgetGroup', widgetGroup);
        let tmp = id.replace('EXIST_', '');
        tmp = HisStringUtils.replaceAll(tmp, '_', '.');
        // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #tmp', tmp);
        if (tmp.startsWith(widgetGroup.label)) {
          // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #widgetGroup', widgetGroup);
          tmp = tmp.replace(widgetGroup.label, '').replace('.', '');
          let index = tmp.substring(0, tmp.indexOf(':'));
          // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #tmp', index);
          let path = tmp.replace(index + ':', '');
          // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #path', path);
          let widgetId = widgetGroup.label + '[' + index + ']' + path;
          // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #widgetId', widgetId);
          for (let criteriaGroup of widgetGroup.criteriaGroups) {
            // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #criteriaGroup', criteriaGroup);
            for (let criteriaGroupWidget of criteriaGroup.widgets) {
              if (criteriaGroupWidget.id === widgetId) {
                // console.log('his-widget-utils#getWidgetWithIdFromWidgetGroups() #criteriaGroupWidget.id', widget.id);
                return criteriaGroupWidget;
              }
            }
          }
        }
      }
      let widget = HisWidgetUtils.getWidgetWithIdFromGroup(id, widgetGroup);
      if (widget === null) {
        continue;
      }
      return widget;
    }
    return null;
  }
  static getWidgetWithIdFromGroup(id, widgetGroup) {
    for (let widget of widgetGroup.widgets) {
      if (widget.id === id) {
        return widget;
      }
    }
    return null;
  }
  static getOptionIds(options) {
    let optionIds = [];
    if (options === null || options === undefined) {
      return optionIds;
    }
    for (let opt of options) {
      let id = opt.id;
      optionIds.push(id);
    }
    return optionIds;
  }
  static parseArrayString(value) {
    // let valueArray: string[] = JSON.parse( value ); // does not work for ids of tree elements with subtree like "3x"
    let valueWithoutBrackets = value.startsWith('[') && value.endsWith(']') ? value.substring(1, value.length - 1) : value;
    let valueArray = valueWithoutBrackets.split(',');
    return valueArray;
  }
  static getCriteriaGroupIndexForKey(key) {
    // groups0.criteriaGroups0.criteria0.field
    let index1 = key.substring(key.indexOf(HisSearchConstants.CRITERIA_GROUPS)).replace(HisSearchConstants.CRITERIA_GROUPS, '');
    // console.log('his-search-parser#keyCriteriaGroupIndex() #index1', index1);
    let index2 = index1.substring(0, index1.indexOf('.'));
    // console.log('his-search-parser#keyCriteriaGroupIndex() #index2', index2);
    return Number(index2);
  }
  static getCriteriaGroupIndexForWidgetId(widgetId) {
    // let tmp = 'de.his.psv.Personbla[0]Person.gender.id';
    // console.log('his-search-parser#widgetIdCriteriaGroupIndex() #widgetId', widgetId);
    let index = widgetId.substring(widgetId.indexOf('[') + 1, widgetId.indexOf(']'));
    if (HisStringUtils.isBlank(index)) {
      // console.log('his-search-parser#widgetIdCriteriaGroupIndex() #index', -1);
      return -1;
    }
    // console.log('his-search-parser#widgetIdCriteriaGroupIndex() #index', Number(index));
    return Number(index);
  }
  /**
   * Prüft, ob der key (aus den params, flat object url format) zur widgetId passt, also ob beide das gleiche Feld vertreten
   *
   * @returns true, if the key represents the widget, false otherwise
   */
  static isMatchingKeyForWidget(key, value, widgetId, groupLabel) {
    // #key groups0.criteria0.field
    if (!key.endsWith('.' + HisSearchConstants.FIELD)) {
      return false;
    }
    // #value Person.gender.id
    if (widgetId !== value) {
      // console.log('his-widget-utils#isMatchingKeyForWidget(), #widgetId !== value', widgetId !== value);
      return false;
    }
    let isCriteriaGroupWidget = widgetId.startsWith(groupLabel);
    let isCriteriaGroupKey = key.includes(HisSearchConstants.CRITERIA_GROUPS);
    if (!isCriteriaGroupWidget && !isCriteriaGroupKey) {
      // Es sind beide keine Kriteriengruppen Element,
      // dann reichen obige Bedingungen aus
      return true;
    }
    let isCriteriaGroup = isCriteriaGroupWidget && isCriteriaGroupKey;
    let isCriteriaGroupId = HisWidgetUtils.getCriteriaGroupIndexForKey(key) === HisWidgetUtils.getCriteriaGroupIndexForWidgetId(widgetId);
    // groups0.criteriaGroups0.criteria0.field
    if (isCriteriaGroup && isCriteriaGroupId) {
      // Es ist das richtige Kriteriengruppen Feld
      return true;
    }
    // console.log('his-widget-utils#isMatchingKeyForWidget(), #no result', widgetId);
    return false;
  }
  /**
   * Gets the preset value for the widget in case of flat object url format
   */
  static getPresetForWidget(widget, presets) {
    // console.log('his-search-parser#getPresetForWidget() #widget', widget, '#presets', presets);
    for (let key of Object.keys(presets)) {
      let fieldValue = presets[key];
      if (!key.endsWith('.' + HisSearchConstants.FIELD)) {
        continue;
      }
      // if (key.endsWith('.' + HisSearchParser.FIELD) && widget.id === fieldValue) {
      if (this.isWidgetForKey(key, fieldValue, widget)) {
        let valueKey = key.replace(HisSearchConstants.FIELD, HisSearchConstants.VALUE);
        // groups0.criteriaGroups0.criteria0.value
        console.log('his-search-parser#getPresetForWidget() #valueKey', valueKey, '#value', presets[valueKey]);
        if (valueKey && presets[valueKey]) {
          // Checkboxen
          // groups0.criteria0.value=<>ISNULL, jdoech widget.value=true (boolean)
          if (widget.kind === 'checkbox') {
            console.log('his-search-parser#getPresetForWidget() #preset to return', true);
            return true;
          }
          // groups0.criteria0.value=2
          let preset = presets[valueKey];
          console.log('his-search-parser#getPresetForWidget() #preset to return', preset);
          return preset;
        }
      }
    }
  }
  static isWidgetForKey(key, value, widget) {
    // console.log('his-search-parser#isWidgetForKey() #key', key);
    if (!key.endsWith('.' + HisSearchConstants.FIELD)) {
      return false;
    }
    if (widget.id !== value) {
      return false;
    }
    // console.log('his-search-parser#isWidgetForKey() #widget', widget);
    if (key.includes(HisSearchConstants.CRITERIA_GROUPS) && HisWidgetUtils.getCriteriaGroupIndexForKey(key) !== HisWidgetUtils.getCriteriaGroupIndexForWidgetId(widget.id)) {
      return false;
    }
    return true;
  }
}
class HisQueryParamUtils {
  static isFlatObjectFormat(queryParams) {
    for (let key of Object.keys(queryParams)) {
      if (key.startsWith(HisSearchConstants.GROUPS + '0.' + HisSearchConstants.CRITERIA)) {
        console.log('his-search-parser-helper#isFlatObjectFormat()', 'true', '#queryParams', queryParams);
        return true;
      }
    }
    console.log('his-search-parser-helper#isFlatObjectFormat()', 'false', '#queryParams', queryParams);
    return false;
  }
}
class HisWidgetBase {
  constructor(options) {
    this.group = options.group;
    this.kind = options.kind || 'text';
    this.value = options.value;
    this.id = options.id;
    // The uid needs a random part, because searchCriterion.path is not unique
    // if the same search criterion is included twice in a page
    // (e.g. when we have a sub-search for project lead and another one for project members)
    this.uid = HisUidService.get(options.id + '.');
    this.label = options.label || '';
    this.helptext = options.helptext;
    this.order = options.order === undefined ? 0 : options.order;
    this.errors = [];
    this.quickSearch = _.isNil(options.quickSearch) ? true : !!options.quickSearch;
    this.required = options.required || false;
    this.inputType = options.inputType;
  }
  /**
   * Default implementation for inputs, calendar, checkbox.
   */
  presetInputFields(presets) {
    if (!presets) {
      // without setting value to undefined, checkboxes will be selected
      this.value = undefined;
      return;
    }
    if (HisQueryParamUtils.isFlatObjectFormat(presets)) {
      this.setPreset(HisWidgetUtils.getPresetForWidget(this, presets));
      return;
    }
    // presets with key value fromat
    let presetValue = presets[this.id];
    this.setPreset(presetValue);
  }
  setPreset(presetValue) {
    if (!presetValue) {
      this.value = undefined;
      return;
    }
    console.log('presetting input field ' + this.id + ' =', presetValue);
    this.value = presetValue;
    return;
  }
}
class HisCalendarWidget extends HisWidgetBase {
  constructor(options = {}) {
    super(options);
    this.kind = 'calendar';
  }
  isWidgetModified() {
    if (this.value === '' || this.value === null) {
      this.value = undefined;
    }
    if (this.originalValue === '' || this.originalValue === null) {
      this.originalValue = undefined;
    }
    return this.value !== this.originalValue;
  }
}

/**
 * This class provides common utility methods for the generic search.
 */
class GenericSearchUtil {
  /**
   * Checks if the given path is an LID path.
   *
   * A path is considered an LID path if it ends with '.lid' or 'Obj.id'.
   *
   * @param path the path to check.
   * @returns true if the path is a LID path, false otherwise.
   */
  static isLidPath(path) {
    return path.endsWith('.lid') || path.endsWith('Obj.id');
  }
  /**
   * Converts a selection value from a tree that might be a selection including subnodes to a clean ID or LID which is a number.
   *
   * A selection value that includes subnodes has an 'x' at the end. This will be removed
   * and the value will be converted to a number.
   *
   * @param value the value to convert.
   * @returns the number which might be a LID or ID.
   */
  static idOrLidTreeSelectionToCleanIdOrLid(value) {
    if (!value) {
      return null;
    }
    return +value.replace('x', '');
  }
  /**
   * Checks if the given value is a tree selection that includes subnodes.
   *
   * A selection value that includes subnodes has an 'x' at the end.
   *
   * @param value the value to check.
   * @returns true if the value is a tree selection including subnodes, false otherwise.
   */
  static isIdOrLidTreeSelectionIncludingSubnodes(value) {
    if (!value) {
      return false;
    }
    return value.endsWith('x');
  }
  /**
   * Checks whether a his-search-autocomplete should be initialized lazy.
   *
   * For this, we check if selectFrom contains '.', which indicates a service method call.
   * Also, for a lazy initialization, showDropdownIcon must be false.
   *
   * @param selectFrom the selectFrom expression
   * @param showDropdownIcon whether a dropdown icon is shown
   * @returns true if the parameters indicate lazy initialization, false otherwise.
   */
  static isLazySelectFrom(selectFrom, showDropdownIcon) {
    return selectFrom && selectFrom.includes('.') && showDropdownIcon === false;
  }
  /**
   * Sorts data using specified criteria
   * @param data The data to sort
   * @param sortMeta The sorting metadata from PrimeNG
   * @returns Sorted copy of the data
   */
  static sortData(data, sortMeta) {
    if (!sortMeta || sortMeta.length === 0) {
      return data;
    }
    return [...data].sort((a, b) => {
      for (const meta of sortMeta) {
        const valueA = a.get(meta.field);
        const valueB = b.get(meta.field);
        const comparator = meta.order === 1 ? 1 : -1;
        // Handle null values
        if (valueA == null && valueB == null) continue;
        if (valueA == null) return comparator;
        if (valueB == null) return -comparator;
        // Handle specific types
        const result = this.compareValues(valueA, valueB);
        if (result !== 0) {
          return result * comparator;
        }
      }
      return 0;
    });
  }
  /**
   * Compares two values of potentially different types
   * @param valueA First value to compare
   * @param valueB Second value to compare
   * @returns Comparison result (-1, 0, 1)
   */
  static compareValues(valueA, valueB) {
    // Handle booleans
    if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
      return valueA === valueB ? 0 : valueA ? 1 : -1;
    }
    // Handle dates
    const dateA = this.toDate(valueA);
    const dateB = this.toDate(valueB);
    if (dateA && dateB) {
      return dateA.getTime() - dateB.getTime();
    }
    // Handle numbers
    const numA = !isNaN(Number(valueA)) ? Number(valueA) : null;
    const numB = !isNaN(Number(valueB)) ? Number(valueB) : null;
    if (numA !== null && numB !== null) {
      return numA - numB;
    }
    // Handle strings
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    }
    // Default comparison
    return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
  }
  /**
   * Converts a value to a Date object if possible
   * @param value The value to convert
   * @returns Date object or null if conversion fails
   */
  static toDate(value) {
    if (value instanceof Date) {
      return value;
    }
    if (typeof value === 'string') {
      // Try to parse the date assuming the format dd.MM.yyyy
      const parts = value.split('.');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is 0-based
        const year = parseInt(parts[2], 10);
        const date = new Date(year, month, day);
        // Check if the date is valid
        return isNaN(date.getTime()) ? null : date;
      }
      // Try standard date parsing
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : date;
    }
    return null;
  }
  /**
   * Helper method to extract sort metadata from PrimeNG {@link TableLazyLoadEvent}
   * @param event The lazy load event from PrimeNG table
   * @returns Array of SortMeta objects
   */
  static extractSortMeta(event) {
    if (!event.sortField) {
      return event.multiSortMeta || [];
    }
    const sortOrder = event.sortOrder || 1;
    if (Array.isArray(event.sortField)) {
      return [{
        field: event.sortField.join(','),
        order: sortOrder
      }];
    }
    return [{
      field: event.sortField,
      order: sortOrder
    }];
  }
}
class HisOption {
  constructor(label, id) {
    this.label = label;
    this.id = id;
  }
}
class HisWidgetBaseSelect extends HisWidgetBase {
  constructor(options = {}) {
    super(options);
    this.showNullItem = false;
    this.not = false;
    this.showNullItem = options.showNullItem;
    this.showDropdownIcon = options.showDropdownIcon;
    this.minLength = options.minLength || 1;
    this.limit = options.limit || null;
    this.not = options.not;
    this.originalNot = options.not;
    this.showUnequalOption = _.isNil(options.showUnequalOption) || String(options.showUnequalOption).includes('true') ? true : false;
  }
  isWidgetModified() {
    // console.log('his-search-save-params.component#isFormModified() #widget.value', widget.value);
    // console.log('his-search-save-params.component#isFormModified() #widget.originalValue', widget.originalValue);
    if (!this.operatorsEquals(this.not, this.originalNot)) {
      return true;
    }
    if ((this.value === null || this.value === undefined) && (this.originalValue === null || this.originalValue === undefined)) {
      return false;
    }
    let value = this.value;
    let originalValue = this.originalValue;
    if (Array.isArray(value) && value.length === 0 || value === undefined) {
      value = null;
    }
    if (Array.isArray(originalValue) && originalValue.length === 0 || originalValue === undefined) {
      originalValue = null;
    }
    if (JSON.stringify(value) !== JSON.stringify(originalValue)) {
      return true;
    }
    return false;
  }
  operatorsEquals(op1, op2) {
    if (op1 === null || op1 === undefined) {
      op1 = false;
    }
    if (op2 === null || op2 === undefined) {
      op2 = false;
    }
    if (op1 === op2) {
      return true;
    }
    return false;
  }
}
class HisSelectWidget extends HisWidgetBaseSelect {
  constructor(options = {}) {
    super(options);
    this.kind = 'dropdown';
    this.multiple = false;
    this.kind = options.kind || 'dropdown';
    this.optionsKey = options.optionsKey;
    this.options = options.options || of([]);
    this.multiple = options.multiple;
    this.configFile = options.configFile;
  }
  presetInputFields(presets) {
    if (!presets) {
      return;
    }
    if (GenericSearchUtil.isLazySelectFrom(this.optionsKey, this.showDropdownIcon)) {
      return;
    }
    let preset;
    if (HisQueryParamUtils.isFlatObjectFormat(presets)) {
      preset = HisWidgetUtils.getPresetForWidget(this, presets);
    } else {
      preset = presets[this.id];
    }
    console.log('presetting single-select field', this.id, 'to', preset);
    if (preset) {
      // Sowohl "model" (form control) und "view" auf denselben Wert zu setzen ist hier besonders tricky, weil
      // * this.value der form control zugewiesen wird bevor der folgende subscribe()-Block abgearbeitet ist
      // * this.value hier nur einen einzelnen Wert enthält (bei einem Array ist die Sache einfacher)
      // Folgender Workaround funktioniert (Schritte 1. bis 3.):
      // 1. Wert für die form control mit einem Dummy-Objekt vorbelegen
      this.value = {
        label: null,
        id: null
      };
      let isLidSearch = GenericSearchUtil.isLidPath(this.id);
      console.log('presetting #preset options', this.options);
      this.getWidgetValues(preset, isLidSearch).subscribe(val => {
        if (val) {
          // 2. Das value-Objekt aktualisieren, dass schon der form control zugewiesen ist
          Object.assign(this.value, val);
          // 3. Um die Anzeige zu aktualisieren müssen wir ein neues Objekt erzeugen
          this.value = val;
        }
      });
      if (preset === 'ISNULL' && this.showNullItem) {
        let isNullOption = new HisOption();
        isNullOption.id = 'ISNULL';
        // for the label we need the uiService, so the label is set at his-search-autocomplete.component.ts
        isNullOption.label = null;
        Object.assign(this.value, isNullOption);
        this.value = isNullOption;
      }
    }
  }
  /**
   * IMPORTANT: This method is SPECIFICALLY designed for generic search functionality only!
   *
   * Behavior:
   * - Will return empty/undefined if no matching option is found
   * - For lazy-loaded selects: Returns warning that values will be loaded later (the actual values need to be handled separately in his-search-form)
   * - Primarily used in the context of generic search field
   *
   * 	* Limitations:
   * - Should not be used outside of generic search context
   *
   */
  getWidgetValues(id, isLidSearch) {
    if (GenericSearchUtil.isLazySelectFrom(this.optionsKey, this.showDropdownIcon)) {
      console.log(`HisSelectWidget.getWidgetValues(): Options for "${this.label}" will be loaded later in his-search-form by copying`);
    }
    let subject = new BehaviorSubject(null);
    this.options.subscribe(options => {
      let option = options.find(opt => opt.id === id.toString());
      subject.next(option);
    });
    return subject;
  }
}
let HisWidgetGroup = /*#__PURE__*/(() => {
  class HisWidgetGroup {
    static {
      this.ID_DEFAULT = 'WidgetGroup.DEFAULT';
    }
    constructor(options) {
      if (!options) {
        options = {};
      }
      this.id = options.id || HisUidService.get('WidgetGroup.');
      this.label = options.label || '';
      this.helptext = options.helptext;
      this.widgets = options.widgets || [];
      this.quickSearch = _.isNil(options.quickSearch) ? true : !!options.quickSearch;
      this.criteriaGroup = _.isNil(options.criteriaGroup) ? true : !!options.criteriaGroup;
      this.criteriaGroups = options.criteriaGroups || [];
      this.combineCriteriaGroupsByOr = options.combineCriteriaGroupsByOr || false;
    }
    presetInputFields(presets) {
      for (let widget of this.widgets) {
        widget.presetInputFields(presets);
      }
    }
    collectLazyWidgets() {
      const lazyWidgets = [];
      for (let widget of this.widgets) {
        if (widget instanceof HisSelectWidget && GenericSearchUtil.isLazySelectFrom(widget.optionsKey, widget.showDropdownIcon)) {
          lazyWidgets.push(widget);
        }
      }
      return lazyWidgets;
    }
  }
  return HisWidgetGroup;
})();
class HisInputWidget extends HisWidgetBase {
  constructor(options = {}) {
    super(options);
    this.kind = 'input';
    this.type = options.type || 'text';
    this.multiSearchCriterion = options.multiSearchCriterion;
    this.multiSearchCriterionLabels = options.multiSearchCriterionLabels;
    this.placeholder = options.placeholder;
  }
  isWidgetModified() {
    if (this.value === '' || this.value === null) {
      this.value = undefined;
    }
    if (this.originalValue === '' || this.originalValue === null) {
      this.originalValue = undefined;
    }
    return this.value !== this.originalValue;
  }
}
class HisMultiSelectWidget extends HisWidgetBaseSelect {
  constructor(options = {}) {
    super(options);
    this.kind = 'multi-dropdown';
    this.multiple = false;
    this.kind = options.kind || 'multi-dropdown';
    this.optionsKey = options.optionsKey;
    this.options = options.options || of([]);
    this.multiple = options.multiple;
  }
  presetInputFields(presets) {
    if (!presets) {
      return;
    }
    let preset;
    if (HisQueryParamUtils.isFlatObjectFormat(presets)) {
      preset = HisWidgetUtils.getPresetForWidget(this, presets);
    } else {
      preset = presets[this.id + '[]'];
    }
    console.log('presetting multi-select field', this.id, 'to', preset);
    this.value = [];
    if (preset) {
      let isLidSearch = GenericSearchUtil.isLidPath(this.id);
      this.getWidgetValues(preset, isLidSearch).subscribe(values => {
        if (values) {
          // Vorsicht! Hier dürfen wir kein neues Objekt erzeugen, weil this.value im folgenden
          // einem form control zugewiesen wird, bevor dieser subscribe()-Block aufgerufen wird.
          for (let value of values) {
            this.value.push(value);
          }
        }
      });
      if (preset === 'ISNULL') {
        let valueOptions = this.value;
        for (let opt of valueOptions) {
          if (opt.id === 'ISNULL') {
            // for the label we need the uiService, so the label is set at his-search-multiselect.component.ts
            opt.label = null;
            this.value.push(opt);
          }
        }
      }
    }
  }
  getWidgetValues(idsStr, isLidSearch) {
    let idArray = HisWidgetUtils.parseArrayString(idsStr);
    let subject = new BehaviorSubject(null);
    let optionsToSet = [];
    this.options.subscribe(options => {
      // the preset value of a multi-dropdown is a list of id's
      for (let id of idArray) {
        let option = options.find(opt => opt.id === id.toString());
        if (option === null || option === undefined) {
          continue;
        }
        optionsToSet.push(option);
      }
      console.log('Multiselect optionsToSet', optionsToSet);
      subject.next(optionsToSet);
    });
    return subject;
  }
}
class HisOptionWidget extends HisWidgetBase {
  constructor(options = {}) {
    super(options);
    this.kind = 'checkbox';
    this.option = options.option || '?';
  }
  isWidgetModified() {
    let widgetValue = this.isCheckboxSelected(this.value);
    let widgetOriginalValue = this.isCheckboxSelected(this.originalValue);
    return widgetValue !== widgetOriginalValue;
  }
  /**
   * Prüft, ob eine Checkbox ausgewählt ist, sowohl für widget.value, als auch für widget.originalValue
   *
   * @param value
   * <p>Die Checkbox ist nicht ausgewählt falls value =</p>
   * <ul>
   * <li>undefined</li>
   * <li>null</li>
   * <li>false: boolean</li>
   * </ul>
   * <p>Die Checkbox ist ausgewählt falls value =</p>
   * <ul>
   * <li>true: boolean</li>
   * <li>irgendein Wert: string (das ist der Value aus der Suchkonfigurationsdatei)</li>
   * </ul>
   */
  isCheckboxSelected(value) {
    if (value === undefined || value === null) {
      return false;
    }
    if (typeof value === 'boolean') {
      if (value === true) {
        return true;
      } else {
        return false;
      }
    }
    if (typeof value === 'string') {
      return true;
    }
    return false;
  }
}

/**
 * Structure for transfer of search prameters via url
 */
class HisSearch {
  constructor() {
    this.groups = [];
  }
}
let HisSearchGroup$1 = class HisSearchGroup {
  constructor() {
    this.criteria = [];
    this.criteriaGroups = [];
  }
};
let HisSearchCriteria$1 = class HisSearchCriteria {};
class HisSearchCriteriaGroup {
  constructor() {
    this.criteria = [];
  }
}
var HisSearchCriteriaOperator = /*#__PURE__*/function (HisSearchCriteriaOperator) {
  // currently not used
  HisSearchCriteriaOperator["EQ"] = "=";
  HisSearchCriteriaOperator["NE"] = "<>";
  HisSearchCriteriaOperator["LT"] = "<";
  HisSearchCriteriaOperator["GT"] = ">";
  return HisSearchCriteriaOperator;
}(HisSearchCriteriaOperator || {});
/**
 * Search select values can have any kind of attributes. Even the id attribute is not required
 * if the component obtains the input selectedOptionsIdColumn.
 */
class HisSearchSelectWidget extends HisWidgetBaseSelect {
  constructor(searchService, options = {}) {
    super(options);
    this.searchService = searchService;
    this.kind = 'search-select';
    this.showSearchFilter = true;
    this.kind = options.kind || 'search-select';
    this.searchEntity = options.searchEntity;
    this.searchConfigFile = options.searchConfigFile;
    this.selectedOptionsIdColumn = options.selectedOptionsIdColumn;
    this.selectedOptionsLabelColumn = options.selectedOptionsLabelColumn;
    this.showSearchFilter = options.showSearchFilter;
  }
  presetInputFields(presets) {
    if (!presets) {
      return;
    }
    let preset;
    if (HisQueryParamUtils.isFlatObjectFormat(presets)) {
      preset = HisWidgetUtils.getPresetForWidget(this, presets);
    } else {
      preset = presets[this.id + '[]'];
    }
    console.log('presetting search-select field', this.id, 'to', preset);
    console.log('selectedOptionsIdColumn =', this.selectedOptionsIdColumn);
    console.log('this.selectedOptionsLabelColumn =', this.selectedOptionsLabelColumn);
    this.value = [];
    if (preset) {
      // The preset value of a search select is a list of id values.
      // So to obtain all other attributes we must run a search with the id's as the unique search constraint.
      let isLidSearch = GenericSearchUtil.isLidPath(this.id);
      this.getWidgetValues(preset, isLidSearch).subscribe(values => {
        if (values) {
          // Vorsicht! Hier dürfen wir kein neues Objekt erzeugen, weil this.value im folgenden
          // einem form control zugewiesen wird, bevor dieser subscribe()-Block aufgerufen wird.
          for (let value of values) {
            this.value.push(value);
          }
        }
      });
    }
  }
  getWidgetValues(idsStr, isLidSearch) {
    // Use value as search constraint
    let idArray = HisWidgetUtils.parseArrayString(idsStr);
    let search = new HisSearch();
    search.configFile = this.searchConfigFile;
    let group = new HisSearchGroup$1();
    group.groupLabel = this.group;
    let criteria = new HisSearchCriteria$1();
    criteria.field = this.selectedOptionsIdColumn;
    criteria.value = idArray.map(element => element).join(',');
    group.criteria.push(criteria);
    search.groups.push(group);
    let subject = new BehaviorSubject([]);
    let widgetValues = [];
    console.log('search =', search);
    this.searchService.loadSearchResult(search, 0, null).subscribe(searchResult => {
      console.log('Preset data for his-search-select \'' + searchResult.name + '\' (' + searchResult.offset + '/' + searchResult.limit + '/' + searchResult.totalCount + ') loaded.');
      // for ( let i = 0; i < searchResult.columns.length; i++ ) {
      //     console.log( 'column', i, '=', searchResult.columns[i] );
      // }
      let rows = searchResult.data;
      console.log('preset search result =', rows);
      // Convert rows to flat rows and add them to self.value
      let row;
      let flatRow;
      for (row of rows) {
        // console.log( 'row =', row );
        let id = row.get(this.selectedOptionsIdColumn);
        // console.log( 'id =', id );
        let label = row.getAt(0);
        // console.log( 'label =', label );
        // The first column must be the label column!
        // TODO This might not be general enough, but this.selectedOptionsLabelColumn is undefined...
        flatRow = row.toFlatSearchResultRow(id, label);
        console.log('Found preset data flatRow =', flatRow);
        widgetValues.push(flatRow);
      }
      subject.next(widgetValues);
    });
    return subject;
  }
}

/**
 * Tree select values always must have an id attribute, may have either a selected or a subTreeSelected attribute,
 * and may have arbitrary additional attributes.
 */
class HisTreeSelectWidget extends HisWidgetBaseSelect {
  constructor(options = {}, treeName, treeSubject) {
    super(options);
    this.kind = 'tree-select';
    this.kind = options.kind || 'tree-select';
    this.treeName = treeName || null;
    this.treeSubject = treeSubject;
    treeSubject.subscribe(result => {
      console.log('Obtained data for tree', this.treeName);
      this.tree = result;
    });
  }
  static getAllTreeNodeIds(treeNodes, isLidSearch) {
    let allTreeNodeIds = [];
    if (treeNodes !== null && treeNodes !== undefined) {
      for (let treeNode of treeNodes) {
        let idOrLid = isLidSearch ? treeNode.data.lid : treeNode.data.id;
        allTreeNodeIds.push(idOrLid);
        allTreeNodeIds = allTreeNodeIds.concat(this.getAllTreeNodeIds(treeNode.children, isLidSearch));
      }
    }
    return allTreeNodeIds;
  }
  presetInputFields(presets) {
    console.log('his-widget-tree-select#presetInputFields() #presets', presets);
    if (!presets) {
      return;
    }
    let preset;
    if (HisQueryParamUtils.isFlatObjectFormat(presets)) {
      preset = HisWidgetUtils.getPresetForWidget(this, presets);
    } else {
      preset = presets[this.id + '[]'];
    }
    console.log('his-widget-tree-select#presetInputFields() #id', this.id, '#to preset', preset);
    this.value = [];
    if (preset) {
      let isLidSearch = GenericSearchUtil.isLidPath(this.id);
      this.getWidgetValues(preset, isLidSearch).subscribe(values => {
        console.log('his-widget-tree-select#presetInputFields() #values', values);
        if (values) {
          // Vorsicht! Hier dürfen wir kein neues Objekt erzeugen, weil this.value im folgenden
          // einem form control zugewiesen wird, bevor dieser subscribe()-Block aufgerufen wird.
          for (let value of values) {
            this.value.push(value);
          }
        }
      });
    }
  }
  getWidgetValues(idsStr, isLidSearch) {
    // idsStr is a comma-separated list of id's; a single id may have
    // an "x" appended signaling that the whole subtree shall be selected
    let idArray = HisWidgetUtils.parseArrayString(idsStr);
    console.log('presetting input field ' + this.id + ' =', idArray);
    let subject = new BehaviorSubject(null);
    let value = [];
    this.treeSubject.subscribe(tree => {
      if (tree) {
        for (let id of idArray) {
          // id kann hier auch lid sein
          console.log('his-widget-tree-select#getWidgetValues() #id', id);
          let isSubtreeSelected = false;
          if (id[id.length - 1] === 'x') {
            isSubtreeSelected = true;
            id = id.substring(0, id.length - 1);
          }
          let treeNode;
          for (treeNode of tree) {
            // console.log( 'treeNode =', treeNode );
            let foundNode = this.findTreeNodeWithId(treeNode, +id, isLidSearch); // +id -> string to number conversion
            if (foundNode) {
              // found the right tree node
              let data = foundNode.data;
              if (isSubtreeSelected) {
                data.selected = false;
                data.subTreeSelected = true;
              } else {
                data.selected = true;
                data.subTreeSelected = false;
              }
              // console.log( 'found treeNode', data );
              value.push(data);
              break;
            }
          }
        }
        // TODO Not very efficient
        subject.next(value);
      }
    });
    return subject;
  }
  findTreeNodeWithId(treeNode, id, isLidSearch) {
    if (isLidSearch && treeNode.data.lid === id) {
      return treeNode;
    }
    if (treeNode.data.id === id) {
      return treeNode;
    }
    let child;
    for (child of treeNode.children) {
      let foundNode = this.findTreeNodeWithId(child, id, isLidSearch);
      if (foundNode) {
        return foundNode;
      }
    }
    return null;
  }
}
let HisWidgetService = /*#__PURE__*/(() => {
  class HisWidgetService {
    constructor() {
      this.hisSearchService = inject(HisSearchService);
      this.hisTreeService = inject(HisTreeService);
      // cached select options for dropdowns etc.
      this.selectFromOptionsCache = new Map();
      this.loadedSelectFromOptions = new Set();
    }
    /**
     * Create all widgets and widget groups for a search page.
     * (All really means all, even if we are in "simple search" mode.)
     *
     * @param searchConfig search configuration
     * @param an array of all widgetGroups
     */
    getWidgetGroups(searchConfig) {
      let widgetGroups = [];
      for (let searchGroup of searchConfig.searchCriteria.group) {
        let label = searchGroup.label;
        let helptext = searchGroup.helptext;
        let widgetGroup = new HisWidgetGroup({
          label,
          helptext
        });
        let index = 0;
        for (let searchCriterion of searchGroup.criteria) {
          index++;
          let widget = this.getWidget(widgetGroup, searchCriterion, index, null, searchConfig.configFile);
          // console.log("HisWidgetService.getWidgetGroups(): Created widget", widget.id);
          widgetGroup.widgets.push(widget);
        }
        widgetGroup.widgets.sort((w1, w2) => w1.order - w2.order);
        widgetGroup.quickSearch = false;
        for (let widget of widgetGroup.widgets) {
          if (widget.quickSearch) {
            widgetGroup.quickSearch = true;
            break;
          }
        }
        widgetGroup.criteriaGroup = searchGroup.criteriaGroup;
        widgetGroups.push(widgetGroup);
      }
      return widgetGroups;
    }
    /**
     * Gets the value from searchCriterion if value != null
     * in case of loading criteria via search-criteria-set.
     *
     * @param searchCriterion a HisSearchCriterion
     * @param model the model
     */
    getValue(searchCriterion, model) {
      if (searchCriterion.value != null) {
        return searchCriterion.value;
      }
      return model ? model[searchCriterion.path] : null;
    }
    getWidget(widgetGroup, searchCriterion, index, model, configFile) {
      let kind;
      if (searchCriterion.selectFrom) {
        kind = searchCriterion.multipleSelect ? 'multi-dropdown' : 'dropdown';
      } else if (!_.isNil(searchCriterion.value)) {
        // XXX does this make sense? A value attribute can have more options than 0 and 1 ...
        kind = 'checkbox';
      } else if (searchCriterion.treeName) {
        kind = 'tree-select';
      } else if (searchCriterion.searchConfigFile) {
        kind = 'search-select';
      } else if (searchCriterion.inputType && searchCriterion.inputType.toUpperCase() === 'DATE') {
        kind = 'calendar';
      } else {
        kind = 'input';
      }
      let id = searchCriterion.path;
      let options = {
        group: widgetGroup.id,
        id,
        kind,
        label: searchCriterion.label,
        helptext: searchCriterion.helptext,
        value: this.getValue(searchCriterion, model),
        order: index,
        quickSearch: searchCriterion.quickSearchCriterion,
        required: searchCriterion.required,
        inputType: searchCriterion.inputType
      };
      // console.log('Creating widget', id, 'of kind', kind, 'with options', options);
      let widget;
      switch (kind) {
        case 'dropdown':
        case 'multi-dropdown':
          {
            options.multiple = searchCriterion.multipleSelect;
            let selectFrom = searchCriterion.selectFrom;
            options.optionsKey = selectFrom;
            // Get or create an observable for the select options of the widget
            options.options = this.getSelectOptions(selectFrom);
            options.showNullItem = searchCriterion.showNullItem;
            options.showDropdownIcon = searchCriterion.showDropdownIcon;
            options.minLength = searchCriterion.typeaheadMinLength || 1;
            options.limit = searchCriterion.typeaheadMaxResults || null;
            options.showUnequalOption = searchCriterion.showUnequalOption;
            options.not = searchCriterion.not;
            options.configFile = configFile;
            if (kind === 'dropdown') {
              let selectWidget = new HisSelectWidget(options);
              if (id.endsWith('(NOT)')) {
                selectWidget.not = true;
              }
              widget = selectWidget;
            } else {
              // multi-dropdown
              let multiWidget = new HisMultiSelectWidget(options);
              if (id.endsWith('(NOT)')) {
                multiWidget.not = true;
              }
              widget = multiWidget;
            }
            break;
          }
        case 'tree-select':
          {
            console.log('HisWidgetService.getWidget(): selectFromTree = ' + searchCriterion.selectFromTree);
            let tree = this.hisTreeService.loadTree(searchCriterion.treeName, searchCriterion.selectFromTree);
            // TODO load tree only if the component is really rendered
            options.showNullItem = searchCriterion.showNullItem;
            options.showDropdownIcon = searchCriterion.showDropdownIcon;
            options.minLength = searchCriterion.typeaheadMinLength || 1;
            options.limit = searchCriterion.typeaheadMaxResults || null;
            options.showUnequalOption = searchCriterion.showUnequalOption;
            options.not = searchCriterion.not;
            let treeWidget = new HisTreeSelectWidget(options, searchCriterion.treeName, tree);
            if (id.endsWith('(NOT)')) {
              treeWidget.not = true;
            }
            widget = treeWidget;
            break;
          }
        case 'search-select':
          {
            options.searchEntity = searchCriterion.searchEntity;
            options.searchConfigFile = searchCriterion.searchConfigFile;
            options.selectedOptionsIdColumn = searchCriterion.searchEntity + '.id';
            // Name der Spalte der Suchergebnistabelle, die für die Labels ausgewählter Elemente genommen wird:
            // Momentan setzen wir diese auf undefined, woraufhin in his-search-result.component einfach
            // die erste Spalte genommen wird, was in den meisten Fällen funktionieren sollte.
            // searchCriterion.searchEntity+".defaulttext" zu nehmen wäre zu unflexibel und würde beispielsweise
            // die Labels aus Publication.title nicht finden.
            // TODO: Wenn die aktuelle Lösung nicht ausreicht, muss der Name der Label-Spalte aus
            // der Suchkonfigurationsdatei gelesen werden.
            options.selectedOptionsLabelColumn = undefined;
            options.showNullItem = searchCriterion.showNullItem;
            options.showDropdownIcon = searchCriterion.showDropdownIcon;
            options.minLength = searchCriterion.typeaheadMinLength || 1;
            options.limit = searchCriterion.typeaheadMaxResults || null;
            options.showUnequalOption = searchCriterion.showUnequalOption;
            options.not = searchCriterion.not;
            options.showSearchFilter = searchCriterion.showSearchFilter;
            // options for autocomplete in his-search-select are loaded in the component,
            // filtered by the autocomplete input
            let searchSelectWidget = new HisSearchSelectWidget(this.hisSearchService, options);
            if (id.endsWith('(NOT)')) {
              searchSelectWidget.not = true;
            }
            widget = searchSelectWidget;
            break;
          }
        case 'checkbox':
          {
            options.option = searchCriterion.value;
            widget = new HisOptionWidget(options);
            break;
          }
        case 'calendar':
          {
            widget = new HisCalendarWidget(options);
            break;
          }
        default:
          {
            console.log('WidgetService: multiSearchCriterion: ', searchCriterion.multiSearchCriterion);
            if (searchCriterion.multiSearchCriterion) {
              options.multiSearchCriterion = searchCriterion.multiSearchCriterion;
            }
            console.log('WidgetService: multiSearchCriterionLabels: ', searchCriterion.multiSearchCriterionLabels);
            if (searchCriterion.multiSearchCriterionLabels) {
              options.multiSearchCriterionLabels = searchCriterion.multiSearchCriterionLabels;
            }
            if (searchCriterion.placeholder) {
              options.placeholder = searchCriterion.placeholder;
            }
            widget = new HisInputWidget(options);
            break;
          }
      }
      return widget;
    }
    /**
     * Load all widget options for a search page.
     * For performance reasons we want to do only one backend call for a whole search page.
     *
     * @param searchConfig search configuration
     * @param showAllSearchCriteria if true then we are in extended search state
     */
    loadWidgetOptions(searchConfig, showAllSearchCriteria) {
      // Scan the complete search configuration for widgets needing select options
      let keys = [];
      for (let group of searchConfig.searchCriteria.group) {
        for (let criterion of group.criteria) {
          let key = criterion.selectFrom;
          if (key && (showAllSearchCriteria || criterion.quickSearchCriterion) && !this.loadedSelectFromOptions.has(key) && !GenericSearchUtil.isLazySelectFrom(criterion.selectFrom, criterion.showDropdownIcon)) {
            // The widget needs select options, it must be displayed, and the options have not been loaded yet -> mark to load
            keys.push(key);
          }
        }
      }
      if (keys.length > 0) {
        // Backend call required, to get the data:
        let data = this.hisSearchService.loadDataForSearchForm(searchConfig, keys);
        data.forEach((options, key) => {
          // pass loaded options from input observable to output subject
          options.subscribe(opts => {
            this.getSelectOptions(key).next(opts);
            // XXX das war im merge nicht mehr drin
            this.loadedSelectFromOptions.add(key);
          });
        });
      }
    }
    getSelectOptions(key) {
      if (!this.selectFromOptionsCache.has(key)) {
        let subject = new BehaviorSubject([]);
        this.selectFromOptionsCache.set(key, subject);
      }
      return this.selectFromOptionsCache.get(key);
    }
    copyWidget(original, newId) {
      //        console.log('copy widget of typet: ' + original.kind);
      let options = {
        group: original.group,
        id: newId,
        kind: original.kind,
        label: original.label,
        helptext: original.helptext,
        order: original.order,
        quickSearch: original.quickSearch,
        required: original.required,
        inputType: original.inputType,
        value: original.value
      };
      console.log('his-widget.service#copyWidget()', '#options', options);
      switch (original.kind) {
        case 'dropdown':
          {
            let originalWidget = original;
            options.multiple = originalWidget.multiple;
            options.optionsKey = originalWidget.optionsKey;
            options.options = originalWidget.options;
            options.showNullItem = originalWidget.showNullItem;
            options.showDropdownIcon = originalWidget.showDropdownIcon;
            options.minLength = originalWidget.minLength;
            options.limit = originalWidget.limit;
            options.not = originalWidget.not;
            options.configFile = originalWidget.configFile;
            return new HisSelectWidget(options);
          }
        case 'multi-dropdown':
          {
            let originalWidget = original;
            options.multiple = originalWidget.multiple;
            options.optionsKey = originalWidget.optionsKey;
            options.options = originalWidget.options;
            options.showNullItem = originalWidget.showNullItem;
            options.showDropdownIcon = originalWidget.showDropdownIcon;
            options.minLength = originalWidget.minLength;
            options.limit = originalWidget.limit;
            options.not = originalWidget.not;
            return new HisMultiSelectWidget(options);
          }
        case 'tree-select':
          {
            let originalWidget = original;
            options.showNullItem = originalWidget.showNullItem;
            options.showDropdownIcon = originalWidget.showDropdownIcon;
            options.minLength = originalWidget.minLength;
            options.limit = originalWidget.limit;
            options.not = originalWidget.not;
            let treeName = originalWidget.treeName;
            let treeSubject = originalWidget.treeSubject;
            return new HisTreeSelectWidget(options, treeName, treeSubject);
          }
        case 'search-select':
          {
            let originalWidget = original;
            options.searchEntity = originalWidget.searchEntity;
            options.searchConfigFile = originalWidget.searchConfigFile;
            options.selectedOptionsIdColumn = originalWidget.selectedOptionsIdColumn;
            options.selectedOptionsLabelColumn = originalWidget.selectedOptionsLabelColumn;
            options.showNullItem = originalWidget.showNullItem;
            options.showDropdownIcon = originalWidget.showDropdownIcon;
            options.minLength = originalWidget.minLength;
            options.limit = originalWidget.limit;
            options.not = originalWidget.not;
            options.showSearchFilter = originalWidget.showSearchFilter;
            return new HisSearchSelectWidget(this.hisSearchService, options);
          }
        case 'checkbox':
          {
            let originalWidget = original;
            options.option = originalWidget.option;
            return new HisOptionWidget(options);
          }
        case 'calendar':
          {
            return new HisCalendarWidget(options);
          }
        default:
          {
            return new HisInputWidget(options);
          }
      }
    }
    static {
      this.ɵfac = function HisWidgetService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisWidgetService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisWidgetService,
        factory: HisWidgetService.ɵfac
      });
    }
  }
  return HisWidgetService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchCriteriagroupComponentBase = /*#__PURE__*/(() => {
  class HisSearchCriteriagroupComponentBase {
    constructor() {
      this.hisUiService = inject(HisUiService);
      this.notificationService = inject(HisNotificationService);
      this.widgetService = inject(HisWidgetService);
      this.searchService = inject(HisSearchService);
      this.criteriagroupOverlayVisible = false;
      this.isEditMode = false;
      this.isAddMode = false;
    }
    ngOnInit() {
      console.log('combineCriteriaGroupsByOr #init', this.group.combineCriteriaGroupsByOr);
      this.initializeResetInputs();
      this.setResetInputs(false);
    }
    addCriteriaGroup(e) {
      this.isAddMode = true;
      // create new ( temporary ) criteria group which will hold the data for the overlay
      this.currentCriteriagroup = new HisSearchCriteriagroup();
      // Aus irgendeinem Grund wird combineCriteriaGroupsByOr nach Suche ändern
      // beim Hinzufügen einer 2. Kriteriengruppe bei #addCriteriaGroup() true
      // Siehe Hiszilla 257845
      if (this.group.criteriaGroups.length < 2) {
        // noch mal ausdrücklich auf default Wert setzen
        this.group.combineCriteriaGroupsByOr = false;
      }
      console.log('combineCriteriaGroupsByOr #add', this.group.combineCriteriaGroupsByOr);
      // add if new criteria group
      if (this.currentlyEditedIndex != null) {
        console.log('his-search-criteriagroup.component#saveCriteriaGroup() #this.currentCriteriagroup already exists:', this.currentCriteriagroup);
        this.group.criteriaGroups[this.currentlyEditedIndex] = this.currentCriteriagroup;
      } else {
        let index = String(this.group.criteriaGroups.length);
        for (let widget of this.group.widgets) {
          if (widget.id.includes('IGNORE:multi')) {
            // excludes multi search fields from criteria group #hiszilla 326976
            continue;
          }
          let widgetCopy = this.widgetService.copyWidget(widget, this.group.label + '[' + index + ']' + widget.id);
          console.log('his-search-criteriagroup.component#addCriteriaGroup #widgetCopy', widgetCopy);
          // eventuell vorhandene Werte dürfen nicht in der Kriteriengruppe angezeit werden
          widgetCopy.value = undefined;
          this.currentCriteriagroup.widgets.push(widgetCopy);
        }
        let groupLabel = this.group.label;
        console.log('his-search-criteriagroup.component#addCriteriaGroup #groupLabel', groupLabel);
        // ohne das Hinzufügen an dieser Stelle wird die Kritieriengruppe nicht angezeigt
        this.addCriteriaGroupToForm(this.currentCriteriagroup, groupLabel);
      }
      // show overlay
      this.showCriteriagroupOverlay();
      e.preventDefault();
    }
    removeCriteriaGroup(e, criteriagroup) {
      //this.group.criteriaGroups = this.group.criteriaGroups.filter(element => element !== criteriagroup);
      this.remove(criteriagroup);
      e.preventDefault();
    }
    remove(criteriagroup) {
      this.group.criteriaGroups = this.group.criteriaGroups.filter(element => element !== criteriagroup);
    }
    editCriteriaGroup(e, criteriagroup) {
      console.log('his-search-criteriagroup.component#editCriteriaGroup() #criteriagroup', criteriagroup);
      this.currentCriteriagroup = criteriagroup;
      this.criteriaGroupToRestore = cloneDeep(criteriagroup);
      this.currentlyEditedIndex = this.group.criteriaGroups.indexOf(criteriagroup);
      this.showCriteriagroupOverlay();
      this.isEditMode = true;
      e.preventDefault();
    }
    showCriteriagroupOverlay() {
      this.criteriagroupOverlayVisible = true;
    }
    hideCriteriagroupOverlayAfterCancel() {
      this.criteriagroupOverlayVisible = false;
      console.log('his-search-criteriagroup.component#hideCriteriagroupOverlayAfterCancel()');
      this.currentCriteriagroup = null;
      this.currentlyEditedIndex = null;
    }
    hideCriteriagroupOverlayAfterSaved() {
      this.criteriagroupOverlayVisible = false;
      this.currentCriteriagroup = null;
      this.currentlyEditedIndex = null;
    }
    saveCriteriaGroup(e) {
      e.preventDefault();
      if (!this.atLeastOneValueSet()) {
        this.notificationService.clear();
        this.notificationService.error(this.hisUiService.translate('cs.sys.genericSearch.criteriaGroup.notices.missingInputField.summary'), this.hisUiService.translate('view.messages.error'));
        return;
      }
      console.log('his-search-criteriagroup.component#saveCriteriaGroup() #this.group', this.group);
      //If an error was previously generated, it will now be deleted if the input is valid. Hiszilla#278609
      this.notificationService.clear();
      this.isEditMode = false;
      this.isAddMode = false;
      this.hideCriteriagroupOverlayAfterSaved();
    }
    atLeastOneValueSet() {
      for (let widget of this.currentCriteriagroup.widgets) {
        if (this.widgetValueAsString(widget)) {
          return true;
        }
      }
      return false;
    }
    cancelEditCriteriaGroup(e) {
      this.notificationService.clear();
      //console.log('his-search-criteriagroup.component#cancelEditCriteriaGroup #this.isAddMode', this.isAddMode);
      //console.log('his-search-criteriagroup.component#cancelEditCriteriaGroup #this.isEditMode', this.isEditMode);
      if (this.isAddMode) {
        // die hinzugefügte Kriteriengruppe muss wieder entfernt werden
        this.remove(this.currentCriteriagroup);
        this.currentCriteriagroup = undefined;
        this.isAddMode = false;
      }
      if (this.isEditMode && this.criteriaGroupToRestore) {
        //console.log('his-search-criteriagroup.component#cancelEditCriteriaGroup #currentlyEditedIndex', this.currentlyEditedIndex);
        //console.log('his-search-criteriagroup.component#cancelEditCriteriaGroup #this.groupToRestore', this.criteriaGroupToRestore);
        this.group.criteriaGroups[this.currentlyEditedIndex] = this.criteriaGroupToRestore;
        this.currentCriteriagroup = undefined;
        this.criteriaGroupToRestore = undefined;
        this.isEditMode = false;
      }
      this.hideCriteriagroupOverlayAfterCancel();
      if (Object.keys(e).length !== 0) {
        e.preventDefault();
      }
    }
    widgetValueAsString(widget) {
      if (widget.value == null) {
        return '';
      }
      // console.log('his-search-criteriagroup.component#widgetValueAsString #widget', widget);
      switch (widget.kind) {
        case 'dropdown':
          {
            let selectWidget = widget;
            let label = selectWidget.value.label;
            return this.addOperdatorPrefixNotIfPresent(selectWidget.not, label);
          }
        case 'multi-dropdown':
          {
            let multiSelectWidget = widget;
            let label = multiSelectWidget.value.map(option => option.label).join(', ');
            return this.addOperdatorPrefixNotIfPresent(multiSelectWidget.not, label);
          }
        case 'tree-select':
          {
            let treeSelectWidget = widget;
            let label = widget.value.map(treeNodeData => {
              let defaulttext = treeNodeData.defaulttext;
              let subTreeSelected = treeNodeData.subTreeSelected;
              if (!subTreeSelected) {
                return defaulttext;
              }
              return defaulttext + ' (' + this.hisUiService.translate('genericSearch.tree.includeSubNodes') + ')';
            }).join(', ');
            return this.addOperdatorPrefixNotIfPresent(treeSelectWidget.not, label);
          }
        case 'search-select':
          {
            let searchSelectWidget = widget;
            let label = searchSelectWidget.value.map(option => option.label).join(', ');
            return this.addOperdatorPrefixNotIfPresent(searchSelectWidget.not, label);
          }
        case 'checkbox':
          {
            if (widget.value) {
              return this.hisUiService.translate('de.his.javang.ja');
            }
            return '';
          }
        case 'calendar':
          {
            // as of 2020-09-24 the kind 'calendar' is not used
            return widget.value;
          }
        default:
          {
            return widget.value;
          }
      }
    }
    addOperdatorPrefixNotIfPresent(not, label) {
      if (!not) {
        return label;
      }
      return this.hisUiService.translate('genericSearch.result.notLabel') + ' ' + label;
    }
    // Eingaben zurücksetzen
    initializeResetInputs() {
      this.searchService.resetInputs.subscribe(resetInputs => {
        if (resetInputs) {
          this.group.criteriaGroups = [];
        }
      });
    }
    setResetInputs(resetInputs) {
      this.searchService.setResetInputs(resetInputs);
    }
    addCriteriaGroupToForm(criteriaGroup, groupLabel) {
      console.log('his-search-criteriagroup.component#addCriteriaGroupToForm() #criteriaGroup', criteriaGroup);
      let groups = this.widgetGroups;
      console.log('his-search-criteriagroup.component#addCriteriaGroupToForm() #groups', groups);
      for (let group of groups) {
        console.log('his-search-criteriagroup.component#addCriteriaGroupToForm() #group.label', group.label, '#groupLabel', groupLabel);
        if (group.label === groupLabel) {
          group.criteriaGroups.push(criteriaGroup);
        }
      }
      console.log('his-search-criteriagroup.component#addCriteriaGroupToForm() #groups', groups);
      this.updateForm(groups);
    }
    updateForm(groups) {
      let formGroup = {};
      for (let widgetGroup of groups) {
        for (let widget of widgetGroup.widgets) {
          formGroup[widget.id] = new UntypedFormControl(widget.value);
          // this.form.addControl(widget.id, new FormControl( widget.value ));
          console.log('his-search-criteriagroup.component#updateForm() #formGroup', formGroup);
        }
        for (let criteriaGroup of widgetGroup.criteriaGroups) {
          for (let criteriaGroupWidget of criteriaGroup.widgets) {
            console.log('his-search-criteriagroup.component#updateForm() #criteriaGroupWidget', criteriaGroupWidget);
            formGroup[criteriaGroupWidget.id] = new UntypedFormControl(criteriaGroupWidget.value);
          }
          console.log('his-search-criteriagroup.component#updateForm() #added criteriaGroup', criteriaGroup);
        }
      }
      // das DOM wird neu aufgebaut, deshalb kann hier form auch neu gefüllt werden
      // mit addControll würden die Werte im Fomular gelöscht werden
      this.form = new UntypedFormGroup(formGroup);
    }
    isValueToShow(value) {
      if (!value) {
        return false;
      }
      if (HisArrayUtils.isEmptyArray(value)) {
        console.log('his-search-criteriagroup.component#isValueToShow #value', value);
        return false;
      }
      return true;
    }
    static {
      this.ɵfac = function HisSearchCriteriagroupComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchCriteriagroupComponentBase)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchCriteriagroupComponentBase,
        inputs: {
          group: "group",
          form: "form",
          widgetGroups: "widgetGroups"
        }
      });
    }
  }
  return HisSearchCriteriagroupComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var HisSearchSelectionSetting = /*#__PURE__*/function (HisSearchSelectionSetting) {
  HisSearchSelectionSetting[HisSearchSelectionSetting["NoSelect"] = 0] = "NoSelect";
  HisSearchSelectionSetting[HisSearchSelectionSetting["SingleSelect"] = 1] = "SingleSelect";
  HisSearchSelectionSetting[HisSearchSelectionSetting["MultiSelect"] = 2] = "MultiSelect";
  return HisSearchSelectionSetting;
}(HisSearchSelectionSetting || {});
const _c0$G = ["SearchFormComponent"];
const _c1$c = ["SearchResultComponent"];
let HisSearchFormResultComponentBase = /*#__PURE__*/(() => {
  class HisSearchFormResultComponentBase {
    constructor() {
      this.route = inject(ActivatedRoute);
      // Used to determine the relevant UI elements
      this.selectionSettingEnum = HisSearchSelectionSetting;
      this.selectionSetting = HisSearchSelectionSetting.MultiSelect;
      this.renderTitle = true;
      this.renderCustomBottomResultButtons = true;
      this.scrollToResultAfterSearch = true;
      this.selectedOptions = [];
      this.selectedOptionsIdColumn = undefined;
      this.selectedOptionsLabelColumn = undefined;
      // is this a principal search? (not a sub-search in a popup)
      // only in this case we want to register the url for the "back to search" button
      this.isSearchPopup = false;
      // the number of result rows per page
      this.resultRowsPerPage = 10;
      // search constraints passed by parent component, like { 'Person.surname': 'Wolf', 'Person.firstname': 'Ulrich' }
      this.presetInputFields = {};
      this.hisIcon = 'arrow_left';
      this.selectionSubmited = new EventEmitter();
      this.selectionCanceled = new EventEmitter();
      this.readSearchSetSubmit = new EventEmitter();
      this.finishedInitialLoad = new EventEmitter();
      this.formTitleLoaded = new EventEmitter();
      this.showTableFilter = true;
      this.searchShowPrintviewButton = true;
      this.toggleFilter = false;
    }
    ngOnInit() {
      this.route.queryParams.subscribe(queryParams => {
        console.log('HisSearchFormResultComponent.ngOnInit(): queryParams=', queryParams, ', presets =', this.presetInputFields);
      });
    }
    setSelectedOptions(selectedOptions, selectedOptionsIdColumn) {
      this.selectedOptions = selectedOptions ? selectedOptions.slice(0) : [];
      this.selectedOptionsIdColumn = selectedOptionsIdColumn;
      this.searchResultComponent.setSelectedOptions(selectedOptions, selectedOptionsIdColumn, this.selectedOptionsLabelColumn);
    }
    submitInitialSearch() {
      let presets = this.searchFormComponent.presetInputFields;
      if (presets && Object.keys(presets).length > 0) {
        this.searchFormComponent.createHisSearchFromSearchData(this.searchConfigFile).subscribe(search => {
          if (search) {
            console.log('HisSearchFormResultComponent:submitInitialSearch() search =', search);
            this.onSubmitSearch(search);
          }
        });
      } // else: do not run initial search if no presets are present #255715
    }
    onSubmitSearch(search) {
      // Die erste anzuzeigende Ergebniszeile muss bei Abschicken einer Suche auf 0 zurückgesetzt werden,
      // da es bei einer erneuten Suche mit geänderten Suchkriterien weniger Treffer als vorher geben kann.
      console.log('HisSearchFormResultComponent.onSubmitSearch(): Initialize search result for ', this.searchConfigFile, 'with search constraints', search, 'with page 1, rows 1..' + this.searchResultComponent.resultRowsPerPage);
      if (this.defaultSearchGroup) {
        if (search.groups) {
          search.groups.unshift(this.defaultSearchGroup);
        } else {
          search.groups = [this.defaultSearchGroup];
        }
      }
      this.searchResultComponent.loadPage(0, search);
      this.readSearchSetSubmit.emit(search);
    }
    /**
     * Submit multiple selection.
     */
    submitSelection() {
      this.selectedOptions = this.searchResultComponent.selectedOptions.slice(0);
      console.log('HisSearchFormResultComponent.submitSelection(): Submit multi-selection:', this.selectedOptions);
      this.selectionSubmited.emit(this.selectedOptions);
    }
    /**
     * Submit single selection.
     */
    submitSingleSelection(selection) {
      console.log('HisSearchFormResultComponent.submitSingleSelection(): Submit single-selection:', selection);
      this.selectedOptions = [selection];
      this.selectionSubmited.emit(this.selectedOptions);
    }
    /**
     * Cancel button pressed -> forget the search result selection, just pass the event.
     */
    cancelSelection() {
      this.selectionCanceled.emit();
    }
    toggleTableFilter(toggle) {
      this.toggleFilter = toggle;
    }
    onFinishedInitialLoad() {
      // Das Timeout ist hier notwendig, damit erst dann gescrolled wird, wenn alle Oberflächenkomponenten fertig geladen sind
      if (this.scrollToResultAfterSearch) {
        setTimeout(() => {
          this.searchFormComponent.scrollToResult();
        }, 1);
      }
      this.finishedInitialLoad.emit();
    }
    onFormTitleLoaded(title) {
      this.formTitleLoaded.emit(title);
    }
    static {
      this.ɵfac = function HisSearchFormResultComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchFormResultComponentBase)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchFormResultComponentBase,
        viewQuery: function HisSearchFormResultComponentBase_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$G, 7);
            i0.ɵɵviewQuery(_c1$c, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchFormComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchResultComponent = _t.first);
          }
        },
        inputs: {
          selectionSetting: "selectionSetting",
          renderTitle: "renderTitle",
          renderCustomBottomResultButtons: "renderCustomBottomResultButtons",
          scrollToResultAfterSearch: "scrollToResultAfterSearch",
          searchConfigFile: "searchConfigFile",
          selectedOptions: "selectedOptions",
          selectedOptionsIdColumn: "selectedOptionsIdColumn",
          selectedOptionsLabelColumn: "selectedOptionsLabelColumn",
          isSearchPopup: "isSearchPopup",
          resultRowsPerPage: "resultRowsPerPage",
          presetInputFields: "presetInputFields",
          resultTableStyle: "resultTableStyle",
          hisIcon: "hisIcon",
          customResultRowsTemplate: "customResultRowsTemplate",
          showTableFilter: "showTableFilter",
          defaultSearchGroup: "defaultSearchGroup",
          hiddenSearchCriteriaPaths: "hiddenSearchCriteriaPaths",
          genericSearchRowTooltipId: "genericSearchRowTooltipId",
          searchShowPrintviewButton: "searchShowPrintviewButton",
          hierarchyLevel: "hierarchyLevel"
        },
        outputs: {
          selectionSubmited: "selectionSubmited",
          selectionCanceled: "selectionCanceled",
          readSearchSetSubmit: "readSearchSetSubmit",
          finishedInitialLoad: "finishedInitialLoad",
          formTitleLoaded: "formTitleLoaded"
        }
      });
    }
  }
  return HisSearchFormResultComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchFormWidgetComponentBase = /*#__PURE__*/(() => {
  class HisSearchFormWidgetComponentBase {
    constructor() {
      this.isFirstInputElement = false;
    }
    get isValid() {
      return this.form.controls[this.widget.id].valid;
    }
    /**
     * Called if any input field except a checkbox has been changed.
     *
     * @param value new input field value
     */
    setValue(value) {
      // Make formgroup model and view model consistent
      console.log('Update value of widget', this.widget.id, ': old value =', this.widget.value, ', form value =', this.form.value[this.widget.id], 'new value =', value);
      if (this.widget instanceof HisSearchSelectWidget || this.widget instanceof HisTreeSelectWidget || this.widget instanceof HisMultiSelectWidget) {
        this.widget.value = value;
        this.form.value[this.widget.id] = value;
      } else {
        // this.widget.value is already up-to-date
        //assert.strictEqual( this.widget.value, value, 'this.widget.value does not equal new value !' );
        // TODO falls equivalent, auskommentiertes assert und Import löschen
        if (this.widget.value === value) {
          this.form.value[this.widget.id] = value;
        } else {
          throw new Error('this.widget.value ' + this.widget.value + ' does not equal new value ' + value + '!');
        }
      }
      // mark the widget as dirty
      this.form.controls[this.widget.id].markAsDirty();
    }
    /**
     * Called by selecting/deselecting a checkbox.
     *
     * @param $event event
     */
    setOptionValue($event) {
      let widget = this.widget;
      // this.widget.value has already been updated.
      // So all we have to do here is to keep the form.value consistent:
      let option = widget.value ? widget.option : null;
      console.log('Set value of checkbox widget', widget.id, 'to', widget.value, '-> select option', option);
      this.form.value[widget.id] = option;
      // mark the widget as dirty
      this.form.controls[this.widget.id].markAsDirty();
    }
    static {
      this.ɵfac = function HisSearchFormWidgetComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchFormWidgetComponentBase)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchFormWidgetComponentBase,
        inputs: {
          widget: "widget",
          form: "form",
          showErrors: "showErrors",
          isFirstInputElement: "isFirstInputElement"
        }
      });
    }
  }
  return HisSearchFormWidgetComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * userprofile REST service invocations.
 */
let HisUserProfileService = /*#__PURE__*/(() => {
  class HisUserProfileService {
    constructor() {
      this.backendService = inject(HisBackendService);
      this.cache = new Map();
      this.userProfileSubject = new ReplaySubject(1);
      this.userProfile = {};
    }
    /**
     * Loads the entire userprofile if it has not been loaded yet and stores it.
     * Returns the userprofile in an Observable that immediately delivers the stored data
     * to new subscribers.
     */
    preloadUserProfile() {
      if (Object.keys(this.userProfile).length > 0) {
        // Early return if userprofile has already been loaded
        return this.userProfileSubject.asObservable();
      }
      if (!this.preloadUserProfileObservable) {
        // Fetch entire userprofile from backend only if not already in progress
        this.preloadUserProfileObservable = this.backendService.getData('api/v1/cs/sys/userprofile/').pipe(tap(profile => {
          this.userProfile = profile;
          this.userProfileSubject.next(this.userProfile);
          // Reset the observable reference after the data is loaded
          this.preloadUserProfileObservable = undefined;
        }));
      }
      // Return the observable that is in progress or already completed
      return this.preloadUserProfileObservable;
    }
    /**
     * Gets a single userprofile setting.
     * First, it will try to retrieve it from preloaded userprofile.
     * As a fallback, it will download a single userprofile setting via GET request.
     */
    getValueforKey(key) {
      // a quick hack to prevent lots of repeated requests for the same key by the GenericSearch implementation
      let cached = this.cache.get(key);
      if (cached) {
        return cached;
      }
      // Retrieve key from preloaded userprofile
      if (this.userProfile[key]) {
        return new Observable(observer => {
          observer.next(this.userProfile[key]);
          observer.complete();
        });
        // Fallback in case of preloaded userprofile is null or undefined
      } else {
        // Download via GET request
        let subject = new ReplaySubject(1);
        // The trailing slash prevents Spring from interpreting the last dot as a
        // extension separator (e. g. .../cs.sys.bar => "bar is not a known file format")
        this.backendService.getData(`api/v1/cs/sys/userprofile/${key}/`).subscribe(value => {
          subject.next(value);
          subject.complete();
        });
        this.cache.set(key, subject);
        return subject;
      }
    }
    setNewValue(aKey, aValue, aDefaultValue) {
      let cached = this.cache.get(aKey);
      if (cached) {
        this.cache.delete(aKey);
      }
      let data = {
        key: aKey,
        value: aValue,
        defaultValue: aDefaultValue
      };
      return this.backendService.postData('api/v1/cs/sys/userprofile/', data).pipe(
      // currently the return value is just "Value set in userprofile"
      tap(() => {
        this.userProfile[aKey] = aValue;
        this.userProfileSubject.next(this.userProfile);
      }));
    }
    delete(aKey) {
      return this.setNewValue(aKey, null, null);
    }
    static {
      this.ɵfac = function HisUserProfileService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUserProfileService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisUserProfileService,
        factory: HisUserProfileService.ɵfac
      });
    }
  }
  return HisUserProfileService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisSearchItem {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}

/**
 * Parser zum Codieren und dekodieren des eines Objekts {@linkcode HisSearch},
 * dass die Parameter als flat Object für die Suche in der URL übergibt.
 *
 * WICHITG: Die indexe grops1.criteria0 beschreiben nicht die Position der Elemente in der Scuhkonfigurationsdatei,
 * sondern guppieren lediglich zusammengehöriges.
 */
class HisSearchParser {
  /**
   * Encodes the HisSearch
   *
   * @returns an array of HisSearchItem
   */
  static encode(search) {
    let searchItems = [];
    searchItems.push(new HisSearchItem(HisSearchConstants.SEARCH_CONFIG_FILE, search.configFile));
    for (let group of search.groups) {
      let groupWithIndex = HisSearchConstants.GROUPS + search.groups.indexOf(group) + '.';
      searchItems.push(new HisSearchItem(groupWithIndex + HisSearchConstants.GROUP_LABEL, group.groupLabel));
      console.log('his-search-parser#encode() #criteriaGroupAnd', group.criteriaGroupAnd);
      if (group.criteriaGroupAnd === true) {
        searchItems.push(new HisSearchItem(groupWithIndex + HisSearchConstants.CRITERIA_GROUP_AND, 'true'));
      }
      if (group.criteriaGroupAnd === false) {
        searchItems.push(new HisSearchItem(groupWithIndex + HisSearchConstants.CRITERIA_GROUP_AND, 'false'));
      }
      if (group.criteria) {
        for (let criteria of group.criteria) {
          let criteriaWithIndex = groupWithIndex + HisSearchConstants.CRITERIA + group.criteria.indexOf(criteria) + '.';
          //                    outcommented because of Hiszilla #245049
          //                    if (!criteria.value ) {
          //                        continue;
          //                    }
          searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.FIELD, criteria.field));
          searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.VALUE, criteria.value));
          if (criteria.not) {
            searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.NOT, String(criteria.not)));
          }
          if (criteria.operator) {
            searchItems.push(new HisSearchItem(criteriaWithIndex + HisSearchConstants.OPERATOR, criteria.operator));
          }
        }
      }
      if (group.criteriaGroups) {
        for (let criteriaGroup of group.criteriaGroups) {
          let criteriaGroupWithIndex = groupWithIndex + HisSearchConstants.CRITERIA_GROUPS + group.criteriaGroups.indexOf(criteriaGroup) + '.';
          if (criteriaGroup.excluding) {
            searchItems.push(new HisSearchItem(criteriaGroupWithIndex + HisSearchConstants.EXCLUDING, String(criteriaGroup.excluding)));
          }
          for (let criteria of criteriaGroup.criteria) {
            let criteriaGroupCriteriaWithIndex = criteriaGroupWithIndex + HisSearchConstants.CRITERIA + criteriaGroup.criteria.indexOf(criteria) + '.';
            if (!criteria.value) {
              continue;
            }
            searchItems.push(new HisSearchItem(criteriaGroupCriteriaWithIndex + HisSearchConstants.FIELD, criteria.field));
            searchItems.push(new HisSearchItem(criteriaGroupCriteriaWithIndex + HisSearchConstants.VALUE, criteria.value));
            if (criteria.not) {
              searchItems.push(new HisSearchItem(criteriaGroupCriteriaWithIndex + HisSearchConstants.NOT, String(criteria.not)));
            }
            if (criteria.operator) {
              searchItems.push(new HisSearchItem(criteriaGroupCriteriaWithIndex + HisSearchConstants.OPERATOR, criteria.operator));
            }
          }
        }
      }
    }
    return searchItems;
  }
  /**
   * Decodes an array of HisSearchItem
   *
   * @param hisSearchItems an array of HisSearchItem
   *
   * @returns a new instance of HisSearch
   */
  static decode(hisSearchItems) {
    let searchItems = this.filterKeys(hisSearchItems);
    let search = new HisSearch();
    search.configFile = this.getValueForKey(HisSearchConstants.SEARCH_CONFIG_FILE, undefined, searchItems);
    let groupsWithIndex = this.getGroupIndexes(searchItems);
    for (let groupIndex of groupsWithIndex) {
      let groupPrefixWithIndex = HisSearchConstants.GROUPS + groupIndex;
      let groupItems = searchItems.filter(item => item.key.startsWith(groupPrefixWithIndex));
      let group = new HisSearchGroup$1();
      group.groupLabel = this.addGroupLabel(groupPrefixWithIndex, groupItems);
      group.criteriaGroupAnd = this.addGroupConcatedWithAND(groupPrefixWithIndex, groupItems);
      let criteriaItems = this.getCriteriaItemsForGroup(groupPrefixWithIndex, groupItems);
      let searchCriteria = this.getSearchCriteria(groupPrefixWithIndex, criteriaItems);
      for (let criterion of searchCriteria) {
        // console.log('searchCriterion', searchCriterion);
        group.criteria.push(criterion);
      }
      this.addCriteriaGroupItems(groupPrefixWithIndex, groupItems, group);
      search.groups.push(group);
    }
    return search;
  }
  /**
   * Filters the duplicate searchItem keys and searchItems without values
   *
   * @returns an array of filtered HisSearchItem
   */
  static filterKeys(searchItems) {
    let filteredSearchItems = [];
    let keyUnifierMap = new Map();
    for (let item of searchItems) {
      if (item.value) {
        keyUnifierMap.set(item.key, item.value);
      }
    }
    for (let key of keyUnifierMap.keys()) {
      filteredSearchItems.push(new HisSearchItem(key, keyUnifierMap.get(key)));
    }
    return filteredSearchItems;
  }
  /**
   * Adds the criteriaGroup items to the group
   *
   * @param groupPrefixWithIndex the prefix of the group with the index, e. g. group[0]
   * @param groupItems the hisSearchItems of this group, e. g. for the group[0]
   * @param group the searchGroup to which the values are added
   * TODO do not hand over params that are gonna chaned (here group), return the values for these params
   */
  static addCriteriaGroupItems(groupPrefixWithIndex, groupItems, group) {
    let criteriaGroupPrefixes = this.getIndexesOfType(groupPrefixWithIndex, HisSearchConstants.CRITERIA_GROUPS, groupItems);
    group.criteriaGroups = [];
    for (let criteriaGroupIndex of criteriaGroupPrefixes) {
      // criteriaGroupPrefix = group[0].criteriaGroup[0]
      let criteriaGroupWithIndex = groupPrefixWithIndex + '.' + HisSearchConstants.CRITERIA_GROUPS + criteriaGroupIndex;
      // console.log('criteriaGroupWithIndex', criteriaGroupWithIndex);
      let newCriteriGroup = new HisSearchCriteriaGroup();
      let excluding = groupItems.find(item => item.key.startsWith(criteriaGroupWithIndex + '.' + HisSearchConstants.EXCLUDING));
      if (excluding) {
        if (excluding.value === 'true') {
          newCriteriGroup.excluding = true;
        } else {
          newCriteriGroup.excluding = false;
        }
      }
      // add criteriaGroup criteria
      let searchCriteria = this.getSearchCriteria(criteriaGroupWithIndex, groupItems);
      for (let searchCriterion of searchCriteria) {
        newCriteriGroup.criteria.push(searchCriterion);
      }
      group.criteriaGroups.push(newCriteriGroup);
    }
  }
  /**
   * Gets the indexes of the type. E. g. type= CRITERIA, the indexes are maybe criteria[0], criteria[1], criteria[2]
   * so the returned indexes are 0,1,2
   *
   * @param prefixWithIndex e. g. group[0]
   * @param type one of both CRITERIA or CRITERIA_GROUPS
   * @param searchItems an array of {@linkcode HisSearchItem}
   * <ul>
   * <li> groups[0].criteria[0].field </li>
   * <li> groups[0].criteriaGroups[1] </li>
   * <li> groups[0].criteriaGroups[0].criteria[0]</li>
   * </ul>
   *
   * @returns a {@linkcode Set} of numbers
   * <ul>
   * <li> if prefixWithIndex=groups[0], type=CRITERIA, then groups[0].criteria[0], groups[0].criteria[1],
   *      etc. returned value will be 0,1</li>
   * <li> if prefixWithIndex=groups[0], type=CRITERIA_GROUPS, then groups[0].criteriaGroups[0], groups[0]
   *      .criteriaGroups[1], etc. returned value will be 0,1</li>
   * <li> if prefixWithIndex=groups[0].criteriaGroups[0], type=CRITERIA, then groups[0].criteriaGroups[0]
   *      .criteria[0], etc. returned value will be 0</li>
   * </ul>
   */
  static getIndexesOfType(prefixWithIndex, type, searchItems) {
    // console.log('his-search-parser#getIndexesOfType#searchItems', searchItems);
    if (!type) {
      return new Set();
    }
    if (type !== HisSearchConstants.CRITERIA && type !== HisSearchConstants.CRITERIA_GROUPS) {
      return new Set();
    }
    let indexes = new Set();
    for (let item of searchItems) {
      if (!item.key.startsWith(prefixWithIndex)) {
        continue;
      }
      // Beispiele:
      // groups0.criteria1.field
      // groups0.criteriaGroups1.criteria1.field
      let itemKeyWithoutPrefix = item.key.replace(prefixWithIndex + '.', '');
      // console.log('his-search-parser#getIndexesOfType#itemKeyWithoutPrefix', itemKeyWithoutPrefix);
      // itemKeyWithoutPrefix soll nun criteriaGroups1.criteria1.field
      // Ziffer ermitteln aus z. B.
      // Beispiele:
      // criteria1.field
      // criteriaGroups1.criteria1.field
      if (type === HisSearchConstants.CRITERIA_GROUPS && itemKeyWithoutPrefix.startsWith(HisSearchConstants.CRITERIA_GROUPS)) {
        indexes.add(this.extractIndex(itemKeyWithoutPrefix, type));
        continue;
      } else if (type === HisSearchConstants.CRITERIA && !itemKeyWithoutPrefix.startsWith(HisSearchConstants.CRITERIA_GROUPS)) {
        // itemKeyWithoutPrefix.startsWith(HisSearchConstants.CRITERIA)
        indexes.add(this.extractIndex(itemKeyWithoutPrefix, type));
      }
    }
    return indexes;
  }
  static extractIndex(itemKeyWithoutPrefix, type) {
    let elementWithIndex = itemKeyWithoutPrefix.substring(0, itemKeyWithoutPrefix.indexOf('.'));
    let index = elementWithIndex.replace(type, '');
    //        console.log('his-search-parser#extractIndex#itemKeyWithoutPrefix', itemKeyWithoutPrefix);
    console.log('his-search-parser#extractIndex', '#itemKeyWithoutPrefix', itemKeyWithoutPrefix, '#type', type, '#index', index);
    return +index;
  }
  static getCriteriaItemsForIndex(criteriaWithIndex, searchItems) {
    let criteriaItems = [];
    for (let searchItem of searchItems) {
      if (searchItem.key.startsWith(criteriaWithIndex)) {
        criteriaItems.push(searchItem);
      }
    }
    return criteriaItems;
  }
  /**
   * Gets the search criteria for the prefixWithIndex
   *
   * @param prefixWithIndex E. g. groups[0] or groups[0].criteriaGroups[0]
   * @param criteriaItems the item from which to select the searchItems
   *
   * @returns an array of HisSearchCriteria with the criteria for the prefixWithIndex
   */
  static getSearchCriteria(prefixWithIndex, criteriaItems) {
    let criteriaIndexes = this.getIndexesOfType(prefixWithIndex, HisSearchConstants.CRITERIA, criteriaItems);
    let searchCriteria = [];
    for (let index of criteriaIndexes) {
      let criteriaWithIndex = prefixWithIndex + '.' + HisSearchConstants.CRITERIA + index;
      let criteria = this.getCriteriaItemsForIndex(criteriaWithIndex, criteriaItems);
      let searchCriterion = new HisSearchCriteria$1();
      let field = criteria.find(item => item.key.endsWith(HisSearchConstants.FIELD));
      if (field) {
        searchCriterion.field = field.value;
      }
      let value = criteria.find(item => item.key.endsWith(HisSearchConstants.VALUE));
      if (value) {
        searchCriterion.value = value.value;
      }
      let not = criteria.find(item => item.key.endsWith(HisSearchConstants.NOT));
      if (not) {
        if (not.value === 'true') {
          searchCriterion.not = true;
        } else {
          searchCriterion.not = false;
        }
      }
      let operator = criteria.find(item => item.key.endsWith(HisSearchConstants.OPERATOR));
      if (operator) {
        if (operator.value === '=') {
          searchCriterion.operator = HisSearchCriteriaOperator.EQ;
        }
        if (operator.value === '<>') {
          searchCriterion.operator = HisSearchCriteriaOperator.NE;
        }
        if (operator.value === '>') {
          searchCriterion.operator = HisSearchCriteriaOperator.GT;
        }
        if (operator.value === '<') {
          searchCriterion.operator = HisSearchCriteriaOperator.LT;
        }
      }
      searchCriteria.push(searchCriterion);
    }
    return searchCriteria;
  }
  /**
   * @param searchItems the searchItems from which to select the criteria items
   * @param groupPrefixWithIndex the group prefix with the index
   *
   * @returns an array of HisSearchItem with the criteria items for the group
   */
  static getCriteriaItemsForGroup(groupPrefixWithIndex, searchItems) {
    let criteriaItems = [];
    for (let searchItem of searchItems) {
      if (searchItem.key.startsWith(groupPrefixWithIndex + '.' + HisSearchConstants.CRITERIA)) {
        criteriaItems.push(searchItem);
      }
    }
    return criteriaItems;
  }
  /**
   * Adds the group label
   */
  static addGroupLabel(groupWithIndex, sortedGroupItems) {
    let labelKey = groupWithIndex + '.' + HisSearchConstants.GROUP_LABEL;
    let labelItem = this.findItemWithKey(labelKey, sortedGroupItems);
    // console.log('labelItem', labelKey, labelItem);
    if (labelItem) {
      return labelItem.value;
    }
    return undefined;
  }
  /**
   * Adds the value for group.and that shows in case of two or more groups
   * if they are concated with AND or wirth OR
   */
  static addGroupConcatedWithAND(groupWithIndex, sortedGroupItems) {
    let andKey = groupWithIndex + '.' + HisSearchConstants.CRITERIA_GROUP_AND;
    let andItem = this.findItemWithKey(andKey, sortedGroupItems);
    console.log('his-search-parser#addGroupConcatedWithAND() #andItem', andItem);
    if (andItem) {
      if (andItem.value === 'true') {
        return true;
      }
      if (andItem.value === 'false') {
        return false;
      }
    }
    return undefined;
  }
  /**
   * @param key a key like groups[0].label, groups[0].and
   * @param searchItems the searchItems from which to select the items
   *
   * @returns an array of HisSearchItem with the item of the key
   */
  static findItemWithKey(key, items) {
    for (let item of items) {
      if (item.key === key) {
        return item;
      }
    }
    return undefined;
  }
  static getValueForKey(key, defaultValue, searchItems) {
    for (let searchItem of searchItems) {
      if (searchItem.key.startsWith(key)) {
        return searchItem.value;
      }
    }
    return defaultValue;
  }
  /**
   * Extracts, on base of group.label, the indexes of the existing groups
   *
   * @returns an array with the indexes of the existing groups
   */
  static getGroupIndexes(searchItems) {
    let groupIndexes = [];
    for (let searchItem of searchItems) {
      // Annahme: jede Gruppe hat ein Label
      if (searchItem.key.endsWith('.' + HisSearchConstants.GROUP_LABEL)) {
        let index = searchItem.key.replace(HisSearchConstants.GROUPS, '').replace('.' + HisSearchConstants.GROUP_LABEL, '');
        console.log('his-search-parser#getGroupIndexes', '#index', index);
        groupIndexes.push(Number(index));
      }
    }
    return groupIndexes;
  }
}

/** Enum with url non criteria url params */
var HisSearchNonCriteriaUrlParam = /*#__PURE__*/function (HisSearchNonCriteriaUrlParam) {
  HisSearchNonCriteriaUrlParam["CONFIG_FILE"] = "configFile";
  HisSearchNonCriteriaUrlParam["PAGE_TITLE"] = "pageTitle";
  HisSearchNonCriteriaUrlParam["TABLE_TITLE"] = "tableTitle";
  HisSearchNonCriteriaUrlParam["IS_NO_SEARCH_ACTIVE"] = "isNotActiveSearch";
  HisSearchNonCriteriaUrlParam["SHOW_CHANGE_SEARCH_BUTTON"] = "showChangeSearchButton";
  HisSearchNonCriteriaUrlParam["SHOW_SEARCH_BUTTON"] = "showSearchButton";
  HisSearchNonCriteriaUrlParam["SHOW_BACK_BUTTON"] = "showBackButton";
  HisSearchNonCriteriaUrlParam["PAGE"] = "page";
  // blacklisted keys are ignored, see #192323, #212551, #249099
  HisSearchNonCriteriaUrlParam["NO_DB_ACTION"] = "noDBAction";
  HisSearchNonCriteriaUrlParam["INIT"] = "init";
  HisSearchNonCriteriaUrlParam["CHOC"] = "chco";
  HisSearchNonCriteriaUrlParam["EXTENDED"] = "extended";
  HisSearchNonCriteriaUrlParam["MODE"] = "mode";
  HisSearchNonCriteriaUrlParam["RECORD_REQUEST"] = "recordRequest";
  HisSearchNonCriteriaUrlParam["NAVIGATION_POSITION"] = "navigationPosition";
  return HisSearchNonCriteriaUrlParam;
}(HisSearchNonCriteriaUrlParam || {});
class HisSearchParserHelper {
  static createNewHisSearchByWidgetValues(widgetGroups, configFile) {
    // let logMessageId = 'his-search-parser-helper#createNewHisSearchByWidgetValues()';
    // console.log(logMessageId + '#widgetGroups', widgetGroups);
    let search = new HisSearch();
    search.configFile = configFile;
    for (let group of widgetGroups) {
      let searchGroup = new HisSearchGroup$1();
      searchGroup.groupLabel = group.label;
      for (let widget of group.widgets) {
        // isEmptyArray macht hier noch Prüfung auf isArray
        if (widget.value && !HisArrayUtils.isEmptyArray(widget.value) || widget instanceof HisWidgetBaseSelect && widget.not) {
          // console.log(logMessageId + '#widget at search form', widget);
          let criterion = this.createNewSearchCriteria(widget, widget.id);
          searchGroup.criteria.push(criterion);
        }
      }
      for (let criteriaGroup of group.criteriaGroups) {
        let searchCriteriaGroup = new HisSearchCriteriaGroup();
        searchCriteriaGroup.excluding = criteriaGroup.notInCriteriaGroup;
        for (let widget of criteriaGroup.widgets) {
          // isEmptyArray macht hier noch Prüfung auf isArray
          if (widget.value && !HisArrayUtils.isEmptyArray(widget.value)) {
            console.log('his-search-parser-helper#createNewHisSearchByWidgetValues()', '#widget at criteria group', widget);
            let path = widget.id.substring(widget.id.indexOf(']') + 1);
            let criterion = this.createNewSearchCriteria(widget, path);
            searchCriteriaGroup.criteria.push(criterion);
          }
        }
        if (searchCriteriaGroup.criteria.length > 0) {
          searchGroup.criteriaGroups.push(searchCriteriaGroup);
        }
      }
      if (searchGroup.criteria.length > 0 || searchGroup.criteriaGroups.length > 0) {
        search.groups.push(searchGroup);
      }
      if (searchGroup.criteriaGroups.length > 1) {
        console.log('his-search-parser-helper#createNewHisSearchByWidgetValues()', '#group.combineCriteriaGroupsByOr', group.combineCriteriaGroupsByOr);
        searchGroup.criteriaGroupAnd = !group.combineCriteriaGroupsByOr;
      }
    }
    return search;
  }
  static createNewSearchCriteria(widget, key) {
    let criterion = new HisSearchCriteria$1();
    let path = key ? key : widget.id;
    criterion.field = path;
    console.log('his-search-parser-helper#createNewSearchCriteria() #widget', widget);
    // Checkbox
    if (widget.kind === 'checkbox') {
      let optionWidget = widget;
      console.log('his-search-parser-helper#createNewSearchCriteria() #optionWidget.option', optionWidget.option);
      criterion.value = this.convertValueToString(path, widget.value, optionWidget.option);
      return criterion;
    }
    if (widget instanceof HisWidgetBaseSelect && widget.not) {
      criterion.not = true;
    }
    if (widget.kind === 'tree-select') {
      // widget.value ist bei trees ein Array mit Objects
      let objectArray = Object.assign([], widget.value);
      let value;
      for (let obj of objectArray) {
        let option = obj;
        console.log('his-search-parser-helper#createNewSearchCriteria() #option', option);
        // Falls das Object versioniert ist
        let val;
        console.log('his-search-parser-helper#createNewSearchCriteria() #path', path);
        if ((path.endsWith('.lid') || path.endsWith('Obj.id')) && option.lid) {
          val = option.lid;
        } else {
          val = option.id;
        }
        if (val) {
          if (option.subTreeSelected) {
            console.log('his-search-parser-helper#createNewSearchCriteria() #subTreeSelected', option.subTreeSelected);
            // Indicate that all children of a tree node shall be added to the select list
            // See also GenericSearchTask.fillSearchCriteriaFromRequestFields(..)
            val += 'x';
            console.log('his-search-parser-helper#createNewSearchCriteria() #val', val);
          }
          if (value) {
            value += val;
          } else {
            value = val;
          }
          value += ',';
          console.log('his-search-parser-helper#createNewSearchCriteria() #value', value);
        }
      }
      criterion.value = value;
      console.log('his-search-parser-helper#createNewSearchCriteria() #criterion #tree', criterion);
      return criterion;
    }
    criterion.value = this.convertValueToString(path, widget.value, null);
    console.log('his-search-parser-helper#createNewSearchCriteria() #criterion', criterion);
    return criterion;
  }
  static convertUrlParamsToHisSearch(queryParams) {
    let items = HisSearchParserHelper.convertFlatObjectFormatParamsToHisSearchItems(queryParams);
    return HisSearchParser.decode(items);
  }
  /**
   * Konvertiert params einer Url im alten Format zu HisSearch.
   * Es wird davon ausgegangen, dass es keine Daten zu einer Gruppe gibt, wesahlb eine 'default' Gruppe abgelegt wird.
   *
   * ACHTUNG: kann nicht mit Kriteriengruppen umgehen, nur verwenden für alte URL Parameter
   */
  static convertOldUrlParamsToHisSearch(queryParams, configFile) {
    let search = new HisSearch();
    search.configFile = configFile;
    let keys = Object.keys(queryParams);
    if (keys.length > 0) {
      let newGroup = new HisSearchGroup$1();
      // FIXME warum wird hier die Defaultgruppe gesetzt?
      newGroup.groupLabel = 'default';
      for (let key of keys) {
        if (this.shouldSkipParamDetection(key)) {
          continue;
        }
        // Checkbox values sollten hier schon den value aus der Suchkofigurationsdatei haben
        let value = this.convertValueToString(key, queryParams[key], null);
        console.log('his-search-parser-helper#convertKeyValueUrlParamsToHisSearch()', 'key', key, '#value', value);
        if (!value) {
          continue;
        }
        let criteria = new HisSearchCriteria$1();
        if (key.endsWith('(NOT)') && value === 'true') {
          criteria.not = true;
          continue;
        }
        criteria.field = this.normalizeKey(key);
        criteria.value = this.normalizeValue(value);
        newGroup.criteria.push(criteria);
      }
      search.groups.push(newGroup);
    }
    return search;
  }
  static normalizeValue(value) {
    if (value.includes('\"')) {
      let valueWithoutQuotes = value.replace('\"', '');
      console.log('his-search-parser-helper#normalizeValue() #replace \"', valueWithoutQuotes);
      return this.normalizeValue(valueWithoutQuotes);
    }
    if (value.includes('[')) {
      let valueWithoutOpenedSquareBracket = value.replace('[', '');
      console.log('his-search-parser-helper#normalizeValue() #replace [', valueWithoutOpenedSquareBracket);
      return this.normalizeValue(valueWithoutOpenedSquareBracket);
    }
    if (value.includes(']')) {
      let valueWithoutClosedSquareBracket = value.replace(']', '');
      console.log('his-search-parser-helper#normalizeValue() #replace ]', valueWithoutClosedSquareBracket);
      return this.normalizeValue(valueWithoutClosedSquareBracket);
    }
    return value;
  }
  static normalizeKey(key) {
    if (key.endsWith('[]')) {
      return key.replace('[]', '');
    }
    return key;
  }
  static shouldSkipParamDetection(key) {
    for (let nonSearchCriteria of Object.values(HisSearchNonCriteriaUrlParam)) {
      if (key === nonSearchCriteria) {
        console.log('his-search-parser-helper#shouldSkipParamDetection()', '#skipped non search criteria key', key);
        return true;
      }
    }
    return false;
  }
  static convertHisSearchToFlatObjectFormatParams(search) {
    if (!search.configFile) {
      throw new Error('his-search-parser-helper#convertHisSearchToFlatObjectFormatParams(): no search.configFile present!');
    }
    let queryParams = {};
    let searchItems = HisSearchParser.encode(search);
    searchItems.push(new HisSearchItem(HisSearchConstants.SEARCH_CONFIG_FILE, search.configFile));
    for (let item of searchItems) {
      queryParams[item.key] = item.value;
    }
    return queryParams;
  }
  static convertFlatObjectFormatParamsToHisSearchItems(params) {
    let items = [];
    for (let key of Object.keys(params)) {
      if (key.startsWith(HisSearchConstants.GROUPS)) {
        let item = new HisSearchItem(key, params[key]);
        items.push(item);
      }
      if (key === HisSearchConstants.SEARCH_CONFIG_FILE) {
        let item = new HisSearchItem(key, params[key]);
        items.push(item);
      }
    }
    return items;
  }
  /**
   * Value kann als String, Number, Array oder Object vorliegen
   * ACHTUNG: bei Checkboxen ist der value=true. Dafür hat eine Checkbox ein option mit dem value aus der Suchkonfiguration,
   * z. B. <>ISNULL oder 0 oder JA. Dieser Wert wird nur dann gesetzt, wenn die Checkbox ausgewählt wird, sonst nicht.
   *
   * @param key key dient nur der Log-Ausgabe
   * @param value the value to convert
   * @param checkboxValue value for the checkbox from the search configuration
   * @returns the value as string
   */
  static convertValueToString(key, value, checkboxValue) {
    // FIXME Vergleiche his-search-criteriagroup.component#widgetValueAsString
    console.log('his-search-parser-helper#convertValueToString() #key', key, '#value', value, '#checkboxValue', checkboxValue);
    if (value === null) {
      return null;
    }
    if (typeof value === 'string') {
      if (HisStringUtils.isBlank(value)) {
        // Blank string is not a valid value
        return null;
      }
      return value;
    }
    if (typeof value === 'boolean' && value === true && checkboxValue) {
      return checkboxValue;
    }
    if (Array.isArray(value)) {
      let objectArray = Object.assign([], value);
      if (objectArray.length === 0) {
        // Empty array is not a valid value
        return null;
      }
      // es ist ein Array mit Objects, also [{}, {}, etc.]
      let values = objectArray.map(obj => obj.id).join(',');
      console.log('his-search-parser-helper#convertValueToString(): object array:', key, values);
      return values;
    } else {
      // Dropdown
      console.log('his-search-parser-helper#convertValueToString(): dropdown', key, value);
      // im Fall von Dropdown ist es ein Object {label: bla, id: 4711}
      let id = 'id';
      return value[id];
    }
  }
  static getCriterionWithPath(path, criteria) {
    // console.log('his-search-parser-helper#getCriterionWithPath() #criteria', criteria);
    for (let criterion of criteria) {
      // console.log('his-search-parser-helper#getCriterionWithPath():', '#path', path);
      // console.log(
      //    'his-search-parser-helper#getCriterionWithPath():',
      //    '#criterion', criterion, 'endsWith(path)', criterion.field.endsWith(path));
      if (criterion.field.endsWith(path)) {
        // console.log('his-search-parser-helper#getCriterionWithPath() #found criterion', criterion);
        return criterion;
      }
    }
    return undefined;
  }
  /**
   * Die Default Gruppe wird angehängt, falls eine Suche ohne Suchkriterien durchgeführt wird.
   * Im Falls der Hinzunahem von Suchkriterien, z. B. durch den Filter, kommt es zu Fehlern mit der "default" Gruppe
   * Diese muss deshalb entfernt werden.
   */
  static removeDefaultGroupFromSearchIfOtherGroupIsPresent(search) {
    console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #search #1', search);
    if (search.groups.length === 0) {
      // nothing to change
      console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent()' + '#search #search.groups.length === 0', search);
      return search;
    }
    if (search.groups.length === 1 && search.groups[0].groupLabel === 'default') {
      // nothing to change
      console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent()' + 'search.groups.length === 1 && search.groups[0].groupLabel === default', search);
      return search;
    }
    let remainigGroups = [];
    for (let group of search.groups) {
      console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #group', group);
      console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #group.groupLabel', group.groupLabel);
      console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() group.groupLabel !== default', group.groupLabel !== 'default');
      if (group.groupLabel !== 'default') {
        remainigGroups.push(group);
        continue;
      }
    }
    search.groups = remainigGroups;
    console.log('his-search-parser-helper#removeDefaultGroupFromSearchIfOtherGroupIsPresent() #search #2', search);
    return search;
  }
}
class HisSearchCriteriaSetRequest {
  constructor(configFile, context, flowName) {
    this.configFile = configFile;
    this.context = context;
    this.flowName = flowName;
  }
}

/**
 * request for search results
 */
class HisSearchRequest {
  constructor(search, offset, limit, sortCriteria) {
    this.sortCriteria = [];
    this.search = search;
    if (offset) {
      this.offset = offset;
      this.limit = limit;
    }
    if (sortCriteria) {
      this.sortCriteria = sortCriteria;
    }
  }
}
class HisSortCriteria {
  constructor(field, ascending) {
    this.ascending = true;
    this.field = field;
    this.ascending = ascending;
  }
}
class HisSortOrder {}
let HisSearchResultColumnSortHelper = /*#__PURE__*/(() => {
  class HisSearchResultColumnSortHelper {
    static {
      this.SPEPERATOR = '_';
    }
    static {
      this.sortCriteria = [];
    }
    static {
      this.safedSortCriteria = [];
    }
    /**
     * Sorts a HisSortOrder list of objects according to the attribute order.
     *
     * @param columnSortOrder Object list from type HisSortOrder.
     * @returns sorted columnSortOrder list.
     */
    static sortColumSortOrder(columnSortOrder) {
      columnSortOrder.sort((a, b) => {
        return a.order - b.order;
      });
      return columnSortOrder;
    }
    /**
     * Converts sortOrder value from -1 to 0 else to 1.
     *
     * @param sortOrder sortOrder
     * @returns converted sortOrder
     */
    static convert(sortOrder) {
      return sortOrder === -1 ? 0 : 1;
    }
    /**
     * Removes all session storage keys that are stored to load the sortorder
     */
    static removeAllSessionStorageKeysContainingSortOrder() {
      let sessionStorageObjekts = Object.keys(sessionStorage);
      //Loads all keys from the session storage and deletes those that were stored for loading the sortorder
      for (let key of sessionStorageObjekts) {
        if (key.startsWith(HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER)) {
          sessionStorage.removeItem(key);
        }
      }
    }
    /**
     * Filters out all session storage keys that have nothing to
     * do with the sorting and creates a sorted list, sorted by the column order.
     *
     * @returns an sorted list of session keys.
     */
    static getSortedSortOrderKeyFromSessionStorage() {
      let sessionStorageKeys = Object.keys(sessionStorage);
      let columnSortedSortOrder = [];
      let columnSortOrder = [];
      for (let key of sessionStorageKeys) {
        if (key.startsWith(HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER)) {
          let value = sessionStorage.getItem(key);
          let values = value.split(HisSearchResultColumnSortHelper.SPEPERATOR);
          let columnSort = new HisSortOrder();
          columnSort.key = key;
          columnSort.value = values[0];
          columnSort.order = Number(values[1]);
          columnSortOrder.push(columnSort);
        }
      }
      columnSortedSortOrder = this.sortColumSortOrder(columnSortOrder);
      return columnSortedSortOrder;
    }
    /**
     * Creates a sortCriteria from a HisSortOrder object.
     *
     * @param columnSortedSortOrder HisSortOrder object to tranfer into sortCriteria.
     */
    static createSortCriteriaBySessionStorageValues(columnSortedSortOrder) {
      for (let sortEntity of columnSortedSortOrder) {
        let startIndex = HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER.length + 1;
        let endIndex = sortEntity.key.length;
        let colField = sortEntity.key.substring(startIndex, endIndex);
        let ascending = sortEntity.value === '1';
        let sortCriterion = new HisSortCriteria(colField, ascending);
        console.log('his-search-result.component#createSortCriteriaBySessionSotorageValues(): #sortCriterion:', sortCriterion);
        this.sortCriteria.push(sortCriterion);
      }
    }
    /**
     * Saving a sortCriteria in a variable for later reading out.
     *
     * @param sortCriteria sortCritia to store in variable.
     */
    static setSafedSortCriteria(sortCriteria) {
      HisSearchResultColumnSortHelper.safedSortCriteria = sortCriteria;
    }
    /**
     * Loads stored sortCriteria from variable sortCriteriaToLoadInTableFilter for later readout.
     *
     *@returns stored sortCriteria
     */
    static getSafedSortCriteria() {
      return HisSearchResultColumnSortHelper.safedSortCriteria;
    }
  }
  return HisSearchResultColumnSortHelper;
})();
let HisSearchCriteriaSetService = /*#__PURE__*/(() => {
  class HisSearchCriteriaSetService {
    constructor() {
      this.backendService = inject(HisBackendService);
    }
    getSearchCriteriaSets(searchCriteriaSetRequest) {
      return this.backendService.postData('api/v1/cs/sys/genericSearch/getSearchCriteriaSets', searchCriteriaSetRequest);
    }
    // das ist die neue Methode die ein his-search zurück gibt
    loadCriteriaSet(searchCriteriaSetId) {
      return this.backendService.getData('api/v1/cs/sys/genericSearch/loadCriteriaSet/' + searchCriteriaSetId);
    }
    saveSearchCriteriaSet(searchCriteriaSet) {
      if (searchCriteriaSet.id) {
        this.searchCriteriaSet$ = this.backendService.putData(`api/v1/cs/sys/genericSearch/updateSearchCriteriaSet/${searchCriteriaSet.id}`, searchCriteriaSet);
      } else {
        this.searchCriteriaSet$ = this.backendService.postData('api/v1/cs/sys/genericSearch/saveSearchCriteriaSet', searchCriteriaSet);
      }
      return this.searchCriteriaSet$;
    }
    updateSearchCriteriaSet(searchCriteriaSet) {
      return this.backendService.putData(`api/v1/cs/sys/genericSearch/updateSearchCriteriaSet/${searchCriteriaSet.id}`, searchCriteriaSet);
    }
    /**
     * Delete a search criteria set.
     *
     * @return Observable( 1 if delete was successful )
     */
    deleteSearchCriteriaSet(searchCriteriaSetId) {
      return this.backendService.delete(`api/v1/cs/sys/genericSearch/deleteSearchCriteriaSet/${searchCriteriaSetId}`);
    }
    static {
      this.ɵfac = function HisSearchCriteriaSetService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchCriteriaSetService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSearchCriteriaSetService,
        factory: HisSearchCriteriaSetService.ɵfac
      });
    }
  }
  return HisSearchCriteriaSetService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Class to hold values of {@link HisSelectOperatorType} and {@code widget.kind}
 * to use as params at the {@link HisSearchService.setOperator( operatorTrigger: HisOperatorTrigger )}
 */
class HisOperatorTrigger {
  constructor(operator, widget) {
    this.operator = operator;
    this.widget = widget;
  }
  getOperator() {
    return this.operator;
  }
  getWidget() {
    return this.widget;
  }
}

/**
 * Enum to hold operators for all search select fields
 */
var HisSelectOperatorType = /*#__PURE__*/function (HisSelectOperatorType) {
  HisSelectOperatorType["EQUAL"] = "=";
  HisSelectOperatorType["UNEQUAL"] = "\u2260";
  return HisSelectOperatorType;
}(HisSelectOperatorType || {});
class OptionByIdRequest {
  constructor(selectFrom, optionIds) {
    this.selectFrom = selectFrom;
    this.optionIds = optionIds;
  }
}
class HisSearchFormData {
  constructor(widgetService, searchService, uiService) {
    this.widgetService = widgetService;
    this.searchService = searchService;
    this.uiService = uiService;
    this.groupIdsToShowExtendedCriteriaBySearchSet = [];
    this.widgetIdsToShowExtendedCriteriaBySearchSet = [];
  }
  getSearchConfiguration() {
    return this.searchConfiguration;
  }
  copyWidgetsFromGroupAndCreateCriteriaGroup(searchGroup, doLoadLazyWidgets = true) {
    for (let searchCriteriaGroup of searchGroup.criteriaGroups) {
      console.log('CriteriaGroup #searchCriteriaGroup', searchCriteriaGroup);
      let originalWidgetGroup = HisWidgetUtils.getWidgetGroupWithLabel(searchGroup.groupLabel, this.widgetGroups);
      console.log('CriteriaGroup #originalWidgetGroup', originalWidgetGroup);
      if (!originalWidgetGroup) {
        // FEHLER
        continue;
      }
      let combineCriteriaGroupsByOr = searchGroup.criteriaGroupAnd ? false : true;
      originalWidgetGroup.combineCriteriaGroupsByOr = combineCriteriaGroupsByOr;
      let groupIndex = String(searchGroup.criteriaGroups.indexOf(searchCriteriaGroup));
      let newSearchCriteriaGroup = new HisSearchCriteriagroup();
      newSearchCriteriaGroup.notInCriteriaGroup = searchCriteriaGroup.excluding ? true : false;
      for (let originalWidget of originalWidgetGroup.widgets) {
        console.log('his-search-form.component#copyWidgetsFromGroupAndCreateCriteriaGroup() #originalWidget', originalWidget);
        // nicht verwirren lassen: in der URL werden keine Klammern verwendet, also auch nicht in den params
        // Es ist die erste kriteriengruppe, deshalb [0]
        let newId = originalWidgetGroup.label + '[' + groupIndex + ']' + originalWidget.id;
        // console.log('his-search-form.component#restoreCriteriaGroupWidgetsForSearchConstraints()', '#newId' , newId);
        let copyOfWidget = this.copyWidget(originalWidget, newId);
        console.log('his-search-form.component#copyWidgetsFromGroupAndCreateCriteriaGroup() #copyOfWidget', copyOfWidget);
        let criterion = HisSearchParserHelper.getCriterionWithPath(originalWidget.id, searchCriteriaGroup.criteria);
        console.log('CriteriaGroup #searchCriteriaGroup', criterion);
        let criteriaGroupWidget = this.createCriteriaGroupWidgetsAndUpdateControl(criterion, copyOfWidget, doLoadLazyWidgets);
        newSearchCriteriaGroup.widgets.push(criteriaGroupWidget);
      }
      console.log('his-search-form.component#copyWidgetsFromGroupAndCreateCriteriaGroup() #newSearchCriteriaGroup', newSearchCriteriaGroup);
      originalWidgetGroup.criteriaGroups.push(newSearchCriteriaGroup);
    }
  }
  copyWidget(original, newId) {
    let copy = this.widgetService.copyWidget(original, newId);
    copy.value = null;
    copy.originalValue = null;
    if (copy instanceof HisWidgetBaseSelect) {
      copy.not = false;
      copy.originalNot = false;
    }
    return copy;
  }
  createCriteriaGroupWidgetsAndUpdateControl(criterion, copyOfWidget, doLoadLazyWidgets = true) {
    if (!criterion || !criterion.value) {
      // Wenn es für ein Widget keine Kriterien gibt, dann die Kopie ohne aktualisierte Werte hinzufügen
      this.addOrUpdateControl(copyOfWidget, undefined);
      return copyOfWidget;
    }
    // Wenn es ein Criterion gibt
    if (copyOfWidget instanceof HisWidgetBaseSelect) {
      this.triggerOperator(criterion.not, copyOfWidget);
      let widgetSelectCopy = this.copyWidgetBaseSelectAndAddToFormControl(copyOfWidget, criterion, doLoadLazyWidgets);
      // this.addOrUpdateControl wird in copyWidgetBaseSelectAndAddToFormControl gemacht
      console.log('createCriteriaGroupWidgetsAndUpdateControl #widgetSelectCopy', widgetSelectCopy);
      return widgetSelectCopy;
    } else if (copyOfWidget instanceof HisOptionWidget) {
      if (criterion.value) {
        // console.log('his-search-form.component#setWidgetGroups() #checkbox value', loadedCriterion.value);
        // console.log('his-search-form.component#setWidgetGroups() #copyOfWidget', copyOfWidget);
        copyOfWidget.option = criterion.value;
        let trueValue = true;
        copyOfWidget.value = trueValue;
        copyOfWidget.originalValue = trueValue;
        this.addOrUpdateControl(copyOfWidget, trueValue);
        return copyOfWidget;
      }
      return undefined;
    } else {
      // Eingabefeld aktualisieren, value: string
      if (copyOfWidget.id !== criterion.value) {
        // console.log('his-search-form.component#setWidgetGroups() #input, date', criterion.value);
        // console.log('his-search-form.component#setWidgetGroups() #copyOfWidget', copyOfWidget);
        copyOfWidget.value = criterion.value;
        copyOfWidget.originalValue = criterion.value;
        this.addOrUpdateControl(copyOfWidget, criterion.value);
        return copyOfWidget;
      }
      return undefined;
    }
  }
  addOrUpdateControl(widget, value) {
    let hasKey = Object.keys(this.form.controls).includes(widget.id);
    if (hasKey) {
      this.form.removeControl(widget.id);
      this.form.addControl(widget.id, new UntypedFormControl(value));
    } else {
      this.form.addControl(widget.id, new UntypedFormControl(value));
    }
  }
  triggerOperator(not, widgetToSet) {
    if (widgetToSet === null) {
      console.warn('HisSearchSaveParams loadedtWidget.value === null');
      return;
    }
    console.log('his-search-save-params triggerOperator loadedtWidget.not', not);
    console.log('his-search-save-params triggerOperator widget.id', widgetToSet.id);
    if (not) {
      let operatorTrigger = new HisOperatorTrigger(HisSelectOperatorType.UNEQUAL, widgetToSet);
      this.searchService.setOperator(operatorTrigger);
      return;
    }
    if (!not) {
      let operatorTrigger = new HisOperatorTrigger(HisSelectOperatorType.EQUAL, widgetToSet);
      this.searchService.setOperator(operatorTrigger);
      return;
    }
  }
  copyWidgetBaseSelectAndAddToFormControl(copyOfWidget, criterion, doLoadLazyWidgets = true) {
    console.log('convertStringToValueType(): #copyOfWidget', copyOfWidget);
    if (criterion && criterion.value === 'ISNULL') {
      console.log('copyWidgetBaseSelectAndAddToFormControl(): #criterion', criterion);
      console.log('copyWidgetBaseSelectAndAddToFormControl(): #copyOfWidget', copyOfWidget);
      const nullValueOption = this.uiService.translate('genericSearch.nullValueMenuEntry');
      let newOption = new HisOption();
      newOption.id = criterion.field;
      newOption.label = nullValueOption;
      if (copyOfWidget.kind === 'dropdown') {
        copyOfWidget.value = newOption;
        copyOfWidget.originalValue = newOption;
        copyOfWidget.not = criterion.not;
        copyOfWidget.originalNot = criterion.not;
        this.addOrUpdateControl(copyOfWidget, 'ISNULL');
      }
      if (copyOfWidget.kind === 'multi-dropdown') {
        copyOfWidget.value.push(newOption);
        copyOfWidget.originalValue.push(newOption);
        copyOfWidget.not = criterion.not;
        copyOfWidget.originalNot = criterion.not;
        this.addOrUpdateControl(copyOfWidget, 'ISNULL');
      }
      return copyOfWidget;
    }
    console.log('his-search-form.component#copyWidgetBaseSelectAndAddToFormControl() #criterion', criterion);
    let isLidSearch = GenericSearchUtil.isLidPath(copyOfWidget.id);
    //if doLoadLAzyWidgets && isLazywidget: skip getWidgetValues
    const isLazySelectWidget = copyOfWidget instanceof HisSelectWidget && GenericSearchUtil.isLazySelectFrom(copyOfWidget.optionsKey, copyOfWidget.showDropdownIcon);
    if (doLoadLazyWidgets || !isLazySelectWidget) {
      copyOfWidget.getWidgetValues(criterion.value, isLidSearch).subscribe(option => {
        if (option && !HisArrayUtils.isEmptyArray(option)) {
          console.log('his-search-form.component#copyWidgetBaseSelectAndAddToFormControl() #option', option);
          copyOfWidget.value = option;
          copyOfWidget.originalValue = Array.isArray(option) ? [...option] : option;
          copyOfWidget.not = criterion.not;
          copyOfWidget.originalNot = criterion.not;
          this.addOrUpdateControl(copyOfWidget, option);
        }
      });
    }
    return copyOfWidget;
  }
  doPresetInputFields(presets) {
    if (this.widgetGroups) {
      for (let widgetGroup of this.widgetGroups) {
        widgetGroup.presetInputFields(presets);
      }
      //handle lazy widgets in a combined rest call
      this.presetLazyInputFields(presets);
    }
  }
  collectLazyWidgets(widgetGroups) {
    const lazyWidgets = [];
    for (let widgetGroup of this.widgetGroups) {
      lazyWidgets.push(...widgetGroup.collectLazyWidgets());
    }
    return lazyWidgets;
  }
  presetLazyInputFields(presets) {
    if (!presets) {
      return;
    }
    const lazyWidgets = this.collectLazyWidgets(this.widgetGroups);
    const optionByIdRequests = [];
    for (let widget of lazyWidgets) {
      let preset;
      if (HisQueryParamUtils.isFlatObjectFormat(presets)) {
        preset = HisWidgetUtils.getPresetForWidget(widget, presets);
      } else {
        preset = presets[widget.id];
      }
      if (!preset) {
        continue;
      }
      // make sure model & view are updated.
      // (see his-widget-select#presetInputFields)
      widget.value = {
        label: null,
        id: null
      };
      if (preset === 'ISNULL' && widget.showNullItem) {
        let isNullOption = new HisOption();
        isNullOption.id = 'ISNULL';
        isNullOption.label = null;
        Object.assign(widget.value, isNullOption);
        widget.value = isNullOption;
        continue;
      }
      optionByIdRequests.push(new OptionByIdRequest(widget.optionsKey, [preset]));
    }
    console.log('presetting lazy select fields via options: ', optionByIdRequests);
    this.searchService.loadOptionsByIds(this.searchConfiguration.configFile, optionByIdRequests).subscribe(result => {
      if (!result) {
        return;
      }
      for (let selectedOption of result) {
        if (!selectedOption || !selectedOption.selectedOptions || selectedOption.selectedOptions.length == 0) {
          continue;
        }
        const matchedWidget = lazyWidgets.find(widget => widget.optionsKey === selectedOption.selectFrom);
        // (see his-widget-select#presetInputFields)
        Object.assign(matchedWidget.value, selectedOption.selectedOptions[0]);
        matchedWidget.value = selectedOption.selectedOptions[0];
      }
    });
  }
}
const _c0$F = ["formSearchButtons"];
let HisSearchFormComponentBase = /*#__PURE__*/(() => {
  class HisSearchFormComponentBase extends HisSearchFormData {
    constructor() {
      const widgetService = inject(HisWidgetService);
      const searchService = inject(HisSearchService);
      const uiService = inject(HisUiService);
      super(widgetService, searchService, uiService);
      this.auth = inject(HisAuthService);
      this.navigationService = inject(HisNavigationService);
      this.notificationService = inject(HisNotificationService);
      this.route = inject(ActivatedRoute);
      this.router = inject(Router);
      this.userProfileService = inject(HisUserProfileService);
      this.searchCriteriaSetService = inject(HisSearchCriteriaSetService);
      this.cdRef = inject(ChangeDetectorRef);
      // true if the rendered page contains both the search form and the search result
      this.isSearchFormResult = false;
      // true if this is a search popup. In that case we don't want to register the url for the "back to search" button.
      this.isSearchPopup = false;
      this.isNestedSearchForm = false;
      this.showFormData = false;
      this.showSearchButton = true;
      this.showLinkToSearchHelp = true;
      // search constraints passed by parent component, like { 'Person.surname': 'Wolf', 'Person.firstname': 'Ulrich' }
      this.presetInputFields = {};
      this.searchShowSearchParamsBox = true;
      this.renderTitle = true;
      // Specifies the heading level for the <his-heading> component.
      this.hierarchyLevel = 1;
      this.searchSubmitted = new EventEmitter();
      this.formTitleLoaded = new EventEmitter();
      // is the search in "extended search" state?
      this.showAllSearchCriteria = false;
      // merged queryParams and presets
      this.allParams = {};
      this.showSearchForm = false;
      this.searchMaskLeftGroupsAmount = 0;
      this.STANDARD = ' <Standard>';
    }
    ngOnInit() {
      this.contextPath = this.navigationService.getQisserverUrl();
      console.log('his-search-form.component#ngOnInit() #isSearchPopup =', this.isSearchPopup);
      this.headingLevelWidgetTitle = (this.hierarchyLevel ?? 1) + 1;
      if (this.isSearchFormResult) {
        // In a search-form-result, we do not have search constraints as URL parameters
        console.log('his-search-form.component#ngOnInit(), #this.configFile =', this.configFile);
        this.allParams = this.presetInputFields;
        console.log('his-search-form.component#ngOnInit(), #isSearchFormResult, #presetInputFields =', this.presetInputFields);
        this.showSearchForm = true;
        this.init(this.configFile);
        return;
      }
      if (!this.auth.hasAny('RIGHT_IS_LOGGED_IN')) {
        this.searchShowSearchParamsBox = false;
      }
      console.log('his-search-form.component#ngOnInit() #user is logged in');
      if (this.isSearchPopup || this.isChangeSearch() || this.isNewSearch() || !this.searchShowSearchParamsBox || this.isNestedSearchForm) {
        this.mergeParamsAndInitStandaloneSearchPage();
        return;
      }
      this.route.queryParams.subscribe(queryParams => {
        console.log('his-search-form.component#ngOnInit(), #this.configFile =', this.configFile, ', queryParams.configFile =', queryParams.configFile);
        // merge queryParams and presets
        this.allParams = {};
        for (let key of Object.keys(this.presetInputFields)) {
          this.allParams[key] = this.presetInputFields[key];
        }
        for (let key of Object.keys(queryParams)) {
          this.allParams[key] = queryParams[key];
        }
        console.log('his-search-form.component#ngOnInit(), #queryParams =', queryParams, ', presetInputFields =', this.presetInputFields, '-> allParams =', this.allParams);
        // config file may be given per input parameter or per URL parameter.
        if (!this.configFile) {
          this.configFile = queryParams.configFile;
        }
        if (!this.configFile) {
          // da nützt auch der Aufruf this.initStandaloneSearchPage(); nichts,
          // das wäre dann ein Konfigurationsfehler
          return;
        }
        // Wenn es kein searchFormResult und auch kein changeSearch oder newSearch ist
        // dann prüfe, ob es ein Standard Suchset gibt.
        // Wenn ja, dann führe die Suche aus, ohne die Suchseite anzuzeigen.
        // Wenn nein, dann zeige die Suchseite an.
        //workaround: we should not use component.name in production mode
        let componentId = this.callerId ?? this.route.routeConfig.component.name;
        let searchCriteriaSetRequest = new HisSearchCriteriaSetRequest(this.configFile, null, componentId);
        this.searchCriteriaSetService.getSearchCriteriaSets(searchCriteriaSetRequest).subscribe(searchSets => {
          console.log('his-search-form.component#ngOnInit() #searchSets', searchSets);
          console.log('his-search-form.component#ngOnInit() #isEmptyArray', HisArrayUtils.isEmptyArray(searchSets));
          if (searchSets && !HisArrayUtils.isEmptyArray(searchSets)) {
            let criteriaSet = this.getStandardSet(searchSets);
            console.log('his-search-form.component#ngOnInit() #criteriaSet', criteriaSet);
            if (criteriaSet) {
              criteriaSet.defaulttext = criteriaSet.defaulttext + this.STANDARD;
              // 0: empty search result;
              // 1: non - empty search result, grouping failed;
              // 2: non - empty search result, grouping worked
              this.searchService.validateInputs(criteriaSet.search).pipe(catchError(error => {
                console.error('his-search-form.component#ngOnInit() #validateInputs', error);
                this.initStandaloneSearchPage();
                throw error; //re-Throw the exception
              })).subscribe(resultCode => {
                console.log('resultCode', resultCode);
                if (resultCode.toString() === '0') {
                  this.initStandaloneSearchPage();
                }
              });
              this.searchService.loadSearchConfiguration(criteriaSet.configFile).subscribe(searchConfig => {
                if (searchConfig) {
                  console.log('onInit #searchConfig', searchConfig);
                  this.title = searchConfig.pageTitle;
                  this.formTitleLoaded.emit(this.title);
                  this.searchConfiguration = searchConfig;
                  this.storeSearchSetAtSessionStorage(criteriaSet);
                  this.storeCompinentIdAtSessionStorage(componentId);
                  this.registerCurrentUrlForBackToSearchButton();
                  this.submitSearch(criteriaSet.search);
                }
              });
            } else {
              console.log('his-search-form.component#ngOnInit() #no standard search set defined');
              this.initStandaloneSearchPage();
            }
          } else {
            console.log('his-search-form.component#ngOnInit() #no search set defined');
            this.initStandaloneSearchPage();
          }
        });
      });
    }
    mergeParamsAndInitStandaloneSearchPage() {
      this.showSearchForm = true;
      this.route.url.subscribe(url => {
        console.log('HisSearchFormComponent.ngOnInit(): Loading route \'' + url.join('/') + '\' ...');
      });
      this.route.queryParams.subscribe(queryParams => {
        console.log('HisSearchFormComponent.ngOnInit(): this.configFile =', this.configFile, ', queryParams.configFile =', queryParams.configFile);
        // merge queryParams and presets
        this.allParams = {};
        for (let key of Object.keys(this.presetInputFields)) {
          this.allParams[key] = this.presetInputFields[key];
        }
        for (let key of Object.keys(queryParams)) {
          this.allParams[key] = queryParams[key];
        }
        console.log('HisSearchFormComponent.ngOnInit(): no searchFormResult, queryParams =', queryParams, ', presetInputFields =', this.presetInputFields, '-> allParams =', this.allParams);
        // config file may be given per input parameter or per URL parameter.
        this.init(this.configFile ? this.configFile : queryParams.configFile);
      });
      this.registerCurrentUrlForBackToSearchButton();
    }
    initStandaloneSearchPage() {
      this.showSearchForm = true;
      this.init(this.configFile);
      this.registerCurrentUrlForBackToSearchButton();
    }
    /**
     * @param configFile the name of the search configuration file
     */
    init(configFile) {
      console.log('HisSearchFormComponent.init(): configFile =', configFile, ', allParams =', this.allParams);
      this.configFile = configFile;
      this.searchService.loadSearchConfiguration(this.configFile).subscribe(searchConfig => {
        if (!searchConfig) {
          // this was just the initialization of the observable, not the real data
          return;
        }
        this.title = searchConfig.pageTitle;
        this.formTitleLoaded.emit(this.title);
        this.searchConfiguration = searchConfig;
        // let searchConstraints = queryParams ? queryParams : this.presetInputFields;
        this.hasQuickSearchCriteria = !!this.searchConfiguration.searchCriteria.quickSearchCriteria; // !! converts null to false
        // all search criteria are shown if there are no quickSearchCriteria or if the search is in "extended search" state
        let isExtendedSearch = this.allParams && this.allParams.extended ? true : false;
        this.showAllSearchCriteria = isExtendedSearch || !this.hasQuickSearchCriteria;
        // load initial select options
        this.widgetService.loadWidgetOptions(this.searchConfiguration, this.showAllSearchCriteria);
        // initialize search criteria
        this.widgetGroups = this.widgetService.getWidgetGroups(searchConfig);
        this.widgetGroups.forEach(g => {
          g.widgets = g.widgets.filter(w => !(this.hiddenSearchCriteriaPaths?.length && this.hiddenSearchCriteriaPaths.some(hiddenGL => hiddenGL === w.id)));
        });
        for (let widgetGroup of this.widgetGroups) {
          for (let widget of widgetGroup.widgets) {
            if (widget instanceof HisWidgetBaseSelect && !widget.not) {
              // Explizites Zurücksetzen der Operatoren,
              // die bei der Breadcrumb-Navigation nicht zurückgesetzt werden
              // see hiszilla 246714
              if (this.isBreadcrumbNavigation()) {
                this.triggerOperator(false, widget);
                console.log('Assigned not', widget.not, 'to form control for widget', widget.id);
              } else {
                // Hiszilla 278471 - Sprachumschaltung in der generischen Suche führt zu unterschiedliches Verhalten (Zweck/Status)
                this.triggerOperator(this.getOperatorStateFromParamOrFalse(widget.id), widget);
              }
            }
          }
        }
        if (this.allParams) {
          this.doPresetInputFields(this.allParams);
        }
        // create form group using the 'widget.value's as data model
        let group = {};
        for (let widgetGroup of this.widgetGroups) {
          for (let widget of widgetGroup.widgets) {
            group[widget.id] = new UntypedFormControl(widget.value);
            console.log('Assigned value', widget.value, 'to form control for widget', widget.id);
          }
        }
        this.form = new UntypedFormGroup(group);
        // Nach dem Laden von `widgetGroups` die Spalten berechnen
        this.calculateColumnGroups();
        console.log('HisSearchFormComponent.init(): this.form=', this.form);
        // listen to value changes
        this.form.valueChanges.subscribe(model => {
          console.log('HisSearchFormComponent.init(): Model changed to', model);
          // console.log( 'form.value=', this.form.value ); // same as model
          // pass value changes from model (this.form.value) to widgets
          for (let widgetGroup of this.widgetGroups) {
            for (let widget of widgetGroup.widgets) {
              this.updateModelValue(model, widget);
            }
          }
        });
      }, error => {
        console.log('init() caught error:', error);
      });
    }
    ngAfterViewInit() {
      if (this.allParams) {
        this.restoreCriteriaGroupWidgets(this.allParams);
      }
      if (this.widgetGroups) {
        this.setOperatorValues(this.widgetGroups);
      }
      this.cdRef.detectChanges();
    }
    isBreadcrumbNavigation() {
      if (!this.allParams) {
        return false;
      }
      for (let key of Object.keys(this.allParams)) {
        // key = groups1.criteria0.field
        if (key.endsWith('field')) {
          return false;
        }
      }
      return true;
    }
    getOperatorStateFromParamOrFalse(widgetId) {
      if (!this.allParams) {
        return false;
      }
      for (let key of Object.keys(this.allParams)) {
        // key = groups1.criteria0.field
        if (key.endsWith('field') && this.allParams[key] === widgetId) {
          const operatorKey = key.replace(HisSearchConstants.FIELD, HisSearchConstants.NOT);
          const operatorValue = this.allParams[operatorKey];
          if (operatorValue === 'true' || operatorValue === 'false') {
            return true;
          }
        }
      }
      return false;
    }
    /**
     * Restores criteria group widgets based on the provided search constraints.
     * Used when modifying an existing search ('Suche ändern').
     *
     * @param searchConstraints - The search constraints to restore widgets from
     */
    restoreCriteriaGroupWidgets(searchConstraints) {
      // Convert flat constraints to HIS search items
      const searchItems = HisSearchParserHelper.convertFlatObjectFormatParamsToHisSearchItems(searchConstraints);
      const parsedSearch = HisSearchParser.decode(searchItems);
      // First populate not lazy widgets values and create all criteria groups
      this.populateNotLazyWidgetValues(parsedSearch);
      // Then populate lazy widgets values
      this.populateLazyWidgetValues(parsedSearch);
    }
    /**
     * Creates criteria groups from the parsed search data
     */
    populateNotLazyWidgetValues(parsedSearch) {
      for (const searchGroup of parsedSearch.groups) {
        this.copyWidgetsFromGroupAndCreateCriteriaGroup(searchGroup, false);
      }
    }
    /**
     * Populates widget values from the parsed search criteria
     *
     * @remarks
     * Not part of the public API - do not use directly in application code.
     * This exists solely to handle the lazy-loading workflow in generic search.
     *
     * This is intentionally public ONLY to allow coordination between:
     * - {@link HisSearchFormComponentBase}
     * - {@link HisSearchSaveParamsComponent}
     */
    populateLazyWidgetValues(parsedSearch) {
      // Iterate through each search group in the parsed search
      for (const searchGroup of parsedSearch.groups) {
        // Process widgets that require lazy loading
        this.processCriteriaGroupWidgets(searchGroup);
      }
    }
    /**
     * Processes widgets for a specific criteria group, focusing on lazy-loaded widgets.
     * Maps search criteria to corresponding widgets and triggers async loading when needed.
     *
     * @param searchGroup - The search group containing criteria groups to process
     */
    processCriteriaGroupWidgets(searchGroup) {
      // Find the matching widget group based on the search group label
      const matchingWidgetGroup = HisWidgetUtils.getWidgetGroupWithLabel(searchGroup.groupLabel, this.widgetGroups);
      const widgetCriteriaGroups = matchingWidgetGroup.criteriaGroups;
      const searchCriteriaGroups = searchGroup.criteriaGroups;
      // Process each criteria group within the widget group
      for (const index in widgetCriteriaGroups) {
        const currentWidgetCriteriaGroup = widgetCriteriaGroups[index];
        // Check each widget in the current criteria group
        for (const widget of currentWidgetCriteriaGroup.widgets) {
          // Process only lazy-loaded select widgets
          if (this.isLazySelectWidget(widget)) {
            const correspondingCriteriaGroup = searchCriteriaGroups[index];
            this.handleLazySelectWidget(widget, correspondingCriteriaGroup);
          }
        }
      }
    }
    isLazySelectWidget(widget) {
      return widget instanceof HisSelectWidget && GenericSearchUtil.isLazySelectFrom(widget.optionsKey, widget.showDropdownIcon);
    }
    /**
     * Handles value restoration for lazy-loaded select widgets.
     * Finds matching criteria, loads the necessary options, and updates the widget.
     */
    handleLazySelectWidget(widget, criteriaGroup) {
      // Extract path suffix
      const widgetFullPath = widget.id;
      const widgetPathSuffix = widgetFullPath.split(']').pop();
      // Find the criterion matching this widget's path
      const matchingCriterion = HisSearchParserHelper.getCriterionWithPath(widgetPathSuffix, criteriaGroup.criteria);
      // Exit if no matching criterion or no value
      if (!matchingCriterion?.value) return;
      // Load the options for this lazy widget and set its value
      this.loadAndSetLazyWidgetValue(widget.optionsKey, matchingCriterion.value, matchingCriterion.not).subscribe(loadedOptions => {
        if (loadedOptions && !HisArrayUtils.isEmptyArray(loadedOptions)) {
          // Update the widget with the only available option
          this.updateWidgetValues(widget, loadedOptions[0], matchingCriterion.not);
          this.addOrUpdateControl(widget, loadedOptions);
        }
      });
    }
    /**
     * Updates widget values after loading
     */
    updateWidgetValues(widget, value, notValue) {
      widget.value = value;
      widget.originalValue = value;
      widget.not = notValue;
      widget.originalNot = notValue;
    }
    /**
     * Loads values for a lazy-loaded widget
     */
    loadAndSetLazyWidgetValue(optionsKey, id, notValue) {
      if (!id) return of([]);
      const optionRequest = new OptionByIdRequest(optionsKey, [id]);
      return this.searchService.loadOptionsByIds(this.configFile, [optionRequest]).pipe(map$1(results => {
        return results?.[0]?.selectedOptions ?? [];
      }));
    }
    updateModelValue(model, widget) {
      let newValue = model[widget.id];
      // console.log('widget.value=', widget.value, ', newValue=', newValue);
      if (newValue !== widget.value) {
        let debug = 'HisSearchFormComponent.listenToValueChanges(): Change widget';
        console.log(debug, widget.id, 'value from', widget.value, 'to', newValue);
        widget.value = newValue;
        // TODO different treatment for setting to null?
      }
    }
    getOperatorValue(params, widget, groupLabel) {
      // old url format
      // #key Person.gender.id #value 2
      // #key Person.gender.id(NOT) #value true
      // key = widget.id + '(NOT)'
      if (params[widget.id + '(NOT)']) {
        console.log('his-search-form#getOperatorValue() #set for key with old url format', widget);
        return true;
      }
      // flat object url format:
      // #key groups0.criteria0.field #value Person.gender.id
      // #key groups0.criteria0.value #value 2
      // #key groups0.criteria0.not #value true
      console.log('his-search-form#getOperatorValue() #widget', widget);
      let flatObjOperatorValue;
      for (let key of Object.keys(params)) {
        console.log('his-search-form#getOperatorValue() #key', key);
        if (HisWidgetUtils.isMatchingKeyForWidget(key, params[key], widget.id, groupLabel)) {
          let notKey = key.replace(HisSearchConstants.FIELD, HisSearchConstants.NOT);
          console.log('his-search-form#getOperatorValue() #notKey', notKey);
          console.log('his-search-form#getOperatorValue() #flatObjOperatorValue', widget.id, flatObjOperatorValue);
          return params[notKey];
        }
      }
      return undefined;
    }
    setOperatorValues(widgetGroups) {
      // siehe Hiszilla 246714
      for (let widgetGroup of widgetGroups) {
        for (let widget of widgetGroup.widgets) {
          this.setOperators(widget, widgetGroup.label);
        }
        for (let criteriaGroup of widgetGroup.criteriaGroups) {
          for (let widget of criteriaGroup.widgets) {
            this.setOperators(widget, widgetGroup.label);
          }
        }
      }
    }
    setOperators(widget, groupLabel) {
      let isSelectWidget = widget instanceof HisWidgetBaseSelect;
      if (!isSelectWidget) {
        console.log('his-search-form#init() #not a select widget', widget);
        return;
      }
      console.log('his-search-form#init() #select widget', widget);
      if (!this.allParams) {
        return;
      }
      let operatorValue = this.getOperatorValue(this.allParams, widget, groupLabel);
      console.log('his-search-form#init() #flatObjOperatorValue after for loop', widget.id, operatorValue);
      this.triggerOperator(operatorValue, widget);
    }
    /**
     * Switch from simple search to extended search or back.
     */
    onToggleQuickSearch() {
      this.showAllSearchCriteria = !this.showAllSearchCriteria;
      // load select options not present yet (typically after switch to "extended search")
      this.widgetService.loadWidgetOptions(this.searchConfiguration, this.showAllSearchCriteria);
    }
    /**
     * Submit a search where the search constraints are taken from the search mask.
     */
    submitSearchForm() {
      console.log('his-search-form.component#submitSearchForm() #this.widgetGroups', this.widgetGroups);
      // XXX Wegen Hiszilla 257303 deaktiviert. Stellt sich die Frage, ob das überhaupt benötigt wird
      // Damit wird das Beziehen der Daten aus this.getFormData() immer weiter abgelöst.
      // Für was war eigentlich diese doppelte Datenhaltung in den widgets und in form?
      let widgetGroups = this.validateWidgetGroupsValues(this.widgetGroups, this.getFormData());
      let search = HisSearchParserHelper.createNewHisSearchByWidgetValues(widgetGroups, this.configFile);
      console.log('his-search-form.component#submitSearchForm() #search', search);
      this.submitSearch(search);
    }
    getNumberOfVisibleWidgetGroups() {
      if (this.showAllSearchCriteria) {
        return this.widgetGroups.length;
      }
      // Einfache Suche:
      let num = 0;
      for (let widgetGroup of this.widgetGroups) {
        if (widgetGroup.quickSearch) {
          num++;
        }
      }
      return num;
    }
    validateWidgetGroupsValues(widgetGroups, params) {
      for (let widgetGroup of widgetGroups) {
        this.checkWidgetValueAndReplaceIfNecessary(widgetGroup.widgets, params);
        for (let criteriaGroup of widgetGroup.criteriaGroups) {
          this.checkWidgetValueAndReplaceIfNecessary(criteriaGroup.widgets, params);
        }
      }
      return widgetGroups;
    }
    checkWidgetValueAndReplaceIfNecessary(widgets, params) {
      for (let widget of widgets) {
        let paramValue = params[widget.id];
        if (this.isWidgetValueEqualToParamValue(widget, paramValue)) {
          continue;
        }
        console.log('his-search-form.component#validateWidgetGroupsValues() #widget value not equals paramValue', widget.id, paramValue);
        widget.value = paramValue;
      }
    }
    isWidgetValueEqualToParamValue(widget, paramValue) {
      return widget.value === paramValue || ___default(paramValue) || ___default(paramValue);
    }
    createHisSearchFromSearchData(configFile) {
      if (!configFile) {
        throw new Error('HisSearchForm: No searchConfigFile present!');
      }
      let obs = new BehaviorSubject(null);
      this.searchService.loadSearchConfiguration(configFile).subscribe(searchConfiguration => {
        //console.log( 'searchConfiguration', searchConfiguration );
        if (!searchConfiguration) {
          return;
        }
        let search = new HisSearch();
        search.configFile = configFile;
        let keys = Object.keys(this.allParams);
        if (keys.length > 0) {
          for (let key of keys) {
            // let value = this.getValueForKey(key, inputFields);
            // let value = HisSearchParserHelper.convertValueToString(key, this.allParams[key]);
            if (!this.allParams[key]) {
              continue;
            }
            for (let group of searchConfiguration.searchCriteria.group) {
              // if (group.and) {
              // warum ist das nicht da?
              // weil es nicht gesetet ist weil es nicht true ist?
              // }
              for (let criterion of group.criteria) {
                // Gruppe setzen nur, wenn es mindestens ein Feld in der Gruppe gibt
                if (criterion.path === key) {
                  console.log('his-search-form.component#createHisSearchFromSearchData() #criterion', criterion);
                  let criteria = new HisSearchCriteria$1();
                  criteria.field = key;
                  let paramValue = this.allParams[key];
                  // hier eine EXTRA Behandlung für Checkboxen, man ist das scheiße gelöst!!!!
                  // Checkbox Wert aus Suchkofiguration>value nur dann, wenn gecheckt, sonst kein value/option
                  criteria.value = HisSearchParserHelper.convertValueToString(key, paramValue, criterion.value);
                  if (criterion.multipleSelect) {
                    if (criterion.not) {
                      criteria.not = true;
                    }
                    // not implemented
                    // if( widget.operator) {
                    //     criteria.operator = widget.operator;
                    // }
                  }
                  // wenn es die Gruppe gibt hinzufügen, wenn nicht, neue Gruppe
                  let searchGroup = search.groups.find(grp => grp.groupLabel === group.label);
                  if (searchGroup) {
                    searchGroup.criteria.push(criteria);
                    console.log('searchGroup.criteria.push(criteria)', searchGroup, criteria);
                  } else {
                    let newGroup = new HisSearchGroup$1();
                    newGroup.groupLabel = group.label;
                    newGroup.criteria.push(criteria);
                    search.groups.push(newGroup);
                    console.log('search.groups.push(newGroup)', newGroup, criteria);
                  }
                  // Kriteriangruppen fehlen noch
                }
              }
            }
          }
        }
        obs.next(search);
      });
      return obs;
    }
    /**
     * Submit a search with the given search constraints.
     * May be used for headless searches without an input form.
     *
     * @param searchConstraints the search constraints to apply in the search
     */
    submitSearch(search) {
      console.log('submitSearch(): Submitting search \'' + search.configFile + '\'', 'with search constraints', search);
      console.log('his-search-form#submitSearch() #search', search);
      // delets all session storage keys with column sort
      HisSearchResultColumnSortHelper.removeAllSessionStorageKeysContainingSortOrder();
      if (this.isSearchFormResult) {
        // This page includes search form and search result -> just fire an event
        console.log('HisSearchFormComponent.submitSearch(): Firing submit-search event ...');
        this.searchSubmitted.emit(search);
      } else {
        // The search result will be displayed on a different page.
        // To show validation errors on the search mask we need a validation REST call
        // before the redirect to the search result URL:
        console.log('his-search-form: this.searchService.validateInputs #search', search);
        this.searchService.validateInputs(search).subscribe(resultCode => {
          console.log('resultCode =', resultCode);
          // resultCode 0: empty search result;
          // resultCode 1:non-empty search result, grouping failed;
          // resultCode 2: non-empty search result, grouping worked
          let route = '../searchresult';
          // no validation error
          if (resultCode.toString() === '0') {
            // remove old messages #248767
            this.notificationService.clear();
            // empty result
            this.notificationService.info(this.uiService.translate('genericSearch.emptyResult'), this.uiService.translate('view.messages.information'));
            this.showSearchForm = true;
            route = '../search';
          }
          // no validation error, non-empty result-> we want to retrieve the search result.
          // Add search constraints to URL parameters and navigate to the search result page:
          let queryParams = {};
          // addNavigationPosition
          let urlParams = this.route.snapshot.queryParams;
          // console.log('his-search-form#submitSearch() #addNavigationPosition #urlParams', urlParams);
          if (urlParams[HisSearchNonCriteriaUrlParam.NAVIGATION_POSITION]) {
            queryParams.navigationPosition = urlParams[HisSearchNonCriteriaUrlParam.NAVIGATION_POSITION];
          }
          if (this.searchConfiguration.pageTitle) {
            queryParams.pageTitle = this.searchConfiguration.pageTitle;
          }
          if (this.searchConfiguration.tableTitle) {
            queryParams.tableTitle = this.searchConfiguration.tableTitle;
          }
          if (this.showAllSearchCriteria) {
            queryParams.extended = true;
          }
          // console.log('his-search-form#submitSearch() #search vor encode', search);
          let searchItems = HisSearchParser.encode(search);
          searchItems.push(new HisSearchItem(HisSearchConstants.SEARCH_CONFIG_FILE, this.searchConfiguration.configFile));
          console.log('his-search-form#submitSearch() #searchItems', searchItems);
          for (let item of searchItems) {
            queryParams[item.key] = item.value;
          }
          // register the current search url path to use on header search buttons 
          queryParams.search = window.location.pathname;
          // it checks if you are logged in.
          // if you are not logged in, no list or table is shown in the route
          if (this.auth.hasAny('RIGHT_IS_LOGGED_IN')) {
            this.userProfileService.getValueforKey('searchResultMode').subscribe(mode => {
              queryParams.mode = mode;
              if (route === '../searchresult') {
                this.navigateToSearchResultByRelativeRoute(queryParams, route);
              }
            });
          } else {
            if (route === '../searchresult') {
              this.navigateToSearchResultByRelativeRoute(queryParams, route);
            }
          }
        });
      }
    }
    showExtendedCriteriaGroupBySearchSet(id) {
      return this.groupIdsToShowExtendedCriteriaBySearchSet.includes(id);
    }
    showExtendedCriteriaWidgetBySearchSet(id) {
      return this.widgetIdsToShowExtendedCriteriaBySearchSet.includes(id);
    }
    navigateToSearchResultByRelativeRoute(queryParams, route) {
      console.log('Current route:', this.route.url);
      console.log('Navigating to \'' + route + '\' with queryParams', queryParams);
      this.router.navigate([route], {
        relativeTo: this.route,
        queryParams
      });
    }
    getFormGroup() {
      return this.form;
    }
    isFormValid() {
      return this.form.valid;
    }
    getFormData() {
      if (this.form) {
        return this.form.value;
      }
    }
    // Eingaben zuruecksetzen
    resetInputs() {
      // log model (aka this.form.value) before reset
      console.log('Model before reset inputs =', this.getFormData());
      // reset form inputs: triggers value changes that are noticed in init()
      if (this.form) {
        this.form.reset();
        this.searchService.setResetInputs(true);
        sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET);
        this.groupIdsToShowExtendedCriteriaBySearchSet = [];
        this.widgetIdsToShowExtendedCriteriaBySearchSet = [];
        // Meldungen zurücksetzen
        this.notificationService.clear();
      }
    }
    enterOnForm(event) {
      const tagName = event.target.tagName.toLowerCase();
      if (!this.showSearchButton && tagName === 'input') {
        event.preventDefault();
      }
    }
    isChangeSearch() {
      return sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON) === 'CHANGE_SEARCH';
    }
    isNewSearch() {
      return sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON) === 'NEW_SEARCH';
    }
    storeSearchSetAtSessionStorage(searchCriteriaSet) {
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET, JSON.stringify(searchCriteriaSet));
    }
    storeCompinentIdAtSessionStorage(componentId) {
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID, componentId);
    }
    getStandardSet(searchSets) {
      for (let searchSet of searchSets) {
        if (searchSet.standard) {
          return searchSet;
        }
      }
      return null;
    }
    registerCurrentUrlForBackToSearchButton() {
      // register the current url for the "back to search" button
      console.log('his-search-form.component#registerUrlForBackToSearchButton() #register url', 'for the "back to search" button with standard set', '#window.location.href', window.location.href);
      this.navigationService.setSearchUrl(window.location.href);
      this.navigationService.setSearchResultUrl(null); // forget last search result
    }
    /**
     * Berechnung der Aufteilung von Kriteriengruppen analog zu de.his.appclient.jsf.genericSearch.GenericSearchControllerBase.init()
     */
    calculateColumnGroups() {
      if (!this.widgetGroups || this.widgetGroups.length === 0) {
        console.log('widgetGroups ist leer oder nicht initialisiert.');
        return;
      }
      const fieldsetBorderHeight = 1.7; // Analog zu JSF
      let rowCount = 0;
      // Berechnung der Gesamtanzahl an "Zeilen"
      this.widgetGroups.forEach(group => {
        rowCount += group.widgets.length + fieldsetBorderHeight;
      });
      const halfRowCount = rowCount / 2;
      let count = 0;
      let i = 0;
      // Dynamische Aufteilung in linke und rechte Spalten
      for (const group of this.widgetGroups) {
        const size = group.widgets.length + fieldsetBorderHeight;
        if (count + size > halfRowCount) {
          const deltaLeft = halfRowCount - (count + size);
          const deltaRight = halfRowCount - (rowCount - count);
          if (Math.abs(deltaLeft) * 0.8 < Math.abs(deltaRight)) {
            i++; // dann doch noch in die linke Spalten aufnehmen
          }
          this.searchMaskLeftGroupsAmount = i;
          break; // Beenden der Schleife, sobald searchMaskLeftGroupsAmount gesetzt wurde
        }
        count += size;
        i++;
      }
    }
    scrollToResult() {
      this.formSearchButtonsComponentRef.nativeElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    static {
      this.ɵfac = function HisSearchFormComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchFormComponentBase)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchFormComponentBase,
        viewQuery: function HisSearchFormComponentBase_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$F, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formSearchButtonsComponentRef = _t.first);
          }
        },
        inputs: {
          configFile: "configFile",
          callerId: "callerId",
          isSearchFormResult: "isSearchFormResult",
          isSearchPopup: "isSearchPopup",
          isNestedSearchForm: "isNestedSearchForm",
          showFormData: "showFormData",
          showSearchButton: "showSearchButton",
          showLinkToSearchHelp: "showLinkToSearchHelp",
          presetInputFields: "presetInputFields",
          searchShowSearchParamsBox: "searchShowSearchParamsBox",
          hiddenSearchCriteriaPaths: "hiddenSearchCriteriaPaths",
          headingLevel: "headingLevel",
          renderTitle: "renderTitle",
          hierarchyLevel: "hierarchyLevel"
        },
        outputs: {
          searchSubmitted: "searchSubmitted",
          formTitleLoaded: "formTitleLoaded"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return HisSearchFormComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisControlValueAccessor {
  constructor() {
    this.onModelChange = () => {};
    this.onModelTouched = () => {};
  }
  setDisabledState(isDisabled) {}
  registerOnTouched(fn) {
    this.onModelTouched = fn;
  }
  registerOnChange(fn) {
    this.onModelChange = fn;
  }
  writeValue(model) {}
}
const _c0$E = ["inputElement"];
const _c1$b = ["SearchFormResultComponent"];
let HisSearchSelectPopupComponentBase = /*#__PURE__*/(() => {
  class HisSearchSelectPopupComponentBase extends HisControlValueAccessor {
    constructor() {
      super(...arguments);
      this.cdref = inject(ChangeDetectorRef);
      // The rows of the search result that are selected.
      // They may have an 'id' property, or selectedOptionsIdColumn must define the property that serves as id.
      this.selectedOptions = [];
      this.selectedOptionsIdColumn = undefined;
      // selectedOptionsLabelColumn is used as the label of selected rows in the his-search-select component.
      this.selectedOptionsLabelColumn = undefined;
      // the number of result rows per page
      this.resultRowsPerPage = 10;
      // name of a custom image for the select button, e.g. "USER_ADD"
      this.selectButtonImage = undefined;
      // custom select button tooltip text (i18n keys should've been substituted already)
      this.selectButtonTooltip = undefined;
      // label of the 'selectItems' button
      this.selectItemsButtonLabel = undefined;
      // label of the 'changeSelectedItems' button
      this.changeSelectedItemsButtonLabel = undefined;
      // display the delete selection button?
      this.showDeleteButton = true;
      // Used to determine the relevant UI elements
      this.selectionSettingEnum = HisSearchSelectionSetting;
      this.selectionSetting = HisSearchSelectionSetting.MultiSelect;
      // restrict selection to a single item?
      this.editMode = true;
      // search constraints passed by parent component, like { 'Person.surname': 'Wolf', 'Person.firstname': 'Ulrich' }
      this.presetInputFields = {};
      this.isFirstInputElement = false;
      // Specifies the heading level for the <his-heading> component.
      this.hierarchyLevel = 2;
      this.selectedOptionsChange = new EventEmitter();
      this.readSearchSetFromSubmit = new EventEmitter();
      this.searchFormResultComponentVisible = false;
      this.showTableFilter = true;
      this.showFooterButtons = false;
      this.genericFallbackTitle = this.selectionSetting === this.selectionSettingEnum.SingleSelect ? 'genericSearch.singleSearchHeader' : 'genericSearch.multiSearchHeader';
    }
    ngDoCheck() {
      this.errortextId = this.inputElement?.nativeElement.closest('his-plam')?.getElementsByClassName('errortext')[0]?.id;
    }
    ngOnChanges(changes) {
      if (changes) {
        if (this.deleteActionChange !== undefined && this.deleteActionChange === true) {
          this.inputElement.nativeElement.focus();
        }
      }
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    /**
     * Display sub search popup. Called from submit of "Auswählen"/"Auswahl ändern" button.
     */
    showSearchFormResultComponent() {
      this.searchFormResultComponentVisible = true;
      this.showFooterButtons = false;
      this.cdref.detectChanges();
      this.searchFormResultComponent.setSelectedOptions(this.selectedOptions, this.selectedOptionsIdColumn);
      this.searchFormResultComponent.submitInitialSearch();
    }
    /**
     * Hide sub search popup. Called from submit of cancel button in the popup.
     */
    hideSearchFormResultComponent() {
      this.searchFormResultComponentVisible = false;
    }
    /**
     * Get results from sub search popup and close it. Called from submit of "Auswahl übernehmen" button in the popup.
     */
    onSubmitSearchFormResultComponent($event) {
      this.searchFormResultComponentVisible = false;
      // sort selected options
      this.selectedOptions = $event.slice(0);
      this.selectedOptions.sort((option1, option2) => {
        let l1 = option1.label;
        let l2 = option2.label;
        if (l1 < l2) {
          return -1;
        } else if (l1 > l2) {
          return 1;
        } else {
          return 0;
        }
      });
      // notify embedding component
      this.fireOnChange();
    }
    deleteAllSelectedOptions() {
      this.selectedOptions.splice(0, this.selectedOptions.length);
      this.fireOnChange();
      this.onModelChange(this);
    }
    /**
     * Notify wrapper component that the model needs to be updated.
     */
    fireOnChange() {
      this.inputElement.nativeElement.focus();
      console.log('HisSearchSelectPopupComponent: Emit change event:', this.selectedOptions);
      this.selectedOptionsChange.emit(this.selectedOptions);
    }
    /**
     *
     * Die Search wird als output weitergeben um draus ein Suchset zu generieren.
     */
    readSearchSetFromSearch($event) {
      this.readSearchSetFromSubmit.emit($event);
    }
    onFinishedInitialLoad() {
      this.showFooterButtons = true;
    }
    onFormTitleLoaded(title) {
      this.formTitle = title;
    }
    submitFormResultSelection() {
      this.searchFormResultComponent.submitSelection();
    }
    cancelFormResultSelection() {
      this.searchFormResultComponent.cancelSelection();
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchSelectPopupComponentBase_BaseFactory;
        return function HisSearchSelectPopupComponentBase_Factory(__ngFactoryType__) {
          return (ɵHisSearchSelectPopupComponentBase_BaseFactory || (ɵHisSearchSelectPopupComponentBase_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchSelectPopupComponentBase)))(__ngFactoryType__ || HisSearchSelectPopupComponentBase);
        };
      })();
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchSelectPopupComponentBase,
        viewQuery: function HisSearchSelectPopupComponentBase_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$E, 5);
            i0.ɵɵviewQuery(_c1$b, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchFormResultComponent = _t.first);
          }
        },
        inputs: {
          searchConfigFile: "searchConfigFile",
          selectedOptions: "selectedOptions",
          selectedOptionsIdColumn: "selectedOptionsIdColumn",
          selectedOptionsLabelColumn: "selectedOptionsLabelColumn",
          resultRowsPerPage: "resultRowsPerPage",
          selectButtonImage: "selectButtonImage",
          selectButtonTooltip: "selectButtonTooltip",
          selectItemsButtonLabel: "selectItemsButtonLabel",
          changeSelectedItemsButtonLabel: "changeSelectedItemsButtonLabel",
          showDeleteButton: "showDeleteButton",
          selectionSetting: "selectionSetting",
          editMode: "editMode",
          presetInputFields: "presetInputFields",
          isFirstInputElement: "isFirstInputElement",
          showTableFilter: "showTableFilter",
          defaultSearchGroup: "defaultSearchGroup",
          hiddenSearchCriteriaPaths: "hiddenSearchCriteriaPaths",
          genericSearchRowTooltipId: "genericSearchRowTooltipId",
          deleteActionChange: "deleteActionChange"
        },
        outputs: {
          selectedOptionsChange: "selectedOptionsChange",
          readSearchSetFromSubmit: "readSearchSetFromSubmit"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisSearchSelectPopupComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchSelectComponentBase = /*#__PURE__*/(() => {
  class HisSearchSelectComponentBase {
    constructor() {
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      // filter selected Options
      this.removeSelectedOptionsFromDropdown = false;
      // Here we can have options selected by autocomplete or subsearch; so both classes must be supported
      this.selectedOptions = [];
      this.selectedOptionsIdColumn = undefined;
      this.selectedOptionsLabelColumn = undefined;
      // label of the 'selectItems' button
      this.selectItemsButtonLabel = undefined;
      // label of the 'changeSelectedItems' button
      this.changeSelectedItemsButtonLabel = undefined;
      // the number of result rows per page
      this.resultRowsPerPage = 10;
      // Used to determine the relevant UI elements
      this.selectionSettingEnum = HisSearchSelectionSetting;
      this.selectionSetting = HisSearchSelectionSetting.MultiSelect;
      // display autocomplete ?
      this.showAutocomplete = true;
      // minimum length of autocomplete input to trigger a search
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete (null -> show all)
      this.limit = null;
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      // search constraints passed by parent component, like { 'Person.surname': 'Wolf', 'Person.firstname': 'Ulrich' }
      this.presetInputFields = {};
      this.changed = new EventEmitter();
      // true if this is the first input element in the search mask
      this.isFirstInputElement = false;
      this.showTableFilter = true;
      /** Limit the number of selections displayed. Overflow will be combined to a single label. */
      // default to 10, similar to JSF
      this.maxDisplayedSelections = 10;
      this.showAllSelected = false;
    }
    getHtmlFocusElementId() {
      return this.uid;
    }
    /**
     * Add one element selected by autocomplete.
     *
     * @param selectedElement the element to add
     */
    addSelectedElement(selectedElement) {
      console.log('Element selected by autocomplete:', selectedElement);
      // In multiSelect mode we do not want to add an element twice; just tell the user that the element is already there.
      // In singleSelect mode we do not need that check because the data is substituted anyway.
      if (this.selectionSetting === this.selectionSettingEnum.MultiSelect && this.isElementAlreadySelected(selectedElement.id)) {
        let message = this.uiService.translate('genericSearch.alreadySelected', selectedElement.label);
        this.notificationService.clear();
        this.notificationService.info(message, 'Info');
        return;
      }
      // Add selectedElement to selectedOptions: In singleSelect mode the previous selection is substituted;
      // in multiSelect mode the spread-operator required to have model and view synchronized
      // (with push() the reset button wouldn't work correctly)
      this.selectedOptions = this.selectionSetting === this.selectionSettingEnum.SingleSelect ? [selectedElement] : [...this.selectedOptions, selectedElement];
      this.changed.emit(this.selectedOptions);
    }
    isElementAlreadySelected(id) {
      // console.log( 'id =', id, 'has type', typeof id );
      for (let option of this.selectedOptions) {
        let optionId = option.id;
        // TODO According to class HisOption the option.id should be of string type
        // But obviously the search result obtained from the REST service contains number ids...
        // console.log( 'optionId =', optionId, 'has type', typeof optionId );
        if (id === optionId.toString()) {
          return true;
        }
      }
      return false;
    }
    /**
     * Delete the given option from the list of selected search result rows.
     *
     * @param option the element to remove from the selection
     */
    deleteSelectedOption(option) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (this.selectedOptions[i] === option) {
          this.selectedOptions.splice(i, 1);
          break;
        }
      }
      this.fireOnChange();
    }
    /**
     * Vom Auswahl-Popup ausgelöstes Event.
     *
     * @param selectedOptions Array der neu ausgewählten Elemente
     */
    selectedOptionsChange(selectedOptions) {
      this.selectedOptions = selectedOptions;
      this.fireOnChange();
    }
    /**
     * Notify HisSearchFormWidgetComponent that the model needs to be updated.
     */
    fireOnChange() {
      console.log('HisSearchSelectComponent: Emit change event:', this.selectedOptions);
      this.changed.emit(this.selectedOptions);
      // re-hide any future overflow after the button disappears
      if (this.selectedOptions.length <= this.maxDisplayedSelections) {
        this.showAllSelected = false;
      }
    }
    toggleShowAllSelected() {
      this.showAllSelected = !this.showAllSelected;
    }
    static {
      this.ɵfac = function HisSearchSelectComponentBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchSelectComponentBase)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchSelectComponentBase,
        inputs: {
          uid: "uid",
          widget: "widget",
          removeSelectedOptionsFromDropdown: "removeSelectedOptionsFromDropdown",
          searchEntity: "searchEntity",
          searchConfigFile: "searchConfigFile",
          selectedOptions: "selectedOptions",
          selectedOptionsIdColumn: "selectedOptionsIdColumn",
          selectedOptionsLabelColumn: "selectedOptionsLabelColumn",
          selectItemsButtonLabel: "selectItemsButtonLabel",
          changeSelectedItemsButtonLabel: "changeSelectedItemsButtonLabel",
          resultRowsPerPage: "resultRowsPerPage",
          selectionSetting: "selectionSetting",
          showAutocomplete: "showAutocomplete",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          presetInputFields: "presetInputFields",
          showUnequalOption: "showUnequalOption",
          isFirstInputElement: "isFirstInputElement",
          showTableFilter: "showTableFilter",
          maxDisplayedSelections: "maxDisplayedSelections"
        },
        outputs: {
          changed: "changed"
        }
      });
    }
  }
  return HisSearchSelectComponentBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * // HIS-PATCH #266927: Barrierefreiheit title und aria-label
 */
let HisButtonTitleDirective = /*#__PURE__*/(() => {
  class HisButtonTitleDirective {
    constructor(el) {
      this.el = el;
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisUiService = inject(HisUiService);
      this.dialog = inject(Dialog, {
        optional: true
      });
      this.confirmDialog = inject(ConfirmDialog, {
        optional: true
      });
      this.panel = inject(Panel, {
        optional: true
      });
      this.autoComplete = inject(AutoComplete, {
        optional: true
      });
      this.treeTableToggler = inject(TreeTableToggler, {
        optional: true
      });
      this.tabView = inject(TabView, {
        optional: true
      });
      this.chips = inject(Chips, {
        optional: true
      });
      this.tabPanel = inject(TabPanel, {
        optional: true
      });
      this.pickList = inject(PickList, {
        optional: true
      });
      this.orderList = inject(OrderList, {
        optional: true
      });
      this.table = inject(Table, {
        optional: true
      });
      this.treeTable = inject(TreeTable, {
        optional: true
      });
      this.sortIcon = inject(SortIcon, {
        optional: true
      });
      this.treeTableSortIcon = inject(TTSortIcon, {
        optional: true
      });
      this.overlayPanel = inject(OverlayPanel, {
        optional: true
      });
      this.steps = inject(Steps, {
        optional: true
      });
    }
    ngOnInit() {
      if (this.dialog) {
        if (this.dialog.closable) {
          this.setCloseTitle(this.dialog);
        }
        if (this.dialog.maximizable) {
          this.dialog.maximizeTitle = this.hisUiService.translate('image.overlay.scalable');
        }
      }
      if (this.confirmDialog) {
        this.setCloseTitle(this.confirmDialog);
      }
      if (this.panel) {
        if (this.panel.header === undefined) {
          this.panel.collapseText = this.hisUiService.translate('view.images.minus_circ');
          this.panel.expandText = this.hisUiService.translate('view.images.plus_circ');
        } else {
          if (this.hisBaseGlobalsService.getLanguage() === 'de') {
            this.panel.collapseText = this.panel.header + ' ' + this.hisUiService.translate('collapsible.close');
            this.panel.expandText = this.panel.header + ' ' + this.hisUiService.translate('expand.open');
          } else {
            this.panel.collapseText = this.hisUiService.translate('view.images.minus_circ') + ' ' + this.panel.header;
            this.panel.expandText = this.hisUiService.translate('view.images.plus_circ') + ' ' + this.panel.header;
          }
        }
      }
      if (this.treeTableToggler) {
        if (this.treeTableToggler.buttonTitle === undefined) {
          if (this.treeTableToggler.rowNode.node.expanded) {
            this.treeTableToggler.buttonTitle = 'Level ' + Number(this.treeTableToggler.rowNode.level + 1) + ' ' + this.hisUiService.translate('collapsible.close');
          } else if (!this.treeTableToggler.rowNode.node.expanded) {
            this.treeTableToggler.buttonTitle = 'Level ' + Number(this.treeTableToggler.rowNode.level + 1) + ' ' + this.hisUiService.translate('expand.open');
          }
        } else {
          let existingButtonTitleToggler = this.treeTableToggler.buttonTitle.toLowerCase();
          if (this.treeTableToggler.rowNode.node.expanded && !existingButtonTitleToggler?.includes('level')) {
            // eslint-disable-next-line max-len
            this.treeTableToggler.buttonTitle = 'Level ' + Number(this.treeTableToggler.rowNode.level + 1) + ' ' + this.treeTableToggler.buttonTitle + ' ' + this.hisUiService.translate('collapsible.close');
          } else if (!this.treeTableToggler.rowNode.node.expanded && !existingButtonTitleToggler?.includes('level')) {
            // eslint-disable-next-line max-len
            this.treeTableToggler.buttonTitle = 'Level ' + Number(this.treeTableToggler.rowNode.level + 1) + ' ' + this.treeTableToggler.buttonTitle + ' ' + this.hisUiService.translate('expand.open');
          }
        }
      }
      if (this.tabView) {
        this.tabView.buttonTitle = this.hisUiService.translate('registertab.closable') + ' ' + this.tabPanel.header;
        this.tabView.scrollableRightLabel = this.hisUiService.translate('registertab.scrollableRight');
        this.tabView.scrollableLeftLabel = this.hisUiService.translate('registertab.scrollableLeft');
      }
      if (this.pickList) {
        this.pickList.upButtonAriaLabel = this.hisUiService.translate('common.angleUp');
        this.pickList.topButtonAriaLabel = this.hisUiService.translate('common.angleDoubleUp');
        this.pickList.downButtonAriaLabel = this.hisUiService.translate('common.angleDown');
        this.pickList.bottomButtonAriaLabel = this.hisUiService.translate('common.angleDoubleDown');
        this.pickList.rightButtonAriaLabel = this.hisUiService.translate('common.angleRight');
        this.pickList.allRightButtonAriaLabel = this.hisUiService.translate('common.angleDoubleRight');
        this.pickList.leftButtonAriaLabel = this.hisUiService.translate('common.angleLeft');
        this.pickList.allLeftButtonAriaLabel = this.hisUiService.translate('common.angleDoubleLeft');
        this.pickList.selectionDescription = this.hisUiService.translate('common.picklist.selectionDescription');
        this.pickList.movingHint = this.hisUiService.translate('common.picklist.supplementaryHint');
      }
      if (this.orderList) {
        this.orderList.upButtonAriaLabel = this.hisUiService.translate('common.angleUp');
        this.orderList.topButtonAriaLabel = this.hisUiService.translate('common.angleDoubleUp');
        this.orderList.downButtonAriaLabel = this.hisUiService.translate('common.angleDown');
        this.orderList.bottomButtonAriaLabel = this.hisUiService.translate('common.angleDoubleDown');
        this.orderList.selectionDescription = this.hisUiService.translate('common.picklist.selectionDescription');
        this.orderList.movingHint = this.hisUiService.translate('common.picklist.supplementaryHint');
      }
      if (this.autoComplete) {
        this.autoComplete.emptyMessage = this.hisUiService.translate('common.noResultsFound');
      }
      // only add buttonTitle if no p-autocomplete title is set
      if (this.autoComplete && !this.autoComplete.el.nativeElement.title) {
        this.autoComplete.buttonTitle = this.hisUiService.translate('autoComplete.dropdown.title');
        this.autoComplete.appendTo = 'body';
      }
      if (this.chips) {
        this.chips.buttonTitle = this.hisUiService.translate('common.delete');
      }
      if (this.sortIcon) {
        this.sortIcon.sortableLabel = this.hisUiService.translate('table.sortableColumn');
      }
      if (this.treeTableSortIcon) {
        this.treeTableSortIcon.sortableLabel = this.hisUiService.translate('table.sortableColumn');
      }
      // Seite 1 standardmäßig als aktive Seite setzen
      if (this.table || this.treeTable) {
        let elementsByTagName = document.getElementsByTagName('p-paginator');
        for (let i in elementsByTagName) {
          if (elementsByTagName[i]) {
            /* eslint-disable max-len */
            if (elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[2]?.children) {
              let innerHTML = elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[2]?.innerHTML;
              if (innerHTML?.indexOf('p-highlight') >= 0) {
                elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[2]?.getElementsByTagName('button')?.[0]?.setAttribute('title', this.hisUiService.translate('common.activePage') + ': ' + elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[2]?.children[0]?.innerHTML);
                elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[2]?.getElementsByTagName('button')?.[0]?.setAttribute('aria-label', this.hisUiService.translate('common.activePage') + ': ' + elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[2]?.children[0]?.innerHTML);
              }
              /* eslint-enable max-len */
            }
          }
        }
      }
      if (this.overlayPanel) {
        this.setCloseTitle(this.overlayPanel);
      }
      if (this.steps) {
        /* eslint-disable max-len */
        this.steps.currentlyActive = this.hisUiService.translate('common.currently.active') + ' ' + this.hisUiService.translate('common.step') + ' ';
        /* eslint-disable max-len */
        this.steps.currentlyNotActive = this.hisUiService.translate('common.currently.not.active') + ' ' + this.hisUiService.translate('common.step') + ' ';
      }
    }
    ngDoCheck() {
      if (this.table && this.sortIcon) {
        if (this.table.sortMode === 'multiple') {
          this.setMultipleSortLabel();
        }
      }
      if (this.table || this.treeTable) {
        this.setActivePageTitle();
      }
    }
    ngAfterViewInit() {
      if (this.table || this.treeTable) {
        let dropdowns = this.el.nativeElement.querySelectorAll('p-dropdown .p-dropdown-trigger');
        for (let dropdown of dropdowns) {
          dropdown.setAttribute('aria-label', this.hisUiService.translate('autoComplete.dropdown.title'));
        }
      }
    }
    onMouseEnter(event) {
      this.setActivePageTitle();
    }
    setCloseTitle(component) {
      component.buttonTitle = this.hisUiService.translate('image.alt.minus_circ');
    }
    /** Setzt das aria-label für den p-paginator für Komponenten, welche den diesen als Attribut [paginator]="true" einbinden */
    /** Wichtig: Neue Komponenten, welche das Attribut [paginator] verfügen, müssen hier ergänzt werden (vgl. z. B. p-table) */
    setActivePageTitle() {
      if (this.table || this.treeTable) {
        let elementsByTagName = document.getElementsByTagName('p-paginator');
        for (let i in elementsByTagName) {
          if (elementsByTagName[i]) {
            /* eslint-disable max-len */
            elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[0]?.children[0]?.setAttribute('aria-label', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.first'));
            elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[0]?.children[0]?.setAttribute('title', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.first'));
            elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[1]?.children[0]?.setAttribute('aria-label', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.previous'));
            elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[1]?.children[0]?.setAttribute('title', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.previous'));
            // Prüfen, ob das Attribut [rowsPerPageOptions] und damit ein weiteres li am Ende der Paginatorliste existiert -> Dann length - 2, ansonsten length - 3
            if (elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 3]?.innerHTML?.indexOf('p-paginator-page') >= 0) {
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 2]?.children[0]?.setAttribute('aria-label', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.next'));
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 2]?.children[0]?.setAttribute('title', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.next'));
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 1]?.children[0]?.setAttribute('aria-label', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.last'));
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 1]?.children[0]?.setAttribute('title', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.last'));
              for (let j = 2; j < elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 2; j++) {
                if (elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.children) {
                  let innerHTML = elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.innerHTML;
                  if (innerHTML?.indexOf('p-highlight') >= 0) {
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.setAttribute('title', this.hisUiService.translate('common.activePage') + ': ' + elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.children[0]?.innerHTML);
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.setAttribute('aria-label', this.hisUiService.translate('common.activePage') + ': ' + elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.children[0]?.innerHTML);
                  } else if (innerHTML?.indexOf('p-highlight') < 0 && elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.getAttribute('title')) {
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.removeAttribute('title');
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.removeAttribute('aria-label');
                  }
                }
              }
            } else {
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 3]?.children[0]?.setAttribute('aria-label', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.next'));
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 3]?.children[0]?.setAttribute('title', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.next'));
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 2]?.children[0]?.setAttribute('aria-label', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.last'));
              elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 2]?.children[0]?.setAttribute('title', this.hisUiService.translate('de.his.faces.tags.table.datascroller.title.last'));
              for (let j = 2; j < elementsByTagName[i].children?.[0]?.children?.[0]?.children.length - 3; j++) {
                if (elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.children) {
                  let innerHTML = elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.innerHTML;
                  if (innerHTML?.indexOf('p-highlight') >= 0) {
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.setAttribute('title', this.hisUiService.translate('common.activePage') + ': ' + elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.children[0]?.innerHTML);
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.setAttribute('aria-label', this.hisUiService.translate('common.activePage') + ': ' + elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.children[0]?.innerHTML);
                  } else if (innerHTML?.indexOf('p-highlight') < 0 && elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.getAttribute('title')) {
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.removeAttribute('title');
                    elementsByTagName[i].children?.[0]?.children?.[0]?.children?.[j]?.getElementsByTagName('button')?.[0]?.removeAttribute('aria-label');
                  }
                }
              }
            }
          }
        }
      }
    }
    // #285156: Barrierefreiheit der p-table bei sortMode="multiple"
    setMultipleSortLabel() {
      /* eslint-disable max-len */
      if (this.sortIcon.getBadgeValue() === 0) {
        this.sortIcon.sortableLabel = this.hisUiService.translate('table.sortableColumn') + '. ' + this.hisUiService.translate('table.sortableColumn.multipleSort');
      } else {
        /* eslint-disable max-len */
        this.sortIcon.sortableLabel = '';
        this.sortIcon.sortableLabel = this.hisUiService.translate('table.sortableColumn') + '. ' + this.hisUiService.translate('table.sortableColumn.multipleSort') + '. ' + this.hisUiService.translate('table.sortableColumn.multipleSort.sortingPriority') + ' ' + this.sortIcon.getBadgeValue();
      }
    }
    static {
      this.ɵfac = function HisButtonTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisButtonTitleDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisButtonTitleDirective,
        selectors: [["p-confirmDialog"], ["p-dialog"], ["p-autoComplete"], ["p-panel"], ["p-treeTableToggler"], ["p-tabPanel"], ["p-chips"], ["p-pickList"], ["p-orderList"], ["p-paginator"], ["", "paginator", ""], ["", "buttonTitle", ""], ["p-table"], ["p-treeTable"], ["p-steps"], ["p-tableHeaderCheckbox"], ["p-sortIcon"], ["p-treeTableSortIcon"], ["", "sortMode", ""], ["p-overlayPanel"], ["", "templatRight", ""]],
        hostBindings: function HisButtonTitleDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function HisButtonTitleDirective_click_HostBindingHandler($event) {
              return ctx.onMouseEnter($event);
            });
          }
        },
        exportAs: ["p-confirmDialog", "p-dialog", "p-autoComplete", "p-panel", "p-treeTableToggler", "p-tabPanel", "p-chips", "p-pickList", "p-orderList", "p-paginator", "p-table", "p-treeTable", "p-steps", "p-tableHeaderCheckbox", "p-sortIcon", "[sortMode]", "p-overlayPanel", "[templatRight]"],
        standalone: false
      });
    }
  }
  return HisButtonTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$D = ["inputElement"];
function HisSearchSelectAutocompleteComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r2.label, " ");
  }
}
let HisSearchSelectAutocompleteComponent = /*#__PURE__*/(() => {
  class HisSearchSelectAutocompleteComponent {
    constructor() {
      this.searchService = inject(HisSearchService);
      // filter selected Options
      this.removeSelectedOptionsFromDropdown = false;
      // minimum length of autocomplete input to trigger a search
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete (null -> show all)
      this.limit = null;
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      this.isFirstInputElement = false;
      // suggestions for autocomplete
      this.filteredSelectList = [];
      // previous autocomplete input string
      this.lastAutocompleteQuery = undefined;
      this.selected = new EventEmitter();
    }
    ngOnInit() {
      if (this.minLength === 0) {
        // we need suggestions from the start
        let requestedCount = this.limit ? this.limit.toString() : 'all';
        console.log('HisSearchSelectAutocompleteComponent.ngOnInit(): Request ' + requestedCount + ' options of entity', this.searchEntity, 'from backend...');
        this.loadFilteredOptions('');
        this.lastAutocompleteQuery = '';
      }
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    /**
     * Find dropdown suggestions. The event should only fire if the autocomplete input length >= minLength
     *
     * @param $event event
     */
    filterSelectList($event) {
      let autocompleteQuery = $event.query;
      console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): event =', $event, ', query =', autocompleteQuery);
      // Produce filteredSelectList:
      // * If the new query contains the previous one, then we filter the last filtering result again
      // * If the new query does not contain the last one (because some characters were removed from the
      //   autocomplete input field), then we have access the backend
      // * Case is ignored.
      console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): Old filteredSelectList =', this.filteredSelectList, ', lastAutocompleteQuery =', this.lastAutocompleteQuery);
      if (this.lastAutocompleteQuery && autocompleteQuery.indexOf(this.lastAutocompleteQuery) > -1) {
        let nextList = [];
        let listElem;
        for (listElem of this.filteredSelectList) {
          if (listElem.label.toUpperCase().indexOf(autocompleteQuery.toUpperCase()) > -1) {
            nextList.push(listElem);
          }
        }
        this.filteredSelectList = nextList;
        console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): Filtered options on client, new filteredSelectList =', this.filteredSelectList);
      } else {
        console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): Request options of entity', this.searchEntity, 'with defaulttext like *' + autocompleteQuery + '* from backend...');
        this.loadFilteredOptions(autocompleteQuery);
      }
      this.lastAutocompleteQuery = autocompleteQuery;
    }
    loadFilteredOptions(autocompleteQuery) {
      this.searchService.loadFilteredOptions(this.searchConfigFile, autocompleteQuery, this.limit).subscribe(result => {
        if (result) {
          this.filteredSelectList = result;
          console.log('HisSearchSelectAutocompleteComponent.loadFilteredOptions(): ' + 'filteredSelectList obtained from backend =', this.filteredSelectList);
        }
      });
    }
    filterSelectedOptions(result) {
      //only filter if is set to true
      if (!this.removeSelectedOptionsFromDropdown) {
        return result;
      }
      let selectedOptions = this.selectedOptions;
      let filteredResult = [];
      for (let i = 0; result.length > i; i++) {
        if (!this.isElementAlreadySelected(result[i].id)) {
          filteredResult.push(result[i]);
        }
      }
      return filteredResult;
    }
    // same function as in search-select, but basically they do differnet things:
    isElementAlreadySelected(id) {
      // console.log( 'id =', id, 'has type', typeof id );
      for (let option of this.selectedOptions) {
        let optionId = option.id;
        // TODO According to class HisOption the option.id should be of string type
        // But obviously the search result obtained from the REST service contains number ids...
        // console.log( 'optionId =', optionId, 'has type', typeof optionId );
        if (id === optionId.toString()) {
          return true;
        }
      }
      return false;
    }
    limitResult(result) {
      if (this.limit != null && result.length > this.limit) {
        result = result.slice(0, this.limit);
      }
      return result;
    }
    /**
     * Pass element selected to wrapping component.
     */
    emitSelectedElement() {
      this.selected.emit(this.selectedElement);
    }
    static {
      this.ɵfac = function HisSearchSelectAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchSelectAutocompleteComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchSelectAutocompleteComponent,
        selectors: [["his-search-select-autocomplete"]],
        viewQuery: function HisSearchSelectAutocompleteComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$D, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          uid: "uid",
          removeSelectedOptionsFromDropdown: "removeSelectedOptionsFromDropdown",
          selectedOptions: "selectedOptions",
          searchEntity: "searchEntity",
          searchConfigFile: "searchConfigFile",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          isFirstInputElement: "isFirstInputElement"
        },
        outputs: {
          selected: "selected"
        },
        standalone: false,
        decls: 3,
        vars: 6,
        consts: [["inputElement", ""], ["field", "nonexistingdummy", 3, "ngModelChange", "completeMethod", "onSelect", "inputId", "ngModel", "suggestions", "minLength", "dropdown", "forceSelection"], ["pTemplate", "item"]],
        template: function HisSearchSelectAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-autoComplete", 1, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchSelectAutocompleteComponent_Template_p_autoComplete_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedElement, $event) || (ctx.selectedElement = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisSearchSelectAutocompleteComponent_Template_p_autoComplete_completeMethod_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterSelectList($event));
            })("onSelect", function HisSearchSelectAutocompleteComponent_Template_p_autoComplete_onSelect_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitSelectedElement());
            });
            i0.ɵɵtemplate(2, HisSearchSelectAutocompleteComponent_ng_template_2_Template, 1, 1, "ng-template", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("inputId", ctx.uid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectedElement);
            i0.ɵɵproperty("suggestions", ctx.filteredSelectList)("minLength", ctx.minLength)("dropdown", ctx.showDropdownIcon)("forceSelection", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2.PrimeTemplate, i2$1.AutoComplete, HisModificationDetectionDirective, HisButtonTitleDirective],
        encapsulation: 2
      });
    }
  }
  return HisSearchSelectAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisEnumUtils {
  /**
   * Gets all values from an enum as string array
   * <p>a little bit generics would be nice</p>
   *
   * @param param an enum
   */
  static getValues(param) {
    let values = [];
    for (const key of Object.keys(param)) {
      values.push(param[key]);
    }
    return values;
  }
}
const _c0$C = ["inputElement"];
let HisSearchSelectOperatorComponent = /*#__PURE__*/(() => {
  class HisSearchSelectOperatorComponent {
    constructor() {
      this.searchService = inject(HisSearchService);
      this.hisUiService = inject(HisUiService);
      this.isFirstInputElement = false;
      this.currentOperators = [];
      this.operators = HisEnumUtils.getValues(HisSelectOperatorType);
    }
    ngOnInit() {
      // console.log('his-search-select-operator#ngOnInit() #tooltip', this.tooltip);
      this.initializeResetInputs();
      this.setResetInputs(false);
      this.initializeSelectOperator();
      console.log('his-search-select-operator#ngOnInit() #this.widget.not', this.widget.not);
      /* Falls "Suche ändern" und unequal im Suchformular ausgewählt war */
      if (this.widget.not) {
        this.selectedOperator = HisSelectOperatorType.UNEQUAL;
        this.tooltip = this.hisUiService.translate('genericSearch.operator.notequal');
      } else {
        this.selectedOperator = HisSelectOperatorType.EQUAL;
        this.tooltip = this.hisUiService.translate('genericSearch.operator.equal');
      }
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    selectOperator() {
      if (this.selectedOperator === HisSelectOperatorType.UNEQUAL) {
        this.widget.not = true;
        this.tooltip = this.hisUiService.translate('genericSearch.operator.notequal');
        return;
      }
      this.tooltip = this.hisUiService.translate('genericSearch.operator.equal');
      this.widget.not = false;
    }
    completeMethod($event) {
      this.currentOperators = []; // ohne Neu-Initialisierung funktioniert es nicht
      for (let operator of this.operators) {
        this.currentOperators.push(operator);
      }
    }
    /* Wenn der Button 'Eingaben zurücksetzen' gedrückt wird,
     * muss das Auswahlfeld für Suchsets die leere Option anzeigen*/
    initializeResetInputs() {
      this.searchService.resetInputs.subscribe(resetInputs => {
        if (resetInputs) {
          if (this.widget) {
            this.widget.not = false;
          }
          this.selectedOperator = HisSelectOperatorType.EQUAL;
        }
      });
    }
    initializeSelectOperator() {
      this.searchService.selectOperator.subscribe(operatorTrigger => {
        if (operatorTrigger === undefined) {
          return;
        }
        let trigger = operatorTrigger;
        if (trigger.getWidget().kind !== this.widget.kind) {
          return;
        }
        if (trigger.getWidget().id !== this.widget.id) {
          return;
        }
        if (trigger.getOperator() === HisSelectOperatorType.UNEQUAL) {
          this.widget.not = true;
          this.selectedOperator = HisSelectOperatorType.UNEQUAL;
          return;
        }
        if (trigger.getOperator() === HisSelectOperatorType.EQUAL) {
          this.widget.not = false;
          this.selectedOperator = HisSelectOperatorType.EQUAL;
          return;
        }
      });
    }
    setResetInputs(resetInputs) {
      this.searchService.setResetInputs(resetInputs);
    }
    static {
      this.ɵfac = function HisSearchSelectOperatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchSelectOperatorComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchSelectOperatorComponent,
        selectors: [["his-search-select-operator"]],
        viewQuery: function HisSearchSelectOperatorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$C, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          widget: "widget",
          isFirstInputElement: "isFirstInputElement"
        },
        standalone: false,
        decls: 6,
        vars: 9,
        consts: [["inputElement", ""], [1, "dropdownEqualOperator"], [3, "ngModelChange", "completeMethod", "onSelect", "ngModel", "suggestions", "dropdown", "title"], [1, "p-sr-only", 3, "id"]],
        template: function HisSearchSelectOperatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "p-autoComplete", 2, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchSelectOperatorComponent_Template_p_autoComplete_ngModelChange_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedOperator, $event) || (ctx.selectedOperator = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisSearchSelectOperatorComponent_Template_p_autoComplete_completeMethod_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.completeMethod($event));
            })("onSelect", function HisSearchSelectOperatorComponent_Template_p_autoComplete_onSelect_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectOperator());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "hisUi");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectedOperator);
            i0.ɵɵproperty("suggestions", ctx.currentOperators)("dropdown", true)("title", ctx.tooltip);
            i0.ɵɵattribute("aria-labelledby", ctx.widget.label);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("id", ctx.widget.label);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, ctx.widget.label), " ");
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2$1.AutoComplete, HisModificationDetectionDirective, HisButtonTitleDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchSelectOperatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$B = ["inputElement"];
let HisSearchInputComponent = /*#__PURE__*/(() => {
  class HisSearchInputComponent {
    constructor() {
      this.isFirstInputElement = false;
      this.changed = new EventEmitter(); // type matches widget.value type
    }
    ngAfterViewInit() {
      // Set name attribute for input autocomplete. Setting it directly in <input /> does not work 
      const sanitizedLabel = this.getSanitizedLabel();
      if (sanitizedLabel !== undefined) {
        this.inputElement.nativeElement.setAttribute('name', sanitizedLabel);
      }
      // Set focus on first input element unless input is in a wizard
      if (this.isFirstInputElement && document.querySelector('.wizardSteps') === null) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    getHtmlFocusElementId() {
      return this.widget.uid;
    }
    change(changes) {
      console.log('HisSearchInputComponent.change(): Emit event', changes);
      this.changed.emit(changes);
    }
    getPlaceholder() {
      return this.widget.placeholder ? this.widget.placeholder : '';
    }
    getSanitizedLabel() {
      return this.widget.label.replace(/[^a-zA-Z0-9]/g, '_');
    }
    static {
      this.ɵfac = function HisSearchInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchInputComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchInputComponent,
        selectors: [["his-search-input"]],
        viewQuery: function HisSearchInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$B, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          widget: "widget",
          isFirstInputElement: "isFirstInputElement"
        },
        outputs: {
          changed: "changed"
        },
        standalone: false,
        decls: 3,
        vars: 6,
        consts: [["inputElement", ""], ["pInputText", "", "autocomplete", "on", 2, "width", "100%", 3, "ngModelChange", "input", "id", "ngModel", "type", "placeholder"]],
        template: function HisSearchInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "input", 1, 0);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchInputComponent_Template_input_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.widget.value, $event) || (ctx.widget.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("input", function HisSearchInputComponent_Template_input_input_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.change(ctx.widget.value));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.widget.uid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.widget.value);
            i0.ɵɵproperty("type", ctx.widget.type)("placeholder", i0.ɵɵpipeBind1(2, 4, ctx.getPlaceholder()));
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, HisModificationDetectionDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$A = ["inputElement"];
let HisSearchCheckboxComponent = /*#__PURE__*/(() => {
  class HisSearchCheckboxComponent {
    constructor() {
      this.isFirstInputElement = false;
      this.changed = new EventEmitter();
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    getHtmlFocusElementId() {
      return this.widget.uid;
    }
    change($event) {
      console.log('HisSearchCheckboxComponent.change(): Emit event', $event);
      this.changed.emit($event);
    }
    static {
      this.ɵfac = function HisSearchCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchCheckboxComponent,
        selectors: [["his-search-checkbox"]],
        viewQuery: function HisSearchCheckboxComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$A, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          widget: "widget",
          isFirstInputElement: "isFirstInputElement"
        },
        outputs: {
          changed: "changed"
        },
        standalone: false,
        decls: 5,
        vars: 7,
        consts: [["inputElement", ""], ["type", "checkbox", 3, "ngModelChange", "change", "id", "ngModel", "hisDdKey"], ["aria-hidden", "false", 3, "for"]],
        template: function HisSearchCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "input", 1, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCheckboxComponent_Template_input_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.widget.value, $event) || (ctx.widget.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("change", function HisSearchCheckboxComponent_Template_input_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.change($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "label", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "hisUi");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.widget.uid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.widget.value);
            i0.ɵɵproperty("hisDdKey", ctx.widget.label);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", ctx.widget.uid);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, ctx.widget.label), "\n");
          }
        },
        encapsulation: 2
      });
    }
  }
  return HisSearchCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Sets default values for p-calendar component bindings that are universally used in H1.
 *
 * Default values are as follows:
 * showIcon: true
 * monthNavigator: true
 * yearNavigator: true
 * yearRange: 1900:2100
 * styleClass: calendarWidth40
 * placeholder: common.dateFormatPlaceholder
 * dateFormat: depending on localization
 * locale: depending on localization
 */
class HisCalendarDefaultsDirective {
  constructor() {
    this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    this.hisUiService = inject(HisUiService);
    this.config = inject(PrimeNGConfig);
    this.calendarRef = inject(Calendar);
  }
  static {
    this.languageToLocalesMap = new Map([['de', {
      firstDayOfWeek: 1,
      dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
      dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      today: 'Heute',
      clear: 'Löschen'
    }], ['en', {
      firstDayOfWeek: 0,
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear'
    }]]);
  }
  static getDateFormat(lang) {
    let dateFormat = HisDateUtils.languageToDateFormatsMap.get(lang);
    if (dateFormat) {
      return dateFormat;
    }
    console.log('HisCalendarDefaultsDirective.getDateFormat(): Language "' + lang + '" is not supported yet.' + 'Return dateFormat for default language "de".');
    return HisDateUtils.languageToDateFormatsMap.get('de');
  }
  ngAfterContentInit() {
    if (this.calendarRef) {
      if (!this.calendarRef.showIcon) {
        this.calendarRef.showIcon = true;
      }
      if (!this.calendarRef.monthNavigator) {
        this.calendarRef.monthNavigator = true;
      }
      if (!this.calendarRef.yearNavigator) {
        this.calendarRef.yearNavigator = true;
      }
      if (this.yearRange) {
        this.calendarRef.yearRange = this.yearRange;
      } else if (!this.calendarRef.yearRange) {
        this.calendarRef.yearRange = '1900:2100';
      }
      if (!this.calendarRef.styleClass) {
        this.calendarRef.styleClass = 'calendarWidth40';
      }
      if (!this.calendarRef.placeholder) {
        this.calendarRef.placeholder = this.hisUiService.translate('common.dateFormatPlaceholder');
      }
      // the calendar should not open on focus to avoid problems with test automation #219913
      this.calendarRef.showOnFocus = false;
      let lang = this.hisBaseGlobalsService.getLanguage();
      if (this.calendarRef._view === 'year') {
        this.calendarRef.dateFormat = 'yy';
      } else {
        this.calendarRef.dateFormat = HisCalendarDefaultsDirective.getDateFormat(lang);
      }
      this.config.setTranslation(HisCalendarDefaultsDirective.languageToLocalesMap.get(lang));
      this.calendarRef.ngOnInit();
    }
    // console.log( this.calendarRef );
  }
  /**
   * host listener onInput implementation to clear model if input was null or empty
   *
   * @param event KeyboardEvent originally is InputEvent
   * -> which is an experimental interface (@types/dom-inputevent) and currently not present in package.json.
   * Using workaround via KeyboardEvent
   */
  onInput(event) {
    const input = event.target.value;
    if (_.isEmpty(input)) {
      this.calendarRef.updateModel(null);
    }
  }
  clickEvent(event) {
    let spanClassNames = ['p-button-icon', 'pi', 'pi-calendar'];
    // eslint-disable-next-line max-len
    if (spanClassNames.some(spanClassName => event.target.classList.contains(spanClassName)) || event.target.classList.contains('p-datepicker-trigger')) {
      if (this.calendarRef.overlayVisible && this.calendarRef.overlay) {
        let offset = 25;
        let elementRect = this.calendarRef.overlay.getBoundingClientRect();
        if (elementRect.right > (window.innerWidth || document.documentElement.clientWidth)) {
          let newPosition = this.calendarRef.overlay.getBoundingClientRect().right - window.innerWidth + offset;
          this.calendarRef.overlay.style.left = '-' + newPosition.toString() + 'px';
        }
      }
    }
  }
  static {
    this.ɵfac = function HisCalendarDefaultsDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HisCalendarDefaultsDirective)();
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: HisCalendarDefaultsDirective,
      selectors: [["p-calendar"]],
      hostBindings: function HisCalendarDefaultsDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("onInput", function HisCalendarDefaultsDirective_onInput_HostBindingHandler($event) {
            return ctx.onInput($event);
          })("click", function HisCalendarDefaultsDirective_click_HostBindingHandler($event) {
            return ctx.clickEvent($event);
          });
        }
      },
      inputs: {
        yearRange: "yearRange"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$z = ["inputElement"];
/**
 * The calendar component used by the generic search.
 *
 * The value of a calendar component is stored in widget.value.
 * We have to store it as a string, because the generic search backend can not handle Date objects,
 * or at least not in the (UTC) format provided by p-calendar.
 *
 * On the other hand, p-calendar obliges us to store the string-values in the format matching the current locale...
 */
let HisSearchCalendarComponent = /*#__PURE__*/(() => {
  class HisSearchCalendarComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      // true if this is the first input element in the search mask
      this.isFirstInputElement = false;
      this.changed = new EventEmitter();
      this.inputChanged = new EventEmitter(); // type matches widget.value type
    }
    ngOnInit() {
      let value = this.widget.value;
      if (value) {
        // After a language change we can still get a value here but in the wrong date format
        console.log('HisSearchCalendarComponent: Current date widget.value =', this.widget.value);
        // Unfortunately in that case we do not know the previous date format, so we have to guess it.
        // This will work for german and english, but cannot be guaranteed for other locales.
        let dd;
        let mm;
        let yyyy;
        let lang = this.hisBaseGlobalsService.getLanguage();
        if (value.indexOf('/') >= 0 && lang === 'de') {
          // the value is still in english date format, but the locale changed to german
          let p1 = value.indexOf('/');
          mm = value.substring(0, p1);
          let p2 = value.indexOf('/', p1 + 1);
          dd = value.substring(p1 + 1, p2);
          yyyy = value.substring(p2 + 1);
        } else if (value.indexOf('.') >= 0 && lang === 'en') {
          // the value is still in german date format, but the locale changed to english
          let p1 = value.indexOf('.');
          dd = value.substring(0, p1);
          let p2 = value.indexOf('.', p1 + 1);
          mm = value.substring(p1 + 1, p2);
          yyyy = value.substring(p2 + 1);
        }
        if (dd && mm && yyyy) {
          let dateFormat = HisCalendarDefaultsDirective.getDateFormat(lang);
          let dateStr = dateFormat.replace('dd', dd).replace('mm', mm).replace('yy', yyyy);
          console.log('HisSearchCalendarComponent: Changed date to ', dateStr);
          this.widget.value = dateStr;
        }
      }
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    getHtmlFocusElementId() {
      return this.widget.uid;
    }
    inputChange(changes) {
      console.log('HisSearchCalendarComponent.inputChange(): Emit event', changes);
      this.changed.emit(changes);
    }
    calendarChange() {
      console.log('Received date change event for widget', this.widget.id, '. Re-emit new date value', this.calendarValue);
      console.log('his-search-calendar.component#calendarChange() #this.calendarValue', this.calendarValue);
      if (!this.calendarValue && this.widget.value) {
        this.calendarValue = this.widget.value;
      }
      this.widget.value = this.calendarValue;
      this.changed.emit(this.calendarValue);
    }
    static {
      this.ɵfac = function HisSearchCalendarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchCalendarComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchCalendarComponent,
        selectors: [["his-search-calendar"]],
        viewQuery: function HisSearchCalendarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$z, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          widget: "widget",
          isFirstInputElement: "isFirstInputElement"
        },
        outputs: {
          changed: "changed",
          inputChanged: "inputChanged"
        },
        standalone: false,
        decls: 4,
        vars: 6,
        consts: [["inputElement", ""], [1, "slInputWrap"], ["pInputText", "", 1, "calendarWidth100", 3, "ngModelChange", "input", "id", "ngModel", "type"], ["dataType", "string", "appendTo", "body", 1, "hidden-p-inputtext", 3, "ngModelChange", "readonlyInput", "ngModel", "tabindex"]],
        template: function HisSearchCalendarComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "input", 2, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCalendarComponent_Template_input_ngModelChange_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.widget.value, $event) || (ctx.widget.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("input", function HisSearchCalendarComponent_Template_input_input_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.inputChange(ctx.widget.value));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p-calendar", 3);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCalendarComponent_Template_p_calendar_ngModelChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.calendarValue, $event) || (ctx.calendarValue = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function HisSearchCalendarComponent_Template_p_calendar_ngModelChange_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.calendarChange());
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.widget.uid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.widget.value);
            i0.ɵɵproperty("type", ctx.widget.type);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("readonlyInput", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.calendarValue);
            i0.ɵɵproperty("tabindex", -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2$2.Calendar, HisCalendarDefaultsDirective, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return HisSearchCalendarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$y = ["inputElement"];
function HisSearchAutocompleteComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "his-search-select-operator", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("widget", ctx_r1.widget);
  }
}
function HisSearchAutocompleteComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r3.label, " ");
  }
}
let HisSearchAutocompleteComponent = /*#__PURE__*/(() => {
  class HisSearchAutocompleteComponent {
    constructor() {
      this.uiService = inject(HisUiService);
      this.searchService = inject(HisSearchService);
      // minimum length of autocomplete input to trigger a search
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete
      this.limit = null;
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      this.showUnequalOption = false;
      // true if this is the first input element in the search mask
      this.isFirstInputElement = false;
      // suggestions for autocomplete
      this.filteredSelectList = [];
      // previous autocomplete input string
      this.lastAutocompleteQuery = undefined;
      this.toolTip = '';
      this.currentAutocompleteQuery = new Subject();
      // true, if a selectFrom method call returned less results than the limit.
      // this means no subsequent rest calls are necessary
      this.hasLessResultsThanLimit = false;
      // emits the id of the selected element
      this.changed = new EventEmitter();
    }
    static {
      this.DEFAULT_LIMIT = 100;
    }
    ngOnInit() {
      this.widget.options.subscribe(values => {
        this.options = [];
        // avoid that the null item is added twice
        if (values) {
          // the label for the null item should be '', see #210958
          // the empty selection should always be available on the top of the options list, see #325731
          this.options.push({
            id: null,
            label: ''
          });
          if (this.widget.showNullItem) {
            // (nicht gefüllt)/(value not existing) should be the second option of the options list, see #325731
            let nullValueLabel = this.uiService.translate('genericSearch.nullValueMenuEntry');
            this.options.push({
              id: 'ISNULL',
              label: nullValueLabel
            });
            console.log('widget.value', this.widget.value);
            let option = this.widget.value;
            if (option && option.id === 'ISNULL') {
              option.label = nullValueLabel;
              this.widget.value = option;
            }
          }
          this.options = this.options.concat(values);
          console.log('Obtained options for widget', this.widget.id, ':', this.options);
        }
      });
      const debounceDelay = GenericSearchUtil.isLazySelectFrom(this.selectFrom, this.showDropdownIcon) ? 200 : 0;
      this.currentAutocompleteQuery.pipe(debounceTime(debounceDelay)).subscribe(query => {
        this.filterSelectList(query);
      });
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.inputEL.nativeElement.focus());
      }
    }
    getHtmlFocusElementId() {
      return this.widget.uid;
    }
    onUpdateInput($event) {
      let autocompleteQuery = $event.query;
      console.log('HisSearchAutocompleteComponent.onUpdateQuery(): event =', $event, ', query =', autocompleteQuery);
      if (!this.showDropdownIcon && (!autocompleteQuery || autocompleteQuery.length < this.minLength)) {
        return;
      }
      this.currentAutocompleteQuery.next(autocompleteQuery);
    }
    /**
     * Find dropdown suggestions. The event should only fire if the autocomplete input length >= minLength
     *
     * @param $event event containing the input field value
     */
    filterSelectList(autocompleteQuery) {
      if (GenericSearchUtil.isLazySelectFrom(this.selectFrom, this.showDropdownIcon)) {
        this.filterOptionsByMethod(autocompleteQuery);
      } else {
        this.filterOptionsByList(autocompleteQuery);
      }
      this.lastAutocompleteQuery = autocompleteQuery;
    }
    filterOptionsByList(autocompleteQuery) {
      // Produce filteredSelectList:
      // * If the new query contains the previous one, then we filter the last filtering result again
      // * If the new query does not contain the last one (because some characters were removed from the
      //   autocomplete input field), then we filter 'options'
      // * Case is ignored.
      console.log('HisSearchAutocompleteComponent.filterOptionsByList(): query =', autocompleteQuery);
      console.log('HisSearchAutocompleteComponent.filterSelectList(): Old filteredSelectList =', this.filteredSelectList, ', lastAutocompleteQuery =', this.lastAutocompleteQuery);
      let srcList = this.lastAutocompleteQuery && autocompleteQuery.indexOf(this.lastAutocompleteQuery) > -1 ? this.filteredSelectList : this.options;
      this.filteredSelectList = this.reduceFilteredOptions(srcList, autocompleteQuery);
      console.log('HisSearchAutocompleteComponent.filterSelectList(): Filtered options on client, new filteredSelectList =', this.filteredSelectList);
    }
    filterOptionsByMethod(autocompleteQuery) {
      console.log('HisSearchAutocompleteComponent.filterOptionsByMethod(): query =', autocompleteQuery);
      console.log('HisSearchAutocompleteComponent.filterOptionsByMethod(): Old filteredSelectList =', this.filteredSelectList, ', lastAutocompleteQuery =', this.lastAutocompleteQuery);
      const hasNarrowedQuery = this.lastAutocompleteQuery && autocompleteQuery.indexOf(this.lastAutocompleteQuery) > -1;
      if (hasNarrowedQuery && this.hasLessResultsThanLimit) {
        this.filteredSelectList = this.reduceFilteredOptions(this.filteredSelectList, autocompleteQuery);
      } else {
        this.loadFilteredOptions(autocompleteQuery);
      }
    }
    reduceFilteredOptions(srcList, query) {
      let nextList = [];
      let listElem;
      for (listElem of srcList) {
        if (listElem.label.toUpperCase().indexOf(query.toUpperCase()) > -1) {
          nextList.push(listElem);
        }
      }
      return nextList;
    }
    loadFilteredOptions(autocompleteQuery) {
      const usedLimit = this.limit ? this.limit : HisSearchAutocompleteComponent.DEFAULT_LIMIT;
      this.searchService.loadFilteredSelectOptions(this.configFile, this.selectFrom, autocompleteQuery, usedLimit).subscribe(result => {
        if (result) {
          this.filteredSelectList = result;
          console.log('HisSearchAutocompleteComponent.loadFilteredOptions(): ' + 'filteredSelectList obtained from backend =', this.filteredSelectList);
          this.hasLessResultsThanLimit = result.length < usedLimit;
        }
      });
    }
    /**
     * The input field content has been deleted -> set model value to null.
     */
    onClear() {
      this.widget.value = null;
      this.emitSelectedElement();
    }
    /**
     * Pass selected element to wrapping component.
     */
    emitSelectedElement() {
      this.toolTip = this.widget.value?.label;
      this.changed.emit(this.widget.value);
    }
    static {
      this.ɵfac = function HisSearchAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchAutocompleteComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchAutocompleteComponent,
        selectors: [["his-search-autocomplete"]],
        viewQuery: function HisSearchAutocompleteComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$y, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          widget: "widget",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          showUnequalOption: "showUnequalOption",
          isFirstInputElement: "isFirstInputElement",
          selectFrom: "selectFrom",
          configFile: "configFile"
        },
        outputs: {
          changed: "changed"
        },
        standalone: false,
        decls: 6,
        vars: 8,
        consts: [["inputElement", ""], [1, "slInputWrap"], [1, "dropdownEqualOperator"], [1, "dropdownEqualOperatorSibling"], ["field", "label", 3, "ngModelChange", "completeMethod", "onSelect", "onClear", "inputId", "ngModel", "suggestions", "minLength", "dropdown", "forceSelection", "title"], ["pTemplate", "item"], [3, "widget"]],
        template: function HisSearchAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HisSearchAutocompleteComponent_Conditional_1_Template, 2, 1, "div", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "p-autoComplete", 4, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchAutocompleteComponent_Template_p_autoComplete_ngModelChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.widget.value, $event) || (ctx.widget.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisSearchAutocompleteComponent_Template_p_autoComplete_completeMethod_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onUpdateInput($event));
            })("onSelect", function HisSearchAutocompleteComponent_Template_p_autoComplete_onSelect_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitSelectedElement());
            })("onClear", function HisSearchAutocompleteComponent_Template_p_autoComplete_onClear_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClear());
            });
            i0.ɵɵtemplate(5, HisSearchAutocompleteComponent_ng_template_5_Template, 1, 1, "ng-template", 5);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showUnequalOption ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("inputId", ctx.widget.uid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.widget.value);
            i0.ɵɵproperty("suggestions", ctx.filteredSelectList)("minLength", ctx.minLength)("dropdown", ctx.showDropdownIcon)("forceSelection", true)("title", ctx.toolTip);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2.PrimeTemplate, i2$1.AutoComplete, HisModificationDetectionDirective, HisButtonTitleDirective, HisSearchSelectOperatorComponent],
        encapsulation: 2
      });
    }
  }
  return HisSearchAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$x = ["inputElement"];
function HisSearchMultiselectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "his-search-select-operator", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("widget", ctx_r1.widget);
  }
}
function HisSearchMultiselectComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r3.label, " ");
  }
}
function HisSearchMultiselectComponent_Conditional_10_ng_template_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 13);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisSearchMultiselectComponent_Conditional_10_ng_template_1_For_3_Template_button_click_2_listener($event) {
      const selectedOption_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.deleteSelectedOption(selectedOption_r5));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOption_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r5.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 2, "view.controls.remove"));
  }
}
function HisSearchMultiselectComponent_Conditional_10_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "ul");
    i0.ɵɵrepeaterCreate(2, HisSearchMultiselectComponent_Conditional_10_ng_template_1_For_3_Template, 4, 4, "li", 12, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedOptions_r6);
  }
}
function HisSearchMultiselectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 8);
    i0.ɵɵtemplate(1, HisSearchMultiselectComponent_Conditional_10_ng_template_1_Template, 4, 0, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.selectedOptions)("emptyMessage", "\u00A0");
  }
}
let HisSearchMultiselectComponent = /*#__PURE__*/(() => {
  class HisSearchMultiselectComponent {
    constructor() {
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      // The selection
      this.selectedOptions = [];
      // minimum length of autocomplete input to trigger a search
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete (null -> show all)
      this.limit = null; // XXX currently unused
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      // true if this is the first input element in the search mask
      this.isFirstInputElement = false;
      // all selectable options
      this.options = [];
      // suggestions for autocomplete
      this.filteredSelectList = [];
      // previous autocomplete input string
      this.lastAutocompleteQuery = undefined;
      this.changed = new EventEmitter();
      this.showUnequalOption = false;
    }
    ngOnInit() {
      this.widget.options.subscribe(values => {
        this.options = [];
        // avoid that the null item is added twice
        if (values) {
          if (this.widget.showNullItem || this.showNullItem) {
            // (nicht gefüllt)/(value not existing) should be the second option of the options list, see #325731
            let nullValueLabel = this.uiService.translate('genericSearch.nullValueMenuEntry');
            this.options.push({
              id: 'ISNULL',
              label: nullValueLabel
            });
            console.log('widget.value', this.widget.value);
            let valueOptions = this.widget.value;
            for (let opt of valueOptions) {
              if (opt.id === 'ISNULL') {
                opt.label = nullValueLabel;
                this.widget.value.push(opt);
              }
            }
          }
          if (this.widget.kind !== 'multi-dropdown') {
            // the label for the null item should be '', see #210958
            // the empty selection should always be available on the top of the options list, see #325731
            // if this.widget.kind === 'multiselect', we don't need the empty selection
            this.options.push({
              id: null,
              label: ''
            });
          }
          this.options = this.options.concat(values);
          console.log('Obtained options for widget', this.widget.id, '=', this.options);
        }
      });
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.inputEL.nativeElement.focus());
      }
    }
    getHtmlFocusElementId() {
      return this.uid;
    }
    /**
     * Find dropdown suggestions. The event should only fire if the autocomplete input length >= minLength
     *
     * @param $event event containing the input field value
     */
    filterSelectList($event) {
      let autocompleteQuery = $event.query;
      console.log('HisSearchMultiselectComponent.filterSelectList(): event =', $event, ', query =', autocompleteQuery);
      // Produce filteredSelectList:
      // * If the new query contains the previous one, then we filter the last filtering result again
      // * If the new query does not contain the last one (because some characters were removed from the
      //   autocomplete input field), then we filter 'options'
      // * Case is ignored.
      console.log('HisSearchMultiselectComponent.filterSelectList(): Old filteredSelectList =', this.filteredSelectList, ', lastAutocompleteQuery =', this.lastAutocompleteQuery);
      let srcList = this.lastAutocompleteQuery && autocompleteQuery.indexOf(this.lastAutocompleteQuery) > -1 ? this.filteredSelectList : this.options;
      let nextList = [];
      let listElem;
      for (listElem of srcList) {
        if (listElem.label.toUpperCase().indexOf(autocompleteQuery.toUpperCase()) > -1) {
          nextList.push(listElem);
        }
      }
      this.filteredSelectList = nextList.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      console.log('HisSearchMultiselectComponent.filterSelectList(): Filtered options on client, new filteredSelectList =', this.filteredSelectList);
      this.lastAutocompleteQuery = autocompleteQuery;
    }
    /**
     * Add one element selected by autocomplete.
     *
     * @param selectedElement the element to add
     */
    addSelectedElement(event) {
      let selectedElement = event.value;
      console.log('Element selected by autocomplete:', selectedElement);
      // We do not want to add an element twice; just tell the user that the element is already there.
      if (this.isElementAlreadySelected(selectedElement.id)) {
        let message = this.uiService.translate('genericSearch.alreadySelected', selectedElement.label);
        this.notificationService.clear();
        this.notificationService.info(message, 'Info');
        return;
      }
      // Add selectedElement to selectedOptions:
      // The spread-operator is required to have model and view synchronized
      // (with push() the reset button wouldn't work correctly)
      this.selectedOptions = [...this.selectedOptions, selectedElement];
      console.log('emit selectedOptions=', this.selectedOptions);
      this.changed.emit(this.selectedOptions);
    }
    isElementAlreadySelected(id) {
      // console.log( 'id =', id, 'has type', typeof id );
      for (let option of this.selectedOptions) {
        let optionId = option.id;
        // TODO According to class HisOption the option.id should be of string type
        // But obviously the search result obtained from the REST service contains number ids...
        // console.log( 'optionId =', optionId, 'has type', typeof optionId );
        if (id === optionId.toString()) {
          return true;
        }
      }
      return false;
    }
    /**
     * Delete the given option from the list of selected search result rows.
     *
     * @param option the element to remove from the selection
     */
    deleteSelectedOption(option) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (this.selectedOptions[i] === option) {
          this.selectedOptions.splice(i, 1);
          break;
        }
      }
      this.fireOnChange();
    }
    /**
     * The selection has been deleted -> set model value to null.
     */
    onClear() {
      this.selectedOptions = [];
      this.fireOnChange();
    }
    /**
     * Notify HisSearchFormWidgetComponent that the model needs to be updated.
     */
    fireOnChange() {
      console.log('HisSearchMultiselectComponent: Emit change event:', this.selectedOptions);
      this.changed.emit(this.selectedOptions);
    }
    static {
      this.ɵfac = function HisSearchMultiselectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchMultiselectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchMultiselectComponent,
        selectors: [["his-search-multiselect"]],
        viewQuery: function HisSearchMultiselectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$x, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          widget: "widget",
          uid: "uid",
          selectedOptions: "selectedOptions",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          isFirstInputElement: "isFirstInputElement",
          showUnequalOption: "showUnequalOption"
        },
        outputs: {
          changed: "changed"
        },
        standalone: false,
        decls: 11,
        vars: 11,
        consts: [["inputElement", ""], [1, "selectContainer"], [1, "slInputWrap"], [1, "dropdownEqualOperator"], ["field", "nonexistingdummy", 3, "completeMethod", "onSelect", "inputId", "ngModel", "suggestions", "minLength", "dropdown", "forceSelection"], ["pTemplate", "item"], [1, "unsichtbar"], [1, "selectedOptionsList"], ["styleClass", "selectedDataContainer", 3, "value", "emptyMessage"], [3, "widget"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], ["type", "button", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"]],
        template: function HisSearchMultiselectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, HisSearchMultiselectComponent_Conditional_2_Template, 2, 1, "div", 3);
            i0.ɵɵelementStart(3, "p-autoComplete", 4, 0);
            i0.ɵɵlistener("completeMethod", function HisSearchMultiselectComponent_Template_p_autoComplete_completeMethod_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterSelectList($event));
            })("onSelect", function HisSearchMultiselectComponent_Template_p_autoComplete_onSelect_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.addSelectedElement($event));
            });
            i0.ɵɵtemplate(5, HisSearchMultiselectComponent_ng_template_5_Template, 1, 1, "ng-template", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 6);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(9, 7);
            i0.ɵɵtemplate(10, HisSearchMultiselectComponent_Conditional_10_Template, 2, 2, "p-dataView", 8);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showUnequalOption ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("inputId", ctx.uid)("ngModel", ctx.selectedOptions)("suggestions", ctx.filteredSelectList)("minLength", ctx.minLength)("dropdown", ctx.showDropdownIcon)("forceSelection", true);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 9, "common.components.selectManyPicklist.selected"), ":");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.selectedOptions.length > 0 ? 10 : -1);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2.PrimeTemplate, i2$3.DataView, i2$1.AutoComplete, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisSearchSelectOperatorComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchMultiselectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$w = ["inputElement"];
function HisTreeSelectPopupComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function HisTreeSelectPopupComponent_Conditional_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.deleteAll();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.deleteSelectedItems"));
  }
}
function HisTreeSelectPopupComponent_ng_template_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12)(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.rowselect"));
  }
}
function HisTreeSelectPopupComponent_ng_template_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13)(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.rowselect"));
  }
}
function HisTreeSelectPopupComponent_ng_template_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14)(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.subTreeSelect"));
  }
}
function HisTreeSelectPopupComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, HisTreeSelectPopupComponent_ng_template_12_Conditional_1_Template, 4, 3, "th", 12)(2, HisTreeSelectPopupComponent_ng_template_12_Conditional_2_Template, 4, 3, "th", 13)(3, HisTreeSelectPopupComponent_ng_template_12_Conditional_3_Template, 4, 3, "th", 14);
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.singleSelect ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.singleSelect ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.singleSelect && ctx_r2.showSubtreeSelectColumn ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "common.components.selectManyPicklist.chooseFrom"));
  }
}
function HisTreeSelectPopupComponent_ng_template_13_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 17)(1, "button", 23);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisTreeSelectPopupComponent_ng_template_13_Conditional_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const rowNode_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.doSingleSelect(rowNode_r5.node));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const rowData_r6 = i0.ɵɵnextContext().rowData;
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(2, 1, "genericSearch.tree.selectNode", rowData_r6.defaulttext));
  }
}
function HisTreeSelectPopupComponent_ng_template_13_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 18)(1, "input", 24);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisTreeSelectPopupComponent_ng_template_13_Conditional_2_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const rowData_r6 = i0.ɵɵnextContext().rowData;
      i0.ɵɵtwoWayBindingSet(rowData_r6.selected, $event) || (rowData_r6.selected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 25);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const rowData_r6 = i0.ɵɵnextContext().rowData;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", rowData_r6.selected);
    i0.ɵɵproperty("id", rowData_r6.checkbox1Id)("title", i0.ɵɵpipeBind2(2, 6, "genericSearch.tree.selectNode", rowData_r6.defaulttext));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(4, 9, rowData_r6.selected ? "genericSearch.tree.removeNode" : "genericSearch.tree.selectNode", rowData_r6.defaulttext));
    i0.ɵɵproperty("for", rowData_r6.checkbox1Id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 12, "genericSearch.tree.selectNode", rowData_r6.defaulttext));
  }
}
function HisTreeSelectPopupComponent_ng_template_13_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 24);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisTreeSelectPopupComponent_ng_template_13_Conditional_3_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const rowData_r6 = i0.ɵɵnextContext(2).rowData;
      i0.ɵɵtwoWayBindingSet(rowData_r6.subTreeSelected, $event) || (rowData_r6.subTreeSelected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowData_r6 = i0.ɵɵnextContext(2).rowData;
    i0.ɵɵtwoWayProperty("ngModel", rowData_r6.subTreeSelected);
    i0.ɵɵproperty("id", rowData_r6.checkbox2Id)("title", i0.ɵɵpipeBind2(1, 3, "genericSearch.tree.selectNodeAndSubNodes", rowData_r6.defaulttext));
  }
}
function HisTreeSelectPopupComponent_ng_template_13_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, HisTreeSelectPopupComponent_ng_template_13_Conditional_3_Conditional_1_Template, 2, 6, "input", 26);
    i0.ɵɵelementStart(2, "label", 25);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const rowNode_r5 = ctx_r8.$implicit;
    const rowData_r6 = ctx_r8.rowData;
    i0.ɵɵadvance();
    i0.ɵɵconditional(rowNode_r5.node.children.length > 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", rowData_r6.checkbox2Id)("title", i0.ɵɵpipeBind2(3, 4, "genericSearch.tree.selectNodeAndSubNodes", rowData_r6.defaulttext));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(5, 7, "genericSearch.tree.selectNodeAndSubNodes", rowData_r6.defaulttext));
  }
}
function HisTreeSelectPopupComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 16);
    i0.ɵɵtemplate(1, HisTreeSelectPopupComponent_ng_template_13_Conditional_1_Template, 3, 4, "td", 17)(2, HisTreeSelectPopupComponent_ng_template_13_Conditional_2_Template, 7, 15, "td", 18)(3, HisTreeSelectPopupComponent_ng_template_13_Conditional_3_Template, 6, 10, "td", 19);
    i0.ɵɵelementStart(4, "td")(5, "div", 20);
    i0.ɵɵelement(6, "p-treeTableToggler", 21);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 22);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const rowNode_r5 = ctx.$implicit;
    const rowData_r6 = ctx.rowData;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(rowData_r6.selected || rowData_r6.subTreeSelected ? "ui-state-highlight" : "");
    i0.ɵɵproperty("ngClass", rowNode_r5.level === 0 ? "level_0" : null);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.singleSelect ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.singleSelect ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.singleSelect && ctx_r2.showSubtreeSelectColumn ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("rowNode", rowNode_r5)("buttonTitle", rowNode_r5.node.expanded ? "Level " + (rowNode_r5.level + 1) + " " + i0.ɵɵpipeBind2(7, 9, "de.his.sys.collapse", rowData_r6.defaulttext) : "Level " + (rowNode_r5.level + 1) + " " + i0.ɵɵpipeBind2(8, 12, "de.his.sys.expand", rowData_r6.defaulttext));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(rowData_r6.defaulttext);
  }
}
function HisTreeSelectPopupComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function HisTreeSelectPopupComponent_Conditional_16_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.save($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "genericSearch.returnSelected"));
  }
}
let HisTreeSelectPopupComponent = /*#__PURE__*/(() => {
  class HisTreeSelectPopupComponent {
    constructor() {
      // select only a single element?
      this.singleSelect = false;
      // display the delete selection button?
      this.showDeleteButton = true;
      // display column with subtree select checkboxes?
      this.showSubtreeSelectColumn = true;
      // selectedData contains TreeNode.data objects for all tree nodes that are selected
      // (either individually or with it's complete subtree). Entries need an id attribute
      // and either a selected="true" or a "subTreeSelected" attribute.
      this.selectedData = [];
      this.isFirstInputElement = false;
      this.visible = false;
      this.selectedDataChange = new EventEmitter();
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    /**
     * shows the popup window
     */
    show() {
      this.updateTreeSelection(this.tree);
      this.visible = true;
    }
    /**
     * Set the selected and subTreeSelected attributes of tree nodes from selectedData,
     * and expand the paths to all selected nodes.
     *
     * @param roots roots of the trees
     */
    updateTreeSelection(roots) {
      // collect ids of selected nodes from selectedData.
      // subtree selection has priority before single element selection
      let selectedIdSet = new Set();
      let subTreeSelectedIdSet = new Set();
      for (let selectedElement of this.selectedData) {
        if (selectedElement.subTreeSelected) {
          subTreeSelectedIdSet.add(selectedElement.id);
        } else if (selectedElement.selected) {
          selectedIdSet.add(selectedElement.id);
        }
      }
      console.log('HisTreeSelectPopupComponent.updateTreeSelection(): selectedIdSet =', selectedIdSet);
      console.log('HisTreeSelectPopupComponent.updateTreeSelection(): subTreeSelectedIdSet =', subTreeSelectedIdSet);
      // Recurrence
      this.updateSubtreeSelection(roots, selectedIdSet, subTreeSelectedIdSet, []);
      // Since Angular 7 we need to change the root objects to trigger a complete re-rendering of the tree.
      // https://github.com/primefaces/primeng/issues/261
      // https://github.com/primefaces/primeng/issues/5872
      this.tree = [...this.tree];
    }
    updateSubtreeSelection(treeNodes, selectedIdSet, subTreeSelectedIdSet, path) {
      for (let treeNode of treeNodes) {
        // set selection attributes
        treeNode.data.selected = selectedIdSet.has(treeNode.data.id);
        // console.log("treeNode id =" , treeNode.data.id , ", selected =" , treeNode.data.selected);
        treeNode.data.subTreeSelected = subTreeSelectedIdSet.has(treeNode.data.id);
        // Expand paths to selected nodes.
        // Usually we would simply want to evaluate TreeNode.parent.
        // However there is a PrimeNG bug in the way: parent-information is not filled before a node has been expanded.
        // See see https://forum.primefaces.org/viewtopic.php?f=35&t=49704
        // This is the reason why we have to pass the node path as a method argument from above
        if (treeNode.data.selected || treeNode.data.subTreeSelected) {
          for (let ancestor of path) {
            ancestor.expanded = true;
          }
        }
        // recurrence
        if (treeNode.children && treeNode.children.length > 0) {
          let extendedPath = [...path, treeNode]; // new array object required
          this.updateSubtreeSelection(treeNode.children, selectedIdSet, subTreeSelectedIdSet, extendedPath);
        }
      }
    }
    /**
     * closes the popup and updates the selection
     *
     * @param e event
     */
    save(e) {
      this.selectedData = [];
      this.saveTreeSelection(this.tree);
      console.log('HisTreeSelectPopupComponent: Emit save event:', this.selectedData);
      this.selectedDataChange.emit(this.selectedData);
      this.visible = false;
      e.preventDefault();
    }
    /**
     * Saves the selection from the tree to selectedData.
     *
     * @param treeNodes roots of the trees
     */
    saveTreeSelection(treeNodes) {
      for (let treeNode of treeNodes) {
        if (treeNode.data.subTreeSelected) {
          treeNode.data.selected = false;
        }
        if (treeNode.data.selected || treeNode.data.subTreeSelected) {
          // Copy data to stop data binding from treeNode to selectedData.
          // A deep copy is not required because all tree nodes have an id attribute.
          // We need Object.assign() because a treeNode.data object can have more
          // properties than id, selected and subTreeSelected...
          let dataCopy = {
            id: treeNode.data.id
          };
          Object.assign(dataCopy, treeNode.data);
          this.selectedData.push(dataCopy);
        }
        // Recurrence, but ignore the children of nodes having subTreeSelected="true"
        if (treeNode.children && !treeNode.data.subTreeSelected) {
          this.saveTreeSelection(treeNode.children);
        }
      }
    }
    /**
     * closes the popup without changing the selection
     *
     * @param e event
     */
    cancel(e) {
      this.visible = false;
      e.preventDefault();
    }
    /**
     * Select a single node from the tree.
     *
     * @param selection the selected tree node
     */
    doSingleSelect(selection) {
      console.log('Submit single-selection:', selection);
      this.selectedData = [selection.data];
      this.selectedDataChange.emit(this.selectedData);
      this.visible = false;
    }
    deleteAll() {
      this.selectedData = [];
      console.log('HisTreeSelectPopupComponent: Emit deleteAll event:', this.selectedData);
      this.selectedDataChange.emit(this.selectedData);
    }
    static {
      this.ɵfac = function HisTreeSelectPopupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTreeSelectPopupComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTreeSelectPopupComponent,
        selectors: [["his-tree-select-popup"]],
        viewQuery: function HisTreeSelectPopupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$w, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          title: "title",
          treename: "treename",
          singleSelect: "singleSelect",
          showDeleteButton: "showDeleteButton",
          showSubtreeSelectColumn: "showSubtreeSelectColumn",
          tree: "tree",
          selectedData: "selectedData",
          isFirstInputElement: "isFirstInputElement"
        },
        outputs: {
          selectedDataChange: "selectedDataChange"
        },
        standalone: false,
        decls: 20,
        vars: 20,
        consts: [["inputElement", ""], ["hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "click"], ["hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton"], ["appendTo", "body", 3, "visibleChange", "visible", "draggable", "closeOnEscape", "resizable", "responsive", "modal", "blockScroll"], [1, "containerTreeTablePopup"], ["dataKey", "id", "onclick", "event.stopPropagation(); return true;", 3, "value", "selectionMode", "selection", "rowHover"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "clearerSpaceAboveHalfEm"], ["hisImage", "TICK", 1, "button_highlighted", "marginRightStandard"], ["hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"], ["hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton", 3, "click"], [1, "treeCellHeaderSingleSelect"], [1, "treeCellHeadercolumnMultiSelect"], [1, "treeCellHeaderSubtreeSingleSelect"], [1, "treeCellHeaderContent"], [3, "ngClass"], [1, "treeCellSingleSelect"], [1, "treeCellcolumnMultiSelect"], [1, "treeCellSubtreeSingleSelect"], [1, "treeTableTogglerContainer", "treeTableTogglerContainer--inDialog"], [3, "rowNode", "buttonTitle"], [1, "treeCellContent"], ["hisImage", "arrow_left", 1, "icon", 3, "click", "title"], ["type", "checkbox", 3, "ngModelChange", "ngModel", "id", "title"], [2, "font-size", "0", 3, "for", "title"], ["type", "checkbox", 3, "ngModel", "id", "title"], ["hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"]],
        template: function HisTreeSelectPopupComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 1, 0);
            i0.ɵɵlistener("click", function HisTreeSelectPopupComponent_Template_button_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.show();
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, HisTreeSelectPopupComponent_Conditional_5_Template, 4, 3, "button", 2);
            i0.ɵɵelementStart(6, "p-dialog", 3);
            i0.ɵɵtwoWayListener("visibleChange", function HisTreeSelectPopupComponent_Template_p_dialog_visibleChange_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.visible, $event) || (ctx.visible = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementStart(7, "p-header")(8, "h2");
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 4)(11, "p-treeTable", 5);
            i0.ɵɵtemplate(12, HisTreeSelectPopupComponent_ng_template_12_Template, 7, 6, "ng-template", 6)(13, HisTreeSelectPopupComponent_ng_template_13_Template, 11, 15, "ng-template", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(14, "div", 8);
            i0.ɵɵelementStart(15, "p-footer");
            i0.ɵɵtemplate(16, HisTreeSelectPopupComponent_Conditional_16_Template, 3, 3, "button", 9);
            i0.ɵɵelementStart(17, "button", 10);
            i0.ɵɵlistener("click", function HisTreeSelectPopupComponent_Template_button_click_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.cancel($event));
            });
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "hisUi");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 16, "genericSearch.selectFromTree"));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showDeleteButton && !ctx.singleSelect && ctx.selectedData.length > 0 ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("visible", ctx.visible);
            i0.ɵɵproperty("draggable", false)("closeOnEscape", true)("resizable", true)("responsive", true)("modal", true)("blockScroll", true);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.tree)("selectionMode", ctx.singleSelect ? "single" : "multiple")("selection", ctx.selectedData)("rowHover", true);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(!ctx.singleSelect ? 16 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 18, "genericSearch.backToParentSearch"));
          }
        },
        dependencies: [i1$2.NgClass, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i3.Dialog, i2.Header, i2.Footer, i2.PrimeTemplate, i5.TreeTable, i5.TreeTableToggler, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisUiPipe],
        styles: ["[_nghost-%COMP%]     .ui-widget{top:5%!important;max-height:90%}[_nghost-%COMP%]     .ui-dialog-content{overflow:auto}"]
      });
    }
  }
  return HisTreeSelectPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$v = ["inputElement"];
function HisTreeSelectAutocompleteComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r2.data.defaulttext, " ");
  }
}
let HisTreeSelectAutocompleteComponent = /*#__PURE__*/(() => {
  class HisTreeSelectAutocompleteComponent {
    constructor() {
      // minimum length of autocomplete input to trigger a search
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete (null -> show all)
      this.limit = null; // XXX currently unused
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      this.isFirstInputElement = false;
      // the value of the autocomplete input field
      this.lastAutocompleteQuery = undefined;
      // suggestions for autocomplete, derived from selectList
      this.filteredSelectList = [];
      // event emitted when selectedData changes
      this.selected = new EventEmitter();
    }
    ngOnInit() {
      if (this.minLength === 0) {
        // if minLength==0 then we must initialize filteredSelectList from the start
        this.filteredSelectList = this.selectList;
        this.lastAutocompleteQuery = '';
      }
    }
    ngAfterViewInit() {
      // Set focus on first input element
      if (this.isFirstInputElement) {
        setTimeout(() => this.inputElement.nativeElement.focus());
      }
    }
    filterSelectList($event) {
      let autocompleteQuery = $event.query;
      console.log('HisTreeSelectAutocompleteComponent.filterSelectList(): event =', $event, ', query =', autocompleteQuery, ', lastAutocompleteQuery =', this.lastAutocompleteQuery);
      // Produce filteredSelectList:
      // * If the new query contains the previous one, then we filter the last filtering result again
      // * If the new query does not contain the last one (because some characters were removed from the
      //   autocomplete input field), then we have process the complete list
      // * Case is ignored.
      let lastList = this.lastAutocompleteQuery && autocompleteQuery.indexOf(this.lastAutocompleteQuery) > -1 ? this.filteredSelectList : this.selectList;
      let nextList = [];
      let listElem;
      for (listElem of lastList) {
        if (listElem.data.defaulttext.toUpperCase().indexOf(autocompleteQuery.toUpperCase()) > -1) {
          nextList.push(listElem);
        }
      }
      this.filteredSelectList = nextList.sort((a, b) => a.data.defaulttext.localeCompare(b.data.defaulttext));
      this.lastAutocompleteQuery = autocompleteQuery;
    }
    /**
     * Pass element selected to wrapping component.
     */
    emitSelectedElement() {
      this.selected.emit(this.selectedElement);
    }
    static {
      this.ɵfac = function HisTreeSelectAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTreeSelectAutocompleteComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTreeSelectAutocompleteComponent,
        selectors: [["his-tree-select-autocomplete"]],
        viewQuery: function HisTreeSelectAutocompleteComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$v, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
          }
        },
        inputs: {
          uid: "uid",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          selectList: "selectList",
          isFirstInputElement: "isFirstInputElement"
        },
        outputs: {
          selected: "selected"
        },
        standalone: false,
        decls: 3,
        vars: 6,
        consts: [["inputElement", ""], ["field", "nonexistingdummy", 3, "ngModelChange", "completeMethod", "onSelect", "inputId", "ngModel", "suggestions", "minLength", "dropdown", "forceSelection"], ["pTemplate", "item"]],
        template: function HisTreeSelectAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-autoComplete", 1, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisTreeSelectAutocompleteComponent_Template_p_autoComplete_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedElement, $event) || (ctx.selectedElement = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisTreeSelectAutocompleteComponent_Template_p_autoComplete_completeMethod_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterSelectList($event));
            })("onSelect", function HisTreeSelectAutocompleteComponent_Template_p_autoComplete_onSelect_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitSelectedElement());
            });
            i0.ɵɵtemplate(2, HisTreeSelectAutocompleteComponent_ng_template_2_Template, 1, 1, "ng-template", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("inputId", ctx.uid);
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectedElement);
            i0.ɵɵproperty("suggestions", ctx.filteredSelectList)("minLength", ctx.minLength)("dropdown", ctx.showDropdownIcon)("forceSelection", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2.PrimeTemplate, i2$1.AutoComplete, HisModificationDetectionDirective, HisButtonTitleDirective],
        encapsulation: 2
      });
    }
  }
  return HisTreeSelectAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisTreeSelectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-tree-select-autocomplete", 7);
    i0.ɵɵlistener("selected", function HisTreeSelectComponent_Conditional_2_Template_his_tree_select_autocomplete_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addSelectedElement($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("uid", ctx_r1.uid)("selectList", ctx_r1.selectList)("minLength", ctx_r1.minLength)("limit", ctx_r1.limit)("showDropdownIcon", ctx_r1.showDropdownIcon);
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", data_r4.defaulttext, " (", i0.ɵɵpipeBind1(2, 2, "genericSearch.tree.includeSubNodes"), ")");
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(data_r4.defaulttext);
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Conditional_2_Template, 3, 4, "span", 11)(3, HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Conditional_3_Template, 2, 1, "span", 11);
    i0.ɵɵelementStart(4, "button", 12);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵlistener("click", function HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Template_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const data_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.deleteObj(data_r4));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const data_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", data_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(data_r4.subTreeSelected ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!data_r4.subTreeSelected ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(5, 4, "common.removeAssignmentOf", data_r4.defaulttext));
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Conditional_0_Template, 6, 7, "li", 10);
  }
  if (rf & 2) {
    const ɵ$index_25_r5 = ctx.$index;
    const selectedData_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r1.maxDisplayedSelections || ctx_r1.showAllSelected || ɵ$index_25_r5 < ctx_r1.maxDisplayedSelections - 1 || ctx_r1.maxDisplayedSelections === selectedData_r6.length ? 0 : -1);
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10)(1, "button", 13);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Conditional_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      ctx_r1.toggleShowAllSelected();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 15);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedData_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 4, "common.components.selectManyPicklist.showAllSelected"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("... ", selectedData_r6.length - ctx_r1.maxDisplayedSelections + 1, " ", i0.ɵɵpipeBind1(5, 6, "common.components.selectManyPicklist.more"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 8, "common.components.selectManyPicklist.showAllSelected"));
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10)(1, "button", 13);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Conditional_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      ctx_r1.toggleShowAllSelected();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 16);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 7, "common.components.selectManyPicklist.showLess"));
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Conditional_0_Template, 8, 10, "li", 10)(1, HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Conditional_1_Template, 8, 9, "li", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r1.showAllSelected ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAllSelected ? 1 : -1);
  }
}
function HisTreeSelectComponent_Conditional_8_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "ul");
    i0.ɵɵrepeaterCreate(2, HisTreeSelectComponent_Conditional_8_ng_template_1_For_3_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(4, HisTreeSelectComponent_Conditional_8_ng_template_1_Conditional_4_Template, 2, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedData_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedData_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.maxDisplayedSelections && ctx_r1.maxDisplayedSelections < selectedData_r6.length ? 4 : -1);
  }
}
function HisTreeSelectComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 6);
    i0.ɵɵtemplate(1, HisTreeSelectComponent_Conditional_8_ng_template_1_Template, 5, 1, "ng-template", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.selectedData)("emptyMessage", "\u00A0");
  }
}
const HISTREESELECTCOMPONENT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => HisTreeSelectComponent),
  multi: true
};
let HisTreeSelectComponent = /*#__PURE__*/(() => {
  class HisTreeSelectComponent extends HisControlValueAccessor {
    constructor() {
      super(...arguments);
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      // select only a single element?
      this.singleSelect = false;
      // display column with subtree select checkboxes in the popup?
      this.showSubtreeSelectColumn = true;
      // display autocomplete ?
      this.showAutocomplete = true;
      // minimum length of autocomplete input to trigger a search
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete (null -> show all)
      this.limit = null;
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      // The component model: An array of the data sections of the selected tree elements.
      // The Input() is only required to make the reset button in the generic search work!
      // Without injecting widget.value in his-search-form-widget.component.html, we'ld have distinct view/model objects.
      this.selectedData = [];
      /** Limit the number of selections displayed. Overflow will be combined to a single label. */
      // default to 10, similar to JSF
      this.maxDisplayedSelections = 10;
      this.showAllSelected = false;
      // event emitted when selectedData changes
      this.changed = new EventEmitter();
    }
    set treeValues(tree) {
      if (tree) {
        this.tree = tree;
        // convert tree (possibly having several root nodes) into a flat list
        console.log('Convert tree to list: tree =', this.tree);
        this.selectList = [];
        let root;
        for (root of this.tree) {
          let subList = this.subtreeToList(root);
          this.selectList = this.selectList.concat(subList);
        }
      }
    }
    subtreeToList(node) {
      let list = [node];
      let child;
      for (child of node.children) {
        let subList = this.subtreeToList(child);
        list = list.concat(subList);
      }
      return list;
    }
    getHtmlFocusElementId() {
      return this.uid;
    }
    /**
     * Add a new element selected by autocomplete.
     *
     * @param selectedElement the element to add to the selection
     */
    addSelectedElement(selectedElement) {
      console.log('Element selected by autocomplete:', selectedElement);
      // In multiSelect mode we do not want to add an element twice; just tell the user that the element is already there.
      // In singleSelect mode we do not need that check because the data is substituted anyway.
      if (!this.singleSelect && this.isElementAlreadySelected(selectedElement.data.id)) {
        let message = this.uiService.translate('genericSearch.alreadySelected', selectedElement.data.defaulttext);
        this.notificationService.clear();
        this.notificationService.info(message, 'Info');
        return;
      }
      // Add selectedElement to selectedData: In singleSelect mode selectedData is replaced by the new selection;
      // in multiSelect mode the selection is added to selectedData. The latter requires the spread-operator
      // to have model and view synchronized (with push() the reset button wouldn't work correctly)
      let data = selectedElement.data;
      data.selected = true;
      this.selectedData = this.singleSelect ? [data] : [...this.selectedData, data];
      this.changed.emit(this.selectedData);
      this.onModelChange(this);
    }
    isElementAlreadySelected(id) {
      for (let option of this.selectedData) {
        if (option.id === id) {
          return true;
        }
      }
      return false;
    }
    /**
     * Vom Auswahl-Popup ausgelöstes Event.
     *
     * @param selectedData Array der neu ausgewählten Baum-Elemente
     */
    selectedDataChange(selectedData) {
      this.selectedData = selectedData;
      console.log('Tree nodes selected in popup:', this.selectedData);
      this.changed.emit(this.selectedData);
      this.onModelChange(this);
      // re-hide any future overflow after the button disappears
      if (this.selectedData.length <= this.maxDisplayedSelections) {
        this.showAllSelected = false;
      }
    }
    /**
     * Wird durch Klick auf das Mülleimer-Icon vor einem ausgewähltem Element aufgerufen
     * und löscht das übergebene Element aus der Auswahl.
     *
     * @param obj zu löschendes Element
     */
    deleteObj(obj) {
      this.selectedData.splice(this.selectedData.indexOf(obj), 1);
      console.log('Deleted selected element', obj, '-> new selection is', this.selectedData);
      this.changed.emit(this.selectedData);
    }
    toggleShowAllSelected() {
      this.showAllSelected = !this.showAllSelected;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisTreeSelectComponent_BaseFactory;
        return function HisTreeSelectComponent_Factory(__ngFactoryType__) {
          return (ɵHisTreeSelectComponent_BaseFactory || (ɵHisTreeSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisTreeSelectComponent)))(__ngFactoryType__ || HisTreeSelectComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTreeSelectComponent,
        selectors: [["his-tree-select"]],
        inputs: {
          uid: "uid",
          title: "title",
          treename: "treename",
          singleSelect: "singleSelect",
          showSubtreeSelectColumn: "showSubtreeSelectColumn",
          showAutocomplete: "showAutocomplete",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          selectedData: "selectedData",
          maxDisplayedSelections: "maxDisplayedSelections",
          treeValues: [0, "tree", "treeValues"]
        },
        outputs: {
          changed: "changed"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([HISTREESELECTCOMPONENT_VALUE_ACCESSOR]), i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 11,
        consts: [[1, "selectContainer"], [1, "slInputWrap"], [3, "uid", "selectList", "minLength", "limit", "showDropdownIcon"], [3, "selectedDataChange", "title", "treename", "tree", "selectedData", "singleSelect", "showSubtreeSelectColumn"], [1, "unsichtbar"], [1, "selectedOptionsList"], ["styleClass", "selectedDataContainer", 3, "value", "emptyMessage"], [3, "selected", "uid", "selectList", "minLength", "limit", "showDropdownIcon"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], [1, "selectedData"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"], ["type", "submit", 1, "transparent", "showAllSelectedOptionsButton", 3, "click", "title"], [1, "btnText"], ["hisImage", "ARROW_OUT", 1, "inlineicon", 3, "title"], ["hisImage", "ARROW_IN", 1, "inlineicon", 3, "title"]],
        template: function HisTreeSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, HisTreeSelectComponent_Conditional_2_Template, 1, 5, "his-tree-select-autocomplete", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "his-tree-select-popup", 3);
            i0.ɵɵlistener("selectedDataChange", function HisTreeSelectComponent_Template_his_tree_select_popup_selectedDataChange_3_listener($event) {
              return ctx.selectedDataChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(7, 5);
            i0.ɵɵtemplate(8, HisTreeSelectComponent_Conditional_8_Template, 2, 2, "p-dataView", 6);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showAutocomplete ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("title", ctx.title)("treename", ctx.treename)("tree", ctx.tree)("selectedData", ctx.selectedData)("singleSelect", ctx.singleSelect)("showSubtreeSelectColumn", ctx.showSubtreeSelectColumn);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 9, "common.components.selectManyPicklist.selected"), ":");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.selectedData.length > 0 ? 8 : -1);
          }
        },
        dependencies: [i2.PrimeTemplate, i2$3.DataView, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisTreeSelectPopupComponent, HisTreeSelectAutocompleteComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisTreeSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisSearchTreeSelectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "his-search-select-operator", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("widget", ctx_r0.widget)("isFirstInputElement", ctx_r0.isFirstInputElement);
  }
}
function HisSearchTreeSelectComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-tree-select-autocomplete", 9);
    i0.ɵɵlistener("selected", function HisSearchTreeSelectComponent_Conditional_3_Template_his_tree_select_autocomplete_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.addSelectedElement($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("uid", ctx_r0.uid)("selectList", ctx_r0.selectList)("minLength", ctx_r0.minLength)("limit", ctx_r0.limit)("showDropdownIcon", ctx_r0.showDropdownIcon)("isFirstInputElement", ctx_r0.isFirstInputElement && !ctx_r0.showUnequalOption);
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", data_r4.defaulttext, " (", i0.ɵɵpipeBind1(2, 2, "genericSearch.tree.includeSubNodes"), ")");
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(data_r4.defaulttext);
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Conditional_2_Template, 3, 4, "span", 13)(3, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Conditional_3_Template, 2, 1, "span", 13);
    i0.ɵɵelementStart(4, "button", 14);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵlistener("click", function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Template_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const data_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.deleteObj(data_r4));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const data_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", data_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(data_r4.subTreeSelected ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!data_r4.subTreeSelected ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(5, 4, "view.controls.remove"));
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Template, 6, 6, "li", 12);
  }
  if (rf & 2) {
    const ɵ$index_30_r5 = ctx.$index;
    const selectedData_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r0.maxDisplayedSelections || ctx_r0.showAllSelected || ɵ$index_30_r5 < ctx_r0.maxDisplayedSelections - 1 || ctx_r0.maxDisplayedSelections === selectedData_r6.length ? 0 : -1);
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12)(1, "button", 15);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      ctx_r0.toggleShowAllSelected();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 16);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 17);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedData_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 4, "common.components.selectManyPicklist.showAllSelected"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("... ", selectedData_r6.length - ctx_r0.maxDisplayedSelections + 1, " ", i0.ɵɵpipeBind1(5, 6, "common.components.selectManyPicklist.more"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 8, "common.components.selectManyPicklist.showAllSelected"));
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12)(1, "button", 15);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      ctx_r0.toggleShowAllSelected();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 16);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 18);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 7, "common.components.selectManyPicklist.showLess"));
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_0_Template, 8, 10, "li", 12)(1, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_1_Template, 8, 9, "li", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r0.showAllSelected ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showAllSelected ? 1 : -1);
  }
}
function HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "ul");
    i0.ɵɵrepeaterCreate(2, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_For_3_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(4, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Conditional_4_Template, 2, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedData_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedData_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.maxDisplayedSelections && ctx_r0.maxDisplayedSelections < selectedData_r6.length ? 4 : -1);
  }
}
function HisSearchTreeSelectComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 7);
    i0.ɵɵtemplate(1, HisSearchTreeSelectComponent_Conditional_9_ng_template_1_Template, 5, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.selectedData)("emptyMessage", "\u00A0");
  }
}
let HisSearchTreeSelectComponent = /*#__PURE__*/(() => {
  class HisSearchTreeSelectComponent extends HisTreeSelectComponent {
    constructor() {
      super();
      // true if this is the first input element in the search mask
      this.isFirstInputElement = false;
    }
    static {
      this.ɵfac = function HisSearchTreeSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchTreeSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchTreeSelectComponent,
        selectors: [["his-search-tree-select"]],
        inputs: {
          widget: "widget",
          showUnequalOption: "showUnequalOption",
          isFirstInputElement: "isFirstInputElement"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 10,
        vars: 13,
        consts: [[1, "selectContainer"], [1, "slInputWrap"], [1, "dropdownEqualOperator"], [3, "uid", "selectList", "minLength", "limit", "showDropdownIcon", "isFirstInputElement"], [3, "selectedDataChange", "title", "treename", "tree", "selectedData", "singleSelect", "showSubtreeSelectColumn", "isFirstInputElement"], [1, "unsichtbar"], [1, "selectedOptionsList"], ["styleClass", "selectedDataContainer", 3, "value", "emptyMessage"], [3, "widget", "isFirstInputElement"], [3, "selected", "uid", "selectList", "minLength", "limit", "showDropdownIcon", "isFirstInputElement"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], [1, "selectedData"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"], ["type", "submit", 1, "transparent", "showAllSelectedOptionsButton", 3, "click", "title"], [1, "btnText"], ["hisImage", "ARROW_OUT", 1, "inlineicon", 3, "title"], ["hisImage", "ARROW_IN", 1, "inlineicon", 3, "title"]],
        template: function HisSearchTreeSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, HisSearchTreeSelectComponent_Conditional_2_Template, 2, 2, "div", 2)(3, HisSearchTreeSelectComponent_Conditional_3_Template, 1, 6, "his-tree-select-autocomplete", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "his-tree-select-popup", 4);
            i0.ɵɵlistener("selectedDataChange", function HisSearchTreeSelectComponent_Template_his_tree_select_popup_selectedDataChange_4_listener($event) {
              return ctx.selectedDataChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(8, 6);
            i0.ɵɵtemplate(9, HisSearchTreeSelectComponent_Conditional_9_Template, 2, 2, "p-dataView", 7);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showUnequalOption ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showAutocomplete ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("title", ctx.title)("treename", ctx.treename)("tree", ctx.tree)("selectedData", ctx.selectedData)("singleSelect", ctx.singleSelect)("showSubtreeSelectColumn", ctx.showSubtreeSelectColumn)("isFirstInputElement", ctx.isFirstInputElement && !ctx.showUnequalOption && !ctx.showAutocomplete);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 11, "common.components.selectManyPicklist.selected"), ":");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.selectedData.length > 0 ? 9 : -1);
          }
        },
        dependencies: [i2.PrimeTemplate, i2$3.DataView, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisTreeSelectPopupComponent, HisTreeSelectAutocompleteComponent, HisSearchSelectOperatorComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchTreeSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Sets default values and behaviour for form components
 * that are universally used in H1.
 *
 * Default values are as follows:
 * ngFormOptions: {updateOn: 'blur'}
 */
let HisFormDefaultsDirective = /*#__PURE__*/(() => {
  class HisFormDefaultsDirective {
    constructor() {
      this.ngForm = inject(NgForm, {
        host: true,
        optional: true,
        self: true
      });
    }
    ngAfterContentInit() {
      if (this.ngForm) {
        // console.log('Pre: ' + JSON.stringify(this.ngForm.options));
        // updateOn: 'blur' setzen, wenn sonst nichts für 'updateOn' gesetzt ist
        if (this.ngForm.options) {
          if (!this.ngForm.options.updateOn) {
            this.ngForm.options.updateOn = 'blur';
          }
        } else {
          this.ngForm.options = {
            updateOn: 'blur'
          };
        }
        // console.log('Post: ' + JSON.stringify(this.ngForm.options));
      }
    }
    static {
      this.ɵfac = function HisFormDefaultsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFormDefaultsDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisFormDefaultsDirective,
        selectors: [["form"]],
        standalone: false
      });
    }
  }
  return HisFormDefaultsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisScrollwithmeDirective = /*#__PURE__*/(() => {
  class HisScrollwithmeDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.renderer = inject(Renderer2);
      this.reached = false;
    }
    onWindowScroll() {
      const parent = this.el.nativeElement.parentNode;
      const element = this.el.nativeElement;
      // Überprüfe, ob das Parent-Element bereits die Klasse enthält
      if (!parent.classList.contains('scrollwithmeWrapper')) {
        this.renderer.addClass(parent, 'scrollwithmeWrapper');
        // Position des Elternelements initial setzen
        if (parent.offsetTop > 0) {
          this.initElPosition = parent.offsetTop;
        }
      }
      // Position prüfen, ob oberen Fensterrand erreicht
      const scrollPosition = window.pageYOffset;
      this.reached = scrollPosition >= this.initElPosition;
      // Zoomlevel prüfen, um scrollWithMe-active bei > 300% Zoom auszublenden
      if (this.checkZoom(300)) {
        if (element.classList.contains('scrollWithMe-active')) {
          this.renderer.removeClass(element, 'scrollWithMe-active');
          this.renderer.removeStyle(parent, 'padding-top');
          this.renderer.removeStyle(element, 'left');
          this.renderer.removeStyle(element, 'max-width');
        }
        return;
      }
      // Wenn das Elternelement den oberen Fensterrand erreicht und Zoom-Level passt
      if (this.initElPosition >= 1 && this.initElPosition !== undefined && this.reached) {
        // Höhe des Elternelements setzen, um das Springen des Browsers zu verhindern,
        // falls es noch nicht angedockt ist
        if (!element.classList.contains('scrollWithMe-active')) {
          const elHeight = element.offsetHeight;
          const elLeft = element.getBoundingClientRect().left;
          // Breite setzen, wenn keepSize gewählt ist
          if (this.keepSize === 'keepSize') {
            const elWidth = element.offsetWidth;
            this.renderer.setStyle(element, 'max-width', elWidth + 'px');
          } else {
            const newWidth = window.innerWidth - elLeft - 30;
            this.renderer.setStyle(element, 'max-width', newWidth + 'px');
          }
          // Höhe des Wraps setzen, um das Springen des Browsers zu verhindern und die Position von links
          this.renderer.setStyle(parent, 'padding-top', elHeight + 'px');
          this.renderer.setStyle(element, 'left', elLeft + 'px');
          this.renderer.addClass(element, 'scrollWithMe-active');
        }
      } else {
        // Reset styles and remove class if not reached or conditions change
        this.renderer.removeStyle(parent, 'padding-top');
        this.renderer.removeStyle(element, 'left');
        this.renderer.removeStyle(element, 'max-width');
        this.renderer.removeClass(element, 'scrollWithMe-active');
      }
    }
    checkZoom(zoomLevel) {
      let browserZoom = window.devicePixelRatio * 100;
      return browserZoom >= zoomLevel ? true : false;
    }
    static {
      this.ɵfac = function HisScrollwithmeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisScrollwithmeDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisScrollwithmeDirective,
        selectors: [["", "appScrollwithme", ""]],
        hostBindings: function HisScrollwithmeDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("scroll", function HisScrollwithmeDirective_scroll_HostBindingHandler() {
              return ctx.onWindowScroll();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          keepSize: [0, "appScrollwithme", "keepSize"]
        },
        standalone: false
      });
    }
  }
  return HisScrollwithmeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisPanelDirective = /*#__PURE__*/(() => {
  class HisPanelDirective {
    constructor(userProfileService, cdRef) {
      this.userProfileService = userProfileService;
      this.cdRef = cdRef;
      this.panelComponent = inject(Panel, {
        host: true,
        optional: true,
        self: true
      });
      this.panelStateInitialized = false;
      this.hisAuthService = inject(HisAuthService);
    }
    ngAfterViewChecked() {
      if (this.panelComponent && this.panelComponent.toggleable && !this.panelStateInitialized) {
        this.initializePanelState();
        if (!this.panelStateSubscription && !this.hisAuthService.isAnonymous) {
          this.panelStateSubscription = this.panelComponent.collapsedChange.subscribe(collapsed => {
            this.savePanelState(collapsed);
          });
        }
      } else {
        this.managePanelVisibility();
      }
    }
    initializePanelState() {
      if (this.panelComponent && this.panelComponent.toggleable) {
        // Das Identifizieren der Panels anhand ihrer ID funktioniert leider nicht, da sich die IDs bei jedem Seitenaufruf ändern
        // Also ziehen wir den Header heran 
        const sanitizedHeader = this.sanitizeKey(this.panelComponent.header);
        let sanitizedPanelText;
        if (!sanitizedHeader) {
          sanitizedPanelText = this.sanitizeKey(this.panelComponent.collapseText);
        }
        const key = sanitizedHeader ? `panel_${sanitizedHeader}_state` : `panel_${sanitizedPanelText}_state`;
        this.userProfileService.getValueforKey(key).subscribe(savedState => {
          if (savedState !== null && savedState !== undefined) {
            const isCollapsed = savedState === 'collapsed';
            if (isCollapsed) {
              this.panelComponent.collapsed = isCollapsed;
              // Manuell die Änderungserkennung auslösen, da Panel sonst initial nicht im korrekten Zustand dargestellt wird
              this.cdRef.detectChanges();
            }
          }
          this.panelStateInitialized = true;
        });
      }
    }
    savePanelState(collapsed) {
      if (this.panelComponent && this.panelComponent.toggleable) {
        const sanitizedHeader = this.sanitizeKey(this.panelComponent.header);
        let sanitizedPanelText;
        if (!sanitizedHeader) {
          sanitizedPanelText = this.sanitizeKey(this.panelComponent.collapseText);
        }
        const key = sanitizedHeader ? `panel_${sanitizedHeader}_state` : `panel_${sanitizedPanelText}_state`;
        const state = collapsed ? 'collapsed' : 'expanded';
        this.userProfileService.setNewValue(key, state, 'expanded').subscribe(() => {});
      }
    }
    sanitizeKey(input) {
      // Ersetze alle nicht alphanumerischen Zeichen durch einen Unterstrich
      return input?.replace(/[^a-zA-Z0-9 ]/g, '_')?.replace(/\s+/g, '_');
    }
    managePanelVisibility() {
      // console.log('#PanelDirective.ngAfterViewChecked() - panelComponent: ', ( this.panelComponent as any ) );
      if (this.panelComponent) {
        if ((this.panelComponent.toggleable === undefined || this.isPanelToggleableAndNotCollapsed()) && this.isPanelHiddenOrEmpty()) {
          // console.log('#PanelDirective has not content except header ', ( this.panelComponent as a<ny ).el.nativeElement.innerText );
          this.panelComponent.el.nativeElement.hidden = true;
        } else {
          this.panelComponent.el.nativeElement.hidden = false;
        }
      }
    }
    isPanelHiddenOrEmpty() {
      return this.panelComponent.ddHidden || this.panelComponent.el.nativeElement.innerText === this.panelComponent.header;
    }
    isPanelToggleableAndNotCollapsed() {
      return this.panelComponent.toggleable === true && !this.panelComponent.collapsed;
    }
    ngOnDestroy() {
      if (this.panelStateSubscription) {
        this.panelStateSubscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function HisPanelDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPanelDirective)(i0.ɵɵdirectiveInject(HisUserProfileService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisPanelDirective,
        selectors: [["p-panel"]],
        standalone: false
      });
    }
  }
  return HisPanelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Sets page title based on a h1-element
 */
let HisPageTitleDirective = /*#__PURE__*/(() => {
  class HisPageTitleDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.titleService = inject(Title);
      this.hisUiService = inject(HisUiService);
    }
    ngAfterContentInit() {
      // Our host element is a native h1-tag. Therefore Angular change detection
      // is not available in this directive and we have to use a native MutationObserver.
      let observer = new MutationObserver(() => {
        this.updateTitle();
      });
      let config = {
        characterData: true,
        childList: true,
        subtree: true
      };
      observer.observe(this.el.nativeElement, config);
      this.updateTitle();
    }
    ngOnDestroy() {
      this.updateTitle();
    }
    findFirstAngularH1() {
      let firstAngularH1Element;
      let allH1Elements = document.querySelectorAll('h1');
      // JSF navigation may contain a h1 with a class sessionTimeoutAccessibilityTitle,
      // which we need to ignore. (it is defined in popup-login.xhtml)
      allH1Elements.forEach(h1Elem => {
        if (h1Elem.className !== 'sessionTimeoutAccessibilityTitle' && !firstAngularH1Element) {
          firstAngularH1Element = h1Elem;
        }
      });
      return firstAngularH1Element;
    }
    updateTitle() {
      // We use the first suitable H1 element of this page,
      // not the one this instance of the directive is linked to. For the following reason:
      // For a brief period of time, there might be two h1 elements. Then first one is removed
      // which triggeres the ngOnDestroy callback of that element. But no callback is triggered
      // on the remaining h1, which is now the first one. Therefore we need to use the ngOnDestroy
      // as trigger, but act on the remaining element instead.
      // Furthermore the element, for which ngOnDestroy is invoked, may still exists in the DOM,
      // therefore we use a setTimeout call, to move the processing of this event to the end of
      // the event queque.
      setTimeout(() => {
        let element = this.findFirstAngularH1();
        if (!element) {
          return;
        }
        let title = element.innerText.trim();
        if (title) {
          let suffix = ' - ' + this.hisUiService.translate('cs.sys.portal.name');
          this.titleService.setTitle(title + suffix);
        }
      }, 1);
    }
    static {
      this.ɵfac = function HisPageTitleDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPageTitleDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisPageTitleDirective,
        selectors: [["h1"]],
        standalone: false
      });
    }
  }
  return HisPageTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisHeadingComponent_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function HisHeadingComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function HisHeadingComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function HisHeadingComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function HisHeadingComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function HisHeadingComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
function HisHeadingComponent_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value);
  }
}
let HisHeadingComponent = /*#__PURE__*/(() => {
  class HisHeadingComponent {
    constructor() {
      this.level = 1;
      this.value = '';
    }
    static {
      this.ɵfac = function HisHeadingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisHeadingComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisHeadingComponent,
        selectors: [["his-heading"]],
        inputs: {
          level: "level",
          value: "value"
        },
        standalone: false,
        decls: 7,
        vars: 1,
        template: function HisHeadingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisHeadingComponent_Case_0_Template, 2, 1, "h1")(1, HisHeadingComponent_Case_1_Template, 2, 1, "h2")(2, HisHeadingComponent_Case_2_Template, 2, 1, "h3")(3, HisHeadingComponent_Case_3_Template, 2, 1, "h4")(4, HisHeadingComponent_Case_4_Template, 2, 1, "h5")(5, HisHeadingComponent_Case_5_Template, 2, 1, "h6")(6, HisHeadingComponent_Case_6_Template, 2, 1, "h1");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.level) === 1 ? 0 : tmp_0_0 === 2 ? 1 : tmp_0_0 === 3 ? 2 : tmp_0_0 === 4 ? 3 : tmp_0_0 === 5 ? 4 : tmp_0_0 === 6 ? 5 : 6);
          }
        },
        dependencies: [HisPageTitleDirective],
        encapsulation: 2
      });
    }
  }
  return HisHeadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* const pDialogKey for ConfirmDialogComponent */
const CONFIRM_PDIALOG_KEY = 'confirmationDialogKey';
let HisConfirmDialogComponent = /*#__PURE__*/(() => {
  class HisConfirmDialogComponent {
    constructor() {
      this.width = 450;
      /**
       * Key of the confirm dialog; default = CONFIRM_PDIALOG_KEY
       */
      this.pDialogKey = CONFIRM_PDIALOG_KEY; // key of <p-confirmDialog>
    }
    static {
      this.ɵfac = function HisConfirmDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisConfirmDialogComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisConfirmDialogComponent,
        selectors: [["his-confirm-dialog"]],
        inputs: {
          width: "width",
          pDialogKey: "pDialogKey"
        },
        standalone: false,
        decls: 12,
        vars: 10,
        consts: [["cd", ""], [3, "key", "header"], [3, "click"]],
        template: function HisConfirmDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-confirmDialog", 1, 0);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "p-footer")(4, "button", 2);
            i0.ɵɵlistener("click", function HisConfirmDialogComponent_Template_button_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              const cd_r2 = i0.ɵɵreference(1);
              return i0.ɵɵresetView(cd_r2.accept());
            });
            i0.ɵɵelementStart(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "button", 2);
            i0.ɵɵlistener("click", function HisConfirmDialogComponent_Template_button_click_8_listener() {
              i0.ɵɵrestoreView(_r1);
              const cd_r2 = i0.ɵɵreference(1);
              return i0.ɵɵresetView(cd_r2.reject());
            });
            i0.ɵɵelementStart(9, "span");
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "hisUi");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("key", ctx.pDialogKey);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(2, 4, "fs.res.common.confirmation.delete"));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "de.his.javang.ja"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 8, "de.his.javang.nein"));
          }
        },
        dependencies: [i2.Footer, i2$4.ConfirmDialog, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisConfirmDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This service must be used instead of primeng's ConfirmationService in order to
 * prevent XSS attacks in confirmation dialogs.
 * See https://hiszilla.his.de/hiszilla/show_bug.cgi?id=242005
 */
let HisConfirmationService = /*#__PURE__*/(() => {
  class HisConfirmationService {
    constructor() {
      this.confirmationService = inject(ConfirmationService);
      this.sanitizer = inject(DomSanitizer);
    }
    confirm(confirmation) {
      confirmation.key ??= CONFIRM_PDIALOG_KEY;
      // console.log('original: ', confirmation.message);
      // console.log('escaped:  ', this.escape(confirmation.message));
      // console.log('sanitized:', this.sanitize(confirmation.message));
      confirmation.message = this.escape(confirmation.message);
      // Sanitizing e.g. replaces "Möchten Sie fortfahren?" by "M&#246;chten Sie fortfahren?"
      // We do not want that.
      this.confirmationService.confirm(confirmation);
    }
    escapeAndSanitize(str) {
      return this.escape(this.sanitize(str));
    }
    sanitize(str) {
      return str ? this.sanitizer.sanitize(SecurityContext.HTML, str) : null;
    }
    escape(str) {
      return str ? str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;') : null;
      // From https://stackoverflow.com/questions/38577347/manually-sanitize-a-string:
      // "The HTML escaping function used above escapes the same chars as angular code does
      // (unfortunately, their escaping function is not public, so we can't use it)"
    }
    static {
      this.ɵfac = function HisConfirmationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisConfirmationService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisConfirmationService,
        factory: HisConfirmationService.ɵfac
      });
    }
  }
  return HisConfirmationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * A search configuration created from a search config XML file by HisSearchService.loadSearchConfiguration()
 */
class HisSearchConfiguration {
  /**
   * Return the criterion with the given path. It seems that the method must be static if 'config'
   * has not been created via a formal constructor (but e.g. by JSON converters).
   *
   * @param config the search configuration
   * @param path the path of the search criterion to look up
   */
  static getSearchCriterion(config, path) {
    for (let group of config.searchCriteria.group) {
      for (let criterion of group.criteria) {
        if (criterion.path === path) {
          return criterion;
        }
      }
    }
    return null; // not found
  }
  static getGroup(config, path) {
    for (let group of config.searchCriteria.group) {
      for (let criterion of group.criteria) {
        if (criterion.path === path) {
          return group;
        }
      }
    }
    return null; // not found
  }
}
class HisSearchCriteria {}
/** a fieldset inside a search configuration */
class HisSearchGroup {}
/** a search criterion inside a group */
class HisSearchCriterion {
  constructor() {
    // Pflichtfeld?
    this.required = false;
    // show "(nicht gefüllt)" entry in dropdowns etc. ?
    this.showNullItem = true;
    this.showSearchFilter = true;
  }
}
class HisSearchCriteriaSet {
  constructor(id, defaulttext, configFile, context, flowName, standard, search, emptyOption) {
    this.id = id;
    this.defaulttext = defaulttext;
    this.configFile = configFile;
    this.context = context;
    this.flowName = flowName;
    this.standard = standard;
    this.search = search;
    this.emptyOption = emptyOption;
  }
}
class HisSearchCriteriaSetStateInfo {}
var HisSearchCriteriaSetStateType = /*#__PURE__*/function (HisSearchCriteriaSetStateType) {
  HisSearchCriteriaSetStateType[HisSearchCriteriaSetStateType["ADDED"] = 0] = "ADDED";
  HisSearchCriteriaSetStateType[HisSearchCriteriaSetStateType["CANCELED"] = 1] = "CANCELED";
  HisSearchCriteriaSetStateType[HisSearchCriteriaSetStateType["CHANGED_SEARCH"] = 2] = "CHANGED_SEARCH";
  HisSearchCriteriaSetStateType[HisSearchCriteriaSetStateType["DELETED"] = 3] = "DELETED";
  HisSearchCriteriaSetStateType[HisSearchCriteriaSetStateType["LOADED"] = 4] = "LOADED";
  HisSearchCriteriaSetStateType[HisSearchCriteriaSetStateType["SAVED"] = 5] = "SAVED";
  return HisSearchCriteriaSetStateType;
}(HisSearchCriteriaSetStateType || {});
/** Barrierefreiheit: Findet und fokussiert nach der Löschen-Aktion den Button mit hisImage="plus_circ_green" */
let HisDeleteActionDirective = /*#__PURE__*/(() => {
  class HisDeleteActionDirective {
    constructor() {
      this.el = inject(ElementRef);
    }
    clickEvent() {
      for (let attribute of this.el.nativeElement.attributes) {
        if (attribute.nodeName === 'hisimage') {
          if (attribute.value === 'DELETE') {
            let nearestPanel = this.el.nativeElement.closest('p-panel');
            setTimeout(() => {
              let addButton = nearestPanel?.querySelector('button[hisimage="plus_circ_green"]');
              if (addButton) {
                addButton.focus();
              }
            }, 5);
          }
          break;
        }
      }
    }
    static {
      this.ɵfac = function HisDeleteActionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDeleteActionDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisDeleteActionDirective,
        selectors: [["", "hisImage", "delete"]],
        hostBindings: function HisDeleteActionDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function HisDeleteActionDirective_click_HostBindingHandler($event) {
              return ctx.clickEvent($event);
            });
          }
        },
        standalone: false
      });
    }
  }
  return HisDeleteActionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$u = ["autocomplete"];
function HisSearchSaveParamsComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addSearchCriteriaSet());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "genericSearch.searchCriteriaSets.saveCriteria"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "genericSearch.searchCriteriaSets.saveCriteria"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 6);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "input", 18, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchSaveParamsComponent_Conditional_0_Conditional_5_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.newSearchCriteriaSetName, $event) || (ctx_r1.newSearchCriteriaSetName = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keydown.enter", function HisSearchSaveParamsComponent_Conditional_0_Conditional_5_Template_input_keydown_enter_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.saveSearchCriteriaSet();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 2, "genericSearch.searchCriteriaSet.name.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.newSearchCriteriaSetName);
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 7);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "p-autoComplete", 19, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchSaveParamsComponent_Conditional_0_Conditional_6_Template_p_autoComplete_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedSearchSet, $event) || (ctx_r1.selectedSearchSet = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("completeMethod", function HisSearchSaveParamsComponent_Conditional_0_Conditional_6_Template_p_autoComplete_completeMethod_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.completeMethod());
    })("onSelect", function HisSearchSaveParamsComponent_Conditional_0_Conditional_6_Template_p_autoComplete_onSelect_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelect($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 4, "genericSearch.searchCriteriaSets.choose"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedSearchSet);
    i0.ɵɵproperty("suggestions", ctx_r1.currentSearchCriteriaSets)("dropdown", true);
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addSearchCriteriaSet());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "genericSearch.searchCriteriaSets.newSet"), " ");
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.saveSearchCriteriaSet());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "genericSearch.searchCriteriaSets.saveSearchSet"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "common.cancel"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setAsStandard());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "genericSearch.searchCriteriaSet.setAsDefault"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.resetStandard());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "genericSearch.searchCriteriaSet.disableAsDefault"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.delete());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "genericSearch.searchCriteriaSets.deleteSearchSet"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSaveParamsComponent_Conditional_0_Conditional_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addSearchCriteriaSet());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "genericSearch.searchCriteriaSets.newSet"));
  }
}
function HisSearchSaveParamsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "his-confirm-dialog");
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
    i0.ɵɵtemplate(4, HisSearchSaveParamsComponent_Conditional_0_Conditional_4_Template, 5, 6, "button", 5)(5, HisSearchSaveParamsComponent_Conditional_0_Conditional_5_Template, 4, 4, "his-plam", 6)(6, HisSearchSaveParamsComponent_Conditional_0_Conditional_6_Template, 5, 6, "his-plam", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtemplate(8, HisSearchSaveParamsComponent_Conditional_0_Conditional_8_Template, 3, 3, "button", 9)(9, HisSearchSaveParamsComponent_Conditional_0_Conditional_9_Template, 2, 3, "button", 10)(10, HisSearchSaveParamsComponent_Conditional_0_Conditional_10_Template, 2, 3, "button", 11)(11, HisSearchSaveParamsComponent_Conditional_0_Conditional_11_Template, 2, 3, "button", 12)(12, HisSearchSaveParamsComponent_Conditional_0_Conditional_12_Template, 2, 3, "button", 13)(13, HisSearchSaveParamsComponent_Conditional_0_Conditional_13_Template, 2, 3, "button", 14)(14, HisSearchSaveParamsComponent_Conditional_0_Conditional_14_Template, 2, 3, "button", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "div", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!ctx_r1.isShowSelectField && !ctx_r1.isShowAddView ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowAddView ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowSelectField ? 6 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isShowAddLink ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowSaveIcon ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowAddView ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowSetStandardIcon ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowResetStandardIcon ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowDeleteIcon ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isShowAddIcon ? 14 : -1);
  }
}
let HisSearchSaveParamsComponent = /*#__PURE__*/(() => {
  class HisSearchSaveParamsComponent {
    constructor() {
      this.searchCriteriaSetService = inject(HisSearchCriteriaSetService);
      this.notificationService = inject(HisNotificationService);
      this.hisUiService = inject(HisUiService);
      this.confirmationService = inject(HisConfirmationService);
      this.widgetService = inject(HisWidgetService);
      this.route = inject(ActivatedRoute);
      this.searchService = inject(HisSearchService);
      this.currentSearchCriteriaSets = [];
      this.allSearchCriteriaSets = [];
      this.isShowAddView = false;
      this.isShowSetStandardIcon = false;
      this.isShowResetStandardIcon = false;
      this.isShowDeleteIcon = false;
      this.isShowAddIcon = false;
      this.isShowSaveIcon = false;
      this.isShowSelectField = false;
      this.isShowAddLink = false;
      this.isDataArrived = false;
      this.stateInfo = new HisSearchCriteriaSetStateInfo();
    }
    static {
      this.STANDARD = ' <Standard>';
    }
    /**
     * Für diese Komponente gibt es eine innere und eine aeußere Navigation.
     *
     * <p>Die innere Navigation steuert den Ablauf innerhalb der Komponente,
     * also z. B. welche Buttons werden in welchem Zusand angezeigt. Dies
     * wird beim Eintritt in die Komponente in der Methode getSearchCriteriaSets gesteuert.</p>
     *
     * <p>Existiert die Komponente bereits, dann findet diese Steuerung mittels onSelect oder
     * auch delete, add usw. statt.</p>
     *
     * <p>Die aeußere Navigation wird durch die generische Suche gesteuert,
     * also z. B. durch die Button "Neue Suche", "Suche aendern"
     * Dies findet in der Methode controlSearchFormEntry statt. Dabei ist zu beachten,
     * dass dort keine Steuerung der Buttons erfolgen sollte, da diese in nachgelagerten
     * Methoden sattfindet und sich deshalb im Zweifelsfall nicht auswirken wuerde </p>
     */
    ngOnInit() {
      this.initializeResetInputs();
      this.setComponentId();
      // Aktuell ist noch kein context in der generischen Suche implementiert
      let context = null;
      let searchCriteriaRequest = new HisSearchCriteriaSetRequest(this.configFile, context, this.componentId);
      this.getSearchCriteriaSetsAndRegulateTheInitialView(searchCriteriaRequest);
    }
    setComponentId() {
      let lastSearchCriteriaSetComponentIdFromSession = sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID);
      let isIdFromSession = !HisStringUtils.isBlank(lastSearchCriteriaSetComponentIdFromSession);
      // Alle Fälle, die von der Suchergebnisseite kommen
      if (isIdFromSession && (this.isNewSearch() || this.isChangeSearch())) {
        this.componentId = lastSearchCriteriaSetComponentIdFromSession;
        return;
      }
      // Alle Fälle die nicht von der Suchergebnisseite kommen
      if (this.route.routeConfig.component.name === 'HisSearchFormComponent' && isIdFromSession) {
        this.componentId = lastSearchCriteriaSetComponentIdFromSession;
        return;
      }
      //workaround: we should not use component.name in production mode
      this.componentId = this.callerId ?? this.route.routeConfig.component.name;
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID, this.componentId);
      return;
    }
    /**
     * Reagiert auf die Auswahl aus dem Auswahlfeld. Läd das ausgewaehlte Suchset
     * und ändert ggf die Buttons für "Standard"
     *
     * @param value the selected HisSearchCriteriaSet
     */
    onSelect(event) {
      let value = event.value;
      this.notificationService.clear();
      console.log('his-search-save-params.component#onSelect', this.selectedSearchSet);
      if (value === null || value === undefined) {
        return;
      }
      let isModified = this.isFormModified();
      if (!isModified) {
        if (value.emptyOption) {
          this.selectEmptyOption(value);
          return;
        }
        this.selectSearchSet(value);
        return;
      }
      // Wenn es bereits manuelle Änderungen im Formular durch Nutzer gab
      // Siehe Hiszilla 247517
      this.confirmationService.confirm({
        key: CONFIRM_PDIALOG_KEY,
        message: this.hisUiService.translate('genericSearch.searchCriteriaSets.unsavedChangesQuestion'),
        header: this.hisUiService.translate('cs.sys.notification.Notification.successType'),
        accept: () => {
          if (value.emptyOption) {
            this.selectEmptyOption(value);
            return;
          }
          this.selectSearchSet(value);
        },
        reject: () => {
          console.log('his-search-save-params.component#onSelect current search set on reject:', this.stateInfo.currentCriteriaSet);
          value = this.stateInfo.currentCriteriaSet;
          this.selectedSearchSet = this.stateInfo.currentCriteriaSet;
          return;
        }
      });
    }
    isFormModified() {
      for (let group of this.widgetGroups) {
        for (let widget of group.widgets) {
          if (widget.isWidgetModified()) {
            return true;
          }
        }
      }
      return false;
    }
    selectEmptyOption(value) {
      this.storeSearchSetAtSessionStorage(value);
      // model zurücksetzen
      this.resetInputs();
      // originalValue neu ausrichten
      this.setWidgetOriginalValueFromWidgetValue(true);
      // Das Auswahlfeld für Suchsets muss extra zurueckgesetzt werden,
      // da es nicht Bestandteil der form, bzw. des models ist
      this.searchService.setResetInputs(true);
      this.showSearchSetExistsButNothingSelectedView();
      this.searchFormData.groupIdsToShowExtendedCriteriaBySearchSet = [];
      this.searchFormData.widgetIdsToShowExtendedCriteriaBySearchSet = [];
    }
    selectSearchSet(value) {
      this.selectedSearchSet = value;
      this.storeSearchSetAtSessionStorage(value);
      // Wird beim Laden durchgefuehrt:
      // this.resetInputs();
      // this.searchService.setResetInputs( true );
      this.loadSearchSet(value);
      this.showSelectView();
      this.isShowSetStandardIcon = !value.standard;
      this.isShowResetStandardIcon = value.standard;
    }
    addSearchCriteriaSet() {
      this.notificationService.clear();
      this.stateInfo.stateType = HisSearchCriteriaSetStateType.ADDED;
      this.stateInfo.currentCriteriaSet = null;
      this.selectedValueBeforCancel = this.stateInfo.currentCriteriaSet;
      this.selectedSearchSet = null;
      // this.isShowSelectView = false;
      this.isShowDeleteIcon = false;
      this.isShowAddIcon = false;
      this.isShowAddLink = false;
      this.isShowSelectField = false;
      this.isShowSaveIcon = true;
      this.isShowAddView = true;
      this.isShowSetStandardIcon = false;
      this.isShowResetStandardIcon = false;
      this.isShowAddLink = false;
    }
    saveSearchCriteriaSet() {
      let searchSetToSave = this.selectedSearchSet;
      // Es muss ausgewertet werden, ob ein Suchset bereits geladen ist.
      // Siehe auch hiszilla 244933
      let isLoaded = this.stateInfo.stateType === HisSearchCriteriaSetStateType.LOADED || HisSearchCriteriaSetStateType.CHANGED_SEARCH;
      // Um Update durchzuführen muss ein Suchset bereits gespeichert sein
      // Siehe auch hiszilla 245707
      if (isLoaded && searchSetToSave !== this.stateInfo.currentCriteriaSet) {
        searchSetToSave = this.stateInfo.currentCriteriaSet;
      }
      let isAlreadySaved = searchSetToSave !== null && searchSetToSave !== undefined && searchSetToSave.id !== null && !HisStringUtils.isBlank(searchSetToSave.defaulttext);
      if (isAlreadySaved && isLoaded) {
        this.update(this.stateInfo.currentCriteriaSet);
      } else {
        this.save();
      }
      this.setWidgetOriginalValueFromWidgetValue(false);
      this.setAutocompleteInputFocus();
    }
    setAutocompleteInputFocus() {
      setTimeout(() => {
        if (this.autocomplete) {
          console.log('his-search-save-params.component#setAutocompleteInputFocus()', this.autocomplete);
          if (this.autocomplete.multiple) {
            this.autocomplete.multiInputEl.nativeElement.focus();
          } else {
            this.autocomplete.inputEL?.nativeElement.focus();
          }
          return;
        }
      }, 100);
    }
    /**
     * Neu Ausrichten von originalValue und originalNot
     *
     * @param reset Wenn dieser boolean Param auf true gesetzt wird,
     * dann werden alle original values auf null bzw. false gesetzt
     */
    setWidgetOriginalValueFromWidgetValue(reset) {
      for (let group of this.widgetGroups) {
        for (let widget of group.widgets) {
          if (reset) {
            widget.originalValue = null;
          } else {
            // Im Fall von Array-Werten brauchen wir unterschiedliche Objekte,
            // damit Änderungen an value nicht gleich Änderungen bei originalValue sind
            widget.originalValue = Array.isArray(widget.value) ? [...widget.value] : widget.value;
          }
          if (widget instanceof HisWidgetBaseSelect) {
            widget.originalNot = reset ? false : widget.not;
          }
        }
      }
    }
    save() {
      this.notificationService.clear();
      let info = this.stateInfo;
      if (info.currentCriteriaSet === null || info.currentCriteriaSet.id === null) {
        // Speichern leerer Suchsetnamen verhindern
        if (HisStringUtils.isBlank(this.newSearchCriteriaSetName)) {
          this.notificationService.error(this.hisUiService.translate('genericSearch.searchCriteriaSets.saveProblemNoNameGiven', this.newSearchCriteriaSetName), this.hisUiService.translate('view.messages.error'));
          return;
        }
        // doppelte und verbotene Suchsetnamen verhindern
        for (let criteriaSet of this.allSearchCriteriaSets) {
          if (criteriaSet.emptyOption) {
            continue;
          }
          // hier noch Standard berücksichtigen
          let isEqalName = criteriaSet.defaulttext === this.newSearchCriteriaSetName;
          let isEqualToStandardSet = criteriaSet.defaulttext.replace(HisSearchSaveParamsComponent.STANDARD, '').trim() === this.newSearchCriteriaSetName;
          // eventuell hier mehr unterschiedliche Meldungen das gibt es in JSF aber nicht
          if (isEqalName || isEqualToStandardSet || criteriaSet.emptyOption) {
            this.notificationService.error(this.hisUiService.translate('genericSearch.searchCriteriaSets.duplicateNameError', this.newSearchCriteriaSetName), this.hisUiService.translate('view.messages.error'));
            // undefined oder null, was ist hier richtig?
            this.newSearchCriteriaSetName = null;
            return;
          }
        }
        this.notificationService.clear();
        // Es ist hier ein noch nicht in der DB gespeicherter Wert und hat deshalb keine Id
        let id = null;
        // Context ist noch nicht implementiert
        let context = null;
        // Standard true kann erst vergeben werden, wenn das Suchset jemals gespeichert war
        let isStandard = false;
        let search = HisSearchParserHelper.createNewHisSearchByWidgetValues(this.widgetGroups, this.configFile);
        console.log('his-search-save-params.component#save()', '#search', search);
        let searchCriteriaSetToSave = new HisSearchCriteriaSet(id, HisStringUtils.trimAll(this.newSearchCriteriaSetName), this.configFile, context, this.componentId, isStandard, search);
        this.searchCriteriaSetService.saveSearchCriteriaSet(searchCriteriaSetToSave).subscribe(savedSearchCriteriaSet => {
          if (savedSearchCriteriaSet != null) {
            // Wenn das Suchset das erste ist, dann eine leere Option hinzufügen
            console.log('allSearchCriteriaSets', this.allSearchCriteriaSets.length);
            console.log('currentSearchCriteriaSets', this.currentSearchCriteriaSets.length);
            if (this.allSearchCriteriaSets.length === 0 && this.currentSearchCriteriaSets.length === 0) {
              this.addEmptyOption();
            }
            this.allSearchCriteriaSets.push(savedSearchCriteriaSet);
            this.currentSearchCriteriaSets.push(savedSearchCriteriaSet);
            this.notificationService.success(this.hisUiService.translate('cs.sys.portal.portlet.portalmessages.save'), this.hisUiService.translate('view.messages.success'));
            this.showSelectView();
            // Da das hier gespeicherte Suchset immer neu ist
            // unterscheidet es sich hier vom Update
            this.isShowSetStandardIcon = true;
            this.isShowResetStandardIcon = false;
            this.selectedSearchSet = savedSearchCriteriaSet;
            this.storeSearchSetAtSessionStorage(savedSearchCriteriaSet);
            this.newSearchCriteriaSetName = ''; // clear input
            // Wenn ein Suchset gespeichert ist,
            // dann sollte der Zustand so sein, wie enn es geladen ist
            this.stateInfo.currentCriteriaSet = savedSearchCriteriaSet;
            // Hier ist 'gespeichert' mit 'geladen' gleichzusetzen
            this.stateInfo.stateType = HisSearchCriteriaSetStateType.LOADED;
          }
        });
        return;
      }
    }
    update(loadedCriteriaSet) {
      this.notificationService.clear();
      if (loadedCriteriaSet === null) {
        throw new Error('HisSearchCriteriaSet to update must not be null');
      }
      if (loadedCriteriaSet.id === null) {
        throw new Error('HisSearchCriteriaSet to update must not have null id');
      }
      let search = HisSearchParserHelper.createNewHisSearchByWidgetValues(this.widgetGroups, this.configFile);
      loadedCriteriaSet.search = search;
      this.searchCriteriaSetService.updateSearchCriteriaSet(loadedCriteriaSet).subscribe(updatedSearchCriteriaSet => {
        if (updatedSearchCriteriaSet) {
          this.notificationService.success(this.hisUiService.translate('cs.sys.portal.portlet.portalmessages.save'), this.hisUiService.translate('view.messages.success'));
          this.showSelectView();
          // 1. Damit hier bei einer Eingabe auch das geladene Suchset angezeigt wird, Siehe Hizilla 244933
          // 2. Falls das gespeicherte Suchset ein Standard Suchset ist,
          // muss auch der Zusatz <Standard> angezeigt werden
          let updatedSet = updatedSearchCriteriaSet;
          if (updatedSet.standard) {
            updatedSet.defaulttext = updatedSet.defaulttext + HisSearchSaveParamsComponent.STANDARD;
          }
          this.stateInfo.currentCriteriaSet = updatedSet;
          this.selectedSearchSet = this.stateInfo.currentCriteriaSet;
          // altes Set aus Listen löschen
          this.initAllSearchCriteriaSetsAndRemoveById(updatedSet.id);
          this.initCurrentSearchCriteriaSetsAndRemoveById(updatedSet.id);
          // geupdatetes Set hinzufügen
          this.allSearchCriteriaSets.push(updatedSet);
          this.currentSearchCriteriaSets.push(updatedSet);
          this.isShowSetStandardIcon = !updatedSearchCriteriaSet.standard;
          this.isShowResetStandardIcon = updatedSearchCriteriaSet.standard;
        }
      });
    }
    enrichSearchConfigurationWithSearchCriteria(searchConfiguration, search) {
      for (let group of search.groups) {
        for (let criterion of group.criteria) {
          this.enrichSearchConfigurationWithSearchCriterionValue(criterion, searchConfiguration);
        }
        for (let criteriaGroup of group.criteriaGroups) {
          for (let criterion of criteriaGroup.criteria) {
            this.enrichSearchConfigurationWithSearchCriterionValue(criterion, searchConfiguration);
          }
        }
      }
      return searchConfiguration;
    }
    enrichSearchConfigurationWithSearchCriterionValue(criterion, searchConfiguration) {
      for (let group of searchConfiguration.searchCriteria.group) {
        for (let searchCriterion of group.criteria) {
          // .endsWith: Kriteriengruppen: de.his.psv.suchePersonen[1]Person.gender.id
          if (criterion.field.endsWith(searchCriterion.path) && criterion.value) {
            searchCriterion.value = criterion.value;
            searchCriterion.not = criterion.not;
          }
        }
      }
    }
    loadSearchSet(searchCriteriaSetToLoad) {
      this.resetInputs();
      this.searchService.setResetInputs(true);
      this.selectedSearchSet = searchCriteriaSetToLoad;
      this.searchCriteriaSetService.loadCriteriaSet(searchCriteriaSetToLoad.id).subscribe(search => {
        console.log('his-search-save-params.component#loadSearchSet() #search', search);
        if (search) {
          search.configFile = this.configFile;
          let originalSearchConfig = this.searchFormData.getSearchConfiguration();
          // console.log( 'his-search-save-params.component#loadSearchSet() #originalSearchConfig: ', originalSearchConfig );
          let copyOfSearchConfig = this.getCopyOfSearchConfiguration(originalSearchConfig);
          // console.log( 'his-search-save-params.component#loadSearchSet() #copyOfSearchConfig: ', copyOfSearchConfig );
          let enrichedSearchConfig = this.enrichSearchConfigurationWithSearchCriteria(copyOfSearchConfig, search);
          console.log('his-search-save-params.component#loadSearchSet() #enrichedSearchConfig: ', enrichedSearchConfig);
          let isValueInNonQuicksearchGroup = this.evaluateExtendedSearch(enrichedSearchConfig, search);
          if (isValueInNonQuicksearchGroup) {
            // hier werden nur die Options nachgeladen, das Anzeigen der Felder wird in his-search-form.html geregelt
            // hier brauche ich dann den Übersetzunggschritt zu searchConfiguration;
            this.widgetService.loadWidgetOptions(enrichedSearchConfig, true);
          }
          this.setWidgetGroups(search, searchCriteriaSetToLoad);
          // originalValue neu ausrichten
          this.setWidgetOriginalValueFromWidgetValue(false);
          this.stateInfo.currentCriteriaSet = searchCriteriaSetToLoad;
          this.stateInfo.stateType = HisSearchCriteriaSetStateType.LOADED;
        }
      });
    }
    getCopyOfSearchConfiguration(searchConfiguration) {
      let copyOfSearchConfig = new HisSearchConfiguration();
      copyOfSearchConfig.configFile = _.cloneDeep(searchConfiguration.configFile);
      copyOfSearchConfig.name = _.cloneDeep(searchConfiguration.name);
      copyOfSearchConfig.pageTitle = _.cloneDeep(searchConfiguration.pageTitle);
      copyOfSearchConfig.searchCriteria = _.cloneDeep(searchConfiguration.searchCriteria);
      copyOfSearchConfig.tableTitle = _.cloneDeep(searchConfiguration.tableTitle);
      return copyOfSearchConfig;
    }
    evaluateExtendedSearch(searchConfiguration, search) {
      console.log('his-search-save-params.component#evaluateExtendedSearch() #searchConfiguration', searchConfiguration);
      // gespeicherte Werte, die in der erweiterten Suche stehen, müssen angezeigt werden
      // his-search-form.html mitteilen, dass weitere Felder
      // außer sie Schnellsuchfelder angezeigt werden sollen
      let isValueInNonQuicksearchGroup = false;
      let groupIdsToShowExtendedCriteria = [];
      let widgetIdsToShowExtendedCriteria = [];
      for (let group of search.groups) {
        for (let criterion of group.criteria) {
          console.log('his-search-save-params.component#evaluateExtendedSearch() #criterion', criterion);
          let searchCriterion = HisSearchConfiguration.getSearchCriterion(searchConfiguration, criterion.field);
          let searchGroup = HisSearchConfiguration.getGroup(searchConfiguration, criterion.field);
          // Fehlende widget options nachladen wenn
          // 1. es eine Quicksearch Gruppe ist und darin ein nicht quicksearch Feld ist, für das Werte gespeichert wurden
          if (searchGroup.quickSearchGroup && !searchCriterion.quickSearchCriterion) {
            widgetIdsToShowExtendedCriteria.push(criterion.field);
          }
          // 2. es KEINE Quicksearch Gruppe ist und darin ein nicht quicksearch Feld ist, für das Werte gespeichert wurden
          if (!searchGroup.quickSearchGroup && !searchCriterion.quickSearchCriterion) {
            widgetIdsToShowExtendedCriteria.push(criterion.field);
            groupIdsToShowExtendedCriteria.push(group.groupLabel);
            isValueInNonQuicksearchGroup = true;
          }
        }
      }
      this.searchFormData.groupIdsToShowExtendedCriteriaBySearchSet = groupIdsToShowExtendedCriteria;
      this.searchFormData.widgetIdsToShowExtendedCriteriaBySearchSet = widgetIdsToShowExtendedCriteria;
      return isValueInNonQuicksearchGroup;
    }
    setWidgetGroups(search, searchCriteriaSetToLoad) {
      console.log('his-search-save-params.component#setWidgetGroups() #search', search);
      const lazyLoadedWidgetAssignments = new Map();
      for (let loadedGroup of search.groups) {
        // Hier findet das Füllen der Werte in das Formular statt
        // in search-form geht das über die Params und die Vorbelegung der Widgets
        for (let loadedCriteria of loadedGroup.criteria) {
          if (loadedCriteria.value === null || loadedCriteria.value === undefined) {
            continue;
          }
          // console.log('his-search-save-params.component#setWidgetGroups() #loadedCriteria', loadedCriteria);
          let widgetToSet = HisWidgetUtils.getWidgetWithIdFromWidgetGroups(loadedCriteria.field, this.widgetGroups);
          // console.log('his-search-save-params.component#setWidgetGroups() #widgetToSet', widgetToSet);
          // console.log('his-search-save-params.component#setWidgetGroups() #this.widgetGroups', this.widgetGroups);
          if (widgetToSet instanceof HisSelectWidget && GenericSearchUtil.isLazySelectFrom(widgetToSet.optionsKey, widgetToSet.showDropdownIcon)) {
            lazyLoadedWidgetAssignments.set(widgetToSet, loadedCriteria);
            continue;
          }
          this.setCriteriaValue(loadedCriteria, widgetToSet);
        }
        this.searchFormData.copyWidgetsFromGroupAndCreateCriteriaGroup(loadedGroup, false);
        this.searchForm.populateLazyWidgetValues(search);
      }
      const finishedLoadingObservable = this.setLazyWidgetValues(lazyLoadedWidgetAssignments, search);
      console.log('his-search-save-params.component#setWidgetGroups() #this.widgetGroups', this.widgetGroups);
      /* Nicht ladbare Suchkriterien ermitteln */
      finishedLoadingObservable.subscribe(() => {
        this.findNotLoadedCriteriaAndTriggerMessage(this.widgetGroups, searchCriteriaSetToLoad);
      });
    }
    setLazyWidgetValues(lazyLoadedWidgetAssignments, search) {
      console.log('his-search-save-params.component#setLazyWidgetValues() #lazyLoadedWidgetAssignments', lazyLoadedWidgetAssignments.keys());
      const subject = new Subject();
      const optionByIdRequests = [];
      for (let widgetAssignment of lazyLoadedWidgetAssignments.keys()) {
        const criterion = lazyLoadedWidgetAssignments.get(widgetAssignment);
        this.searchFormData.triggerOperator(criterion.not, widgetAssignment);
        optionByIdRequests.push(new OptionByIdRequest(widgetAssignment.optionsKey, [criterion.value]));
      }
      if (optionByIdRequests.length == 0) {
        subject.next();
        return subject;
      }
      this.searchService.loadOptionsByIds(search.configFile, optionByIdRequests).subscribe(result => {
        if (!result) {
          subject.next();
          return;
        }
        for (let selectedOption of result) {
          if (!selectedOption || !selectedOption.selectedOptions || selectedOption.selectedOptions.length == 0) {
            continue;
          }
          const matchedWidget = Array.from(lazyLoadedWidgetAssignments.keys()).find(widget => widget.optionsKey === selectedOption.selectFrom);
          this.setNewWidgetValue(matchedWidget, selectedOption.selectedOptions[0]);
        }
        subject.next();
      });
      return subject;
    }
    showMessageCouldNotLoadAllCriteria() {
      this.notificationService.warn(this.hisUiService.translate('genericSearch.searchCriteriaSets.applyProblem'), this.hisUiService.translate('view.messages.warning'));
    }
    setCriteriaValue(criterion, widgetToSet) {
      if (widgetToSet instanceof HisWidgetBaseSelect) {
        this.searchFormData.triggerOperator(criterion.not, widgetToSet);
        let isLidSearch = GenericSearchUtil.isLidPath(widgetToSet.id);
        // (nicht gefüllt)/(value not existing), see #325731
        if (criterion.value && criterion.value === 'ISNULL') {
          let option = new HisOption();
          option.id = criterion.value;
          let nullValueLabel = this.hisUiService.translate('genericSearch.nullValueMenuEntry');
          option.label = nullValueLabel;
          this.setNewWidgetValue(widgetToSet, option);
          return;
        }
        widgetToSet.getWidgetValues(criterion.value, isLidSearch).subscribe(optionsToSet => {
          if (optionsToSet) {
            this.setNewWidgetValue(widgetToSet, optionsToSet);
          }
        });
      } else if (widgetToSet instanceof HisOptionWidget) {
        if (criterion.value) {
          // console.log('his-search-save-params.component#setWidgetGroups() #checkbox value', loadedCriteria.value);
          // console.log('his-search-save-params.component#setWidgetGroups() #widgetToSet', widgetToSet);
          widgetToSet.option = criterion.value;
          this.setNewWidgetValue(widgetToSet, true);
        }
      } else {
        // Eingabefeld aktualisieren, value: string
        if (widgetToSet.id !== criterion.value) {
          // console.log('his-search-save-params.component#setWidgetGroups() #input, date', loadedCriteria.value);
          // console.log('his-search-save-params.component#setWidgetGroups() #widgetToSet', widgetToSet);
          this.setNewWidgetValue(widgetToSet, criterion.value);
        }
      }
    }
    /**
     * prüft, ob es criteria gibt, die nicht geladen werden kann,
     * etwa weil sich die Suchkonfiguration geändert hat und das
     * erwartete Feld nicht mehr im Suchformular enthalten ist
     * oder ein Option nicht mehr vorhanden ist
     *
     * @param loadedWidgetGroups    die aufgrund des Suchsets geladenen widgetGroups,
     *                              ohne diejenigen, die nicht mehr in der Suchkonfiguration enthalten sind
     *
     * @param searchCriteriaSetToLoad das Suchset, das geladen werden soll mit den eventuell nicht ladbaren Suchkriterien
     *
     * @return array von HisSearchSetCriteria, die nicht geladen werden konnten
     */
    findNotLoadedCriteriaAndTriggerMessage(loadedWidgetGroups, searchCriteriaSetToLoad) {
      for (let group of searchCriteriaSetToLoad.search.groups) {
        for (let criterion of group.criteria) {
          this.findNotLoadedCriterionAndTriggerMessage(criterion, loadedWidgetGroups);
        }
      }
    }
    findNotLoadedCriterionAndTriggerMessage(criteria, loadedWidgetGroups) {
      console.log('his-search-save-params.component#findNotLoadedCriterion() #criteria', criteria);
      let widget = HisWidgetUtils.getWidgetWithIdFromWidgetGroups(criteria.field, loadedWidgetGroups);
      if (widget === null || widget === undefined) {
        return;
      }
      if (widget instanceof HisSelectWidget) {
        if (GenericSearchUtil.isLazySelectFrom(widget.optionsKey, widget.showDropdownIcon)) {
          //Lazy
          if (widget.value.id !== criteria.value && criteria.value !== 'ISNULL') {
            this.showMessageCouldNotLoadAllCriteria();
            return;
          }
        } else {
          widget.options.subscribe(opts => {
            if (opts) {
              let optionIds = HisWidgetUtils.getOptionIds(opts);
              console.log('not loadable optionIds', optionIds, criteria.value, !optionIds.includes(criteria.value));
              if (!optionIds.includes(criteria.value) && criteria.value !== 'ISNULL') {
                this.showMessageCouldNotLoadAllCriteria();
                return;
              }
            }
          });
        }
      } else if (widget instanceof HisMultiSelectWidget) {
        // ACHTUNG: Wenn hier ein Wert ausgewählt ist,
        // dann wird dieser aus der Liste der verfügbaren Werte entfernt (aus den options)
        // Außerdem muss beachtet werden, dass criteria.value hier mehrere Werte enthalten kann
        let criteriaValues = criteria.value.split(',');
        widget.options.subscribe(opts => {
          if (opts && opts.length > 0) {
            let optIds = HisWidgetUtils.getOptionIds(opts);
            // console.log( 'opts =', opts, ', optIds =', optIds );
            let notExistentValues = HisArrayUtils.getNotContainedElements(criteriaValues, optIds);
            console.log('criteriaValues =', criteriaValues, ', notExistentValues =', notExistentValues);
            if (notExistentValues.length > 0) {
              this.showMessageCouldNotLoadAllCriteria();
              return;
            }
          }
        });
      } else if (widget instanceof HisSearchSelectWidget) {
        // Wo kommen die Options für HisSearchSelect her?
        // Im Service steht: options for autocomplete in his-search-select are loaded in the component,
        // filtered by the autocomplete input
        // widget.values hat jedoch HisOptions[]
        let widgetValues = widget.value.toString().split(',');
        let criteriaValues = criteria.value.split(',');
        // XXX Der folgende Ausdruck gibt niemals 'true' weil widget.value asynchron geladen wird und hier noch [] ist.
        if (HisArrayUtils.containsAll(criteriaValues, widgetValues)) {
          return;
        }
        // hier habe ich keine options, das widget kennt diesel nicht
        // also holen, eventuell gibt es die auch schon, aber wo?:
        let filteredSelectList = [];
        // suchen ohne Einschränkung
        let wherePart = '';
        // hier sollten möglichst alle Options gefunden werden
        let limit = 1000;
        this.searchService.loadFilteredOptions(widget.searchConfigFile, wherePart, limit).subscribe(result => {
          if (result) {
            filteredSelectList = result;
            let filteredSelectListIds = [];
            for (let option of filteredSelectList) {
              filteredSelectListIds.push(option.id);
            }
            let notContainedValues = HisArrayUtils.getNotContainedElements(criteriaValues, filteredSelectListIds);
            console.log('not contained values', notContainedValues);
            if (notContainedValues.length > 0) {
              this.showMessageCouldNotLoadAllCriteria();
              return;
            }
          }
        });
      } else if (widget instanceof HisTreeSelectWidget) {
        // Achtung: Lid Behandlung
        widget.treeSubject.subscribe(tree => {
          if (tree) {
            // Baum-Elemente, die inkl. Unterbaum ausgewählt wurden,
            // haben ein x an der id hängen, z.B. "3x", (siehe auch #250963).
            // console.log( 'widget', widget.id, ': tree =', tree );
            let isLidSearch = GenericSearchUtil.isLidPath(widget.id);
            let treeNodeIds = HisTreeSelectWidget.getAllTreeNodeIds(tree, isLidSearch);
            // console.log('his-search-save-params.component#findNotLoadedCriterion() #treeNodeIds', treeNodeIds);
            let treeNodeIdsAsStringArray = treeNodeIds.map(value => String(value));
            let criteriaValues = criteria.value.split(',');
            let notContainedValues = this.getNotContainedTreeNodeElements(criteriaValues, treeNodeIdsAsStringArray);
            // console.log('his-search-save-params.component#findNotLoadedCriterion() #notContainedValues', notContainedValues);
            if (notContainedValues.length > 0) {
              this.showMessageCouldNotLoadAllCriteria();
              return;
            }
          }
        });
      } else {
        // input/checkbox/date: nichts machen
      }
    }
    getNotContainedTreeNodeElements(criteriaValues, treeNodeIdsAsStringArray) {
      // console.log('his-search-save-params.component#getNotContainedTreeNodeElements() #criteriaValues', criteriaValues);
      if (criteriaValues === null || criteriaValues === undefined) {
        throw new Error('array1 must not be null or undefined');
      }
      if (treeNodeIdsAsStringArray === null || treeNodeIdsAsStringArray === undefined) {
        throw new Error('array2 must not be null or undefined');
      }
      let notContainedElements = [];
      for (let criteriaValue of criteriaValues) {
        // Baum-Elemente, die inkl. Unterbaum ausgewählt wurden,
        // haben ein x an der id hängen, z.B. "3x", (siehe auch #250963).
        let value = criteriaValue.replace('x', '');
        if (!treeNodeIdsAsStringArray.includes(value)) {
          notContainedElements.push(criteriaValue);
        }
      }
      return notContainedElements;
    }
    /**
     * Setzt den Wert des Widgets mit der Id 'widgetToSet.id' sowohl im Ui
     * als auch im Model für alle Felder ausser für Checkboxen.
     *
     * @param widgetToSet Das Widget, dass aktualisiert werden soll
     * @param loadedValue Der Wert der dem Widget.value übergeben werden soll
     */
    setNewWidgetValue(widgetToSet, loadedValue) {
      // Achtung, böse Falle:
      // Das Ui und das Model verwenden teilweise unterschiedliche Variablen
      if (loadedValue === null || loadedValue === undefined) {
        return;
      }
      // Ui aktualisieren
      widgetToSet.value = loadedValue;
      // Model aktualisieren
      this.form.value[widgetToSet.id] = loadedValue;
      this.form.controls[widgetToSet.id].setValue(loadedValue);
      this.form.controls[widgetToSet.id].markAsDirty();
      // original-Werte vor Inputs aktualisieren:
      // Im Fall von Array-Werten brauchen wir unterschiedliche Objekte,
      // damit Änderungen an value nicht gleich Änderungen bei originalValue sind
      widgetToSet.originalValue = Array.isArray(loadedValue) ? [...loadedValue] : loadedValue;
      console.log('set', widgetToSet.id, 'originalValue to', widgetToSet.originalValue);
    }
    getDefaultSearchCriteriaSetIfPresent() {
      for (let criteriaSet of this.allSearchCriteriaSets) {
        if (criteriaSet.standard === true && criteriaSet.defaulttext.endsWith(HisSearchSaveParamsComponent.STANDARD)) {
          return criteriaSet;
        }
      }
      return undefined;
    }
    setAsStandard() {
      this.notificationService.clear();
      let currentSet = this.stateInfo.currentCriteriaSet;
      if (currentSet != null && currentSet.id != null) {
        // Die Daten in der Suchmaske können sich ändern, deshalb werden hier nochmal die aktuellen Daten abgefragt
        currentSet.standard = true;
        let search = HisSearchParserHelper.createNewHisSearchByWidgetValues(this.widgetGroups, this.configFile);
        currentSet.search = search;
        let otherStandardCriteriaSet = this.getDefaultSearchCriteriaSetIfPresent();
        this.searchCriteriaSetService.updateSearchCriteriaSet(currentSet).subscribe(newSavedSearchCriteriaSet => {
          if (newSavedSearchCriteriaSet != null) {
            // Neues Hinzufügen Anfang - das betrifft nur das Ui,
            // die Objekte in der Datenbank werden vom Backend verwaltet
            this.initCurrentSearchCriteriaSetsAndRemoveById(currentSet.id);
            this.initAllSearchCriteriaSetsAndRemoveById(currentSet.id);
            this.selectedSearchSet = newSavedSearchCriteriaSet;
            this.selectedSearchSet.defaulttext = newSavedSearchCriteriaSet.defaulttext + HisSearchSaveParamsComponent.STANDARD;
            this.stateInfo.currentCriteriaSet = this.selectedSearchSet;
            this.storeSearchSetAtSessionStorage(newSavedSearchCriteriaSet);
            // erst pushen dann löschen wegen der Initialisierung
            this.allSearchCriteriaSets.push(this.selectedSearchSet);
            this.currentSearchCriteriaSets.push(currentSet);
            this.notificationService.success(this.hisUiService.translate('cs.sys.portal.portlet.portalmessages.save'), this.hisUiService.translate('view.messages.success'));
            // Neues Hinzufügen Ende
            this.isShowSetStandardIcon = false;
            this.isShowResetStandardIcon = true;
          }
        });
        this.removeStandardSetFromUi(otherStandardCriteriaSet);
        this.setWidgetOriginalValueFromWidgetValue(false);
      }
    }
    removeStandardSetFromUi(standardCriteriaSetToRemove) {
      if (standardCriteriaSetToRemove !== undefined) {
        // Bisheriges Suchset entfernen - das betrifft nur das Ui,
        // die Objekte in der Datenbank werden vom Backend verwaltet
        this.initCurrentSearchCriteriaSetsAndRemoveById(standardCriteriaSetToRemove.id);
        this.initAllSearchCriteriaSetsAndRemoveById(standardCriteriaSetToRemove.id);
        standardCriteriaSetToRemove.defaulttext = standardCriteriaSetToRemove.defaulttext.replace(HisSearchSaveParamsComponent.STANDARD, '').trim();
        standardCriteriaSetToRemove.standard = false;
        this.storeSearchSetAtSessionStorage(standardCriteriaSetToRemove);
        this.allSearchCriteriaSets.push(standardCriteriaSetToRemove);
        this.currentSearchCriteriaSets.push(standardCriteriaSetToRemove);
      }
    }
    resetStandard() {
      this.notificationService.clear();
      let currentSet = this.stateInfo.currentCriteriaSet;
      console.log('resetStandard #this.stateInfo', this.stateInfo);
      if (currentSet != null && currentSet.id != null) {
        let search = HisSearchParserHelper.createNewHisSearchByWidgetValues(this.widgetGroups, this.configFile);
        currentSet.search = search;
        currentSet.standard = false;
        currentSet.defaulttext = this.selectedSearchSet.defaulttext.replace(HisSearchSaveParamsComponent.STANDARD, '').trim();
        this.searchCriteriaSetService.updateSearchCriteriaSet(currentSet).subscribe(savedSearchCriteriaSet => {
          if (savedSearchCriteriaSet != null) {
            this.initCurrentSearchCriteriaSetsAndRemoveById(currentSet.id);
            this.initAllSearchCriteriaSetsAndRemoveById(currentSet.id);
            this.selectedSearchSet = savedSearchCriteriaSet;
            this.stateInfo.currentCriteriaSet = this.selectedSearchSet;
            this.allSearchCriteriaSets.push(currentSet);
            this.currentSearchCriteriaSets.push(currentSet);
            this.storeSearchSetAtSessionStorage(savedSearchCriteriaSet);
            this.notificationService.success(this.hisUiService.translate('cs.sys.portal.portlet.portalmessages.save'), this.hisUiService.translate('view.messages.success'));
            this.isShowSetStandardIcon = true;
            this.isShowResetStandardIcon = false;
            this.setWidgetOriginalValueFromWidgetValue(false);
          }
        });
      }
    }
    cancel() {
      this.newSearchCriteriaSetName = '';
      // für alle
      this.isShowAddView = false;
      if (this.allSearchCriteriaSets.length === 0) {
        this.showNoSearchSetExistsView();
        return;
      }
      if (this.allSearchCriteriaSets.length > 0 && this.selectedValueBeforCancel != null) {
        this.selectedSearchSet = this.selectedValueBeforCancel;
        this.stateInfo.currentCriteriaSet = this.selectedValueBeforCancel;
        this.stateInfo.stateType = HisSearchCriteriaSetStateType.CANCELED;
        this.showSelectView();
        this.isShowSetStandardIcon = !this.selectedSearchSet.standard;
        this.isShowResetStandardIcon = this.selectedSearchSet.standard;
        this.selectedValueBeforCancel = null;
        return;
      }
      if (this.allSearchCriteriaSets.length > 0 && this.selectedValueBeforCancel == null) {
        this.showSearchSetExistsButNothingSelectedView();
        this.selectedValueBeforCancel = null;
        return;
      }
    }
    delete() {
      this.notificationService.clear();
      let currentSet = this.selectedSearchSet;
      if (this.stateInfo.currentCriteriaSet) {
        currentSet = this.stateInfo.currentCriteriaSet;
      }
      this.confirmationService.confirm({
        key: CONFIRM_PDIALOG_KEY,
        message: this.hisUiService.translate('genericSearch.searchCriteriaSet.deleteQuestion', currentSet.defaulttext),
        accept: () => {
          this.searchCriteriaSetService.deleteSearchCriteriaSet(currentSet.id).subscribe(deleteSuccess => {
            if (deleteSuccess === 1) {
              // Delete Success Message
              this.notificationService.success(this.hisUiService.translate('de.his.javang.successfullySaved'), this.hisUiService.translate('view.messages.success'));
              this.initAllSearchCriteriaSetsAndRemoveById(currentSet.id);
              this.initCurrentSearchCriteriaSetsAndRemoveById(currentSet.id);
              // Anfang Empty Option entfernen
              // Wenn das Suchset das letzte Suchset ist,
              // das nicht emptyOption ist, dann muss auch emptyOption gelöscht werden
              if (this.allSearchCriteriaSets.length === 1 && this.allSearchCriteriaSets[0].emptyOption) {
                this.allSearchCriteriaSets = [];
              }
              if (this.currentSearchCriteriaSets.length === 1 && this.currentSearchCriteriaSets[0].emptyOption) {
                this.currentSearchCriteriaSets = [];
              }
              // Ende Empty Option entfernen
              this.selectedSearchSet = null; // clear selectedValue
              // eigentlich ist nun emptyOption ausgewählt
              this.stateInfo.currentCriteriaSet = null;
              this.stateInfo.stateType = HisSearchCriteriaSetStateType.DELETED;
              sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET);
              if (this.allSearchCriteriaSets.length === 0) {
                this.showNoSearchSetExistsView();
              } else {
                this.showSearchSetExistsButNothingSelectedView();
              }
            }
          });
        }
      });
    }
    initAllSearchCriteriaSetsAndRemoveById(id) {
      this.allSearchCriteriaSets = []; // ohne Neu-Initialisierung funktioniert es nicht
      for (let criteriaSet of this.currentSearchCriteriaSets) {
        if (criteriaSet.id !== id) {
          this.allSearchCriteriaSets.push(criteriaSet);
        }
      }
    }
    initCurrentSearchCriteriaSetsAndRemoveById(id) {
      this.currentSearchCriteriaSets = []; // ohne Neu-Initialisierung funktioniert es nicht
      for (let criteriaSet of this.allSearchCriteriaSets) {
        if (criteriaSet.id !== id) {
          this.currentSearchCriteriaSets.push(criteriaSet);
        }
      }
    }
    completeMethod() {
      this.currentSearchCriteriaSets = []; // ohne Neu-Initialisierung funktioniert es nicht
      for (let searchCriteriaSet of this.allSearchCriteriaSets) {
        this.currentSearchCriteriaSets.push(searchCriteriaSet);
      }
    }
    isChangeSearch() {
      return sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON) === 'CHANGE_SEARCH';
    }
    isNewSearch() {
      return sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON) === 'NEW_SEARCH';
    }
    isNavigation() {
      return !this.isChangeSearch() && !this.isNewSearch();
    }
    getStandardSet() {
      for (let searchSet of this.allSearchCriteriaSets) {
        if (searchSet.standard) {
          return searchSet;
        }
      }
      return null;
    }
    /**
     * Setzt die ermittelten Suchsets initial in {@code allSearchCriteriaSets}
     * und {@code currentSearchCriteriaSets}, damit diese im Auswahlfeld angezeigt werden können.
     *
     * <p>Falls es ein Standard Suchset gibt, wird an dessen Namen der Zusatz <Standard> angehängt.</p>
     * <p>Falls das Array mit den ermittelten Suchsets nicht leer ist, wird eine leere Option hinzugefügt</p>
     *
     * @param foundSearchCriteriaSets die ermittelten Suchsets
     */
    setSearchSets(foundSearchCriteriaSets) {
      if (foundSearchCriteriaSets.length < 1) {
        return;
      }
      this.allSearchCriteriaSets = [];
      let emptyOptionSet = new HisSearchCriteriaSet();
      emptyOptionSet.emptyOption = true;
      this.allSearchCriteriaSets.push(emptyOptionSet);
      for (let set of foundSearchCriteriaSets) {
        if (set.standard) {
          set.defaulttext = set.defaulttext + HisSearchSaveParamsComponent.STANDARD;
        }
        this.allSearchCriteriaSets.push(set);
      }
      this.currentSearchCriteriaSets = [];
      for (let set of this.allSearchCriteriaSets) {
        this.currentSearchCriteriaSets.push(set);
      }
    }
    /**
     * Holt aufgrund der in {@code searchCriteriaSetRequest} übermittelten Daten die Suchsets aus der Datenbank
     * und setzt diese initial in {@code allSearchCriteriaSets} und {@code currentSearchCriteriaSets},
     * damit diese im Auswahlfeld angezeigt werden können.
     *
     * <p>In dieser Methode wird initial der Zustand der Anzeige der Suchsets beim Betreten der Seite geregelt.</p>
     *
     * @param searchCriteriaSetRequest ein {@link HisSearchCriteriaSetRequest} mit Daten zum Ermitteln von Suchsets in der Datenbank
     */
    getSearchCriteriaSetsAndRegulateTheInitialView(searchCriteriaSetRequest) {
      this.searchCriteriaSetService.getSearchCriteriaSets(searchCriteriaSetRequest).subscribe(allSearchCriteriaSets => {
        this.setSearchSets(allSearchCriteriaSets);
        if (this.isNewSearch()) {
          this.searchService.setResetInputs(true);
          this.stateInfo.currentCriteriaSet = null;
          this.isDataArrived = true;
          sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON);
          sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET);
          if (!this.currentSearchCriteriaSets || this.currentSearchCriteriaSets.length === 0) {
            this.showNoSearchSetExistsView();
          } else {
            this.showSearchSetExistsButNothingSelectedView();
          }
          return;
        }
        // Eintrittspunkt Navigation
        if (this.isNavigation()) {
          console.log('his-search-save-params.component#getSearchCriteriaSetsAndRegulateTheInitialView() #isNavigation', this.isNavigation());
          // Es gibt noch keine Suchsets
          if (allSearchCriteriaSets === null || allSearchCriteriaSets === undefined || allSearchCriteriaSets.length === 0) {
            this.showNoSearchSetExistsView();
            this.isDataArrived = true;
            return;
          }
          let standardSearchSet = this.getStandardSet();
          // Es gibt Suchsets aber keine Standard Set
          if (!standardSearchSet) {
            this.showSearchSetExistsButNothingSelectedView();
            this.isDataArrived = true;
            return;
          }
          // Es gibt ein StandardSuchset, und dieser enthält bereits die Sucheinschränkungen, z.B.
          // searchCriteria = [{ path: "[Role].id", value: "1,100054" }, { path: "EXT:[Role].id(NOT)", value: "true" }]
          // console.log( 'standardSearchSet =', standardSearchSet );
          if (standardSearchSet) {
            this.searchCriteriaSetService.loadCriteriaSet(standardSearchSet.id).subscribe(search => {
              sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON);
              this.storeSearchSetAtSessionStorage(standardSearchSet);
              sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_SEARCH_CRITERIA_SET_COMPONENT_ID, this.componentId);
              console.log('HisSearchSaveParams: load standard search set with data:', search);
              // Die Standard Sets werden nun im ngOnInit in his-search-form behandelt (validateInputs, submitSearchForm)
              // Deshalb müssen hier nur noch die richtigen Werte und Einstellungen gesetzt werden
              //  this.searchService.validateInputs(search).subscribe(resultCode => {
              //     if (resultCode === 0) {
              //         console.log(
              //             'his-search-save-params.component#getSearchCriteriaSetsAndRegulateTheInitialView()',
              //             '#resultCode', resultCode);
              // Falls im Suchet params gespeichert sind, für die kein Suchergebnis anzeigt wird.
              // XXX Das geht performanter, wenn man resultCode aus
              // this.searchFormData.submitSearch( search ) bezieht
              // 1. Wert in die Widget setzen
              let params = HisSearchParserHelper.convertHisSearchToFlatObjectFormatParams(search);
              this.searchFormData.doPresetInputFields(params);
              // 2. Suchset anzeigen
              this.selectedSearchSet = standardSearchSet;
              this.stateInfo.currentCriteriaSet = standardSearchSet;
              this.showSelectView();
              this.isShowSetStandardIcon = false;
              this.isShowResetStandardIcon = true;
              // 3. OriginalWerte setzen (nicht für Kriteriengruppen)
              this.setWidgetOriginalValueFromSearchValue();
              //                                }
              //                            });
              //                            this.searchFormData.submitSearch( search );
              return;
            });
          }
        }
        if (this.isChangeSearch()) {
          this.selectedSearchSet = this.getSearchSetFromSessionStorage();
          sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON);
          if (this.allSearchCriteriaSets.length === 0) {
            // Es ist changeSearch und es gibt noch kein Suchset
            this.showNoSearchSetExistsView();
            this.isDataArrived = true;
            return;
          }
          // Es ist changeSearch und es gibt Suchsets (dann ist das Standard Suchset egal)
          if (this.selectedSearchSet === null || this.selectedSearchSet.emptyOption) {
            // Beim Durchführen der Suche war kein Suchset ausgewählt oder der ausgewählte Suchset war die leere Option
            this.showSearchSetExistsButNothingSelectedView();
            this.isDataArrived = true;
            this.stateInfo.currentCriteriaSet = null;
            return;
          }
          // Es ist changeSearch und ein Suchset war ausgewählt
          this.showSelectView();
          this.stateInfo.currentCriteriaSet = this.selectedSearchSet;
          this.stateInfo.stateType = HisSearchCriteriaSetStateType.CHANGED_SEARCH;
          // OriginalValues für Sucheinschränkungen aus dem Suchset neu setzen
          // (alle anderen wurden manuell geändert)
          // FIXME hier fehlt noch die Behandlung der Kriteriengruppen
          this.setWidgetOriginalValueFromSearchValue();
          // Ermitteln und Nachladen der Felder aus der erweiterten Suche, Anfang
          // 1. Holen der Suchkonfiguration
          // 2. Anreichern mit Values aus dem Suchset
          // 3. Ermitten der Felder aus der erweiterten Suche
          // 4. Nachladen der ggf. dafür benötigten Options
          let originalSearchConfig = this.searchFormData.getSearchConfiguration();
          // console.log(
          // 'his-search-save-params.component#getSearchCriteriaSetsAndRegulateTheInitialView() #originalSearchConfig',
          // originalSearchConfig );
          let copyOfSearchConfig = this.getCopyOfSearchConfiguration(originalSearchConfig);
          // console.log(
          // 'his-search-save-params.component#getSearchCriteriaSetsAndRegulateTheInitialView() #copyOfSearchConfig',
          // copyOfSearchConfig );
          let search = this.stateInfo.currentCriteriaSet.search;
          console.log('his-search-save-params.component#getSearchCriteriaSetsAndRegulateTheInitialView() #search', search);
          // Die searchConfiguration braucht noch die values aus
          for (let searchGroup of this.stateInfo.currentCriteriaSet.search.groups) {
            for (let group of copyOfSearchConfig.searchCriteria.group) {
              // console.log(
              // 'his-search-save-params.component#getSearchCriteriaSetsAndRegulateTheInitialView() #searchGroup.groupLabel',
              // searchGroup.groupLabel, '#group.label', group.label );
              if (searchGroup.groupLabel === group.label) {
                for (let searchCriterion of searchGroup.criteria) {
                  for (let criteria of group.criteria) {
                    if (criteria.path === searchCriterion.field) {
                      criteria.value = searchCriterion.value;
                    }
                  }
                }
                // Kriteriengruppen? Wie ist das in JSF?
                // Es wird nichts angezeigt, nicht die Gruppe und auch nicht das gespeicherte Feld.
                // Wenn man die erweiterte Suche aufmacht, dann werdendie Werte an der Kriterienguppe angezeigt,
                // diese kommenjedoch von 'Suche ändern'
              }
            }
          }
          // ermittelt, ob es Werte in der erweiterten Suche gibt
          // Wenn ja, in searchForm component setzen, damit bei "Suche ändern" die Optionen geladen
          // XXX Wenn wir "extendedSearch" im Suchset speichern könnten, dann müssten wir
          // hier nicht einmal die Suchkonfiguration laden...
          // XXX Für die Suchsets ist es nicht ausreichend, einmal extendedSearch = true zu machen
          // 1. Es sollen nur diejenigen Gruppen angezeigt werden,
          // in denen sich Suchfelder befinden, die in einem Suchset gespeichert sind.
          // 2. Es sollen nur diejenigen Felder aus der erweiterten Suche angezeigt werden,
          // die in einem Suchset gespeichert sind.
          let isValueInNonQuicksearchGroup = this.evaluateExtendedSearch(copyOfSearchConfig, search);
          console.log('isValueInNonQuicksearchGroup', isValueInNonQuicksearchGroup);
          if (isValueInNonQuicksearchGroup) {
            // hier werden nur die Options nachgeladen, das Anzeigen der Felder wird in his-search-form.html geregelt
            this.widgetService.loadWidgetOptions(copyOfSearchConfig, true);
          }
          // Ermitteln und Nachladen der Felder aus der erweiterten Suche, Ende
          this.isShowSetStandardIcon = !this.selectedSearchSet.standard;
          this.isShowResetStandardIcon = this.selectedSearchSet.standard;
          this.isDataArrived = true;
          return;
        }
        // Tritt das überhaupt ein?
        console.warn('HisSearchSaveParamsComponent#getSearchCriteriaSetsAndRegulateTheInitialView', '- Nicht berücksichtigter Fall beim initialen Einstellen des Suchsets');
        // Vorsichtshalber nichts anzeigen
        this.showNoSearchSetExistsView();
        this.isDataArrived = true;
      });
    }
    setWidgetOriginalValueFromSearchValue() {
      // OriginalValues für Sucheinschränkungen aus dem Suchset neu setzen
      // (alle anderen wurden manuell geändert)
      for (let searchGroup of this.selectedSearchSet.search.groups) {
        let widgetGroup = HisWidgetUtils.getWidgetGroupWithLabel(searchGroup.groupLabel, this.widgetGroups);
        for (let criterion of searchGroup.criteria) {
          let widget = HisWidgetUtils.getWidgetWithIdFromGroup(criterion.field, widgetGroup);
          this.setOriginalValue(criterion.value, criterion.not, widget);
        }
      }
    }
    setOriginalValue(rawValue, not, widget) {
      if (rawValue) {
        if (widget instanceof HisWidgetBaseSelect) {
          widget.originalNot = not;
          let isLidSearch = GenericSearchUtil.isLidPath(widget.id);
          widget.getWidgetValues(rawValue, isLidSearch).subscribe(options => {
            if (options) {
              widget.originalValue = options;
            }
          });
        } else {
          widget.originalValue = rawValue;
        }
      }
    }
    addEmptyOption() {
      let emptyOptionSet = new HisSearchCriteriaSet();
      emptyOptionSet.emptyOption = true;
      this.allSearchCriteriaSets.push(emptyOptionSet);
      this.currentSearchCriteriaSets.push(emptyOptionSet);
    }
    getSearchSetFromSessionStorage() {
      return JSON.parse(sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET));
    }
    storeSearchSetAtSessionStorage(searchCriteriaSet) {
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_CRITERIA_SET, JSON.stringify(searchCriteriaSet));
    }
    showNoSearchSetExistsView() {
      this.isShowDeleteIcon = false;
      this.isShowAddIcon = false;
      this.isShowSaveIcon = false;
      this.isShowSelectField = false;
      this.isShowAddLink = false;
      this.isShowAddView = false;
      this.isShowSetStandardIcon = false;
      this.isShowResetStandardIcon = false;
    }
    /**
     * Es sind Suchsets vorhanden, jedoch ist das Auswahlfeld leer,
     * weil die letzte Aktion z. B. das Löschen eines Suchsets war
     */
    showSearchSetExistsButNothingSelectedView() {
      this.isShowDeleteIcon = false;
      this.isShowAddIcon = false;
      this.isShowSaveIcon = false;
      this.isShowSelectField = true;
      this.isShowAddLink = true;
      this.isShowAddView = false;
      this.isShowSetStandardIcon = false;
      this.isShowResetStandardIcon = false;
    }
    showSelectView() {
      this.isShowDeleteIcon = true;
      this.isShowAddIcon = true;
      this.isShowSaveIcon = true;
      this.isShowSelectField = true;
      this.isShowAddLink = false;
      this.isShowAddView = false;
    }
    resetInputs() {
      // log model (aka this.form.value) before reset
      console.log('Model before reset inputs =', this.form);
      // reset form inputs: triggers value changes that are noticed in his-search-form.component init()
      // Hier besser die parent component aufrufen
      this.form.reset();
    }
    /* Wenn der Button 'Eingaben zurücksetzen' gedrückt wird,
     * muss das Auswahlfeld für Suchsets die leere Option anzeigen*/
    initializeResetInputs() {
      this.searchService.resetInputs.subscribe(resetInputs => {
        if (resetInputs === true) {
          // Wenn ein Suchset ausgewählt ist, wird vor dem Zurücksetzen der Auswahl
          // die Ansicht zurückgesetzt
          if (this.selectedSearchSet !== null && this.selectedSearchSet !== undefined) {
            this.showSearchSetExistsButNothingSelectedView();
          }
          // Auswahlfeld
          this.selectedSearchSet = null;
          // Eingabefeld, falls ein neuese Suchset angelegt werden soll
          this.newSearchCriteriaSetName = null;
          this.stateInfo.currentCriteriaSet = null;
          this.stateInfo.stateType = null;
          // originalValues zurücksetzen
          this.setWidgetOriginalValueFromWidgetValue(true);
        }
      });
    }
    static {
      this.ɵfac = function HisSearchSaveParamsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchSaveParamsComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchSaveParamsComponent,
        selectors: [["his-search-save-params"]],
        viewQuery: function HisSearchSaveParamsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$u, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocomplete = _t.first);
          }
        },
        inputs: {
          configFile: "configFile",
          form: "form",
          widgetGroups: "widgetGroups",
          searchFormData: "searchFormData",
          searchForm: "searchForm",
          callerId: "callerId"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["content", ""], ["content", "", "autocomplete", ""], [1, "saveSearchCriteriaContainerWrap"], [1, "saveSearchCriteriaContainer"], [1, "saveSearchCriteriaColumnLeft"], [1, "iconfont-save_mono", "submit_image_text", 3, "title"], [3, "label"], ["styleClass", "verticalAlignMiddle input_standard", 3, "label"], [1, "saveSearchCriteriaColumnRight"], ["hisImage", "plus_circ", 1, "transparent"], ["hisImage", "save", 1, "icon", 3, "title"], ["hisImage", "panel_close", 1, "icon", 3, "title"], ["hisImage", "star", 1, "icon", 3, "title"], ["hisImage", "star_delete", 1, "icon", 3, "title"], ["hisImage", "delete", 1, "icon", 3, "title"], ["hisImage", "plus_circ", 1, "icon", 3, "title"], [1, "clearer"], [1, "iconfont-save_mono", "submit_image_text", 3, "click", "title"], ["required", "", 3, "ngModelChange", "keydown.enter", "ngModel"], ["field", "defaulttext", 3, "ngModelChange", "completeMethod", "onSelect", "ngModel", "suggestions", "dropdown"], ["hisImage", "plus_circ", 1, "transparent", 3, "click"], ["hisImage", "save", 1, "icon", 3, "click", "title"], ["hisImage", "panel_close", 1, "icon", 3, "click", "title"], ["hisImage", "star", 1, "icon", 3, "click", "title"], ["hisImage", "star_delete", 1, "icon", 3, "click", "title"], ["hisImage", "delete", 1, "icon", 3, "click", "title"], ["hisImage", "plus_circ", 1, "icon", 3, "click", "title"]],
        template: function HisSearchSaveParamsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSearchSaveParamsComponent_Conditional_0_Template, 16, 10, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isDataArrived ? 0 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.NgModel, i2$1.AutoComplete, HisConfirmDialogComponent, HisPlamComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisDeleteActionDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchSaveParamsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisHelptextComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.linkTitle);
  }
}
function HisHelptextComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h2");
    i0.ɵɵelement(2, "img", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 4, "cs.sys.fieldset.help"), " '", ctx_r0.subtitle, "' ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.helptext);
  }
}
let HisHelptextComponent = /*#__PURE__*/(() => {
  class HisHelptextComponent {
    constructor() {
      this.hisUiService = inject(HisUiService);
      this.showHelptext = false;
    }
    ngOnInit() {
      this.title = _.isNil(this.title) ? this.hisUiService.translate('common.help') : this.title;
      this.linkTitle = _.isNil(this.linkTitle) ? this.hisUiService.translate('common.help') : this.linkTitle;
    }
    toggleShowHelptext() {
      this.showHelptext = !this.showHelptext;
    }
    static {
      this.ɵfac = function HisHelptextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisHelptextComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisHelptextComponent,
        selectors: [["his-helptext"]],
        inputs: {
          title: "title",
          linkTitle: "linkTitle",
          subtitle: "subtitle",
          helptext: "helptext"
        },
        standalone: false,
        decls: 3,
        vars: 3,
        consts: [["hisImage", "information", "type", "button", 1, "icon", 3, "click", "title"], [1, "fieldsetLevel2", "showHelp", "overlayHelp"], ["hisImage", "information", 1, "inlineicon", 3, "title"]],
        template: function HisHelptextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function HisHelptextComponent_Template_button_click_0_listener() {
              return ctx.toggleShowHelptext();
            });
            i0.ɵɵtemplate(1, HisHelptextComponent_Conditional_1_Template, 2, 1, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, HisHelptextComponent_Conditional_2_Template, 7, 6, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.linkTitle ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showHelptext ? 2 : -1);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisHelptextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisConversionUtils {
  /**
   * Konvertiert die Nummernrepräsentation (Millisekunden) eines Datums in ein Date-Objekt
   * Benötigt z.B. im Rahmen von REST-Ergebnissen
   */
  static millisToDate(obj) {
    if (obj && !(obj instanceof Date)) {
      return new Date(Number.parseInt(obj.toString(), 10));
    }
    return obj;
  }
}
let HisJobService = /*#__PURE__*/(() => {
  class HisJobService {
    constructor() {
      this.hisBackendService = inject(HisBackendService);
    }
    getAvailableJobs(key) {
      console.log('HisJobService.getAvailableJobs(): key =', key);
      return this.hisBackendService.getData('api/v1/cs/sys/jobConfig/optionsForStarter/' + key);
    }
    startJob(jobRequest) {
      console.log('HisJobService.startJob(): request =', jobRequest);
      return this.hisBackendService.postData('api/v1/cs/sys/jobExecution', jobRequest);
    }
    getJobStatus(jobHandle) {
      console.log('HisJobService.getJobStatus(): handle =', jobHandle);
      return this.hisBackendService.getData('api/v1/cs/sys/jobExecution/' + jobHandle.executionId).pipe(map(status => {
        status.startedAt = HisConversionUtils.millisToDate(status.startedAt);
        status.finishedAt = HisConversionUtils.millisToDate(status.finishedAt);
        return status;
      }));
    }
    getJobProtocol(jobHandle, startPos, maxLines) {
      console.log('HisJobService.getJobProtocol(): handle =', jobHandle);
      let requestUrl = 'api/v1/cs/sys/jobExecution/' + jobHandle.executionId + '/log';
      requestUrl += '?startPos=' + (startPos ? startPos : 0);
      if (maxLines && maxLines > 0) {
        requestUrl += '&maxLines=' + maxLines;
      }
      return this.hisBackendService.getData(requestUrl);
    }
    static {
      this.ɵfac = function HisJobService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisJobService,
        factory: HisJobService.ɵfac
      });
    }
  }
  return HisJobService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisJobRequest {
  constructor(jobMetadata) {
    this.jobConfiguration = jobMetadata.jobConfiguration;
    this.jobKey = jobMetadata.key;
    this.executionType = 'JobManagement'; // use standard JobManagement
  }
}
const _c0$t = () => ({
  height: "33vh"
});
function HisJobSettingComponent_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-job-setting", 2);
  }
  if (rf & 2) {
    const childSetting_r1 = ctx.$implicit;
    i0.ɵɵproperty("setting", childSetting_r1);
  }
}
function HisJobSettingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-panel", 1);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵrepeaterCreate(2, HisJobSettingComponent_Conditional_0_For_3_Template, 1, 1, "his-job-setting", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(1, 1, ctx_r1.setting.label));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.setting.settings);
  }
}
function HisJobSettingComponent_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 3);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "input", 5, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisJobSettingComponent_Conditional_1_Conditional_0_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.setting.value, $event) || (ctx_r1.setting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, ctx_r1.setting.label))("helptext", i0.ɵɵpipeBind1(2, 6, ctx_r1.setting.helptext))("required", ctx_r1.setting.required);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.setting.value);
  }
}
function HisJobSettingComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 3);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "p-editor", 6, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisJobSettingComponent_Conditional_1_Conditional_1_Template_p_editor_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.setting.value, $event) || (ctx_r1.setting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(10, _c0$t));
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 6, ctx_r1.setting.label))("helptext", i0.ɵɵpipeBind1(2, 8, ctx_r1.setting.helptext))("required", ctx_r1.setting.required);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.setting.value);
  }
}
function HisJobSettingComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 3);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "p-autoComplete", 7, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisJobSettingComponent_Conditional_1_Conditional_2_Template_p_autoComplete_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedItem, $event) || (ctx_r1.selectedItem = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("completeMethod", function HisJobSettingComponent_Conditional_1_Conditional_2_Template_p_autoComplete_completeMethod_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.filterItems($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 6, ctx_r1.setting.label))("helptext", i0.ɵɵpipeBind1(2, 8, ctx_r1.setting.helptext))("required", ctx_r1.setting.required);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedItem);
    i0.ɵɵproperty("suggestions", ctx_r1.filteredItems)("dropdown", true);
  }
}
function HisJobSettingComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 3);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "input", 8, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisJobSettingComponent_Conditional_1_Conditional_3_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.setting.value, $event) || (ctx_r1.setting.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, ctx_r1.setting.label))("helptext", i0.ɵɵpipeBind1(2, 6, ctx_r1.setting.helptext))("required", ctx_r1.setting.required);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.setting.value);
  }
}
function HisJobSettingComponent_Conditional_1_Conditional_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-job-setting", 2);
  }
  if (rf & 2) {
    const childSetting_r7 = ctx.$implicit;
    i0.ɵɵproperty("setting", childSetting_r7);
  }
}
function HisJobSettingComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, HisJobSettingComponent_Conditional_1_Conditional_4_For_1_Template, 1, 1, "his-job-setting", 2, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.setting.childSettings);
  }
}
function HisJobSettingComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisJobSettingComponent_Conditional_1_Conditional_0_Template, 5, 8, "his-plam", 3)(1, HisJobSettingComponent_Conditional_1_Conditional_1_Template, 5, 11, "his-plam", 4)(2, HisJobSettingComponent_Conditional_1_Conditional_2_Template, 5, 10, "his-plam", 3)(3, HisJobSettingComponent_Conditional_1_Conditional_3_Template, 5, 8, "his-plam", 3)(4, HisJobSettingComponent_Conditional_1_Conditional_4_Template, 2, 0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.setting.type === "SHORT_TEXT" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setting.type === "HTML_TEXT" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setting.type === "SELECT_ONE" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setting.type === "BOOLEAN" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setting.type === "SETTING_GROUP" ? 4 : -1);
  }
}
let HisJobSettingComponent = /*#__PURE__*/(() => {
  class HisJobSettingComponent {
    constructor() {
      this.uiTextService = inject(HisUiService);
      this.filteredItems = [];
    }
    get setting() {
      return this.settingValue;
    }
    set setting(value) {
      this.settingValue = value;
      this.copySettingToSelection();
    }
    get selectedItem() {
      return this.selectedItemValue;
    }
    set selectedItem(value) {
      this.selectedItemValue = value;
      this.copySelectionToSetting();
    }
    copySelectionToSetting() {
      if (this.selectedItem) {
        this.setting.value = this.selectedItem.key;
        this.setting.selectedValue = this.selectedItem.value;
      }
    }
    copySettingToSelection() {
      if (this.setting && this.setting.options) {
        this.assureItemsAreAssembled();
        let foundItem = null;
        for (let item of this.allItems) {
          // setting.value bezieht sich auf den key in den options - das ist etwas schräg.
          if (item.key === this.setting.value) {
            foundItem = item;
            break;
          }
        }
        this.selectedItem = foundItem;
        if (foundItem) {
          // da setting.value dem key der option entspricht, brauchen wir für den option.value ein neues Feld
          this.setting.selectedValue = foundItem.value;
        }
      }
    }
    assureItemsAreAssembled() {
      if (!this.allItems) {
        this.allItems = [];
        for (let option of this.setting.options) {
          let theLabel = this.uiTextService.translate(option.label);
          if (theLabel.startsWith('???')) {
            theLabel = option.label;
          }
          let item = {
            key: option.key,
            value: option.value,
            label: theLabel
          };
          this.allItems.push(item);
        }
      }
    }
    filterItems(event) {
      this.assureItemsAreAssembled();
      this.filteredItems = [];
      for (let item of this.allItems) {
        if (item.label.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
          this.filteredItems.push(item);
        }
      }
    }
    static {
      this.ɵfac = function HisJobSettingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobSettingComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisJobSettingComponent,
        selectors: [["his-job-setting"]],
        inputs: {
          setting: "setting",
          selectedItem: "selectedItem"
        },
        standalone: false,
        decls: 2,
        vars: 2,
        consts: [["content", ""], [3, "header"], [3, "setting"], [3, "label", "helptext", "required"], [3, "label", "helptext", "style", "required"], [1, "inputWidth100", 3, "ngModelChange", "ngModel"], [3, "ngModelChange", "ngModel"], ["field", "label", 3, "ngModelChange", "completeMethod", "ngModel", "suggestions", "dropdown"], ["type", "checkbox", "binary", "true", 1, "inputWidth100", 3, "ngModelChange", "ngModel"]],
        template: function HisJobSettingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisJobSettingComponent_Conditional_0_Template, 4, 3, "p-panel", 1)(1, HisJobSettingComponent_Conditional_1_Template, 5, 5);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.setting.settings ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.setting.settings && ctx.setting.active ? 1 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, HisPlamComponent, HisModificationDetectionDirective, HisButtonTitleDirective, HisPanelDirective, i4$1.Panel, i2$1.AutoComplete, i4.Editor, HisJobSettingComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisJobSettingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisJobConfigurationComponent_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-job-setting", 2);
  }
  if (rf & 2) {
    const setting_r1 = ctx.$implicit;
    i0.ɵɵproperty("setting", setting_r1);
  }
}
let HisJobConfigurationComponent = /*#__PURE__*/(() => {
  class HisJobConfigurationComponent {
    constructor() {
      this.startJobClicked = new EventEmitter();
      this.jobConfigurationVisible = false;
    }
    showJobConfiguration() {
      this.jobConfigurationVisible = true;
    }
    hideJobConfiguration() {
      this.jobConfigurationVisible = false;
    }
    areSettingsValid(settings) {
      let result = true;
      for (const setting of settings) {
        if (setting.settings) {
          result = result && this.areSettingsValid(setting.settings);
        } else if (setting.childSettings) {
          result = result && this.areSettingsValid(setting.childSettings);
        } else {
          if (setting.required) {
            if (!setting.selectedValue && !setting.value) {
              result = false;
            }
          }
        }
      }
      return result;
    }
    static {
      this.ɵfac = function HisJobConfigurationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobConfigurationComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisJobConfigurationComponent,
        selectors: [["his-job-configuration"]],
        inputs: {
          settings: "settings"
        },
        outputs: {
          startJobClicked: "startJobClicked"
        },
        standalone: false,
        decls: 16,
        vars: 16,
        consts: [["hisImage", "PENCIL", 1, "plamButton", "icon", 3, "click", "title"], ["appendTo", "body", "styleClass", "jobConfigurationOverlay", 3, "visibleChange", "onHide", "visible", "modal", "blockScroll"], [3, "setting"], ["type", "button", 3, "click", "disabled"], ["type", "button", 3, "click"]],
        template: function HisJobConfigurationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵlistener("click", function HisJobConfigurationComponent_Template_button_click_0_listener() {
              return ctx.showJobConfiguration();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "p-dialog", 1);
            i0.ɵɵtwoWayListener("visibleChange", function HisJobConfigurationComponent_Template_p_dialog_visibleChange_2_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.jobConfigurationVisible, $event) || (ctx.jobConfigurationVisible = $event);
              return $event;
            });
            i0.ɵɵlistener("onHide", function HisJobConfigurationComponent_Template_p_dialog_onHide_2_listener() {
              return ctx.hideJobConfiguration();
            });
            i0.ɵɵelementStart(3, "p-header")(4, "h2");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵrepeaterCreate(7, HisJobConfigurationComponent_For_8_Template, 1, 1, "his-job-setting", 2, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementStart(9, "p-footer")(10, "button", 3);
            i0.ɵɵlistener("click", function HisJobConfigurationComponent_Template_button_click_10_listener() {
              ctx.startJobClicked.emit();
              return ctx.hideJobConfiguration();
            });
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "button", 4);
            i0.ɵɵlistener("click", function HisJobConfigurationComponent_Template_button_click_13_listener() {
              return ctx.hideJobConfiguration();
            });
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "hisUi");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 8, "cs.sys.reporting.job.showJobConfiguration"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("visible", ctx.jobConfigurationVisible);
            i0.ɵɵproperty("modal", true)("blockScroll", true);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 10, "cs.sys.reporting.contextJobConfigurationName"));
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.settings);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.areSettingsValid(ctx.settings));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 12, "de.his.javang.submit"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 14, "common.cancel"));
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, i2.Header, i2.Footer, i3.Dialog, HisJobSettingComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisJobConfigurationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * HIS DatePipe
 * Dient vor allem dazu, dass eingestellte Anwendungslocale automatisch zu verwenden.
 * Mit diesem Locale wird dann an die Angular DatePipe delegiert.
 * Da Angular neben 'en-US' nur die in der 'his-core-module.ts' explizit importierten Locales unterstützt,
 * muss ein Mapping der HISinOne-Locales auf diese Locales passieren - das passiert in
 *  hisBaseGlobalsService.getNearestLocaleSupportedByClient().
 *
 * Wenn noch weitere, HIS-spezifische, Namen für Datumsformate erfunden werden sollen, können diese hier
 *  umgesetzt werden.
 */
let HisDatePipe = /*#__PURE__*/(() => {
  class HisDatePipe {
    constructor(hisBaseGlobalsService) {
      this.hisBaseGlobalsService = hisBaseGlobalsService || inject(HisBaseGlobalsService);
      let nearestSupportedLocale = this.hisBaseGlobalsService.getNearestLocaleSupportedByClient();
      this.delegate = new DatePipe(nearestSupportedLocale);
    }
    transform(value, format, timezone, locale) {
      return this.delegate.transform(value, format, timezone, locale);
    }
    static {
      this.ɵfac = function HisDatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDatePipe)(i0.ɵɵdirectiveInject(HisBaseGlobalsService, 16));
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisDate",
        type: HisDatePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisJobDetailsComponent_Conditional_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "cs.sys.notification.noNotification"), " ");
  }
}
function HisJobDetailsComponent_Conditional_45_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "cs.sys.notification.Notification.type"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "cs.sys.notification.Notification"));
  }
}
function HisJobDetailsComponent_Conditional_45_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const line_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(line_r1.type);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(line_r1.message);
  }
}
function HisJobDetailsComponent_Conditional_45_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 8);
    i0.ɵɵtemplate(1, HisJobDetailsComponent_Conditional_45_ng_template_1_Template, 7, 6, "ng-template", 10)(2, HisJobDetailsComponent_Conditional_45_ng_template_2_Template, 5, 2, "ng-template", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.loggingLines)("paginator", true)("rows", 5)("responsive", true);
  }
}
function HisJobDetailsComponent_Conditional_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelement(3, "a", 12);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "common.download.file") + ":", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.jobStatus.resultDocumentUrl, i0.ɵɵsanitizeUrl)("title", i0.ɵɵpipeBind1(4, 5, "common.download.file"));
  }
}
let HisJobDetailsComponent = /*#__PURE__*/(() => {
  class HisJobDetailsComponent {
    constructor() {
      this.jobService = inject(HisJobService);
      this.jobDetailsVisible = false;
      this.loggingLines = [];
    }
    set jobStatus(value) {
      this.internalJobStatus = value;
      this.refreshJobProtocol();
    }
    get jobStatus() {
      return this.internalJobStatus;
    }
    refreshJobProtocol() {
      if (!this.jobStatus || !this.jobDetailsVisible) {
        return;
      }
      let startPos = 0;
      let maxLines = 100;
      if (this.chunkFitsStatus(this.lastProtocolChunk)) {
        startPos = this.lastProtocolChunk.endPos;
      }
      this.jobService.getJobProtocol(this.jobStatus.handle, startPos, maxLines).subscribe(chunk => {
        if (!this.chunkFitsStatus(chunk)) {
          this.loggingLines = [];
          return; // Mittlerweile wird ein neuer Job angezeigt
        }
        if (chunk.startPos === 0 || !this.chunkFitsStatus(this.lastProtocolChunk)) {
          this.loggingLines = [];
        }
        if (chunk.lines) {
          this.loggingLines = [...this.loggingLines, ...chunk.lines];
        }
        this.lastProtocolChunk = chunk;
      });
    }
    chunkFitsStatus(chunk) {
      return chunk && chunk.handle.executionId === this.jobStatus.handle.executionId;
    }
    showJobDetails() {
      this.jobDetailsVisible = true;
      this.refreshJobProtocol();
    }
    hideJobDetails() {
      this.jobDetailsVisible = false;
    }
    static {
      this.ɵfac = function HisJobDetailsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobDetailsComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisJobDetailsComponent,
        selectors: [["his-job-details"]],
        inputs: {
          jobDetailsVisible: "jobDetailsVisible",
          jobStatus: "jobStatus"
        },
        standalone: false,
        decls: 51,
        vars: 42,
        consts: [["hisImage", "PROJECT", 1, "plamButton", "icon", 3, "click", "title"], ["appendTo", "body", 3, "visibleChange", "onHide", "visible", "modal", "blockScroll", "header"], [1, "details"], [1, "detailPresentationList"], [1, "layoutBlock", "detailPresentationListItem"], [1, "columnDetailLabel", "detailPresentationListLabel"], [1, "columnDetailContent", "detailPresentationListContent"], [3, "header"], [3, "value", "paginator", "rows", "responsive"], ["type", "button", 3, "click"], ["pTemplate", "header"], ["pTemplate", "body"], ["hisImage", "DOWNLOAD", 1, "icon", 3, "href", "title"]],
        template: function HisJobDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵlistener("click", function HisJobDetailsComponent_Template_button_click_0_listener() {
              return ctx.showJobDetails();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "p-dialog", 1);
            i0.ɵɵpipe(3, "hisUi");
            i0.ɵɵtwoWayListener("visibleChange", function HisJobDetailsComponent_Template_p_dialog_visibleChange_2_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.jobDetailsVisible, $event) || (ctx.jobDetailsVisible = $event);
              return $event;
            });
            i0.ɵɵlistener("onHide", function HisJobDetailsComponent_Template_p_dialog_onHide_2_listener() {
              return ctx.hideJobDetails();
            });
            i0.ɵɵelementStart(4, "div")(5, "div", 2)(6, "div", 3)(7, "div", 4)(8, "div", 5)(9, "span");
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 6)(13, "span");
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 4)(16, "div", 5)(17, "span");
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 6)(21, "span");
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "hisUi");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(24, "div", 4)(25, "div", 5)(26, "span");
            i0.ɵɵtext(27);
            i0.ɵɵpipe(28, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(29, "div", 6)(30, "span");
            i0.ɵɵtext(31);
            i0.ɵɵpipe(32, "hisDate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(33, "div", 4)(34, "div", 5)(35, "span");
            i0.ɵɵtext(36);
            i0.ɵɵpipe(37, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(38, "div", 6)(39, "span");
            i0.ɵɵtext(40);
            i0.ɵɵpipe(41, "hisDate");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(42, "p-panel", 7);
            i0.ɵɵpipe(43, "hisUi");
            i0.ɵɵtemplate(44, HisJobDetailsComponent_Conditional_44_Template, 3, 3, "p")(45, HisJobDetailsComponent_Conditional_45_Template, 3, 4, "p-table", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(46, HisJobDetailsComponent_Conditional_46_Template, 5, 7, "div");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(47, "p-footer")(48, "button", 9);
            i0.ɵɵlistener("click", function HisJobDetailsComponent_Template_button_click_48_listener() {
              return ctx.hideJobDetails();
            });
            i0.ɵɵtext(49);
            i0.ɵɵpipe(50, "hisUi");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 18, "common.components.jobConfigurationPanel.actions.showLastExecutionProtocol"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("visible", ctx.jobDetailsVisible);
            i0.ɵɵproperty("modal", true)("blockScroll", true)("header", i0.ɵɵpipeBind1(3, 20, "common.components.jobConfigurationPanel.lastExecutionProtocol.title"));
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(11, 22, "cs.sys.reporting.jobexecutioncontext.report_name"), ":");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.jobStatus.jobName);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(19, 24, "cs.sys.reporting.jobexecutioncontext.status"), ":");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 26, ctx.jobStatus.statusMsgKey));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(28, 28, "cs.sys.reporting.jobexecutioncontext.startdate"), ":");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(32, 30, ctx.jobStatus.startedAt, "medium"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(37, 33, "cs.sys.reporting.jobexecutioncontext.enddate"), ":");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(41, 35, ctx.jobStatus.finishedAt, "medium"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(43, 38, "cs.sys.reporting.jobexecutioncontext.protocol.title"));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.loggingLines || ctx.loggingLines.length === 0 ? 44 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loggingLines && ctx.loggingLines.length > 0 ? 45 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.jobStatus && ctx.jobStatus.resultDocumentUrl ? 46 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(50, 40, "image.alt.minus_circ"));
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisPanelDirective, i4$1.Panel, i2.Footer, i2.PrimeTemplate, i3.Dialog, i3$1.Table, HisUiPipe, HisDatePipe],
        encapsulation: 2
      });
    }
  }
  return HisJobDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisJobStarterComponent_Conditional_0_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function HisJobStarterComponent_Conditional_0_For_2_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const job_r3 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.startJob(job_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const job_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("hisImage", job_r3.quickstarterIcon)("title", job_r3.name);
  }
}
function HisJobStarterComponent_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisJobStarterComponent_Conditional_0_For_2_Conditional_0_Template, 1, 2, "button", 10);
  }
  if (rf & 2) {
    const job_r3 = ctx.$implicit;
    i0.ɵɵconditional(job_r3.quickstarterIcon ? 0 : -1);
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-job-configuration", 12);
    i0.ɵɵlistener("startJobClicked", function HisJobStarterComponent_Conditional_0_Conditional_12_Template_his_job_configuration_startJobClicked_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.startJob());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("settings", ctx_r3.selectedJob.defaultJobSettings);
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_13_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-progressSpinner", 13);
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, HisJobStarterComponent_Conditional_0_Conditional_13_Conditional_1_Template, 1, 0, "p-progressSpinner", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.lastStartedJob && !ctx_r3.lastStartedJob.finishedAt ? 1 : -1);
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-job-details", 6);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("jobStatus", ctx_r3.lastStartedJob);
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function HisJobStarterComponent_Conditional_0_Conditional_15_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.toggleShowDebug());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", "Debuginfos");
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1, "selectedJob: none");
    i0.ɵɵelementEnd();
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("selectedJob: ", i0.ɵɵpipeBind1(2, 1, ctx_r3.selectedJob), "");
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1, "lastStartedJob: none");
    i0.ɵɵelementEnd();
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("lastStartedJob: ", i0.ɵɵpipeBind1(2, 1, ctx_r3.lastStartedJob), "");
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1, "lastError: none");
    i0.ɵɵelementEnd();
  }
}
function HisJobStarterComponent_Conditional_0_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("lastError: ", i0.ɵɵpipeBind1(2, 1, ctx_r3.lastError), "");
  }
}
function HisJobStarterComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵrepeaterCreate(1, HisJobStarterComponent_Conditional_0_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(3, "label", 1);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementStart(6, "p-autoComplete", 2);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisJobStarterComponent_Conditional_0_Template_p_autoComplete_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r3.selectedJob, $event) || (ctx_r3.selectedJob = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("completeMethod", function HisJobStarterComponent_Conditional_0_Template_p_autoComplete_completeMethod_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.filterJobs($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "button", 3);
    i0.ɵɵpipe(9, "hisUi");
    i0.ɵɵlistener("click", function HisJobStarterComponent_Conditional_0_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.startJob());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, HisJobStarterComponent_Conditional_0_Conditional_12_Template, 1, 1, "his-job-configuration", 4)(13, HisJobStarterComponent_Conditional_0_Conditional_13_Template, 2, 1, "span", 5)(14, HisJobStarterComponent_Conditional_0_Conditional_14_Template, 1, 1, "his-job-details", 6)(15, HisJobStarterComponent_Conditional_0_Conditional_15_Template, 1, 1, "button", 7);
    i0.ɵɵelementStart(16, "p-dialog", 8);
    i0.ɵɵpipe(17, "hisUi");
    i0.ɵɵtwoWayListener("visibleChange", function HisJobStarterComponent_Conditional_0_Template_p_dialog_visibleChange_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r3.showDebug, $event) || (ctx_r3.showDebug = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(18, "div", 9)(19, "pre");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, HisJobStarterComponent_Conditional_0_Conditional_21_Template, 2, 0, "pre")(22, HisJobStarterComponent_Conditional_0_Conditional_22_Template, 3, 3, "pre")(23, HisJobStarterComponent_Conditional_0_Conditional_23_Template, 2, 0, "pre")(24, HisJobStarterComponent_Conditional_0_Conditional_24_Template, 3, 3, "pre")(25, HisJobStarterComponent_Conditional_0_Conditional_25_Template, 2, 0, "pre")(26, HisJobStarterComponent_Conditional_0_Conditional_26_Template, 3, 3, "pre");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.availableJobs);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectJobLabel ? ctx_r3.selectJobLabel : i0.ɵɵpipeBind1(5, 25, "cs.sys.reporting.center.JobReportingCenterElement"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.selectedJob);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(7, 27, "cs.sys.reporting.oo.reportNameList"))("dropdown", true)("forceSelection", true)("suggestions", ctx_r3.filteredJobs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r3.selectedJob)("title", i0.ɵɵpipeBind1(9, 29, "cs.sys.reporting.oo.reportNameList"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(11, 31, "common.components.jobConfigurationPanel.quickStartJob"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r3.selectedJob ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.lastStartedJob && !ctx_r3.lastStartedJob.finishedAt ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.lastStartedJob ? 14 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.debugAvailable ? 15 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("visible", ctx_r3.showDebug);
    i0.ɵɵproperty("modal", true)("dismissableMask", true)("blockScroll", true)("header", i0.ɵɵpipeBind1(17, 33, "common.components.jobConfigurationPanel.lastExecutionProtocol.title"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Job-Starter: '", ctx_r3.key, "'");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.selectedJob ? 21 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.selectedJob ? 22 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.lastStartedJob ? 23 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.lastStartedJob ? 24 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r3.lastError ? 25 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r3.lastError ? 26 : -1);
  }
}
let HisJobStarterComponent = /*#__PURE__*/(() => {
  class HisJobStarterComponent {
    static {
      this.jobRight = 'RIGHT_CS_SYS_JOBS_RIGHT_EXECUTE_JOB';
    }
    constructor() {
      this.jobService = inject(HisJobService);
      this.notificationService = inject(HisNotificationService);
      this.uiTextService = inject(HisUiService);
      this.showDebug = false;
      this.debugAvailable = false;
      this.selectJobLabel = '';
      this.availableJobs = [];
      this.isAuthorized = false;
      const authService = inject(HisAuthService);
      this.isAuthorized = authService.hasAll(HisJobStarterComponent.jobRight);
    }
    ngOnInit() {
      if (this.isAuthorized) {
        this.loadJobOptions();
      }
    }
    ngOnDestroy() {
      this.lastStartedJob = null;
    }
    loadJobOptions() {
      this.jobService.getAvailableJobs(this.key).subscribe(options => {
        this.availableJobs = options;
      }, error => {
        console.log(error);
        this.lastError = error;
      });
    }
    filterJobs(event) {
      this.filteredJobs = [];
      for (let jobMeta of this.availableJobs) {
        if (jobMeta.name.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
          this.filteredJobs.push(jobMeta);
        }
      }
    }
    startJob(job) {
      if (job) {
        this.selectedJob = job;
      }
      if (this.jobConfiguration) {
        if (!this.jobConfiguration.areSettingsValid(this.selectedJob.defaultJobSettings)) {
          this.jobConfiguration.showJobConfiguration();
          return;
        }
      }
      let jobRequest = new HisJobRequest(this.selectedJob);
      jobRequest.jobStarterKey = this.key;
      // Suchdaten mit übertragen, falls vorhanden
      if (this.searchConfigFile) {
        jobRequest.searchRequest = new HisSearchRequest(this.search);
      }
      // Manuelle Suchselektion mit übertragen, falls vorhanden
      if (this.selectedOptions && this.selectedOptions.length > 0) {
        jobRequest.selectedRowData = this.selectedOptions;
      }
      // Parameter aus JobSettings sammeln und mit übertragen
      let jobParams = {};
      this.collectJobParamsFromSetting(this.selectedJob.defaultJobSettings, jobParams, '');
      jobRequest.jobParams = jobParams;
      this.jobService.startJob(jobRequest).subscribe(status => {
        this.lastStartedJob = status;
        let successMsg = this.uiTextService.translate('cs.sys.jobs.successfully_started', status.jobName);
        let category = this.uiTextService.translate('messagebox.singleSuccessTitle');
        this.notificationService.info(successMsg, category);
        this.monitorStatus(status.handle, 1);
      }, error => {
        console.log(error);
        this.lastError = error;
      });
    }
    collectJobParamsFromSetting(settings, jobParams, prefix) {
      for (const setting of settings) {
        if (setting.settings) {
          this.collectJobParamsFromSetting(setting.settings, jobParams, prefix);
        } else if (setting.childSettings) {
          this.collectJobParamsFromSetting(setting.childSettings, jobParams, prefix + '.' + setting.name);
        } else {
          let settingName = prefix + '.' + setting.name;
          if (settingName.startsWith('.')) {
            settingName = settingName.substring(1);
          }
          // #310483 beim ersten Klick auf eines der Schnellstart-Items "Publikationsliste (ODT)" oder "Publikationsliste (PDF)" haben
          // wir hier für das Setting mit name="citationStyle" hier noch keinen selectedValue und value="item-1".
          // In dem Fall müssen wir anscheinend also den defaultValue nehmen.
          if (!(setting.selectedValue == null)) {
            jobParams[settingName] = setting.selectedValue;
          } else if (!(setting.defaultValue == null)) {
            jobParams[settingName] = setting.defaultValue;
          } else if (setting.value !== null || setting.options) {
            const settingOptionValue = setting?.options?.find(options => options.key === setting.value).value;
            if (settingOptionValue !== null && setting.options) {
              jobParams[settingName] = settingOptionValue;
            } else {
              jobParams[settingName] = setting.value;
            }
          }
        }
      }
    }
    monitorStatus(handle, iterationCount) {
      if (this.lastStartedJob && this.lastStartedJob.handle.executionId === handle.executionId && !this.lastStartedJob.finishedAt) {
        setTimeout(() => {
          this.jobService.getJobStatus(handle).subscribe(status => {
            if (this.lastStartedJob && this.lastStartedJob.handle.executionId === handle.executionId) {
              this.lastStartedJob = status;
              this.downloadResultIfPresent();
              this.monitorStatus(handle, iterationCount + 1);
            }
          }, error => {
            console.log(error);
            this.lastError = error;
          });
        }, this.getDelayForIteration(iterationCount));
      }
    }
    /*
     * Am Anfang häufiger auf den Status zugreifen, damit Ergebnisse schneller Jobs zeitnah angeboten werden.
     * Bei lange dauernden Jobs kommt es nicht mehr so drauf an - dann länger warten um den Server zu schonen.
     */
    getDelayForIteration(iterationCount) {
      if (iterationCount < 5) {
        return iterationCount * 200;
      } else if (iterationCount < 10) {
        return iterationCount * 400;
      }
      return 5000;
    }
    downloadResultIfPresent() {
      if (this.lastStartedJob.resultDocumentUrl && !(this.lastStartedJob.resultDocumentUrl === this.lastAutoDownloadedURL)) {
        this.lastAutoDownloadedURL = this.lastStartedJob.resultDocumentUrl;
        window.location.href = this.lastStartedJob.resultDocumentUrl;
      }
    }
    toggleShowDebug() {
      this.showDebug = !this.showDebug;
    }
    static {
      this.ɵfac = function HisJobStarterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobStarterComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisJobStarterComponent,
        selectors: [["his-job-starter"]],
        viewQuery: function HisJobStarterComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(HisJobConfigurationComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.jobConfiguration = _t.first);
          }
        },
        inputs: {
          key: "key",
          search: "search",
          searchConfigFile: "searchConfigFile",
          selectedOptions: "selectedOptions",
          showDebug: "showDebug",
          debugAvailable: "debugAvailable",
          selectJobLabel: "selectJobLabel"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "jobStarterContainer"], ["for", "selectJob"], ["id", "selectJob", "field", "name", 1, "autocompleteWidth60", 3, "ngModelChange", "completeMethod", "ngModel", "placeholder", "dropdown", "forceSelection", "suggestions"], ["hisImage", "resultset_next", 1, "transparent", "jobstartBadge", 3, "click", "disabled", "title"], [3, "settings"], [1, "jobStarterSpinner", "progressSpinnerContainer"], [3, "jobStatus"], ["hisImage", "debug", 1, "plamButton", "icon", 3, "title"], ["appendTo", "body", 3, "visibleChange", "visible", "modal", "dismissableMask", "blockScroll", "header"], [1, "plamRow"], [1, "plamButton", "icon", 3, "hisImage", "title"], [1, "plamButton", "icon", 3, "click", "hisImage", "title"], [3, "startJobClicked", "settings"], ["strokeWidth", "8", "fill", "#EEEEEE", "animationDuration", "5s"], ["hisImage", "debug", 1, "plamButton", "icon", 3, "click", "title"]],
        template: function HisJobStarterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisJobStarterComponent_Conditional_0_Template, 27, 35, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isAuthorized ? 0 : -1);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, i2$1.AutoComplete, i7.ProgressSpinner, i3.Dialog, HisJobDetailsComponent, HisJobConfigurationComponent, i1$2.JsonPipe, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisJobStarterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisSearchPrintviewData {}
class HisSearchResultConfigColumn {
  constructor(id, label) {
    this.checked = true;
    this.id = id;
    this.label = label;
  }
}
let HisSearchResultConfigConstants = /*#__PURE__*/(() => {
  class HisSearchResultConfigConstants {
    static {
      this.DEFAUT_TABLE_PAGE_SIZE = 'DefaultTablePageSize';
    }
    /**
     * Constant for an user profile key:
     * <ul>
     * <li>tableId = HisStringUtils.getHashCode(this.pathname + this.searchConfigFile);
     * <li>user profile key = tableId + HIDDEN_COLS;
     * <ul/>
     */
    static {
      this.HIDDEN_COLS = '.hiddenCols';
    }
    /**
     * Constant for an user profile key:
     * <ul>
     * <li>tableId = HisStringUtils.getHashCode(this.pathname + this.searchConfigFile);
     * <li>user profile key = tableId + PAGINATOR_POSITION;
     * <ul/>
     */
    static {
      this.PAGINATOR_POSITION = '.paginatorPosition';
    }
  }
  return HisSearchResultConfigConstants;
})();
let HisUserProfileConstants = /*#__PURE__*/(() => {
  class HisUserProfileConstants {
    static {
      this.PAGE_SIZE = '.pageSize';
    }
    static {
      this.SHOW_TABLE_FILTER = '.showTableFilter';
    }
  }
  return HisUserProfileConstants;
})();
let HisSearchRowsPerPageService = /*#__PURE__*/(() => {
  class HisSearchRowsPerPageService {
    constructor() {
      this.userProfileService = inject(HisUserProfileService);
    }
    // eine Methode, die im userProfile schaut ob etwas im UserProfile für
    // Tabelle anpassen
    // die aktuell angezeigte Seite
    // gespeichert ist
    getPageSizeFromUserProfile(key, defaultValue) {
      let obs = new BehaviorSubject(null);
      const defaultTablePageSize = this.getDeaultTablePageSize();
      const tablePageSize = this.getTablePageSize(key);
      forkJoin([tablePageSize, defaultTablePageSize]).subscribe(result => {
        if (result) {
          let pageSize = result[0];
          let defaultSize = result[1];
          console.log('getPageSizeFromUserProfile() #key', key);
          console.log('getPageSizeFromUserProfile() #pageSize', pageSize);
          console.log('getPageSizeFromUserProfile() #defaultSize', defaultSize);
          console.log('getPageSizeFromUserProfile() #defaultValue', defaultValue);
          // Der spezifisch für eine Seite eingestellte Wert "Zeilen pro Seite" hat Vorrang
          // vor dem Standard-Wert aus "Tabellen anpassen", der für alle Seiten mit gerischer Suche
          // eines Benutzers gilt.
          if (pageSize) {
            obs.next(pageSize);
          } else if (defaultSize) {
            obs.next(defaultSize);
          } else {
            obs.next(defaultValue);
          }
        }
      });
      return obs;
    }
    /**
     * Gets the table page size for the specific page from the user profile.
     *
     * @returns an Observable<string> that contains the specific page size for the page
     */
    getTablePageSize(key) {
      return this.userProfileService.getValueforKey(key);
    }
    /**
     * DEFAUT_TABLE_PAGE_SIZE ist ein Sonderfall: es wird ohne weitere Kennung im userProfile gespeichert
     * und gilt somit für alle Tabellen des Nutzers, also auch unabhängit von Angular oder JSF.
     *
     * @returns an Observable<string> that contains the DEFAUT_TABLE_PAGE_SIZE
     */
    getDeaultTablePageSize() {
      return this.userProfileService.getValueforKey(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE);
    }
    static {
      this.ɵfac = function HisSearchRowsPerPageService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchRowsPerPageService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSearchRowsPerPageService,
        factory: HisSearchRowsPerPageService.ɵfac
      });
    }
  }
  return HisSearchRowsPerPageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisSearchResultFilterHelper {
  static removeFilterCriteriaFromParams(params) {
    // clonen ist notwendig, da es sonst Probleme mit readonly gibt
    let urlParams = _.cloneDeep(params);
    //console.log('his-search-result-filter-helper#removeFilterCriteriaFromUrl() #searchParamsToDelete #urlParams', urlParams);
    //console.log(
    //'his-search-result-filter-helper#removeFilterCriteriaFromUrl() #searchParamsToDelete #this.queryParams', this.queryParams);
    for (let key of Object.keys(urlParams)) {
      //console.log('his-search-result.component#removeFilterCriteriaFromUrl() #searchParamsToDelete #urlParams #key', key);
      let value = urlParams[key];
      let group;
      if (value === HisSearchConstants.FILTER) {
        console.log('his-search-result-filter-helper#removeFilterCriteriaFromParams() #searchParamsToDelete #urlParams #value', key, value);
        let k = String(key);
        console.log('his-search-result-filter-helper#removeFilterCriteriaFromParams() #searchParamsToDelete #urlParams #k', k);
        let idx = k.indexOf('.');
        console.log('his-search-result-filter-helper#removeFilterCriteriaFromUrl() #searchParamsToDelete #urlParams #idx', idx);
        group = k.substring(0, idx);
        console.log('his-search-result-filter-helper#removeFilterCriteriaFromUrl() #searchParamsToDelete #urlParams #group', group);
      }
      if (group) {
        for (let paramKey of Object.keys(urlParams)) {
          if (paramKey.startsWith(group)) {
            urlParams[paramKey] = null;
          }
        }
      }
    }
    console.log('his-search-result.component#removeFilterCriteriaFromUrl() #searchParamsToDelete' + ' #urlParams nach dem Entfernen der Filter Kriterien', urlParams);
    return urlParams;
  }
}
class FilterUtils {
  /**
   * Prepares the search object for the given filter.
   *
   * @param filter An object {'searchPath': value ...}
   * @param search An instance of HisSearch
   *
   * @throws Will throw an error if `search` is not valid.
   *
   * @return A new instance of HisSearch with the filter applied.
   */
  static prepareSearchForFilter(filter, search) {
    console.log('#prepareSearchForFilter() #filter', filter, '#search', search);
    if (!search) {
      throw new Error('search must not be null or undefined');
    }
    let searchForFilter = cloneDeep(search);
    let filterGroup = searchForFilter.groups.find(group => group.groupLabel === HisSearchConstants.FILTER);
    if (!filterGroup) {
      if (isEmpty(filter)) {
        console.log('#prepareSearchForFilter #nothing changed #search', search);
        return search;
      }
      // Create new filter group.
      filterGroup = new HisSearchGroup$1();
      // The name doesn't matter for the search
      // So let's call it 'filter'
      filterGroup.groupLabel = HisSearchConstants.FILTER;
      searchForFilter.groups.push(filterGroup);
      console.log('#prepareSearchForFilter #added new filter group', searchForFilter);
    }
    for (const [key, value] of Object.entries(filter)) {
      if (!isEmpty(value)) {
        const theCriterion = filterGroup.criteria.find(criterion => criterion.field === key);
        if (theCriterion) {
          theCriterion.value = value;
        } else {
          let filterCriterion = new HisSearchCriteria$1();
          filterCriterion.field = key;
          filterCriterion.value = value;
          filterGroup.criteria.push(filterCriterion);
        }
      } else {
        filterGroup.criteria = filterGroup.criteria.filter(criterion => criterion.field !== key);
      }
    }
    FilterUtils.removeEmptyFilterGroup(searchForFilter);
    return searchForFilter;
  }
  static removeEmptyFilterGroup(search) {
    search.groups = search.groups.filter(group => group.groupLabel !== HisSearchConstants.FILTER || group.criteria.length > 0);
  }
}
function HisSearchResultSearchInfoComponent_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const searchInfoItem_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", searchInfoItem_r1.not, " ");
  }
}
function HisSearchResultSearchInfoComponent_div_0_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HisSearchResultSearchInfoComponent_div_0_ng_container_4_ng_container_1_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const searchInfoItem_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", searchInfoItem_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", searchInfoItem_r1.not);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", searchInfoItem_r1.value, " ");
  }
}
function HisSearchResultSearchInfoComponent_div_0_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HisSearchResultSearchInfoComponent_div_0_ng_container_4_ng_container_1_ng_container_1_Template, 4, 3, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const searchInfoItem_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", searchInfoItem_r1.value);
  }
}
function HisSearchResultSearchInfoComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HisSearchResultSearchInfoComponent_div_0_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.searchInfo);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "genericSearch.criteriaGroup.exclude"), ":");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "genericSearch.criteriaGroup.include"), ":");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_5_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupItem_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", criteriaGroupItem_r3.not, " ");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_5_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupItem_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", criteriaGroupItem_r3.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", criteriaGroupItem_r3.not);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", criteriaGroupItem_r3.value, " ");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_5_ng_container_1_Template, 4, 3, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupItem_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", criteriaGroupItem_r3.value);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵtemplate(2, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_2_Template, 4, 3, "ng-container", 5)(3, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_template_3_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_ng_container_5_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupInfo_r4 = ctx.$implicit;
    const including_r5 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", criteriaGroupInfo_r4.excluding)("ngIfElse", including_r5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", criteriaGroupInfo_r4.searchCriteriaGroupItems);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_ng_container_2_Template, 6, 3, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const groupWithCriteriaGroup_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", groupWithCriteriaGroup_r6.searchInfoCriteriaGroup);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "genericSearch.criteriaGroup.exclude"), ":");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "genericSearch.criteriaGroup.include"), ":");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_5_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupItem_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", criteriaGroupItem_r7.not, " ");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_5_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", criteriaGroupItem_r7.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", criteriaGroupItem_r7.not);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", criteriaGroupItem_r7.value, " ");
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_5_ng_container_1_Template, 4, 3, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupItem_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", criteriaGroupItem_r7.value);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵtemplate(2, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_2_Template, 4, 3, "ng-container", 5)(3, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_template_3_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_ng_container_5_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteriaGroupInfo_r8 = ctx.$implicit;
    const including_r9 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", criteriaGroupInfo_r8.excluding)("ngIfElse", including_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", criteriaGroupInfo_r8.searchCriteriaGroupItems);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 6)(2, "li")(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "ul");
    i0.ɵɵtemplate(6, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_ng_container_6_Template, 6, 3, "ng-container", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const groupWithCriteriaGroup_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(groupWithCriteriaGroup_r6.criteriaGroupOr);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", groupWithCriteriaGroup_r6.searchInfoCriteriaGroup);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_1_Template, 3, 1, "ng-container", 3)(2, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_ng_container_2_Template, 7, 2, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const groupWithCriteriaGroup_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !groupWithCriteriaGroup_r6.criteriaGroupOr);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", groupWithCriteriaGroup_r6.criteriaGroupOr);
  }
}
function HisSearchResultSearchInfoComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HisSearchResultSearchInfoComponent_div_0_div_5_ng_container_4_Template, 3, 2, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "genericSearch.criteriaGroups"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.searchGroupInfos);
  }
}
function HisSearchResultSearchInfoComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HisSearchResultSearchInfoComponent_div_0_ng_container_4_Template, 2, 1, "ng-container", 3)(5, HisSearchResultSearchInfoComponent_div_0_div_5_Template, 5, 4, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, "genericSearch.searchWords"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.searchInfo.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.searchGroupInfos.length > 0);
  }
}
// Suchkriterium
class HisSearchInfoItem {}
// Alle Suchkriterien in einer Kriteriengruppe
class HisSearchInfoCriteriaGroup {
  constructor() {
    this.searchCriteriaGroupItems = [];
  }
}
// Eine Gruppe, z. B. Personendaten, mit allen Kriteriengruppen
class HisSearchGroupInfo {
  constructor() {
    this.searchInfoCriteriaGroup = [];
  }
}
class LazyCriteriaData {
  constructor(configCriterion, searchCriteria, isCriteriaGroup, searchInfoCriteriaGroup) {
    this.configCriterion = configCriterion;
    this.searchCriteria = searchCriteria;
    this.isCriteriaGroup = isCriteriaGroup;
    this.searchInfoCriteriaGroup = searchInfoCriteriaGroup;
  }
}
let HisSearchResultSearchInfoComponent = /*#__PURE__*/(() => {
  class HisSearchResultSearchInfoComponent {
    constructor() {
      this.searchService = inject(HisSearchService);
      this.hisWidgetService = inject(HisWidgetService);
      this.hisUiService = inject(HisUiService);
      this.hisTreeService = inject(HisTreeService);
      this.searchInfo = [];
      this.searchGroupInfos = [];
      this.lazySearchCriteriaData = [];
      /** maximum number of select options to load */
      this.limit = 1000;
      /** constraint on the defaulttext column of that entity */
      this.wherePart = '';
    }
    ngOnInit() {
      const isFlatObjectFormat = HisQueryParamUtils.isFlatObjectFormat(this.queryParams);
      this.queryParams = HisSearchResultFilterHelper.removeFilterCriteriaFromParams(this.queryParams);
      if (this.queryParams) {
        const searchItems = [];
        for (const key of Object.keys(this.queryParams)) {
          switch (key) {
            // case HisSearchNonCriteriaUrlParam.CONFIG_FILE: this.configFile = queryParams.configFile; break;
            case HisSearchNonCriteriaUrlParam.PAGE_TITLE:
              break;
            case HisSearchNonCriteriaUrlParam.TABLE_TITLE:
              break;
            case HisSearchNonCriteriaUrlParam.IS_NO_SEARCH_ACTIVE:
              // Falls keine aktive Suche, dann kein params auswerten und "Suchergebnisse" nicht anzeigen.
              return;
            case HisSearchNonCriteriaUrlParam.SHOW_CHANGE_SEARCH_BUTTON:
              break;
            case HisSearchNonCriteriaUrlParam.SHOW_BACK_BUTTON:
              break;
            case HisSearchNonCriteriaUrlParam.PAGE:
              break;
            case HisSearchNonCriteriaUrlParam.EXTENDED:
              break;
            case HisSearchNonCriteriaUrlParam.NAVIGATION_POSITION:
              break;
            // blacklisted keys are ignored, see #192323, #212551, #249099
            case HisSearchNonCriteriaUrlParam.NO_DB_ACTION:
            case HisSearchNonCriteriaUrlParam.INIT:
            case HisSearchNonCriteriaUrlParam.CHOC:
            case HisSearchNonCriteriaUrlParam.MODE:
              break;
            default:
              // All other parameters are permitted. Keys added by URL manipulation (#223241) are filtered in the backend
              // Update: key value pairs are now transmitted as part of a flat object
              // group0.criteria0.field = person.gender.id
              // group0.criteria0.value = 2
              if (!isFlatObjectFormat) {
                continue;
              }
              searchItems.push(new HisSearchItem(key, this.queryParams[key]));
          }
        }
        if (isFlatObjectFormat) {
          this.search = HisSearchParser.decode(searchItems);
          this.search.configFile = this.searchConfigFile;
        } else {
          this.search = HisSearchParserHelper.convertUrlParamsToHisSearch(this.queryParams);
        }
      }
      if (!this.searchConfigFile) {
        return;
      }
      this.searchService.loadSearchConfiguration(this.searchConfigFile).subscribe(searchConfig => {
        if (searchConfig) {
          this.hisWidgetService.loadWidgetOptions(searchConfig, true);
          for (const searchGroup of this.search.groups) {
            const searchGroupInfo = new HisSearchGroupInfo();
            if (searchGroup.criteriaGroupAnd === false) {
              searchGroupInfo.criteriaGroupOr = this.hisUiService.translate('genericSearch.result.orLabel');
            }
            this.addItems(searchGroup, searchConfig);
            this.addCriteriaGroupItems(searchGroup, searchConfig, searchGroupInfo);
            if (!HisArrayUtils.isEmptyArray(searchGroupInfo.searchInfoCriteriaGroup)) {
              this.searchGroupInfos.push(searchGroupInfo);
            }
          }
          this.handleLazyCriterias(searchConfig.configFile);
        }
      });
    }
    handleLazyCriterias(configFile) {
      if (this.lazySearchCriteriaData.length == 0) {
        return;
      }
      const optionByIdRequests = [];
      for (const lazyCriteriaData of this.lazySearchCriteriaData) {
        optionByIdRequests.push(new OptionByIdRequest(lazyCriteriaData.configCriterion.selectFrom, [lazyCriteriaData.searchCriteria.value]));
      }
      this.searchService.loadOptionsByIds(configFile, optionByIdRequests).subscribe(result => {
        if (!result) {
          return;
        }
        for (let selectedOption of result) {
          if (!selectedOption || !selectedOption.selectedOptions || selectedOption.selectedOptions.length == 0) {
            continue;
          }
          const matchingCriteriaData = this.lazySearchCriteriaData.find(criteriaData => criteriaData.searchCriteria.value === selectedOption.selectedOptions[0].id);
          this.addToSearchInfo(matchingCriteriaData.configCriterion, selectedOption.selectedOptions[0].label, matchingCriteriaData.searchCriteria.not, matchingCriteriaData.searchCriteria.operator, matchingCriteriaData.isCriteriaGroup, matchingCriteriaData.searchInfoCriteriaGroup);
        }
      });
    }
    addItems(searchGroup, searchConfig) {
      for (const searchCriterion of searchGroup.criteria) {
        this.handleSearchFields(searchCriterion, searchConfig, false, null);
      }
    }
    addCriteriaGroupItem(criteriaGroup, searchConfig, searchInfoCriteriaGroup) {
      for (const searchCriterion of criteriaGroup.criteria) {
        this.handleSearchFields(searchCriterion, searchConfig, true, searchInfoCriteriaGroup);
      }
    }
    handleSearchFields(criteria, searchConfig, isCriteriaGroup, searchInfoCriteriaGroup) {
      if (HisStringUtils.isBlank(criteria.value)) {
        return;
      }
      const configCriterion = this.getConfigCriterionFromSearchCriterion(criteria, searchConfig);
      if (!configCriterion) {
        return;
      }
      const value = criteria.value;
      const not = criteria.not;
      const operator = criteria.operator;
      if (configCriterion.selectFrom && !configCriterion.multipleSelect) {
        if (GenericSearchUtil.isLazySelectFrom(configCriterion.selectFrom, configCriterion.showDropdownIcon)) {
          this.lazySearchCriteriaData.push(new LazyCriteriaData(configCriterion, criteria, isCriteriaGroup, searchInfoCriteriaGroup));
        } else {
          this.handleSingleSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        }
        return;
      }
      if (configCriterion.selectFrom && configCriterion.multipleSelect) {
        this.handleMultiSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        return;
      }
      if (!_.isNil(configCriterion.value)) {
        this.handleCheckbox(configCriterion, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        return;
      }
      if (configCriterion.selectFromTree) {
        this.handleTreeSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        return;
      }
      if (configCriterion.searchConfigFile) {
        this.handleSearchSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        return;
      }
      // input, date
      this.addToSearchInfo(configCriterion, criteria.value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
    }
    handleSingleSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup) {
      this.hisWidgetService.getSelectOptions(configCriterion.selectFrom).subscribe(options => {
        if (options && options.length) {
          // option.id z. B. 5
          // option.label, z. B. männlich
          const option = this.getOptionWithValue(value, options);
          if (option) {
            const label = option.label;
            this.addToSearchInfo(configCriterion, label, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
            return;
          }
        }
        if (value === 'ISNULL') {
          const nullValueLabel = this.hisUiService.translate('genericSearch.nullValueMenuEntry');
          this.addToSearchInfo(configCriterion, nullValueLabel, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        }
      });
    }
    handleMultiSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup) {
      this.hisWidgetService.getSelectOptions(configCriterion.selectFrom).subscribe(options => {
        if (options) {
          const valueArray = value.split(',');
          const optionValue = this.getOptionValues(valueArray, options);
          this.addToSearchInfo(configCriterion, optionValue, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        }
      });
    }
    handleCheckbox(configCriterion, not, operator, isCriteriaGroup, searchInfoCriteriaGroup) {
      const yesValue = this.hisUiService.translate('de.his.javang.ja');
      this.addToSearchInfo(configCriterion, yesValue, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
    }
    handleTreeSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup) {
      // treeSelect
      this.hisTreeService.loadTree(configCriterion.treeName, configCriterion.selectFromTree).subscribe(nodes => {
        if (nodes) {
          const isLidSearch = GenericSearchUtil.isLidPath(configCriterion.path);
          const nodeLabels = this.getNodeLabels(nodes, value, isLidSearch);
          this.addToSearchInfo(configCriterion, nodeLabels, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        }
      });
    }
    handleSearchSelect(configCriterion, value, not, operator, isCriteriaGroup, searchInfoCriteriaGroup) {
      const subSearchSearchConfigFile = configCriterion.searchConfigFile;
      this.searchService.loadFilteredOptions(subSearchSearchConfigFile, this.wherePart, this.limit).subscribe(options => {
        if (options) {
          const valueArray = value.split(',');
          const optionValue = this.getOptionValues(valueArray, options);
          this.addToSearchInfo(configCriterion, optionValue, not, operator, isCriteriaGroup, searchInfoCriteriaGroup);
        }
      });
    }
    addCriteriaGroupItems(searchGroup, searchConfig, searchGroupInfo) {
      for (const criteriaGroup of searchGroup.criteriaGroups) {
        const searchInfoCriteriaGroup = new HisSearchInfoCriteriaGroup();
        searchInfoCriteriaGroup.excluding = criteriaGroup.excluding;
        this.addCriteriaGroupItem(criteriaGroup, searchConfig, searchInfoCriteriaGroup);
        if (!HisArrayUtils.isEmptyArray(searchInfoCriteriaGroup)) {
          searchGroupInfo.searchInfoCriteriaGroup.push(searchInfoCriteriaGroup);
        }
      }
    }
    addToSearchInfo(configCriterion, label, not, operator, isCriteriaGroup, searchInfoCriteriaGroup) {
      const searchInfoItem = this.createSearchInfoItem(configCriterion.label, label, not, operator);
      if (!searchInfoItem) {
        return;
      }
      if (isCriteriaGroup) {
        searchInfoCriteriaGroup.searchCriteriaGroupItems.push(searchInfoItem);
        return;
      }
      this.searchInfo.push(searchInfoItem);
    }
    getNodeLabels(nodes, value, isLidSearch) {
      return nodes.flatMap(node => this.getNodeLabelForOneNode(node, value, isLidSearch));
    }
    getNodeLabelForOneNode(node, value, isLidSearch) {
      const idOrLidValues = value.split(',');
      const nodeLabels = idOrLidValues.map(idOrLidValue => this.getNodeLabel(node, idOrLidValue, isLidSearch)).filter(nodeLabel => nodeLabel != null);
      return nodeLabels;
    }
    getNodeLabel(node, idOrLid, isLidSearch) {
      const includeSubNodes = GenericSearchUtil.isIdOrLidTreeSelectionIncludingSubnodes(idOrLid);
      const cleanIdOrLid = GenericSearchUtil.idOrLidTreeSelectionToCleanIdOrLid(idOrLid);
      // TODO das ist eine komische Bedingung, die ich nicht verstehe
      if (cleanIdOrLid === 0) {
        return null;
      }
      const foundNode = this.findTreeNodeWithIdOrLid(node, cleanIdOrLid, isLidSearch);
      if (!foundNode) {
        return null;
      }
      const data = foundNode.data;
      if (includeSubNodes) {
        return data.defaulttext + ' (' + this.hisUiService.translate('genericSearch.tree.includeSubNodes') + ')';
      }
      return data.defaulttext;
    }
    /**
     * @param labelAsI18nKey
     * @param value
     * @param criterion
     */
    createSearchInfoItem(labelAsI18nKey, label, not, operator) {
      if (!label) {
        return null;
      }
      const searchInfoItem = new HisSearchInfoItem();
      searchInfoItem.label = this.hisUiService.translate(labelAsI18nKey) + ': ';
      if (typeof label == 'string') {
        searchInfoItem.value = label + '; ';
      } else {
        searchInfoItem.value = label.join(', ') + '; ';
        if (not) {
          searchInfoItem.value = '(' + label.join(', ') + ')' + '; ';
        }
      }
      if (not) {
        searchInfoItem.not = this.hisUiService.translate('genericSearch.result.notLabel');
      }
      if (operator) {
        searchInfoItem.operator = operator;
      }
      return searchInfoItem;
    }
    getConfigCriterionFromSearchCriterion(searchCriterion, searchConfig) {
      for (const group of searchConfig.searchCriteria.group) {
        for (const criterion of group.criteria) {
          if (criterion.path === searchCriterion.field) {
            return criterion;
          }
        }
      }
      return null;
    }
    getOptionValues(value, options) {
      const optionValues = [];
      for (const val of value) {
        const option = this.getOptionWithValue(val, options);
        if (option && option.label) {
          optionValues.push(option.label);
        }
      }
      return optionValues;
    }
    getOptionWithValue(value, options) {
      for (const option of options) {
        if (option.id === value) {
          return option;
        }
      }
      return null;
    }
    findTreeNodeWithIdOrLid(treeNode, idOrLid, isLidSearch) {
      if (isLidSearch && treeNode.data.lid === idOrLid) {
        return treeNode;
      }
      if (!isLidSearch && treeNode.data.id === idOrLid) {
        return treeNode;
      }
      let child;
      for (child of treeNode.children) {
        const foundNode = this.findTreeNodeWithIdOrLid(child, idOrLid, isLidSearch);
        if (foundNode) {
          return foundNode;
        }
      }
      return null;
    }
    static {
      this.ɵfac = function HisSearchResultSearchInfoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultSearchInfoComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultSearchInfoComponent,
        selectors: [["his-search-result-search-info"]],
        inputs: {
          searchConfigFile: "searchConfigFile",
          queryParams: "queryParams"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["including", ""], ["class", "text_white_searchresult", 4, "ngIf"], [1, "text_white_searchresult"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], [1, "listStyleIconSimple"]],
        template: function HisSearchResultSearchInfoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSearchResultSearchInfoComponent_div_0_Template, 6, 5, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.searchInfo.length > 0 || ctx.searchGroupInfos.length > 0);
          }
        },
        dependencies: [i1$2.NgForOf, i1$2.NgIf, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultSearchInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisSearchResultConfigComponent_For_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "his-plam", 6);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "input", 9, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultConfigComponent_For_26_Template_input_ngModelChange_3_listener($event) {
      const col_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      i0.ɵɵtwoWayBindingSet(col_r3.checked, $event) || (col_r3.checked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const col_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 2, col_r3.label));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", col_r3.checked);
  }
}
function HisSearchResultConfigComponent_Conditional_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "p-panel", 5);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "his-plam", 6);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementStart(8, "input", 9, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultConfigComponent_Conditional_38_Template_input_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r4 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r4.reorderableColumns, $event) || (ctx_r4.reorderableColumns = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(2, 5, "tableConfig.columnMove"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, "tableConfig.columnMove.helpText"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(7, 9, "tableConfig.columnMoveBtns"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.reorderableColumns);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" [", ctx_r4.reorderableColumns, "] ");
  }
}
let HisSearchResultConfigComponent = /*#__PURE__*/(() => {
  class HisSearchResultConfigComponent {
    constructor() {
      this.userProfileService = inject(HisUserProfileService);
      this.auth = inject(HisAuthService);
      this.uiService = inject(HisUiService);
      this.notificationService = inject(HisNotificationService);
      this.configColumns = [];
      this.saved = new EventEmitter();
      this.originalconfigColumns = [];
      this.showEditTableDialog = false;
      /** Blätterfunktion unterhalb anzeigen, per Default true */
      this.naviAfter = true;
    }
    ngOnInit() {
      //console.log('his-search-result-config#ngOnInit() #columns', this.columns);
      this.userProfileService.getValueforKey(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE).subscribe(result => {
        if (result) {
          this.defaultTablePageSize = +result;
        }
      });
    }
    showTableConfigPopup() {
      console.log('his-search-result-config#showTableConfigPopup() #columns', this.configColumns);
      this.originalconfigColumns = _.cloneDeep(this.configColumns);
      console.log('his-search-result-config#showTableConfigPopup() #originalconfigColumns', this.originalconfigColumns);
      this.originalPaginatiorPosition = _.clone(this.paginatorPosition);
      this.getPaginatorPosition();
      console.log('his-search-result-config#showTableConfigPopup() #originalPaginatorPosition', this.originalPaginatiorPosition);
      this.showEditTableDialog = true;
    }
    hideEditTablePopup() {
      this.showEditTableDialog = false;
    }
    save() {
      console.log('his-search-result-config#save()');
      this.notificationService.clear();
      console.log('his-search-result-config#save() #this.defaultTablePageSize', this.defaultTablePageSize);
      if (this.defaultTablePageSize) {
        if (!(this.defaultTablePageSize >= this.minRows) || this.defaultTablePageSize > this.maxRows) {
          let label = this.uiService.translate('tableConfig.globalPageSizeDefault');
          this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.range', label, this.minRows, this.maxRows), this.uiService.translate('view.messages.error'));
          return;
        }
      }
      let hiddenColumnsKey = this.getUserProfileKey(HisSearchResultConfigConstants.HIDDEN_COLS);
      let paginatorPositionKey = this.getUserProfileKey(HisSearchResultConfigConstants.PAGINATOR_POSITION);
      if (this.auth.isAnonymous) {
        let hiddenCols = sessionStorage.getItem(hiddenColumnsKey);
        hiddenCols = hiddenCols === null ? '' : hiddenCols;
        this.saveHiddenColumns(hiddenCols, hiddenColumnsKey);
        let paginatorPos = sessionStorage.getItem(paginatorPositionKey);
        this.savePaginatorPosition(paginatorPos, paginatorPositionKey);
        if (this.defaultTablePageSize) {
          console.log('his-search-result-config#save() #sessionStorage #defaultTablePageSize', this.defaultTablePageSize);
          this.saveAtSessionStorage(HisSessionStorageKeys.CS_SYS_ANONYMOUS_DEFAULT_TABLE_PAGE_SIZE, this.defaultTablePageSize.toString());
        } else {
          this.deleteKeyFromSessionStorage(HisSessionStorageKeys.CS_SYS_ANONYMOUS_DEFAULT_TABLE_PAGE_SIZE);
        }
        this.showEditTableDialog = false;
        this.saved.emit(this.defaultTablePageSize);
      } else {
        const hiddenCols = this.userProfileService.getValueforKey(hiddenColumnsKey);
        const paginatorPos = this.userProfileService.getValueforKey(paginatorPositionKey);
        // Sonderfall: wird ohne weitere Kennung gespeichert und gilt somit für alle Tabellen des Nutzers
        // also auch unabhängit von Angular oder JSF
        const defaultTablePageSize = this.userProfileService.getValueforKey(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE);
        forkJoin([hiddenCols, paginatorPos, defaultTablePageSize]).subscribe(result => {
          console.log('his-search-result-config#save() #forkJoin #result', result);
          // if-else um zu auf Ergebnis zu warten
          if (result[0]) {
            console.log('his-search-result-config#save() #configColumns #result', result[0]);
            this.saveHiddenColumns(result[0], hiddenColumnsKey);
          } else {
            // no entry at userProfile present
            console.log('his-search-result-config#save() #this.configColumns', this.configColumns);
            let emptyHiddenColumns = '';
            this.saveHiddenColumns(emptyHiddenColumns, hiddenColumnsKey);
          }
          let lastSavedpaginatorPosition = result[1];
          console.log('his-search-result-config#save() #paginator #fromUserProfile', lastSavedpaginatorPosition);
          this.savePaginatorPosition(lastSavedpaginatorPosition, paginatorPositionKey);
          if (result[2]) {
            console.log('his-search-result-config#save() #defaultTablePageSize #result', result[2]);
            if (this.defaultTablePageSize) {
              if (result[2] !== this.defaultTablePageSize.toString()) {
                this.saveAtUserProfile(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE, this.defaultTablePageSize.toString());
              }
            } else {
              this.userProfileService.delete(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE).subscribe();
            }
          } else {
            console.log('his-search-result-config#save() #defaultTablePageSize #result expected null:', result[2]);
            if (this.defaultTablePageSize) {
              let key = HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE;
              let value = this.defaultTablePageSize.toString();
              this.userProfileService.setNewValue(key, value, null).subscribe(saveResult => {
                if (saveResult) {
                  console.log('his-search-result-config#save() #forkJoin #save #key', key, '#value', value, '#saveResult', saveResult);
                }
              });
            }
          }
          this.showEditTableDialog = false;
          console.log('his-search-result-config#save() #forkJoin #emit #this.defaultTablePageSize', this.defaultTablePageSize);
          this.saved.emit(this.defaultTablePageSize);
        });
      }
    }
    deleteKeyFromSessionStorage(key) {
      sessionStorage.removeItem(key);
    }
    saveAtUserProfile(key, value) {
      this.userProfileService.setNewValue(key, value, null).subscribe(result => {
        if (result) {
          console.log('his-search-result-config#saveAtUserProfile() #key', key, '#value', value, '#result', result);
        }
      });
    }
    saveAtSessionStorage(key, value) {
      sessionStorage.setItem(key, value);
    }
    savePaginatorPosition(lastSavedPaginatorPos, key) {
      console.log('his-search-result-config#savePaginatorPosition() #lastSavedPaginatorPos', lastSavedPaginatorPos);
      console.log('his-search-result-config#savePaginatorPosition() #this.paginatorPosition', this.paginatorPosition);
      console.log('his-search-result-config#savePaginatorPosition() #key', key);
      // paginatorPosition = 'bottom'; soll nie gespeichert werden, weil default
      if (this.paginatorPosition === 'bottom') {
        // 'bottom' delete key
        if (this.auth.isAnonymous) {
          this.deleteKeyFromSessionStorage(key);
        } else {
          console.log('his-search-result-config#savePaginatorPosition() #delete #key', key);
          this.userProfileService.delete(key).subscribe();
        }
        return;
      }
      // nur speichern und emitten, wenn sich etwas geändert hat
      if (this.paginatorPosition !== lastSavedPaginatorPos) {
        if (this.auth.isAnonymous) {
          this.saveAtSessionStorage(key, this.paginatorPosition);
        } else {
          this.saveAtUserProfile(key, this.paginatorPosition);
        }
      }
    }
    saveHiddenColumns(hiddenColumns, key) {
      let originalHiddenColumns = _.cloneDeep(hiddenColumns);
      console.log('his-search-result-config#saveOrDeleteHiddenColumnsAtUserProfile() #this.configColumns', this.configColumns);
      if (!HisStringUtils.isBlank(hiddenColumns)) {
        hiddenColumns = hiddenColumns + ',';
      }
      for (let col of this.configColumns) {
        console.log('his-search-result-config#saveOrDeleteHiddenColumnsAtUserProfile() #col of this.configColumns', col);
        // wenn !col.checked und nicht hiddenColumns = hinzufügen
        if (!col.checked && !hiddenColumns.includes(col.id)) {
          hiddenColumns = hiddenColumns + col.id + ',';
        }
        // wenn col.checked und in hiddenColumns vorhanden = entfernen
        if (col.checked && hiddenColumns.includes(col.id)) {
          hiddenColumns = hiddenColumns.replace(col.id, '');
        }
      }
      // Problem mit doppelten Kommas lösen
      if (hiddenColumns.includes(',,')) {
        hiddenColumns = hiddenColumns.replace(',,', ',');
      }
      // Weiß nicht ob das Probleme machen würde, sicherheitshalber entfernen
      hiddenColumns = HisStringUtils.removeLast(hiddenColumns, ',');
      if (!HisStringUtils.isBlank(hiddenColumns) && hiddenColumns !== originalHiddenColumns) {
        // value = z. B. String 'ActionsBefore,psv.Person.name,common.components.contactPerson.email'
        console.log('his-search-result-config#saveOrDeleteHiddenColumnsAtUserProfile() #userProfile key', key);
        console.log('his-search-result-config#saveOrDeleteHiddenColumnsAtUserProfile() #userProfile columns to save', hiddenColumns);
        if (this.auth.isAnonymous) {
          this.saveAtSessionStorage(key, hiddenColumns);
        } else {
          this.saveAtUserProfile(key, hiddenColumns);
        }
      } else if (HisStringUtils.isBlank(hiddenColumns)) {
        // wenn es nichts zu Speichern gibt, Schlüssel löschen
        if (this.auth.isAnonymous) {
          this.deleteKeyFromSessionStorage(key);
        } else {
          this.userProfileService.delete(key).subscribe();
        }
      }
    }
    cancel() {
      this.configColumns = _.cloneDeep(this.originalconfigColumns);
      this.paginatorPosition = _.clone(this.originalPaginatiorPosition);
      console.log('his-search-result-config#cancel() #originalconfigColumns', this.originalconfigColumns);
    }
    /**
     * resets (deletes) user profile keys
     * <p>triggered by click on "Standard wiederherstellen"</p>
     */
    reset() {
      console.log('his-search-result-config#reset()');
      this.defaultTablePageSize = null;
      this.naviBefore = false;
      this.naviAfter = true;
      this.setPaginatorPosition();
      if (this.auth.isAnonymous) {
        console.log('his-search-result-config#reset()');
        this.deleteKeyFromSessionStorage(this.getUserProfileKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_HIDDEN_COLS));
        this.deleteKeyFromSessionStorage(this.getUserProfileKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_PAGINATOR_POSITION));
        this.deleteKeyFromSessionStorage(this.getUserProfileKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_PAGE_SIZE));
        this.deleteKeyFromSessionStorage(HisSessionStorageKeys.CS_SYS_ANONYMOUS_DEFAULT_TABLE_PAGE_SIZE);
        this.saved.emit(this.defaultTablePageSize);
      } else {
        let hiddenColumnsKey = this.getUserProfileKey(HisSearchResultConfigConstants.HIDDEN_COLS);
        let paginatorPositionKey = this.getUserProfileKey(HisSearchResultConfigConstants.PAGINATOR_POSITION);
        let pageSizeKey = this.getUserProfileKey(HisUserProfileConstants.PAGE_SIZE);
        const hiddenColumns = this.userProfileService.setNewValue(hiddenColumnsKey, null, null);
        const paginatorPosition = this.userProfileService.setNewValue(paginatorPositionKey, null, null);
        const pageSize = this.userProfileService.setNewValue(pageSizeKey, null, null);
        const defaultTablePageSize = this.userProfileService.setNewValue(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE, null, null);
        console.log('his-search-result-config#reset() #pageSizeKey', pageSizeKey);
        forkJoin([hiddenColumns, paginatorPosition, pageSize, defaultTablePageSize]).subscribe(result => {
          // Weiter erst wenn alles gelöscht ist
          if (result) {
            console.log('his-search-result-config#reset() #result', result);
            console.log('his-search-result-config#reset() #this.defaultTablePageSize', this.defaultTablePageSize);
            this.saved.emit(this.defaultTablePageSize);
          }
        });
      }
    }
    getUserProfileKey(key) {
      return this.userProfileKeyBasePath + key;
    }
    setPaginatorPosition() {
      if (this.naviAfter && !this.naviBefore) {
        this.paginatorPosition = 'bottom';
      } else if (!this.naviAfter && this.naviBefore) {
        this.paginatorPosition = 'top';
      } else if (this.naviAfter && this.naviBefore) {
        this.paginatorPosition = 'both';
      } else if (!this.naviAfter && !this.naviBefore) {
        this.paginatorPosition = 'absent';
      }
    }
    onCheckboxChange(event) {
      console.log('his-search-result-config#onCheckboxChange() #event', event);
      this.setPaginatorPosition();
      console.log('his-search-result-config#onCheckboxChange() #this.paginatorPosition', this.paginatorPosition);
    }
    getPaginatorPosition() {
      console.log('his-search-result-config#getPaginatorPosition() #paginator #showPaginator', this.showPaginator);
      console.log('his-search-result-config#getPaginatorPosition() #paginator #paginatorPosition', this.paginatorPosition);
      if (this.showPaginator === false) {
        this.naviBefore = false;
        this.naviAfter = false;
        return;
      }
      if (this.paginatorPosition === 'bottom') {
        this.naviBefore = false;
        this.naviAfter = true;
      } else if (this.paginatorPosition === 'top') {
        this.naviBefore = true;
        this.naviAfter = false;
      } else if (this.paginatorPosition === 'both') {
        this.naviBefore = true;
        this.naviAfter = true;
      }
    }
    static {
      this.ɵfac = function HisSearchResultConfigComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultConfigComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultConfigComponent,
        selectors: [["his-search-result-config"]],
        inputs: {
          configColumns: "configColumns",
          minRows: "minRows",
          maxRows: "maxRows",
          defaultTablePageSize: "defaultTablePageSize",
          paginatorPosition: "paginatorPosition",
          showPaginator: "showPaginator",
          userProfileKeyBasePath: "userProfileKeyBasePath"
        },
        outputs: {
          saved: "saved"
        },
        standalone: false,
        decls: 46,
        vars: 45,
        consts: [["content", ""], ["hisImage", "brush", 1, "transparent", 3, "click"], ["styleClass", "fieldsetBgYellow", 3, "visibleChange", "onHide", "responsive", "modal", "blockScroll", "closable", "visible"], ["type", "button", 3, "click"], [1, "columnHalf"], [3, "header"], [3, "label"], ["type", "checkbox", "binary", "true", 3, "ngModelChange", "change", "ngModel"], [1, "inputWidth100", 3, "ngModelChange", "ngModel"], ["type", "checkbox", "binary", "true", 3, "ngModelChange", "ngModel"], [1, "infoMessage"]],
        template: function HisSearchResultConfigComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "span")(1, "button", 1);
            i0.ɵɵlistener("click", function HisSearchResultConfigComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showTableConfigPopup());
            });
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "p-dialog", 2);
            i0.ɵɵtwoWayListener("visibleChange", function HisSearchResultConfigComponent_Template_p_dialog_visibleChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.showEditTableDialog, $event) || (ctx.showEditTableDialog = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onHide", function HisSearchResultConfigComponent_Template_p_dialog_onHide_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hideEditTablePopup());
            });
            i0.ɵɵelementStart(6, "p-header")(7, "h2");
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div")(11, "button", 3);
            i0.ɵɵlistener("click", function HisSearchResultConfigComponent_Template_button_click_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.save());
            });
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "button", 3);
            i0.ɵɵlistener("click", function HisSearchResultConfigComponent_Template_button_click_14_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.hideEditTablePopup();
              return i0.ɵɵresetView(ctx.cancel());
            });
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "button", 3);
            i0.ɵɵlistener("click", function HisSearchResultConfigComponent_Template_button_click_17_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.hideEditTablePopup();
              return i0.ɵɵresetView(ctx.reset());
            });
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 4)(21, "p-panel", 5);
            i0.ɵɵpipe(22, "hisUi");
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "hisUi");
            i0.ɵɵrepeaterCreate(25, HisSearchResultConfigComponent_For_26_Template, 5, 4, "div", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "div", 4)(28, "p-panel", 5);
            i0.ɵɵpipe(29, "hisUi");
            i0.ɵɵelementStart(30, "his-plam", 6);
            i0.ɵɵpipe(31, "hisUi");
            i0.ɵɵelementStart(32, "input", 7, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultConfigComponent_Template_input_ngModelChange_32_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.naviBefore, $event) || (ctx.naviBefore = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("change", function HisSearchResultConfigComponent_Template_input_change_32_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCheckboxChange($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(34, "his-plam", 6);
            i0.ɵɵpipe(35, "hisUi");
            i0.ɵɵelementStart(36, "input", 7, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultConfigComponent_Template_input_ngModelChange_36_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.naviAfter, $event) || (ctx.naviAfter = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("change", function HisSearchResultConfigComponent_Template_input_change_36_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCheckboxChange($event));
            });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(38, HisSearchResultConfigComponent_Conditional_38_Template, 11, 11, "div", 4);
            i0.ɵɵelementStart(39, "div", 4)(40, "p-panel", 5);
            i0.ɵɵpipe(41, "hisUi");
            i0.ɵɵelementStart(42, "his-plam", 6);
            i0.ɵɵpipe(43, "hisUi");
            i0.ɵɵelementStart(44, "input", 8, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultConfigComponent_Template_input_ngModelChange_44_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.defaultTablePageSize, $event) || (ctx.defaultTablePageSize = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 21, "de.his.javang.edit.table"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("responsive", true)("modal", true)("blockScroll", true)("closable", false);
            i0.ɵɵtwoWayProperty("visible", ctx.showEditTableDialog);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 23, "tableConfig.title"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 25, "de.his.javang.save"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 27, "common.cancel"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 29, "resetToDefault"));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(22, 31, "tableConfig.chooseColumns"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" * ", i0.ɵɵpipeBind1(24, 33, "tableConfig.chooseColumnsSubtitle"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.configColumns);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(29, 35, "tableConfig.naviBefore"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(31, 37, "tableConfig.naviBefore"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.naviBefore);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(35, 39, "tableConfig.naviAfter"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.naviAfter);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(false ? 38 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(41, 41, "tableConfig.globalPageSizeDefault"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(43, 43, "tableConfig.globalPageSizeDefault"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.defaultTablePageSize);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.Header, i3.Dialog, i4$1.Panel, HisPlamComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisPanelDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultConfigComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisSearchResultRowsPerPageComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, "de.his.faces.tags.table.datascroller.numRowsFound.page", ctx_r1.currentPageNumber, ctx_r1.totalNumberOfPages), " | ");
  }
}
function HisSearchResultRowsPerPageComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "de.his.faces.tags.table.datascroller.numRowsPerPage"), " (Max:", ctx_r1.maxRows, ") ");
  }
}
function HisSearchResultRowsPerPageComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(1, 2, "de.his.faces.tags.table.datascroller.numRowsPerPage"), " ", i0.ɵɵpipeBind1(2, 4, "de.his.faces.tags.table.datascroller.maxNumRowsPerPage"), " ");
  }
}
let HisSearchResultRowsPerPageComponent = /*#__PURE__*/(() => {
  class HisSearchResultRowsPerPageComponent {
    constructor() {
      this.authService = inject(HisAuthService);
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      this.rowsPerPageInputChanged = new EventEmitter();
      this.minRows = 1;
    }
    get i18nKeyForRecords() {
      return 'de.his.faces.tags.table.datascroller.numRowsFound' + (this.totalRowCount === 1 ? '.record' : '.records');
    }
    ngOnInit() {
      this.ensureMaxRowsGreaterThanResultRowsPerPage();
      this.inputValue = this.rowsPerPage ? this.rowsPerPage.toString() : null;
    }
    ngOnChanges() {
      console.log('his-search-result-rows-per-page.component#ngOnChanges() #rowsPerPage', this.rowsPerPage);
      this.inputValue = this.rowsPerPage ? this.rowsPerPage.toString() : null;
    }
    changed(event) {
      console.log('his-search-result-rows-per-page.component#changed() #event', event);
      console.log('his-search-result-rows-per-page.component#changed() #inputValue', this.inputValue);
      this.notificationService.clear();
      let input = this.inputValue;
      console.log('his-search-result-rows-per-page.component#changed() #this.rowsPerPage', this.rowsPerPage);
      console.log('his-search-result-rows-per-page.component#changed() #input', input);
      this.inputValue = this.changeInputValueAfterValidation(this.validateInput(input), input);
      this.rowsPerPageInputChanged.emit(+this.inputValue);
    }
    /**
     * Changes the input value after validation.
     *
     *@param validated - Indicates whether the input value has been validated.
     *@param input - The input value to be changed.
     *@returns The modified input value.
     */
    changeInputValueAfterValidation(validated, input) {
      if (!validated) {
        return input = this.rowsPerPage ? this.resultRowsPerPage.toString() : null;
      }
      return input;
    }
    /**
     *Validates the input value.
     *
     *@param input - The input value to be validated.
     *@returns A boolean indicating whether the input value is valid or not.
     */
    validateInput(input) {
      let label = this.uiService.translate('de.his.faces.tags.table.datascroller.numRowsPerPage');
      //convertes the input value to a number
      let checkInput = +input;
      //check that input is a number
      if (!this.isNumber(checkInput)) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.type', label, input), this.uiService.translate('view.messages.error'));
        return false;
      }
      //returns a error message if the input is smaller than this.minRows or bigger than this.maxRows
      if (!(checkInput >= this.minRows) || checkInput > this.maxRows) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.range', label, this.minRows, this.maxRows), this.uiService.translate('view.messages.error'));
        return false;
      }
      //check that input is not a decimal number
      if (checkInput % 1 !== 0) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.type', label, checkInput), this.uiService.translate('view.messages.error'));
        return false;
      }
      return true;
    }
    isNumber(value) {
      if (isNaN(+value)) {
        return false;
      }
      return true;
    }
    // ist das überhaupt noch notwendig?
    // in welchen Fällen kann das auftreten?
    ensureMaxRowsGreaterThanResultRowsPerPage() {
      let input = Number(this.inputValue);
      if (input > this.maxRows) {
        this.notificationService.error(this.uiService.translate('his-search-result.component - ' + 'ungültige Parameterübergabe: resultRowsPerPage (' + this.inputValue + ') darf nicht größer sein als maxRows (' + this.maxRows + '). Bitte ändern Sie die Parameter.'), this.uiService.translate('view.messages.error'));
        throw new Error('his-search-result.component - ' + 'passed invalid parameters: resultRowsPerPage ' + this.inputValue + ' must not be > than maxRows ' + this.maxRows + '. Please adjust parameters.');
      }
    }
    static {
      this.ɵfac = function HisSearchResultRowsPerPageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultRowsPerPageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultRowsPerPageComponent,
        selectors: [["his-search-result-rows-per-page"]],
        inputs: {
          resultRowsPerPage: "resultRowsPerPage",
          rowsPerPage: "rowsPerPage",
          maxRows: "maxRows",
          totalRowCount: "totalRowCount",
          currentPageNumber: "currentPageNumber",
          totalNumberOfPages: "totalNumberOfPages"
        },
        outputs: {
          rowsPerPageInputChanged: "rowsPerPageInputChanged"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 11,
        vars: 10,
        consts: [["content", ""], [1, "tableRowCount"], ["for", "tableRow"], ["required", "", "id", "tableRow", 1, "input_3_Chars", "tableRowInput", 3, "ngModelChange", "change", "ngModel"]],
        template: function HisSearchResultRowsPerPageComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "hisUi");
            i0.ɵɵpipe(4, "hisUi");
            i0.ɵɵtemplate(5, HisSearchResultRowsPerPageComponent_Conditional_5_Template, 2, 5);
            i0.ɵɵelementStart(6, "label", 2);
            i0.ɵɵtemplate(7, HisSearchResultRowsPerPageComponent_Conditional_7_Template, 3, 4, "span")(8, HisSearchResultRowsPerPageComponent_Conditional_8_Template, 3, 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "input", 3, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultRowsPerPageComponent_Template_input_ngModelChange_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.inputValue, $event) || (ctx.inputValue = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("change", function HisSearchResultRowsPerPageComponent_Template_input_change_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.changed($event));
            });
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(3, 5, "de.his.faces.tags.table.datascroller.numRowsFound.label"), " ", i0.ɵɵpipeBind2(4, 7, ctx.i18nKeyForRecords, ctx.totalRowCount), " | ");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.totalNumberOfPages > 1 ? 5 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.maxRows ? 7 : 8);
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.inputValue);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.NgModel, HisModificationDetectionDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultRowsPerPageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisHtmlUnsafePipe = /*#__PURE__*/(() => {
  class HisHtmlUnsafePipe {
    constructor() {
      this.sanitizer = inject(DomSanitizer);
    }
    transform(html) {
      if (html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
      } else {
        return '';
      }
    }
    static {
      this.ɵfac = function HisHtmlUnsafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisHtmlUnsafePipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisHtmlUnsafe",
        type: HisHtmlUnsafePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisHtmlUnsafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$s = a0 => ({
  showBackButton: a0
});
function HisSearchResultTableCellComponent_Conditional_0_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.columnContent, " ");
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r0.columnContent, ctx_r0.column.format || "1.0-3"), " ");
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r0.columnContent, ctx_r0.column.format || "dd.MM.yyyy"), " ");
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r0.columnContent, ctx_r0.column.format || "HH:mm"), " ");
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵlistener("click", function HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onBeforeNavigateDefaultRoute());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("disabledLink", ctx_r0.disableDefaultActionLink);
    i0.ɵɵproperty("routerLink", ctx_r0.defaultActionRoute.replace(":id", ctx_r0.rowId))("queryParams", i0.ɵɵpureFunction1(6, _c0$s, ctx_r0.showBackButton))("title", ctx_r0.getDefaultActionToolTipForColumn(ctx_r0.columnContent));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.columnContent);
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("disabledLink", ctx_r0.defaultActionRowRight ? !ctx_r0.row.get(ctx_r0.defaultActionRowRight) : false);
    i0.ɵɵproperty("href", ctx_r0.defaultActionUrl.replace(":id", ctx_r0.rowId), i0.ɵɵsanitizeUrl)("title", ctx_r0.getDefaultActionToolTipForColumn(ctx_r0.columnContent));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.columnContent);
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.columnContent === "1" && ctx_r0.column.format === "Boolean" ? i0.ɵɵpipeBind1(1, 1, "de.his.javang.ja.lowercase") : ctx_r0.columnContent === "0" && ctx_r0.column.format === "Boolean" ? i0.ɵɵpipeBind1(2, 3, "de.his.javang.nein.lowercase") : ctx_r0.columnContent, " ");
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_1_Template, 2, 8, "a", 3)(2, HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_2_Template, 2, 5, "a", 4)(3, HisSearchResultTableCellComponent_Conditional_0_Case_5_Conditional_3_Template, 3, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.defaultActionRoute && ctx_r0.isDefaultColumn ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.defaultActionUrl && ctx_r0.isDefaultColumn && ctx_r0.defaultActionToolTip ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.defaultActionRoute && !ctx_r0.defaultActionUrl || !ctx_r0.isDefaultColumn ? 3 : -1);
  }
}
function HisSearchResultTableCellComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisSearchResultTableCellComponent_Conditional_0_Case_1_Template, 2, 1, "div", 1)(2, HisSearchResultTableCellComponent_Conditional_0_Case_2_Template, 3, 4, "div", 1)(3, HisSearchResultTableCellComponent_Conditional_0_Case_3_Template, 3, 4, "div", 1)(4, HisSearchResultTableCellComponent_Conditional_0_Case_4_Template, 3, 4, "div", 1)(5, HisSearchResultTableCellComponent_Conditional_0_Case_5_Template, 4, 3, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_1_0 = ctx_r0.column.dataType) === "decimal" ? 1 : tmp_1_0 === "number" ? 2 : tmp_1_0 === "date" ? 3 : tmp_1_0 === "time" ? 4 : 5);
  }
}
function HisSearchResultTableCellComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 0);
    i0.ɵɵpipe(1, "hisHtmlUnsafe");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.column.renderer(ctx_r0, ctx_r0.ri, ctx_r0.row)), i0.ɵɵsanitizeHtml);
  }
}
let HisSearchResultTableCellComponent = /*#__PURE__*/(() => {
  class HisSearchResultTableCellComponent {
    constructor() {
      this.isDefaultColumn = false;
      // metadata describing the columns of the search result
      this.beforeNavigateDefaultRoute = new EventEmitter();
      this.uiService = inject(HisUiService);
    }
    ngOnInit() {
      this.columnContent = this.row.getAt(this.columnIndex);
      this.disableDefaultActionLink = this.defaultActionRowRight ? !this.row.get(this.defaultActionRowRight) : false;
    }
    ngOnChanges(changes) {
      if (changes.row || changes.columnIndex) {
        this.columnContent = this.row.getAt(this.columnIndex);
      }
      if (changes.row || changes.defaultActionRowRight) {
        this.disableDefaultActionLink = changes.defaultActionRowRight ? !this.row.get(this.defaultActionRowRight) : false;
      }
    }
    onBeforeNavigateDefaultRoute() {
      this.beforeNavigateDefaultRoute.emit();
    }
    getDefaultActionToolTipForColumn(columnContent) {
      if (this.defaultActionToolTip) {
        return this.uiService.translate(this.defaultActionToolTip, columnContent);
      }
      return this.uiService.translate('common.showOf', columnContent);
    }
    static {
      this.ɵfac = function HisSearchResultTableCellComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultTableCellComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultTableCellComponent,
        selectors: [["his-search-result-table-cell"]],
        inputs: {
          rowId: "rowId",
          row: "row",
          column: "column",
          columnIndex: "columnIndex",
          ri: "ri",
          defaultActionRoute: "defaultActionRoute",
          defaultActionUrl: "defaultActionUrl",
          showBackButton: "showBackButton",
          isDefaultColumn: "isDefaultColumn",
          defaultActionToolTip: "defaultActionToolTip",
          defaultActionRowRight: "defaultActionRowRight"
        },
        outputs: {
          beforeNavigateDefaultRoute: "beforeNavigateDefaultRoute"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 1,
        consts: [[3, "innerHTML"], [2, "text-align", "right"], [1, "defaultActionContainer"], [1, "defaultActionLink", 3, "disabledLink", "routerLink", "queryParams", "title"], ["target", "_blank", 1, "defaultActionLink", 3, "disabledLink", "href", "title"], [1, "defaultActionLink", 3, "click", "routerLink", "queryParams", "title"], ["target", "_blank", 1, "defaultActionLink", 3, "href", "title"]],
        template: function HisSearchResultTableCellComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSearchResultTableCellComponent_Conditional_0_Template, 6, 1, "div")(1, HisSearchResultTableCellComponent_Conditional_1_Template, 2, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.column.renderer ? 0 : 1);
          }
        },
        dependencies: [i1$3.RouterLink, i1$2.DecimalPipe, i1$2.DatePipe, HisHtmlUnsafePipe, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultTableCellComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _forTrack0$1 = ($index, $item) => $item.id;
function HisSearchResultSelectedItemsComponent_ng_template_10_For_5_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-sortIcon", 10);
  }
  if (rf & 2) {
    const column_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("field", column_r2.sortPath);
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_10_For_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultSelectedItemsComponent_ng_template_10_For_5_Conditional_0_Conditional_3_Template, 1, 1, "p-sortIcon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("pSortableColumnDisabled", !column_r2.sortable)("pSortableColumn", column_r2.sortPath)("id", column_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, column_r2.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(column_r2.sortable ? 3 : -1);
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_10_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultSelectedItemsComponent_ng_template_10_For_5_Conditional_0_Template, 4, 7, "th", 9);
  }
  if (rf & 2) {
    const column_r2 = ctx.$implicit;
    i0.ɵɵconditional(column_r2.visible ? 0 : -1);
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(4, HisSearchResultSelectedItemsComponent_ng_template_10_For_5_Template, 1, 1, null, null, _forTrack0$1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.rowselect"));
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.columns);
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_11_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "his-search-result-table-cell", 13);
    i0.ɵɵlistener("beforeNavigateDefaultRoute", function HisSearchResultSelectedItemsComponent_ng_template_11_For_4_Conditional_0_Template_his_search_result_table_cell_beforeNavigateDefaultRoute_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onBeforeNavigateDefaultRoute());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const column_r6 = ctx_r4.$implicit;
    const ɵ$index_40_r7 = ctx_r4.$index;
    const row_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("column", column_r6)("columnIndex", ɵ$index_40_r7)("row", row_r8)("rowId", row_r8.getAt(ctx_r2.idColumn));
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_11_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultSelectedItemsComponent_ng_template_11_For_4_Conditional_0_Template, 2, 4, "td");
  }
  if (rf & 2) {
    const column_r6 = ctx.$implicit;
    i0.ɵɵconditional(column_r6.visible ? 0 : -1);
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 11);
    i0.ɵɵelement(2, "p-tableCheckbox", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(3, HisSearchResultSelectedItemsComponent_ng_template_11_For_4_Template, 1, 1, null, null, _forTrack0$1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r8 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", row_r8)("ariaLabel", ctx_r2.getTableCheckboxTitle(row_r8))("title", ctx_r2.getTableCheckboxTitle(row_r8));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.columns);
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("colspan", ctx_r2.columns.length + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "de.his.faces.tags.table.datascroller.noRowsFound"), " ");
  }
}
function HisSearchResultSelectedItemsComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function HisSearchResultSelectedItemsComponent_ng_template_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onUpdateTableSelectItems());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 15);
    i0.ɵɵlistener("click", function HisSearchResultSelectedItemsComponent_ng_template_13_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCancelOverlay());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "common.apply"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "common.close"), " ");
  }
}
let HisSearchResultSelectedItemsComponent = /*#__PURE__*/(() => {
  class HisSearchResultSelectedItemsComponent {
    constructor() {
      this.DEFAULT_PAGE_SIZE = 10;
      this.searchService = inject(HisSearchService);
      this.uiService = inject(HisUiService);
      this.navigationService = inject(HisNavigationService);
      // Emits when selected items are updated from the overlay
      this.updateSelectedItems = new EventEmitter();
      //overlay
      // Items available for selection in the overlay 
      this.overlayItemsToSelect = [];
      //Pagination properties
      this.rowsPerPageOverlay = this.DEFAULT_PAGE_SIZE;
      this.rowsPerPageOptionsOverlay = [10, 15, 25, 50, 100, 150, 200, 250, 300];
    }
    onOpenOverlay() {
      this.loadSelectedRows().subscribe(_ => this.display = true);
    }
    loadSelectedRows() {
      // Don't load if there are no selected options
      if (!this.selectedOptions.length) {
        this.resetOverlayData();
        return of(null);
      }
      const searchRequest = this.createSearchRequestFromSelectedOptions(this.currentSearch);
      return this.loadSearchResult(searchRequest).pipe(tap$1(result => {
        this.selectedItems = result.data;
        this.overlaySelectedItems = [...this.selectedItems];
        this.overlayItemsToSelect = [...this.selectedItems];
        this.totalRecords = this.selectedItems.length;
      }));
    }
    /**
     * Creates a clone of the given HisSearch to be used in the
     * 'already selected' overlay. This allows performing a sub-search
     * to retrieve rows based on the selected option IDs.
     */
    createSearchRequestFromSelectedOptions(hisSubSearch) {
      const clonedSearch = cloneDeep(hisSubSearch);
      clonedSearch.groups = [];
      const group = new HisSearchGroup$1();
      group.groupLabel = this.selectedOptionsIdColumn;
      group.criteriaGroups = [];
      group.criteriaGroupAnd = false;
      /**
       * we need to split up the search into chunks as the maximum search string length currently is 3000 characters
       * tweak the chunk size if any problems occure!
       * Note: if the id is an objGuid, the maximum chunkSize will be 81
       * length(objGuid) = 36  + 1 for the comma
       * 3000/37 = 81,...
       */
      const chunkSize = 80;
      const allOptions = [...this.selectedOptions];
      for (let i = 0; i < allOptions.length; i += chunkSize) {
        // Clear existing groups and create a new one with ID-based criteria
        const criteriaGroupChunk = allOptions.slice(i, i + chunkSize).map(option => option.id).join(',');
        const criteriaGroup = new HisSearchCriteriaGroup();
        const criteria = {
          field: this.selectedOptionsIdColumn,
          value: criteriaGroupChunk,
          not: undefined,
          operator: undefined
        };
        criteriaGroup.criteria = [criteria];
        group.criteriaGroups.push(criteriaGroup);
      }
      clonedSearch.groups.push(group);
      return clonedSearch;
    }
    /**
     * Loads pre and selected items.
     */
    loadSearchResult(search) {
      return this.searchService.loadSearchResult(search, 0, this.selectedOptions.length, null);
    }
    /**
     * Handles lazy loading of data with sorting and pagination
     */
    load(event) {
      // Don't load if there are no selected options
      if (!this.selectedOptions.length) {
        this.resetOverlayData();
        return;
      }
      // Extract sorting metadata
      const sortMeta = GenericSearchUtil.extractSortMeta(event);
      // Sort data based on criteria
      this.sortedData = GenericSearchUtil.sortData([...this.selectedItems], sortMeta);
      // Handle pagination
      const first = event.first || 0;
      const rows = event.rows || this.rowsPerPageOverlay;
      // Create paginated view
      this.currentPageData = this.sortedData.slice(first, first + rows);
      this.overlaySelectedItems = this.currentPageData;
    }
    resetOverlayData() {
      this.selectedItems = [];
      this.overlaySelectedItems = [];
      this.overlayItemsToSelect = [];
      this.totalRecords = 0;
    }
    /**
     * Gets tooltip text for row selection
     */
    getTableCheckboxTitle(row) {
      const isSelected = this.selectedItems.some(item => item.get(this.idColumn) === row.get(this.idColumn));
      const displayValue = row.getAt(0);
      if (isSelected) {
        return this.uiService.translate('common.deselectOf', displayValue);
      }
      return this.uiService.translate('genericSearch.selectItemOf', displayValue);
    }
    /**
     * Stores last URL before navigation
     */
    onBeforeNavigateDefaultRoute() {
      this.navigationService.setLastBackUrl(window.location.href);
    }
    /**
     * Updates selected items based on overlay selection
     */
    onUpdateTableSelectItems() {
      const rowsToDeselect = differenceWith(this.selectedItems, this.overlayItemsToSelect, isEqual);
      this.updateSelectedItems.emit(rowsToDeselect);
      this.display = false;
    }
    /**
     * Cancels any changes made in the overlay and reverts to the previous selection state.
     */
    onCancelOverlay() {
      this.display = false;
    }
    static {
      this.ɵfac = function HisSearchResultSelectedItemsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultSelectedItemsComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultSelectedItemsComponent,
        selectors: [["his-search-result-selected-items"]],
        inputs: {
          currentSearch: "currentSearch",
          selectedOptions: "selectedOptions",
          selectedOptionsIdColumn: "selectedOptionsIdColumn",
          idColumn: "idColumn",
          columns: "columns"
        },
        outputs: {
          updateSelectedItems: "updateSelectedItems"
        },
        standalone: false,
        decls: 14,
        vars: 19,
        consts: [["searchResultSelectTable", ""], ["id", "display", "type", "button", "hisImage", "CHECKBOX_TICK", 1, "transparent", 3, "click"], [3, "visibleChange", "visible", "responsive", "modal", "blockScroll"], ["sortMode", "multiple", 3, "selectionChange", "onLazyLoad", "value", "selection", "paginator", "rows", "rowHover", "rowsPerPageOptions", "totalRecords", "lazy"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["pTemplate", "footer"], [1, "fitToContent"], [3, "pSortableColumnDisabled", "pSortableColumn", "id"], [3, "field"], [1, "multiSelectColumn"], [3, "value", "ariaLabel", "title"], [3, "beforeNavigateDefaultRoute", "column", "columnIndex", "row", "rowId"], ["type", "button", 1, "p-button-primary", 3, "click"], ["type", "button", 1, "p-button-secondary", 3, "click"]],
        template: function HisSearchResultSelectedItemsComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 1);
            i0.ɵɵlistener("click", function HisSearchResultSelectedItemsComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOpenOverlay());
            });
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p-dialog", 2);
            i0.ɵɵtwoWayListener("visibleChange", function HisSearchResultSelectedItemsComponent_Template_p_dialog_visibleChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.display, $event) || (ctx.display = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementStart(4, "p-header")(5, "h2");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "p-table", 3, 0);
            i0.ɵɵtwoWayListener("selectionChange", function HisSearchResultSelectedItemsComponent_Template_p_table_selectionChange_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.overlayItemsToSelect, $event) || (ctx.overlayItemsToSelect = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onLazyLoad", function HisSearchResultSelectedItemsComponent_Template_p_table_onLazyLoad_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.load($event));
            });
            i0.ɵɵtemplate(10, HisSearchResultSelectedItemsComponent_ng_template_10_Template, 6, 3, "ng-template", 4)(11, HisSearchResultSelectedItemsComponent_ng_template_11_Template, 5, 3, "ng-template", 5)(12, HisSearchResultSelectedItemsComponent_ng_template_12_Template, 4, 4, "ng-template", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, HisSearchResultSelectedItemsComponent_ng_template_13_Template, 6, 6, "ng-template", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 15, "genericSearch.alreadySelectedItems"), " (", ctx.selectedOptions.length, ")\n");
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("visible", ctx.display);
            i0.ɵɵproperty("responsive", true)("modal", true)("blockScroll", true);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 17, "genericSearch.alreadySelectedItems"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.overlaySelectedItems);
            i0.ɵɵtwoWayProperty("selection", ctx.overlayItemsToSelect);
            i0.ɵɵproperty("paginator", true)("rows", ctx.rowsPerPageOverlay)("rowHover", true)("rowsPerPageOptions", ctx.rowsPerPageOptionsOverlay)("totalRecords", ctx.totalRecords)("lazy", true);
          }
        },
        dependencies: [i3$1.Table, i2.Header, i2.PrimeTemplate, i3$1.SortableColumn, i3$1.SortIcon, i3$1.TableCheckbox, i3.Dialog, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisSearchResultTableCellComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultSelectedItemsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchResultSelectButtonsComponent = /*#__PURE__*/(() => {
  class HisSearchResultSelectButtonsComponent {
    constructor() {
      this.selectAllItems = new EventEmitter();
      this.clearSelectedItems = new EventEmitter();
    }
    /**
     * Emits event to select all items
     */
    notifySelectAllItems() {
      this.selectAllItems.emit();
    }
    /**
     * Emits event to clear all selected items
     */
    notifyClearSelectedItems() {
      this.clearSelectedItems.emit();
    }
    static {
      this.ɵfac = function HisSearchResultSelectButtonsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultSelectButtonsComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultSelectButtonsComponent,
        selectors: [["his-search-result-select-buttons"]],
        outputs: {
          selectAllItems: "selectAllItems",
          clearSelectedItems: "clearSelectedItems"
        },
        standalone: false,
        decls: 8,
        vars: 6,
        consts: [["type", "button", "iconPos", "left", "hisImage", "TICK_MASS", 1, "transparent", 3, "click"], ["type", "button", "iconPos", "left", "hisImage", "PANEL_CLOSE", 1, "transparent", 3, "click"]],
        template: function HisSearchResultSelectButtonsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function HisSearchResultSelectButtonsComponent_Template_button_click_0_listener() {
              return ctx.notifySelectAllItems();
            });
            i0.ɵɵelementStart(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "button", 1);
            i0.ɵɵlistener("click", function HisSearchResultSelectButtonsComponent_Template_button_click_4_listener() {
              return ctx.notifyClearSelectedItems();
            });
            i0.ɵɵelementStart(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "genericSearch.selectAll"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 4, "genericSearch.clearSelectedItems"));
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultSelectButtonsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$r = ["rowAction"];
const _c1$a = ["searchResultTable"];
const _c2$5 = ["resultRowsPerPageComponent"];
const _c3$3 = [[["", "customResultButtons", ""]], [["", "customContentAboveTable", ""]], [["", "customResultButtonsAfterJobStarter", ""]], [["", "customContentBelowTable", ""]], [["", "customBottomResultButtons", ""]]];
const _c4$3 = ["[customResultButtons]", "[customContentAboveTable]", "[customResultButtonsAfterJobStarter]", "[customContentBelowTable]", "[customBottomResultButtons]"];
const _c5$2 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  first: a1,
  totalRecords: a2,
  rowsPerPage: a3
});
const _c6$2 = a0 => ({
  numberOfVisibleDataColumns: a0
});
const _c7$1 = (a0, a1) => ({
  index: a0,
  row: a1
});
function HisSearchResultComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 3);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("level", ctx_r0.headingLevelPageTitle)("value", i0.ɵɵpipeBind1(1, 2, ctx_r0.pageTitle));
  }
}
function HisSearchResultComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.newSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.newsearch"));
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.changeSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.changesearch"));
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.showPrintview());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "de.his.javang.printview"));
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-job-starter", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("key", ctx_r0.jobStarterKey)("search", ctx_r0.search)("searchConfigFile", ctx_r0.searchConfigFile)("selectedOptions", ctx_r0.selectedOptions);
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "his-search-result-selected-items", 27);
    i0.ɵɵlistener("updateSelectedItems", function HisSearchResultComponent_ng_template_3_Conditional_7_Template_his_search_result_selected_items_updateSelectedItems_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleUpdateSelectedItems($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "his-search-result-select-buttons", 28);
    i0.ɵɵlistener("selectAllItems", function HisSearchResultComponent_ng_template_3_Conditional_7_Template_his_search_result_select_buttons_selectAllItems_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleSelectAllItems());
    })("clearSelectedItems", function HisSearchResultComponent_ng_template_3_Conditional_7_Template_his_search_result_select_buttons_clearSelectedItems_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleClearSelectedItems());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("currentSearch", ctx_r0.searchToUseOverlay)("columns", ctx_r0.columns)("selectedOptions", ctx_r0.selectedOptions)("selectedOptionsIdColumn", ctx_r0.selectedOptionsIdColumn)("idColumn", ctx_r0.idColumn);
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 3);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(1, 2, ctx_r0.tableTitle));
    i0.ɵɵproperty("level", ctx_r0.headingLevelTableTitle);
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 29);
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_Conditional_12_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.toggleFilter();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.toggleTableFilter ? i0.ɵɵpipeBind1(4, 1, "de.his.faces.tags.table.tableFilter.disable") : i0.ɵɵpipeBind1(5, 3, "de.his.faces.tags.table.tableFilter.enable"));
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 13)(1, "his-search-result-config", 30);
    i0.ɵɵlistener("saved", function HisSearchResultComponent_ng_template_3_Conditional_13_Template_his_search_result_config_saved_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.reloadPage($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("configColumns", ctx_r0.configColumns)("showPaginator", ctx_r0.showPaginator)("paginatorPosition", ctx_r0.paginatorPosition)("defaultTablePageSize", ctx_r0.defaultTablePageSize)("minRows", ctx_r0.minRows)("maxRows", ctx_r0.maxRows)("userProfileKeyBasePath", ctx_r0.userProfileKeyBasePath);
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.resultRowsLimitedMessage, ctx_r0.maxResultRows));
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "his-search-result-search-info", 31)(2, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("queryParams", ctx_r0.queryParams)("searchConfigFile", ctx_r0.searchConfigFile);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "genericSearch.rowselect"));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 33)(1, "p-tableHeaderCheckbox", 35);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_2_Template_p_tableHeaderCheckbox_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.tableHeaderSelectedAll = !ctx_r0.tableHeaderSelectedAll);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 36);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r0.tableHeaderSelectedAll ? i0.ɵɵpipeBind1(2, 2, "genericSearch.deselectAllOfPage") : i0.ɵɵpipeBind1(3, 4, "genericSearch.selectAllOfPage"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, "genericSearch.rowselect"));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 37);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onFilterTable());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 38);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onResetFilter());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 4, "genericSearch.resultTable.tableFilter.resetFilter"));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template, 5, 6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "de.his.javang.aktionen"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.toggleTableFilter ? 3 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "p-sortIcon", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", column_r12.sortPath);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 42);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const column_r12 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.filter[column_r12.filterPath], $event) || (ctx_r0.filter[column_r12.filterPath] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const column_r12 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onFilter($event, column_r12));
    })("keydown.enter", function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(6);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.onFilterTable());
    })("click", function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_click_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.filter[column_r12.filterPath]);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template, 2, 4, "input", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r12.visible ? 1 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 39);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_3_Template, 2, 1, "span")(4, HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("pSortableColumnDisabled", !column_r12.sortable)("pSortableColumn", column_r12.sortPath)("id", column_r12.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 6, column_r12.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(column_r12.sortable ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.toggleTableFilter ? 4 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Template, 5, 8, "th", 39);
  }
  if (rf & 2) {
    const column_r12 = ctx.$implicit;
    i0.ɵɵconditional(column_r12.visible ? 0 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 37);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onFilterTable());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 38);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onResetFilter());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 4, "genericSearch.resultTable.tableFilter.resetFilter"));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template, 5, 6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "de.his.javang.aktionen"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.toggleTableFilter ? 3 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_1_Template, 3, 3, "th", 32)(2, HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_2_Template, 7, 8, "th", 33)(3, HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_3_Template, 4, 4, "th", 34);
    i0.ɵɵrepeaterCreate(4, HisSearchResultComponent_ng_template_3_ng_template_22_For_5_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(6, HisSearchResultComponent_ng_template_3_ng_template_22_Conditional_6_Template, 4, 4, "th");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.SingleSelect ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.MultiSelect || ctx_r0.doShowJobStarter ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsBefore ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsAfter ? 6 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customResultRowsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6$2, ctx_r0.numberOfVisibleDataColumns));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 32)(1, "button", 45);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r15);
      const row_r16 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.doSingleSelect(row_r16));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(2, 2, "common.assignOf", ctx_r0.getTooltipParam(row_r16)));
    i0.ɵɵproperty("hisImage", ctx_r0.hisIcon);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 33);
    i0.ɵɵelement(1, "p-tableCheckbox", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ariaLabel", ctx_r0.getTableCheckboxTitleForRow(row_r16));
    i0.ɵɵpropertyInterpolate("title", ctx_r0.getTableCheckboxTitleForRow(row_r16));
    i0.ɵɵproperty("value", row_r16);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 43);
    i0.ɵɵtemplate(1, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const row_r16 = ctx_r16.$implicit;
    const ri_r18 = ctx_r16.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rowAction)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c7$1, ri_r18, row_r16));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_For_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "his-search-result-table-cell", 47);
    i0.ɵɵlistener("beforeNavigateDefaultRoute", function HisSearchResultComponent_ng_template_3_ng_template_23_For_6_Conditional_0_Template_his_search_result_table_cell_beforeNavigateDefaultRoute_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onBeforeNavigateDefaultRoute());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const column_r21 = ctx_r19.$implicit;
    const ɵ$index_184_r22 = ctx_r19.$index;
    const ctx_r16 = i0.ɵɵnextContext();
    const row_r16 = ctx_r16.$implicit;
    const ri_r18 = ctx_r16.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rowId", row_r16.getAt(ctx_r0.idColumnIndex))("row", row_r16)("column", column_r21)("columnIndex", ɵ$index_184_r22)("ri", ri_r18)("defaultActionRoute", ctx_r0.defaultActionRoute)("defaultActionUrl", ctx_r0.defaultActionUrl)("showBackButton", ctx_r0.showBackButton)("isDefaultColumn", column_r21.id === ctx_r0.defaultColumn)("defaultActionToolTip", ctx_r0.defaultActionToolTip)("defaultActionRowRight", ctx_r0.defaultActionRowRight);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_23_For_6_Conditional_0_Template, 2, 11, "td");
  }
  if (rf & 2) {
    const column_r21 = ctx.$implicit;
    i0.ɵɵconditional(column_r21.visible ? 0 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 44);
    i0.ɵɵtemplate(1, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_7_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const row_r16 = ctx_r16.$implicit;
    const ri_r18 = ctx_r16.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rowAction)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c7$1, ri_r18, row_r16));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_0_Template, 1, 4, "ng-container");
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_2_Template, 3, 5, "td", 32)(3, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_3_Template, 2, 3, "td", 33)(4, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_4_Template, 2, 5, "td", 43);
    i0.ɵɵrepeaterCreate(5, HisSearchResultComponent_ng_template_3_ng_template_23_For_6_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(7, HisSearchResultComponent_ng_template_3_ng_template_23_Conditional_7_Template, 2, 5, "td", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ri_r18 = ctx.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ri_r18 === 0 ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.SingleSelect ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.MultiSelect || ctx_r0.doShowJobStarter ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsBefore ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsAfter ? 7 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customResultRowsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6$2, ctx_r0.numberOfVisibleDataColumns));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("colspan", 99);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "genericSearch.emptyResultPageAfterDelete"));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("colspan", 99);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "genericSearch.emptyResult"));
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_1_Template, 3, 4, "td")(2, HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_2_Template, 3, 4, "td");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.currentPageNumber > 1 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.currentPageNumber === 1 ? 2 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_0_Template, 1, 4, "ng-container")(1, HisSearchResultComponent_ng_template_3_ng_template_24_Conditional_1_Template, 3, 2, "tr");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.initialLoadFinished && ctx_r0.customResultRowsTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.initialLoadFinished && !ctx_r0.customResultRowsTemplate ? 1 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_25_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "his-search-result-rows-per-page", 48, 2);
    i0.ɵɵlistener("rowsPerPageInputChanged", function HisSearchResultComponent_ng_template_3_ng_template_25_Conditional_0_Template_his_search_result_rows_per_page_rowsPerPageInputChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.rowsPerPageChanged($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("resultRowsPerPage", ctx_r0.resultRowsPerPage)("rowsPerPage", ctx_r0.rowsPerPage)("maxRows", ctx_r0.maxRows)("resultRowsPerPage", ctx_r0.resultRowsPerPage)("totalRowCount", ctx_r0.totalRowCount)("currentPageNumber", ctx_r0.currentPageNumber)("totalNumberOfPages", ctx_r0.totalNumberOfPages);
  }
}
function HisSearchResultComponent_ng_template_3_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultComponent_ng_template_3_ng_template_25_Conditional_0_Template, 3, 7, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.totalRowCount > 0 ? 0 : -1);
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_29_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_Conditional_29_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.newSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.newsearch"));
  }
}
function HisSearchResultComponent_ng_template_3_Conditional_30_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function HisSearchResultComponent_ng_template_3_Conditional_30_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.changeSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.changesearch"));
  }
}
function HisSearchResultComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HisSearchResultComponent_ng_template_3_Conditional_1_Template, 4, 3, "button", 6)(2, HisSearchResultComponent_ng_template_3_Conditional_2_Template, 4, 3, "button", 7);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HisSearchResultComponent_ng_template_3_Conditional_4_Template, 2, 3, "button", 8);
    i0.ɵɵprojection(5, 1);
    i0.ɵɵtemplate(6, HisSearchResultComponent_ng_template_3_Conditional_6_Template, 1, 4, "his-job-starter", 9)(7, HisSearchResultComponent_ng_template_3_Conditional_7_Template, 3, 5, "div", 10);
    i0.ɵɵelementStart(8, "div")(9, "div", 11);
    i0.ɵɵtemplate(10, HisSearchResultComponent_ng_template_3_Conditional_10_Template, 2, 4, "his-heading", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵtemplate(12, HisSearchResultComponent_ng_template_3_Conditional_12_Template, 6, 5, "span")(13, HisSearchResultComponent_ng_template_3_Conditional_13_Template, 2, 7, "span", 13);
    i0.ɵɵprojection(14, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "div", 15);
    i0.ɵɵtemplate(17, HisSearchResultComponent_ng_template_3_Conditional_17_Template, 3, 4, "div", 16);
    i0.ɵɵelement(18, "div", 15);
    i0.ɵɵtemplate(19, HisSearchResultComponent_ng_template_3_Conditional_19_Template, 3, 2, "div");
    i0.ɵɵelementStart(20, "p-table", 17, 1);
    i0.ɵɵtwoWayListener("firstChange", function HisSearchResultComponent_ng_template_3_Template_p_table_firstChange_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.firstResultRow, $event) || (ctx_r0.firstResultRow = $event);
      return i0.ɵɵresetView($event);
    })("selectionChange", function HisSearchResultComponent_ng_template_3_Template_p_table_selectionChange_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.selectedRows, $event) || (ctx_r0.selectedRows = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onRowSelect", function HisSearchResultComponent_ng_template_3_Template_p_table_onRowSelect_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onRowSelect($event));
    })("onRowUnselect", function HisSearchResultComponent_ng_template_3_Template_p_table_onRowUnselect_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onRowUnselect($event));
    })("onHeaderCheckboxToggle", function HisSearchResultComponent_ng_template_3_Template_p_table_onHeaderCheckboxToggle_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onHeaderCheckboxToggle($event));
    })("onLazyLoad", function HisSearchResultComponent_ng_template_3_Template_p_table_onLazyLoad_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.load($event));
    })("onPage", function HisSearchResultComponent_ng_template_3_Template_p_table_onPage_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const searchResultTable_r9 = i0.ɵɵreference(21);
      const ctx_r0 = i0.ɵɵnextContext();
      ctx_r0.onPage($event);
      return i0.ɵɵresetView(searchResultTable_r9 == null ? null : searchResultTable_r9.el == null ? null : searchResultTable_r9.el.nativeElement == null ? null : searchResultTable_r9.el.nativeElement.scrollIntoView({
        block: "start",
        behavior: "smooth"
      }));
    });
    i0.ɵɵtemplate(22, HisSearchResultComponent_ng_template_3_ng_template_22_Template, 7, 4, "ng-template", 18)(23, HisSearchResultComponent_ng_template_3_ng_template_23_Template, 8, 5, "ng-template", 19)(24, HisSearchResultComponent_ng_template_3_ng_template_24_Template, 2, 2, "ng-template", 20)(25, HisSearchResultComponent_ng_template_3_ng_template_25_Template, 1, 1, "ng-template", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(26, 3);
    i0.ɵɵprojection(27, 4);
    i0.ɵɵelementStart(28, "div", 22);
    i0.ɵɵtemplate(29, HisSearchResultComponent_ng_template_3_Conditional_29_Template, 4, 3, "button", 23)(30, HisSearchResultComponent_ng_template_3_Conditional_30_Template, 4, 3, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showNewSearchButton ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showChangeSearchButton ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.searchShowPrintviewButton ? 4 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.doShowJobStarter ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.MultiSelect || ctx_r0.doShowJobStarter ? 7 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.tableTitle ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showTableFilter ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showTableConfig ? 13 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.resultRowsLimitedMessage ? 17 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showSearchInfo ? 19 : -1);
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(ctx_r0.resultTableStyle);
    i0.ɵɵproperty("value", ctx_r0.rows)("paginator", ctx_r0.showPaginator)("paginatorPosition", ctx_r0.paginatorPosition)("totalRecords", ctx_r0.totalRowCount)("lazy", true)("rowHover", true)("compareSelectionBy", "equals")("rows", ctx_r0.rowsPerPage);
    i0.ɵɵtwoWayProperty("first", ctx_r0.firstResultRow)("selection", ctx_r0.selectedRows);
    i0.ɵɵproperty("lazyLoadOnInit", !ctx_r0.isSearchPopup);
    i0.ɵɵadvance(9);
    i0.ɵɵconditional(ctx_r0.showNewSearchButton ? 29 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showChangeSearchButton ? 30 : -1);
  }
}
let HisSearchResultComponent = /*#__PURE__*/(() => {
  class HisSearchResultComponent {
    constructor() {
      this.baseGlobalService = inject(HisBaseGlobalsService);
      this.searchService = inject(HisSearchService);
      this.navigationService = inject(HisNavigationService);
      this.route = inject(ActivatedRoute);
      this.router = inject(Router);
      this.authService = inject(HisAuthService);
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      this.userProfileService = inject(HisUserProfileService);
      this.rowsPerPageService = inject(HisSearchRowsPerPageService);
      /**
       * The pathname of 'window.location.pathname' as substitute for missing tableId.<br/>
       * It is required when saving table config items at the user profile.<br/>
       * Usage: HisStringUtils.getHashCode(this.pathname + this.searchConfigFile);
       */
      this.PATHNAME = window.location.pathname;
      this.DEFAULT_PAGE_SIZE = 10;
      this.showTitle = true;
      this.showNewSearchButton = true;
      this.showChangeSearchButton = true;
      this.doShowJobStarter = false;
      this.showBackButton = false;
      this.searchShowPrintviewButton = true;
      // true if the rendered page contains both the search form and the search result
      this.isSearchFormResult = false;
      // true if this is a search popup. In that case we don't want to register the url for the "back to search result" button.
      this.isSearchPopup = false;
      // Used to determine the relevant UI elements
      this.selectionSettingEnum = HisSearchSelectionSetting;
      this.selectionSetting = HisSearchSelectionSetting.NoSelect;
      // The rows of the search result that are selected.
      // They may have an 'id' property, or selectedOptionsIdColumn must define the property that serves as id.
      this.selectedOptions = [];
      this.selectedOptionsIdColumn = undefined;
      // selectedOptionsLabelColumn is used as the label of selected rows in the his-search-select component.
      this.selectedOptionsLabelColumn = undefined;
      this.hisIcon = 'arrow_left';
      // the rows of the current search result page
      this.rows = [];
      // the rows on the current search result page that are selected
      this.selectedRows = [];
      // the number of result rows per page (is read from and written to UserProfile)
      this.resultRowsPerPage = this.DEFAULT_PAGE_SIZE;
      // for intern usage isted of resultRowsPerPage
      this.rowsPerPage = clone(this.resultRowsPerPage);
      // the first result row to display
      this.firstResultRow = 0;
      // the total number of row results, not just those on the current page
      this.totalRowCount = 0;
      // value of URL parameter page
      this.pageFromUrl = undefined;
      // current page, starting at 1
      this.currentPageNumber = 1;
      // The number of result rows has been restricted by the search configuration if != null
      this.resultRowsLimitedMessage = undefined;
      // limits the number of search result rows
      this.maxResultRows = undefined;
      // metadata describing the columns of the search result
      this.columns = [];
      // configColumns dienen ausschließlich dazu die Checkboxen in 'Tabelle anpassen' zu steuern
      this.configColumns = [];
      this.radioButtonGroups = {};
      // To hide the 'no data' message until the search result has been loaded
      this.initialLoadFinished = false;
      this.finishedInitialLoad = new EventEmitter();
      this.singleSelectionSubmited = new EventEmitter();
      // if true, the current url will be ignored for backToSearchResultButton
      this.ignoreForBackToSearchResultNavigation = false;
      this.isNotActiveSearch = false;
      this.isExtended = false;
      // notifying embedding components allows them to manipulate the data after it was loaded
      this.rowsChanged = new EventEmitter();
      this.showSearchInfo = true;
      this.showTableFilter = true;
      // TODO toggleTableFilter und onToggleFilter eventuell zu einer Variablen zusammenfassen
      this.toggleTableFilter = false;
      this.filterToggled = new EventEmitter();
      this.filter = {};
      this.showTableConfig = true;
      /** linke Aktionenspalte anzeigen */
      this.showActionsBefore = true;
      /** rechte Aktionenspalte anzeigen */
      this.showActionsAfter = true;
      /** falls false wird kein Paginator angezeigt */
      this.showPaginator = true;
      this.paginatorPosition = 'bottom';
      this.paginator = this.showPaginator;
      /** Constant to name the action colum before other table colums */
      this.ACTIONS_BEFORE = 'ActionsBefore';
      /** Constant to name the action colum after other table colums */
      this.ACTIONS_AFTER = 'ActionsAfter';
      /** Zeilen pro Seite untere Grenze */
      this.minRows = 1;
      /** Maximale Anzahl von Zeile pro Seite: Zeilen pro Seite (Max:maxRows) */
      this.maxRows = 300;
      this.loadLastSortOrder = true;
      this.tableHeaderSelectedAll = false;
      this.entriesIds = []; // IDs extracted from the search results.
      console.log('HisSearchResultComponent.construct()');
    }
    ngOnInit() {
      this.headingLevelPageTitle = (this.hierarchyLevel ?? 0) + 1;
      this.headingLevelTableTitle = (this.hierarchyLevel ?? 0) + 2;
      this.setUserProfileBasePath();
      // Remember queryParams for jump back to search page via "Suche ändern"
      this.queryParams = this.route.snapshot.queryParams;
      console.log('HisSearchResultComponent.ngOnInit(): queryParams=', this.queryParams);
      let isFlatObjectFormat = HisQueryParamUtils.isFlatObjectFormat(this.queryParams);
      // If we are on a simple search result page not including the search form, then
      // derive searchConfigFile, pageTitle, tableTitle and searchData from queryParams.
      if (this.queryParams && !this.isSearchFormResult) {
        console.log('Init search result with queryParams =', this.queryParams);
        let searchItems = [];
        for (let key of Object.keys(this.queryParams)) {
          switch (key) {
            // searchConfigFile, pageTitle and tableTitle etc. are taken from queryParams
            // only when given; otherwise they may have been set via @Input
            case HisSearchNonCriteriaUrlParam.CONFIG_FILE:
              this.searchConfigFile = this.queryParams.configFile;
              break;
            case HisSearchNonCriteriaUrlParam.PAGE_TITLE:
              this.pageTitle = this.queryParams.pageTitle;
              break;
            case HisSearchNonCriteriaUrlParam.TABLE_TITLE:
              this.tableTitle = this.queryParams.tableTitle;
              break;
            case HisSearchNonCriteriaUrlParam.IS_NO_SEARCH_ACTIVE:
              this.isNotActiveSearch = this.queryParams.isNotActiveSearch;
              break;
            // showChangeSearchButton needs conversion from string to boolean.
            // Since its default value is true, we set it to true whenever the string is not equal to 'false'.
            case HisSearchNonCriteriaUrlParam.SHOW_CHANGE_SEARCH_BUTTON:
              this.showChangeSearchButton = this.queryParams.showChangeSearchButton !== 'false';
              break;
            // showBackButton
            case HisSearchNonCriteriaUrlParam.SHOW_BACK_BUTTON:
              this.showBackButton = this.queryParams.showBackButton !== 'false';
              break;
            // page could be passed by URL by "Suche ändern"
            case HisSearchNonCriteriaUrlParam.PAGE:
              {
                // currentPageNumber muss hier evtl. nicht notwendigerweise gesetzt werden
                this.pageFromUrl = this.currentPageNumber = Number(this.queryParams.page);
                if (isNaN(this.pageFromUrl)) {
                  this.currentPageNumber = 1;
                  this.pageFromUrl = undefined;
                }
                // Hier würden wir auch gern firstResultRow setzen, damit die p-table-Komponente
                // diesen In-/Output richtig aktualisiert, event.first beim Aufruf von load()
                // richtig setzt, und wir daraus currentPageNumber korrekt ableiten können.
                // Das geht aber leider nicht, weil die Berechnung von firstResultRow die Variable
                // rowsPerPage benötigt, die aus dem UserProfile geladen wird. Wenn wir das hier machen
                // würden, dann würden wir einen ExpressionChangedAfterItHasBeenCheckedError bekommen.
                // Also müssen wir uns in load() ein bisschen mehr Mühe geben, um all diese Variablen
                // richtig zu setzen.
                break;
              }
            case HisSearchNonCriteriaUrlParam.EXTENDED:
              this.isExtended = true;
              break;
            // see hiszilla #259078
            case HisSearchNonCriteriaUrlParam.NAVIGATION_POSITION:
              this.navigationPosition = this.queryParams.navigationPosition;
              break;
            // blacklisted keys are ignored, see #192323, #212551, #249099
            case HisSearchNonCriteriaUrlParam.NO_DB_ACTION:
            case HisSearchNonCriteriaUrlParam.INIT:
            case HisSearchNonCriteriaUrlParam.CHOC:
            case HisSearchNonCriteriaUrlParam.MODE:
              break;
            default:
              // All other parameters are permitted. Keys added by URL manipulation (#223241) are filtered in the backend
              // Update: key value pairs are now transmitted as part of a flat object
              // group0.criteria0.field = person.gender.id
              // group0.criteria0.value = 2
              if (!isFlatObjectFormat) {
                continue;
              }
              searchItems.push(new HisSearchItem(key, this.queryParams[key]));
          }
        }
        if (isFlatObjectFormat) {
          console.log('his-search-result.component#ngOnInit()', '#is flat object url format');
          this.search = HisSearchParser.decode(searchItems);
          this.search.configFile = this.searchConfigFile;
        } else {
          console.log('his-search-result.component#ngOnInit()', '#is key value url format or empty search');
          // Es ist eine leere Suche oder eine alte URL im key value Format
          // hierfür ist eine Auswertung der Gruppen aus der Suchkonfiguration nicht notwendig,
          // deshalb ist group.label = 'default',
          // da die Gruppen nicht bekannt sind, wird für alle Suchkriterien in Search nur diese eine Gruppe erzeugt,
          // also können auch keine URL mit Suchkriterien für Kriteriengruppen ausgewertet werden.
          let newQueryParams = {};
          if (this.navigationPosition) {
            newQueryParams.navigationPosition = this.navigationPosition;
          }
          this.search = HisSearchParserHelper.convertOldUrlParamsToHisSearch(this.queryParams, this.searchConfigFile);
          let searchParams = HisSearchParserHelper.convertHisSearchToFlatObjectFormatParams(this.search);
          for (let key of Object.keys(searchParams)) {
            newQueryParams[key] = searchParams[key];
          }
          if (this.isExtended) {
            newQueryParams.extended = true;
          }
          this.queryParams = newQueryParams;
        }
        console.log('his-search-result.component#ngOnInit()', '#this.search', this.search);
        if (isDevMode()) {
          console.log('Search Config File: \'' + this.searchConfigFile + '\'');
          console.log('Search Page Title: \'' + this.pageTitle + '\'');
          console.log('Search Table Title: \'' + this.tableTitle + '\'');
          console.log('ShowChangeSearchButton: \'' + this.showChangeSearchButton + '\'');
          console.log('Search Parameters:', this.search);
        }
      }
      // If this is not a popup search then register the current url for "back to search result" button
      console.log('Init search result: isSearchPopup =', this.isSearchPopup);
      if (!this.isSearchPopup) {
        if (isFlatObjectFormat) {
          let url = window.location.href;
          if (url.indexOf('&page=') < 0) {
            url += '&page=' + this.currentPageNumber.toString();
          }
          console.log('his-search-result.component#ngOnInit()', '#Register search result url (flat object format)', url);
          if (!this.isNotActiveSearch && !this.ignoreForBackToSearchResultNavigation) {
            this.navigationService.setSearchResultUrl(url);
          }
        } else {
          // Url in neues Format Konvertieren
          let queryParams = Object.create(this.queryParams);
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge',
            // preserve the existing query params in the route
            skipLocationChange: true
            // do not trigger navigation
          });
          let url = window.location.href;
          if (!this.isNotActiveSearch && !this.ignoreForBackToSearchResultNavigation) {
            console.log('his-search-result#ngOnInit()', '# !this.isNotActiveSearch', !this.isNotActiveSearch);
            this.navigationService.setSearchResultUrl(url);
          }
          console.log('his-search-result#ngOnInit()', '#url', this.router.url);
        }
      }
      this.doShowJobStarter = this.showJobStarter();
      this.pageSizeKey = this.getUserProfileByKey(HisUserProfileConstants.PAGE_SIZE);
      this.showTableFilterKey = this.getUserProfileByKey(HisUserProfileConstants.SHOW_TABLE_FILTER);
      console.log('his-search-result.component#ngOnInit() #isAnonymous', this.authService.isAnonymous);
      console.log('his-search-result.component#ngOnInit() #this.rowsPerPage', this.rowsPerPage);
      if (this.showTableConfig) {
        this.initTableConfigUserProfileValues();
      }
      if (this.loadLastSortOrder) {
        HisSearchResultColumnSortHelper.createSortCriteriaBySessionStorageValues(HisSearchResultColumnSortHelper.getSortedSortOrderKeyFromSessionStorage());
      }
      // Filter-Kriterien aus URL bzw. searchParams übernehmen zum Anzeigen,
      // z. B. nach Rückkehr aus einer Detailansicht
      this.extracFilterCriteriaFromParams();
    }
    getTooltipTableHeader() {
      console.log('getTooltipTableHeader tableHeaderSelectedAll: ', this.tableHeaderSelectedAll);
      return this.uiService.translate('genericSearch.selectAllOfPage');
    }
    /** get tooltip for the entry of a given row */
    getTableCheckboxTitleForRow(row) {
      /* console.log( 'his-search-result.component#getTableCheckboxTitleForRow( row: HisSearchResultRow )' +
          'rowTooltipId: ', rowTooltipId); */
      if (this.selectedRows.indexOf(row) > -1) {
        return this.uiService.translate('common.deselectOf', this.getTooltipParam(row));
      } else {
        return this.uiService.translate('genericSearch.selectItemOf', this.getTooltipParam(row));
      }
    }
    getTooltipSelectedAllOfPage() {
      console.log('this.tableHeaderSelectedAll: ', this.tableHeaderSelectedAll);
      let whichUiKey = this.tableHeaderSelectedAll === true ? 'genericSearch.deselectAllOfPage' : 'genericSearch.selectAllOfPage';
      console.log('whichUiKey: ', whichUiKey);
      return this.uiService.translate(whichUiKey);
    }
    getTooltipParam(row) {
      return this.rowTooltipGeneratorMethod ? this.rowTooltipGeneratorMethod(row) : row.get(this.getRowTooltipId());
    }
    /** get genericSearchTooltipId. As default search for Id containg defaulttext or title */
    getRowTooltipId() {
      if (this.genericSearchRowTooltipId) {
        return this.genericSearchRowTooltipId;
      } else {
        let columnWithDefaulttextOrTitle = this.columns.find(c => c.id.includes('defaulttext') || c.id.includes('title'));
        if (columnWithDefaulttextOrTitle) {
          return columnWithDefaulttextOrTitle.id;
        }
      }
      return '';
    }
    initTableConfigUserProfileValues() {
      console.log('his-search-result.component#initTableConfigUserProfileValues()' + ' #this.rowsPerPage #onEntry', this.rowsPerPage);
      console.log('his-search-result.component#initTableConfigUserProfileValues()' + ' #this.resultRowsPerPage #onEntry', this.resultRowsPerPage);
      if (this.authService.isAnonymous) {
        this.getRowsPerPageFormSessionStorageOrDefault();
        // showTableFilter aus Browser Cache laden
        let showTableFilterKeyFromSessionStorage = sessionStorage.getItem(this.showTableFilterKey);
        if (showTableFilterKeyFromSessionStorage) {
          console.log('his-search-result.component#initTableConfigUserProfileValues() #showTableFilter', showTableFilterKeyFromSessionStorage);
          this.toggleTableFilter = true;
          this.filterToggled.emit(true);
        } else {
          this.toggleTableFilter = false;
          this.filterToggled.emit(false);
        }
        this.firstResultRow = (this.currentPageNumber - 1) * this.rowsPerPage;
      } else {
        this.rowsPerPageService.getPageSizeFromUserProfile(this.pageSizeKey, this.resultRowsPerPage).subscribe(result => {
          if (result) {
            this.rowsPerPage = result;
          }
        });
        this.userProfileService.getValueforKey(this.showTableFilterKey).subscribe(filter => {
          if (filter) {
            console.log('his-search-result.component#initTableConfigUserProfileValues() #showTableFilter', filter);
            this.toggleTableFilter = true;
            this.filterToggled.emit(true);
          } else {
            console.log('his-search-result.component#initTableConfigUserProfileValues() #showTableFilter', '\'null\' (no userProfile entry)');
            this.toggleTableFilter = false;
            this.filterToggled.emit(false);
          }
        });
      }
    }
    /**
     * Select a single row from the result table.
     *
     * @param selection the selected row
     */
    doSingleSelect(selection) {
      console.log('HisSearchResultComponent.doSingleSelect(): selection =', selection);
      console.log('HisSearchResultComponent.doSingleSelect(): selectedOptionsLabelColumn =', this.selectedOptionsLabelColumn);
      let id = selection.get(this.selectedOptionsIdColumn);
      // If selectedOptionsLabelColumn is undefined we take the first column of the result table.
      // See comment in HisWidgetService...
      let label = this.selectedOptionsLabelColumn ? selection.get(this.selectedOptionsLabelColumn) : selection.getAt(0);
      console.log('Submit single-selection:', selection);
      this.singleSelectionSubmited.emit(selection.toFlatSearchResultRow(id, label));
    }
    /**
     * Set selectedOptions, selectedOptionsIdColumn and selectedOptionsLabelColumn.
     *
     * @param selectedOptions The new selection
     * @param selectedOptionsIdColumn The identifier of the column containing the id of a dataset
     * @param selectedOptionsLabelColumn The identifier of the column containing the label of a dataset
     */
    setSelectedOptions(selectedOptions, selectedOptionsIdColumn, selectedOptionsLabelColumn) {
      // calculateSelectedRows() needs this.selectedOptionsIdColumn, so we initialize the latter first
      if (selectedOptionsIdColumn) {
        console.log('HisSearchResultComponent.setSelectedOptions(): set selectedOptionsIdColumn = ' + selectedOptionsIdColumn);
        this.selectedOptionsIdColumn = selectedOptionsIdColumn;
      } else {
        console.warn('HisSearchResultComponent.setSelectedOptions(): selectedOptionsIdColumn is undefined!');
      }
      console.log('HisSearchResultComponent.setSelectedOptions(): set selectedOptionsLabelColumn = ' + selectedOptionsLabelColumn);
      if (selectedOptionsLabelColumn) {
        this.selectedOptionsLabelColumn = selectedOptionsLabelColumn;
      }
      this.selectedOptions = selectedOptions ? selectedOptions.slice(0) : [];
      try {
        this.calculateSelectedRows();
      } catch (e) {
        console.error('calculateSelectedRows Error:', e);
      }
    }
    /**
     * Compute the selectedRows which PrimeNgs p-table compares to all rows to find out which of the latter must be checked.
     */
    calculateSelectedRows() {
      this.selectedRows = [];
      if (this.selectedOptions && this.selectedOptions.length > 0) {
        console.log('HisSearchResultComponent.calculateSelectedRows(): number of selectedOptions = ', this.selectedOptions.length);
        let row;
        for (row of this.rows) {
          let rowId = row.get(this.selectedOptionsIdColumn);
          let selectedOption;
          for (selectedOption of this.selectedOptions) {
            // The "===" operator does not work having arguments of type string and number
            // -> convert both sides to string before the comparison
            let optionId = selectedOption.id;
            // console.log( 'rowId=', rowId, '(', typeof rowId, '), optionId=', optionId, '(', typeof optionId, ')' );
            if (rowId?.toString() === optionId.toString()) {
              this.selectedRows.push(row);
              break;
            }
          }
        }
      } else {
        console.log('HisSearchResultComponent.calculateSelectedRows(): There are no selectedOptions.');
      }
    }
    onRowSelect(event) {
      this.selectRow(event.data);
      if (isDevMode()) {
        console.log('> Selected rows: ' + JSON.stringify(this.selectedOptions));
      }
    }
    selectRow(selectedRow) {
      let selectedOptionId = selectedRow.get(this.selectedOptionsIdColumn);
      let selectedOptionIndex = this.getIndexOfSelectedOptionById(selectedOptionId);
      if (selectedOptionIndex < 0) {
        let label;
        if (this.selectedOptionsLabelColumn) {
          label = selectedRow.get(this.selectedOptionsLabelColumn);
          console.log('HisSearchResultComponent.onRowSelect(): selectedOptionsLabelColumn = ' + this.selectedOptionsLabelColumn + ', label = "' + label + '"');
        } else {
          label = selectedRow.getAt(0);
          console.warn('HisSearchResultComponent.onRowSelect(): selectedOptionsLabelColumn is undefined, ' + 'label taken from first column = "' + label + '"');
        }
        this.selectedOptions.push(selectedRow.toFlatSearchResultRow(selectedOptionId, label));
      } else {
        // Reselecting a row can happen when the header checkbox is clicked
        console.log('Ignore row select event for row', selectedRow, 'which was already selected before.');
      }
    }
    onRowUnselect(event) {
      this.deselectRow(event.data);
      if (isDevMode()) {
        console.log('> Selected rows: ' + JSON.stringify(this.selectedOptions));
      }
    }
    deselectRow(deselectedRow) {
      let selectedOptionId = deselectedRow.get(this.selectedOptionsIdColumn);
      let selectedOptionIndex = this.getIndexOfSelectedOptionById(selectedOptionId);
      if (selectedOptionIndex >= 0) {
        this.selectedOptions.splice(selectedOptionIndex, 1);
      }
      this.selectedOptions = [...this.selectedOptions];
    }
    getIndexOfSelectedOptionById(id) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        let optionId = this.selectedOptions[i].id;
        // console.log( '222: id=', id, '(', typeof id, '), optionId=', optionId, '(', typeof optionId, ')' );
        if (id.toString() === optionId.toString()) {
          return i;
        }
      }
      return -1;
    }
    /**
     * Event triggered by a click in the "header checkbox" of the result table.
     *
     * @param event event
     */
    onHeaderCheckboxToggle(event) {
      let checked = event.checked;
      console.log('header checkbox toggle event: ', event, ', checked =', checked);
      if (checked) {
        // select all items on the page (we could have an extra button to select all elements in total)
        for (let row of this.rows) {
          this.selectRow(row);
        }
      } else {
        // deselect all items on the page
        for (let row of this.rows) {
          this.deselectRow(row);
        }
      }
      if (isDevMode()) {
        console.log('> Selected rows: ' + JSON.stringify(this.selectedOptions));
      }
    }
    /**
     * Called when pagination occurs.
     * event.first is the index of first record in page.
     */
    onPage(event) {
      // adjusting the URL is not necessary when search and search result are on the same page (popup)
      if (!this.isSearchPopup) {
        console.log('HisSearchResultComponent.onPage(): first = ', event.first);
        this.firstResultRow = event.first;
        this.currentPageNumber = 1 + this.firstResultRow / this.rowsPerPage;
        // page in der gespeicherten URL aktualisieren
        let url = this.replacePageNumberInURL();
        console.log('Register modified search result url', url);
        // fix "Zurück zum Suchergebnis" button
        if (!this.isNotActiveSearch && !this.ignoreForBackToSearchResultNavigation) {
          this.navigationService.setSearchResultUrl(url);
        }
        // fix "Zurück" button from his-dialog-header
        window.history.replaceState('', '', url);
      }
    }
    replacePageNumberInURL() {
      let url = window.location.href;
      // console.log('original url =', url);
      let pagePos = url.indexOf('&page=');
      if (pagePos < 0) {
        return url + '&page=' + this.currentPageNumber.toString();
      } else {
        let url2 = url.substring(0, pagePos + 6) + this.currentPageNumber.toString();
        let afterPagePos = url.indexOf('&', pagePos + 6);
        if (afterPagePos >= 0) {
          url2 += url.substring(afterPagePos);
        }
        return url2;
      }
    }
    /**
     * Builds a session storage key with the suffix of the column to be sorted.
     *
     * @param colField Name of the field to be sorted.
     * @returns a session storage key.
     */
    getSortCriterionSessionStorageKey(colField) {
      return HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER + '_' + colField;
    }
    load(event) {
      console.log('his-search-result.component#load event! searchConfigFile =', this.searchConfigFile, ', this.search =', this.search, ', event =', event);
      if (event.multiSortMeta) {
        this.multiSortMeta = event.multiSortMeta;
        console.log('his-search-result.component#load() #multiSortMeta', this.multiSortMeta);
        console.log('his-search-result.component#load() #event', event);
        HisSearchResultColumnSortHelper.sortCriteria = [];
        let colOrder = 1;
        HisSearchResultColumnSortHelper.removeAllSessionStorageKeysContainingSortOrder();
        for (let colToSort of this.multiSortMeta) {
          let ascending = colToSort.order > 0 ? true : false;
          let sortCriterion = new HisSortCriteria(colToSort.field, ascending);
          console.log('his-search-result.component#load() #sortCriterion', sortCriterion);
          HisSearchResultColumnSortHelper.sortCriteria.push(sortCriterion);
          //Stores the sortorder in the session storage
          sessionStorage.setItem(this.getSortCriterionSessionStorageKey(colToSort.field), HisSearchResultColumnSortHelper.convert(colToSort.order) + HisSearchResultColumnSortHelper.SPEPERATOR + colOrder);
          colOrder++;
        }
      }
      // Saves the sortCriteria in a variable named sortCriteriaToLoadInTableFilter
      // to be able to reload the sort order when filtering tables
      HisSearchResultColumnSortHelper.setSafedSortCriteria(HisSearchResultColumnSortHelper.sortCriteria);
      HisSearchResultColumnSortHelper.sortCriteria = [];
      // Loads the page with stored sortCriteria
      this.loadPage(event.first, undefined, event.sortField, event.sortOrder, HisSearchResultColumnSortHelper.getSafedSortCriteria());
    }
    loadPage(start, search, sortField, sortOrder, sortCriteria) {
      console.log('his-search-result.component#loadPage() #start', start, '#sortField', sortField, 'sortOrder', sortOrder);
      console.log('his-search-result.component#loadPage() #this.resultRowsPerPage', this.rowsPerPage);
      console.log('his-search-result.component#loadPage() #search #search', search);
      let searchToUse;
      if (search) {
        searchToUse = cloneDeep(search);
        this.search = cloneDeep(searchToUse);
      } else if (this.search) {
        searchToUse = cloneDeep(this.search);
      } else {
        if (isDevMode()) {
          this.notificationService.error(this.uiService.translate('Kein gültiges HisSearch Objekt vorhanden: HisSearch = ' + searchToUse + ' searchConfigFile = ' + this.searchConfigFile), this.uiService.translate('view.messages.error'));
        }
      }
      searchToUse = HisSearchParserHelper.removeDefaultGroupFromSearchIfOtherGroupIsPresent(searchToUse);
      console.log('his-search-result.component#loadPage() #search #searchToUse', searchToUse);
      // Hier wird rowsPerPage aus dem UserProfile geholt!
      this.calculateRowsPerPage(this).subscribe(pageSize => {
        console.log('his-search-result.component#loadPage() #pageSize1', pageSize);
        if (pageSize) {
          this.rowsPerPage = pageSize;
          // #265099: Für 'offset' muss der url parameter 'page' ausgewertet werden.
          // Dies kann erst hier geschehen, da zur Berechnung die pageSize benötigt wird,
          // die aus dem UserProfile geladen werden musste.
          // #287499 wurde durch Verwendung von pageFromUrl korrigiert.
          let offset;
          if (this.pageFromUrl) {
            offset = (this.pageFromUrl - 1) * pageSize;
            // pageFromUrl muss und darf nur benutzt werden wenn auch ngOnInit() ausgeführt wurde.
            // Wenn wir in der Komponente bleiben, z.B. beim Blättern, dann müssen wir event.first aus
            // p-table benutzen. Also löschen wir die Variable nach jeder Verwendung:
            this.pageFromUrl = undefined;
            console.log('his-search-result.component#loadPage(): offset from page URL parameter =', offset);
          } else {
            offset = start;
            console.log('his-search-result.component#loadPage(): offset from start =', offset);
          }
          this.configColumns = [];
          this.showActionsBefore = true;
          this.showActionsAfter = true;
          if (this.showPaginator) {
            this.loadPaginatorPosition();
          }
          let sortStr = '';
          if (sortField) {
            sortStr = ' (sort: ' + sortField;
            if (sortOrder) {
              sortStr += sortOrder > 0 ? 'asc' : 'desc';
            }
            sortStr += ')';
          }
          console.log('Request loading search result rows ' + (start + 1) + '..' + (start + this.rowsPerPage) + sortStr + ' from \'' + this.searchConfigFile + '\' ...');
          console.log('his-search-result.component#loadPage() #sortCriteria', sortCriteria);
          this.searchService.loadSearchResult(searchToUse, offset, this.rowsPerPage, sortCriteria).subscribe(searchResult => {
            //Wenn searchResult aufgrunf von offset null ist, liegt es daran, dass die angegebene Seite größer als das Suchergebnis ist.
            //Daher findet hier eine Weiterleitung auf die erste Seite des Suchergenisses statt #287394
            this.searchToUseOverlay = searchToUse;
            if (!searchResult && offset !== 0 || searchResult.limit === 0 && offset !== 0) {
              this.searchService.loadSearchResult(searchToUse, 0, this.rowsPerPage, sortCriteria).subscribe(newSearchResult => {
                if (newSearchResult) {
                  this.notificationService.infoI18n('genericSearch.notExistingPageInSearchResult', this.currentPageNumber);
                  this.createSearchResult(1, newSearchResult, searchToUse, sortField, sortOrder);
                  this.currentPageNumber = 1;
                }
              });
            } else {
              this.createSearchResult(start, searchResult, searchToUse, sortField, sortOrder);
            }
          }, error => {
            console.log(error);
          });
        } else {
          this.firstResultRow = (this.currentPageNumber - 1) * this.rowsPerPage;
        }
      });
    }
    createSearchResult(start, searchResult, searchToUse, sortField, sortOrder) {
      console.log('start =', start, ', searchResult.offset =', searchResult.offset);
      console.log('rowsPerPage =', this.rowsPerPage, ', searchResult.limit =', searchResult.limit);
      console.log('searchResult.maxResultRows =', searchResult.maxResultRows);
      console.log('searchToUse', searchToUse);
      // Has the limit been reduced by the search configuration?
      if (searchResult.maxResultRows > 0) {
        // show info message that resultRowsPerPage has been restricted by search config.
        this.resultRowsLimitedMessage = 'cs.sys.genericSearch.resultRowsLimitedByConfiguration';
        this.maxResultRows = searchResult.maxResultRows;
      }
      console.log('Loaded search result for \'' + searchResult.name + '\' (rows ' + (searchResult.offset + 1) + '..' + (searchResult.offset + searchResult.limit) + ' of ' + searchResult.totalCount + ', with ' + searchResult.columns.length + ' columns).');
      // for ( let i = 0; i < searchResult.columns.length; i++ ) {
      //    console.log(searchResult.columns[i]);
      // }
      this.columns = cloneDeep(searchResult.columns);
      console.log('his-search-result.component#loadPage() #this.columns', this.columns);
      this.processTableConfigCols(this);
      this.numberOfDataColumns = this.columns.length;
      this.numberOfVisibleDataColumns = this.columns.filter(column => column.visible).length;
      this.rows = searchResult.data;
      for (let row of this.rows) {
        row.metadata = this.columns;
      }
      this.firstResultRow = searchResult.offset;
      this.totalRowCount = searchResult.totalCount;
      // currentPageNumber muss hier wohl nicht neu berechnet werden
      // falls doch, dann: this.currentPageNumber = 1 + offset / this.rowsPerPage;
      // this.currentPageNumber = 1 + start / this.rowsPerPage;
      this.totalNumberOfPages = Math.ceil(this.totalRowCount / this.rowsPerPage);
      console.log('his-search-result.component#loadPage() #result #firstResultRow', this.firstResultRow);
      console.log('his-search-result.component#loadPage() #result #currentPageNumber', this.currentPageNumber);
      console.log('his-search-result.component#loadPage() #result #rowsPerPage', this.rowsPerPage);
      // To find out which rows in the table must be checked, PrimeNGs p-table compares
      // "value" and "selection" attribute elements using "Object equals".
      // So after loading new search result data, we must find the selectedRows again.
      this.calculateSelectedRows();
      this.columns = this.configureColumnMetadata(this.columns, this.searchConfigFile);
      for (let r = 0; r < this.rows.length; r++) {
        this.rows[r] = this.configureRow(start + r, this.rows[r], this.columns, this.searchConfigFile);
      }
      this.idColumnIndex = this.columns.findIndex(column => column.id === this.idColumn);
      if (sortField) {
        this.rows.sort((r1, r2) => {
          let v1 = r1.getAt(sortField);
          let v2 = r2.getAt(sortField);
          let c;
          if (v1 > v2) {
            c = 1;
          } else if (v1 < v2) {
            c = -1;
          } else {
            c = 0;
          }
          return sortOrder > 0 ? c : -c;
        });
      }
      // selectedOptionsIdColumn should have been set by setSelectedOptionsIdColumn() before;
      // if that did not happen we try to guess the column name and log a warn message.
      if (!this.selectedOptionsIdColumn) {
        this.selectedOptionsIdColumn = searchResult.name + '.id';
        console.warn('HisSearchResultComponent.loadPage(): Set selectedOptionsIdColumn = ' + this.selectedOptionsIdColumn);
      }
      this.initialLoadFinished = true;
      this.finishedInitialLoad.emit();
      this.rowsChanged.emit(this.rows);
      this.restoreFocusAfterSort();
      if (this.currentPageNumber === 0) {
        this.currentPageNumber = 1;
      }
    }
    /**
     * Prepares navigation context by loading entry IDs and generating the navigation URL.
     * @returns Observable with navigation context
     */
    prepareNavigationContext() {
      // Retrieve the 'search' query parameter from the current route
      const {
        search: searchPath
      } = this.route.snapshot.queryParams;
      // Return an empty response if the newSearchUrl is missing
      if (!searchPath) {
        return of({
          ids: [],
          changeSearchUrl: '',
          newSearchUrl: ''
        });
      }
      // Create URL objects from the current URL and the new search URL
      const currentUrl = new URL(this.router.url, window.location.origin);
      const newSearchUrl = new URL(searchPath, window.location.origin);
      // Add relevant query parameters to the URL for new search
      this.addRequiredParamsToUrl(currentUrl, newSearchUrl);
      // Build the URL with query params to use on change search
      const changeSearchUrl = this.buildChangeSearchUrl(searchPath);
      // If entry IDs are already loaded, return them directly with the updated URLs
      if (this.entriesIds.length > 0) {
        return of({
          ids: this.entriesIds,
          changeSearchUrl: changeSearchUrl,
          newSearchUrl: newSearchUrl.toString()
        });
      }
      // If entry IDs are not loaded, load them and return the result
      return this.loadEntryIds().pipe(map$1(entryIds => ({
        ids: entryIds,
        changeSearchUrl: changeSearchUrl,
        newSearchUrl: newSearchUrl.toString()
      })));
    }
    // Helper function to add required parameters to the new URL
    addRequiredParamsToUrl(currentUrl, newUrl) {
      const requiredParams = ['navigationPosition', 'configFile', 'pageTitle'];
      requiredParams.forEach(param => {
        const paramValue = currentUrl.searchParams.get(param);
        if (paramValue) {
          newUrl.searchParams.set(param, paramValue);
        }
      });
    }
    /**
     * Builds the navigation URL by removing filter criteria from query parameters
     * @returns The clean navigation URL string
     */
    buildChangeSearchUrl(newSearchUrl) {
      const url = new URL(newSearchUrl, window.location.href);
      const cleanParams = this.getCleanQueryParams();
      const urlTree = this.router.createUrlTree([url.pathname], {
        queryParams: cleanParams,
        queryParamsHandling: 'merge'
      });
      return url.origin + this.router.serializeUrl(urlTree);
    }
    /**
     * Removes filter criteria from the current query parameters
     * @returns Clean query parameters object
     */
    getCleanQueryParams() {
      return HisSearchResultFilterHelper.removeFilterCriteriaFromParams(this.queryParams);
    }
    /**
     * Loads search results and extracts entry IDs
     * @returns Observable with array of entry IDs
     */
    loadEntryIds() {
      return this.searchService.loadSearchResult(this.search, 0, this.totalRowCount).pipe(map$1(searchResult => {
        if (searchResult.data.length === 0) {
          return [];
        }
        // Extract and store entry IDs
        this.entriesIds = searchResult.data.map(entry => entry.get(this.selectedOptionsIdColumn));
        return this.entriesIds;
      }));
    }
    restoreFocusAfterSort() {
      setTimeout(() => {
        let clickedHeaderCell = document.querySelectorAll('.p-sortable-column.p-highlight')[0];
        if (clickedHeaderCell !== undefined && clickedHeaderCell.id) {
          let clickedHeaderCellId = clickedHeaderCell.id;
          let sortedHeaderCell = document.getElementById(clickedHeaderCellId);
          sortedHeaderCell.focus();
        }
      }, 1);
    }
    calculateRowsPerPage(self) {
      console.log('his-search-result.component#calculateRowsPerPage()');
      let obs = new BehaviorSubject(null);
      if (!self.showTableConfig) {
        self.rowsPerPage = clone(self.resultRowsPerPage);
        obs.next(self.rowsPerPage);
        return obs;
      }
      if (!self.searchConfigFile && !self.search) {
        self.rowsPerPage = clone(self.resultRowsPerPage);
        obs.next(self.rowsPerPage);
        return obs;
      }
      if (self.authService.isAnonymous) {
        console.log('his-search-result.component#calculateRowsPerPage() #isAnonymous #self.rowsPerPage', self.rowsPerPage);
        let pageSize = self.getRowsPerPageFormSessionStorageOrDefault();
        obs.next(pageSize);
        return obs;
      }
      console.log('his-search-result.component#calculateRowsPerPage() #!isAnonymous #self.rowsPerPage', self.rowsPerPage);
      this.rowsPerPageService.getPageSizeFromUserProfile(this.pageSizeKey, this.resultRowsPerPage).subscribe(result => {
        if (result) {
          console.log('his-search-result.component#calculateRowsPerPage() #getPageSizeFromUserProfile', result);
          obs.next(result);
        }
      });
      console.log('his-search-result.component#calculateRowsPerPage() #rowsPerPage', self.rowsPerPage);
      return obs;
    }
    processTableConfigCols(self) {
      console.log('his-search-result.component#processTableConfigCols() #rowAction', self.rowAction);
      if (self.rowAction && self.showActionsBefore) {
        self.addConfigColumn(self.ACTIONS_BEFORE, 'common.actions.short');
      }
      for (let col of self.columns) {
        // Checkboxen nur Anzeige, wenn Spalten aufgrund der Suchkonfiguration sichtbar sind
        if (col.visible) {
          let configCol = new HisSearchResultConfigColumn(col.id, col.label);
          // prüfen ob schon enthalten
          // TODO: eventuell auf map umstellen
          let confCol = self.configColumns.find(c => c.id === col.id);
          if (!confCol) {
            self.configColumns.push(configCol);
          }
        }
      }
      if (self.rowAction && self.showActionsAfter) {
        self.addConfigColumn(self.ACTIONS_AFTER, 'common.actions');
      }
      console.log('his-search-result.component#processTableConfigCols() #columns #self.columns', self.columns);
      console.log('his-search-result.component#processTableConfigCols() #columns #self.configColumns', self.configColumns);
      if (self.authService.isAnonymous) {
        // im SessionStorage nachschauen
        let key = self.getUserProfileByKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_HIDDEN_COLS);
        let hiddenCols = sessionStorage.getItem(key);
        console.log('his-search-result-component#processTableConfigCols() #hiddenCols #sessionStorage', hiddenCols);
        if (hiddenCols) {
          self.setTableConfigHiddenColumns(hiddenCols, self);
        }
      } else {
        let key = self.getUserProfileByKey(HisSearchResultConfigConstants.HIDDEN_COLS);
        self.userProfileService.getValueforKey(key).subscribe(hiddenCols => {
          if (hiddenCols) {
            console.log('his-search-result-component#processTableConfigCols() #hiddenCols #userProfile', hiddenCols);
            self.setTableConfigHiddenColumns(hiddenCols, self);
          }
        });
      }
    }
    /**
     * @param hiddenCols die im userProfile oder sessionStorage gespeicherten hidden columns
     */
    setTableConfigHiddenColumns(hiddenCols, self) {
      // columns werden aufgrund der Suchkonfiguration erzeugt
      // und vefügen noch nicht über die Information aus dem userProfile
      for (let col of self.columns) {
        // console.log('his-search-result-component#loadPage() #hiddenCols #col', col);
        if (hiddenCols.includes(col.id)) {
          console.log('his-search-result-component#loadPage() #columns #hiddenCololumn includes col.id', col);
          col.visible = false;
          let configCol = self.configColumns.find(c => c.id === col.id);
          configCol.checked = false;
        }
      }
      if (self.rowAction && self.showActionsBefore) {
        let idActionsBefore = self.ACTIONS_BEFORE;
        let configColActionBefore = self.configColumns.find(c => c.id === idActionsBefore);
        if (hiddenCols.includes(self.ACTIONS_BEFORE)) {
          self.showActionsBefore = false;
          configColActionBefore.checked = false;
        } else {
          self.showActionsBefore = true;
        }
      }
      if (self.rowAction && self.showActionsAfter) {
        let idActionsAfter = self.ACTIONS_AFTER;
        let configColActionAfter = self.configColumns.find(c => c.id === idActionsAfter);
        if (hiddenCols.includes(self.ACTIONS_AFTER)) {
          self.showActionsAfter = false;
          configColActionAfter.checked = false;
        } else {
          self.showActionsAfter = true;
        }
      }
    }
    // Configure
    configureColumnMetadata(columns, searchConfigFile) {
      return columns;
    }
    configureRow(index, row, columns, searchConfigFile) {
      return row;
    }
    newSearch() {
      // navigate back to search page passing only the basic queryParams, no search constraints
      let queryParams = {};
      if (this.navigationPosition) {
        queryParams.navigationPosition = this.navigationPosition;
      }
      if (this.searchConfigFile) {
        queryParams.configFile = this.searchConfigFile;
      }
      if (this.pageTitle) {
        queryParams.pageTitle = this.pageTitle;
      }
      if (this.tableTitle) {
        queryParams.tableTitle = this.tableTitle;
      }
      // it feels correct to keep the toggle state as well if we click on "Neue Suche"
      if (this.queryParams.extended) {
        queryParams.extended = true;
      }
      let route = '../search';
      console.log('HisSearchResultComponent.newSearch(): Current route:', this.route.url);
      console.log('HisSearchResultComponent.newSearch(): Navigating to \'' + route + '\' with queryParams', queryParams);
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON, 'NEW_SEARCH');
      this.router.navigate([route], {
        relativeTo: this.route,
        queryParams
      });
    }
    /**
     * Generates a URL without filter parameters based on the provided route and query parameters.
     * This method encapsulates the logic for creating a URL tree, merging query parameters, and serializing the URL.
     *
     * @param route - The target route for navigation (e.g., '../search').
     * @param params - The query parameters to be included in the URL.
     * @returns The generated URL as a string.
     */
    generateUrlWithoutFilterParams(route, params) {
      let urlTree = this.router.createUrlTree([route], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: 'merge'
      });
      let urlString = this.router.serializeUrl(urlTree);
      let urlBasePath = this.navigationService.getUrlBasePath();
      return urlBasePath + urlString;
    }
    changeSearch() {
      // navigate back to search page passing all queryParams
      let route = '../search';
      console.log('HisSearchResultComponent.changeSearch(): Current route:', this.route.url);
      console.log('HisSearchResultComponent.changeSearch(): Navigating to \'' + route + '\' with queryParams', this.queryParams);
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON, 'CHANGE_SEARCH');
      if (this.filterToggled) {
        let params = HisSearchResultFilterHelper.removeFilterCriteriaFromParams(this.queryParams);
        let urlWithoutFilterParams = this.generateUrlWithoutFilterParams(route, params);
        console.log('his-search-result.component#changeSearch() #params #urlWithoutFilterParams', urlWithoutFilterParams);
        if (!this.ignoreForBackToSearchResultNavigation) {
          // ohne diesen Aufruf manifestirt sich die neue URL nicht
          this.navigationService.setSearchResultUrl(urlWithoutFilterParams);
        }
        this.router.navigate([route], {
          relativeTo: this.route,
          queryParams: params
        });
        return;
      }
      this.router.navigate([route], {
        relativeTo: this.route,
        queryParams: this.queryParams
      });
    }
    /**
     * Delete the row from the result table at the given index.
     *
     * Actually we do not delete the result row blindly but reload the page;
     * so only if the object has really been deleted in the database it will be gone.
     *
     * @param index the relative row index, i.e. 0 if we want to delete the first element on page 2
     *
     * @deprecated because the method name is misleading and the index argument is not required at all; use reloadPageAfterDelete() instead
     */
    deleteRow(index) {
      console.log('index =', index, ', totalRowCount =', this.totalRowCount);
      this.reloadPageAfterDelete();
    }
    /**
     * Reload the current search result page after one of its rows has been deleted.
     */
    reloadPageAfterDelete() {
      if (this.firstResultRow + 1 === this.totalRowCount && this.firstResultRow > 0) {
        // we are on the last page which has only one result row and there are other pages -> jump one page back
        this.firstResultRow -= this.rowsPerPage;
      }
      // We have to reload the page to get 10 result rows again if there are >= 10 in total.
      // Reloading the page updates total row count, current page number etc. as well.
      console.log('Reload after delete: firstResultRow =', this.firstResultRow, ', rowsPerPage =', this.rowsPerPage);
      this.loadPage(this.firstResultRow);
      this.updateSortIconAfterDeletion();
    }
    updateSortIconAfterDeletion() {
      setTimeout(() => {
        let clickedHeaderCell = document.querySelectorAll('.p-sortable-column.p-highlight')[0];
        if (clickedHeaderCell !== undefined) {
          let iconElement = clickedHeaderCell.querySelector('.p-sortable-column-icon');
          if (iconElement !== undefined) {
            let currentClass = Array.from(iconElement.classList).find(cls => cls.startsWith('pi-sort-amount-'));
            if (currentClass) {
              iconElement.classList.remove(currentClass);
            }
            iconElement.classList.add('pi-sort-alt');
          }
        }
      }, 100);
    }
    showJobStarter() {
      if (!this.jobStarterKey) {
        return false;
      }
      return this.authService.hasAll(HisJobStarterComponent.jobRight);
    }
    // unused stub
    getRowActionDefaultIcon(action) {
      if (!isString(action)) {
        action = action.action;
      }
      switch (action) {
        case 'edit':
          return 'edit';
        case 'add':
          return 'plus';
        case 'delete':
          return 'close';
        default:
          return 'question';
      }
    }
    // unused stub
    getColumnStyle(column) {
      return {
        width: !column.width && column.dataType === 'checkbox' ? '34px' : column.width
      };
    }
    // unused stub
    getRadioButtonGroup(columnIndex) {
      let group = this.radioButtonGroups['' + columnIndex];
      if (!group) {
        group = this.baseGlobalService.uid();
        console.log(columnIndex + ':' + group);
        this.radioButtonGroups['' + columnIndex] = group;
      }
      return group;
    }
    rowsPerPageChanged(value) {
      console.log('his-search-result.component#refreshTable() #value', value);
      console.log('his-search-result.component#refreshTable() #this.rowsPerPage', this.rowsPerPage);
      if (!this.authService.isAnonymous) {
        let defaultValue = this.DEFAULT_PAGE_SIZE.toString();
        console.log('his-search-result.component#refreshTable() #defaultValue', defaultValue);
        if (!value || +value === this.DEFAULT_PAGE_SIZE) {
          this.userProfileService.delete(this.pageSizeKey).subscribe(result => {
            if (result) {
              this.rowsPerPage = this.DEFAULT_PAGE_SIZE;
              this.currentPageNumber = 1;
              this.loadPage(0, undefined, this.getCurrentSortField(), this.getCurrentSortOrder(), HisSearchResultColumnSortHelper.getSafedSortCriteria());
            }
          });
        } else {
          this.userProfileService.setNewValue(this.pageSizeKey, value.toString(), defaultValue).subscribe(result => {
            if (result) {
              console.log('his-search-result.component#refreshTable() #result', result);
              // in JSF springt der Paginator auf 1 zurück, falls Zeile pro Seite geändert wird
              // Seit Hiszilla 265099 ist currentPageNumber Bestandteil der Berechnung des offset
              this.currentPageNumber = 1;
              this.loadPage(0, undefined, this.getCurrentSortField(), this.getCurrentSortOrder(), HisSearchResultColumnSortHelper.getSafedSortCriteria());
            }
          });
        }
      } else {
        //Hiszilla 262553: Zeilen pro Seite soll auch für anonyme Benutzer bespeichert werden
        // In JSF wird hierfür wie im userProfile üblich als key 'tableId.pageSize' gespeichert
        let key = this.getUserProfileByKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_PAGE_SIZE);
        if (Number(value) === this.DEFAULT_PAGE_SIZE) {
          // Schlüssel löschen falls Standard
          sessionStorage.removeItem(key);
          console.log('his-search-result.component#refreshTable() #removed key', key);
        } else {
          let valueAsString = value ? value.toString() : null;
          sessionStorage.setItem(key, valueAsString);
        }
        // in JSF springt der Paginator auf 1 zurück, falls Zeile pro Seite geändert wird
        // Seit Hiszilla 265099 ist currentPageNumber Bestandteil der Berechnung des offset
        this.currentPageNumber = 1;
        this.loadPage(0, undefined, this.getCurrentSortField(), this.getCurrentSortOrder(), HisSearchResultColumnSortHelper.getSafedSortCriteria());
      }
    }
    getCurrentSortOrder() {
      const currentSearchCriteria = HisSearchResultColumnSortHelper.getSafedSortCriteria();
      return currentSearchCriteria?.length > 0 ? currentSearchCriteria[0].ascending ? 1 : -1 : null;
    }
    getCurrentSortField() {
      const currentSearchCriteria = HisSearchResultColumnSortHelper.getSafedSortCriteria();
      return currentSearchCriteria?.length > 0 ? currentSearchCriteria[0].field : null;
    }
    // *** Filter result table ***
    toggleFilter() {
      this.toggleTableFilter = !this.toggleTableFilter;
      this.filterToggled.emit(this.toggleTableFilter);
      console.log('his-search-result.component#onToggleFilter() #this.toggleTableFilter', this.toggleTableFilter);
      // Comparison with JSF: Filter is reset on close
      if (this.toggleTableFilter === false) {
        this.onResetFilter();
        // für eingelogt User aus dem UserProfile löschen, für anonyme aus dem SessionStorage
        if (this.authService.isAnonymous) {
          console.log('his-search-result.component#onToggleFilter() #delete from sessionStorage', this.showTableFilterKey);
          sessionStorage.removeItem(this.showTableFilterKey);
        } else {
          // user profile key löschen
          console.log('his-search-result.component#onToggleFilter() #delete from userProfile', this.showTableFilterKey);
          this.userProfileService.setNewValue(this.showTableFilterKey, null, null).subscribe();
        }
      } else {
        if (this.authService.isAnonymous) {
          console.log('his-search-result.component#onToggleFilter() #store at sessionStorage', this.showTableFilterKey, '= true');
          sessionStorage.setItem(this.showTableFilterKey, 'true');
        } else {
          console.log('his-search-result.component#onToggleFilter() #store at userProfile', this.showTableFilterKey, '= true');
          this.userProfileService.setNewValue(this.showTableFilterKey, 'true', null).subscribe();
        }
      }
    }
    /** Writes every entry at filter inputs to this.filter */
    onFilter(value, column) {
      // console.log('his-search-result.component#onFilter() #column.id', column.id);
      // console.log('his-search-result.component#onFilter() #value', value);
      // console.log('his-search-result.component#onFilter() #columnsToFilter', this.filter);
      this.filter[column.filterPath] = value;
    }
    /**
     * NOTE: Standard filter, this.searchResultTable.filter('value', 'field', 'matchMode'), does not work on all search results
     */
    onFilterTable() {
      this.notificationService.clear();
      let searchForFilter = FilterUtils.prepareSearchForFilter(this.filter, this.search);
      // filterGroup an url übergeben Anfang
      // If this is not a popup search then register the current url for "back to search result" button
      if (!this.isSearchPopup) {
        searchForFilter = HisSearchParserHelper.removeDefaultGroupFromSearchIfOtherGroupIsPresent(searchForFilter);
        let searchParams = HisSearchParserHelper.convertHisSearchToFlatObjectFormatParams(searchForFilter);
        this.updateParamsAndSetNewUrlToBrowser(searchParams);
      }
      // filterGroup an url übergeben Ende
      console.log('his-search-result.component#onFilterTable() #searchForFilter', searchForFilter);
      // Könnte hier auch ein anderer Wert als 0 möglich/erfroderlich sein?
      this.loadPage(0, searchForFilter);
      // Comparison with JSF: inputs are reset
      // reset input values
      // reset deaktiviert wegen hiszilla 267655
      // da gab es vor kurzem wohl auch eine Änderung in JSF
      // this.filter = {};
    }
    onResetFilter() {
      this.notificationService.clear();
      console.log('his-search-result.component#onResetFilter() #this.search', this.search);
      console.log('his-search-result.component#onResetFilter() #this.filter', this.filter);
      console.log('his-search-result.component#onResetFilter() #this.searchConfigFile', this.searchConfigFile);
      // reset input values
      this.filter = {};
      console.log('his-search-result.component#onResetFilter() #sortCriteria', HisSearchResultColumnSortHelper.sortCriteria);
      // Filter-Kriterium aus URL löschen
      let urlParams = cloneDeep(this.route.snapshot.queryParams);
      console.log('his-search-result.component#onResetFilter() #searchParamsToDelete #urlParams', urlParams);
      console.log('his-search-result.component#onResetFilter() #searchParamsToDelete #this.queryParams', this.queryParams);
      urlParams = HisSearchResultFilterHelper.removeFilterCriteriaFromParams(urlParams);
      this.updateParamsAndSetNewUrlToBrowser(urlParams);
      console.log('his-search-result.component#onResetFilter() #searchParamsToDelete #urlParams nach updateParams', urlParams);
      // - hisSearch mit aktualisierten params erzeugen
      // - nachdem die urlParams in this.updateParamsAndSetNewUrlToBrowser aktualisiert werden,
      //   kann hier wieder auf this.queryParams zugegriffen werden
      let search = HisSearchParserHelper.convertUrlParamsToHisSearch(urlParams);
      search.configFile = this.search.configFile;
      console.log('his-search-result.component#onResetFilter() #searchParamsToDelete #search', search);
      // loadPage with default values, and the stored sortCriteria to keep the original sort order
      // param for search = undefined (second param) results in the usage of this.search, which it is assumed, that it is unchanged
      this.loadPage(0, search, undefined, 0, HisSearchResultColumnSortHelper.getSafedSortCriteria());
    }
    updateParamsAndSetNewUrlToBrowser(searchParams) {
      // schreibt die params in die auf der Suchergebnisseite angezeigte Url
      // wäre nicht unbedingt notwendig, stellt aber konsistenten Zustand her:
      // * Hinzufügen beim Filter anwenden
      // * entfernen beim Filter ausblenden
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: searchParams,
        queryParamsHandling: 'merge'
      });
      let urlTree = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: searchParams,
        queryParamsHandling: 'merge'
      });
      let urlString = this.router.serializeUrl(urlTree);
      let urlBasePath = this.navigationService.getUrlBasePath();
      console.log('his-search-result.component#onFilterTable() #url #shortUrl', urlBasePath);
      let urlWithFilterParam = urlBasePath + urlString;
      console.log('his-search-result.component#onFilterTable() #url #urlWithFilterParam', urlWithFilterParam);
      if (!this.ignoreForBackToSearchResultNavigation) {
        // ohne diesen Aufruf manifestirt sich die neue URL nichtnicht
        this.navigationService.setSearchResultUrl(urlWithFilterParam);
      }
    }
    reloadPage(event) {
      console.log('his-search-result-component#reloadPage() #event', event);
      if (event) {
        this.defaultTablePageSize = +event;
      }
      this.loadPage(this.firstResultRow, undefined, this.getCurrentSortField(), this.getCurrentSortOrder(), HisSearchResultColumnSortHelper.getSafedSortCriteria());
    }
    /* set last window.location.href before page leave on defaultRoute navigation */
    onBeforeNavigateDefaultRoute() {
      this.navigationService.setLastBackUrl(window.location.href);
    }
    setUserProfileBasePath() {
      if (this.PATHNAME.includes('print-view')) {
        let tableId = this.route.snapshot.queryParams.pathname + this.searchConfigFile;
        let tableIdHash = HisStringUtils.getHashCode(tableId);
        this.userProfileKeyBasePath = tableIdHash;
      } else {
        let tableId = this.PATHNAME + this.searchConfigFile;
        let tableIdHash = HisStringUtils.getHashCode(tableId);
        this.userProfileKeyBasePath = tableIdHash;
      }
    }
    getUserProfileByKey(key) {
      return this.userProfileKeyBasePath + key;
    }
    addConfigColumn(id, label) {
      if (!label) {
        label = id;
      }
      // das ist neu hier, so sll es dann sein
      let confCol = this.configColumns.find(c => c.id === id);
      console.log('his-Search-result.component#addConfigColumn() #confCol in array', confCol);
      if (!confCol) {
        let configColActionAfter = new HisSearchResultConfigColumn(id, label);
        this.configColumns.push(configColActionAfter);
      }
    }
    loadPaginatorPosition() {
      //console.log('his-search-result.component#loadPaginatorPosition() #paginator', this.paginator);
      //console.log('his-search-result.component#loadPaginatorPosition() #paginatorPosition', this.paginatorPosition);
      if (this.authService.isAnonymous) {
        let key = this.getUserProfileByKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_PAGINATOR_POSITION);
        console.log('his-search-result.component#loadPaginatorPosition() #anonymous #paginPosSessionStorage #key', key);
        let paginPosSessionStorage = sessionStorage.getItem(key); // XXX always null ?
        //console.log('his-search-result.component#loadPaginatorPosition() #anonymous #paginPosSessionStorage', paginPosSessionStorage);
        this.setPaginatorPosition(paginPosSessionStorage);
        //console.log('his-search-result.component#loadPaginatorPosition() #anonymous #paginator', this.paginator);
        //console.log('his-search-result.component#loadPaginatorPosition() #anonymous #paginatorPosition', this.paginatorPosition);
      } else {
        let paginatorPositionKey = this.getUserProfileByKey(HisSearchResultConfigConstants.PAGINATOR_POSITION);
        this.userProfileService.getValueforKey(paginatorPositionKey).subscribe(paginatorPos => {
          // XXX paginatorPos always null ?
          console.log('his-search-result.component#loadPaginatorPosition() #userProfile #paginatorPos', paginatorPos);
          this.setPaginatorPosition(paginatorPos);
          //console.log('his-search-result.component#loadPaginatorPosition() #userProfile #paginator', this.paginator);
          //console.log(
          //'his-search-result.component#loadPaginatorPosition() #userProfile #paginatorPosition', this.paginatorPosition);
        });
      }
    }
    setPaginatorPosition(paginatorPos) {
      if (paginatorPos) {
        if (paginatorPos === 'absent') {
          this.paginator = false;
        } else {
          this.paginator = true;
          this.paginatorPosition = paginatorPos;
        }
      } else {
        // falls paginatorPos= null, dann this.paginatorPosition = 'bottom' (Default)
        this.paginator = true;
        this.paginatorPosition = 'bottom';
      }
    }
    getRowsPerPageFormSessionStorageOrDefault() {
      console.log('his-search-result.component#getRowsPerPageFormSessionStorageOrDefault() #onEntry #this.rowsPerPage', this.rowsPerPage);
      console.log('his-search-result.component#getRowsPerPageFormSessionStorageOrDefault()' + ' #onEntry #this.resultRowsPerPage', this.resultRowsPerPage);
      let defaultTablePageSizeFormSessionStorage = sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_ANONYMOUS_DEFAULT_TABLE_PAGE_SIZE);
      let anonymousPageSizeKey = this.getUserProfileByKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_PAGE_SIZE);
      let pageSizeFormSessionStorage = sessionStorage.getItem(anonymousPageSizeKey);
      console.log('his-search-result.component#getRowsPerPageFormSessionStorageOrDefault()' + ' #pageSizeFormSessionStorage', pageSizeFormSessionStorage);
      console.log('his-search-result.component#getRowsPerPageFormSessionStorageOrDefault() #defaultTablePageSizeFormSessionStorage', defaultTablePageSizeFormSessionStorage);
      this.defaultTablePageSize = undefined;
      if (defaultTablePageSizeFormSessionStorage) {
        this.defaultTablePageSize = +defaultTablePageSizeFormSessionStorage;
        this.rowsPerPage = +defaultTablePageSizeFormSessionStorage;
      }
      if (pageSizeFormSessionStorage) {
        this.rowsPerPage = +pageSizeFormSessionStorage;
      }
      if (!defaultTablePageSizeFormSessionStorage && !pageSizeFormSessionStorage) {
        this.rowsPerPage = clone(this.resultRowsPerPage);
      }
      console.log('his-search-result.component#getRowsPerPageFormSessionStorageOrDefault()' + '#this.rowsPerPage #forkJoin #onExit', this.rowsPerPage);
      this.firstResultRow = (this.currentPageNumber - 1) * this.rowsPerPage;
      return this.rowsPerPage;
    }
    /**
     * This method clears the data within the 'rows' and 'columns' arrays.
     */
    clearRowsAndColumns() {
      this.rows.length = 0;
      this.columns.length = 0;
    }
    /**
     * Extracts the filter criteria from the url params in case of initial setup (via onInit) of this component.
     * <p> It is not provided yet to use filter AND the return from detail view to popup search via loadPage.
     * so this is not implemented yet.</p>
     */
    extracFilterCriteriaFromParams() {
      // Filter-Kriterien aus URL bzw. searchParams übernehmen zum Anzeigen,
      // z. B. nach Rückkehr aus einer Detailansicht
      let urlParams = cloneDeep(this.route.snapshot.queryParams);
      console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #params', urlParams);
      for (let key of Object.keys(urlParams)) {
        if (HisSearchConstants.FILTER === urlParams[key]) {
          console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #key', key);
          let group;
          console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #value', key, urlParams[key]);
          let k = key.toString();
          console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #k', k);
          let idx = k.indexOf('.');
          console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #idx', idx);
          group = k.substring(0, idx);
          console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #group', group);
          if (group) {
            let field;
            let value;
            for (let paramKey of Object.keys(urlParams)) {
              if (paramKey.startsWith(group) && paramKey.endsWith(HisSearchConstants.FIELD)) {
                field = urlParams[paramKey];
              }
              if (paramKey.startsWith(group) && paramKey.endsWith(HisSearchConstants.VALUE)) {
                value = urlParams[paramKey];
              }
              console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #field', field);
              console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #value', value);
              if (field && value) {
                this.filter[field] = value;
                console.log('his-search-result.component#extracFilterCriteriaFromParams() #filter params #filter', this.filter);
              }
            }
          }
        }
      }
    }
    showPrintview() {
      let printview = new HisSearchPrintviewData();
      printview.pageTitle = this.pageTitle;
      printview.searchConfigFile = this.searchConfigFile;
      printview.showSearchInfo = this.showSearchInfo;
      printview.queryParams = this.queryParams;
      printview.searchResultSize = this.totalRowCount;
      let modifiedCopyOfQueryParams = {
        ...this.route.snapshot.queryParams
      };
      delete modifiedCopyOfQueryParams.pageTitle;
      delete modifiedCopyOfQueryParams.page;
      modifiedCopyOfQueryParams.pathname = this.PATHNAME;
      this.router.navigate(['/print-view/'], {
        state: {
          data: printview
        },
        queryParams: modifiedCopyOfQueryParams
      });
    }
    /**
     * Handles the selection of all items from the child component.
     *
     * This method is triggered when the child component his-search-result-select-buttons emits the `selectAllItems` event.
     *
     */
    handleSelectAllItems() {
      this.searchService.loadSearchResult(this.searchToUseOverlay, 0, this.totalRowCount).subscribe(searchResult => {
        for (let row of searchResult.data) {
          this.selectRow(row);
        }
        this.calculateSelectedRows();
      });
    }
    /**
     * Handles the deselection of all items from the child component.
     *
     * This method is triggered when the child component his-search-result-select-buttons emits the `clearSelectedItems` event.
     */
    handleClearSelectedItems() {
      this.selectedOptions = [];
      this.calculateSelectedRows();
    }
    /**
     * Updates the selected items by deselecting specific rows.
     *
     * This method is triggered when the child component his-search-result-selected-items emits the `updateSelectedItems` event.
     * It processes the rows to be deselected.
     *
     */
    handleUpdateSelectedItems(rowsToDeselect) {
      this.deselectRows(rowsToDeselect);
    }
    /**
     * Deselects rows from the current selection.
     *
     * @param rows - An array of `HisSearchResultRow` objects to be deselected.
     */
    deselectRows(rows) {
      for (let row of rows) {
        this.deselectRow(row);
      }
      this.calculateSelectedRows();
    }
    static {
      this.ɵfac = function HisSearchResultComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultComponent,
        selectors: [["his-search-result"]],
        contentQueries: function HisSearchResultComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c0$r, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowAction = _t.first);
          }
        },
        viewQuery: function HisSearchResultComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1$a, 7);
            i0.ɵɵviewQuery(_c2$5, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchResultTable = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resultRowsPerPageComponent = _t.first);
          }
        },
        inputs: {
          searchConfigFile: "searchConfigFile",
          pageTitle: "pageTitle",
          tableTitle: "tableTitle",
          showTitle: "showTitle",
          showNewSearchButton: "showNewSearchButton",
          showChangeSearchButton: "showChangeSearchButton",
          jobStarterKey: "jobStarterKey",
          showBackButton: "showBackButton",
          searchShowPrintviewButton: "searchShowPrintviewButton",
          search: "search",
          idColumn: "idColumn",
          defaultColumn: "defaultColumn",
          defaultActionRoute: "defaultActionRoute",
          defaultActionUrl: "defaultActionUrl",
          defaultActionToolTip: "defaultActionToolTip",
          defaultActionRowRight: "defaultActionRowRight",
          isSearchFormResult: "isSearchFormResult",
          isSearchPopup: "isSearchPopup",
          selectionSetting: "selectionSetting",
          selectedOptions: "selectedOptions",
          selectedOptionsIdColumn: "selectedOptionsIdColumn",
          selectedOptionsLabelColumn: "selectedOptionsLabelColumn",
          resultTableStyle: "resultTableStyle",
          hisIcon: "hisIcon",
          hierarchyLevel: "hierarchyLevel",
          resultRowsPerPage: "resultRowsPerPage",
          resultListTemplate: "resultListTemplate",
          customResultRowsTemplate: "customResultRowsTemplate",
          ignoreForBackToSearchResultNavigation: "ignoreForBackToSearchResultNavigation",
          showSearchInfo: "showSearchInfo",
          showTableFilter: "showTableFilter",
          showTableConfig: "showTableConfig",
          showActionsBefore: "showActionsBefore",
          showActionsAfter: "showActionsAfter",
          showPaginator: "showPaginator",
          maxRows: "maxRows",
          genericSearchRowTooltipId: "genericSearchRowTooltipId",
          rowTooltipGeneratorMethod: "rowTooltipGeneratorMethod",
          loadLastSortOrder: "loadLastSortOrder"
        },
        outputs: {
          finishedInitialLoad: "finishedInitialLoad",
          singleSelectionSubmited: "singleSelectionSubmited",
          rowsChanged: "rowsChanged",
          filterToggled: "filterToggled"
        },
        standalone: false,
        ngContentSelectors: _c4$3,
        decls: 5,
        vars: 8,
        consts: [["defaultResultTable", ""], ["searchResultTable", ""], ["resultRowsPerPageComponent", ""], [3, "level", "value"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["appScrollwithme", "", 1, "genericSearchButtons"], ["type", "submit", "iconPos", "left", 1, "newSearchButton"], ["type", "submit", "iconPos", "left", 1, "changeSearchButton"], ["id", "showPrintview", "hisImage", "PRINTER_L", "iconPos", "left", 1, "submitLookImage", 3, "title"], [3, "key", "search", "searchConfigFile", "selectedOptions"], [1, "tableSelectItemsButtonBlock"], [1, "floatLeft"], [1, "tableFilterEditBlock"], [1, "hideOnMobile"], [1, "clearer"], [1, "clearerSpaceAboveHalfEm"], [1, "infoMessage"], ["sortMode", "multiple", 3, "firstChange", "selectionChange", "onRowSelect", "onRowUnselect", "onHeaderCheckboxToggle", "onLazyLoad", "onPage", "value", "paginator", "paginatorPosition", "totalRecords", "lazy", "rowHover", "compareSelectionBy", "rows", "first", "selection", "lazyLoadOnInit"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["pTemplate", "paginatorright"], [1, "genericSearchButtons"], ["type", "submit", "iconPos", "left"], ["type", "submit", "iconPos", "left", 1, "newSearchButton", 3, "click"], ["type", "submit", "iconPos", "left", 1, "changeSearchButton", 3, "click"], ["id", "showPrintview", "hisImage", "PRINTER_L", "iconPos", "left", 1, "submitLookImage", 3, "click", "title"], [3, "updateSelectedItems", "currentSearch", "columns", "selectedOptions", "selectedOptionsIdColumn", "idColumn"], [3, "selectAllItems", "clearSelectedItems"], ["hisImage", "FILTER", 1, "transparent", "hideOnMobile", 3, "click"], [3, "saved", "configColumns", "showPaginator", "paginatorPosition", "defaultTablePageSize", "minRows", "maxRows", "userProfileKeyBasePath"], [3, "queryParams", "searchConfigFile"], [1, "singleSelectColumn"], [1, "multiSelectColumn"], [1, "actionsBeforeColumn"], [1, "hideOnBreakpointSmall", 3, "click", "title"], [1, "hideOnBreakpointLarge"], ["hisImage", "filter", 1, "icon", 3, "click", "title"], ["hisImage", "filter_reset", 1, "icon", 3, "click", "title"], [3, "pSortableColumnDisabled", "pSortableColumn", "id"], [3, "field"], ["pInputText", "", "type", "text", 3, "title", "ngModel"], ["pInputText", "", "type", "text", 3, "ngModelChange", "keydown.enter", "click", "title", "ngModel"], ["ngClass", "singleLine", 1, "actionsBeforeColumn"], ["ngClass", "singleLine", 1, "actionsAfterColumn"], [1, "icon", 3, "click", "hisImage", "title"], [3, "value", "ariaLabel", "title"], [3, "beforeNavigateDefaultRoute", "rowId", "row", "column", "columnIndex", "ri", "defaultActionRoute", "defaultActionUrl", "showBackButton", "isDefaultColumn", "defaultActionToolTip", "defaultActionRowRight"], [3, "rowsPerPageInputChanged", "resultRowsPerPage", "rowsPerPage", "maxRows", "totalRowCount", "currentPageNumber", "totalNumberOfPages"], ["type", "submit", "iconPos", "left", 3, "click"]],
        template: function HisSearchResultComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c3$3);
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, HisSearchResultComponent_Conditional_1_Template, 2, 4, "his-heading", 3)(2, HisSearchResultComponent_ng_container_2_Template, 1, 0, "ng-container", 4)(3, HisSearchResultComponent_ng_template_3_Template, 31, 25, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const defaultResultTable_r26 = i0.ɵɵreference(4);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.pageTitle && ctx.showTitle ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.resultListTemplate ? ctx.resultListTemplate : defaultResultTable_r26)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c5$2, ctx.rows, ctx.firstResultRow, ctx.totalRowCount, ctx.rowsPerPage));
          }
        },
        dependencies: [i1$2.NgClass, i1$2.NgTemplateOutlet, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i3$1.Table, i2.PrimeTemplate, i3$1.SortableColumn, i3$1.SortIcon, i3$1.TableCheckbox, i3$1.TableHeaderCheckbox, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisScrollwithmeDirective, HisButtonTitleDirective, HisHeadingComponent, HisJobStarterComponent, HisSearchResultSearchInfoComponent, HisSearchResultConfigComponent, HisSearchResultRowsPerPageComponent, HisSearchResultTableCellComponent, HisSearchResultSelectedItemsComponent, HisSearchResultSelectButtonsComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisSearchSelectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "his-search-select-operator", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("widget", ctx_r0.widget)("isFirstInputElement", ctx_r0.isFirstInputElement);
  }
}
function HisSearchSelectComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-select-autocomplete", 9);
    i0.ɵɵlistener("selected", function HisSearchSelectComponent_Conditional_3_Template_his_search_select_autocomplete_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.addSelectedElement($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("uid", ctx_r0.uid)("removeSelectedOptionsFromDropdown", ctx_r0.removeSelectedOptionsFromDropdown)("selectedOptions", ctx_r0.selectedOptions)("searchEntity", ctx_r0.searchEntity)("searchConfigFile", ctx_r0.searchConfigFile)("minLength", ctx_r0.minLength)("limit", ctx_r0.limit)("showDropdownIcon", ctx_r0.showDropdownIcon)("isFirstInputElement", ctx_r0.isFirstInputElement && !ctx_r0.showUnequalOption);
  }
}
function HisSearchSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 13);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const selectedOption_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.deleteSelectedOption(selectedOption_r4));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOption_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("title", "", selectedOption_r4.label, ": ", i0.ɵɵpipeBind1(3, 4, "view.controls.disconnect"), "");
  }
}
function HisSearchSelectComponent_Conditional_9_ng_template_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchSelectComponent_Conditional_9_ng_template_1_For_3_Conditional_0_Template, 4, 6, "li", 12);
  }
  if (rf & 2) {
    const ɵ$index_30_r5 = ctx.$index;
    const selectedOptions_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r0.maxDisplayedSelections || ctx_r0.showAllSelected || ɵ$index_30_r5 < ctx_r0.maxDisplayedSelections - 1 || ctx_r0.maxDisplayedSelections === selectedOptions_r6.length ? 0 : -1);
  }
}
function HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12)(1, "button", 14);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      ctx_r0.toggleShowAllSelected();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 15);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 16);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 4, "common.components.selectManyPicklist.showAllSelected"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("... ", selectedOptions_r6.length - ctx_r0.maxDisplayedSelections + 1, " ", i0.ɵɵpipeBind1(5, 6, "common.components.selectManyPicklist.more"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 8, "common.components.selectManyPicklist.showAllSelected"));
  }
}
function HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12)(1, "button", 14);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      ctx_r0.toggleShowAllSelected();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 15);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 17);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 7, "common.components.selectManyPicklist.showLess"));
  }
}
function HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_0_Template, 8, 10, "li", 12)(1, HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Conditional_1_Template, 8, 9, "li", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r0.showAllSelected ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showAllSelected ? 1 : -1);
  }
}
function HisSearchSelectComponent_Conditional_9_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "ul");
    i0.ɵɵrepeaterCreate(2, HisSearchSelectComponent_Conditional_9_ng_template_1_For_3_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(4, HisSearchSelectComponent_Conditional_9_ng_template_1_Conditional_4_Template, 2, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedOptions_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.maxDisplayedSelections && ctx_r0.maxDisplayedSelections < selectedOptions_r6.length ? 4 : -1);
  }
}
function HisSearchSelectComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 7);
    i0.ɵɵtemplate(1, HisSearchSelectComponent_Conditional_9_ng_template_1_Template, 5, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.selectedOptions)("emptyMessage", "\u00A0");
  }
}
const _c0$q = () => [];
function HisSearchFormWidgetComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-checkbox", 9, 0);
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_4_Template_his_search_checkbox_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOptionValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("isFirstInputElement", ctx_r1.isFirstInputElement);
  }
}
function HisSearchFormWidgetComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-input", 9, 0);
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_5_Template_his_search_input_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("isFirstInputElement", ctx_r1.isFirstInputElement);
  }
}
function HisSearchFormWidgetComponent_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-calendar", 9, 0);
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_6_Template_his_search_calendar_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("isFirstInputElement", ctx_r1.isFirstInputElement);
  }
}
function HisSearchFormWidgetComponent_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-autocomplete", 10, 0);
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_7_Template_his_search_autocomplete_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("minLength", ctx_r1.widget.minLength)("limit", ctx_r1.widget.limit)("showDropdownIcon", ctx_r1.widget.showDropdownIcon)("showUnequalOption", ctx_r1.widget.showUnequalOption)("isFirstInputElement", ctx_r1.isFirstInputElement)("selectFrom", ctx_r1.widget.optionsKey)("configFile", ctx_r1.widget.configFile);
  }
}
function HisSearchFormWidgetComponent_Case_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-multiselect", 11, 0);
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_8_Template_his_search_multiselect_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("uid", ctx_r1.widget.uid)("selectedOptions", ctx_r1.widget.value ? ctx_r1.widget.value : i0.ɵɵpureFunction0(8, _c0$q))("minLength", ctx_r1.widget.minLength)("limit", ctx_r1.widget.limit)("showDropdownIcon", ctx_r1.widget.showDropdownIcon)("showUnequalOption", ctx_r1.widget.showUnequalOption)("isFirstInputElement", ctx_r1.isFirstInputElement);
  }
}
function HisSearchFormWidgetComponent_Case_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-select", 12, 0);
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_9_Template_his_search_select_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("uid", ctx_r1.widget.uid)("selectedOptions", ctx_r1.widget.value ? ctx_r1.widget.value : i0.ɵɵpureFunction0(13, _c0$q))("searchEntity", ctx_r1.widget.searchEntity)("searchConfigFile", ctx_r1.widget.searchConfigFile)("selectedOptionsIdColumn", ctx_r1.widget.selectedOptionsIdColumn)("selectedOptionsLabelColumn", ctx_r1.widget.selectedOptionsLabelColumn)("minLength", ctx_r1.widget.minLength)("limit", ctx_r1.widget.limit)("showDropdownIcon", ctx_r1.widget.showDropdownIcon)("showUnequalOption", ctx_r1.widget.showUnequalOption)("isFirstInputElement", ctx_r1.isFirstInputElement)("showTableFilter", ctx_r1.widget.showSearchFilter);
  }
}
function HisSearchFormWidgetComponent_Case_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-tree-select", 13, 0);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("changed", function HisSearchFormWidgetComponent_Case_10_Template_his_search_tree_select_changed_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("widget", ctx_r1.widget)("uid", ctx_r1.widget.uid)("treename", ctx_r1.widget.treeName)("tree", ctx_r1.widget.tree)("selectedData", ctx_r1.widget.value ? ctx_r1.widget.value : i0.ɵɵpureFunction0(13, _c0$q))("title", i0.ɵɵpipeBind1(2, 11, ctx_r1.widget.label))("minLength", ctx_r1.widget.minLength)("limit", ctx_r1.widget.limit)("showDropdownIcon", ctx_r1.widget.showDropdownIcon)("showUnequalOption", ctx_r1.widget.showUnequalOption)("isFirstInputElement", ctx_r1.isFirstInputElement);
  }
}
function HisSearchFormWidgetComponent_Case_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Widget kind '", ctx_r1.widget.kind, "' not supported. ");
  }
}
function HisSearchFormWidgetComponent_Conditional_12_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const error_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(error_r9);
  }
}
function HisSearchFormWidgetComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵrepeaterCreate(1, HisSearchFormWidgetComponent_Conditional_12_For_2_Template, 2, 1, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", "red");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.widget.errors);
  }
}
const _c1$9 = [[["", "customSearchButtons", ""]], [["", "customSearchButtons", ""]], [["", "customSearchSet", ""]]];
const _c2$4 = ["[customSearchButtons]", "[customSearchButtons]", "[customSearchSet]"];
function HisSearchFormComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 1);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("level", ctx_r0.hierarchyLevel)("value", i0.ɵɵpipeBind1(1, 2, ctx_r0.title));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.submitSearchForm());
    });
    i0.ɵɵelementEnd();
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.submitSearchForm());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.search"));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_9_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(3);
      ctx_r0.onToggleQuickSearch();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.showAllSearchCriteria ? i0.ɵɵpipeBind1(3, 1, "genericSearch.toggleSearchShowAllCriteria_showQuickSearch") : i0.ɵɵpipeBind1(4, 3, "genericSearch.toggleSearchShowAllCriteria_showAll"));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("href", "", ctx_r0.contextPath, "/pages/genericSearch/genericSearchHelp.faces", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate2("title", "", i0.ɵɵpipeBind1(1, 6, "common.openInNewWindow"), ": ", i0.ɵɵpipeBind1(2, 8, "genericSearch.help"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 10, "genericSearch.help"));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-search-save-params", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("configFile", ctx_r0.configFile)("form", ctx_r0.form)("widgetGroups", ctx_r0.widgetGroups)("searchFormData", ctx_r0)("searchForm", ctx_r0)("callerId", ctx_r0.callerId);
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_For_17_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 1);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const widgetGroup_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("level", ctx_r0.headingLevelWidgetTitle)("value", i0.ɵɵpipeBind1(1, 2, widgetGroup_r6.label));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_For_17_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "his-search-form-widget", 27);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const widget_r7 = ctx.$implicit;
    const ɵ$index_68_r8 = ctx.$index;
    const ɵ$index_58_r9 = i0.ɵɵnextContext().$index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.showAllSearchCriteria || widget_r7.quickSearch || ctx_r0.showExtendedCriteriaWidgetBySearchSet(widget_r7.id) ? "" : "hiddenQuicksearchElement");
    i0.ɵɵadvance();
    i0.ɵɵproperty("widget", widget_r7)("form", ctx_r0.form)("showErrors", true)("isFirstInputElement", ɵ$index_58_r9 === 0 && ɵ$index_68_r8 === 0);
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "p-panel", 24);
    i0.ɵɵtemplate(2, HisSearchFormComponent_Conditional_0_Conditional_3_For_17_ng_template_2_Template, 2, 4, "ng-template", 25);
    i0.ɵɵrepeaterCreate(3, HisSearchFormComponent_Conditional_0_Conditional_3_For_17_For_4_Template, 3, 6, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelement(5, "his-search-criteriagroup", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const widgetGroup_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.showAllSearchCriteria || widgetGroup_r6.quickSearch || ctx_r0.showExtendedCriteriaGroupBySearchSet(widgetGroup_r6.label) ? "" : "hiddenQuicksearchElement");
    i0.ɵɵproperty("id", widgetGroup_r6.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("toggleable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(widgetGroup_r6.widgets);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("group", widgetGroup_r6)("form", ctx_r0.form)("widgetGroups", ctx_r0.widgetGroups);
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_For_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 1);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const widgetGroup_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("level", ctx_r0.headingLevelWidgetTitle)("value", i0.ɵɵpipeBind1(1, 2, widgetGroup_r10.label));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_For_2_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "his-search-form-widget", 27);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const widget_r11 = ctx.$implicit;
    const ɵ$index_90_r12 = ctx.$index;
    const ɵ$index_80_r13 = i0.ɵɵnextContext().$index;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.showAllSearchCriteria || widget_r11.quickSearch || ctx_r0.showExtendedCriteriaWidgetBySearchSet(widget_r11.id) ? "" : "hiddenQuicksearchElement");
    i0.ɵɵadvance();
    i0.ɵɵproperty("widget", widget_r11)("form", ctx_r0.form)("showErrors", true)("isFirstInputElement", ɵ$index_80_r13 === 0 && ɵ$index_90_r12 === 0);
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "p-panel", 24);
    i0.ɵɵtemplate(2, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_For_2_ng_template_2_Template, 2, 4, "ng-template", 25);
    i0.ɵɵrepeaterCreate(3, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_For_2_For_4_Template, 3, 6, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelement(5, "his-search-criteriagroup", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const widgetGroup_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r0.showAllSearchCriteria || widgetGroup_r10.quickSearch || ctx_r0.showExtendedCriteriaGroupBySearchSet(widgetGroup_r10.label) ? "" : "hiddenQuicksearchElement");
    i0.ɵɵproperty("id", widgetGroup_r10.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("toggleable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(widgetGroup_r10.widgets);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("group", widgetGroup_r10)("form", ctx_r0.form)("widgetGroups", ctx_r0.widgetGroups);
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵrepeaterCreate(1, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_For_2_Template, 6, 7, "div", 15, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.widgetGroups.slice(ctx_r0.searchMaskLeftGroupsAmount));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "br");
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵtext(3, "Form Data:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "pre", 28);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "json");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, ctx_r0.form.value));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_22_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.submitSearchForm());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.search"));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_27_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_27_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r0 = i0.ɵɵnextContext(3);
      ctx_r0.onToggleQuickSearch();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.showAllSearchCriteria ? i0.ɵɵpipeBind1(3, 1, "genericSearch.toggleSearchShowAllCriteria_showQuickSearch") : i0.ɵɵpipeBind1(4, 3, "genericSearch.toggleSearchShowAllCriteria_showAll"));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate2("title", "", i0.ɵɵpipeBind1(1, 4, "common.openInNewWindow"), ": ", i0.ɵɵpipeBind1(2, 6, "genericSearch.help"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 8, "genericSearch.help"));
  }
}
function HisSearchFormComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "form", 4);
    i0.ɵɵlistener("keydown.enter", function HisSearchFormComponent_Conditional_0_Conditional_3_Template_form_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.enterOnForm($event));
    });
    i0.ɵɵtemplate(2, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_2_Template, 1, 0, "button", 5);
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtemplate(4, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_4_Template, 4, 3, "button", 7);
    i0.ɵɵelementStart(5, "button", 8);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Template_button_click_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.resetInputs();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_9_Template, 5, 5, "button", 9)(10, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_10_Template, 5, 12, "a", 10);
    i0.ɵɵprojection(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_12_Template, 1, 6, "his-search-save-params", 11);
    i0.ɵɵelement(13, "div", 12);
    i0.ɵɵelementStart(14, "div", 13)(15, "div", 14);
    i0.ɵɵrepeaterCreate(16, HisSearchFormComponent_Conditional_0_Conditional_3_For_17_Template, 6, 7, "div", 15, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_18_Template, 3, 0, "div", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_19_Template, 7, 3, "div");
    i0.ɵɵelementStart(20, "div", 17, 0);
    i0.ɵɵtemplate(22, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_22_Template, 4, 3, "button", 18);
    i0.ɵɵelementStart(23, "button", 8);
    i0.ɵɵlistener("click", function HisSearchFormComponent_Conditional_0_Conditional_3_Template_button_click_23_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.resetInputs();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(24, "span");
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(27, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_27_Template, 5, 5, "button", 9)(28, HisSearchFormComponent_Conditional_0_Conditional_3_Conditional_28_Template, 5, 10, "a", 19);
    i0.ɵɵprojection(29, 1);
    i0.ɵɵprojection(30, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showSearchButton ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showSearchButton ? 4 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 13, "common.reset"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.hasQuickSearchCriteria ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showLinkToSearchHelp ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.searchShowSearchParamsBox ? 12 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r0.widgetGroups.slice(0, ctx_r0.searchMaskLeftGroupsAmount));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.widgetGroups.length > ctx_r0.searchMaskLeftGroupsAmount ? 18 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showFormData ? 19 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.showSearchButton ? 22 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 15, "common.reset"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.hasQuickSearchCriteria ? 27 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showLinkToSearchHelp ? 28 : -1);
  }
}
function HisSearchFormComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisSearchFormComponent_Conditional_0_Conditional_1_Template, 2, 4, "his-heading", 1);
    i0.ɵɵelement(2, "div", 2);
    i0.ɵɵtemplate(3, HisSearchFormComponent_Conditional_0_Conditional_3_Template, 31, 17, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.title && ctx_r0.renderTitle ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.widgetGroups ? 3 : -1);
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "his-search-form-widget", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const widget_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("widget", widget_r4)("form", ctx_r1.form)("showErrors", true);
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dialog", 5);
    i0.ɵɵtwoWayListener("visibleChange", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template_p_dialog_visibleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.criteriagroupOverlayVisible, $event) || (ctx_r1.criteriagroupOverlayVisible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onHide", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template_p_dialog_onHide_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancelEditCriteriaGroup($event));
    });
    i0.ɵɵelementStart(1, "p-header");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "his-helptext", 4);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div")(9, "his-plam", 6)(10, "p-radioButton", 7, 0);
    i0.ɵɵpipe(12, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template_p_radioButton_ngModelChange_10_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.currentCriteriagroup.notInCriteriaGroup, $event) || (ctx_r1.currentCriteriagroup.notInCriteriaGroup = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p-radioButton", 7, 0);
    i0.ɵɵpipe(15, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template_p_radioButton_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.currentCriteriagroup.notInCriteriaGroup, $event) || (ctx_r1.currentCriteriagroup.notInCriteriaGroup = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵrepeaterCreate(16, HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_For_17_Template, 3, 3, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(18, "button", 8);
    i0.ɵɵlistener("click", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template_button_click_18_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.saveCriteriaGroup($event));
    });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "button", 8);
    i0.ɵɵlistener("click", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template_button_click_21_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancelEditCriteriaGroup($event));
    });
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtwoWayProperty("visible", ctx_r1.criteriagroupOverlayVisible);
    i0.ɵɵproperty("draggable", false)("closeOnEscape", true)("resizable", false)("responsive", true)("modal", true)("blockScroll", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 18, "genericSearch.addCriteriaGroup"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("subtitle", i0.ɵɵpipeBind1(6, 20, "genericSearch.addCriteriaGroup"))("helptext", i0.ɵɵpipeBind1(7, 22, "genericSearch.criteriaGroup.helptext"));
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(12, 24, "genericSearch.criteriaGroup.include"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.currentCriteriagroup.notInCriteriaGroup);
    i0.ɵɵproperty("value", false);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(15, 26, "genericSearch.criteriaGroup.exclude"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.currentCriteriagroup.notInCriteriaGroup);
    i0.ɵɵproperty("value", true);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.currentCriteriagroup.widgets);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 28, "common.save"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 30, "common.cancel"));
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_6_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.group.combineCriteriaGroupsByOr, $event) || (ctx_r1.group.combineCriteriaGroupsByOr = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_6_Template_input_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.group.combineCriteriaGroupsByOr, $event) || (ctx_r1.group.combineCriteriaGroupsByOr = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "label", 11);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.group.id + "combineCriteriaGroupsByOr_and");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.group.combineCriteriaGroupsByOr);
    i0.ɵɵproperty("value", false)("name", ctx_r1.group.id + "combineCriteriaGroupsByOr");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.group.id + "combineCriteriaGroupsByOr_and");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 12, "genericSearch.criteriaGroup.and.label"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.group.id + "combineCriteriaGroupsByOr_or");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.group.combineCriteriaGroupsByOr);
    i0.ɵɵproperty("value", true)("name", ctx_r1.group.id + "combineCriteriaGroupsByOr");
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.group.id + "combineCriteriaGroupsByOr_or");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 14, "genericSearch.criteriaGroup.or.label"), " ");
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "genericSearch.criteriaGroup.include"), ": ");
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "genericSearch.criteriaGroup.exclude"), ": ");
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const widget_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, widget_r7.label), ": ", ctx_r1.widgetValueAsString(widget_r7), " ");
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_For_4_Conditional_1_Template, 3, 4, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const widget_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isValueToShow(widget_r7.value) ? 1 : -1);
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Conditional_1_Template, 3, 3, "strong")(2, HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Conditional_2_Template, 3, 3, "strong");
    i0.ɵɵrepeaterCreate(3, HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_For_4_Template, 2, 1, "span", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementStart(5, "button", 13);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵlistener("click", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Template_button_click_5_listener($event) {
      const criteriaGroup_r8 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.removeCriteriaGroup($event, criteriaGroup_r8));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 14);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵlistener("click", function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Template_button_click_7_listener($event) {
      const criteriaGroup_r8 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.editCriteriaGroup($event, criteriaGroup_r8));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const criteriaGroup_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(!criteriaGroup_r8.notInCriteriaGroup ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(criteriaGroup_r8.notInCriteriaGroup ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(criteriaGroup_r8.widgets);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(6, 4, "genericSearch.removeCriteriaGroup"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(8, 6, "genericSearch.editCriteriaGroup"));
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "ul", 12);
    i0.ɵɵrepeaterCreate(2, HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_For_3_Template, 9, 8, "li", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.group.criteriaGroups);
  }
}
function HisSearchCriteriagroupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("keydown.enter", function HisSearchCriteriagroupComponent_Conditional_0_Template_div_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.saveCriteriaGroup($event));
    });
    i0.ɵɵelementStart(1, "button", 2);
    i0.ɵɵlistener("click", function HisSearchCriteriagroupComponent_Conditional_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addCriteriaGroup($event));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, HisSearchCriteriagroupComponent_Conditional_0_Conditional_5_Template, 24, 32, "p-dialog", 3)(6, HisSearchCriteriagroupComponent_Conditional_0_Conditional_6_Template, 9, 16, "div")(7, HisSearchCriteriagroupComponent_Conditional_0_Conditional_7_Template, 4, 0, "div");
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelement(9, "his-helptext", 4);
    i0.ɵɵpipe(10, "hisUi");
    i0.ɵɵpipe(11, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "genericSearch.addCriteriaGroup"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.currentCriteriagroup ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.group.criteriaGroups.length > 1 ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.group.criteriaGroups.length > 0 && !ctx_r1.isAddMode && !ctx_r1.isEditMode ? 7 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("subtitle", i0.ɵɵpipeBind1(10, 8, "genericSearch.addCriteriaGroup"))("helptext", i0.ɵɵpipeBind1(11, 10, "genericSearch.criteriaGroup.helptext"));
  }
}
const _c3$2 = [[["", "passToForm", ""]]];
const _c4$2 = ["[passToForm]"];
function HisSearchFormResultComponent_Conditional_8_ng_template_1_Template(rf, ctx) {}
function HisSearchFormResultComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, HisSearchFormResultComponent_Conditional_8_ng_template_1_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
}
function HisSearchFormResultComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 8);
    i0.ɵɵelementStart(1, "button", 10);
    i0.ɵɵlistener("click", function HisSearchFormResultComponent_Conditional_9_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.submitSelection();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 11);
    i0.ɵɵlistener("click", function HisSearchFormResultComponent_Conditional_9_Template_button_click_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.cancelSelection();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "genericSearch.returnSelected"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 4, "genericSearch.backToParentSearch"));
  }
}
function HisSearchFormResultComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 9);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("click", function HisSearchFormResultComponent_Conditional_10_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.submitSelection());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 13);
    i0.ɵɵlistener("click", function HisSearchFormResultComponent_Conditional_10_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.cancelSelection());
    });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "genericSearch.returnSelected"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 4, "genericSearch.backToParentSearch"));
  }
}
const _c5$1 = ["*", [["", "passToPopUp", ""]]];
const _c6$1 = ["*", "[passToPopUp]"];
function HisSearchSelectPopupComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8, 0);
    i0.ɵɵlistener("click", function HisSearchSelectPopupComponent_Conditional_0_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.showSearchFormResultComponent();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r1.editMode)("hisImage", ctx_r1.selectButtonImage)("title", ctx_r1.selectButtonTooltip);
    i0.ɵɵattribute("aria-describedby", ctx_r1.errortextId ? ctx_r1.errortextId : "");
  }
}
function HisSearchSelectPopupComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9, 0);
    i0.ɵɵlistener("click", function HisSearchSelectPopupComponent_Conditional_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.showSearchFormResultComponent();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r1.editMode);
    i0.ɵɵattribute("aria-describedby", ctx_r1.errortextId ? ctx_r1.errortextId : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((ctx_r1.selectedOptions == null ? null : ctx_r1.selectedOptions.length) > 0 ? ctx_r1.changeSelectedItemsButtonLabel ? ctx_r1.changeSelectedItemsButtonLabel : i0.ɵɵpipeBind1(4, 3, "genericSearch.changeSelectedItems") : ctx_r1.selectItemsButtonLabel ? ctx_r1.selectItemsButtonLabel : i0.ɵɵpipeBind1(5, 5, "genericSearch.selectItems"));
  }
}
function HisSearchSelectPopupComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function HisSearchSelectPopupComponent_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.deleteAllSelectedOptions();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-describedby", ctx_r1.errortextId ? ctx_r1.errortextId : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "genericSearch.deleteSelectedItems"));
  }
}
function HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-search-form-result", 12, 1);
    i0.ɵɵlistener("selectionSubmited", function HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template_his_search_form_result_selectionSubmited_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSubmitSearchFormResultComponent($event));
    })("selectionCanceled", function HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template_his_search_form_result_selectionCanceled_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hideSearchFormResultComponent());
    })("readSearchSetSubmit", function HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template_his_search_form_result_readSearchSetSubmit_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.readSearchSetFromSearch($event));
    })("finishedInitialLoad", function HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template_his_search_form_result_finishedInitialLoad_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFinishedInitialLoad());
    })("formTitleLoaded", function HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template_his_search_form_result_formTitleLoaded_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFormTitleLoaded($event));
    });
    i0.ɵɵelementStart(2, "p", 13);
    i0.ɵɵprojection(3, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("renderTitle", false)("searchConfigFile", ctx_r1.searchConfigFile)("genericSearchRowTooltipId", ctx_r1.genericSearchRowTooltipId)("selectedOptions", ctx_r1.selectedOptions)("selectedOptionsIdColumn", ctx_r1.selectedOptionsIdColumn)("selectedOptionsLabelColumn", ctx_r1.selectedOptionsLabelColumn)("isSearchPopup", true)("resultRowsPerPage", ctx_r1.resultRowsPerPage)("selectionSetting", ctx_r1.selectionSetting)("renderCustomBottomResultButtons", false)("presetInputFields", ctx_r1.presetInputFields)("defaultSearchGroup", ctx_r1.defaultSearchGroup)("hiddenSearchCriteriaPaths", ctx_r1.hiddenSearchCriteriaPaths)("showTableFilter", ctx_r1.showTableFilter)("searchShowPrintviewButton", false)("hierarchyLevel", ctx_r1.hierarchyLevel);
  }
}
function HisSearchSelectPopupComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, HisSearchSelectPopupComponent_Conditional_7_Conditional_1_Template, 4, 16, "his-search-form-result", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.searchFormResultComponentVisible ? 1 : -1);
  }
}
function HisSearchSelectPopupComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 14);
    i0.ɵɵlistener("click", function HisSearchSelectPopupComponent_Conditional_10_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.searchFormResultComponent.submitSelection());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 15);
    i0.ɵɵlistener("click", function HisSearchSelectPopupComponent_Conditional_10_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.searchFormResultComponent.cancelSelection());
    });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "genericSearch.returnSelected"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 4, "genericSearch.backToParentSearch"));
  }
}
let HisSearchSelectComponent = /*#__PURE__*/(() => {
  class HisSearchSelectComponent extends HisSearchSelectComponentBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchSelectComponent_BaseFactory;
        return function HisSearchSelectComponent_Factory(__ngFactoryType__) {
          return (ɵHisSearchSelectComponent_BaseFactory || (ɵHisSearchSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchSelectComponent)))(__ngFactoryType__ || HisSearchSelectComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchSelectComponent,
        selectors: [["his-search-select"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 10,
        vars: 17,
        consts: [[1, "selectContainer"], [1, "slInputWrap"], [1, "dropdownEqualOperator"], [3, "uid", "removeSelectedOptionsFromDropdown", "selectedOptions", "searchEntity", "searchConfigFile", "minLength", "limit", "showDropdownIcon", "isFirstInputElement"], [3, "selectedOptionsChange", "searchConfigFile", "selectedOptions", "selectedOptionsIdColumn", "selectedOptionsLabelColumn", "selectItemsButtonLabel", "changeSelectedItemsButtonLabel", "resultRowsPerPage", "selectionSetting", "presetInputFields", "isFirstInputElement", "showTableFilter"], [1, "unsichtbar"], [1, "selectedOptionsList"], ["styleClass", "selectedDataContainer", 3, "value", "emptyMessage"], [3, "widget", "isFirstInputElement"], [3, "selected", "uid", "removeSelectedOptionsFromDropdown", "selectedOptions", "searchEntity", "searchConfigFile", "minLength", "limit", "showDropdownIcon", "isFirstInputElement"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"], ["type", "submit", 1, "transparent", "showAllSelectedOptionsButton", 3, "click", "title"], [1, "btnText"], ["hisImage", "ARROW_OUT", 1, "inlineicon", 3, "title"], ["hisImage", "ARROW_IN", 1, "inlineicon", 3, "title"]],
        template: function HisSearchSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, HisSearchSelectComponent_Conditional_2_Template, 2, 2, "div", 2)(3, HisSearchSelectComponent_Conditional_3_Template, 1, 9, "his-search-select-autocomplete", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "his-search-select-popup", 4);
            i0.ɵɵlistener("selectedOptionsChange", function HisSearchSelectComponent_Template_his_search_select_popup_selectedOptionsChange_4_listener($event) {
              return ctx.selectedOptionsChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(8, 6);
            i0.ɵɵtemplate(9, HisSearchSelectComponent_Conditional_9_Template, 2, 2, "p-dataView", 7);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showUnequalOption ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showAutocomplete ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("searchConfigFile", ctx.searchConfigFile)("selectedOptions", ctx.selectedOptions)("selectedOptionsIdColumn", ctx.selectedOptionsIdColumn)("selectedOptionsLabelColumn", ctx.selectedOptionsLabelColumn)("selectItemsButtonLabel", ctx.selectItemsButtonLabel)("changeSelectedItemsButtonLabel", ctx.changeSelectedItemsButtonLabel)("resultRowsPerPage", ctx.resultRowsPerPage)("selectionSetting", ctx.selectionSetting)("presetInputFields", ctx.presetInputFields)("isFirstInputElement", ctx.isFirstInputElement && !ctx.showUnequalOption && !ctx.showAutocomplete)("showTableFilter", ctx.showTableFilter);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 15, "common.components.selectManyPicklist.selected"), ":");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.selectedOptions.length > 0 ? 9 : -1);
          }
        },
        dependencies: () => [i2.PrimeTemplate, i2$3.DataView, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisSearchSelectPopupComponent, HisSearchSelectAutocompleteComponent, HisSearchSelectOperatorComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchFormWidgetComponent = /*#__PURE__*/(() => {
  class HisSearchFormWidgetComponent extends HisSearchFormWidgetComponentBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchFormWidgetComponent_BaseFactory;
        return function HisSearchFormWidgetComponent_Factory(__ngFactoryType__) {
          return (ɵHisSearchFormWidgetComponent_BaseFactory || (ɵHisSearchFormWidgetComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchFormWidgetComponent)))(__ngFactoryType__ || HisSearchFormWidgetComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchFormWidgetComponent,
        selectors: [["his-search-form-widget"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 13,
        vars: 6,
        consts: [["content", ""], [3, "formGroup"], [3, "label"], [3, "widget", "isFirstInputElement"], [3, "widget", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement", "selectFrom", "configFile"], [3, "widget", "uid", "selectedOptions", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement"], [3, "widget", "uid", "selectedOptions", "searchEntity", "searchConfigFile", "selectedOptionsIdColumn", "selectedOptionsLabelColumn", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement", "showTableFilter"], [3, "widget", "uid", "treename", "tree", "selectedData", "title", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement"], [3, "color"], [3, "changed", "widget", "isFirstInputElement"], [3, "changed", "widget", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement", "selectFrom", "configFile"], [3, "changed", "widget", "uid", "selectedOptions", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement"], [3, "changed", "widget", "uid", "selectedOptions", "searchEntity", "searchConfigFile", "selectedOptionsIdColumn", "selectedOptionsLabelColumn", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement", "showTableFilter"], [3, "changed", "widget", "uid", "treename", "tree", "selectedData", "title", "minLength", "limit", "showDropdownIcon", "showUnequalOption", "isFirstInputElement"]],
        template: function HisSearchFormWidgetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "his-plam", 2);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "div");
            i0.ɵɵtemplate(4, HisSearchFormWidgetComponent_Case_4_Template, 2, 2, "his-search-checkbox", 3)(5, HisSearchFormWidgetComponent_Case_5_Template, 2, 2, "his-search-input", 3)(6, HisSearchFormWidgetComponent_Case_6_Template, 2, 2, "his-search-calendar", 3)(7, HisSearchFormWidgetComponent_Case_7_Template, 2, 8, "his-search-autocomplete", 4)(8, HisSearchFormWidgetComponent_Case_8_Template, 2, 9, "his-search-multiselect", 5)(9, HisSearchFormWidgetComponent_Case_9_Template, 2, 14, "his-search-select", 6)(10, HisSearchFormWidgetComponent_Case_10_Template, 3, 14, "his-search-tree-select", 7)(11, HisSearchFormWidgetComponent_Case_11_Template, 2, 1, "div");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, HisSearchFormWidgetComponent_Conditional_12_Template, 3, 2, "div", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance();
            i0.ɵɵproperty("label", ctx.widget.kind !== "checkbox" ? i0.ɵɵpipeBind1(2, 4, ctx.widget.label) : " ");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((tmp_2_0 = ctx.widget.kind) === "checkbox" ? 4 : tmp_2_0 === "input" ? 5 : tmp_2_0 === "calendar" ? 6 : tmp_2_0 === "dropdown" ? 7 : tmp_2_0 === "multi-dropdown" ? 8 : tmp_2_0 === "search-select" ? 9 : tmp_2_0 === "tree-select" ? 10 : 11);
            i0.ɵɵadvance(8);
            i0.ɵɵconditional(ctx.showErrors && !ctx.isValid ? 12 : -1);
          }
        },
        dependencies: [i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, HisPlamComponent, HisSearchInputComponent, HisSearchCheckboxComponent, HisSearchCalendarComponent, HisSearchAutocompleteComponent, HisSearchMultiselectComponent, HisSearchSelectComponent, HisSearchTreeSelectComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchFormWidgetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchFormComponent = /*#__PURE__*/(() => {
  class HisSearchFormComponent extends HisSearchFormComponentBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchFormComponent_BaseFactory;
        return function HisSearchFormComponent_Factory(__ngFactoryType__) {
          return (ɵHisSearchFormComponent_BaseFactory || (ɵHisSearchFormComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchFormComponent)))(__ngFactoryType__ || HisSearchFormComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchFormComponent,
        selectors: [["his-search-form"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2$4,
        decls: 1,
        vars: 1,
        consts: [["formSearchButtons", ""], [3, "level", "value"], [1, "clearer"], [1, "searchFormContainer"], [3, "keydown.enter", "formGroup"], [1, "hiddenButton"], ["appScrollwithme", "", 1, "form-row", "genericSearchbuttonsTop", "displayInline"], [1, "submitSearchFormButton"], [1, "resetInputsButton", 3, "click"], ["hisImage", "ARROW_RIGHT_FAT", 1, "transparent", "hasQuickSearchCriteriaButton"], ["hisImage", "INFORMATION", "rel", "noopener", "tabindex", "", 1, "transparent", 3, "href", "title"], [3, "configFile", "form", "widgetGroups", "searchFormData", "searchForm", "callerId"], [1, "clearerSpaceAboveHalfEm"], [1, "layoutBlock"], [1, "columnHalfLeft"], [3, "id", "class"], [1, "columnHalfRight"], [1, "form-row", "genericSearchbuttonsBottom"], ["type", "submit", 1, "submitSearchFormButton"], ["href", "../../pages/genericSearch/genericSearchHelp.faces", "hisImage", "LINK_EXTERN", "rel", "noopener", "tabindex", "", 1, "transparent", 3, "title"], [1, "hiddenButton", 3, "click"], [1, "submitSearchFormButton", 3, "click"], ["hisImage", "ARROW_RIGHT_FAT", 1, "transparent", "hasQuickSearchCriteriaButton", 3, "click"], [3, "id"], [3, "toggleable"], ["pTemplate", "header"], [3, "group", "form", "widgetGroups"], [3, "widget", "form", "showErrors", "isFirstInputElement"], [2, "margin", "0px"], ["type", "submit", 1, "submitSearchFormButton", 3, "click"]],
        template: function HisSearchFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$9);
            i0.ɵɵtemplate(0, HisSearchFormComponent_Conditional_0_Template, 4, 2, "div");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.showSearchForm ? 0 : -1);
          }
        },
        dependencies: () => [i1$1.ɵNgNoValidate, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i2.PrimeTemplate, i4$1.Panel, HisImageDirective, HisFormDefaultsDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisScrollwithmeDirective, HisButtonTitleDirective, HisPanelDirective, HisHeadingComponent, HisSearchFormWidgetComponent, HisSearchCriteriagroupComponent, HisSearchSaveParamsComponent, i1$2.JsonPipe, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchCriteriagroupComponent = /*#__PURE__*/(() => {
  class HisSearchCriteriagroupComponent extends HisSearchCriteriagroupComponentBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchCriteriagroupComponent_BaseFactory;
        return function HisSearchCriteriagroupComponent_Factory(__ngFactoryType__) {
          return (ɵHisSearchCriteriagroupComponent_BaseFactory || (ɵHisSearchCriteriagroupComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchCriteriagroupComponent)))(__ngFactoryType__ || HisSearchCriteriagroupComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchCriteriagroupComponent,
        selectors: [["his-search-criteriagroup"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["content", ""], [3, "keydown.enter"], ["hisImage", "tag_group_add", 1, "transparent", 3, "click"], [3, "visible", "draggable", "closeOnEscape", "resizable", "responsive", "modal", "blockScroll"], [3, "subtitle", "helptext"], [3, "visibleChange", "onHide", "visible", "draggable", "closeOnEscape", "resizable", "responsive", "modal", "blockScroll"], ["styleClass", "noLabelContentLine_50", "label", " "], ["name", "includeExcludeCriteriaGroup", 1, "plamOptionVertical", 3, "ngModelChange", "ngModel", "value", "label"], [3, "click"], [3, "widget", "form", "showErrors"], ["type", "radio", 3, "ngModelChange", "id", "ngModel", "value", "name"], [3, "for"], [1, "listStyleIconSimple"], ["hisImage", "delete", 1, "transparent", 3, "click", "title"], ["hisImage", "pencil", 1, "transparent", 3, "click", "title"]],
        template: function HisSearchCriteriagroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSearchCriteriagroupComponent_Conditional_0_Template, 12, 12, "div");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.group.criteriaGroup ? 0 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.RadioControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.Header, i3.Dialog, i26.RadioButton, HisPlamComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisDeleteActionDirective, HisHelptextComponent, HisSearchFormWidgetComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchCriteriagroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchFormResultComponent = /*#__PURE__*/(() => {
  class HisSearchFormResultComponent extends HisSearchFormResultComponentBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchFormResultComponent_BaseFactory;
        return function HisSearchFormResultComponent_Factory(__ngFactoryType__) {
          return (ɵHisSearchFormResultComponent_BaseFactory || (ɵHisSearchFormResultComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchFormResultComponent)))(__ngFactoryType__ || HisSearchFormResultComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchFormResultComponent,
        selectors: [["his-search-form-result"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c4$2,
        decls: 11,
        vars: 31,
        consts: [["SearchFormComponent", ""], ["SearchResultComponent", ""], ["rowAction", ""], [1, "searchFormResultContainer"], [3, "searchSubmitted", "formTitleLoaded", "renderTitle", "configFile", "isSearchFormResult", "isSearchPopup", "presetInputFields", "hiddenSearchCriteriaPaths", "searchShowSearchParamsBox", "hierarchyLevel"], ["customSearchSet", ""], [1, "clearerSpaceAboveHalfEm"], [3, "singleSelectionSubmited", "filterToggled", "finishedInitialLoad", "searchConfigFile", "genericSearchRowTooltipId", "isSearchFormResult", "hisIcon", "isSearchPopup", "selectionSetting", "resultTableStyle", "selectedOptions", "selectedOptionsIdColumn", "selectedOptionsLabelColumn", "showNewSearchButton", "showChangeSearchButton", "showSearchInfo", "resultRowsPerPage", "customResultRowsTemplate", "showTableFilter", "searchShowPrintviewButton", "hierarchyLevel"], ["customResultButtons", ""], ["customBottomResultButtons", ""], ["type", "submit", "iconPos", "left", "hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"], ["type", "submit", "iconPos", "left", "hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"], ["iconPos", "left", "hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"], ["iconPos", "left", "hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"]],
        template: function HisSearchFormResultComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c3$2);
            i0.ɵɵelementStart(0, "div", 3)(1, "his-search-form", 4, 0);
            i0.ɵɵlistener("searchSubmitted", function HisSearchFormResultComponent_Template_his_search_form_searchSubmitted_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmitSearch($event));
            })("formTitleLoaded", function HisSearchFormResultComponent_Template_his_search_form_formTitleLoaded_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFormTitleLoaded($event));
            });
            i0.ɵɵelementStart(3, "p", 5);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(5, "div", 6);
            i0.ɵɵelementStart(6, "his-search-result", 7, 1);
            i0.ɵɵlistener("singleSelectionSubmited", function HisSearchFormResultComponent_Template_his_search_result_singleSelectionSubmited_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.submitSingleSelection($event));
            })("filterToggled", function HisSearchFormResultComponent_Template_his_search_result_filterToggled_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleTableFilter($event));
            })("finishedInitialLoad", function HisSearchFormResultComponent_Template_his_search_result_finishedInitialLoad_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFinishedInitialLoad());
            });
            i0.ɵɵtemplate(8, HisSearchFormResultComponent_Conditional_8_Template, 3, 0, "span")(9, HisSearchFormResultComponent_Conditional_9_Template, 9, 6, "ng-container", 8)(10, HisSearchFormResultComponent_Conditional_10_Template, 9, 6, "ng-container", 9);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("renderTitle", ctx.renderTitle)("configFile", ctx.searchConfigFile)("isSearchFormResult", true)("isSearchPopup", ctx.isSearchPopup)("presetInputFields", ctx.presetInputFields)("hiddenSearchCriteriaPaths", ctx.hiddenSearchCriteriaPaths)("searchShowSearchParamsBox", false)("hierarchyLevel", ctx.hierarchyLevel);
            i0.ɵɵadvance(5);
            i0.ɵɵclassMap(ctx.searchResultComponent.initialLoadFinished ? "" : "hiddenQuicksearchElement");
            i0.ɵɵproperty("searchConfigFile", ctx.searchConfigFile)("genericSearchRowTooltipId", ctx.genericSearchRowTooltipId)("isSearchFormResult", true)("hisIcon", ctx.hisIcon)("isSearchPopup", ctx.isSearchPopup)("selectionSetting", ctx.selectionSetting)("resultTableStyle", ctx.resultTableStyle)("selectedOptions", ctx.selectedOptions)("selectedOptionsIdColumn", ctx.selectedOptionsIdColumn)("selectedOptionsLabelColumn", ctx.selectedOptionsLabelColumn)("showNewSearchButton", false)("showChangeSearchButton", false)("showSearchInfo", false)("resultRowsPerPage", ctx.resultRowsPerPage)("customResultRowsTemplate", ctx.customResultRowsTemplate)("showTableFilter", ctx.showTableFilter)("searchShowPrintviewButton", ctx.searchShowPrintviewButton)("hierarchyLevel", ctx.hierarchyLevel);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showTableFilter && ctx.toggleFilter ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectionSetting === ctx.selectionSettingEnum.MultiSelect ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectionSetting === ctx.selectionSettingEnum.MultiSelect && ctx.renderCustomBottomResultButtons ? 10 : -1);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisSearchFormComponent, HisSearchResultComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchFormResultComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const HISSEARCHSELECTPOPUPCOMPONENT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => HisSearchSelectPopupComponent),
  multi: true
};
let HisSearchSelectPopupComponent = /*#__PURE__*/(() => {
  class HisSearchSelectPopupComponent extends HisSearchSelectPopupComponentBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisSearchSelectPopupComponent_BaseFactory;
        return function HisSearchSelectPopupComponent_Factory(__ngFactoryType__) {
          return (ɵHisSearchSelectPopupComponent_BaseFactory || (ɵHisSearchSelectPopupComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisSearchSelectPopupComponent)))(__ngFactoryType__ || HisSearchSelectPopupComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchSelectPopupComponent,
        selectors: [["his-search-select-popup"]],
        standalone: false,
        features: [i0.ɵɵProvidersFeature([HISSEARCHSELECTPOPUPCOMPONENT_VALUE_ACCESSOR]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c6$1,
        decls: 11,
        vars: 13,
        consts: [["inputElement", ""], ["SearchFormResultComponent", ""], ["type", "submit", "alt", "", 1, "icon", 3, "disabled", "hisImage", "title"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton"], ["appendTo", "body", "styleClass", "minWidth90", 3, "visibleChange", "onHide", "visible", "modal", "blockScroll", "focusTrap"], [3, "level", "value"], [1, "searchresult"], ["type", "submit", "alt", "", 1, "icon", 3, "click", "disabled", "hisImage", "title"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "click", "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton", 3, "click"], [3, "renderTitle", "searchConfigFile", "genericSearchRowTooltipId", "selectedOptions", "selectedOptionsIdColumn", "selectedOptionsLabelColumn", "isSearchPopup", "resultRowsPerPage", "selectionSetting", "renderCustomBottomResultButtons", "presetInputFields", "defaultSearchGroup", "hiddenSearchCriteriaPaths", "showTableFilter", "searchShowPrintviewButton", "hierarchyLevel"], [3, "selectionSubmited", "selectionCanceled", "readSearchSetSubmit", "finishedInitialLoad", "formTitleLoaded", "renderTitle", "searchConfigFile", "genericSearchRowTooltipId", "selectedOptions", "selectedOptionsIdColumn", "selectedOptionsLabelColumn", "isSearchPopup", "resultRowsPerPage", "selectionSetting", "renderCustomBottomResultButtons", "presetInputFields", "defaultSearchGroup", "hiddenSearchCriteriaPaths", "showTableFilter", "searchShowPrintviewButton", "hierarchyLevel"], ["passToForm", ""], ["iconPos", "left", "hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"], ["iconPos", "left", "hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"]],
        template: function HisSearchSelectPopupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5$1);
            i0.ɵɵtemplate(0, HisSearchSelectPopupComponent_Conditional_0_Template, 2, 4, "button", 2)(1, HisSearchSelectPopupComponent_Conditional_1_Template, 6, 7, "button", 3)(2, HisSearchSelectPopupComponent_Conditional_2_Template, 4, 4, "button", 4);
            i0.ɵɵelementStart(3, "p-dialog", 5);
            i0.ɵɵtwoWayListener("visibleChange", function HisSearchSelectPopupComponent_Template_p_dialog_visibleChange_3_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.searchFormResultComponentVisible, $event) || (ctx.searchFormResultComponentVisible = $event);
              return $event;
            });
            i0.ɵɵlistener("onHide", function HisSearchSelectPopupComponent_Template_p_dialog_onHide_3_listener() {
              return ctx.hideSearchFormResultComponent();
            });
            i0.ɵɵelementStart(4, "p-header");
            i0.ɵɵelement(5, "his-heading", 6);
            i0.ɵɵpipe(6, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, HisSearchSelectPopupComponent_Conditional_7_Template, 2, 1, "div", 7);
            i0.ɵɵprojection(8);
            i0.ɵɵelementStart(9, "p-footer");
            i0.ɵɵtemplate(10, HisSearchSelectPopupComponent_Conditional_10_Template, 9, 6, "ng-container");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.selectButtonImage && ctx.searchConfigFile ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.selectButtonImage && ctx.searchConfigFile ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDeleteButton && ctx.selectionSetting === ctx.selectionSettingEnum.MultiSelect && ctx.selectedOptions.length > 0 && ctx.searchConfigFile ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("visible", ctx.searchFormResultComponentVisible);
            i0.ɵɵproperty("modal", true)("blockScroll", true)("focusTrap", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("level", ctx.hierarchyLevel)("value", i0.ɵɵpipeBind1(6, 11, ctx.formTitle || ctx.genericFallbackTitle));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.searchConfigFile ? 7 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.showFooterButtons && ctx.selectionSetting === ctx.selectionSettingEnum.MultiSelect ? 10 : -1);
          }
        },
        dependencies: [i2.Header, i2.Footer, i3.Dialog, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisHeadingComponent, HisSearchFormResultComponent, HisUiPipe],
        styles: [".ui-dialog{max-height:90%}"]
      });
    }
  }
  return HisSearchSelectPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisGlobalDataService = /*#__PURE__*/(() => {
  class HisGlobalDataService {
    constructor() {
      this.navigationService = inject(HisNavigationService);
      this.SUBMIT_SUCCESS_MESSAGE = 'submitSuccessMessage';
      this.data = new Map();
      this.dirty = new Map();
    }
    setData(key, value) {
      if (key === this.SUBMIT_SUCCESS_MESSAGE && value) {
        this.navigationService.dirty = false;
      }
      this.data.set(key, value);
      this.dirty.set(key, this.navigationService.dirty);
    }
    getData(key, restoreDirty) {
      if (restoreDirty && this.getDirty(key)) {
        // getData is typically called before dirtyTracking is enabled
        queueMicrotask(() => {
          this.navigationService.dirty = true;
        });
      }
      return this.data.get(key);
    }
    getDirty(key) {
      return this.dirty.get(key);
    }
    markDirty(key) {
      this.dirty.set(key, true);
    }
    removeData(key) {
      this.data.delete(key);
      this.dirty.delete(key);
    }
    static {
      this.ɵfac = function HisGlobalDataService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisGlobalDataService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisGlobalDataService,
        factory: HisGlobalDataService.ɵfac
      });
    }
  }
  return HisGlobalDataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-underscore-dangle */
let HisDynamicFormGroupUtils = /*#__PURE__*/(() => {
  class HisDynamicFormGroupUtils {
    constructor() {
      this.globalDataService = inject(HisGlobalDataService);
      this.FORMGROUPVALUE = 'dynamicformGroupValue';
    }
    /* set dynamic component for object from dynamic container components */
    setDynamicComponentObject(dynamicContentObject) {
      if (dynamicContentObject._dynamicComponent) {
        let formGroupValue = {};
        let globalDataFormGroupValue = this.globalDataService.getData(this.FORMGROUPVALUE);
        if (globalDataFormGroupValue) {
          dynamicContentObject._dynamicComponent.guiComponent.children.forEach(tabChild => {
            tabChild.children.forEach(fieldsetChild => {
              if (fieldsetChild) {
                if (!formGroupValue[fieldsetChild.name]) {
                  formGroupValue[fieldsetChild.name] = globalDataFormGroupValue[fieldsetChild.name];
                } else {
                  Object.assign(formGroupValue[fieldsetChild.name], globalDataFormGroupValue[fieldsetChild.name]);
                }
              }
            });
          });
        }
        dynamicContentObject._dynamicComponent = this.convertFormGroupValueToDynamicObjects(formGroupValue, dynamicContentObject._dynamicComponent);
      }
    }
    convertFormGroupValueToDynamicObjects(formGroupValue, dynamicComponentRoot) {
      // console.log('formGroupValue =', formGroupValue);
      if (dynamicComponentRoot) {
        dynamicComponentRoot.guiComponent.children.forEach(tabChild => {
          tabChild.children.forEach(fieldsetChild => {
            if (fieldsetChild) {
              this.convertFormValueToDynamicObjectsRecurrent(formGroupValue[fieldsetChild.name], fieldsetChild, dynamicComponentRoot.dynamicObjects);
            }
          });
        });
      }
      return dynamicComponentRoot;
    }
    convertFormValueToDynamicObjectsRecurrent(formValue, guiComponent, dynamicObjects) {
      if (formValue) {
        // console.log('dynamicComponent =', dynamicComponent, ', formValue =', formValue);
        if (guiComponent.fields) {
          guiComponent.fields.forEach(fieldChild => {
            // console.log('field', field.name, 'gets value', formValue[field.name]);
            let dynamicObject = dynamicObjects.find(dO => dO.objGuid === fieldChild.objectUID);
            if (dynamicObject) {
              let dynamicObjectValue = dynamicObject.values.find(dV => dV.attributeName === fieldChild.attributeName);
              if (dynamicObjectValue) {
                dynamicObjectValue.value = formValue[fieldChild.name];
              }
            }
          });
        }
        if (guiComponent.children) {
          guiComponent.children.forEach(fieldChild => {
            if (fieldChild) {
              this.convertFormValueToDynamicObjectsRecurrent(formValue[fieldChild.name], fieldChild, dynamicObjects);
            }
          });
        }
      }
    }
    static {
      this.ɵfac = function HisDynamicFormGroupUtils_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicFormGroupUtils)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDynamicFormGroupUtils,
        factory: HisDynamicFormGroupUtils.ɵfac
      });
    }
  }
  return HisDynamicFormGroupUtils;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-underscore-dangle */
class HisDdRegistryObject {
  constructor(object, target, retainHiddenValues) {
    this.object = object;
    this.target = target;
    this.hisDdDirectives = [];
    this.retainHiddenValues = retainHiddenValues;
  }
}
let HisDdDirectiveRegistryService = /*#__PURE__*/(() => {
  class HisDdDirectiveRegistryService {
    constructor() {
      this.backendService = inject(HisBackendService);
      this.dynamicFormGroupUtils = inject(HisDynamicFormGroupUtils);
      this.hisDdRegistryObject = new HisDdRegistryObject();
    }
    setRegisterObject(object, target, retainHiddenValues) {
      this.hisDdRegistryObject = new HisDdRegistryObject(object, target, retainHiddenValues);
    }
    refreshObject(object) {
      if (this.hisDdRegistryObject.object) {
        this.hisDdRegistryObject.object = object;
        // console.log( '#HisDdDirectiveRegistryService.refreshObject() this.hisDdRegistryObject: ', this.hisDdRegistryObject );
        // when loading onject we need to check for context changes with subscribed object
        this.checkForAnyContextChanges();
      }
    }
    registerHisDdDirective(hisDdDirective) {
      if (this.hisDdRegistryObject.object) {
        if (!this.hisDdRegistryObject.hisDdDirectives) {
          this.hisDdRegistryObject.hisDdDirectives = [];
        }
        if (this.isNotRegistered(hisDdDirective)) {
          // console.log( '#HisDdDirectiveRegistryService.registerHisDdDirective() :', hisDdDirective.hisDdKey );
          this.hisDdRegistryObject.hisDdDirectives.push(hisDdDirective);
        }
      } else {
        console.log('#HisDdDirectiveRegistryService.registerHisDdDirective() no valid hisDdRegistryObject found: ', this.hisDdRegistryObject.object);
      }
    }
    checkForContextChanges(hisDdKey) {
      // console.log( '#HisDdDirectiveRegistryService.checkForContextChanges(): ', hisDdKey );
      // check for triggers for perfermonce - we should not call backend on every change
      if (this.hisDdRegistryObject.object && this.hisDdRegistryObject.object._dynamicComponent !== null && this.hisDdRegistryObject.object._dynamicComponent?.conditions?.triggers.indexOf(hisDdKey) >= 0) {
        this.backendService.postData(`api/v1/cs/sys/objectContextManager/manageContext/${this.hisDdRegistryObject.target}`, this.getManageContextPayload()).subscribe(managedContexts => {
          this.managedContexts = managedContexts;
          // console.log( '#HisDdDirectiveRegistryService.checkForContextChanges() managedContexts: ', managedContexts );
          this.hisDdRegistryObject.hisDdDirectives.forEach(hisDdDirective => {
            // trigger changes for HisDdDirective
            this.triggerChanges(hisDdDirective, managedContexts);
          });
        });
      }
    }
    checkForAnyContextChanges() {
      if (this.hisDdRegistryObject.hisDdDirectives) {
        this.hisDdRegistryObject.hisDdDirectives.map(ddDirective => ddDirective.hisDdKey).forEach(ddKey => {
          this.checkForContextChanges(ddKey);
        });
      }
    }
    triggerChanges(hisDdDirective, contexts) {
      if (hisDdDirective) {
        hisDdDirective.hisDdContexts = [...contexts];
        hisDdDirective.findElementRef().hisDdContexts = [...contexts];
        hisDdDirective.notifyDdKeyOrContextsChanged();
      }
    }
    getManageContextPayload() {
      if (this.hisDdRegistryObject.object._dynamicComponent?.dynamicObjects && !!this.hisDdRegistryObject.object._dynamicComponent.dynamicObjects.length) {
        // create new object without reference, cause setDynamicComponentObject()
        // should not set dynamicObject values on original object
        let copyObject = JSON.parse(JSON.stringify(this.hisDdRegistryObject.object));
        // update dynamic objects from formGroupValues
        this.dynamicFormGroupUtils.setDynamicComponentObject(copyObject);
        return copyObject;
      }
      return this.hisDdRegistryObject.object;
    }
    getManagedContexts() {
      return this.managedContexts;
    }
    resetObjectValue(ddKey) {
      let attributeName = ddKey.split('.').pop();
      if (this.hisDdRegistryObject && this.hisDdRegistryObject.object && Object.prototype.hasOwnProperty.call(this.hisDdRegistryObject.object, attributeName)) {
        let currentValue = this.hisDdRegistryObject.object[attributeName];
        if (!this.hisDdRegistryObject.retainHiddenValues) {
          this.hisDdRegistryObject.object[attributeName] = null;
        }
      }
    }
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    }
    clearHisDdRegistryObject() {
      this.hisDdRegistryObject = new HisDdRegistryObject();
    }
    debugHisDdRegistryObject() {
      console.log('#HisDdDirectiveRegistryService.debugHisDdRegistryObject: ', this.hisDdRegistryObject);
    }
    debugHisDdRegistryDirectives() {
      this.hisDdRegistryObject.hisDdDirectives.forEach(ddDirective => console.log('##HisDdDirectiveRegistryService.debugHisDdRegistryDirectives hisDdKey: ', ddDirective.hisDdKey));
    }
    isNotRegistered(hisDdDirective) {
      return this.hisDdRegistryObject.hisDdDirectives.indexOf(hisDdDirective) === -1;
    }
    generateInitialDynamicContent() {
      if (!this.hisDdRegistryObject.target) {
        console.error('No target specified. Did you call \'registerHisDdDirective\' before?');
      }
      return this.backendService.getData(`api/v1/cs/sys/objectContextManager/generateConditions/${this.hisDdRegistryObject.target}`);
    }
    static {
      this.ɵfac = function HisDdDirectiveRegistryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDdDirectiveRegistryService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDdDirectiveRegistryService,
        factory: HisDdDirectiveRegistryService.ɵfac
      });
    }
  }
  return HisDdDirectiveRegistryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$p = ["selectTable"];
const _c1$8 = ["autoComplete1"];
const _c2$3 = ["autoComplete2"];
function HisMultiselectComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-autoComplete", 13, 0);
    i0.ɵɵlistener("onSelect", function HisMultiselectComponent_Conditional_0_Template_p_autoComplete_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectEvent($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1._selectedOptions)("hisEagerDataSource", ctx_r1.dataSource)("minLength", ctx_r1.minLength)("dropdown", ctx_r1.showDropdownIcon)("forceSelection", true)("hisDdKey", ctx_r1.hisDdKey)("disabled", !ctx_r1.editMode)("inputId", ctx_r1.inputId);
  }
}
function HisMultiselectComponent_Conditional_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r4.label, " ");
  }
}
function HisMultiselectComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-autoComplete", 14, 1);
    i0.ɵɵlistener("completeMethod", function HisMultiselectComponent_Conditional_1_Template_p_autoComplete_completeMethod_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.filterSelectList($event));
    })("onSelect", function HisMultiselectComponent_Conditional_1_Template_p_autoComplete_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectEvent($event));
    });
    i0.ɵɵtemplate(3, HisMultiselectComponent_Conditional_1_ng_template_3_Template, 1, 1, "ng-template", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1._selectedOptions)("suggestions", ctx_r1.filteredSelectList)("minLength", ctx_r1.minLength)("dropdown", ctx_r1.showDropdownIcon)("forceSelection", true)("hisDdKey", ctx_r1.hisDdKey)("inputId", ctx_r1.inputId);
  }
}
function HisMultiselectComponent_Conditional_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 27);
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_2_Conditional_7_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.toggleFilter();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.toggleTableFilter ? i0.ɵɵpipeBind1(4, 1, "de.his.faces.tags.table.tableFilter.disable") : i0.ɵɵpipeBind1(5, 3, "de.his.faces.tags.table.tableFilter.enable"));
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 33);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.filter, $event) || (ctx_r1.filter = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onFilter($event));
    })("keydown.enter", function HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template_input_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.onFilterTable());
    })("keydown.space", function HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template_input_keydown_space_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.stopPropagation());
    })("click", function HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template_input_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.filter);
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th", 28);
    i0.ɵɵelement(2, "p-tableHeaderCheckbox", 29);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "span", 30);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "th", 31);
    i0.ɵɵtext(8);
    i0.ɵɵelement(9, "p-sortIcon", 32);
    i0.ɵɵtemplate(10, HisMultiselectComponent_Conditional_2_ng_template_11_Conditional_10_Template, 3, 4, "div");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 6, "genericSearch.selectAllOfPage"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, "genericSearch.rowselect"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pSortableColumn", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", "label");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.toggleTableFilter ? 10 : -1);
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 28);
    i0.ɵɵelement(2, "p-tableCheckbox", 34);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r8 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 4, "genericSearch.selectItems"));
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 6, "genericSearch.selectItems"));
    i0.ɵɵproperty("value", row_r8);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(row_r8.label);
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_13_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, "de.his.faces.tags.table.datascroller.numRowsFound.page", ctx_r1.currentPageNumber, ctx_r1.totalNumberOfPages), " | ");
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_13_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "de.his.faces.tags.table.datascroller.numRowsPerPage"), " (Max:", ctx_r1.maxRows, ") ");
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_13_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(1, 2, "de.his.faces.tags.table.datascroller.numRowsPerPage"), " ", i0.ɵɵpipeBind1(2, 4, "de.his.faces.tags.table.datascroller.maxNumRowsPerPage"), " ");
  }
}
function HisMultiselectComponent_Conditional_2_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵtemplate(5, HisMultiselectComponent_Conditional_2_ng_template_13_Conditional_5_Template, 2, 5);
    i0.ɵɵelementStart(6, "label", 36);
    i0.ɵɵtemplate(7, HisMultiselectComponent_Conditional_2_ng_template_13_Conditional_7_Template, 3, 4, "span")(8, HisMultiselectComponent_Conditional_2_ng_template_13_Conditional_8_Template, 3, 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 37, 3);
    i0.ɵɵlistener("blur", function HisMultiselectComponent_Conditional_2_ng_template_13_Template_input_blur_9_listener() {
      i0.ɵɵrestoreView(_r9);
      const content_r10 = i0.ɵɵreference(10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateAndRefresh(content_r10));
    })("keyup.enter", function HisMultiselectComponent_Conditional_2_ng_template_13_Template_input_keyup_enter_9_listener() {
      i0.ɵɵrestoreView(_r9);
      const content_r10 = i0.ɵɵreference(10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.validateAndRefresh(content_r10));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(3, 5, "de.his.faces.tags.table.datascroller.numRowsFound.label"), " ", i0.ɵɵpipeBind2(4, 7, ctx_r1.i18nKeyForRecords, ctx_r1.totalRowCount), " | ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.totalNumberOfPages > 1 ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.maxRows ? 7 : 8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r1.resultRowsPerPage);
  }
}
function HisMultiselectComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dialog", 16);
    i0.ɵɵtwoWayListener("visibleChange", function HisMultiselectComponent_Conditional_2_Template_p_dialog_visibleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.multiselectPopupVisible, $event) || (ctx_r1.multiselectPopupVisible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onHide", function HisMultiselectComponent_Conditional_2_Template_p_dialog_onHide_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hideMultiselectPopup());
    });
    i0.ɵɵelementStart(1, "p-header")(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "div", 17);
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵtemplate(7, HisMultiselectComponent_Conditional_2_Conditional_7_Template, 6, 5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 19);
    i0.ɵɵelementStart(9, "p-table", 20, 2);
    i0.ɵɵtwoWayListener("selectionChange", function HisMultiselectComponent_Conditional_2_Template_p_table_selectionChange_9_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedRows, $event) || (ctx_r1.selectedRows = $event);
      return i0.ɵɵresetView($event);
    })("firstChange", function HisMultiselectComponent_Conditional_2_Template_p_table_firstChange_9_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.firstResultRow, $event) || (ctx_r1.firstResultRow = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onPage", function HisMultiselectComponent_Conditional_2_Template_p_table_onPage_9_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPage($event));
    });
    i0.ɵɵtemplate(11, HisMultiselectComponent_Conditional_2_ng_template_11_Template, 11, 10, "ng-template", 21)(12, HisMultiselectComponent_Conditional_2_ng_template_12_Template, 7, 8, "ng-template", 22)(13, HisMultiselectComponent_Conditional_2_ng_template_13_Template, 11, 10, "ng-template", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p-footer")(15, "button", 24);
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_2_Template_button_click_15_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.submitSelection();
      ctx_r1.hideMultiselectPopup();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(16, "span", 25);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "button", 26);
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_2_Template_button_click_19_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.cancelSelection();
      ctx_r1.hideMultiselectPopup();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(20, "span", 25);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "hisUi");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("visible", ctx_r1.multiselectPopupVisible);
    i0.ɵɵproperty("responsive", true)("modal", true)("blockScroll", true)("focusTrap", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 16, "multiselectPlam.selectValues"), " ", ctx_r1.label, "");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.showTableFilter ? 7 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r1.selectList)("paginator", true)("selectionPageOnly", true)("rows", ctx_r1.resultRowsPerPage);
    i0.ɵɵtwoWayProperty("selection", ctx_r1.selectedRows)("first", ctx_r1.firstResultRow);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 18, "genericSearch.returnSelected"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 20, "genericSearch.backToParentSearch"));
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 42);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_For_3_Conditional_0_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const selectedOption_r12 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.deleteSelectedOption(selectedOption_r12));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOption_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r12.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("title", "", selectedOption_r12.label, ": ", i0.ɵɵpipeBind1(3, 4, "view.controls.disconnect"), "");
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_For_3_Conditional_0_Template, 4, 6, "li", 41);
  }
  if (rf & 2) {
    const ɵ$index_129_r13 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵconditional(!ctx_r1.maxDisplayedSelections || ctx_r1.showAllSelectedOptions || ɵ$index_129_r13 < ctx_r1.maxDisplayedSelections - 1 || ctx_r1.maxDisplayedSelections === ctx_r1._selectedOptions.length ? 0 : -1);
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 41)(1, "button", 43);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Conditional_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      $event.stopPropagation();
      ctx_r1.toggleShowAllSelectedOptions();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 44);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 45);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 4, "common.components.selectManyPicklist.showAllSelected"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("... ", ctx_r1._selectedOptions.length - ctx_r1.maxDisplayedSelections + 1, " ", i0.ɵɵpipeBind1(5, 6, "common.components.selectManyPicklist.more"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 8, "common.components.selectManyPicklist.showAllSelected"));
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 41)(1, "button", 43);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Conditional_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(5);
      $event.stopPropagation();
      ctx_r1.toggleShowAllSelectedOptions();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(3, "span", 44);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "img", 46);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "common.components.selectManyPicklist.showLess"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 7, "common.components.selectManyPicklist.showLess"));
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Conditional_0_Template, 8, 10, "li", 41)(1, HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Conditional_1_Template, 8, 9, "li", 41);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵconditional(!ctx_r1.showAllSelectedOptions ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAllSelectedOptions ? 1 : -1);
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40)(1, "ul");
    i0.ɵɵrepeaterCreate(2, HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_For_3_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(4, HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Conditional_4_Template, 2, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1._selectedOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.maxDisplayedSelections && ctx_r1.maxDisplayedSelections < ctx_r1._selectedOptions.length ? 4 : -1);
  }
}
function HisMultiselectComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 38);
    i0.ɵɵtemplate(1, HisMultiselectComponent_Conditional_6_Conditional_1_ng_template_1_Template, 5, 1, "ng-template", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", ctx_r1._selectedOptions)("emptyMessage", "\u00A0");
  }
}
function HisMultiselectComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 9);
    i0.ɵɵtemplate(1, HisMultiselectComponent_Conditional_6_Conditional_1_Template, 2, 2, "p-dataView", 38);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1._selectedOptions == null ? null : ctx_r1._selectedOptions.length) > 0 ? 1 : -1);
  }
}
function HisMultiselectComponent_Conditional_7_Conditional_1_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 48);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_7_Conditional_1_ng_template_2_For_3_Template_button_click_2_listener() {
      const ɵ$index_176_r17 = i0.ɵɵrestoreView(_r16).$index;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.deleteSelectedOption(ɵ$index_176_r17));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOption_r18 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r18[ctx_r1.field], " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(3, 3, "common.removeAssignmentOf", selectedOption_r18[ctx_r1.field]));
    i0.ɵɵproperty("disabled", !ctx_r1.editMode);
  }
}
function HisMultiselectComponent_Conditional_7_Conditional_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40)(1, "ul");
    i0.ɵɵrepeaterCreate(2, HisMultiselectComponent_Conditional_7_Conditional_1_ng_template_2_For_3_Template, 4, 6, "li", 41, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1._selectedOptions);
  }
}
function HisMultiselectComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 47, 3);
    i0.ɵɵtemplate(2, HisMultiselectComponent_Conditional_7_Conditional_1_ng_template_2_Template, 4, 0, "ng-template", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hisDdKey", ctx_r1.hisDdKey)("value", ctx_r1._selectedOptions)("emptyMessage", "\u00A0")("disabled", !ctx_r1.editMode);
  }
}
function HisMultiselectComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 9);
    i0.ɵɵtemplate(1, HisMultiselectComponent_Conditional_7_Conditional_1_Template, 3, 4, "p-dataView", 47);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1._selectedOptions == null ? null : ctx_r1._selectedOptions.length) > 0 ? 1 : -1);
  }
}
function HisMultiselectComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49, 4);
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_8_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.loadOptions();
      ctx_r1.showMultiselectPopup();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r1.editMode)("hisImage", ctx_r1.selectButtonImage)("title", ctx_r1.selectButtonTooltip);
  }
}
function HisMultiselectComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 50, 4);
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_9_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.loadOptions();
      ctx_r1.showMultiselectPopup();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r1.editMode);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((ctx_r1._selectedOptions == null ? null : ctx_r1._selectedOptions.length) > 0 ? i0.ɵɵpipeBind1(4, 2, "genericSearch.changeSelectedItems") : i0.ɵɵpipeBind1(5, 4, "genericSearch.selectItems"));
  }
}
function HisMultiselectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 51);
    i0.ɵɵlistener("click", function HisMultiselectComponent_Conditional_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.deleteAllSelectedOptions();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.deleteSelectedItems"));
  }
}
let HisMultiselectComponent = /*#__PURE__*/(() => {
  class HisMultiselectComponent extends HisControlValueAccessor {
    constructor() {
      super(...arguments);
      this.cdref = inject(ChangeDetectorRef);
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      this.userProfileService = inject(HisUserProfileService);
      this.authService = inject(HisAuthService);
      // minimum length of autocomplete input to trigger a searcha
      this.minLength = 1;
      // maximum number of suggestions to show in autocomplete (null -> show all)
      this.limit = null; // XXX currently unused
      // show icon to open dropdown?
      this.showDropdownIcon = true;
      // show null item in autocomplete select list?
      this.showNullItem = false;
      this.showDeleteButton = false;
      this.showSelectButton = false;
      this.editMode = true;
      // name of a custom image for the select button, e.g. "USER_ADD"
      this.selectButtonImage = undefined;
      // custom select button tooltip text (i18n keys should've been substituted already)
      this.selectButtonTooltip = undefined;
      // The selection
      this.selectedOptions = [];
      this.selectedOptionsChange = new EventEmitter();
      this._selectedOptions = [];
      this.selectedRows = [];
      // suggestions for autocomplete
      this.filteredSelectList = [];
      this.selectList = [];
      this.optionList = [];
      // previous autocomplete input string
      this.lastAutocompleteQuery = undefined;
      this.selected = new EventEmitter();
      this.multiselectPopupVisible = false;
      // filter selected Options
      this.removeSelectedOptionsFromDropdown = false;
      this.DEFAULT_PAGE_SIZE = 10;
      // the number of result rows per page (is read from and written to UserProfile)
      this.resultRowsPerPage = this.DEFAULT_PAGE_SIZE;
      // the first result row to display
      this.firstResultRow = 0;
      // the total number of row results, not just those on the current page
      this.totalRowCount = 0;
      // current page, starting at 1
      this.currentPageNumber = 1;
      // // for intern usage isted of resultRowsPerPage
      // rowsPerPage?: number;
      /** Maximale Anzahl von Zeile pro Seite: Zeilen pro Seite (Max:maxRows) */
      this.maxRows = 300;
      /** Zeilen pro Seite untere Grenze */
      this.minRows = 1;
      /** Limit the number of selections displayed. Overflow will be combined to a single label. */
      // default to 10, similar to JSF
      this.maxDisplayedSelections = 10;
      // metadata describing the columns of the result
      this.columns = [];
      this.toggleTableFilter = true;
      this.filter = '';
      this.showTableFilter = true;
      this.showAllSelectedOptions = false;
    }
    get i18nKeyForRecords() {
      return 'de.his.faces.tags.table.datascroller.numRowsFound' + (this.totalRowCount === 1 ? '.record' : '.records');
    }
    ngOnInit() {
      this.pageSizeKey = this.getUserProfileKey(HisUserProfileConstants.PAGE_SIZE);
      this.getRowsPerPageFormUserProfileOrDefault().subscribe(result => {
        if (result) {
          this.resultRowsPerPage = result;
        }
      });
      this._selectedOptions = this.selectedOptions;
    }
    ngOnChanges(changes) {
      if (changes.selectedOptions) {
        this._selectedOptions = changes.selectedOptions.currentValue;
      }
    }
    /**
     * Called when pagination occurs.
     * event.first is the index of first record in page.
     */
    onPage(event) {
      // adjusting the URL is not necessary when search and search result are on the same page (popup)
      console.log('HisSearchResultComponent.onPage(): first = ', event.first);
      this.firstResultRow = event.first;
      this.currentPageNumber = 1 + this.firstResultRow / this.resultRowsPerPage;
    }
    toggleFilter() {
      this.toggleTableFilter = !this.toggleTableFilter;
      if (!this.toggleTableFilter) {
        this.filter = '';
        this.selectList = this.optionList;
        this.refreshTable();
      }
    }
    showMultiselectPopup() {
      // this.cdref.detectChanges();
      this.selectedRows = this._selectedOptions ? this._selectedOptions.slice(0) : [];
      // this.selectedRows = [this.selectedOptions];
      this.multiselectPopupVisible = !this.multiselectPopupVisible;
      this.refreshTable();
    }
    hideMultiselectPopup() {
      this.multiselectPopupVisible = false;
    }
    toggleShowAllSelectedOptions() {
      this.showAllSelectedOptions = !this.showAllSelectedOptions;
    }
    deleteAllSelectedOptions() {
      this._selectedOptions = [];
      this.selectedRows = [];
      this.finishAndEmitChanges();
    }
    /** Writes every entry at filter inputs to this.filter */
    onFilter(value) {
      this.filter = value;
      this.refreshTable();
    }
    validateAndRefresh(inputElement) {
      if (this.validateInput(inputElement.value)) {
        this.resultRowsPerPage = Number(inputElement.value);
      }
      inputElement.value = String(this.resultRowsPerPage);
      this.refreshTable();
    }
    validateInput(input) {
      this.notificationService.clear();
      let label = this.uiService.translate('de.his.faces.tags.table.datascroller.numRowsPerPage');
      //convertes the input value to a number
      let checkInput = +input;
      //check that input is a number
      if (!this.isNumber(checkInput)) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.type', label, input), this.uiService.translate('view.messages.error'));
        return false;
      }
      //returns a error message if the input is smaller than this.minRows or bigger than this.maxRows
      if (!(checkInput >= this.minRows) || checkInput > this.maxRows) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.range', label, this.minRows, this.maxRows), this.uiService.translate('view.messages.error'));
        return false;
      }
      //check that input is not a decimal number
      if (checkInput % 1 !== 0) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.type', label, checkInput), this.uiService.translate('view.messages.error'));
        return false;
      }
      return true;
    }
    isNumber(value) {
      if (isNaN(+value)) {
        return false;
      }
      return true;
    }
    /**
     * Standard filter, this.searchResultTable.filter('value', 'field', 'matchMode'), does not work on all search results
     */
    onFilterTable() {
      console.log('his-multiselect-plam.component#onFilterTable(), #this.filter=', this.filter);
      if (this.filter) {
        let nextList = [];
        let listElem;
        for (listElem of this.optionList) {
          if (listElem.label.toUpperCase().indexOf(this.filter.toUpperCase()) > -1) {
            nextList.push(listElem);
          }
        }
        this.selectList = nextList;
        console.log('his-multiselect-plam-selectList(): Filtered options on client, new selectList =', this.selectList);
      } else {
        this.selectList = this.optionList;
      }
      this.totalRowCount = this.selectList.length;
      this.refreshTable();
    }
    /**
     * Find dropdown suggestions. The event should only fire if the autocomplete input length >= minLength
     *
     * @param $event event
     */
    filterSelectList($event) {
      let autocompleteQuery = $event.query;
      console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): event =', $event, ', query =', autocompleteQuery);
      // Produce filteredSelectList:
      // * If the new query contains the previous one, then we filter the last filtering result again
      // * If the new query does not contain the last one (because some characters were removed from the
      //   autocomplete input field), then we have access the backend
      // * Case is ignored.
      console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): Old filteredSelectList =', this.filteredSelectList, ', lastAutocompleteQuery =', this.lastAutocompleteQuery);
      if (this.lastAutocompleteQuery && autocompleteQuery.indexOf(this.lastAutocompleteQuery) > -1) {
        let nextList = [];
        let listElem;
        for (listElem of this.filteredSelectList) {
          if (listElem.label.toUpperCase().indexOf(autocompleteQuery.toUpperCase()) > -1) {
            nextList.push(listElem);
          }
        }
        this.filteredSelectList = nextList;
        console.log('HisSearchSelectAutocompleteComponent.filterSelectList(): Filtered options on client, new filteredSelectList =', this.filteredSelectList);
      } else {
        this.loadFilteredOptions(autocompleteQuery);
      }
      this.lastAutocompleteQuery = autocompleteQuery;
    }
    loadOptions() {
      if (this.customOptionsMethod) {
        this.customOptionsMethod('').subscribe(result => {
          if (result) {
            this.selectList = result;
            this.optionList = result;
            this.totalRowCount = result.length;
            this.totalNumberOfPages = Math.ceil(result.length / this.resultRowsPerPage);
          }
        });
      }
    }
    loadFilteredOptions(autocompleteQuery) {
      if (this.customOptionsMethod) {
        this.customOptionsMethod(autocompleteQuery).subscribe(result => {
          if (result) {
            this.selectList = result;
            this.totalRowCount = result.length;
            this.totalNumberOfPages = Math.ceil(result.length / this.resultRowsPerPage);
            result = this.filterSelectedOptions(result);
            this.filteredSelectList = this.limitResult(result);
            console.log('HisSearchSelectAutocompleteComponent.loadFilteredOptions(): ' + 'filteredSelectList obtained from this.customOptionsMethod =', this.filteredSelectList);
          }
        });
      }
    }
    filterSelectedOptions(result) {
      //only filter if is set to true
      if (!this.removeSelectedOptionsFromDropdown) {
        return result;
      }
      //let selectedOptions = this.selectedOptions;
      let filteredResult = [];
      for (let i = 0; result.length > i; i++) {
        if (!this.isElementAlreadySelected(result[i].id)) {
          filteredResult.push(result[i]);
        }
      }
      return filteredResult;
    }
    limitResult(result) {
      if (this.limit != null && result.length > this.limit) {
        result = result.slice(0, this.limit);
      }
      return result;
    }
    clearAutoComplete() {
      this.autoComplete1?.clear();
      this.autoComplete2?.clear();
    }
    onSelectEvent(event) {
      this.addSelectedElement(event.value);
    }
    /**
     * Add one element selected by autocomplete.
     *
     * @param selectedElement the element to add
     */
    addSelectedElement(selectedElement) {
      console.log('HisMultiselectPlamComponent: Element selected by autocomplete:', selectedElement);
      this.clearAutoComplete();
      // We do not want to add an element twice; just tell the user that the element is already there.
      if (this.isElementAlreadySelected(selectedElement.id)) {
        let label = selectedElement.label || selectedElement.defaulttext;
        let message = this.uiService.translate('genericSearch.alreadySelected', label);
        this.notificationService.info(message, 'Info');
        return;
      }
      // Add selectedElement to selectedOptions:
      // The spread-operator is required to have model and view synchronized
      // (with push() the reset button wouldn't work correctly)
      if (this._selectedOptions) {
        this._selectedOptions = [...this._selectedOptions, selectedElement];
      } else {
        this._selectedOptions = [selectedElement];
      }
      //und nochmal für die Tabelle
      if (this.selectedRows) {
        this.selectedRows = [...this.selectedRows, selectedElement];
      } else {
        this.selectedRows = [selectedElement];
      }
      // notify apps embedding this component
      this.finishAndEmitChanges();
    }
    // same function as in search-select, but basically they do differnet things:
    isElementAlreadySelected(id) {
      if (!this._selectedOptions) {
        return false;
      }
      console.log('id =', id, 'has type', typeof id);
      for (let option of this._selectedOptions) {
        let optionId = option.id;
        if (typeof optionId === 'undefined') {
          continue;
        }
        // TODO According to class HisOption the option.id should be of string type
        // But obviously the search result obtained from the REST service contains number ids...
        console.log('optionId =', optionId, 'has type', typeof optionId);
        if (id === optionId.toString() || id === optionId) {
          console.log('Element already selected =', optionId, 'has type', typeof optionId);
          return true;
        }
      }
      return false;
    }
    /**
     * Delete an element from the list of selected options.
     *
     * @param index the index of the element
     */
    deleteSelectedOption(index) {
      this._selectedOptions.splice(index, 1);
      this.finishAndEmitChanges();
    }
    /**
     * Submit multiple selection.
     */
    submitSelection() {
      console.log('this.selectTable', this.selectTable);
      // empty selectedOptions in case something got deselected
      this._selectedOptions = [];
      for (let row of this.selectedRows) {
        this.addSelectedElement(row);
      }
      console.log('HisSearchFormResultComponent.submitSelection(): Submit multi-selection:', this._selectedOptions);
      this.finishAndEmitChanges();
    }
    refreshTable() {
      this.notificationService.clear();
      let label = this.uiService.translate('de.his.faces.tags.table.datascroller.numRowsPerPage');
      if (!(this.resultRowsPerPage >= this.minRows) || this.resultRowsPerPage > this.maxRows) {
        this.notificationService.error(this.uiService.translate('de.his.faces.validator.NumberValidator.range', label, this.minRows, this.maxRows), this.uiService.translate('view.messages.error'));
        return;
      }
      console.log('his-search-result.component#refreshTable() #this.rowsPerPage', this.resultRowsPerPage);
      if (!this.authService.isAnonymous) {
        let value = String(this.resultRowsPerPage);
        let defaultValue = String(this.DEFAULT_PAGE_SIZE);
        this.userProfileService.setNewValue(this.pageSizeKey, value, defaultValue).subscribe(result => {
          if (result) {
            // in JSF springt der Paginator auf 1 zurück, falls Zeile pro Seite geändert wird
            // Seit Hiszilla 265099 ist currentPageNumber Bestandteil der Berechnung des offset
            this.currentPageNumber = 1;
            this.totalNumberOfPages = Math.ceil(this.selectList.length / this.resultRowsPerPage);
            this.onPage({
              first: 0,
              rows: this.resultRowsPerPage
            });
          }
        });
      } else {
        //Hiszilla 262553: Zeilen pro Seite soll auch für anonyme Benutzer bespeichert werden
        // In JSF wird hierfür wie im userProfile üblich als key 'tableId.pageSize' gespeichert
        let key = this.getUserProfileKey(HisSessionStorageKeys.CS_SYS_ANONYMOUS_PAGE_SIZE);
        if (Number(this.resultRowsPerPage) === this.DEFAULT_PAGE_SIZE) {
          // Schlüssel löschen falls Standard
          sessionStorage.removeItem(key);
          console.log('his-search-result.component#refreshTable() #removed key', key);
        } else {
          sessionStorage.setItem(key, String(this.resultRowsPerPage));
        }
        // in JSF springt der Paginator auf 1 zurück, falls Zeile pro Seite geändert wird
        // Seit Hiszilla 265099 ist currentPageNumber Bestandteil der Berechnung des offset
        this.currentPageNumber = 1;
        this.onPage({
          first: 0,
          rows: this.resultRowsPerPage
        });
        this.totalNumberOfPages = Math.ceil(this.selectList.length / this.resultRowsPerPage);
      }
    }
    /**
     * Cancel button pressed -> forget the search result selection, just pass the event.
     */
    cancelSelection() {
      this.finishAndEmitChanges();
    }
    getUserProfileKey(key) {
      let tableId = window.location.pathname + this.label;
      let tableIdHash = HisStringUtils.getHashCode(tableId);
      return tableIdHash + key;
    }
    getRowsPerPageFormUserProfileOrDefault() {
      let obs = new BehaviorSubject(null);
      const defaultTablePageSize = this.userProfileService.getValueforKey(HisSearchResultConfigConstants.DEFAUT_TABLE_PAGE_SIZE);
      const pageSize = this.userProfileService.getValueforKey(this.pageSizeKey);
      forkJoin([defaultTablePageSize, pageSize]).subscribe(result => {
        if (this.defaultTablePageSize) {
          //this.defaultTablePageSize wird mittels his-search-result.config#onSave.emit an reloadPage übergeben
          this.resultRowsPerPage = this.defaultTablePageSize;
        } else if (result[0]) {
          this.defaultTablePageSize = +result[0];
          this.resultRowsPerPage = this.defaultTablePageSize;
        }
        if (result[1]) {
          this.resultRowsPerPage = +result[1];
        }
        if (!result[0] && !result[1]) {
          // zurücksetzen von rowsPerPage auf default, z. B. beim 'Standard wiederherstellen'
          this.resultRowsPerPage = this.DEFAULT_PAGE_SIZE;
        }
        obs.next(this.resultRowsPerPage);
      });
      return obs;
    }
    sortSelectedOptions() {
      let sortedArray = this._selectedOptions.sort((n1, n2) => {
        if (n1.label > n2.label) {
          return 1;
        }
        if (n1.label < n2.label) {
          return -1;
        }
        return 0;
      });
      this._selectedOptions = sortedArray;
    }
    /**
     * Notify HisSearchFormWidgetComponent that the model needs to be updated.
     */
    finishAndEmitChanges() {
      this.sortSelectedOptions();
      // set sortorder for entries
      this._selectedOptions.forEach((option, i) => {
        option.sortorder = i;
      });
      //console.log( 'HisMultiselectPlamComponent: Emit change event:', this.selectedOptions );
      if (this.autoComplete1) {
        this.autoComplete1.onModelChange(this._selectedOptions);
      }
      if (this.autoComplete2) {
        this.autoComplete2.onModelChange(this._selectedOptions);
      }
      this.onModelChange(this._selectedOptions);
      this.onModelTouched();
      // re-hide any future overflow after the combined button disappears
      if (this._selectedOptions.length <= this.maxDisplayedSelections) {
        this.showAllSelectedOptions = false;
      }
      this.selectedOptionsChange.emit(this._selectedOptions);
    }
    writeValue(value) {
      this._selectedOptions = value;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisMultiselectComponent_BaseFactory;
        return function HisMultiselectComponent_Factory(__ngFactoryType__) {
          return (ɵHisMultiselectComponent_BaseFactory || (ɵHisMultiselectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisMultiselectComponent)))(__ngFactoryType__ || HisMultiselectComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisMultiselectComponent,
        selectors: [["his-multiselect"]],
        viewQuery: function HisMultiselectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$p, 7);
            i0.ɵɵviewQuery(_c1$8, 5);
            i0.ɵɵviewQuery(_c2$3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectTable = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoComplete1 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoComplete2 = _t.first);
          }
        },
        inputs: {
          ddKey: "ddKey",
          hisDdKey: "hisDdKey",
          dataSource: "dataSource",
          inputId: "inputId",
          field: "field",
          customOptionsMethod: "customOptionsMethod",
          label: "label",
          minLength: "minLength",
          limit: "limit",
          showDropdownIcon: "showDropdownIcon",
          showNullItem: "showNullItem",
          showDeleteButton: "showDeleteButton",
          showSelectButton: "showSelectButton",
          editMode: "editMode",
          selectButtonImage: "selectButtonImage",
          selectButtonTooltip: "selectButtonTooltip",
          selectedOptions: "selectedOptions",
          removeSelectedOptionsFromDropdown: "removeSelectedOptionsFromDropdown",
          resultRowsPerPage: "resultRowsPerPage",
          maxRows: "maxRows",
          maxSelectedOptions: "maxSelectedOptions",
          maxDisplayedSelections: "maxDisplayedSelections"
        },
        outputs: {
          selectedOptionsChange: "selectedOptionsChange",
          selected: "selected"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HisMultiselectComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 11,
        vars: 11,
        consts: [["content", "", "autoComplete1", ""], ["content", "", "autoComplete2", ""], ["selectTable", ""], ["content", ""], ["inputElement", ""], [1, "autocompleteWidth100", 3, "ngModel", "hisEagerDataSource", "minLength", "dropdown", "forceSelection", "hisDdKey", "disabled", "inputId"], ["field", "nonexistingdummy", 1, "autocompleteWidth100", 3, "ngModel", "suggestions", "minLength", "dropdown", "forceSelection", "hisDdKey", "inputId"], ["appendTo", "body", "showEffect", "fade", 3, "visible", "responsive", "modal", "blockScroll", "focusTrap"], [1, "unsichtbar"], [1, "selectedOptionsList"], ["type", "submit", "alt", "", 1, "icon", 3, "disabled", "hisImage", "title"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton"], [1, "autocompleteWidth100", 3, "onSelect", "ngModel", "hisEagerDataSource", "minLength", "dropdown", "forceSelection", "hisDdKey", "disabled", "inputId"], ["field", "nonexistingdummy", 1, "autocompleteWidth100", 3, "completeMethod", "onSelect", "ngModel", "suggestions", "minLength", "dropdown", "forceSelection", "hisDdKey", "inputId"], ["pTemplate", "item"], ["appendTo", "body", "showEffect", "fade", 3, "visibleChange", "onHide", "visible", "responsive", "modal", "blockScroll", "focusTrap"], [1, "floatLeft"], [1, "tableFilterEditBlock"], [1, "clearerSpaceAboveHalfEm"], [3, "selectionChange", "firstChange", "onPage", "value", "paginator", "selectionPageOnly", "rows", "selection", "first"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "paginatorright"], ["type", "submit", "iconPos", "left", "hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"], [2, "vertical-align", "middle"], ["type", "submit", "iconPos", "left", "hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"], ["hisImage", "FILTER", 1, "transparent", "hideOnMobile", 3, "click"], [1, "multiSelectColumn"], [1, "hideOnBreakpointSmall", 3, "title"], [1, "hideOnBreakpointLarge"], [3, "pSortableColumn"], [3, "field"], ["pInputText", "", "type", "text", 3, "ngModelChange", "keydown.enter", "keydown.space", "click", "title", "ngModel"], ["tabindex", "0", 3, "value", "title", "ariaLabel"], [1, "tableRowCount"], ["for", "tableRow"], ["required", "", "id", "tableRow", 1, "input_3_Chars", "tableRowInput", 3, "blur", "keyup.enter", "value"], ["styleClass", "selectedDataContainer", 3, "value", "emptyMessage"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"], ["type", "submit", 1, "transparent", "showAllSelectedOptionsButton", 3, "click", "title"], [1, "btnText"], ["hisImage", "ARROW_OUT", 1, "inlineicon", 3, "title"], ["hisImage", "ARROW_IN", 1, "inlineicon", 3, "title"], ["styleClass", "selectedDataContainer", 3, "ngModel", "hisDdKey", "value", "emptyMessage", "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title", "disabled"], ["type", "submit", "alt", "", 1, "icon", 3, "click", "disabled", "hisImage", "title"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "click", "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton", 3, "click"]],
        template: function HisMultiselectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisMultiselectComponent_Conditional_0_Template, 3, 8, "p-autoComplete", 5)(1, HisMultiselectComponent_Conditional_1_Template, 4, 7, "p-autoComplete", 6)(2, HisMultiselectComponent_Conditional_2_Template, 23, 22, "p-dialog", 7);
            i0.ɵɵelementStart(3, "div", 8);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, HisMultiselectComponent_Conditional_6_Template, 2, 1, "ng-container", 9)(7, HisMultiselectComponent_Conditional_7_Template, 2, 1, "ng-container", 9)(8, HisMultiselectComponent_Conditional_8_Template, 2, 3, "button", 10)(9, HisMultiselectComponent_Conditional_9_Template, 6, 6, "button", 11)(10, HisMultiselectComponent_Conditional_10_Template, 4, 3, "button", 12);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.customOptionsMethod ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.customOptionsMethod ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.multiselectPopupVisible ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 9, "common.components.selectManyPicklist.selected"), ":");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.customOptionsMethod ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.customOptionsMethod ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSelectButton && ctx.selectButtonImage ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSelectButton && !ctx.selectButtonImage ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDeleteButton && (ctx._selectedOptions == null ? null : ctx._selectedOptions.length) > 0 ? 10 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return HisMultiselectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSummernoteService = /*#__PURE__*/(() => {
  class HisSummernoteService {
    constructor(http) {
      this.http = http;
      this.hisNavigationService = inject(HisNavigationService);
      // URL des REST-Services, der die Bildpfade aus HISinOne/images/portal/ zurückliefert
      this.apiUrl = this.hisNavigationService.getQisserverUrl() + '/api/v1/cs/sys/imagesList';
    }
    /**
    * Ruft die Bilddaten als JSON vom REST-Service ab.
    * Nutzt einen Cache, um wiederholte HTTP-Requests zu vermeiden.
    */
    getImagePaths() {
      if (!this.imageCache$) {
        this.imageCache$ = this.http.get(this.apiUrl).pipe(
        // shareReplay(1) speichert den letzten erfolgreichen Wert und teilt ihn mit allen Abonnenten
        shareReplay(1), catchError$1(error => {
          // Im Fehlerfall den Cache zurücksetzen, um erneute Versuche zu ermöglichen
          this.imageCache$ = null;
          throw error;
        }));
      }
      return this.imageCache$;
    }
    static {
      this.ɵfac = function HisSummernoteService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSummernoteService)(i0.ɵɵinject(i1$4.HttpClient));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSummernoteService,
        factory: HisSummernoteService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HisSummernoteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$o = ["editor"];
function HisSummernoteComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngxSummernote", ctx_r0.config)("ngxSummernoteDisabled", ctx_r0.disabled);
  }
}
function HisSummernoteComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p")(1, "a", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("href", "../../pages/cs/sys/portal/documentation/documentation.faces?\n                    navigationPosition=documentation&site=", ctx_r0.documentationUrl, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("title", "Dokumentation: Grundlagen, Bedienung, erste Schritte-HISinOne");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 4, "de.his.portal.doku"), ": Arbeiten mit dem Richtext-Editor");
  }
}
//import jQuery from 'jquery';
let HisSummernoteComponent = /*#__PURE__*/(() => {
  class HisSummernoteComponent {
    constructor(sanitizer, cdr, imagePathService) {
      this.sanitizer = sanitizer;
      this.cdr = cdr;
      this.imagePathService = imagePathService;
      //private hisNavigationService = inject( HisNavigationService );
      // eslint-disable-next-line max-len
      this.documentationUrl = 'Grundlagen%2C_Bedienung%2C_erste_Schritte-HISinOne.xhtml#Arbeiten_mit_dem_Richtext-Editor';
      this.auth = inject(HisAuthService);
      this.$editor = null;
      this.maxHeight = '80vh';
      this.minHeight = '200px';
      this.placeholder = 'Schreiben Sie hier Ihren Text...';
      this.dataChange = new EventEmitter();
      this._data = '';
      this._filteredData = null;
      this.editorInitialized = false;
      this.useNgModel = false;
      // Array für die Bildpfade
      this.imagePaths = [];
      // DONE: implement HISControlValueAccessor
      this.onModelChange = () => {};
      this.onModelTouched = () => {};
      // ControlValueAccessor Callbacks
      this.onChange = () => {};
      this.onTouched = () => {};
    }
    ngOnInit() {
      this.config = this.getConfig();
    }
    ngAfterContentInit() {
      // Abonnieren des Observables, um die Bildpfade zu erhalten
      this.imagePathService.getImagePaths().subscribe({
        next: data => {
          this.imagePaths = data.result;
        },
        error: error => {
          console.error('Error fetching image paths', error);
        },
        complete: () => {
          //console.log( 'Image paths successfully fetched', this.imagePaths );
          this.insertImages();
        }
      });
    }
    /**
    * Fügt die Bildliste in das DIV mit der Klasse note-group-select-from-files ein.
    */
    insertImages() {
      const targetElements = document.querySelectorAll('.note-group-select-from-files');
      if (!targetElements || targetElements.length === 0) {
        console.warn('No target containers .note-group-select-from-files found.');
        return;
      }
      // Für jeden gefundenen Container wird die Bildliste eingefügt
      targetElements.forEach(targetElement => {
        let html = '';
        this.imagePaths.forEach(image => {
          html += `<img src="${image.src}" alt="${image.alt}" class="custom-image" data-url="${image.src}" style="cursor: pointer; margin: 5px; max-width: 100px; max-height: 100px;">`;
        });
        targetElement.innerHTML = html;
        // Event-Listener für jedes eingefügte Bild hinzufügen
        const images = targetElement.querySelectorAll('.custom-image');
        images.forEach(img => {
          img.addEventListener('click', event => {
            const target = event.target;
            const imageUrl = target.getAttribute('data-url');
            if (imageUrl) {
              // Relatives Ermitteln des Input-Felds und des Buttons anhand des geklickten Bildes
              this.setImageUrlInInput(target, imageUrl);
            }
          });
        });
      });
    }
    /**
     * Sucht relativ vom geklickten Bild das zugehörige Input-Feld im Modal und setzt dessen Value.
     *
     * Vom geklickten Bild (innerhalb des Modals) wird mittels closest() der übergeordnete
     * Container (.note-modal-body) gefunden. Anschließend wird im Container das Input-Feld
     * (innerhalb .note-group-image-url) gesucht.
     */
    setImageUrlInInput(clickedImage, url) {
      // Finde den übergeordneten Container .note-modal-body
      const modalBody = clickedImage.closest('.note-modal-body');
      if (modalBody) {
        // Suche innerhalb von modalBody das Input-Feld im Container .note-group-image-url
        const inputElement = modalBody.querySelector('.note-group-image-url input.note-image-url');
        if (inputElement) {
          inputElement.value = url;
          // Suche das übergeordnete Modal-Container (.note-modal-content)
          const modalContent = modalBody.closest('.note-modal-content');
          if (modalContent) {
            // Suche innerhalb des Modal-Containers den Button mit der Klasse note-image-btn
            const insertButton = modalContent.querySelector('.note-image-btn');
            if (insertButton) {
              // Button aktivieren: disabled-Attribut entfernen und CSS-Klasse "disabled" löschen
              insertButton.disabled = false;
              insertButton.classList.remove('disabled');
            } else {
              console.warn('Insert button (.note-image-btn) not found.');
            }
          } else {
            console.warn('Modal content (.note-modal-content) not found.');
          }
        } else {
          console.warn('Input element within .note-group-image-url not found.');
        }
      } else {
        console.warn('Modal body not found from clicked image.');
      }
    }
    ngOnDestroy() {
      if (this.imageSubscription) {
        this.imageSubscription.unsubscribe();
      }
    }
    /**
    * Setter für das Input-Property "data". Wird immer mit dem Rohwert aufgerufen.
    * Hier wird der Wert gefiltert und das Editor-Inhalt aktualisiert.
    */
    set data(value) {
      if (value === undefined) return; // undefined ist kein valider Wert, wird auch bei ngModel durch Lifecycle Hooks aufgerufen 
      if (this.useNgModel) {
        console.warn('[his-editor] ngModel verwendet - set data ist nicht erlaubt.', value);
        return;
      }
      this._data = value || '';
      this._filteredData = this.filterHtml(this._data, this.getAllowedContent());
      this.tryInitEditor();
    }
    get data() {
      return this._filteredData;
    }
    tryInitEditor() {
      if (!this.$editor || !this._filteredData || this.editorInitialized) return;
      console.log('set initial summernote value:', this._filteredData);
      this.editorInitialized = true;
      this.$editor.summernote('code', this._filteredData);
    }
    /**
     * Wird vom Angular-Formular aufgerufen, wenn sich der Wert von außen ändert.
     * Wir übergeben hier den Rohwert, der über den Setter gefiltert und verarbeitet wird.
     */
    writeValue(value) {
      this.useNgModel = true;
      this._data = value || '';
      this._filteredData = this.filterHtml(this._data, this.getAllowedContent());
      this.tryInitEditor();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
      // Falls der Editor einen Disable-Zustand unterstützt:
      if (this.$editor) {
        this.$editor.summernote(isDisabled ? 'disable' : 'enable');
      }
    }
    /**
     * Wird aufgerufen, wenn der Editor vom Benutzer verändert wird.
     * Hier aktualisieren wir den internen Wert, leiten die Änderung an Angular weiter und
     * sorgen dafür, dass immer der gefilterte HTML-Wert benutzt wird.
     */
    onEditorChange(newValue) {
      if (newValue !== this._data) {
        console.log('onEditorChange note', newValue);
        // Aktualisiere den Rohwert und filtere ihn
        this._data = newValue;
        this._filteredData = this.filterHtml(newValue, this.getAllowedContent());
        // Informiere externe Bindings
        this.dataChange.emit(this._filteredData);
        this.onChange(this._filteredData);
        this.onTouched();
        this.cdr.markForCheck();
      }
    }
    /** HTML will get cut when not using SafeHtml for output (writing to innerHTML).
     * rgb colors in style attributes are most common to get cut.
     *
     * SafeHtml DISABLES Angular DomSanitizationService when writing to innerHTML.
     * NOT an automatically safe type for HTML,
     * BUT this is trustedHtml (manually sanitized and filtered HTML, marked as safe).
    **/
    get trustedHtml() {
      return this.sanitizer.bypassSecurityTrustHtml(this._filteredData);
    }
    sanitizeHtml(htmlString) {
      function trimAndRemoveEmptyPTag(string) {
        // remove empty tags
        let value = string.trim() === '<p><br></p>' ? '' : removeTrailingBr(string.trim());
        // remove empty p
        // remove empty br
        value = value === '<br>' ? '' : value;
        // fix Oberflächentextbearbeitung Special Word EMPTY
        value = value === '<p>EMPTY</p>' ? 'EMPTY' : value;
        return value;
      }
      function removeTrailingBr(string) {
        // replace trailing br and also trailing <p><br></p>
        return string.replace(/(<br\s*\/?>)+$/, '').replace(/<p>\s*<br>\s*<\/p>\s*$/g, '');
      }
      // replace font tags with dom Parser. 
      // update parent spans and present styles when appropriate
      function replaceFontWithSpan(string) {
        const parser = new DOMParser();
        let doc = parser.parseFromString(string, 'text/html');
        function replaceFontElements(element) {
          element.querySelectorAll('font').forEach(font => {
            let parent = font.parentElement;
            // Aktuelles style-Attribut vom font übernehmen
            let fontStyle = font.getAttribute('style') || '';
            let fontColor = font.getAttribute('color') ? `color:${font.getAttribute('color')};` : '';
            // Kombiniere vorhandene Style-Angaben
            let combinedStyle = fontStyle + (fontStyle && fontColor ? ' ' : '') + fontColor;
            if (parent && parent.tagName.toLowerCase() === 'span') {
              // Parent ist bereits ein <span>, style hinzufügen/ergänzen
              let parentStyle = parent.getAttribute('style') || '';
              parent.setAttribute('style', parentStyle + (parentStyle && combinedStyle ? '; ' : '') + combinedStyle);
              // Verschiebe alle Kinder des font in den span
              while (font.firstChild) {
                parent.appendChild(font.firstChild);
              }
              // Entferne das ursprüngliche font-Tag
              font.remove();
            } else {
              // Erstelle ein neues span-Element
              let span = document.createElement('span');
              if (combinedStyle.trim()) {
                span.setAttribute('style', combinedStyle);
              }
              // Übertrage alle anderen Attribute außer color und style
              Array.from(font.attributes).forEach(attr => {
                if (attr.name !== 'color' && attr.name !== 'style') {
                  span.setAttribute(attr.name, attr.value);
                }
              });
              // Inhalte in das neue span verschieben
              while (font.firstChild) {
                span.appendChild(font.firstChild);
              }
              font.replaceWith(span);
            }
          });
        }
        replaceFontElements(doc.body);
        return doc.body.innerHTML;
      }
      htmlString = trimAndRemoveEmptyPTag(htmlString);
      return replaceFontWithSpan(htmlString);
    }
    convertHTMLStringtoElement(htmlString) {
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = htmlString?.trim();
      return tempContainer;
    }
    /**
     * filter HTML based on allowedContent
     * * replaces all Tags that are not allowed with p, but keeps the children and textnodes
     * * removes all attributes that are not allowed
     * * removes data-* attributes (except data-delayedsrc)
     * * removes all styles from style-attribute that are not allowed
     * * removes p Tag as only child (retaining children)
     * * removes html-comments
     * * removes trailing <br>
     */
    filterHtml(content, allowedContent) {
      const debugLog = false;
      if (content == null || content == '' || typeof content === 'undefined') {
        if (debugLog) console.log('filterHTML: content is empty or undefined', content);
        return '';
      }
      if (debugLog) console.time('filterHTML');
      // String und DOM-Parser Manipulation vor Browser-DOM 
      content = this.sanitizeHtml(content);
      if (content == '') {
        if (debugLog) console.log('content is empty after sanitizing');
        if (debugLog) console.timeEnd('filterHTML');
        return '';
      }
      // String zu Browser DOM-Element umwandeln
      const rootElement = this.convertHTMLStringtoElement(content);
      if (!rootElement) {
        console.error('HTML is undefined');
        return '';
      }
      // get default
      if (typeof allowedContent === 'undefined') {
        console.info('HTML-Editor: AllowedContent not set. Using default allowedContent.');
        allowedContent = this.getAllowedContent();
      }
      if (debugLog) console.group('filterHtml');
      if (debugLog) console.log('filter HTML: ', rootElement, allowedContent);
      // replace element with p element,
      // append children to new p element
      /** TODO
       * - replace inline elements with span and block elements with p
       */
      function replaceElement(element) {
        if (debugLog) console.info('replace element', element.tagName);
        const pElement = document.createElement('p');
        while (element.firstChild) {
          pElement.appendChild(element.firstChild);
        }
        element.parentNode.replaceChild(pElement, element);
        return pElement;
      }
      // remove attribute from element
      function removeAttr(e, a) {
        if (debugLog) console.info('remove attr.name', a.name);
        e.removeAttribute(a.name);
      }
      function removeHTMLComments(elem) {
        const walker = document.createTreeWalker(elem, NodeFilter.SHOW_COMMENT, null);
        let commentNode;
        while (commentNode = walker.nextNode()) {
          commentNode.parentNode.removeChild(commentNode);
          // Reset the walker to start from the root again, since the DOM has changed
          walker.currentNode = elem;
        }
      }
      function cleanStyle(e) {
        // Regulärer Ausdruck für erlaubte RGB-Werte
        const rgbRegex = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i;
        const allowedStyles = allowedContent.styles;
        const styles = e.getAttribute('style').split(';').map(style => style.trim()).filter(Boolean);
        const cleanedStyles = styles.filter(style => {
          // remove unallowed keys and leys with unallowed value
          const [key, value] = style.split(':').map(part => part.trim());
          const keyAllowed = allowedStyles.includes(key);
          if (debugLog) console.log('key, value', [key, value]);
          // @ ' " \ / () & * and [] not allowed
          const unallowedValueChars = /.*[@`''\"\\\\/()&*\[\]].*/;
          // % without space or semicolon not allowed
          const unallowedProzent = /.*%[^\s;].*/;
          // special words
          const unallowedWords = /.*(behavior|behaviour|binding|expression|script|url).*/;
          let valueAllowed = true;
          if (unallowedValueChars.test(value) || unallowedProzent.test(value) || unallowedWords.test(value)) {
            // Wenn der Wert ein gültiger RGB-Wert ist, erlauben
            if (rgbRegex.test(value)) {
              valueAllowed = true;
            } else {
              valueAllowed = false;
            }
          }
          const allow = keyAllowed && valueAllowed;
          /*console.info(key + " keyAllowed?", keyAllowed);
          console.info(value + " valueAllowed?", valueAllowed)
          if (!allow) {
              console.info("remove style key", key);
          }*/
          return allow ? keyAllowed : false;
        });
        if (cleanedStyles.length) {
          // set left over styles
          if (debugLog) console.info('setting style with cleanedStyles:', cleanedStyles);
          e.setAttribute('style', cleanedStyles.join('; '));
        } else {
          if (debugLog) console.info('all styles stripped removing style attribute');
          // all styles have been stripped, remove style attribute
          e.removeAttribute('style');
        }
      }
      function isHTMLElement(node) {
        return node.nodeType === Node.ELEMENT_NODE && node instanceof HTMLElement;
      }
      function traverseAndClean(element) {
        if (!isHTMLElement(element)) {
          return;
        }
        // if the element is a node, check if it should be replace
        const tagName = element.tagName.toLowerCase();
        // replace the element if it's not allowed
        if (!(tagName in allowedContent.elements) || allowedContent.elements[tagName] === false) {
          // move possible child nodes into a p node that replaces the element
          // write new element back to element or childNOdes will ne be processed
          element = replaceElement(element);
        }
        if (!isHTMLElement(element)) {
          return;
        }
        Array.from(element.attributes).forEach(attr => {
          if (debugLog) console.log(tagName, attr);
          if (!allowedContent.attributes || !allowedContent.attributes.includes(attr.name) || attr.name.startsWith('data-') && !(attr.name === 'data-delayedsrc')) {
            // data-delayedsrc is used in BIA portlets to lazy load images from superx 
            if (debugLog) console.info('remove attr.name', attr.name);
            element.removeAttribute(attr.name);
          } else if (attr.name === 'style' && element.hasAttribute('style')) {
            // Clean the style attribute
            cleanStyle(element);
          }
        });
        // clean the class attribute if classes are not allowed
        if (!allowedContent.classes) {
          element.removeAttribute('class');
        }
        // traverse child nodes
        element.childNodes.forEach(child => {
          traverseAndClean(child);
        });
      }
      // clean the attributes
      if (debugLog) console.log('allowed Attributes', allowedContent.attributes);
      if (debugLog) console.log('allowed Styles', allowedContent.styles);
      // remove HTML comments
      removeHTMLComments(rootElement);
      // start traversing and cleaning from the root element
      traverseAndClean(rootElement);
      if (debugLog) console.log('filtered Html', rootElement.innerHTML);
      if (debugLog) console.groupEnd();
      if (debugLog) console.timeEnd('filterHTML');
      return rootElement.innerHTML;
    }
    getConfig() {
      if (this.minHeight > this.maxHeight) {
        this.minHeight = this.maxHeight;
      }
      return {
        placeholder: this.placeholder,
        tabsize: 2,
        minHeight: this.minHeight,
        maxHeight: this.maxHeight,
        tabDisable: false,
        lang: 'de-DE',
        toolbar: this.getToolbarConfig(this.toolbar),
        codemirror: {
          lineNumbers: true,
          lineWrapping: true,
          mode: 'text/html'
        },
        styleTags: ['p', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre'],
        popover: {
          table: [['custom', ['tableHeaders']], ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight', 'toggle']], ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]]
        },
        icons: {
          redo: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve"><g><path  d="M28,6c12.5,0,22.9,8.8,25.4,20.4c0.5-0.1,8.699-1.7,8.699-1.7c0.7,0,1.4,0.4,1.7,1.1c0.3,0.7,0.101,1.5-0.399,2L52.1,40.2C51.4,40.9,49.9,41,49.2,40.3L36.7,28.1c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.2,0-0.5,0.1-0.7c0.3-0.7,0.9-1.1,1.7-1.2l8.2,1.5C43.8,18.7,36.6,13,28.1,13C17.6,13.1,9.2,21.6,9.2,32c0,10.4,8.5,18.9,18.9,18.9c3.5,0,7-1,10-2.9c1.2-0.7,2.7-0.6,3.7,0.3l0.8,0.7c0.7,0.6,1.101,1.6,1,2.5c-0.1,0.9-0.6,1.8-1.399,2.3C38,56.5,33.1,57.9,28.1,57.9C13.7,58,2,46.3,2,32S13.7,6,28,6z"/></g></svg>',
          undo: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g><path  d="M36,6c-12.5,0-22.9,8.8-25.4,20.4c-0.5-0.1-8.7-1.7-8.7-1.7c-0.7,0-1.4,0.4-1.7,1.1c-0.3,0.7-0.1,1.5,0.4,2L12,40.2c0.7,0.7,2.2,0.8,2.9,0.1l12.5-12.2c0.3-0.3,0.5-0.8,0.5-1.3c0-0.2,0-0.5-0.1-0.7c-0.3-0.7-0.9-1.1-1.7-1.2l-8.2,1.5C20.3,18.7,27.5,13,36,13c10.4,0,18.9,8.5,18.9,18.9S46.4,50.8,36,50.8c-3.5,0-7-1-10-2.899c-1.2-0.7-2.7-0.601-3.7,0.3L21.5,49c-0.7,0.6-1.1,1.6-1,2.5s0.6,1.8,1.4,2.3C26.1,56.5,31,57.9,36,57.9C50.3,58,62,46.3,62,32S50.3,6,36,6z"/></g></svg>',
          align: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M55.5,12H8.5C7.1,12,6,13.3,6,15s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,12,55.5,12z"/><path  d="M55.5,23.3H8.5c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,23.3,55.5,23.3z"/><path  d="M55.5,34.7H8.5c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,34.7,55.5,34.7z"/><path  d="M28,46H8.5C7.1,46,6,47.3,6,49s1.1,3,2.5,3H28c1.4,0,2.5-1.3,2.5-3S29.4,46,28,46z"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/></svg>',
          alignJustify: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M55.5,12H8.5C7.1,12,6,13.3,6,15s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,12,55.5,12z"/><path  d="M55.5,23.3H8.5c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,23.3,55.5,23.3z"/><path  d="M55.5,34.7H8.5c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,34.7,55.5,34.7z"/><path  d="M28,46H8.5C7.1,46,6,47.3,6,49s1.1,3,2.5,3H28c1.4,0,2.5-1.3,2.5-3S29.4,46,28,46z"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/></svg>',
          alignLeft: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M55.5,12H8.5C7.1,12,6,13.3,6,15s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,12,55.5,12z"/><path  d="M32,23.3H8.5c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3H32c1.4,0,2.5-1.3,2.5-3S33.4,23.3,32,23.3z"/><path  d="M47.5,34.7h-39c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h39c1.4,0,2.5-1.3,2.5-3S48.9,34.7,47.5,34.7z"/><path  d="M39.5,46h-31C7.1,46,6,47.3,6,49s1.1,3,2.5,3h31c1.4,0,2.5-1.3,2.5-3S40.9,46,39.5,46z"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/></svg>',
          alignRight: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M8.5,12h46.9c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3H8.5C7.1,18,6,16.7,6,15S7.1,12,8.5,12z"/><path  d="M32,23.3h23.5c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3H32c-1.4,0-2.5-1.3-2.5-3S30.6,23.3,32,23.3z"/><path  d="M16.5,34.7h39c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3h-39c-1.4,0-2.5-1.3-2.5-3S15.1,34.7,16.5,34.7z"/><path  d="M24.5,46h31c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3h-31c-1.4,0-2.5-1.3-2.5-3S23.1,46,24.5,46z"/></g><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/></svg>',
          alignCenter: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M8.5,12h46.9c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3H8.5C7.1,18,6,16.7,6,15S7.1,12,8.5,12z"/><path  d="M20.2,23.3h23.5c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3H20.2c-1.4,0-2.5-1.3-2.5-3S18.9,23.3,20.2,23.3z"/><path  d="M12.5,34.7h39c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3h-39c-1.4,0-2.5-1.3-2.5-3S11.1,34.7,12.5,34.7z"/><path  d="M16.5,46h31c1.4,0,2.5,1.3,2.5,3s-1.1,3-2.5,3h-31c-1.4,0-2.5-1.3-2.5-3S15.1,46,16.5,46z"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/></svg>',
          indent: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M55.5,14H8.6c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,14,55.5,14z"/><path  d="M55.5,24h-30c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3S56.9,24,55.5,24z"/><path  d="M55.5,34h-30c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3S56.9,34,55.5,34z"/><path  d="M55.5,44H8.6c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,44,55.5,44z"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/><path  d="M6,38.6L6,38.6c0,0.3,0.1,0.6,0.3,0.8C6.6,39.8,7.1,40,7.5,40c0.3,0,0.7-0.1,0.9-0.3l8.1-6.5c0.4-0.3,0.6-0.7,0.6-1.2c0-0.5-0.2-0.9-0.6-1.2l-8.1-6.5c-0.7-0.5-1.6-0.4-2.1,0.2c-0.2,0.3-0.3,0.6-0.3,1h0V38.6z"/></svg>',
          outdent: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M55.5,14H8.6c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,14,55.5,14z"/><path  d="M55.5,24h-30c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3S56.9,24,55.5,24z"/><path  d="M55.5,34h-30c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3S56.9,34,55.5,34z"/><path  d="M55.5,44H8.6c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h46.9c1.4,0,2.5-1.3,2.5-3S56.9,44,55.5,44z"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/><path  d="M17.1,25.5L17.1,25.5c0-0.3-0.1-0.7-0.3-1c-0.5-0.7-1.5-0.8-2.1-0.2l-8.1,6.5C6.2,31.1,6,31.5,6,32c0,0.5,0.2,0.9,0.6,1.2l8.1,6.5c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.9-0.2,1.2-0.6c0.2-0.2,0.3-0.5,0.3-0.8h0V25.5z"/></svg>',
          /* ???*/ //fullScreen: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g><g><g><g><path  d="M63.4,26c-0.2,0.2-0.4,0.3-0.7,0.4c-0.8,0.3-1.601,0.1-2.2-0.4l-5.6-11.3L40.8,28.9c-0.8,0.8-2.1,0.8-2.899,0L34.8,25.8c-0.8-0.8-0.8-2.1,0-2.9L49.3,9.1L38,3.5c-0.6-0.6-0.8-1.5-0.4-2.2C37.8,0.5,38.6,0,39.4,0H62c1.1,0,2,0.9,2,2v22.6C64,25.2,63.8,25.7,63.4,26z"/></g></g></g><g><g><g><path  d="M0.6,38c0.2-0.2,0.4-0.3,0.7-0.4C2,37.2,2.9,37.4,3.5,38l5.6,11.3l14.1-14.1c0.8-0.8,2.1-0.8,2.9,0l3.1,3.1c0.8,0.8,0.8,2.101,0,2.9L14.7,54.9L26,60.5c0.6,0.6,0.8,1.5,0.4,2.2c-0.3,0.8-1.1,1.3-1.9,1.3H2c-1.1,0-2-0.9-2-2V39.4C0,38.8,0.2,38.3,0.6,38z"/></g></g></g></g></svg>',
          /** arrowsAlt is actually the fullscreen icon in 0.9.1  */
          arrowsAlt: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g><g><g><g><path  d="M63.4,26c-0.2,0.2-0.4,0.3-0.7,0.4c-0.8,0.3-1.601,0.1-2.2-0.4l-5.6-11.3L40.8,28.9c-0.8,0.8-2.1,0.8-2.899,0L34.8,25.8c-0.8-0.8-0.8-2.1,0-2.9L49.3,9.1L38,3.5c-0.6-0.6-0.8-1.5-0.4-2.2C37.8,0.5,38.6,0,39.4,0H62c1.1,0,2,0.9,2,2v22.6C64,25.2,63.8,25.7,63.4,26z"/></g></g></g><g><g><g><path  d="M0.6,38c0.2-0.2,0.4-0.3,0.7-0.4C2,37.2,2.9,37.4,3.5,38l5.6,11.3l14.1-14.1c0.8-0.8,2.1-0.8,2.9,0l3.1,3.1c0.8,0.8,0.8,2.101,0,2.9L14.7,54.9L26,60.5c0.6,0.6,0.8,1.5,0.4,2.2c-0.3,0.8-1.1,1.3-1.9,1.3H2c-1.1,0-2-0.9-2-2V39.4C0,38.8,0.2,38.3,0.6,38z"/></g></g></g></g></svg>',
          caret: '<svg version="1.1" id = "Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns: xlink = "http://www.w3.org/1999/xlink" x="0px" y="0px" class= "his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml: space = "preserve" > <g><g><g><path  d = "M12,24.3c0-0.3,0.1-0.6,0.2-0.9c0.4-0.9,1.2-1.4,2.2-1.4L32,27.1l17.7-5c0.899,0,1.8,0.6,2.2,1.4c0.399,0.9,0.199,1.9-0.5,2.5L34,43.3c-0.9,0.9-2.9,0.9-3.8,0L12.7,26C12.2,25.5,12,24.9,12,24.3z" /> </g></g > </g></svg > ',
          circle: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="his-icon"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class= "his-icon" ></path></svg> ',
          close: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g><path  d="M38.4,32l16.1-16.1c1-1.1,1.5-2.3,1.5-3.5c0-1.3-0.5-2.3-1.5-3.2c-1-0.9-2.1-1.3-3.4-1.2   C49.9,8.1,48.7,8.8,47.7,9.9L32,25.6L16.4,9.9C15.3,8.7,14.2,8.1,13,8c-1.3-0.1-2.4,0.3-3.4,1.2c-1,0.9-1.5,2-1.5,3.2   c0,1.2,0.5,2.4,1.5,3.5l16,16.1l-16,15.9C8.6,49.1,8,50.3,8,51.5c0,1.3,0.5,2.4,1.5,3.3c0.9,0.8,1.9,1.2,3,1.2c0.1,0,0.1,0,0.2,0   h0.2c1.2-0.1,2.4-0.8,3.5-1.9L32,38.4L47.6,54c1.101,1.2,2.301,1.8,3.5,1.9h0.2c0.101,0,0.101,0,0.2,0c1.1,0,2.1-0.4,3-1.2   c1-0.9,1.5-2,1.5-3.3c0-1.2-0.6-2.4-1.6-3.601L38.4,32z"/></g></svg>',
          code: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M31.7,5.3"/><g><path  d="M17.4,46.5c-0.6,0-1.2-0.2-1.7-0.6L1,33.9c-0.7-0.5-1-1.3-1-2.2s0.4-1.7,1-2.2l14.6-12c1.2-1,2.9-0.8,3.9,0.4c0.9,1.2,0.8,3-0.4,3.9l-12,9.8l12,9.8c1.2,1,1.4,2.7,0.4,3.9C19,46.2,18.2,46.5,17.4,46.5z"/><path  d="M46.6,46.5c-0.8,0-1.6-0.4-2.1-1.1c-0.9-1.2-0.8-3,0.4-3.9l12-9.8l-12-9.8c-1.2-1-1.4-2.7-0.4-3.9c0.9-1.2,2.7-1.4,3.9-0.4l14.6,12c0.7,0.5,1,1.3,1,2.2s-0.4,1.7-1,2.2l-14.6,12C47.8,46.3,47.2,46.5,46.6,46.5z"/><path  d="M24.7,54c-0.3,0-0.6,0-0.9-0.2c-1.4-0.5-2.2-2-1.6-3.4l14.6-38.7c0.5-1.4,2.1-2.1,3.5-1.6c1.4,0.5,2.2,2,1.6,3.4L27.3,52.3C26.9,53.3,25.8,54,24.7,54z"/></g><path style="fill:#fff;stroke:#006ab2;stroke-miterlimit:10" d="M-39,86.7"/></svg>',
          bold: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path style="fill:#fff;stroke:#006ab2;stroke-miterlimit:10" d="M-39,86.7"/><g><path  d="M52,42.4c0,1.8-0.3,3.5-0.8,5c-0.5,1.5-1.2,2.8-2.1,4c-0.9,1.2-2,2.1-3.2,3c-1.3,0.8-2.6,1.5-4.2,2c-1.5,0.5-3.1,0.9-4.8,1.2c-1.7,0.3-3.6,0.4-5.7,0.4h-14c-0.9,0-1.6-0.3-2.3-0.8c-0.6-0.5-0.9-1.4-0.9-2.6V9.3c0-1.2,0.3-2,0.9-2.6C15.5,6.3,16.3,6,17.2,6h13.2c3.2,0,5.9,0.3,8.2,0.8c2.2,0.5,4.1,1.3,5.6,2.4s2.7,2.5,3.5,4.1c0.8,1.7,1.2,3.6,1.2,5.9c0,1.3-0.2,2.4-0.5,3.6c-0.3,1.1-0.8,2.1-1.4,3c-0.6,0.9-1.4,1.7-2.3,2.4c-0.9,0.7-1.9,1.3-3.1,1.7c1.5,0.3,2.9,0.7,4.1,1.4C47,32,48,32.9,49,33.9c0.9,1.1,1.7,2.3,2.2,3.7S52,40.6,52,42.4z M38.2,20.5c0-1-0.2-2-0.5-2.8c-0.3-0.8-0.8-1.5-1.5-2.1c-0.6-0.5-1.5-1-2.5-1.3c-1-0.3-2.3-0.4-4-0.4h-5.4v13.5h6c1.5,0,2.8-0.2,3.7-0.5s1.7-0.9,2.3-1.5c0.6-0.6,1.1-1.4,1.4-2.2C38.1,22.3,38.2,21.4,38.2,20.5z M40.9,42.8c0-1.2-0.2-2.3-0.6-3.2c-0.4-1-1-1.7-1.8-2.4c-0.8-0.6-1.8-1.1-3-1.5c-1.2-0.3-2.8-0.5-4.7-0.5h-6.3v14.8h7.7c1.5,0,2.7-0.2,3.8-0.5c1-0.3,1.9-0.8,2.6-1.4c0.7-0.6,1.3-1.4,1.7-2.3S40.9,43.9,40.9,42.8z"/></g></svg>',
          underline: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><g><path  d="M50,32.5c0,2.6-0.4,4.9-1.2,6.9c-0.8,2-2,3.8-3.5,5.2c-1.5,1.4-3.5,2.5-5.7,3.2c-2.3,0.7-4.9,1.1-7.8,1.1c-2.8,0-5.3-0.3-7.5-1c-2.2-0.7-4.1-1.7-5.6-3c-1.5-1.3-2.7-3-3.5-5c-0.8-2-1.2-4.3-1.2-7V7.4c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.7-0.4s0.8-0.2,1.4-0.3C16.9,6,17.6,6,18.5,6c0.9,0,1.6,0,2.1,0.1c0.6,0.1,1,0.2,1.4,0.3c0.3,0.1,0.6,0.2,0.7,0.4C22.9,7,23,7.1,23,7.4v24.8c0,1.7,0.2,3.1,0.6,4.3s1.1,2.2,1.9,3c0.8,0.8,1.8,1.4,2.9,1.8s2.4,0.6,3.8,0.6c1.4,0,2.7-0.2,3.8-0.6c1.1-0.4,2.1-1,2.8-1.8s1.4-1.8,1.8-2.9s0.6-2.5,0.6-3.9V7.4c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.7-0.4c0.3-0.1,0.8-0.2,1.4-0.3C44,6,44.7,6,45.6,6s1.6,0,2.1,0.1c0.6,0.1,1,0.2,1.3,0.3c0.3,0.1,0.6,0.2,0.7,0.4C49.9,7,50,7.1,50,7.4V32.5z"/></g><path  d="M47.3,58H16.7c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7h30.7c1.5,0,2.7,1.2,2.7,2.7C50,56.8,48.8,58,47.3,58z"/></g></svg>',
          italic: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path style="fill:#fff;stroke:#006ab2;stroke-miterlimit:10" d="M-39,86.7"/><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M-36.5,6"/><path  d="M47.2,6H28.4c-1.6,0-2.8,1.3-2.8,2.9c0,1.6,1.3,2.9,2.8,2.9h4.4L21.9,52.3h-5.1c-1.6,0-2.8,1.3-2.8,2.9s1.3,2.9,2.8,2.9H37c1.6,0,2.8-1.3,2.8-2.9s-1.3-2.9-2.8-2.9h-4.7l10.8-40.6h4.1c1.6,0,2.8-1.3,2.8-2.9C50,7.3,48.7,6,47.2,6z"/></svg>',
          strike: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M30.2,24.4c-1-0.6-1.8-1.4-2.4-2.2c-0.6-0.8-0.9-1.8-0.9-2.9c0-0.8,0.1-1.5,0.4-2.1c0.3-0.7,0.7-1.2,1.2-1.7c0.5-0.5,1.2-0.9,2-1.1c0.8-0.3,1.8-0.4,2.8-0.4c1.4,0,2.7,0.2,3.8,0.5c1.2,0.3,2.2,0.7,3.1,1.2c0.9,0.4,1.6,0.8,2.2,1.2c0.6,0.4,1,0.5,1.3,0.5c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.4-0.7c0.1-0.3,0.2-0.8,0.2-1.3c0-0.5,0.1-1.2,0.1-1.9s0-1.2,0-1.7c0-0.5-0.1-0.8-0.1-1.1c-0.1-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.4-0.5-0.7c-0.3-0.3-0.8-0.6-1.6-1c-0.8-0.4-1.7-0.8-2.7-1.1c-1-0.3-2.1-0.6-3.3-0.7C35.5,6.1,34.3,6,33.2,6c-2.2,0-4.4,0.3-6.4,0.9s-3.7,1.5-5.2,2.7s-2.7,2.7-3.5,4.5c-0.9,1.8-1.3,3.9-1.3,6.3c0,2.1,0.3,3.9,0.9,5.4h15.1C31.9,25.4,31,24.9,30.2,24.4z"/><path  d="M34.3,38.2c1,0.6,1.8,1.4,2.4,2.2c0.6,0.8,0.9,1.8,0.9,2.9c0,1-0.2,1.9-0.5,2.7c-0.3,0.8-0.9,1.5-1.5,2c-0.7,0.5-1.5,1-2.4,1.3c-1,0.3-2,0.4-3.3,0.4c-1.8,0-3.5-0.2-4.9-0.6c-1.4-0.4-2.6-0.9-3.6-1.4c-1-0.5-1.8-1-2.5-1.4c-0.6-0.4-1.1-0.6-1.5-0.6c-0.3,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.3,0.4-0.5,0.7c-0.1,0.3-0.2,0.8-0.2,1.3c-0.1,0.5-0.1,1.2-0.1,2c0,1.2,0.1,2.1,0.2,2.7c0.1,0.6,0.4,1.1,0.7,1.5c0.3,0.4,0.9,0.7,1.6,1.2c0.7,0.4,1.7,0.9,2.8,1.3c1.1,0.4,2.4,0.7,3.8,1c1.5,0.3,3,0.4,4.7,0.4c2.5,0,4.8-0.3,7-1s4.1-1.7,5.8-3c1.6-1.3,2.9-3,3.9-5c1-2,1.4-4.3,1.4-6.9c0-2-0.3-3.7-0.9-5.2H31.8C32.6,37.2,33.5,37.7,34.3,38.2z"/><path  d="M51.2,28.7H12.7c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7h38.6c1.5,0,2.7-1.2,2.7-2.7C53.9,29.9,52.7,28.7,51.2,28.7z"/></g></svg>',
          subscript: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M32,29l14.8-15.4c0.9-1,1.4-2.2,1.3-3.3c0-1.2-0.5-2.3-1.4-3.1c-0.9-0.8-2-1.2-3.1-1.1c-1.1,0.1-2.2,0.7-3.1,1.8L26,22.8l-14.4-15c-1-1.1-2-1.7-3.2-1.8C7.3,5.9,6.3,6.3,5.4,7.1C4.5,8,4,9,4,10.2c0,1.2,0.4,2.3,1.4,3.4L20.1,29L5.5,44.3c-1,1.1-1.5,2.2-1.5,3.4c0,1.2,0.4,2.3,1.3,3.2C6.2,51.6,7.1,52,8.1,52c0.1,0,0.1,0,0.2,0l0.2,0c1.1-0.1,2.2-0.7,3.2-1.8l14.3-15l14.3,15c1,1.1,2.1,1.7,3.2,1.8l0.2,0c0.1,0,0.1,0,0.2,0c1,0,2-0.4,2.8-1.1c0.9-0.9,1.4-2,1.3-3.2c0-1.2-0.5-2.3-1.5-3.4L32,29z"/><path  d="M62,55.9c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.1-0.1-0.2-0.2-0.3C61.5,55,61.4,55,61.3,55h-6.1l1.7-1.7c1-1,1.7-1.8,2.3-2.5c0.6-0.7,1-1.4,1.4-2c0.3-0.6,0.5-1.2,0.6-1.7c0.1-0.5,0.2-1.1,0.2-1.6c0-0.6-0.1-1.2-0.3-1.8c-0.2-0.5-0.5-1-1-1.4c-0.4-0.4-1-0.7-1.6-0.9C57.8,41.1,57,41,56.2,41c-0.5,0-1.1,0.1-1.6,0.2c-0.5,0.1-1,0.2-1.4,0.4c-0.4,0.1-0.8,0.3-1.1,0.5c-0.3,0.2-0.5,0.3-0.6,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.4c0,0.1,0,0.3,0,0.5c0,0.3,0,0.5,0,0.7c0,0.2,0.1,0.4,0.1,0.5c0,0.1,0.1,0.3,0.2,0.3c0.2,0.2,0.4,0.2,0.8-0.1c0.2-0.1,0.4-0.3,0.7-0.4c0.3-0.1,0.6-0.3,1-0.4c0.4-0.1,0.8-0.2,1.3-0.2c0.3,0,0.6,0,0.9,0.1c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.3,0,0.6-0.1,0.9c-0.1,0.3-0.2,0.7-0.4,1.1c-0.2,0.4-0.5,0.8-0.8,1.3c-0.3,0.5-0.8,1-1.3,1.6l-2.8,3c-0.2,0.2-0.3,0.3-0.4,0.5C51.1,54.8,51,55,51,55.2c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.5,0,0.7c0,0.3,0,0.6,0.1,0.8c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3,0.1,0.5,0.1h9.4c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.4,0-0.6C62,56.3,62,56,62,55.9z"/></g></svg>',
          superscript: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M32.1,35L47,19.6c0.9-1,1.4-2.2,1.4-3.3c0-1.2-0.5-2.3-1.4-3.1c-0.9-0.8-2-1.2-3.1-1.1c-1.1,0.1-2.2,0.7-3.2,1.8l-14.5,15l-14.4-15c-1-1.1-2.1-1.7-3.2-1.8c-1.2-0.1-2.2,0.3-3.1,1.1C4.5,14,4,15,4,16.2c0,1.2,0.4,2.3,1.4,3.4L20.2,35L5.5,50.3c-1,1.1-1.5,2.2-1.5,3.4c0,1.2,0.4,2.3,1.4,3.2C6.2,57.6,7.1,58,8.1,58c0.1,0,0.1,0,0.2,0l0.2,0c1.1-0.1,2.2-0.7,3.2-1.8l14.4-15l14.4,15c1,1.1,2.1,1.7,3.2,1.8l0.2,0c0.1,0,0.1,0,0.2,0c1,0,2-0.4,2.8-1.1c0.9-0.9,1.4-2,1.4-3.2c0-1.2-0.5-2.3-1.5-3.4L32.1,35z"/><path  d="M62,20.8c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.1-0.1-0.2-0.2-0.3C61.5,20,61.4,20,61.3,20h-6.1l1.7-1.7c1-1,1.7-1.8,2.3-2.5c0.6-0.7,1-1.4,1.4-2c0.3-0.6,0.5-1.2,0.6-1.7c0.1-0.5,0.2-1.1,0.2-1.6c0-0.6-0.1-1.2-0.3-1.8c-0.2-0.5-0.5-1-1-1.4c-0.4-0.4-1-0.7-1.6-0.9C57.8,6.1,57,6,56.1,6c-0.5,0-1.1,0.1-1.6,0.2c-0.5,0.1-1,0.2-1.4,0.4c-0.4,0.1-0.8,0.3-1.1,0.5c-0.3,0.2-0.5,0.3-0.6,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.4c0,0.1,0,0.3,0,0.5c0,0.3,0,0.5,0,0.7c0,0.2,0.1,0.4,0.1,0.5c0,0.1,0.1,0.3,0.2,0.3c0.2,0.2,0.4,0.2,0.8-0.1c0.2-0.1,0.4-0.3,0.7-0.4c0.3-0.1,0.6-0.3,1-0.4c0.4-0.1,0.8-0.2,1.3-0.2c0.3,0,0.6,0,0.9,0.1c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.3,0,0.6-0.1,0.9c-0.1,0.3-0.2,0.7-0.4,1.1c-0.2,0.4-0.5,0.8-0.8,1.3c-0.3,0.5-0.8,1-1.4,1.6l-2.8,3c-0.2,0.2-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.5,0,0.7c0,0.3,0,0.6,0.1,0.8c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3,0.1,0.5,0.1h9.4c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.4,0-0.6C62,21.2,62,21,62,20.8z"/></g></svg>',
          eraser: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M61.5,27.8L45.7,7c-0.4-0.5-1-0.9-1.7-1c-0.7-0.1-1.3,0.1-1.9,0.5L3,35.5c-1.1,0.8-1.3,2.4-0.5,3.5l12.1,16c0.5,0.6,1.2,1,2,1c0,0,0,0,0,0h36.8c1.4,0,2.5-1.1,2.5-2.5S54.9,51,53.5,51h-19L61,31.3c0.5-0.4,0.9-1,1-1.6C62.1,29,61.9,28.3,61.5,27.8z M8.1,38l11.8-8.8L32.8,46L26,51l-8.1,0L8.1,38z"/></svg>',
          unorderedlist: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.74 12.37"><g><path d="M7.77,16.12a1.59,1.59,0,0,0-.49-1.18,1.62,1.62,0,0,0-1.19-.49,1.68,1.68,0,1,0,0,3.36,1.67,1.67,0,0,0,1.68-1.69Zm0-4.48A1.67,1.67,0,0,0,6.09,10,1.68,1.68,0,0,0,4.9,12.82a1.62,1.62,0,0,0,1.19.49,1.67,1.67,0,0,0,1.68-1.67Zm12.38,3.64a.27.27,0,0,0-.08-.19.28.28,0,0,0-.2-.09H9.19a.28.28,0,0,0-.2.08.29.29,0,0,0-.08.19V17a.27.27,0,0,0,.28.28H19.87a.27.27,0,0,0,.19-.08.24.24,0,0,0,.08-.2V15.28ZM7.77,7.13a1.63,1.63,0,0,0-.49-1.2,1.61,1.61,0,0,0-1.19-.49,1.61,1.61,0,0,0-1.19.49,1.71,1.71,0,0,0,0,2.4,1.62,1.62,0,0,0,1.19.49,1.61,1.61,0,0,0,1.19-.49,1.63,1.63,0,0,0,.49-1.2Zm12.38,3.66a.28.28,0,0,0-.08-.2.29.29,0,0,0-.19-.08H9.19a.27.27,0,0,0-.28.28v1.69a.27.27,0,0,0,.08.19.24.24,0,0,0,.2.08H19.87a.27.27,0,0,0,.19-.08.25.25,0,0,0,.08-.19V10.79Zm0-4.5a.27.27,0,0,0-.08-.19A.25.25,0,0,0,19.88,6H9.19A.28.28,0,0,0,9,6.1a.26.26,0,0,0-.08.19V8A.27.27,0,0,0,9,8.17a.24.24,0,0,0,.2.08H19.87a.27.27,0,0,0,.19-.08A.25.25,0,0,0,20.14,8V6.29Z" transform="translate(-4.41 -5.44)"/></g></svg>',
          orderedlist: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M53.5,12.7h-30c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3S54.9,12.7,53.5,12.7z"/><path  d="M53.5,28.9h-30c-1.4,0-2.5,1.3-2.5,3c0,1.7,1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3C56,30.2,54.9,28.9,53.5,28.9z"/><path  d="M53.5,45.1h-30c-1.4,0-2.5,1.3-2.5,3s1.1,3,2.5,3h30c1.4,0,2.5-1.3,2.5-3S54.9,45.1,53.5,45.1z"/><g><path  d="M15,20.6c0,0.2,0,0.3,0,0.4s0,0.2-0.1,0.3s-0.1,0.1-0.1,0.1s-0.1,0-0.1,0H8.4c0,0-0.1,0-0.1,0s-0.1-0.1-0.1-0.1S8.1,21.1,8.1,21s0-0.3,0-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2s0.1,0,0.1,0h2.1v-7.4l-1.8,1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1S8,13.2,8,13.1s0-0.3,0-0.5c0-0.1,0-0.3,0-0.3s0-0.2,0-0.2s0.1-0.1,0.1-0.2s0.1-0.1,0.2-0.1l2.4-1.6c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.2,0s0.2,0,0.3,0c0.1,0,0.3,0,0.4,0c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0s0.1,0,0.1,0.1s0,0.1,0,0.1v9.4h1.9c0.1,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3C15,20.3,15,20.4,15,20.6z"/></g><g><path  d="M15.6,50.5c0,0.6-0.1,1.1-0.3,1.5s-0.5,0.8-0.9,1.1s-0.8,0.5-1.4,0.7c-0.5,0.2-1.1,0.2-1.8,0.2c-0.4,0-0.8,0-1.1-0.1c-0.3-0.1-0.6-0.1-0.9-0.2s-0.5-0.2-0.6-0.3s-0.3-0.2-0.3-0.2s-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.3,0-0.5,0.1-0.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.3,0.2,0.5,0.3C9.4,51.9,9.6,52,9.9,52c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6,0,0.9-0.1s0.5-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.4-0.5-0.5c-0.2-0.1-0.5-0.3-0.8-0.3c-0.3-0.1-0.7-0.1-1.1-0.1h-1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1s-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0-0.4c0-0.2,0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.2s0.1-0.1,0.1-0.1s0.1,0,0.2,0h1c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.5-0.2,0.7-0.3s0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.1-0.7-0.1c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.1-0.3,0.1-0.3,0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1s0-0.1-0.1-0.3s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2s0-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.2c0.1-0.1,0.2-0.1,0.4-0.2s0.4-0.2,0.7-0.3s0.6-0.2,1-0.3c0.4-0.1,0.8-0.1,1.2-0.1c0.6,0,1,0.1,1.5,0.2s0.8,0.3,1.1,0.6c0.3,0.2,0.5,0.5,0.7,0.9c0.1,0.4,0.2,0.8,0.2,1.2c0,0.3,0,0.7-0.1,1s-0.2,0.6-0.4,0.8s-0.4,0.4-0.6,0.6c-0.3,0.2-0.5,0.3-0.9,0.4v0c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.4,0.8,0.6c0.2,0.2,0.4,0.5,0.5,0.8C15.5,49.8,15.6,50.1,15.6,50.5z"/></g><g><path  d="M15.6,36.7c0,0.2,0,0.3,0,0.4c0,0.1,0,0.2-0.1,0.3s-0.1,0.1-0.1,0.2c0,0-0.1,0-0.2,0H8.7c-0.1,0-0.2,0-0.3,0s-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0-0.5c0-0.2,0-0.4,0-0.5c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.3l2-2.1c0.4-0.4,0.7-0.8,0.9-1.1c0.2-0.3,0.4-0.6,0.6-0.9s0.2-0.5,0.3-0.8s0.1-0.5,0.1-0.7c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3s-0.4-0.1-0.6-0.1c-0.3,0-0.7,0-0.9,0.1s-0.5,0.2-0.7,0.3c-0.2,0.1-0.4,0.2-0.5,0.3S8.6,29,8.5,29c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.2s0-0.2-0.1-0.3s0-0.3,0-0.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2s0-0.1,0.1-0.2s0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.2,0.7-0.3s0.6-0.2,0.9-0.3s0.7-0.1,1.1-0.1c0.6,0,1.1,0.1,1.6,0.2c0.4,0.1,0.8,0.4,1.1,0.6s0.5,0.6,0.7,0.9c0.1,0.4,0.2,0.8,0.2,1.2c0,0.4,0,0.7-0.1,1.1s-0.2,0.7-0.4,1.2s-0.5,0.9-0.9,1.4s-0.9,1.1-1.6,1.7l-1.3,1.4h4.5c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3C15.6,36.4,15.6,36.6,15.6,36.7z"/></g></g><path style="fill:#fff;stroke:#006ab2;stroke-width:6;stroke-miterlimit:10" d="M113.7,7.3"/></svg>',
          picture: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve" class="his-icon"> <path  d="M61.1,64H2.9C1.3,64,0,62.7,0,61.1V2.9C0,1.3,1.3,0,2.9,0h58.2C62.7,0,64,1.3,64,2.9v58.2	C64,62.7,62.7,64,61.1,64z M6,58h52V6H6V58z" /> <path  d="M54,52.8c0-0.1-2.2-8.4-4.7-16.6C44.1,19,42.6,19,41.6,19c-1.2,0-2.8,1-6.8,12.3c-1.3,3.9-2.5,7.7-3.2,9.9c-2-2.4-6-6.7-9.2-6.7c-4.1,0-10.5,13.8-12.4,18.1c-0.1,0.3-0.1,0.6,0.1,0.9c0.2,0.3,0.5,0.4,0.8,0.4H53c0.3,0,0.6-0.1,0.8-0.4C54,53.4,54,53.1,54,52.8z" /> <circle  cx="17" cy="17" r="7" /> </svg>',
          video: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.74 14.55"><g><path d="M20.15,10.26V18.9l-3.94-1.57v1.2H4.41V10.66H16.22v1.23l2-.81,2-.82ZM14.64,17h0V12.54h0v-.31H6V17h8.67Zm3.94-.37v-4l-2.37,1v2l1.18.48,1.19.48ZM7.94,9.86A2.77,2.77,0,0,1,5.19,7.11a2.76,2.76,0,0,1,5.51,0A2.78,2.78,0,0,1,7.94,9.86Zm0-3.93a1.21,1.21,0,0,0-.83.35,1.15,1.15,0,0,0-.34.84A1.09,1.09,0,0,0,7.11,8,1.15,1.15,0,0,0,8,8.28,1.13,1.13,0,0,0,9.11,7.12,1.16,1.16,0,0,0,7.94,5.93Zm5.9,3.93a2.34,2.34,0,0,1-1.67-.68,2.3,2.3,0,0,1-.68-1.67,2.35,2.35,0,0,1,4-1.67,2.37,2.37,0,0,1,0,3.34,2.33,2.33,0,0,1-1.68.68Zm0-3.14a.75.75,0,1,0,.55.22.73.73,0,0,0-.55-.22Z" transform="translate(-4.41 -4.35)"/></g></svg>',
          font: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="font" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" cclass="his-icon"><path d = "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z" ></path ></svg > ',
          link: '<svg version="1.1" class="his-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g><g><path  d="M38.5,28.4c0,0-3.1-3.1-3.3-3.2c-0.7-0.6-1.4-1.1-2.101-1.5c-2.899-1.4-6.3-1.3-8.899,0.5c-0.4,0.3-0.9,0.6-1.3,1L6.5,41.7C3.1,45.1,3.2,50.8,6.8,54.4L9.7,57.3C13.3,60.9,19,61,22.4,57.6l13.8-13.8c-0.4,0-0.7,0.101-1.101,0.101c-0.8,0-1.6-0.101-2.3-0.2c-0.4-0.101-0.8-0.2-1.1-0.3C30.8,43.1,30,42.8,29.2,42.3L18,53.2c-1.1,1.1-3,1.1-4.2-0.101L10.9,50.2C9.7,49,9.7,47.1,10.8,46l16.5-16.5c0.4-0.4,1-0.7,1.5-0.8c0.9-0.2,1.9,0.1,2.6,0.8c0,0,0.1,0,0.1,0.1l2.9,2.9c0,0,0,0.1,0.1,0.1c0.1,0.101,0.2,0.101,0.3,0.101c0,0,0.2,0,0.2-0.101l3.9-3.899C38.7,28.7,38.6,28.5,38.5,28.4z"/></g><g><path  d="M57.2,9.7l-2.9-2.9C50.7,3.2,45,3.1,41.6,6.5L27.9,20.3c0.5,0,0.9-0.1,1.4-0.1c2,0,4,0.6,5.7,1.6l11-11c1.1-1.1,3-1.1,4.2,0.1l2.899,2.9c1.2,1.2,1.2,3.1,0.101,4.2L36.7,34.5c-0.4,0.4-1,0.7-1.5,0.8c-0.9,0.2-1.9-0.1-2.601-0.8c0,0-0.1,0-0.1-0.1l-2.9-2.9c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.2,0.1l-3.9,3.9c0.1,0.101,3.5,3.5,3.6,3.601c0.7,0.6,1.4,1.1,2.1,1.5c0.9,0.399,1.8,0.699,2.7,0.899c0.4,0.101,0.9,0.101,1.3,0.101c1.7,0,3.4-0.5,4.8-1.4c0.4-0.3,17.7-17.5,17.7-17.5C60.9,18.9,60.8,13.2,57.2,9.7z"/></g></g></svg>',
          unlink: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="unlink" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="his-icon"><path d = "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z" ></path ></svg > ',
          magic: '<svg xmlns="http://www.w3.org/2000/svg" class="his-icon" viewBox="0 0 15.73 15.75"><g><path d="M19.86,19.21a1,1,0,0,0,.28-.68,1,1,0,0,0-.28-.7L13,10.93a1,1,0,0,0-.7-.28,1,1,0,0,0-.68,1.65l6.9,6.9a1,1,0,0,0,.69.29.93.93,0,0,0,.69-.28ZM9.19,8.55a3,3,0,0,0,1.68,0,14.12,14.12,0,0,0,1.41-.32A11.26,11.26,0,0,0,10.8,7.06c-.56-.36-.86-.56-.91-.58S10,5.91,10,5.11s0-1.26-.15-1.37a4.35,4.35,0,0,0-1.19.71c-.53.4-.81.62-.87.68a9,9,0,0,0-2-.6,6.84,6.84,0,0,0-.76-.09s0,.27.08.77a8.6,8.6,0,0,0,.61,2q-.09.09-.69.87a3.59,3.59,0,0,0-.68,1.17c.12.17.57.23,1.36.15S7,9.26,7.15,9.23s.21.36.57.91a10.49,10.49,0,0,0,1.14,1.48c0-.1.14-.57.31-1.4a3,3,0,0,0,0-1.67Z" transform="translate(-4.41 -3.74)"/></g></svg>',
          menuCheck: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="his-icon"><path d = "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" class= "" ></path ></svg > ',
          minus: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="his-icon"><path d = "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class= "" ></path ></svg > ',
          pencil: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="his-icon"><path d = "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z" class= "" ></path ></svg > ',
          question: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"  x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g><g><path  d="M32,4C16.6,4,4,16.6,4,32c0,15.4,12.6,28,28,28c15.4,0,28-12.6,28-28C60,16.6,47.4,4,32,4z     M35.6,50.8c0,0.601-0.5,1.2-1.199,1.2h-4.9c-0.6,0-1.2-0.5-1.2-1.2V46c0-0.6,0.5-1.2,1.2-1.2h4.9c0.6,0,1.199,0.5,1.199,1.2V50.8    z M43.2,27.4c-0.8,1.4-2.2,3-4.4,5c-1.6,1.5-2.3,2.2-2.6,2.5c-0.3,0.5-0.601,1-0.8,1.6C35.3,37,35.2,38,35.1,40    c0,0.6-0.5,1.2-1.199,1.2H29.8c-0.6,0-1.2-0.5-1.2-1.101c0-0.6,0-1,0-1.3c0-1.8,0.3-3.399,0.8-4.8c0.4-1,1-2.1,1.9-3.1    c0.6-0.7,1.7-1.7,3.2-3.1c1.7-1.5,2.4-2.4,2.6-2.8c0.301-0.6,0.5-1.2,0.5-2c0-1.3-0.5-2.5-1.6-3.5s-2.4-1.6-3.9-1.6    c-1.5,0-2.7,0.5-3.7,1.4c-1,0.9-1.7,2.5-2,4.7c-0.1,0.6-0.7,1-1.3,1l-4.4-0.5c-0.3,0-0.6-0.2-0.8-0.4c-0.2-0.2-0.3-0.6-0.2-0.9    c0.4-3.5,1.7-6.3,3.9-8.2c2.2-1.9,5-2.9,8.5-2.9c3.7,0,6.7,1,8.9,3.1c2.3,2.1,3.4,4.6,3.4,7.6C44.4,24.4,44,26,43.2,27.4z"/></g></g></svg>',
          square: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="his-icon"><path d = "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z" ></path ></svg > ',
          strikethrough: '<svg class="his-icon" aria-hidden="true" data-prefix="fas" data-icon="strikethrough" data-fa-i2svg="" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d = "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z" ></path ></svg > ',
          table: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><path  d="M6.1,60h11.7c1.2,0,2.1-1,2.1-2.1V46.1c0-1.2-1-2.1-2.1-2.1H6.1C5,44,4,45,4,46.1v11.7C4,59,5,60,6.1,60z"/><path  d="M6.1,40h11.7c1.2,0,2.1-1,2.1-2.1V26.1c0-1.2-1-2.1-2.1-2.1H6.1C5,24,4,25,4,26.1v11.7C4,39,5,40,6.1,40z"/><path  d="M6.1,20h11.7c1.2,0,2.1-1,2.1-2.1V6.1C20,5,19,4,17.9,4H6.1C5,4,4,5,4,6.1v11.7C4,19,5,20,6.1,20z"/><path  d="M46.1,60h11.7c1.2,0,2.1-1,2.1-2.1V46.1c0-1.2-1-2.1-2.1-2.1H46.1C45,44,44,45,44,46.1v11.7C44,59,45,60,46.1,60z"/><path  d="M46.1,40h11.7c1.2,0,2.1-1,2.1-2.1V26.1c0-1.2-1-2.1-2.1-2.1H46.1C45,24,44,25,44,26.1v11.7C44,39,45,40,46.1,40z"/><path  d="M46.1,20h11.7c1.2,0,2.1-1,2.1-2.1V6.1C60,5,59,4,57.9,4H46.1C45,4,44,5,44,6.1v11.7C44,19,45,20,46.1,20z"/><path  d="M26.1,60h11.7c1.2,0,2.1-1,2.1-2.1V46.1c0-1.2-1-2.1-2.1-2.1H26.1C25,44,24,45,24,46.1v11.7C24,59,25,60,26.1,60z"/><path  d="M26.1,40h11.7c1.2,0,2.1-1,2.1-2.1V26.1c0-1.2-1-2.1-2.1-2.1H26.1C25,24,24,25,24,26.1v11.7C24,39,25,40,26.1,40z"/><path  d="M26.1,20h11.7c1.2,0,2.1-1,2.1-2.1V6.1C40,5,39,4,37.9,4H26.1C25,4,24,5,24,6.1v11.7C24,19,25,20,26.1,20z"/></svg>',
          rowBelow: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path style="fill:none" d="M44.9,39.9L44.9,39.9c-0.3-1.1-0.7-2.1-1.2-3.1C44.2,37.8,44.6,38.8,44.9,39.9z"/><path  d="M45.3,41.9c-0.1-0.7-0.2-1.3-0.3-2l0,0C45.1,40.6,45.2,41.2,45.3,41.9z"/><path  d="M56.1,18H7.9C4.7,18,2,20.7,2,24.1v15.8C2,43.3,4.7,46,7.9,46h8.4c-0.2-1-0.3-2-0.3-3c0-1.1,0.1-2.1,0.3-3.1H7.9l0-15.8l48.2,0l0,15.8h-8.3c0.2,1,0.3,2,0.3,3.1c0,1-0.1,2-0.3,3h8.2c3.3,0,5.9-2.7,5.9-6.1V24.1C62,20.7,59.3,18,56.1,18z"/><path  d="M45.3,41.9c-0.1-0.7-0.2-1.3-0.3-2c-0.3-1.1-0.7-2.1-1.2-3.1c-0.3-0.6-0.7-1.2-1.2-1.7c-1.3-1.6-2.9-2.9-4.8-3.8c-1-0.4-2-0.8-3-1C33.8,30.1,33,30,32.1,30c-0.8,0-1.7,0.1-2.4,0.2c-5.1,0.9-9.1,4.8-10.4,9.7c-0.2,1-0.4,2-0.4,3.1c0,1,0.1,2,0.4,3c0.5,2,1.4,3.9,2.8,5.4c1.9,2.2,4.6,3.8,7.6,4.4c0.8,0.1,1.6,0.2,2.4,0.2c0.9,0,1.7-0.1,2.6-0.2c3.2-0.6,6-2.4,7.9-4.8c1.1-1.4,2-3.1,2.4-5c0.2-1,0.4-2,0.4-3C45.3,42.6,45.3,42.3,45.3,41.9z M34,51.3h-3.8v-6.5h-6.3v-3.7h6.3v-6.5H34v6.5h6.3v3.7H34V51.3z"/></g></svg>',
          rowAbove: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path style="fill:none" d="M39,10c-0.4-0.3-0.9-0.5-1.4-0.7c-0.5-0.2-1-0.4-1.5-0.6c0.5,0.2,1,0.4,1.5,0.6C38.1,9.5,38.5,9.7,39,10z"/><path style="fill:none" d="M21.9,29.4c0.5,0.6,1,1.1,1.6,1.5C22.9,30.4,22.4,29.9,21.9,29.4z"/><path  d="M56.1,18H54h-6.3c0.2,1,0.3,2,0.3,3c0,1.1-0.1,2.1-0.3,3.1l6.3,0h2.1l0,15.8H7.9l0-15.8l8.3,0c-0.2-1-0.3-2-0.3-3.1c0-1,0.1-2,0.3-3H7.9C6.4,18,5,18.6,4,19.5c-1.2,1.1-2,2.7-2,4.5v15.8c0,1.8,0.8,3.4,2,4.5c1,1,2.4,1.5,3.9,1.5h48.2c3.3,0,5.9-2.7,5.9-6.1V24.1C62,20.7,59.3,18,56.1,18z"/><path  d="M32,8c-0.3,0-0.5,0-0.8,0h1.6C32.5,8,32.3,8,32,8z"/><path  d="M44.8,18c-0.4-1.8-1.3-3.5-2.4-5c-1-1.2-2.1-2.3-3.5-3.1c-0.4-0.3-0.9-0.5-1.4-0.7c-0.5-0.2-1-0.4-1.5-0.6c-0.5-0.2-1-0.3-1.6-0.4C34,8.1,33.4,8.1,32.8,8h-1.6c-0.6,0-1.1,0.1-1.7,0.2C24.4,9.2,20.3,13,19.1,18c-0.2,1-0.4,2-0.4,3c0,1.1,0.1,2.1,0.4,3.1c0.5,2,1.4,3.8,2.7,5.3c0.5,0.6,1,1.1,1.6,1.5c1.7,1.4,3.8,2.4,6.1,2.8c0.8,0.1,1.6,0.2,2.4,0.2c0.9,0,1.7-0.1,2.6-0.2c3.2-0.6,6-2.4,7.9-4.8c1.1-1.4,1.9-3.1,2.4-4.9c0.2-1,0.4-2,0.4-3.1C45.2,20,45.1,19,44.8,18z M33.9,29.3h-3.8v-6.5h-6.3v-3.7h6.3v-6.5h3.8v6.5h6.3v3.7h-6.3V29.3z"/></g></svg>',
          colBefore: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path style="fill:none" d="M32.2,25.3c0.4,0.7,0.8,1.4,1.1,2.1C33,26.6,32.6,25.9,32.2,25.3z"/><path style="fill:none" d="M30.8,23.4c0.5,0.6,1,1.2,1.4,1.9C31.8,24.6,31.3,24,30.8,23.4z"/><path  d="M39.9,2H24.2c-3.3,0-6.1,2.7-6.1,5.9v8.6c1-0.2,2-0.3,3-0.3c1,0,2.1,0.1,3.1,0.3l0-8.6l15.8,0v48.2l-15.8,0l0-8.2c-1,0.2-2,0.3-3.1,0.3c-1,0-2-0.1-3-0.3v8.2c0,3.3,2.7,5.9,6.1,5.9h15.8c3.3,0,6.1-2.7,6.1-5.9V7.9C46,4.7,43.3,2,39.9,2z"/><path  d="M33.9,29.7c-0.2-0.8-0.4-1.6-0.7-2.3c-0.3-0.7-0.6-1.4-1.1-2.1c-0.4-0.7-0.9-1.3-1.4-1.9c-0.5-0.6-1.1-1.1-1.7-1.6c-1.4-1.1-3.1-2-4.9-2.4c-1-0.2-2-0.4-3.1-0.4c-1,0-2,0.1-3,0.4c-1.9,0.4-3.6,1.3-5,2.4c-1.6,1.3-3,2.9-3.8,4.8c-0.4,1-0.8,2-1,3C8.1,30.5,8,31.3,8,32.2c0,0.8,0.1,1.6,0.2,2.4c1,5.1,4.9,9.2,9.9,10.4c1,0.2,2,0.4,3,0.4c0.4,0,0.8,0,1.2-0.1c0.6-0.1,1.3-0.2,1.9-0.3c0.1,0,0.3-0.1,0.4-0.1c0.4-0.1,0.7-0.2,1.1-0.4c0.7-0.3,1.4-0.6,2-1c0.6-0.4,1.3-0.8,1.8-1.3c2.3-1.9,3.9-4.6,4.4-7.6c0.1-0.8,0.2-1.6,0.2-2.4C34.2,31.3,34.1,30.5,33.9,29.7z M29.5,34.1h-6.5v6.3h-3.7v-6.3h-6.5v-3.8h6.5V24h3.7v6.3h6.5V34.1z"/><path style="fill:#fff" d="M24.2,45L24.2,45c0.1,0,0.3-0.1,0.4-0.1C24.4,44.9,24.3,45,24.2,45z"/><path style="fill:#fff" d="M27.7,43.6c-0.6,0.4-1.3,0.7-2,1C26.4,44.3,27,44,27.7,43.6z"/><path style="fill:#fff" d="M22.3,45.3c0.6-0.1,1.3-0.2,1.9-0.3l0,0C23.5,45.2,22.9,45.3,22.3,45.3z"/></g></svg>',
          colAfter: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path style="fill:none" d="M31.8,38.7c-0.4-0.7-0.8-1.4-1.1-2.1C31,37.4,31.4,38.1,31.8,38.7z"/><path style="fill:none" d="M33.2,40.6c-0.5-0.6-1-1.2-1.4-1.9C32.2,39.4,32.7,40,33.2,40.6z"/><path  d="M24.1,62h15.8c3.3,0,6.1-2.7,6.1-5.9v-8.6c-1,0.2-2,0.3-3,0.3c-1,0-2.1-0.1-3.1-0.3l0,8.6l-15.8,0V7.9l15.8,0l0,8.2c1-0.2,2-0.3,3.1-0.3c1,0,2,0.1,3,0.3V7.9c0-3.3-2.7-5.9-6.1-5.9H24.1C20.7,2,18,4.7,18,7.9v48.2C18,59.3,20.7,62,24.1,62z"/><path  d="M30.1,34.3c0.2,0.8,0.4,1.6,0.7,2.3c0.3,0.7,0.6,1.4,1.1,2.1c0.4,0.7,0.9,1.3,1.4,1.9c0.5,0.6,1.1,1.1,1.7,1.6c1.4,1.1,3.1,2,4.9,2.4c1,0.2,2,0.4,3.1,0.4c1,0,2-0.1,3-0.4c1.9-0.4,3.6-1.3,5-2.4c1.6-1.3,3-2.9,3.8-4.8c0.4-1,0.8-2,1-3c0.2-0.8,0.3-1.7,0.3-2.5c0-0.8-0.1-1.6-0.2-2.4c-1-5.1-4.9-9.2-9.9-10.4c-1-0.2-2-0.4-3-0.4c-0.4,0-0.8,0-1.2,0.1c-0.6,0.1-1.3,0.2-1.9,0.3c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.1-0.7,0.2-1.1,0.4c-0.7,0.3-1.4,0.6-2,1c-0.6,0.4-1.3,0.8-1.8,1.3c-2.3,1.9-3.9,4.6-4.4,7.6c-0.1,0.8-0.2,1.6-0.2,2.4C29.8,32.7,29.9,33.5,30.1,34.3z M34.5,29.9h6.5v-6.3h3.7v6.3h6.5v3.8h-6.5V40h-3.7v-6.3h-6.5V29.9z"/><path style="fill:#fff" d="M39.8,19L39.8,19c-0.1,0-0.3,0.1-0.4,0.1C39.6,19.1,39.7,19,39.8,19z"/><path style="fill:#fff" d="M36.3,20.4c0.6-0.4,1.3-0.7,2-1C37.6,19.7,37,20,36.3,20.4z"/><path style="fill:#fff" d="M41.7,18.7c-0.6,0.1-1.3,0.2-1.9,0.3l0,0C40.5,18.8,41.1,18.7,41.7,18.7z"/></g></svg>',
          rowRemove: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M56.1,18H54h-6.3c0.2,1,0.3,2,0.3,3c0,1.1-0.1,2.1-0.3,3.1l6.3,0h2.1l0,13.9l0,1.9H54H7.9l0-1.9l0-13.9l8.3,0c-0.2-1-0.3-2-0.3-3.1c0-1,0.1-2,0.3-3H7.9C6.4,18,5,18.6,4,19.5c-1.2,1.1-2,2.7-2,4.6V38v1.9c0,1.8,0.8,3.4,2,4.6c1,1,2.4,1.5,3.9,1.5H54h2.1c3.3,0,5.9-2.7,5.9-6.1V38V24.1C62,20.7,59.3,18,56.1,18z"/><path  d="M44.8,18c-0.4-1.8-1.3-3.5-2.4-5c-1-1.2-2.1-2.3-3.5-3.1c-0.4-0.3-0.9-0.5-1.4-0.7c-0.5-0.2-1-0.4-1.5-0.6c-0.5-0.2-1-0.3-1.6-0.4C34,8.1,33.4,8,32.8,8h-1.6c-0.6,0-1.1,0.1-1.7,0.2C24.4,9.1,20.3,13,19.1,18c-0.2,1-0.4,2-0.4,3c0,1.1,0.1,2.1,0.4,3.1c0.5,2,1.4,3.8,2.7,5.3c0.5,0.6,1,1.1,1.6,1.6c1.7,1.4,3.8,2.4,6.1,2.8c0.8,0.1,1.6,0.2,2.4,0.2c0.9,0,1.7-0.1,2.6-0.2c3.2-0.6,6-2.4,7.9-4.8c1.1-1.4,1.9-3.1,2.4-4.9c0.2-1,0.4-2,0.4-3.1C45.2,19.9,45.1,18.9,44.8,18z M23.8,22.8v-3.7h16.4v3.7H23.8z"/></g></svg>',
          colRemove: '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve" class="his-icon"><g><path  d="M45.9,56.1V54v-6.3c-1,0.2-2,0.3-3,0.3c-1,0-2.1-0.1-3.1-0.3l0,6.3v2.1l-13.8,0l-1.9,0V54V7.9l1.9,0l13.8,0l0,8.3c1-0.2,2-0.3,3.1-0.3c1,0,2,0.1,3,0.3V7.9c0-1.5-0.6-2.9-1.5-3.9c-1.1-1.2-2.7-2-4.5-2H26h-1.9c-1.8,0-3.4,0.8-4.5,2C18.6,5,18,6.4,18,7.9V54v2.1c0,3.3,2.7,5.9,6.1,5.9H26h13.8C43.1,62,45.9,59.3,45.9,56.1z"/><path  d="M30.1,35c0.4,1.8,1.3,3.5,2.4,5c1,1.2,2.1,2.3,3.4,3.1c0.4,0.3,0.9,0.5,1.4,0.7c0.5,0.2,1,0.4,1.5,0.6c0.5,0.2,1,0.3,1.5,0.4c0.6,0.1,1.2,0.2,1.8,0.2h1.6c0.6,0,1.1-0.1,1.6-0.2c5.1-0.9,9.2-4.8,10.3-9.8c0.2-1,0.4-2,0.4-3c0-1.1-0.1-2.1-0.4-3.1c-0.5-2-1.4-3.8-2.7-5.3c-0.5-0.6-1-1.1-1.6-1.5c-1.7-1.4-3.8-2.4-6-2.8c-0.8-0.1-1.6-0.2-2.4-0.2c-0.9,0-1.7,0.1-2.5,0.2c-3.2,0.6-5.9,2.4-7.8,4.8c-1.1,1.4-1.9,3.1-2.4,4.9c-0.2,1-0.4,2-0.4,3.1C29.7,33,29.9,34,30.1,35z M51,30.2v3.7H34.7v-3.7H51z"/></g></svg>',
          tableHeader: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"  x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve" class="his-icon"> <path  d="M54.7,60c0,0-0.1,0-0.1,0l-5.3,0c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.4c0.8,0,1.6,0.7,1.6,1.5  C56.2,59.3,55.6,60,54.7,60z M43.9,60h-5.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.4c0.8,0,1.5,0.7,1.5,1.5S44.7,60,43.9,60z   M33.1,60h-5.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.4c0.8,0,1.5,0.7,1.5,1.5S33.9,60,33.1,60z M22.3,60h-5.4  c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.4c0.8,0,1.5,0.7,1.5,1.5S23.1,60,22.3,60z M11.5,60H9.3c-1.5,0-3-0.7-4-1.8  c-0.6-0.6-0.5-1.6,0.1-2.2c0.6-0.6,1.6-0.5,2.2,0.1c0.4,0.5,1,0.8,1.7,0.8h2.2c0.8,0,1.5,0.7,1.5,1.5S12.3,60,11.5,60z M58.4,56.7  c-0.1,0-0.1,0-0.2,0c-0.8-0.1-1.4-0.9-1.3-1.7c0-0.1,0-0.2,0-0.3v-4.9c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v4.9  c0,0.2,0,0.5,0,0.7C59.9,56.2,59.2,56.7,58.4,56.7z M5.5,53.5C4.7,53.5,4,52.8,4,52v-5.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5V52  C7.1,52.8,6.4,53.5,5.5,53.5z M58.5,45.9c-0.8,0-1.5-0.7-1.5-1.5V39c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v5.4  C60,45.2,59.3,45.9,58.5,45.9z M5.5,42.7C4.7,42.7,4,42,4,41.2v-5.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v5.4  C7.1,42,6.4,42.7,5.5,42.7z M58.5,35.1c-0.8,0-1.5-0.7-1.5-1.5v-5.4c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v5.4  C60,34.4,59.3,35.1,58.5,35.1z M5.5,31.9c-0.8,0-1.5-0.7-1.5-1.5V25c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v5.4  C7.1,31.2,6.4,31.9,5.5,31.9z M58.5,24.3c-0.8,0-1.5-0.7-1.5-1.5v-5.4c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v5.4  C60,23.6,59.3,24.3,58.5,24.3z M5.5,21.1c-0.8,0-1.5-0.7-1.5-1.5v-5.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v5.4  C7.1,20.4,6.4,21.1,5.5,21.1z M58.5,13.5c-0.8,0-1.5-0.7-1.5-1.5V9.3c0-0.5-0.2-1.1-0.6-1.5c-0.6-0.6-0.5-1.6,0.1-2.2  c0.6-0.6,1.6-0.5,2.2,0.1C59.5,6.8,60,8,60,9.3V12C60,12.8,59.3,13.5,58.5,13.5z M5.6,10.3c-0.1,0-0.1,0-0.2,0  C4.5,10.2,3.9,9.4,4,8.6C4.4,6,6.7,4,9.3,4c0,0,0,0,0,0c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5C8.2,7.1,7.2,7.9,7.1,9  C7,9.8,6.3,10.3,5.6,10.3z M52.5,7.1h-5.4c-0.8,0-1.5-0.7-1.5-1.5S46.3,4,47.1,4h5.4C53.3,4,54,4.7,54,5.5S53.3,7.1,52.5,7.1z   M41.7,7.1h-5.4c-0.8,0-1.5-0.7-1.5-1.5S35.4,4,36.3,4h5.4c0.8,0,1.5,0.7,1.5,1.5S42.5,7.1,41.7,7.1z M30.9,7.1h-5.4  c-0.8,0-1.5-0.7-1.5-1.5S24.6,4,25.5,4h5.4c0.8,0,1.5,0.7,1.5,1.5S31.7,7.1,30.9,7.1z M20.1,7.1h-5.4c-0.8,0-1.5-0.7-1.5-1.5  S13.8,4,14.7,4h5.4c0.8,0,1.5,0.7,1.5,1.5S20.9,7.1,20.1,7.1z"/> <path  d="M48,23.8H16c-3.1,0-5.7-2.5-5.7-5.7s2.5-5.7,5.7-5.7h32c3.1,0,5.7,2.5,5.7,5.7S51.1,23.8,48,23.8z"/></svg>',
          textHeight: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="text-height" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="his-icon"><path d = "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z" class= "" ></path ></svg > ',
          trash: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64" xml:space="preserve"><g><g><path  d="M55.5,8L40.8,5.5V5.4C41.1,3.8,40,2.2,38.4,1.9L27.7,0c-1.6-0.3-3.2,0.8-3.5,2.4v0.1L9.5,0C7.9-0.2,6.3,0.9,6,2.5C5.8,4.1,6.9,5.7,8.5,6l46,8c0.2,0,0.4,0,0.6,0c1.4,0,2.601-1.1,2.9-2.5C58.2,9.9,57.1,8.3,55.5,8z"/></g><g><path  d="M55.2,17c-0.601-0.6-1.4-1-2.3-1H11.1c-0.9,0-1.7,0.4-2.3,1c-0.6,0.6-0.9,1.5-0.8,2.3l5.2,42c0.2,1.5,1.5,2.601,3.1,2.601h31.3c1.601,0,2.9-1.101,3.101-2.601l5.2-42C56.1,18.5,55.8,17.6,55.2,17z M22.3,58.3c-0.1,0-0.2,0-0.3,0c-1.3,0-2.3-1-2.5-2.2l-3.2-29.8c-0.1-1.4,0.8-2.6,2.2-2.8c1.4-0.1,2.6,0.8,2.8,2.2l3.2,29.8C24.6,56.9,23.6,58.2,22.3,58.3z M34.5,56c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5V26c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5V56z M47.7,26.4l-3.2,29.8c-0.1,1.3-1.2,2.2-2.5,2.2c-0.1,0-0.2,0-0.3,0C40.3,58.3,39.3,57,39.5,55.6l3.2-29.8c0.1-1.4,1.399-2.4,2.8-2.2C46.9,23.8,47.8,25.1,47.7,26.4z"/></g></g></svg>',
          specialchars: '<svg class="his-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24"><text x="2" y="13" font-size="1em" font-weight="700">Ω</text></svg>',
          docximport: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 class="his-icon" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve"><g>	<g>		<path style="fill:none;" d="M3,46V29.5c0-2,1.2-3.8,3-4.6l0,0c-1.8,0.8-3.1,2.5-3.1,4.6L3,46c-0.1,2.1,1.2,3.9,3,4.6l0,0			C4.2,49.8,3,48,3,46z"/>	</g>	<g>		<path style="fill:none;" d="M36.7,29.5V46c0,2.8-2.2,5-5,5h0.1c2.7,0,4.9-2.2,4.9-5V29.5c0.1-2.8-2.2-5-4.9-5h-0.1			C34.4,24.5,36.7,26.8,36.7,29.5z"/>	</g>	<g>		<path style="fill:none;" d="M39.7,29.5V46c0.3,6-5.7,8-7.9,8H12.1v3.9h39.8V18.7h-5.2c-0.9,0-1.7-0.1-2.5-0.3v0.1l-0.7-0.3l0,0			L43.2,18l0,0c-2-1-3-3.2-3-6.5V6.1H12.1v15.4h19.7C36.2,21.5,39.7,25.1,39.7,29.5z"/>	</g>	<g>		<path  d="M6,50.6C6.4,50.8,6.8,50.9,7.3,50.9C6.8,50.9,6.4,50.8,6,50.6L6,50.6z"/>	</g>	<g>		<path  d="M7.3,24.6c-0.4,0.1-0.9,0.2-1.3,0.3l0,0C6.4,24.7,6.8,24.6,7.3,24.6z"/>	</g>	<g>		<path  d="M7.9,51H8c-0.1,0-0.2,0-0.3,0C7.8,51,7.8,51,7.9,51z"/>	</g>	<g>		<path d="M7.9,24.5c-0.1,0-0.1,0-0.2,0c0.1,0,0.2,0,0.3,0H7.9z"/>	</g>	<g>		<path   d="M46.6,0H11.1C8.3,0,6,2.3,6,5.1v16.6c0.6-0.1,1.2-0.2,1.9-0.2h4.2V6.1h28.2v5.3c0,3.4,1,5.5,3,6.5			l0,0l0.3,0.1l0,0l0.7,0.3v-0.1c0.7,0.2,1.5,0.3,2.5,0.3H52v39.2H12.1V54H7.9c-0.6,0-1.3-0.1-1.9-0.2V58.9c0,2.8,2.3,5.1,5.1,5.1			h41.8c2.8,0,5.1-2.3,5.1-5.1V12.1L46.6,0z"/>	</g>		<g>		<path  d="M31.8,21.5h-24c-0.6,0-1.3,0.1-1.9,0.2c-3.4,0.9-6,4-6,7.8V46c0,3.8,2.6,6.9,6,7.8			C6.6,53.9,7.2,54,7.9,54h24c2.2,0,8.2-2,7.9-8V29.5C39.7,25.1,36.2,21.5,31.8,21.5z M36.7,46c0,2.8-2.2,5-4.9,5h-24			c-0.1,0-0.1,0-0.2,0s-0.3,0-0.4,0c-0.4-0.1-0.9-0.2-1.3-0.3c-1.8-0.8-3.1-2.5-3.1-4.601V29.5c0-2.1,1.3-3.9,3.1-4.6			c0.4-0.2,0.8-0.3,1.3-0.3c0.1,0,0.3,0,0.4,0s0.1,0,0.2,0h24c2.7,0,4.9,2.2,4.9,5V46z"/>	</g>	<g>		<path  d="M7.7,51c-0.1,0-0.3,0-0.4,0C7.4,51,7.6,51,7.7,51z"/>	</g>	<g>		<path  d="M7.3,24.6c0.1,0,0.3,0,0.4,0C7.6,24.5,7.4,24.5,7.3,24.6z"/>	</g>	<g>		<path  d="M27.5,28.5c0,0-2.3,12.1-2.6,14.2h-0.1c-0.3-2.101-2.5-14.2-2.5-14.2h-4.5c0,0-2.5,12.2-2.8,14.3			h-0.1c-0.3-1.899-2.5-14.3-2.5-14.3H7.9l4.5,18.8H17c0,0,2.5-11.7,2.9-13.899H20c0.2,2.1,2.5,13.899,2.5,13.899H27l4.8-18.8H27.5z"/>	</g></g></svg>'
        },
        callbacks: {
          onInit: e => {
            console.log('Summernote onInit:', e);
            console.log('maxHeight:', this.maxHeight);
            this.$editor = e.note;
            this.$codeable = e.codable;
            // Falls writeValue() bereits einen Wert geliefert hat
            this.tryInitEditor();
            /**
             * DONE:
             * - CodeMirror einbinden
             */
            this.$editor.on('summernote.codeview.toggled', () => {
              const isCodeViewActive = window.$('.note-editor').hasClass('codeview');
              if (isCodeViewActive) {
                console.log('CodeView wurde aktiviert, wende js-beautify an...');
                setTimeout(() => {
                  const codeEditorElement = document.querySelector('.note-codable');
                  if (codeEditorElement) {
                    const formattedHtml = html(this._filteredData, {
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      indent_with_tabs: true
                      // // eslint-disable-next-line @typescript-eslint/naming-convention
                      // wrap_attributes: 'auto',
                      // // eslint-disable-next-line @typescript-eslint/naming-convention
                      // preserve_newlines: true
                    });
                    // Falls CodeMirror aktiv ist, direkt das CodeMirror-Objekt setzen
                    //const cmInstance = ( window as any ).CodeMirror?.fromTextArea( codeEditorElement );
                    const cmInstance = this.$editor.closest('.summernote-container').find('.CodeMirror')[0]?.CodeMirror;
                    if (cmInstance) {
                      cmInstance.setValue(formattedHtml);
                      console.log('CodeMirror aktualisiert.');
                    } else {
                      // Falls kein CodeMirror, setze den Wert in die Textarea
                      codeEditorElement.value = formattedHtml;
                      console.log('Textarea aktualisiert.');
                    }
                  } else {
                    console.error('Code-Editor-Element nicht gefunden!');
                  }
                }, 0);
              }
            });
            // handle color Chooser btn
            const colorButton = this.$editor.closest('.summernote-container').find('.note-current-color-button')[0];
            if (colorButton) {
              const textNode = Array.from(colorButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
              if (textNode) {
                textNode.nodeValue = textNode.nodeValue.replace(' note-recent-color', '').trim();
              }
              // fix data-backcolor set to yellow onInit.
              colorButton.setAttribute('data-backcolor', 'transparent');
              let observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                  if (mutation.type === 'attributes') {
                    // Neue Farben aus den data-Attributen holen
                    const backColor = colorButton.getAttribute('data-backcolor') || 'transparent';
                    const foreColor = colorButton.getAttribute('data-forecolor') || '#000000';
                    // SVG-Pfad-Element auswählen
                    const svgPath = colorButton.querySelector('path');
                    if (svgPath) {
                      // Hintergrundfarbe setzen
                      colorButton.style.backgroundColor = backColor;
                      // SVG-Farbe setzen
                      svgPath.setAttribute('fill', foreColor);
                    }
                  }
                });
              });
              // Observer starten und auf Attribut-Änderungen hören
              observer.observe(colorButton, {
                attributes: true,
                attributeFilter: ['data-backcolor', 'data-forecolor']
              });
              // remove fileUpload field (Anfrage 341124)
              document.querySelectorAll('.note-image-input').forEach(input => {
                const label = input.previousElementSibling;
                if (label && label.tagName.toLowerCase() === 'label') {
                  label.remove();
                }
                input.remove();
              });
            }
          },
          onFocus: e => {
            //enable toolbar tabbing on focus for accesibility
            this.$editor[0].nextElementSibling.querySelectorAll('button').forEach(button => {
              button.tabIndex = 0;
            });
          },
          /* filter on paste..*/
          onPaste: e => {
            e.preventDefault();
            // get clipboard data from event (vanilla), event.originalEvent (jQuery) or window (<=IE10)
            const clipboardData = (e.originalEvent || e).clipboardData || window.Clipboard;
            const pastedData = clipboardData.getData('text/html') || clipboardData.getData('text/plain');
            /**
             * Summernotes pasteHTML wirft Fehler, wenn Text markiert ist und HTML eingefügt wird.
             * Manuell per Browser API einfügen, falls Text markiert ist.
             */
            //console.log('onPaste Summernote',pastedData);
            // try {
            //     this.$editor.summernote( 'pasteHTML', this.filterHtml( pastedData, this.getAllowedContent( 'onPaste' ) ) );
            // } catch ( error: any ) {
            //     console.log( 'error on paste, summernote problem', error );
            //     alert( 'Fehler beim Einfügen des Inhalts. Bitte entfernen Sie unerwünschten Inhalt und fügen sie gezielt neue Inhalte ein. Ein Markieren und Ersetzen von Text funktioniert aktuell nicht.' );
            //     //this.$editor.summernote( 'code', this.filterHtml( pastedData, this.getAllowedContent( 'onPaste' ) ) );
            // }
            // Filtere den eingefügten HTML-Code
            const filteredHtml = this.filterHtml(pastedData, this.getAllowedContent('onPaste'));
            // Versuche, den HTML-Content direkt in den aktuellen Selektionsbereich einzufügen:
            const selection = window.getSelection();
            if (selection && selection.rangeCount > 0) {
              const range = selection.getRangeAt(0);
              // Entferne den aktuell markierten Inhalt, falls vorhanden
              range.deleteContents();
              // Erstelle ein temporäres Element, um die HTML-String in DOM-Knoten zu zerlegen
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = filteredHtml;
              // Erzeuge ein DocumentFragment und überführe alle Knoten aus tempDiv hinein
              const fragment = document.createDocumentFragment();
              let node;
              while (node = tempDiv.firstChild) {
                fragment.appendChild(node);
              }
              // Füge den Fragment am aktuellen Range ein
              range.insertNode(fragment);
              // Den Caret am Ende der eingefügten Inhalte positionieren
              selection.collapseToEnd();
            } else {
              try {
                // Falls keine Selektion vorhanden ist, funktioniert pasteHTML zuverlässiger
                this.$editor.summernote('pasteHTML', this.filterHtml(pastedData, this.getAllowedContent('onPaste')));
              } catch (error) {
                console.warn('Fehler beim Einfügen von HTML', error);
              }
            }
          },
          onChange: contents => {
            if (contents !== this._data) {
              //console.log( 'summernote onChange:', contents );
              clearTimeout(this.debounceTimeout); // Vorheriges Timeout abbrechen
              this.debounceTimeout = setTimeout(() => {
                this.onEditorChange(contents);
              }, 300);
            }
          }
        }
      };
    }
    getToolbarConfig(toolbar) {
      switch (toolbar) {
        case 'basic':
          return [
          //['style', ['style']],
          ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
          //['fontname', ['fontname']],
          ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['table', ['table']], ['insert', ['link']], ['view', ['fullscreen', 'help']]];
        case 'slim':
          return [['style', ['style']], ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
          //['fontname', ['fontname']],
          ['color', ['color']],
          //['para', ['ul', 'ol', 'paragraph', 'height']],
          //['table', ['table']],
          ['insert', ['link']], ['view', ['help']]];
        case 'none':
          return [];
        case 'codeviewOnly':
          return [['view', ['codeview']]];
        default:
          return [['view', ['codeview']], ['history', ['undo', 'redo']], ['insert', ['link', 'picture', 'docximport', 'specialchars', 'hr']],
          //, 'video'
          //['insert', ['link', 'picture', 'specialchars', 'hr']], //, 'video'
          ['table', ['table']], ['view', ['fullscreen']], ['help', ['help']], ['break', []], ['style', ['style']], ['font', ['hisStrong', 'hisEm', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
          //['fontname', ['fontname']],
          ['para', ['ul', 'ol', 'paragraph']], ['color', ['color']]];
      } // switch end
    }
    getAllowedContent(mode = null, allowedHtmlTags = null, allowedHtmlAttributes = null) {
      let allowedContent;
      switch (mode) {
        /**
         * TODO:
         * only default is used atm.
         */
        case 'extendedHtml':
          allowedContent = {
            // Use the ability to specify elements as an object.
            elements: allowedHtmlTags,
            attributes: allowedHtmlAttributes,
            styles: true,
            classes: true
          };
          break;
        case 'tagsOnly':
          allowedContent = {
            // Use the ability to specify elements as an object.
            // Tags only
            elements: {
              h1: false,
              h2: true,
              h3: true,
              h4: true,
              h5: true,
              h6: true,
              a: true,
              abbr: true,
              b: true,
              i: true,
              u: true,
              sub: true,
              sup: true,
              ul: true,
              ol: true,
              li: true,
              dl: true,
              dt: true,
              dd: true,
              p: true,
              span: true,
              em: true,
              s: true,
              strike: true,
              strong: true,
              table: true,
              tbody: true,
              thead: true,
              tfoot: true,
              tr: true,
              th: true,
              td: true,
              colgroup: true,
              col: true,
              caption: true,
              div: true,
              small: true,
              pre: true,
              code: true,
              br: true,
              hr: true,
              img: true,
              style: true
            },
            attributes: false,
            styles: false,
            classes: false
          };
          break;
        case 'onPaste':
          allowedContent = {
            // Use the ability to specify elements as an object.
            // filter some styles on Paste only
            elements: {
              h1: false,
              h2: true,
              h3: true,
              h4: true,
              h5: true,
              h6: true,
              a: true,
              abbr: true,
              b: true,
              i: true,
              u: true,
              sub: true,
              sup: true,
              ul: true,
              ol: true,
              li: true,
              dl: true,
              dt: true,
              dd: true,
              p: true,
              span: true,
              em: true,
              s: true,
              strike: true,
              strong: true,
              table: true,
              tbody: true,
              thead: true,
              tfoot: true,
              tr: true,
              th: true,
              td: true,
              colgroup: true,
              col: true,
              caption: true,
              div: true,
              small: true,
              pre: true,
              code: true,
              br: true,
              hr: true,
              img: true,
              style: true
            },
            attributes: ['aria-label', 'aria-labelledby', 'aria-describedby', 'title', 'alt', 'src', 'target', 'style', 'class', 'align', 'valign', 'bgcolor', 'colspan', 'rowspan', 'height', 'nowrap', 'width', 'cellpadding', 'cellspacing', 'border', 'id', 'scope', 'summary', 'href', 'lang', 'data-delayedsrc'],
            styles: ['width', 'height', 'direction', 'list-style-type', 'list-style-position', 'color', 'background-color', 'text-decoration', 'border', 'border-top', 'border-right', 'border-bottom', 'border-left', 'border-width', 'border-style', 'border-color', 'border-collapse'],
            classes: false
          };
          break;
        default:
          allowedContent = {
            // Use the ability to specify elements as an object.
            // allowed tags, attributes and styles, from HTMLUtil.java, keep in sync!
            // font and font-family is allowed in HTMLUtil.java, but ' and " in style attribute aren't.
            // therefore filter font and font-family, since there is no value in getting the font-family from a Word Document, because the texts are always within a font-family setting context (Portal, FOP-Report, LO-Report) 
            elements: {
              h1: false,
              h2: true,
              h3: true,
              h4: true,
              h5: true,
              h6: true,
              a: true,
              abbr: true,
              b: true,
              i: true,
              u: true,
              sub: true,
              sup: true,
              ul: true,
              ol: true,
              li: true,
              dl: true,
              dt: true,
              dd: true,
              p: true,
              span: true,
              em: true,
              s: true,
              strike: true,
              strong: true,
              table: true,
              tbody: true,
              thead: true,
              tfoot: true,
              tr: true,
              th: true,
              td: true,
              colgroup: true,
              col: true,
              caption: true,
              div: true,
              small: true,
              pre: true,
              code: true,
              br: true,
              hr: true,
              img: true,
              style: true
            },
            attributes: ['aria-label', 'aria-labelledby', 'aria-describedby', 'title', 'alt', 'src', 'target', 'style', 'class', 'align', 'valign', 'bgcolor', 'colspan', 'rowspan', 'height', 'nowrap', 'width', 'cellpadding', 'cellspacing', 'border', 'id', 'scope', 'summary', 'href', 'lang', 'data-delayedsrc'],
            styles: ['width', 'height', 'direction', 'line-height', 'vertical-align', 'list-style-type', 'list-style-position', 'color', 'background-color', 'background-repeat', 'font-style', 'font-variant', 'font-weight', 'font-size', 'text-indent', 'text-align', 'text-decoration', 'letter-spacing', 'word-spacing', 'text-transform', 'white-space', 'border', 'border-top', 'border-right', 'border-bottom', 'border-left', 'border-width', 'border-style', 'border-color', 'border-collapse'],
            classes: true
          };
      }
      return allowedContent;
    }
    static {
      this.ɵfac = function HisSummernoteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSummernoteComponent)(i0.ɵɵdirectiveInject(i1$5.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(HisSummernoteService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSummernoteComponent,
        selectors: [["his-editor"]],
        viewQuery: function HisSummernoteComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$o, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editor = _t.first);
          }
        },
        inputs: {
          ddKey: "ddKey",
          toolbar: "toolbar",
          disabled: "disabled",
          maxHeight: "maxHeight",
          minHeight: "minHeight",
          placeholder: "placeholder",
          data: "data"
        },
        outputs: {
          dataChange: "dataChange"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HisSummernoteComponent),
          multi: true
        }])],
        decls: 3,
        vars: 4,
        consts: [["editor", ""], [1, "summernote-container"], [3, "ngxSummernote", "ngxSummernoteDisabled", 4, "ngIf"], [3, "ngxSummernote", "ngxSummernoteDisabled"], ["hisImage", "LINK_EXTERN", "target", "_blank", 1, "documentationLink", 2, "float", "none", 3, "href", "title"]],
        template: function HisSummernoteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HisSummernoteComponent_div_1_Template, 2, 2, "div", 2)(2, HisSummernoteComponent_Conditional_2_Template, 4, 6, "p");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("min-height", ctx.minHeight);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.config !== null);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.auth.hasAll("RIGHT_CS_SYS_HELP_READ_DOCUMENTATION") ? 2 : -1);
          }
        },
        dependencies: [i1$2.NgIf, i4$2.NgxSummernoteDirective, HisImageDirective, HisUiPipe],
        styles: [".form-group.note-form-group.note-group-select-from-files{display:block}\n", ".summernote-container{min-height:295px}.note-editor .table.table-bordered td{background-color:#fff}.note-toolbar .note-btn svg,.note-toolbar .note-dropdown-menu svg,.popover-content .note-btn-group .note-btn svg{fill:#006ab2;width:18px;height:18px}.note-editor .note-icon-close:before{content:\"\";display:inline-block;width:16px;height:16px;background-image:url(/HISinOne/images/icons/panel_close.svg);background-size:contain;background-repeat:no-repeat}[class^=note-icon]:before,[class*=\" note-icon\"]:before{display:inline-block;font-family:summernote;font-style:normal;font-size:inherit;text-decoration:inherit;text-rendering:auto;text-transform:none;vertical-align:middle;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;speak:none}.note-icon-fw{text-align:center;width:1.25em}.note-icon-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.note-icon-pull-left{float:left}.note-icon-pull-right{float:right}.note-icon.note-icon-pull-left{margin-right:.3em}.note-icon.note-icon-pull-right{margin-left:.3em}.note-icon-align:before{content:\"\\ea01\"}.note-icon-align-center:before{content:\"\\ea02\"}.note-icon-align-indent:before{content:\"\\ea03\"}.note-icon-align-justify:before{content:\"\\ea04\"}.note-icon-align-left:before{content:\"\\ea05\"}.note-icon-align-outdent:before{content:\"\\ea06\"}.note-icon-align-right:before{content:\"\\ea07\"}.note-icon-arrow-circle-down:before{content:\"\\ea08\"}.note-icon-arrow-circle-left:before{content:\"\\ea09\"}.note-icon-arrow-circle-right:before{content:\"\\ea0a\"}.note-icon-arrow-circle-up:before{content:\"\\ea0b\"}.note-icon-arrows-alt:before{content:\"\\ea0c\"}.note-icon-arrows-h:before{content:\"\\ea0d\"}.note-icon-arrows-v:before{content:\"\\ea0e\"}.note-icon-bold:before{content:\"\\ea0f\"}.note-icon-caret:before{content:\"\\ea10\"}.note-icon-chain-broken:before{content:\"\\ea11\"}.note-icon-circle:before{content:\"\\ea12\"}.note-icon-close:before{content:\"\\ea13\"}.note-icon-code:before{content:\"\\ea14\"}.note-icon-col-after:before{content:\"\\ea15\"}.note-icon-col-before:before{content:\"\\ea16\"}.note-icon-col-remove:before{content:\"\\ea17\"}.note-icon-eraser:before{content:\"\\ea18\"}.note-icon-float-left:before{content:\"\\ea19\"}.note-icon-float-none:before{content:\"\\ea1a\"}.note-icon-float-right:before{content:\"\\ea1b\"}.note-icon-font:before{content:\"\\ea1c\"}.note-icon-frame:before{content:\"\\ea1d\"}.note-icon-italic:before{content:\"\\ea1e\"}.note-icon-link:before{content:\"\\ea1f\"}.note-icon-magic:before{content:\"\\ea20\"}.note-icon-menu-check:before{content:\"\\ea21\"}.note-icon-minus:before{content:\"\\ea22\"}.note-icon-orderedlist:before{content:\"\\ea23\"}.note-icon-pencil:before{content:\"\\ea24\"}.note-icon-picture:before{content:\"\\ea25\"}.note-icon-question:before{content:\"\\ea26\"}.note-icon-redo:before{content:\"\\ea27\"}.note-icon-rollback:before{content:\"\\ea28\"}.note-icon-row-above:before{content:\"\\ea29\"}.note-icon-row-below:before{content:\"\\ea2a\"}.note-icon-row-remove:before{content:\"\\ea2b\"}.note-icon-special-character:before{content:\"\\ea2c\"}.note-icon-square:before{content:\"\\ea2d\"}.note-icon-strikethrough:before{content:\"\\ea2e\"}.note-icon-subscript:before{content:\"\\ea2f\"}.note-icon-summernote:before{content:\"\\ea30\"}.note-icon-superscript:before{content:\"\\ea31\"}.note-icon-table:before{content:\"\\ea32\"}.note-icon-text-height:before{content:\"\\ea33\"}.note-icon-trash:before{content:\"\\ea34\"}.note-icon-underline:before{content:\"\\ea35\"}.note-icon-undo:before{content:\"\\ea36\"}.note-icon-unorderedlist:before{content:\"\\ea37\"}.note-icon-video:before{content:\"\\ea38\"}.note-frame{-ms-box-sizing:border-box;box-sizing:border-box;color:#000;border-radius:4px}.note-toolbar{padding:10px 5px;border-bottom:1px solid #e2e2e2;color:#333;background-color:#f5f5f5;border-color:#ddd;border-top-left-radius:3px;border-top-right-radius:3px}.note-btn-group{position:relative;display:inline-block;margin-right:8px}.note-btn-group>.note-btn-group{margin-right:0}.note-btn-group>.note-btn:first-child{margin-left:0}.note-btn-group .note-btn+.note-btn,.note-btn-group .note-btn+.note-btn-group,.note-btn-group .note-btn-group+.note-btn,.note-btn-group .note-btn-group+.note-btn-group{margin-left:-1px}.note-btn-group>.note-btn:not(:first-child),.note-btn-group>.note-btn-group:not(:first-child)>.note-btn{border-top-left-radius:0;border-bottom-left-radius:0}.note-btn-group>.note-btn:not(:last-child):not(.dropdown-toggle),.note-btn-group>.note-btn-group:not(:last-child)>.note-btn{border-top-right-radius:0;border-bottom-right-radius:0}.note-btn-group.open>.note-dropdown{display:block}.note-btn{display:inline-block;font-weight:400;margin-bottom:0;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid #dae0e5;white-space:nowrap;outline:0;color:#333;background-color:#fff;border-color:#dae0e5;padding:5px 10px;font-size:14px;line-height:1.4;border-radius:3px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.note-btn:focus,.note-btn.focus{color:#333;background-color:#ebebeb;border-color:#dae0e5}.note-btn:hover{color:#333;background-color:#ebebeb;border-color:#dae0e5}.note-btn.disabled:focus,.note-btn.disabled.focus,.note-btn[disabled]:focus,.note-btn[disabled].focus,fieldset[disabled] .note-btn:focus,fieldset[disabled] .note-btn.focus{background-color:#fff;border-color:#dae0e5}.note-btn:hover,.note-btn:focus,.note-btn.focus{color:#333;text-decoration:none;border:1px solid #dae0e5;background-color:#ebebeb;outline:0;border-radius:1px}.note-btn:active,.note-btn.active{background-image:none;color:#333;text-decoration:none;border:1px solid #dae0e5;background-color:#ebebeb;outline:0;border-radius:1px;box-shadow:inset 0 3px 5px #00000020}.note-btn.disabled,.note-btn[disabled],fieldset[disabled] .note-btn{cursor:not-allowed;-webkit-opacity:.65;-khtml-opacity:.65;-moz-opacity:.65;opacity:.65;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=65);filter:alpha(opacity=65);box-shadow:none}.note-btn>span.note-icon-caret:first-child{margin-left:-1px}.note-btn>span.note-icon-caret:nth-child(2){padding-left:3px;margin-right:-5px}.note-btn-block{display:block;width:100%}.note-btn-block+.note-btn-block{margin-top:5px}input[type=submit].note-btn-block,input[type=reset].note-btn-block,input[type=button].note-btn-block{width:100%}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.close{float:right;font-size:21px;line-height:1;color:#000;opacity:.2}.close:hover{-webkit-opacity:1;-khtml-opacity:1;-moz-opacity:1;-ms-filter:alpha(opacity=100);filter:alpha(opacity=100);opacity:1}.note-dropdown{position:relative}.note-color .dropdown-toggle{width:30px;padding-left:5px}.note-dropdown-menu{display:none;min-width:100px;position:absolute;top:100%;left:0;z-index:1000;float:left;text-align:left;background:#fff;border:1px solid #e2e2e2;padding:5px;background-clip:padding-box;box-shadow:0 1px 1px #0000000f}.note-dropdown-menu>*:last-child{margin-right:0}.note-btn-group.open .note-dropdown-menu,.note-dropdown-item{display:block}.note-dropdown-item:hover{background-color:#ebebeb}a.note-dropdown-item,a.note-dropdown-item:hover{margin:5px 0;color:#000;text-decoration:none}.note-modal{position:fixed;inset:100px 0 0;z-index:1050;-webkit-opacity:1;-khtml-opacity:1;-moz-opacity:1;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=100);filter:alpha(opacity=100);display:none}.note-modal.open{display:block}.note-modal-content{position:relative;width:auto;margin:30px 20px;border:1px solid rgba(0,0,0,.2);background:#fff;background-clip:border-box;outline:0;border-radius:5px;box-shadow:0 3px 9px #00000080}.note-modal-header{padding:10px 20px;border:1px solid #ededef}.note-modal-body{position:relative;padding:20px 30px}.note-modal-body kbd{border-radius:2px;background-color:#000;color:#fff;padding:3px 5px;font-weight:700;-ms-box-sizing:border-box;box-sizing:border-box}.note-modal-footer{height:40px;padding:10px;text-align:center}.note-modal-footer a{color:#337ab7;text-decoration:none}.note-modal-footer a:hover,.note-modal-footer a:focus{color:#23527c;text-decoration:underline}.note-modal-footer .note-btn{float:right;margin-top:-20px}.note-modal-title{font-size:20px;color:#42515f;margin:0;line-height:1.4}.note-modal-backdrop{position:fixed;inset:0;z-index:1040;background:#000;-webkit-opacity:.5;-khtml-opacity:.5;-moz-opacity:.5;opacity:.5;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=50);filter:alpha(opacity=50);display:none}.note-modal-backdrop.open{display:block}@media (min-width: 768px){.note-modal-content{width:600px;margin:30px auto}}@media (min-width: 992px){.note-modal-content-large{width:900px}}.note-modal .note-help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}.note-modal .note-nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.note-modal .note-nav-link{display:block;padding:.5rem 1rem;color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}.note-modal .note-nav-link:focus,.note-modal .note-nav-link:hover{color:#0056b3;text-decoration:none}.note-modal .note-nav-link.disabled{color:#868e96}.note-modal .note-nav-tabs{border-bottom:1px solid #ddd}.note-modal .note-nav-tabs .note-nav-item{margin-bottom:-1px}.note-modal .note-nav-tabs .note-nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.note-modal .note-nav-tabs .note-nav-link:focus,.note-modal .note-nav-tabs .note-nav-link:hover{border-color:#e9ecef #e9ecef #ddd}.note-modal .note-nav-tabs .note-nav-link.disabled{color:#868e96;background-color:transparent;border-color:transparent}.note-modal .note-nav-tabs .note-nav-item.show .note-nav-link{color:#495057;background-color:#fff;border-color:#ddd #ddd #fff}.note-modal .note-tab-content{margin:15px auto}.note-modal .note-tab-content>.note-tab-pane:target~.note-tab-pane:last-child,.note-modal .note-tab-content>.note-tab-pane{display:none}.note-modal .note-tab-content>:last-child,.note-modal .note-tab-content>.note-tab-pane:target{display:block}.note-form-group{padding-bottom:20px}.note-form-group:last-child{padding-bottom:0}.note-form-label{display:block;width:100%;font-size:16px;color:#42515f;margin-bottom:10px;font-weight:700}.note-input{width:100%;display:block;outline:0;padding:6px 4px;font-size:14px;-ms-box-sizing:border-box;box-sizing:border-box}.note-input::-webkit-input-placeholder{color:#eee}.note-input:-moz-placeholder{color:#eee}.note-input::-moz-placeholder{color:#eee}.note-input:-ms-input-placeholder{color:#eee}.note-tooltip{position:absolute;z-index:1070;display:block;font-size:13px;transition:opacity .15s;-webkit-opacity:0;-khtml-opacity:0;-moz-opacity:0;opacity:0;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0);filter:alpha(opacity=0)}.note-tooltip.in{-webkit-opacity:.9;-khtml-opacity:.9;-moz-opacity:.9;opacity:.9;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=90);filter:alpha(opacity=90)}.note-tooltip.top{margin-top:-3px;padding:5px 0}.note-tooltip.right{margin-left:3px;padding:0 5px}.note-tooltip.bottom{margin-top:3px;padding:5px 0}.note-tooltip.left{margin-left:-3px;padding:0 5px}.note-tooltip.bottom .note-tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.note-tooltip.top .note-tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.note-tooltip.right .note-tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.note-tooltip.left .note-tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.note-tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.note-tooltip-content{max-width:200px;font-family:sans-serif;padding:3px 8px;color:#fff;text-align:center;background-color:#000}.note-popover{position:absolute;z-index:1060;display:block;font-size:13px;font-family:sans-serif;display:none;background:#fff;border:1px solid rgba(0,0,0,.2);border:1px solid #ccc}.note-popover.in{display:block}.note-popover.top{margin-top:-10px;padding:5px 0}.note-popover.right{margin-left:10px;padding:0 5px}.note-popover.bottom{margin-top:10px;padding:5px 0}.note-popover.left{margin-left:-10px;padding:0 5px}.note-popover.bottom .note-popover-arrow{top:-11px;left:20px;margin-left:-10px;border-top-width:0;border-bottom-color:#999;border-bottom-color:#00000040}.note-popover.bottom .note-popover-arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.note-popover.top .note-popover-arrow{bottom:-11px;left:20px;margin-left:-10px;border-bottom-width:0;border-top-color:#999;border-top-color:#00000040}.note-popover.top .note-popover-arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-bottom-width:0;border-top-color:#fff}.note-popover.right .note-popover-arrow{top:50%;left:-11px;margin-top:-10px;border-left-width:0;border-right-color:#999;border-right-color:#00000040}.note-popover.right .note-popover-arrow:after{left:1px;margin-top:-10px;content:\" \";border-left-width:0;border-right-color:#fff}.note-popover.left .note-popover-arrow{top:50%;right:-11px;margin-top:-10px;border-right-width:0;border-left-color:#999;border-left-color:#00000040}.note-popover.left .note-popover-arrow:after{right:1px;margin-top:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.note-popover-arrow{position:absolute;width:0;height:0;border:11px solid transparent}.note-popover-arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;content:\" \";border-width:10px}.note-popover-content{padding:3px 8px;color:#000;text-align:center;background-color:#fff;min-width:100px;min-height:30px}.note-editor{position:relative}.note-editor .note-dropzone{position:absolute;display:none;z-index:100;color:#87cefa;background-color:#fff;opacity:.95}.note-editor .note-dropzone .note-dropzone-message{display:table-cell;vertical-align:middle;text-align:center;font-size:28px;font-weight:700}.note-editor .note-dropzone.hover{color:#098ddf}.note-editor.dragover .note-dropzone{display:table}.note-editor .note-editing-area{position:relative}.note-editor .note-editing-area .note-editable{outline:none}.note-editor .note-editing-area .note-editable sup{vertical-align:super}.note-editor .note-editing-area .note-editable sub{vertical-align:sub}.note-editor .note-editing-area .note-editable img.note-float-left{margin-right:10px}.note-editor .note-editing-area .note-editable img.note-float-right{margin-left:10px}.note-editor.note-frame,.note-editor.note-airframe{border:1px solid rgba(0,0,0,.1960784314)}.note-editor.note-frame.codeview .note-editing-area .note-editable,.note-editor.note-airframe.codeview .note-editing-area .note-editable{display:none}.note-editor.note-frame.codeview .note-editing-area .note-codable,.note-editor.note-airframe.codeview .note-editing-area .note-codable{display:block}.note-editor.note-frame .note-editing-area,.note-editor.note-airframe .note-editing-area{overflow:hidden}.note-editor.note-frame .note-editing-area .note-editable,.note-editor.note-airframe .note-editing-area .note-editable{padding:10px;overflow:auto;word-wrap:break-word}.note-editor.note-frame .note-editing-area .note-editable[contenteditable=false],.note-editor.note-airframe .note-editing-area .note-editable[contenteditable=false]{background-color:#8080801d}.note-editor.note-frame .note-editing-area .note-codable,.note-editor.note-airframe .note-editing-area .note-codable{display:none;width:100%;padding:10px;border:none;box-shadow:none;font-family:Menlo,Monaco,monospace,sans-serif;font-size:14px;color:#ccc;background-color:#222;resize:none;outline:none;-ms-box-sizing:border-box;box-sizing:border-box;border-radius:0;margin-bottom:0}.note-editor.note-frame.fullscreen,.note-editor.note-airframe.fullscreen{position:fixed;top:0;left:0;bottom:0;width:100%!important;z-index:1250!important;background-color:#fff}.note-editor.note-frame.fullscreen .note-resizebar,.note-editor.note-airframe.fullscreen .note-resizebar{display:none}.note-editor.note-frame .note-status-output,.note-editor.note-airframe .note-status-output{display:block;width:100%;font-size:14px;line-height:1.42857143;height:20px;margin-bottom:0;color:#000;border:0;border-top:1px solid #e2e2e2}.note-editor.note-frame .note-status-output:empty,.note-editor.note-airframe .note-status-output:empty{height:0;border-top:0 solid transparent}.note-editor.note-frame .note-status-output .pull-right,.note-editor.note-airframe .note-status-output .pull-right{float:right!important}.note-editor.note-frame .note-status-output .text-muted,.note-editor.note-airframe .note-status-output .text-muted{color:#777}.note-editor.note-frame .note-status-output .text-primary,.note-editor.note-airframe .note-status-output .text-primary{color:#286090}.note-editor.note-frame .note-status-output .text-success,.note-editor.note-airframe .note-status-output .text-success{color:#3c763d}.note-editor.note-frame .note-status-output .text-info,.note-editor.note-airframe .note-status-output .text-info{color:#31708f}.note-editor.note-frame .note-status-output .text-warning,.note-editor.note-airframe .note-status-output .text-warning{color:#8a6d3b}.note-editor.note-frame .note-status-output .text-danger,.note-editor.note-airframe .note-status-output .text-danger{color:#a94442}.note-editor.note-frame .note-status-output .alert,.note-editor.note-airframe .note-status-output .alert{margin:-7px 0 0;padding:7px 10px 2px;border-radius:0;color:#000;background-color:#f5f5f5}.note-editor.note-frame .note-status-output .alert .note-icon,.note-editor.note-airframe .note-status-output .alert .note-icon{margin-right:5px}.note-editor.note-frame .note-status-output .alert-success,.note-editor.note-airframe .note-status-output .alert-success{color:#3c763d!important;background-color:#dff0d8!important}.note-editor.note-frame .note-status-output .alert-info,.note-editor.note-airframe .note-status-output .alert-info{color:#31708f!important;background-color:#d9edf7!important}.note-editor.note-frame .note-status-output .alert-warning,.note-editor.note-airframe .note-status-output .alert-warning{color:#8a6d3b!important;background-color:#fcf8e3!important}.note-editor.note-frame .note-status-output .alert-danger,.note-editor.note-airframe .note-status-output .alert-danger{color:#a94442!important;background-color:#f2dede!important}.note-editor.note-frame .note-statusbar,.note-editor.note-airframe .note-statusbar{background-color:#8080801d;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top:1px solid rgba(0,0,0,.1960784314)}.note-editor.note-frame .note-statusbar .note-resizebar,.note-editor.note-airframe .note-statusbar .note-resizebar{padding-top:1px;height:9px;width:100%;cursor:ns-resize}.note-editor.note-frame .note-statusbar .note-resizebar .note-icon-bar,.note-editor.note-airframe .note-statusbar .note-resizebar .note-icon-bar{width:20px;margin:1px auto;border-top:1px solid rgba(0,0,0,.1960784314)}.note-editor.note-frame .note-statusbar.locked .note-resizebar,.note-editor.note-airframe .note-statusbar.locked .note-resizebar{cursor:default}.note-editor.note-frame .note-statusbar.locked .note-resizebar .note-icon-bar,.note-editor.note-airframe .note-statusbar.locked .note-resizebar .note-icon-bar{display:none}.note-editor.note-frame .note-placeholder,.note-editor.note-airframe .note-placeholder{padding:10px}.note-editor.note-airframe{border:0}.note-editor.note-airframe .note-editing-area .note-editable{padding:0}.note-popover.popover{display:none;max-width:none}.note-popover.popover .popover-content a{display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle}.note-popover.popover .arrow{left:20px!important}.note-toolbar{position:relative}.note-break{display:block;margin-top:0!important}.note-popover .popover-content,.note-editor .note-toolbar{margin:0;padding:0 0 5px 5px}.note-popover .popover-content>.note-btn-group,.note-editor .note-toolbar>.note-btn-group{margin-top:5px;margin-left:0;margin-right:5px}.note-popover .popover-content .note-btn-group .note-table,.note-editor .note-toolbar .note-btn-group .note-table{min-width:0;padding:5px}.note-popover .popover-content .note-btn-group .note-table .note-dimension-picker,.note-editor .note-toolbar .note-btn-group .note-table .note-dimension-picker{font-size:18px}.note-popover .popover-content .note-btn-group .note-table .note-dimension-picker .note-dimension-picker-mousecatcher,.note-editor .note-toolbar .note-btn-group .note-table .note-dimension-picker .note-dimension-picker-mousecatcher{position:absolute!important;z-index:3;width:10em;height:10em;cursor:pointer}.note-popover .popover-content .note-btn-group .note-table .note-dimension-picker .note-dimension-picker-unhighlighted,.note-editor .note-toolbar .note-btn-group .note-table .note-dimension-picker .note-dimension-picker-unhighlighted{position:relative!important;z-index:1;width:5em;height:5em;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASAgMAAAAroGbEAAAACVBMVEUAAIj4+Pjp6ekKlAqjAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfYAR0BKhmnaJzPAAAAG0lEQVQI12NgAAOtVatWMTCohoaGUY+EmIkEAEruEzK2J7tvAAAAAElFTkSuQmCC) repeat}.note-popover .popover-content .note-btn-group .note-table .note-dimension-picker .note-dimension-picker-highlighted,.note-editor .note-toolbar .note-btn-group .note-table .note-dimension-picker .note-dimension-picker-highlighted{position:absolute!important;z-index:2;width:1em;height:1em;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASAgMAAAAroGbEAAAACVBMVEUAAIjd6vvD2f9LKLW+AAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfYAR0BKwNDEVT0AAAAG0lEQVQI12NgAAOtVatWMTCohoaGUY+EmIkEAEruEzK2J7tvAAAAAElFTkSuQmCC) repeat}.note-popover .popover-content .note-style .dropdown-style blockquote,.note-popover .popover-content .note-style .dropdown-style pre,.note-editor .note-toolbar .note-style .dropdown-style blockquote,.note-editor .note-toolbar .note-style .dropdown-style pre{margin:0;padding:5px 10px}.note-popover .popover-content .note-style .dropdown-style h1,.note-popover .popover-content .note-style .dropdown-style h2,.note-popover .popover-content .note-style .dropdown-style h3,.note-popover .popover-content .note-style .dropdown-style h4,.note-popover .popover-content .note-style .dropdown-style h5,.note-popover .popover-content .note-style .dropdown-style h6,.note-popover .popover-content .note-style .dropdown-style p,.note-editor .note-toolbar .note-style .dropdown-style h1,.note-editor .note-toolbar .note-style .dropdown-style h2,.note-editor .note-toolbar .note-style .dropdown-style h3,.note-editor .note-toolbar .note-style .dropdown-style h4,.note-editor .note-toolbar .note-style .dropdown-style h5,.note-editor .note-toolbar .note-style .dropdown-style h6,.note-editor .note-toolbar .note-style .dropdown-style p{margin:0;padding:0}.note-popover .popover-content .note-color .dropdown-toggle,.note-editor .note-toolbar .note-color .dropdown-toggle{padding-left:5px}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette{display:inline-block;margin:0;width:160px}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette:first-child,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette:first-child{margin:0 5px}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-palette-title,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-palette-title{font-size:12px;margin:2px 7px;text-align:center;border-bottom:1px solid #eee}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-color-reset,.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-color-select,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-color-reset,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-color-select{font-size:11px;margin:3px;padding:0 3px;cursor:pointer;width:100%;border-radius:5px}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-color-reset:hover,.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-color-select:hover,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-color-reset:hover,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-color-select:hover{background:#eee}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-color-row,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-color-row{height:20px}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-color-select-btn,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-color-select-btn{display:none}.note-popover .popover-content .note-color .note-dropdown-menu .note-palette .note-holder-custom .note-color-btn,.note-editor .note-toolbar .note-color .note-dropdown-menu .note-palette .note-holder-custom .note-color-btn{border:1px solid #eee}.note-popover .popover-content .note-para .note-dropdown-menu,.note-editor .note-toolbar .note-para .note-dropdown-menu{min-width:228px;padding:5px}.note-popover .popover-content .note-para .note-dropdown-menu>div+div,.note-editor .note-toolbar .note-para .note-dropdown-menu>div+div{margin-left:5px}.note-popover .popover-content .note-dropdown-menu,.note-editor .note-toolbar .note-dropdown-menu{min-width:160px}.note-popover .popover-content .note-dropdown-menu.right,.note-editor .note-toolbar .note-dropdown-menu.right{right:0;left:auto}.note-popover .popover-content .note-dropdown-menu.right:before,.note-editor .note-toolbar .note-dropdown-menu.right:before{right:9px;left:auto!important}.note-popover .popover-content .note-dropdown-menu.right:after,.note-editor .note-toolbar .note-dropdown-menu.right:after{right:10px;left:auto!important}.note-popover .popover-content .note-dropdown-menu.note-check a i,.note-editor .note-toolbar .note-dropdown-menu.note-check a i{color:#00bfff;visibility:hidden}.note-popover .popover-content .note-dropdown-menu.note-check a.checked i,.note-editor .note-toolbar .note-dropdown-menu.note-check a.checked i{visibility:visible}.note-popover .popover-content .note-fontsize-10,.note-editor .note-toolbar .note-fontsize-10{font-size:10px}.note-popover .popover-content .note-color-palette,.note-editor .note-toolbar .note-color-palette{line-height:1}.note-popover .popover-content .note-color-palette div .note-color-btn,.note-editor .note-toolbar .note-color-palette div .note-color-btn{width:20px;height:20px;padding:0;margin:0;border:0;border-radius:0}.note-popover .popover-content .note-color-palette div .note-color-btn:hover,.note-editor .note-toolbar .note-color-palette div .note-color-btn:hover{transform:scale(1.2);transition:all .2s}.note-modal .modal-dialog{outline:0;border-radius:5px;box-shadow:0 3px 9px #00000080}.note-modal .form-group{margin-left:0;margin-right:0}.note-modal .note-modal-form{margin:0}.note-modal .note-image-dialog .note-dropzone{min-height:100px;font-size:30px;line-height:4;color:#d3d3d3;text-align:center;border:4px dashed lightgray;margin-bottom:10px}.note-placeholder{position:absolute;display:none;color:gray}.note-handle .note-control-selection{position:absolute;display:none;border:1px solid #000}.note-handle .note-control-selection>div{position:absolute}.note-handle .note-control-selection .note-control-selection-bg{width:100%;height:100%;background-color:#000;-webkit-opacity:.3;-khtml-opacity:.3;-moz-opacity:.3;opacity:.3;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=30);filter:alpha(opacity=30)}.note-handle .note-control-selection .note-control-handle,.note-handle .note-control-selection .note-control-sizing,.note-handle .note-control-selection .note-control-holder{width:7px;height:7px;border:1px solid #000}.note-handle .note-control-selection .note-control-sizing{background-color:#000}.note-handle .note-control-selection .note-control-nw{top:-5px;left:-5px;border-right:none;border-bottom:none}.note-handle .note-control-selection .note-control-ne{top:-5px;right:-5px;border-bottom:none;border-left:none}.note-handle .note-control-selection .note-control-sw{bottom:-5px;left:-5px;border-top:none;border-right:none}.note-handle .note-control-selection .note-control-se{right:-5px;bottom:-5px;cursor:se-resize}.note-handle .note-control-selection .note-control-se.note-control-holder{cursor:default;border-top:none;border-left:none}.note-handle .note-control-selection .note-control-selection-info{right:0;bottom:0;padding:5px;margin:5px;color:#fff;background-color:#000;font-size:12px;border-radius:5px;-webkit-opacity:.7;-khtml-opacity:.7;-moz-opacity:.7;opacity:.7;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(opacity=70);filter:alpha(opacity=70)}.note-hint-popover{min-width:100px;padding:2px}.note-hint-popover .popover-content{padding:3px;max-height:150px;overflow:auto}.note-hint-popover .popover-content .note-hint-group .note-hint-item{display:block!important;padding:3px}.note-hint-popover .popover-content .note-hint-group .note-hint-item.active,.note-hint-popover .popover-content .note-hint-group .note-hint-item:hover{display:block;clear:both;font-weight:400;line-height:1.4;color:#fff;white-space:nowrap;text-decoration:none;background-color:#428bca;outline:0;cursor:pointer}html .note-fullscreen-body,body .note-fullscreen-body{overflow:hidden!important}.note-editable ul li,.note-editable ol li{list-style-position:inside}.note-editor .note-editing-area .note-editable table{width:100%;border-collapse:collapse}.note-editor .note-editing-area .note-editable table td,.note-editor .note-editing-area .note-editable table th{border:1px solid #ececec;padding:5px 3px}.note-editor .note-editing-area .note-editable figure{margin:0}.note-modal .note-modal-body label{margin-bottom:2px;padding:2px 5px;display:inline-block}.note-modal .note-modal-body .help-list-item:hover{background-color:#e0e0e0}@-moz-document url-prefix(){.note-modal .note-image-input{height:auto}}.help-list-item label{margin-bottom:5px;display:inline-block}\n/*!\n * \n * Super simple WYSIWYG editor v0.9.0\n * https://summernote.org\n *\n * Copyright 2013~ Hackerwins and contributors\n * Summernote may be freely distributed under the MIT license.\n *\n * Date: 2024-09-30T14:42Z\n *\n */\n", ".CodeMirror{font-family:monospace;height:300px;color:#000;direction:ltr}.CodeMirror-lines{padding:4px 0}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{padding:0 4px}.CodeMirror-scrollbar-filler,.CodeMirror-gutter-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid black;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-fat-cursor .CodeMirror-line::selection,.cm-fat-cursor .CodeMirror-line>span::selection,.cm-fat-cursor .CodeMirror-line>span>span::selection{background:transparent}.cm-fat-cursor .CodeMirror-line::-moz-selection,.cm-fat-cursor .CodeMirror-line>span::-moz-selection,.cm-fat-cursor .CodeMirror-line>span>span::-moz-selection{background:transparent}.cm-fat-cursor{caret-color:transparent}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;inset:-50px 0 0;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:#00f}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-variable-3,.cm-s-default .cm-type{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-s-default .cm-error,.cm-invalidchar{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0b0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#a22}.CodeMirror-matchingtag{background:#ff96004d}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-50px;margin-right:-50px;padding-bottom:50px;height:100%;outline:none;position:relative;z-index:0}.CodeMirror-sizer{position:relative;border-right:50px solid transparent}.CodeMirror-vscrollbar,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-gutter-filler{position:absolute;z-index:6;display:none;outline:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-50px}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper ::selection{background-color:transparent}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;-webkit-font-variant-ligatures:contextual;font-variant-ligatures:contextual}.CodeMirror-wrap pre.CodeMirror-line,.CodeMirror-wrap pre.CodeMirror-line-like{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;inset:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;padding:.1px}.CodeMirror-rtl pre{direction:rtl}.CodeMirror-code{outline:none}.CodeMirror-scroll,.CodeMirror-sizer,.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber{-moz-box-sizing:content-box;box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}div.CodeMirror-dragcursors,.CodeMirror-focused div.CodeMirror-cursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background-color:#ffa;background-color:#ff06}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:\"\"}span.CodeMirror-selectedtext{background:none}\n"],
        encapsulation: 2
      });
    }
  }
  return HisSummernoteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Looks up DataDictionary-Entries for the given Datadictionary-Key and decorates the given
 * Input-Element accordingly
 *
 * hisDdKey should be used on Input-Elements but partly works with other Elements as well (e.g. 'hidden')
 * ddKey may be changed dynamically
 */
let HisDdDirective = /*#__PURE__*/(() => {
  class HisDdDirective {
    constructor() {
      this.hisDdService = inject(HisDdService);
      this.ddValidator = inject(HisDdValidator);
      this.notificationService = inject(HisNotificationService);
      this.hisUiService = inject(HisUiService);
      this.elementRef = inject(ElementRef);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.ddDirectiveRegistryService = inject(HisDdDirectiveRegistryService);
      this.ngModelRef = inject(NgModel, {
        host: true,
        optional: true,
        self: true
      });
      this.ctrlRef = inject(FormControlDirective, {
        host: true,
        optional: true,
        self: true
      });
      this.formControlName = inject(FormControlName, {
        host: true,
        optional: true
      });
      this.autocompleteRef = inject(AutoComplete, {
        host: true,
        optional: true,
        self: true
      });
      this.calendarRef = inject(Calendar, {
        host: true,
        optional: true,
        self: true
      });
      this.chipsRef = inject(Chips, {
        host: true,
        optional: true,
        self: true
      });
      this.panelRef = inject(Panel, {
        host: true,
        optional: true,
        self: true
      });
      this.multiSelectRef = inject(MultiSelect, {
        host: true,
        optional: true,
        self: true
      });
      this.hisPlamRef = inject(HisPlamComponent, {
        host: true,
        optional: true,
        self: true
      });
      this.hisTreeSelectRef = inject(HisTreeSelectComponent, {
        host: true,
        optional: true,
        self: true
      });
      this.hisSearchSelectPopup = inject(HisSearchSelectPopupComponent, {
        host: true,
        optional: true,
        self: true
      });
      this.inputNumber = inject(InputNumber, {
        host: true,
        optional: true,
        self: true
      });
      this.dataViewRef = inject(DataView, {
        host: true,
        optional: true,
        self: true
      });
      this.pickList = inject(PickList, {
        host: true,
        optional: true,
        self: true
      });
      this.hisMultiselect = inject(HisMultiselectComponent, {
        host: true,
        optional: true,
        self: true
      });
      this.tabView = inject(TabView, {
        optional: true
      });
      this.tabPanel = inject(TabPanel, {
        optional: true
      });
      this.hisEditor = inject(HisSummernoteComponent, {
        host: true,
        optional: true,
        self: true
      });
      this.ignoreDefaultValue = false;
      this.autocompleteDefaultValueRetries = 5; // Einige Male probieren, den Default bei AutoCompletes zu setzen (während Optionen laden)
      // Damit der ddKey dynamisch geändert werden kann, werden hier die originalen Attribute gespeichert
      this.originalValues = {};
      this.originalRequiredValue = undefined;
    }
    ngAfterContentInit() {
      /*
      * Field-Errors vom Backend empfangen.
      * Funktioniert bisher nur für template-driven Forms.
      * Validierungsfehler-Meldung wird für Reactive Forms
      * frontendseitig erzeugt.
      */
      localStorage.setItem('listTabs', '');
      this.fieldMessagesSubscription = this.notificationService.fieldMessages$.subscribe(msg => {
        let errorElement = null;
        if (this.ngModelRef != null && this.hisDdKey != null && this.hisDdKey === msg.field) {
          if (this.ngModelRef.control.errors == null) {
            this.ngModelRef.control.setErrors({});
          }
          this.ngModelRef.control.errors.backendError = {
            message: msg.message,
            valid: false
          };
          // Fokus auf Eingabefeld mit Fehlermeldung setzen.
          // TODO: Autocomplete und Calendar unterstützen
          // TODO: nur auf erste Fehlermeldung setzen, für die ein Eingabefeld gefunden wird.
          //this.elementRef.nativeElement.focus();
          errorElement = this.elementRef.nativeElement.closest('.plamRow');
        } else if (this.ngModelRef == null && this.elementRef.nativeElement !== null && this.hisDdKey.startsWith('dynamic.') && this.hisDdKey === msg.field) {
          // Das this.ngModelRefist für/bei dynamischen Attributen null,
          // daher müssen wir die Feldermeldungen anderweitig behandeln und setzen
          this.setDdBackendErrorForDynamicFields(msg.message);
          errorElement = this.elementRef.nativeElement.closest('.plamRow');
        }
        if (errorElement !== null) {
          HisDdDirective.removeErrorIconInTab();
          setTimeout(() => {
            this.markTabsWithError(errorElement);
          }, 0.01);
        }
      });
      // register hisDdDirectivce
      this.ddDirectiveRegistryService.registerHisDdDirective(this);
    }
    // Setzen des Warnicons in der Registerkarte
    markTabsWithError(errorElement) {
      if (errorElement) {
        let tabHeader = errorElement.closest('p-tabpanel > div').getAttribute('aria-labelledby');
        if (tabHeader) {
          /* Überprüfung, ob fehlerhafte Registerkarte bereits ein Warnicon hat.
          Wenn nicht, dann markTabsWithError zum Setzen des Warnicons aufrufen */
          let markedTabs = localStorage.getItem('listTabs');
          if (!markedTabs.includes(tabHeader) && markedTabs !== undefined) {
            /* Voraussetzungen: - Ist ein eigenes headerTemplate gesetzt, muss der Text der Registerkarte
                                von einem span-Element umschlossen sein*
                                - Das header-Attribut muss am tabPanel gesetzt sein*/
            let tabs = document.getElementsByClassName('p-tabview-nav-link');
            for (let tab of tabs) {
              if (tab.id === tabHeader) {
                let tabTitleElement = tab.children[0];
                // insert "warning"-icon on tab, if not already on exists
                if (!(tabTitleElement.children[0]?.getAttribute('class').includes('tabIcon') && tabTitleElement.children[0].title === this.hisUiService.translate('common.error.tab'))) {
                  let advice = '<img class="tabWarnIcon marginRightStandard" src="/HISinOne/images/icons/bullet_error.svg"/>';
                  tabTitleElement.insertAdjacentHTML('beforebegin', advice);
                } else {
                  console.log('#HisDdDirective.markTabsWithError() tab - ', tabTitleElement.innerText, ' - already contains warning tab icon.');
                }
              }
            }
            // Fokus auf die erste Registerkarte mit einem Fehler setzen
            if (this.tabPanel) {
              for (let tab of Array.from(this.tabPanel.tabView.navbar.nativeElement.children)) {
                if (tab.querySelector('.tabWarnIcon')) {
                  let errorTab = tab.querySelector('[role="tab"]');
                  errorTab.focus();
                  break;
                }
              }
            }
            let warnIcons = document.getElementsByClassName('tabWarnIcon');
            for (let icon of warnIcons) {
              icon.title = this.hisUiService.translate('common.error.tab');
              icon.alt = this.hisUiService.translate('common.error.tab');
            }
            localStorage.setItem('listTabs', markedTabs + tabHeader);
          }
        }
      }
    }
    static removeErrorIconInTab() {
      let tabErrorIcons = document.getElementsByClassName('tabWarnIcon');
      do {
        for (let icon of tabErrorIcons) {
          icon.parentNode.removeChild(icon);
          localStorage.setItem('listTabs', '');
        }
      } while (tabErrorIcons.length > 0);
    }
    /**
     * Reagiere auf Änderungen des ddKey (ermöglicht dynamische Änderung)
     */
    ngOnChanges(changes) {
      if (changes.hisDdKey || changes.hisDdContexts) {
        this.notifyDdKeyOrContextsChanged();
        if (this.autocompleteDefaultValue != null) {
          this.handleAutocompleteDefaultValue(undefined);
        }
      }
    }
    ngOnDestroy() {
      if (this.fieldMessagesSubscription) {
        this.fieldMessagesSubscription.unsubscribe();
      }
    }
    onNgModelChange(event) {
      if (!this.autocompleteRef || this.autocompleteRef && typeof event !== 'string') {
        setTimeout(() => {
          this.ddDirectiveRegistryService.checkForContextChanges(this.hisDdKey);
        }, 1); // delay registery-service call to be sure ngModel was updated
      }
      // reset ddBackenErrors for dynamic field/attribute
      this.setDdBackendErrorForDynamicFields(null);
    }
    /**
     * When hisDataSource sets suggestions via AutoCompleteRef, change detection is not triggered.
     * This custom event is called instead.
     */
    onHisDataSourceDataAvailable(event) {
      if (this.autocompleteDefaultValue != null) {
        this.handleAutocompleteDefaultValue(event);
      }
    }
    /**
     * Setzt den Autocomplete-Defaultwert, nachdem die Gesamtliste der Optionen
     * in 'suggestions' zur Verfügung steht.
     */
    handleAutocompleteDefaultValue(event, dDReadOnly) {
      if (this.autocompleteRef == null || this.ignoreDefaultValue) {
        return;
      }
      let defaultValue = this.autocompleteDefaultValue;
      let suggestions = this.autocompleteRef.suggestions;
      if (suggestions != null && suggestions.length > 0) {
        this.autocompleteDefaultValue = null; // Verhindern, dass der selbe DefaultWert noch einmal behandelt wird.
        // Default nur setzen, wenn vorher noch kein Wert gesetzt war (leeres Objekt (bei multiselect) gilt als kein Wert)
        // oder ein Defaultwert existiert und das Feld readOnly definiert ist (Weiterführung der Abfrage-Bedingung aus applyDefaultValueIfSet())
        if (this.ngModelRef && (this.ngModelRef.value == null || !Object.keys(this.ngModelRef.value).length || this.ngModelRef.value !== null && dDReadOnly)) {
          if (this.hisDdTransformMethod) {
            defaultValue = this.hisDdTransformMethod(defaultValue, suggestions);
          } else {
            defaultValue = this.hisDdDefaultTransformMethod(defaultValue, suggestions);
          }
          if (defaultValue !== null) {
            this.setModelValue(defaultValue);
          }
        }
      } else {
        // Die Optionen waren (noch) leer - später nochmal versuchen
        if (this.autocompleteDefaultValueRetries-- > 0) {
          setTimeout(() => {
            this.autocompleteRef.completeMethod.emit({
              query: '',
              originalEvent: event
            }); // Alle Optionen / suggestions anfordern
          }, 200);
        }
      }
    }
    hisDdDefaultTransformMethod(defaultValue, entries) {
      for (let entry of entries) {
        if (entry.objGuid === defaultValue || entry.hisKeyId === defaultValue || entry === defaultValue) {
          return entry;
        }
      }
      return null;
    }
    /**
     * Der ddKey oder ddContexts hat sich geändert -> nun müssen die neuen Werte gesetzt
     * werden, falls ein Entry existiert
     */
    notifyDdKeyOrContextsChanged() {
      let elInput = this.findElementRef();
      if (!elInput) {
        return;
      }
      // Zunächst Fehlermeldungen von alten Kontexten löschen und eventuelle Originalwerte wiederherstellen
      this.resetErrors();
      this.restoreOriginalValues(elInput);
      // Wenn ddKey gesetzt, Werte anwenden
      if (this.hisDdKey) {
        let ddEntry = this.hisDdService.getMergedEntry(this.hisDdKey, this.hisDdContexts);
        if (!ddEntry || !ddEntry.identifier) {
          // Minimalen Entry synthetisieren, wenn nicht vorhanden, um Label zu erhalten
          ddEntry = {
            identifier: this.hisDdKey
          };
        }
        // Setzen der dataSourceFilter an AutoComplete/Auswahlfeldern
        if (elInput instanceof AutoComplete) {
          if (ddEntry.dataSourceFilter) {
            // Current expected format { hiskeyIds = 1001,1004 } || { objGuids = c93bc42b-ba6d-48c4-9047-8a0bb6a69d92, a798722d-b1fa-4f19-8238-1845f1938cfc }
            this.autocompleteRef.dataSourceFilter = ddEntry.dataSourceFilter;
          } else {
            this.autocompleteRef.dataSourceFilter = undefined;
          }
        }
        this.applyDdEntry(ddEntry, elInput);
      }
    }
    /**
     * Um die Validieren auf Pflichtfeld für Übersetzungsfelder zu deaktivieren
     * könnten wir hier das required-Attribut auf false setzen, bzw. es auf seinen
     * Ursprungswert zurücksetzen
     */
    forceNotRequired(forceRequiredFalse) {
      let elInput = this.findElementRef();
      if (!elInput && !this.isReactiveForm()) {
        return;
      }
      // Wenn ddKey gesetzt, Werte anwenden
      if (this.hisDdKey) {
        let ddEntry = this.hisDdService.getMergedEntry(this.hisDdKey, this.hisDdContexts);
        if (!this.originalRequiredValue) {
          this.originalRequiredValue = ddEntry.required;
        }
        if (forceRequiredFalse) {
          // force required false
          ddEntry.required = false;
        } else {
          ddEntry.required = this.originalRequiredValue;
        }
        this.applyDdEntry(ddEntry, elInput);
      }
    }
    resetErrors() {
      if (this.ngModelRef?.control?.errors) {
        console.log('delete error messages for hisDdKey', this.hisDdKey);
        this.ngModelRef.control.setErrors(null); // bei {} würden noch Fehler ohne Meldung angezeigt werden
      }
    }
    setDdBackendErrorForDynamicFields(ddBackendErrorMessage) {
      if (this.ngModelRef == null && this.hisDdKey && this.hisDdKey.startsWith('dynamic.')) {
        if (this.autocompleteRef) {
          this.autocompleteRef.ddBackendError = ddBackendErrorMessage;
        } else if (this.calendarRef) {
          this.calendarRef.ddBackendError = ddBackendErrorMessage;
        } else {
          this.elementRef.nativeElement.ddBackendError = ddBackendErrorMessage;
        }
      }
    }
    /**
     * Um dynamische Änderung zu erlauben, müssen die Originalwerte
     * vor der Anwendung des vorherigen DdEntries wieder hergestellt werden können
     */
    restoreOriginalValues(elInput) {
      // eslint-disable-next-line guard-for-in
      for (let key in this.originalValues) {
        elInput[key] = this.originalValues[key];
      }
    }
    /**
     * Übernimmt einen Wert aus dem ddEntry in das Inputfeld, falls gesetzt.
     * Vorher wird der alte Wert in den originalValues zwischengespeichert.
     * Wenn sich der Zustand 'ungesetzt' nicht einfach durch Setzen des alten Wertes wieder herstellen lässt,
     * kann ein Ersatzwert für 'ungesetzt' angegeben werden.
     */
    applyPropertyIfSet(ddAttributeValue, elInput, inputProperty, unsetValue, unsetSubst) {
      if (ddAttributeValue != null && ddAttributeValue !== false) {
        if (unsetValue != null && elInput[inputProperty] === unsetValue) {
          this.originalValues[inputProperty] = unsetSubst;
        } else {
          this.originalValues[inputProperty] = elInput[inputProperty];
        }
        elInput[inputProperty] = ddAttributeValue;
      }
    }
    /**
     * Übernimmt minDate-Angaben, wenn im DD gesetzt.
     * Dabei wird zwischen 'input type=date' und der p-calendar-Komponente unterschieden.
     *
     * @param rawDate Datum als ISO-String oder in Millisekunden seit 1.1.1970 00:00:00 UTC
     */
    applyMinDatePropertyIfSet(rawDate, elInput) {
      if (rawDate !== null && rawDate !== undefined) {
        // rawDate===0 ist ein gültiges Datum
        if (elInput.type === 'date') {
          this.originalValues.min = elInput.min;
          elInput.min = HisDateUtils.convertToIsoDateString(rawDate);
        } else if (elInput instanceof Calendar) {
          this.originalValues.minDate = elInput.minDate;
          elInput.minDate = HisDateUtils.convertToLocalDate(rawDate);
        }
      }
    }
    /**
     * Übernimmt maxDate-Angaben, wenn im DD gesetzt.
     * Dabei wird zwischen 'input type=date' und der p-calendar-Komponente unterschieden.
     *
     * @param rawDate Datum als ISO-String oder in Millisekunden seit 1.1.1970 00:00:00 UTC
     */
    applyMaxDatePropertyIfSet(rawDate, elInput) {
      if (rawDate !== null && rawDate !== undefined) {
        // rawDate===0 ist ein gültiges Datum
        if (elInput.type === 'date') {
          this.originalValues.max = elInput.max;
          elInput.max = HisDateUtils.convertToIsoDateString(rawDate);
        } else if (elInput instanceof Calendar) {
          this.originalValues.maxDate = elInput.maxDate;
          elInput.maxDate = HisDateUtils.convertToLocalDate(rawDate);
        }
      }
    }
    /**
     * Wendet einen im DD gesetzten Standardwert auf die Eingabekomponente an,
     * sofern noch kein Wert gesetzt wurde.
     * TODO: Funktioniert noch nicht für Reactive Forms
     */
    applyDefaultValueIfSet(ddEntry, elInput) {
      // defaultValue setzen, wenn noch kein Wert gesetzt
      if (ddEntry.defaultValue != null) {
        if (this.ngModelRef && (this.ngModelRef.value == null || ddEntry.defaultValue !== this.ngModelRef.value && ddEntry.readonly)) {
          let defaultValue = ddEntry.defaultValue;
          if (elInput instanceof HisMultiselectComponent) {
            // applying default value is not supported for multiselect yet
          } else if (elInput instanceof AutoComplete) {
            // DefaultValue asynchron setzen, nachdem die Optionen ermittelt wurden
            // Das läuft in ngOnChanges über die Veränderung von 'suggestions'
            this.autocompleteDefaultValue = defaultValue;
            this.handleAutocompleteDefaultValue(undefined, ddEntry.readonly);
            // Verzögern bis nach diesem Darstellungszyklus, da sonst der geänderte Wert
            // von 'suggestions' angemeckert wird
            setTimeout(() => {
              this.autocompleteRef.completeMethod.emit({
                query: '',
                originalEvent: undefined
              }); // Alle Optionen / suggestions anfordern
            });
          } else {
            if (this.hisDdTransformMethod) {
              defaultValue = this.hisDdTransformMethod(defaultValue);
            }
            if (elInput instanceof Calendar) {
              try {
                defaultValue = HisDateUtils.convertToLocalDate(defaultValue);
              } catch (error) {
                console.warn('Could not transform Default-String to Date (ISO Date expected): \'' + defaultValue + '\'');
                defaultValue = null;
              }
            }
            setTimeout(() => {
              this.setModelValue(defaultValue);
            });
          }
        }
      }
    }
    /**
     * Wendet den Entry auf das (Input-) Element an
     */
    applyDdEntry(ddEntry, elInput) {
      // zunächst die Eigenschaften anwenden, die auch bei passiven Komponenten
      // (nicht-Eingabefelder) greifen sollen.
      this.applyPropertyIfSet(ddEntry.helptextIdentifier, elInput, 'ddHelptext');
      this.applyPropertyIfSet(ddEntry.backendErrorIdentifier, elInput, 'ddBackendError');
      // labeltextIdentifier überschreibt den identifier bzgl. Label-Oberflächenschlüssel
      if (ddEntry.labeltextIdentifier != null) {
        this.applyPropertyIfSet(ddEntry.labeltextIdentifier, elInput, 'ddLabeltext');
      } else {
        this.applyPropertyIfSet(ddEntry.identifier, elInput, 'ddLabeltext');
      }
      this.applyPropertyIfSet(ddEntry.identifier, elInput, 'ddIdentifier');
      // hidden
      if (ddEntry.hidden) {
        this.hideInputField(elInput, ddEntry);
        this.ddDirectiveRegistryService.resetObjectValue(ddEntry.identifier);
      } else {
        this.showChildInputField(elInput, ddEntry);
      }
      /*
      * Required auch zur Verfügung stellen, wenn kein ngModel gefunden wurde.
      * Aber nicht bei Reactive Forms, dort ist required ein Validator.
      */
      if (!this.isReactiveForm()) {
        this.applyPropertyIfSet(ddEntry.required, elInput, 'required');
      }
      // Ab hier werden Werte für Eingabekomponenten gesetzt.
      // Deshalb abbrechen, wenn kein ngModel vorhanden ist
      if (!this.ngModelRef && !this.isReactiveForm()) {
        return;
      }
      // defaultValue setzen, wenn noch kein Wert gesetzt
      // Das soll auch bei hidden Eingabefeldern passieren können
      this.applyDefaultValueIfSet(ddEntry, elInput);
      // wenn hidden insb. keine Validatoren an die Eingabe binden
      if (ddEntry.hidden) {
        return;
      }
      // setzen des readonly Wertes für Eingabefelder
      this.setReadOnly(elInput, ddEntry);
      // Bei Reactive Forms ist required ein Validator und keine Property.
      if (!this.isReactiveForm()) {
        // Hack, da -1 in 64000 übersetzt wird! Aber -1 lässt sich nicht wieder setzen und null wird als 0 angesehen,
        // was ein schlechter max-Wert ist ;)
        this.applyPropertyIfSet(ddEntry.maxLength, elInput, 'maxLength', -1, 64000);
        // Hack, da -1 in 0 übersetzt wird! Aber -1 lässt sich nicht wieder setzen
        this.applyPropertyIfSet(ddEntry.minLength, elInput, 'minLength', -1, 0);
      }
      this.applyMinDatePropertyIfSet(ddEntry.minValueDate, elInput);
      this.applyMaxDatePropertyIfSet(ddEntry.maxValueDate, elInput);
      // Validatoren erzeugen
      if (ddEntry.datatype === 'PAST_DATE') {
        this.applyMaxDatePropertyIfSet(new Date().toISOString(), elInput);
      } else if (ddEntry.datatype === 'FUTURE_DATE') {
        this.applyMinDatePropertyIfSet(new Date().toISOString(), elInput);
      }
      this.ddValidator.registerValidators(ddEntry);
      if (this.isReactiveForm()) {
        let vals = this.ddValidator.getValidators();
        this.formControl.addValidators(Validators.compose(vals));
        this.formControl.updateValueAndValidity();
      }
    }
    hideInputField(elInput, ddEntry) {
      this.originalValues.style = elInput.style;
      this.originalValues.ddHidden = elInput.ddHidden;
      elInput.ddHidden = ddEntry.hidden;
      if (elInput.style == null) {
        elInput.style = {};
      }
      elInput.style.display = 'none';
    }
    showChildInputField(elInput, ddEntry) {
      if (elInput.el?.nativeElement?.firstChild) {
        elInput.el.nativeElement.firstChild.style.display = '';
      } else {
        this.elementRef.nativeElement.ddHidden = ddEntry.hidden;
      }
    }
    setReadOnly(elInput, ddEntry) {
      // eslint-disable-next-line max-len
      if (elInput instanceof Calendar || elInput instanceof Chips || elInput instanceof AutoComplete || elInput instanceof DataView) {
        // Calendar, Autocomplete, Chips und DataView verstehen kein readonly und müssen deshalb disabled werden
        this.applyPropertyIfSet(ddEntry.readonly, elInput, 'disabled');
        // markForCheck to trigger ChangeDection, um gesetzte Attribute wie "readOnly" / "disabled" zu reseten/entfernen.
        this.changeDetectorRef.markForCheck();
      } else if (elInput instanceof InputNumber) {
        this.applyPropertyIfSet(ddEntry.readonly, elInput, 'readonly');
      } else if (elInput instanceof HisSummernoteComponent) {
        elInput.setDisabledState(ddEntry.readonly); //this.( ddEntry.readonly, elInput, 'readonly' );
      } else {
        this.applyPropertyIfSet(ddEntry.readonly, elInput, 'readOnly');
      }
    }
    /**
     * find element reference of this directive is defined on
     */
    findElementRef() {
      if (this.calendarRef) {
        return this.calendarRef;
      } else if (this.autocompleteRef) {
        return this.autocompleteRef;
      } else if (this.chipsRef) {
        return this.chipsRef;
      } else if (this.panelRef) {
        return this.panelRef;
      } else if (this.multiSelectRef) {
        return this.multiSelectRef;
      } else if (this.hisPlamRef) {
        return this.hisPlamRef;
      } else if (this.hisTreeSelectRef) {
        return this.hisTreeSelectRef;
      } else if (this.inputNumber) {
        return this.inputNumber;
      } else if (this.hisSearchSelectPopup) {
        return this.hisSearchSelectPopup;
      } else if (this.dataViewRef) {
        return this.dataViewRef;
      } else if (this.pickList) {
        return this.pickList;
      } else if (this.hisMultiselect) {
        return this.hisMultiselect;
      } else if (this.hisEditor) {
        return this.hisEditor;
      }
      return this.elementRef.nativeElement;
    }
    /**
     * Setzt einen neuen Wert im Model und benachrichtigt auch die View über den geänderten Wert,
     * so dass dieser dargestellt wird.
     */
    setModelValue(newValue) {
      // Diese Art, das Modell zu setzen aktualisiert die View und das Model
      // Das war Ergebnis harter experimenteller Arbeit - bitte nich leichtfertig ändern ;) JOL
      this.ngModelRef.reset(newValue);
      this.ngModelRef.viewToModelUpdate(newValue);
      if (this.autocompleteRef) {
        this.autocompleteRef.onSelect.emit({
          originalEvent: new CustomEvent('custom'),
          value: newValue
        });
      }
    }
    get formControl() {
      return this.ctrlRef?.form ?? this.formControlName?.formDirective?.form;
    }
    isReactiveForm() {
      return !!this.formControl;
    }
    static {
      this.ɵfac = function HisDdDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDdDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisDdDirective,
        selectors: [["", "hisDdKey", ""]],
        hostBindings: function HisDdDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("ngModelChange", function HisDdDirective_ngModelChange_HostBindingHandler($event) {
              return ctx.onNgModelChange($event);
            })("hisDataSourceDataAvailable", function HisDdDirective_hisDataSourceDataAvailable_HostBindingHandler($event) {
              return ctx.onHisDataSourceDataAvailable($event);
            });
          }
        },
        inputs: {
          hisDdKey: "hisDdKey",
          hisDdContexts: "hisDdContexts",
          ignoreDefaultValue: "ignoreDefaultValue",
          hisDdTransformMethod: "hisDdTransformMethod"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisDdDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Explicitly define dateFormat because his-calendar-directive does
// not reformat a value set by form control.
let DateComponent = /*#__PURE__*/(() => {
  class DateComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.hbgs = hbgs;
      this.options = injectedData.options;
    }
    ngOnInit() {
      this.dateFormat = HisDateUtils.languageToDateFormatsMap.get(this.hbgs.getLanguage());
      if (this.options.defaultValue) {
        this.value = new Date(this.options.defaultValue);
      }
      // console.log('this.value: ', this.value);
      super.initFormControl(this.value);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        let newValue = matchingConfig.defaultValue;
        this.formControl.setValue(newValue, {
          emitEvent: false
        });
      }
    }
    getControlValue() {
      return this.formControl.value ? HisDateUtils.formatEnglishDateFromString(new Date(this.formControl.value)) : '';
    }
    static {
      this.ɵfac = function DateComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DateComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: DateComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 5,
        consts: [["content", ""], [3, "label", "helptext"], [3, "hisDdKey", "formControl", "dateFormat"]],
        template: function DateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "p-calendar", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl)("dateFormat", ctx.dateFormat);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$2.Calendar, HisPlamComponent, HisDdDirective, HisDdValidator, HisCalendarDefaultsDirective, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return DateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxComponent = /*#__PURE__*/(() => {
  class CheckboxComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.formControl.setValue(matchingConfig.defaultValue, {
          emitEvent: false
        });
      }
    }
    ngOnInit() {
      super.initFormControl(this.value);
    }
    getControlValue() {
      return this.formControl.value ? this.formControl.value.toString() : 'false';
    }
    static {
      this.ɵfac = function CheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CheckboxComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 4,
        consts: [["content", ""], [3, "label", "helptext"], ["type", "checkbox", 3, "hisDdKey", "formControl"]],
        template: function CheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "input", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl);
          }
        },
        dependencies: [i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return CheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectComponent = /*#__PURE__*/(() => {
  class SelectComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      this.items = this.options.items;
      this.item = this.findDefaultItem(this.value);
      super.initFormControl(this.item);
    }
    // autocomplete
    search(event) {
      this.filteredItems = this.items.filter(item => event.query === '' || item.label.toLowerCase().indexOf(event.query.toLowerCase()) !== -1);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.items = matchingConfig.items;
        let selectedItem = this.findDefaultItem(matchingConfig.defaultValue);
        this.formControl.setValue(selectedItem, {
          emitEvent: false
        });
      }
    }
    findDefaultItem(defaultValue) {
      let selectedItem;
      selectedItem = this.items.find(item => defaultValue === item.value);
      if (!selectedItem) {
        selectedItem = {
          label: '',
          value: ''
        };
      }
      return selectedItem;
    }
    getControlValue() {
      return this.formControl.value ? this.formControl.value.value : '';
    }
    static {
      this.ɵfac = function SelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: SelectComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 7,
        consts: [["content", ""], [3, "label", "helptext"], ["field", "label", 3, "completeMethod", "hisDdKey", "formControl", "suggestions", "dropdown", "forceSelection"]],
        template: function SelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "p-autoComplete", 2, 0);
            i0.ɵɵlistener("completeMethod", function SelectComponent_Template_p_autoComplete_completeMethod_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.search($event));
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl)("suggestions", ctx.filteredItems)("dropdown", true)("forceSelection", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$1.AutoComplete, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective, HisButtonTitleDirective],
        encapsulation: 2
      });
    }
  }
  return SelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function RadioButtonComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "input", 3, 0);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const opt_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hisDdKey", ctx_r1.options.ddKey)("value", opt_r1.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", opt_r1.label, " ");
  }
}
let RadioButtonComponent = /*#__PURE__*/(() => {
  class RadioButtonComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      this.items = this.options.items;
      this.currentItem = this.items.find(it => this.value === it.value) || {
        label: '',
        value: ''
      };
      this.localFormGroup = new UntypedFormGroup({
        value: this.required ? new UntypedFormControl(this.currentItem.value, Validators.required) : new UntypedFormControl(this.currentItem.value)
      });
      this.formGroup.addControl(this.name, this.localFormGroup);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.items = matchingConfig.items;
        this.currentItem = this.items.find(it => matchingConfig.defaultValue === it.value) || {
          label: '',
          value: ''
        };
        this.localFormGroup.removeControl(this.name);
        this.formControl.setValue(matchingConfig.defaultValue, {
          emitEvent: false
        });
      }
    }
    getControlValue() {
      return this.localFormGroup.value.value;
    }
    static {
      this.ɵfac = function RadioButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RadioButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: RadioButtonComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 3,
        consts: [["content", ""], [3, "label", "helptext"], [3, "formGroup"], ["type", "radio", "formControlName", "value", 1, "biaRadioButton", 3, "hisDdKey", "value"]],
        template: function RadioButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "form", 2);
            i0.ɵɵrepeaterCreate(2, RadioButtonComponent_For_3_Template, 4, 3, "div", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.localFormGroup);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.items);
          }
        },
        dependencies: [i1$1.ɵNgNoValidate, i1$1.DefaultValueAccessor, i1$1.RadioControlValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName, HisPlamComponent, HisDdDirective, HisDdValidator, HisFormDefaultsDirective, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return RadioButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PasswordComponent = /*#__PURE__*/(() => {
  class PasswordComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(this.value);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.formControl.setValue(matchingConfig.defaultValue, {
          emitEvent: false
        });
      }
    }
    getControlValue() {
      return this.formControl.value;
    }
    static {
      this.ɵfac = function PasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PasswordComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: PasswordComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 4,
        consts: [["content", ""], [3, "label", "helptext"], ["type", "password", 1, "inputWidth100", 3, "hisDdKey", "formControl"]],
        template: function PasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "input", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return PasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextAreaComponent = /*#__PURE__*/(() => {
  class TextAreaComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.hbgs = hbgs;
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(this.value);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.formControl.setValue(matchingConfig.defaultValue, {
          emitEvent: false
        });
      }
    }
    setRequired(state) {
      if (this.options.ddKey) {
        this.hbgs.setRequiredToDdEntry(this.ddKey, state);
        this.ddDirective.notifyDdKeyOrContextsChanged();
      }
      this.formControl.setValidators(state ? Validators.required : []);
      this.formControl.markAsDirty();
    }
    getControlValue() {
      return this.formControl.value;
    }
    static {
      this.ɵfac = function TextAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextAreaComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: TextAreaComponent,
        selectors: [["ng-component"]],
        viewQuery: function TextAreaComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(HisDdDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ddDirective = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 6,
        consts: [["content", ""], [3, "label", "helptext", "showLabelTop"], [1, "textareaWidth100", 3, "hisDdKey", "formControl", "rows"]],
        template: function TextAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "textarea", 2, 0);
            i0.ɵɵtext(3, "            ");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext)("showLabelTop", ctx.options.showLabelTop);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.ddKey)("formControl", ctx.formControl)("rows", ctx.options.height);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return TextAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LabelComponent = /*#__PURE__*/(() => {
  class LabelComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(null);
    }
    updateConfiguration(entireFormConfig) {}
    getControlValue() {
      return null;
    }
    static {
      this.ɵfac = function LabelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LabelComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LabelComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 3,
        consts: [["content", ""], [3, "label", "helptext"], [1, "plamContentText"]],
        template: function LabelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "span", 2, 0);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.value);
          }
        },
        dependencies: [HisPlamComponent],
        encapsulation: 2
      });
    }
  }
  return LabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextComponent = /*#__PURE__*/(() => {
  class TextComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(this.value);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.formControl.setValue(matchingConfig.defaultValue, {
          emitEvent: false
        });
      }
    }
    getControlValue() {
      return this.formControl.value;
    }
    static {
      this.ɵfac = function TextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: TextComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 5,
        consts: [["content", ""], [3, "label", "helptext"], ["pInputText", "", 1, "inputWidth100", 3, "ngModel", "hisDdKey", "formControl"]],
        template: function TextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "input", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngModel", ctx.value)("hisDdKey", ctx.options.ddKey !== null ? ctx.options.ddKey : ctx.options.name)("formControl", ctx.formControl);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, i7$1.InputText, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return TextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$n = ["content"];
function MultiSelectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 20);
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_10_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.toggleFilter();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.toggleTableFilter ? i0.ɵɵpipeBind1(4, 1, "de.his.faces.tags.table.tableFilter.disable") : i0.ɵɵpipeBind1(5, 3, "de.his.faces.tags.table.tableFilter.enable"), " ");
  }
}
function MultiSelectComponent_ng_template_14_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 25, 0);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("keydown.enter", function MultiSelectComponent_ng_template_14_Conditional_9_Template_input_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r2.onFilterTable());
    })("click", function MultiSelectComponent_ng_template_14_Conditional_9_Template_input_click_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 2, "genericSearch.resultTable.tableFilter.applyFilter"))("formControl", ctx_r2.overlayFilter);
  }
}
function MultiSelectComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th", 21);
    i0.ɵɵelement(2, "p-tableHeaderCheckbox", 22);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "span", 23);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "th", 24);
    i0.ɵɵtext(8);
    i0.ɵɵtemplate(9, MultiSelectComponent_ng_template_14_Conditional_9_Template, 4, 4, "div");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 5, "genericSearch.selectAllOfPage"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, "genericSearch.rowselect"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pSortableColumn", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.options.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.toggleTableFilter ? 9 : -1);
  }
}
function MultiSelectComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td", 21)(2, "p-tableCheckbox", 26);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function MultiSelectComponent_ng_template_15_Template_p_tableCheckbox_click_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 4, "genericSearch.selectItems"));
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 6, "genericSearch.selectItems"));
    i0.ɵɵproperty("value", row_r7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(row_r7.label);
  }
}
function MultiSelectComponent_ng_template_16_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "de.his.faces.tags.table.datascroller.numRowsPerPage"), " (Max:", ctx_r2.maxRows, ") ");
  }
}
function MultiSelectComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "label", 28);
    i0.ɵɵtemplate(5, MultiSelectComponent_ng_template_16_Conditional_5_Template, 3, 4, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "input", 29, 0);
    i0.ɵɵlistener("keydown.enter", function MultiSelectComponent_ng_template_16_Template_input_keydown_enter_6_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r2.calculateTotalNumberOfPages());
    })("click", function MultiSelectComponent_ng_template_16_Template_input_click_6_listener($event) {
      i0.ɵɵrestoreView(_r8);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(3, 3, "de.his.faces.tags.table.datascroller.numRowsFound.page", ctx_r2.currentPageNumber, ctx_r2.totalNumberOfPages), " | ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.maxRows ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r2.maxTableRows);
  }
}
function MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ɵ$index_109_r10 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.deleteSelectedOption(ɵ$index_109_r10));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(1, 1, "common.removeAssignmentOf", selectedOption_r11.label));
  }
}
function MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 33);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Conditional_2_Template, 2, 4, "button", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r11 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r11.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.options.disabled ? 2 : -1);
  }
}
function MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "ul");
    i0.ɵɵrepeaterCreate(2, MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Template, 3, 2, "li", 33, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r12 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedOptions_r12);
  }
}
function MultiSelectComponent_Conditional_26_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 30, 0);
    i0.ɵɵtemplate(2, MultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_Template, 4, 0, "ng-template", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hisDdKey", ctx_r2.options.ddKey)("formControl", ctx_r2.formControl)("value", ctx_r2.selectedOptions)("emptyMessage", "\u00A0");
  }
}
function MultiSelectComponent_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 16);
    i0.ɵɵtemplate(1, MultiSelectComponent_Conditional_26_Conditional_1_Template, 3, 4, "p-dataView", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.selectedOptions && ctx_r2.selectedOptions.length > 0 ? 1 : -1);
  }
}
function MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ɵ$index_129_r14 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.deleteSelectedOption(ɵ$index_129_r14));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate2("title", "", selectedOption_r15.label, ": ", i0.ɵɵpipeBind1(1, 3, "view.controls.disconnect"), "");
  }
}
function MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 33);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Conditional_2_Template, 2, 5, "button", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r15 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r15.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.options.disabled ? 2 : -1);
  }
}
function MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "ul");
    i0.ɵɵrepeaterCreate(2, MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Template, 3, 2, "li", 33, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r16 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedOptions_r16);
  }
}
function MultiSelectComponent_Conditional_27_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 36, 0);
    i0.ɵɵtemplate(2, MultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_Template, 4, 0, "ng-template", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hisDdKey", ctx_r2.options.ddKey)("formControl", ctx_r2.formControl)("value", ctx_r2.selectedOptions)("emptyMessage", "\u00A0");
  }
}
function MultiSelectComponent_Conditional_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵtemplate(1, MultiSelectComponent_Conditional_27_Conditional_1_Template, 3, 4, "p-dataView", 36);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.selectedOptions && ctx_r2.selectedOptions.length > 0 ? 1 : -1);
  }
}
function MultiSelectComponent_Conditional_28_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37, 2);
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_28_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.showMultiselectPopup();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.options.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.selectedOptions == null ? null : ctx_r2.selectedOptions.length) > 0 ? i0.ɵɵpipeBind1(4, 2, "genericSearch.changeSelectedItems") : i0.ɵɵpipeBind1(5, 4, "genericSearch.selectItems"), " ");
  }
}
function MultiSelectComponent_Conditional_29_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function MultiSelectComponent_Conditional_29_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.deleteAllSelectedOptions();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.deleteSelectedItems"));
  }
}
let MultiSelectComponent = /*#__PURE__*/(() => {
  class MultiSelectComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      this.pageSize = 10;
      this.maxRows = 300;
      this.currentPageNumber = 1;
      this.maxTableRows = new FormControl(this.pageSize);
      this.firstResultRow = 0;
      this.selectedOptions = [];
      this.selectedRows = [];
      this.multiselectPopupVisible = false;
      this.inlineFilter = new FormControl('');
      this.overlayFilter = new FormControl('');
      this.toggleTableFilter = true;
      this.showTableFilter = true;
      this.inlineFilteredCustomOptions = [];
      this.overlayFilteredCustomOptions = [];
      this.customOptions = [];
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(this.adaptDefaultValue(this.value));
      this.customOptions = this.options.items;
      this.overlayFilteredCustomOptions = this.options.items;
      this.setSelectedOptions(this.options.defaultValue);
    }
    // autocomplete
    search(event) {
      this.inlineFilteredCustomOptions = this.customOptions.filter(item => event.query === '' || item.label.toLowerCase().indexOf(event.query.toLowerCase()) !== -1);
    }
    onSelect(event) {
      this.addSelectedElement(event.value);
    }
    addSelectedElement(selectedElement) {
      if (this.selectedOptions.find(selectedOption => selectedOption.value === selectedElement.value)) {
        this.notificationService.info(this.uiService.translate('genericSearch.alreadySelected', selectedElement.label), 'Info');
      } else {
        this.selectedOptions = [...this.selectedOptions, selectedElement];
      }
      this.formControl.setValue(this.selectedOptions.map(o => o.value), {
        emitEvent: true
      });
      this.inlineFilter.setValue('');
      this.autoComplete.clear();
    }
    deleteSelectedOption(index) {
      this.selectedOptions.splice(index, 1);
      this.selectedOptions = [...this.selectedOptions];
      this.formControl.setValue(this.selectedOptions.map(o => o.value), {
        emitEvent: true
      });
    }
    deleteAllSelectedOptions() {
      this.selectedOptions = [];
      this.selectedRows = [];
      this.formControl.setValue(this.selectedOptions, {
        emitEvent: true
      });
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        //// Replace items. Note that here we must avoid to create a new array object #255241
        //this.customOptions.splice( 0, this.customOptions.length, ...matchingConfig.items );
        // but the above causes a different problem:
        // set new default value(s)
        this.customOptions = [...matchingConfig.items];
        this.search({
          query: ''
        });
        this.overlayFilteredCustomOptions = this.customOptions;
        let adaptedValue = this.adaptDefaultValue(matchingConfig.defaultValue);
        this.formControl.setValue(adaptedValue, {
          emitEvent: false
        });
        this.setSelectedOptions(matchingConfig.defaultValue);
      }
    }
    adaptDefaultValue(value) {
      if (Array.isArray(value)) {
        return value;
      } else if (value && value !== null && value !== '') {
        return [value];
      }
      return [];
    }
    setSelectedOptions(defaultValue) {
      this.selectedOptions = [];
      if (defaultValue) {
        this.adaptDefaultValue(defaultValue).forEach(value => {
          this.customOptions.find(item => {
            if (item.value === value.trim()) {
              this.selectedOptions.push(item);
            }
          });
        });
      }
    }
    getControlValue() {
      return this.formControl.value ? this.formControl.value.join(',') : '';
    }
    showMultiselectPopup() {
      this.inlineFilter.setValue('');
      this.selectedRows = this.selectedOptions ? this.selectedOptions.slice(0) : [];
      for (let selectedRow of this.selectedRows) {
        for (let element of this.overlayFilteredCustomOptions) {
          if (element.value === selectedRow.value) {
            this.overlayFilteredCustomOptions.splice(this.overlayFilteredCustomOptions.indexOf(element), 1, selectedRow);
          }
        }
      }
      this.calculateTotalNumberOfPages();
      this.multiselectPopupVisible = !this.multiselectPopupVisible;
    }
    hideMultiselectPopup() {
      this.multiselectPopupVisible = false;
    }
    submitSelection() {
      this.selectedOptions = [];
      for (let row of this.selectedRows) {
        this.addSelectedElement(row);
      }
      this.formControl.setValue(this.selectedOptions.map(o => o.value), {
        emitEvent: true
      });
    }
    toggleFilter() {
      this.toggleTableFilter = !this.toggleTableFilter;
      if (!this.toggleTableFilter) {
        this.overlayFilter.setValue('');
        this.onFilterTable();
      }
    }
    onFilterTable() {
      if (this.overlayFilter.value) {
        this.overlayFilteredCustomOptions = [];
        for (let element of this.customOptions) {
          if (element.label?.toUpperCase().indexOf(this.overlayFilter.value.toUpperCase()) > -1) {
            this.overlayFilteredCustomOptions = [...this.overlayFilteredCustomOptions, element];
          }
        }
        this.calculateTotalNumberOfPages();
      } else {
        this.overlayFilteredCustomOptions = this.customOptions;
        this.calculateTotalNumberOfPages();
      }
    }
    calculateTotalNumberOfPages() {
      if (this.maxTableRows && this.maxTableRows.value > 0 || this.maxTableRows.value > this.maxRows) {
        this.pageSize = +this.maxTableRows.value;
      }
      this.maxTableRows.setValue(this.pageSize);
      this.totalNumberOfPages = Math.ceil(this.overlayFilteredCustomOptions.length / this.pageSize);
    }
    onPage(event) {
      this.pageSize = +this.maxTableRows.value;
      this.firstResultRow = event.first;
      this.currentPageNumber = 1 + this.firstResultRow / this.pageSize;
    }
    static {
      this.ɵfac = function MultiSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MultiSelectComponent,
        selectors: [["ng-component"]],
        viewQuery: function MultiSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$n, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoComplete = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 30,
        vars: 34,
        consts: [["content", ""], ["selectTable", ""], ["inputElement", ""], [3, "label", "helptext"], ["field", "label", 3, "completeMethod", "onSelect", "hisDdKey", "formControl", "suggestions", "dropdown", "forceSelection"], ["appendTo", "body", "showEffect", "fade", 3, "visibleChange", "onHide", "visible", "responsive", "modal", "dismissableMask", "blockScroll", "focusTrap"], [1, "floatLeft"], [1, "tableFilterEditBlock"], [1, "clearerSpaceAboveHalfEm"], [3, "firstChange", "selectionChange", "onPage", "value", "paginator", "selectionPageOnly", "rows", "first", "selection"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "paginatorright"], ["type", "submit", "iconPos", "left", "hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"], [2, "vertical-align", "middle"], ["type", "submit", "iconPos", "left", "hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"], [1, "selectedOptionsList"], [1, "selectedOptionsListWithSelection"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton"], ["hisImage", "FILTER", 1, "transparent", "hideOnMobile", 3, "click"], [1, "multiSelectColumn"], [1, "hideOnBreakpointSmall", 3, "title"], [1, "hideOnBreakpointLarge"], [3, "pSortableColumn"], ["pInputText", "", "type", "text", 3, "keydown.enter", "click", "title", "formControl"], ["tabindex", "0", 3, "click", "value", "title", "ariaLabel"], [1, "tableRowCount"], ["for", "tableRow"], ["required", "", 1, "input_3_Chars", "tableRowInput", 3, "keydown.enter", "click", "formControl"], [3, "hisDdKey", "formControl", "value", "emptyMessage"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "title"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"], ["styleClass", "selectedDataContainer", 3, "hisDdKey", "formControl", "value", "emptyMessage"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "click", "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton", 3, "click"]],
        template: function MultiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 3)(1, "p-autoComplete", 4, 0);
            i0.ɵɵlistener("completeMethod", function MultiSelectComponent_Template_p_autoComplete_completeMethod_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.search($event));
            })("onSelect", function MultiSelectComponent_Template_p_autoComplete_onSelect_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelect($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p-dialog", 5);
            i0.ɵɵtwoWayListener("visibleChange", function MultiSelectComponent_Template_p_dialog_visibleChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.multiselectPopupVisible, $event) || (ctx.multiselectPopupVisible = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onHide", function MultiSelectComponent_Template_p_dialog_onHide_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hideMultiselectPopup());
            });
            i0.ɵɵelementStart(4, "p-header")(5, "h2");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "div", 6);
            i0.ɵɵelementStart(9, "div", 7);
            i0.ɵɵtemplate(10, MultiSelectComponent_Conditional_10_Template, 6, 5, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "div", 8);
            i0.ɵɵelementStart(12, "p-table", 9, 1);
            i0.ɵɵtwoWayListener("firstChange", function MultiSelectComponent_Template_p_table_firstChange_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.firstResultRow, $event) || (ctx.firstResultRow = $event);
              return i0.ɵɵresetView($event);
            })("selectionChange", function MultiSelectComponent_Template_p_table_selectionChange_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedRows, $event) || (ctx.selectedRows = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onPage", function MultiSelectComponent_Template_p_table_onPage_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              const selectTable_r4 = i0.ɵɵreference(13);
              ctx.onPage($event);
              return i0.ɵɵresetView(selectTable_r4 == null ? null : selectTable_r4.el == null ? null : selectTable_r4.el.nativeElement == null ? null : selectTable_r4.el.nativeElement.scrollIntoView({
                block: "start",
                behavior: "smooth"
              }));
            });
            i0.ɵɵtemplate(14, MultiSelectComponent_ng_template_14_Template, 10, 9, "ng-template", 10)(15, MultiSelectComponent_ng_template_15_Template, 7, 8, "ng-template", 11)(16, MultiSelectComponent_ng_template_16_Template, 8, 7, "ng-template", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "p-footer")(18, "button", 13);
            i0.ɵɵlistener("click", function MultiSelectComponent_Template_button_click_18_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.submitSelection();
              ctx.hideMultiselectPopup();
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelementStart(19, "span", 14);
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "button", 15);
            i0.ɵɵlistener("click", function MultiSelectComponent_Template_button_click_22_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.hideMultiselectPopup();
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelementStart(23, "span", 14);
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "hisUi");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(26, MultiSelectComponent_Conditional_26_Template, 2, 1, "ng-container", 16)(27, MultiSelectComponent_Conditional_27_Template, 2, 1, "ng-container", 17)(28, MultiSelectComponent_Conditional_28_Template, 6, 6, "button", 18)(29, MultiSelectComponent_Conditional_29_Template, 4, 3, "button", 19);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.inlineFilter)("suggestions", ctx.inlineFilteredCustomOptions)("dropdown", true)("forceSelection", true);
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("visible", ctx.multiselectPopupVisible);
            i0.ɵɵproperty("responsive", true)("modal", true)("dismissableMask", true)("blockScroll", true)("focusTrap", true);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 28, "multiselectPlam.selectValues"), " ", ctx.options.label, "");
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showTableFilter ? 10 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.overlayFilteredCustomOptions)("paginator", true)("selectionPageOnly", true)("rows", ctx.pageSize);
            i0.ɵɵtwoWayProperty("first", ctx.firstResultRow)("selection", ctx.selectedRows);
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 30, "genericSearch.returnSelected"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 32, "genericSearch.backToParentSearch"));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!true ? 26 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(true ? 27 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(true ? 28 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(true && ctx.selectedOptions && ctx.selectedOptions.length > 0 ? 29 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.FormControlDirective, i2$1.AutoComplete, i2.Header, i2.Footer, i2.PrimeTemplate, i2$3.DataView, i3.Dialog, i3$1.Table, i3$1.SortableColumn, i3$1.TableCheckbox, i3$1.TableHeaderCheckbox, i7$1.InputText, HisPlamComponent, HisImageDirective, HisDdDirective, HisDdValidator, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return MultiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Sets default values for p-autoComplete that are universally used in H1.
 */
class HisAutoCompleteDefaults {
  /**
   * Unless otherwise specified, the following defaults are applied:
   * drop-down with force-selection enabled and displaying the "text" property
   *
   * @param autoCompleteRef reference to a p-autoComplete-component
   */
  initDefaults(autoCompleteRef) {
    if (!autoCompleteRef) {
      return;
    }
    if (!autoCompleteRef.dropdown) {
      autoCompleteRef.dropdown = true;
    }
    if (!autoCompleteRef.forceSelection) {
      autoCompleteRef.forceSelection = true;
    }
    if (!autoCompleteRef.field) {
      autoCompleteRef.field = 'text';
    }
  }
  /**
   * a dataSource may either be a url to a rest service or the class name of value entities
   *
   * @param url url
   * @return complete url
   */
  expandBackendUrl(dataSource) {
    if (!dataSource) {
      return null;
    }
    if (dataSource.indexOf('/') > -1) {
      return dataSource;
    }
    return 'api/v1/cs/sys/values/' + dataSource;
  }
}

/**
 * Easy way to load a key table into an p-autoComplete component.
 * Also sets default values for p-autoComplete that are universally used in H1.
 */
let HisAutoCompleteEagerDataSourceDirective = /*#__PURE__*/(() => {
  class HisAutoCompleteEagerDataSourceDirective extends HisAutoCompleteDefaults {
    constructor() {
      super(...arguments);
      this.backendService = inject(HisBackendService);
      this.autoCompleteRef = inject(AutoComplete, {
        host: true
      });
      this.hisDataSourceDataAvailable = new EventEmitter();
    }
    ngAfterContentInit() {
      this.initDefaults(this.autoCompleteRef);
      // make name of data source available to debug panel
      // (needs some trickery to convince the compiler that AutoComplete has a field hisDataSource)
      this.autoCompleteRef.hisDataSource = this.dataSource;
    }
    ngOnChanges(changes) {
      if (changes.dataSource) {
        this.loadAllValuesFromServer();
        if (this.autoCompleteRef) {
          // make name of data source available to debug panel
          this.autoCompleteRef.hisDataSource = this.dataSource;
        }
      }
    }
    loadAllValuesFromServer() {
      let result$ = this.backendService.getData(this.expandBackendUrl(this.dataSource));
      result$.subscribe(data => {
        this.allEntries = data;
        // set suggestions here because hisDdKey is expecting it and @HostListener cannot read data of events
        this.autoCompleteRef.suggestions = data;
        // send an event to hisDdKey because direct access to autoCompleteRef.suggestions does not trigger change detection
        // (When @HostBinding supports custom @Input properties, that would be a much cleaner solution.
        this.hisDataSourceDataAvailable.emit(data);
      });
    }
    filterEntriesOnClient(query) {
      let dataSourceFilter = this.autoCompleteRef.dataSourceFilter;
      let result = [];
      if (dataSourceFilter) {
        this.getResult(this.filterAllEntries(this.allEntries, dataSourceFilter), query, result);
      } else {
        this.getResult(this.allEntries, query, result);
        // this.loadAllValuesFromServer();
      }
      this.autoCompleteRef.suggestions = result;
    }
    getResult(allEntries, query, result) {
      let queryInLowerCase = query.toLowerCase();
      let prop = this.autoCompleteRef.field;
      if (allEntries && allEntries.length > 0) {
        for (let entry of allEntries) {
          if (!entry || !entry[prop]) {
            continue;
          }
          if (entry[prop].toLowerCase().indexOf(queryInLowerCase) > -1) {
            result.push(entry);
          }
        }
      }
    }
    /** host listener paste event implementation to set ngModel based on filtered suggestions */
    onExtendedPaste(event) {
      let pastedText = event.clipboardData.getData('Text');
      // trigger set suggestions
      this.filterEntriesOnClient(pastedText);
      if (this.autoCompleteRef.suggestions) {
        let foundEntry = this.autoCompleteRef.suggestions.find(entry => entry.defaulttext === pastedText);
        if (foundEntry) {
          // set ngModel
          this.autoCompleteRef.onModelChange(foundEntry);
        }
      }
    }
    // filter the list of objects based on user input in the text field
    filterValue(event) {
      let query = event.query;
      this.filterEntriesOnClient(query);
    }
    /** filter allEntries withiout reload by dataSourceFilter parameter */
    filterAllEntries(allEntries, dataSourceFilter) {
      switch (dataSourceFilter.split('=')[0].trim()) {
        case 'hiskeyIds':
          return allEntries.filter(entry => dataSourceFilter.includes(entry.hiskeyId));
        case 'objGuids':
          return allEntries.filter(entry => dataSourceFilter.includes(entry.objGuid));
        default:
          console.log('#HisAutoCompleteDefaults.filterAllEntries() not valid datSourceFilter: ', dataSourceFilter);
          return allEntries;
      }
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisAutoCompleteEagerDataSourceDirective_BaseFactory;
        return function HisAutoCompleteEagerDataSourceDirective_Factory(__ngFactoryType__) {
          return (ɵHisAutoCompleteEagerDataSourceDirective_BaseFactory || (ɵHisAutoCompleteEagerDataSourceDirective_BaseFactory = i0.ɵɵgetInheritedFactory(HisAutoCompleteEagerDataSourceDirective)))(__ngFactoryType__ || HisAutoCompleteEagerDataSourceDirective);
        };
      })();
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisAutoCompleteEagerDataSourceDirective,
        selectors: [["p-autoComplete", "hisEagerDataSource", ""]],
        hostBindings: function HisAutoCompleteEagerDataSourceDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("paste", function HisAutoCompleteEagerDataSourceDirective_paste_HostBindingHandler($event) {
              return ctx.onExtendedPaste($event);
            })("completeMethod", function HisAutoCompleteEagerDataSourceDirective_completeMethod_HostBindingHandler($event) {
              return ctx.filterValue($event);
            });
          }
        },
        inputs: {
          dataSource: [0, "hisEagerDataSource", "dataSource"]
        },
        outputs: {
          hisDataSourceDataAvailable: "hisDataSourceDataAvailable"
        },
        exportAs: ["hisEagerDataSource"],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisAutoCompleteEagerDataSourceDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$m = ["content"];
let KeytableSelectComponent = /*#__PURE__*/(() => {
  class KeytableSelectComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(this.selectedGenericValue);
    }
    ngAfterContentChecked() {
      if (this.autoComplete && this.autoComplete._suggestions && this.genericValueTypes == null) {
        if (this.autoComplete._suggestions) {
          this.genericValueTypes = this.autoComplete._suggestions();
          if (this.genericValueTypes && this.options.defaultValue) {
            this.selectedGenericValue = this.genericValueTypes.find(genericValue => {
              if (genericValue.id === Number.parseFloat(this.value)) {
                return genericValue;
              }
              return undefined;
            });
            this.formControl.setValue(this.selectedGenericValue, {
              emitEvent: false
            });
            this.defaultValue = this.selectedGenericValue;
          }
        }
      }
    }
    updateConfiguration(entireFormConfig) {
      console.log('search config');
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      console.log('found: ' + matchingConfig);
      if (matchingConfig !== null) {
        if (this.genericValueTypes) {
          let selectedGenericValue = this.genericValueTypes.find(genericValue => Number.parseFloat(matchingConfig.defaultValue) === genericValue.id) || null;
          this.formControl.setValue(selectedGenericValue, {
            emitEvent: false
          });
        }
      }
    }
    getControlValue() {
      return this.formControl.value ? '' + this.formControl.value.id : '';
    }
    static {
      this.ɵfac = function KeytableSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KeytableSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: KeytableSelectComponent,
        selectors: [["ng-component"]],
        viewQuery: function KeytableSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$m, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoComplete = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 7,
        consts: [["content", ""], [3, "label", "helptext"], ["field", "defaulttext", 3, "hisDdKey", "formControl", "hisEagerDataSource", "dropdown", "forceSelection"]],
        template: function KeytableSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "p-autoComplete", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl)("hisEagerDataSource", ctx.options.typeAheadUrl)("dropdown", true)("forceSelection", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$1.AutoComplete, HisPlamComponent, HisDdDirective, HisDdValidator, HisAutoCompleteEagerDataSourceDirective, HisModificationDetectionDirective, HisButtonTitleDirective],
        encapsulation: 2
      });
    }
  }
  return KeytableSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$l = ["content"];
function KeytableMultiSelectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 20);
    i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Conditional_10_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.toggleFilter();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.toggleTableFilter ? i0.ɵɵpipeBind1(4, 1, "de.his.faces.tags.table.tableFilter.disable") : i0.ɵɵpipeBind1(5, 3, "de.his.faces.tags.table.tableFilter.enable"), " ");
  }
}
function KeytableMultiSelectComponent_ng_template_14_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 25, 0);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("keydown.enter", function KeytableMultiSelectComponent_ng_template_14_Conditional_9_Template_input_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r2.onFilterTable());
    })("click", function KeytableMultiSelectComponent_ng_template_14_Conditional_9_Template_input_click_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 2, "genericSearch.resultTable.tableFilter.applyFilter"))("formControl", ctx_r2.filter);
  }
}
function KeytableMultiSelectComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th", 21);
    i0.ɵɵelement(2, "p-tableHeaderCheckbox", 22);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "span", 23);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "th", 24);
    i0.ɵɵtext(8);
    i0.ɵɵtemplate(9, KeytableMultiSelectComponent_ng_template_14_Conditional_9_Template, 4, 4, "div");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 5, "genericSearch.selectAllOfPage"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, "genericSearch.rowselect"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pSortableColumn", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.options.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.toggleTableFilter ? 9 : -1);
  }
}
function KeytableMultiSelectComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td", 21)(2, "p-tableCheckbox", 26);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function KeytableMultiSelectComponent_ng_template_15_Template_p_tableCheckbox_click_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 4, "genericSearch.selectItems"));
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 6, "genericSearch.selectItems"));
    i0.ɵɵproperty("value", row_r7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(row_r7.defaulttext);
  }
}
function KeytableMultiSelectComponent_ng_template_16_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "de.his.faces.tags.table.datascroller.numRowsPerPage"), " (Max:", ctx_r2.maxRows, ") ");
  }
}
function KeytableMultiSelectComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "label", 28);
    i0.ɵɵtemplate(5, KeytableMultiSelectComponent_ng_template_16_Conditional_5_Template, 3, 4, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "input", 29, 0);
    i0.ɵɵlistener("keydown.enter", function KeytableMultiSelectComponent_ng_template_16_Template_input_keydown_enter_6_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r2.calculateTotalNumberOfPages());
    })("click", function KeytableMultiSelectComponent_ng_template_16_Template_input_click_6_listener($event) {
      i0.ɵɵrestoreView(_r8);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(3, 3, "de.his.faces.tags.table.datascroller.numRowsFound.page", ctx_r2.currentPageNumber, ctx_r2.totalNumberOfPages), " | ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.maxRows ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r2.maxTableRows);
  }
}
function KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ɵ$index_109_r10 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.deleteSelectedOption(ɵ$index_109_r10));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(1, 1, "common.removeAssignmentOf", selectedOption_r11.defaulttext));
  }
}
function KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 33);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Conditional_2_Template, 2, 4, "button", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r11 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r11.defaulttext, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.options.disabled ? 2 : -1);
  }
}
function KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "ul");
    i0.ɵɵrepeaterCreate(2, KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_For_3_Template, 3, 2, "li", 33, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r12 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedOptions_r12);
  }
}
function KeytableMultiSelectComponent_Conditional_26_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 30, 0);
    i0.ɵɵtemplate(2, KeytableMultiSelectComponent_Conditional_26_Conditional_1_ng_template_2_Template, 4, 0, "ng-template", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hisDdKey", ctx_r2.options.ddKey)("formControl", ctx_r2.formControl)("value", ctx_r2.selectedOptions)("emptyMessage", "\u00A0");
  }
}
function KeytableMultiSelectComponent_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 16);
    i0.ɵɵtemplate(1, KeytableMultiSelectComponent_Conditional_26_Conditional_1_Template, 3, 4, "p-dataView", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.selectedOptions && ctx_r2.selectedOptions.length > 0 ? 1 : -1);
  }
}
function KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ɵ$index_129_r14 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext(4);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r2.deleteSelectedOption(ɵ$index_129_r14));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate2("title", "", selectedOption_r15.label, ": ", i0.ɵɵpipeBind1(1, 3, "view.controls.disconnect"), "");
  }
}
function KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 33);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Conditional_2_Template, 2, 5, "button", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selectedOption_r15 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedOption_r15.defaulttext, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.options.disabled ? 2 : -1);
  }
}
function KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "ul");
    i0.ɵɵrepeaterCreate(2, KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_For_3_Template, 3, 2, "li", 33, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const selectedOptions_r16 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(selectedOptions_r16);
  }
}
function KeytableMultiSelectComponent_Conditional_27_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-dataView", 36, 0);
    i0.ɵɵtemplate(2, KeytableMultiSelectComponent_Conditional_27_Conditional_1_ng_template_2_Template, 4, 0, "ng-template", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hisDdKey", ctx_r2.options.ddKey)("formControl", ctx_r2.formControl)("value", ctx_r2.selectedOptions)("emptyMessage", "\u00A0");
  }
}
function KeytableMultiSelectComponent_Conditional_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 17);
    i0.ɵɵtemplate(1, KeytableMultiSelectComponent_Conditional_27_Conditional_1_Template, 3, 4, "p-dataView", 36);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.selectedOptions && ctx_r2.selectedOptions.length > 0 ? 1 : -1);
  }
}
function KeytableMultiSelectComponent_Conditional_28_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37, 2);
    i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Conditional_28_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.showMultiselectPopup();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r2.options.disabled);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.selectedOptions == null ? null : ctx_r2.selectedOptions.length) > 0 ? i0.ɵɵpipeBind1(4, 2, "genericSearch.changeSelectedItems") : i0.ɵɵpipeBind1(5, 4, "genericSearch.selectItems"), " ");
  }
}
function KeytableMultiSelectComponent_Conditional_29_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Conditional_29_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.deleteAllSelectedOptions();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "genericSearch.deleteSelectedItems"));
  }
}
let KeytableMultiSelectComponent = /*#__PURE__*/(() => {
  class KeytableMultiSelectComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      this.pageSize = 10;
      this.maxRows = 300;
      this.currentPageNumber = 1;
      this.maxTableRows = new FormControl(this.pageSize);
      this.firstResultRow = 0;
      this.selectedOptions = [];
      this.selectedRows = [];
      this.multiselectPopupVisible = false;
      this.filter = new FormControl('');
      this.toggleTableFilter = true;
      this.showTableFilter = true;
      this.filteredCustomOptions = [];
      this.options = injectedData.options;
      if (this.options.customOptions) {
        this.filteredCustomOptions = this.options.customOptions;
      }
    }
    ngOnInit() {
      super.initFormControl(this.value);
    }
    ngAfterContentChecked() {
      if (this.autoComplete && this.autoComplete._suggestions && this.genericValueTypes == null) {
        if (this.autoComplete._suggestions) {
          this.genericValueTypes = this.autoComplete._suggestions();
          this.setSelectedOptions(this.options.defaultValue);
        }
      }
    }
    onSelect(event) {
      let selectedElement = event.value;
      this.addSelectedElement(selectedElement);
    }
    addSelectedElement(selectedElement) {
      if (this.selectedOptions.find(selectedOption => selectedOption.id === selectedElement.id)) {
        this.notificationService.info(this.uiService.translate('genericSearch.alreadySelected', selectedElement.defaulttext), 'Info');
      } else {
        this.selectedOptions = [...this.selectedOptions, selectedElement];
      }
      this.formControl.setValue(this.selectedOptions.map(o => o.id).join(','), {
        emitEvent: false
      });
      this.autoComplete.inputEL.nativeElement.value = '';
    }
    deleteSelectedOption(index) {
      this.selectedOptions.splice(index, 1);
      this.selectedOptions = [...this.selectedOptions];
      this.formControl.setValue(this.selectedOptions.map(o => o.id).join(','), {
        emitEvent: false
      });
      if (this.selectedOptions.length === 0) {
        this.autoComplete.clear();
      }
    }
    deleteAllSelectedOptions() {
      this.selectedOptions = [];
      this.selectedRows = [];
      this.formControl.setValue(this.selectedOptions, {
        emitEvent: false
      });
    }
    updateConfiguration(entireFormConfig) {
      this.selectedOptions = [];
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        if (this.genericValueTypes) {
          this.setSelectedOptions(matchingConfig.defaultValue);
        }
      }
    }
    reset() {
      if (this.formGroup) {
        this.formControl.reset(this.defaultValue);
        this.selectedOptions = [...this.defaultValue];
      }
    }
    setSelectedOptions(defaultValue) {
      if (defaultValue != null && defaultValue !== undefined) {
        defaultValue.split(',').forEach(value => {
          if (this.genericValueTypes) {
            this.genericValueTypes.find(genericValue => {
              if (genericValue.id === Number.parseFloat(value)) {
                this.selectedOptions.push(genericValue);
              }
            });
          }
        });
      }
    }
    getControlValue() {
      return this.selectedOptions.map(selectedOption => selectedOption.id).join();
    }
    showMultiselectPopup() {
      this.selectedRows = this.selectedOptions ? this.selectedOptions.slice(0) : [];
      for (let selectedRow of this.selectedRows) {
        for (let element of this.filteredCustomOptions) {
          if (element.id === selectedRow.id) {
            this.filteredCustomOptions.splice(this.filteredCustomOptions.indexOf(element), 1, selectedRow);
          }
        }
      }
      this.calculateTotalNumberOfPages();
      this.multiselectPopupVisible = !this.multiselectPopupVisible;
    }
    hideMultiselectPopup() {
      this.multiselectPopupVisible = false;
    }
    submitSelection() {
      this.selectedOptions = [];
      for (let row of this.selectedRows) {
        this.addSelectedElement(row);
      }
    }
    toggleFilter() {
      this.toggleTableFilter = !this.toggleTableFilter;
      if (!this.toggleTableFilter) {
        this.filter.setValue('');
        this.onFilterTable();
      }
    }
    onFilterTable() {
      if (this.filter.value) {
        this.filteredCustomOptions = [];
        for (let element of this.options.customOptions) {
          if (element.defaulttext?.toUpperCase().indexOf(this.filter.value.toUpperCase()) > -1) {
            this.filteredCustomOptions = [...this.filteredCustomOptions, element];
          }
        }
        this.calculateTotalNumberOfPages();
      } else {
        this.filteredCustomOptions = this.options.customOptions;
        this.calculateTotalNumberOfPages();
      }
    }
    calculateTotalNumberOfPages() {
      if (this.maxTableRows && this.maxTableRows.value > 0 || this.maxTableRows.value > this.maxRows) {
        this.pageSize = +this.maxTableRows.value;
      }
      this.maxTableRows.setValue(this.pageSize);
      this.totalNumberOfPages = Math.ceil(this.filteredCustomOptions.length / this.pageSize);
    }
    onPage(event) {
      this.pageSize = +this.maxTableRows.value;
      this.firstResultRow = event.first;
      this.currentPageNumber = 1 + this.firstResultRow / this.pageSize;
    }
    static {
      this.ɵfac = function KeytableMultiSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KeytableMultiSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: KeytableMultiSelectComponent,
        selectors: [["ng-component"]],
        viewQuery: function KeytableMultiSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$l, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoComplete = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 30,
        vars: 34,
        consts: [["content", ""], ["selectTable", ""], ["inputElement", ""], [3, "label", "helptext"], ["field", "defaulttext", 3, "onSelect", "hisDdKey", "formControl", "hisEagerDataSource", "dropdown", "forceSelection"], ["appendTo", "body", "showEffect", "fade", 3, "visibleChange", "onHide", "visible", "responsive", "modal", "dismissableMask", "blockScroll", "focusTrap"], [1, "floatLeft"], [1, "tableFilterEditBlock"], [1, "clearerSpaceAboveHalfEm"], [3, "firstChange", "selectionChange", "onPage", "value", "paginator", "selectionPageOnly", "rows", "first", "selection"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "paginatorright"], ["type", "submit", "iconPos", "left", "hisImage", "TICK", 1, "button_highlighted", "marginRightStandard", 3, "click"], [2, "vertical-align", "middle"], ["type", "submit", "iconPos", "left", "hisImage", "RED_X", 1, "button_highlighted", "blue", 3, "click"], [1, "selectedOptionsList"], [1, "selectedOptionsListWithSelection"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton"], ["hisImage", "FILTER", 1, "transparent", "hideOnMobile", 3, "click"], [1, "multiSelectColumn"], [1, "hideOnBreakpointSmall", 3, "title"], [1, "hideOnBreakpointLarge"], [3, "pSortableColumn"], ["pInputText", "", "type", "text", 3, "keydown.enter", "click", "title", "formControl"], ["tabindex", "0", 3, "click", "value", "title", "ariaLabel"], [1, "tableRowCount"], ["for", "tableRow"], ["required", "", 1, "input_3_Chars", "tableRowInput", 3, "keydown.enter", "click", "formControl"], [3, "hisDdKey", "formControl", "value", "emptyMessage"], ["pTemplate", "listItem"], [1, "p-grid", "p-grid-nogutter"], [1, "selectedDataRow"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "title"], ["type", "submit", "hisImage", "PANEL_CLOSE", 1, "icon", "deleteSelectedOption", 3, "click", "title"], ["styleClass", "selectedDataContainer", 3, "hisDdKey", "formControl", "value", "emptyMessage"], ["type", "submit", "hisImage", "ARROW_RIGHT_FAT", "alt", "", 1, "transparent", "selectButton", 3, "click", "disabled"], ["type", "submit", "hisImage", "PANEL_CLOSE", "alt", "", 1, "transparent", "selectButton", 3, "click"]],
        template: function KeytableMultiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 3)(1, "p-autoComplete", 4, 0);
            i0.ɵɵlistener("onSelect", function KeytableMultiSelectComponent_Template_p_autoComplete_onSelect_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelect($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p-dialog", 5);
            i0.ɵɵtwoWayListener("visibleChange", function KeytableMultiSelectComponent_Template_p_dialog_visibleChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.multiselectPopupVisible, $event) || (ctx.multiselectPopupVisible = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onHide", function KeytableMultiSelectComponent_Template_p_dialog_onHide_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hideMultiselectPopup());
            });
            i0.ɵɵelementStart(4, "p-header")(5, "h2");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "div", 6);
            i0.ɵɵelementStart(9, "div", 7);
            i0.ɵɵtemplate(10, KeytableMultiSelectComponent_Conditional_10_Template, 6, 5, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "div", 8);
            i0.ɵɵelementStart(12, "p-table", 9, 1);
            i0.ɵɵtwoWayListener("firstChange", function KeytableMultiSelectComponent_Template_p_table_firstChange_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.firstResultRow, $event) || (ctx.firstResultRow = $event);
              return i0.ɵɵresetView($event);
            })("selectionChange", function KeytableMultiSelectComponent_Template_p_table_selectionChange_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedRows, $event) || (ctx.selectedRows = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onPage", function KeytableMultiSelectComponent_Template_p_table_onPage_12_listener($event) {
              i0.ɵɵrestoreView(_r1);
              const selectTable_r4 = i0.ɵɵreference(13);
              ctx.onPage($event);
              return i0.ɵɵresetView(selectTable_r4 == null ? null : selectTable_r4.el == null ? null : selectTable_r4.el.nativeElement == null ? null : selectTable_r4.el.nativeElement.scrollIntoView({
                block: "start",
                behavior: "smooth"
              }));
            });
            i0.ɵɵtemplate(14, KeytableMultiSelectComponent_ng_template_14_Template, 10, 9, "ng-template", 10)(15, KeytableMultiSelectComponent_ng_template_15_Template, 7, 8, "ng-template", 11)(16, KeytableMultiSelectComponent_ng_template_16_Template, 8, 7, "ng-template", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "p-footer")(18, "button", 13);
            i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Template_button_click_18_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.submitSelection();
              ctx.hideMultiselectPopup();
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelementStart(19, "span", 14);
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "button", 15);
            i0.ɵɵlistener("click", function KeytableMultiSelectComponent_Template_button_click_22_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.hideMultiselectPopup();
              return i0.ɵɵresetView($event.preventDefault());
            });
            i0.ɵɵelementStart(23, "span", 14);
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "hisUi");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(26, KeytableMultiSelectComponent_Conditional_26_Template, 2, 1, "ng-container", 16)(27, KeytableMultiSelectComponent_Conditional_27_Template, 2, 1, "ng-container", 17)(28, KeytableMultiSelectComponent_Conditional_28_Template, 6, 6, "button", 18)(29, KeytableMultiSelectComponent_Conditional_29_Template, 4, 3, "button", 19);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.filter)("hisEagerDataSource", ctx.options.typeAheadUrl)("dropdown", true)("forceSelection", true);
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("visible", ctx.multiselectPopupVisible);
            i0.ɵɵproperty("responsive", true)("modal", true)("dismissableMask", true)("blockScroll", true)("focusTrap", true);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 28, "multiselectPlam.selectValues"), " ", ctx.options.label, "");
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showTableFilter ? 10 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.filteredCustomOptions)("paginator", true)("selectionPageOnly", true)("rows", ctx.pageSize);
            i0.ɵɵtwoWayProperty("first", ctx.firstResultRow)("selection", ctx.selectedRows);
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 30, "genericSearch.returnSelected"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 32, "genericSearch.backToParentSearch"));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.options.customOptionsMethod ? 26 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.options.customOptionsMethod ? 27 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.options.customOptionsMethod ? 28 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.options.customOptionsMethod && ctx.selectedOptions && ctx.selectedOptions.length > 0 ? 29 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.FormControlDirective, i2$1.AutoComplete, i2.Header, i2.Footer, i2.PrimeTemplate, i2$3.DataView, i3.Dialog, i3$1.Table, i3$1.SortableColumn, i3$1.TableCheckbox, i3$1.TableHeaderCheckbox, i7$1.InputText, HisPlamComponent, HisImageDirective, HisDdDirective, HisDdValidator, HisAutoCompleteEagerDataSourceDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return KeytableMultiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisGenericValueService = /*#__PURE__*/(() => {
  class HisGenericValueService {
    constructor() {
      this.hisUiService = inject(HisUiService);
      this.backendService = inject(HisBackendService);
      this.booleanValues = null;
      this.booleanValues = new Array();
      this.booleanValues.push({
        id: 1,
        text: this.hisUiService.translate('de.his.javang.ja.lowercase')
      });
      this.booleanValues.push({
        id: 0,
        text: this.hisUiService.translate('de.his.javang.nein.lowercase')
      });
    }
    /**
     * @return an array containing GenericValues for 'yes' and 'no'
     */
    getBooleanTypes() {
      return this.booleanValues;
    }
    isValidBeanName(beanName) {
      return this.backendService.getData(`api/v1/cs/sys/values/check/${beanName}`).pipe(map$1(result => result === true));
    }
    /**
     * get all values/entries for given entity (key table values)
     *
     * @param entity of key table
     */
    getValueTypes(entity) {
      return this.backendService.getData(`api/v1/cs/sys/values/${entity}`);
    }
    /**
     * get values/entries by text of given entity (key table values)
     *
     * @param entity of key table
     * @param query search text
     */
    filterValueTypes(entity, query) {
      return this.backendService.getData(`api/v1/cs/sys/values/${entity}?q=${encodeURI(query)}`);
    }
    // TODO sgr: Sollten wir das nicht in eine andere Util-Klasse verlagern?
    // Das ist ja kein Service!?
    findRowByValue(array, value) {
      if (array) {
        let row = {};
        for (row of array) {
          if (row.id === value) {
            return row;
          }
        }
      }
      return null;
    }
    // TODO sgr: Sollten wir das nicht in eine andere Util-Klasse verlagern?
    // Das ist ja kein Service!?
    deleteRow(array, i) {
      let updatedArray = [];
      if (array) {
        let rowIndex = 0;
        for (let row of array) {
          if (rowIndex !== i) {
            updatedArray.push(row);
          }
          rowIndex++;
        }
      }
      return updatedArray;
    }
    static {
      this.ɵfac = function HisGenericValueService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisGenericValueService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisGenericValueService,
        factory: HisGenericValueService.ɵfac
      });
    }
  }
  return HisGenericValueService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YesNoSelectComponent = /*#__PURE__*/(() => {
  class YesNoSelectComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.genericValueService = inject(HisGenericValueService);
      this.valueChangeEvent = new EventEmitter();
      this.filteredBooleanTypes = [];
      this.options = injectedData.options;
    }
    ngOnInit() {
      this.booleanTypes = this.genericValueService.getBooleanTypes();
      console.log('yesno value =', this.value);
      this.selectedGenericValue = this.getGenericValue(this.value);
      console.log('yesno selectedGenericValue =', this.selectedGenericValue);
      super.initFormControl(this.selectedGenericValue);
      this.formControl.valueChanges.pipe(map(value => this.getStringValue(value)), tap(stringVal => this.setAndEmitNewStringValue(stringVal))).subscribe();
    }
    setAndEmitNewStringValue(value) {
      this.value = value;
      this.valueChangeEvent.emit(value === null ? null : value === '1');
    }
    getGenericValue(value) {
      if (value) {
        //assert.ok( value === '0' || value === '1' );
        // TODO falls equivalent, auskommentiertes assert und Import löschen
        if (value === '0' || value === '1') {
          return this.booleanTypes.find(type => type.id.toString() === value);
        } else {
          throw new Error('value ' + value + ' must be 0 or 1!');
        }
      } else {
        return null;
      }
    }
    /** completeMethod implementation boolean types */
    filterBooleanTypes(event) {
      this.filteredBooleanTypes = [];
      for (let booleanType of this.booleanTypes) {
        if (booleanType.text.toLowerCase().includes(event.query.toLowerCase())) {
          this.filteredBooleanTypes.push(booleanType);
        }
      }
    }
    getStringValue(genericValue) {
      return genericValue ? genericValue.id.toString() : null;
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null && matchingConfig.defaultValue) {
        console.log('--> updateConfiguration matchingConfig.defaultValue: ', matchingConfig.defaultValue);
        this.formControl.setValue(this.getGenericValue(matchingConfig.defaultValue), {
          emitEvent: false
        });
      }
    }
    getControlValue() {
      return this.value;
    }
    static {
      this.ɵfac = function YesNoSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || YesNoSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: YesNoSelectComponent,
        selectors: [["ng-component"]],
        outputs: {
          valueChangeEvent: "valueChangeEvent"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 8,
        consts: [["content", ""], [3, "label", "helptext", "showLabelTop"], ["field", "text", 3, "completeMethod", "hisDdKey", "formControl", "suggestions", "dropdown", "forceSelection"]],
        template: function YesNoSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "p-autoComplete", 2, 0);
            i0.ɵɵlistener("completeMethod", function YesNoSelectComponent_Template_p_autoComplete_completeMethod_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterBooleanTypes($event));
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext)("showLabelTop", ctx.options.showLabelTop);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl)("suggestions", ctx.filteredBooleanTypes)("dropdown", true)("forceSelection", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$1.AutoComplete, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective, HisButtonTitleDirective],
        encapsulation: 2
      });
    }
  }
  return YesNoSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FieldsAndSubscriptions {
  constructor() {
    this.content = [];
  }
  add(field, subscription) {
    let name = field.name;
    if (this.has(name)) {
      throw new Error('Tried to add second field with identical name \'' + name + '\' to ValueGroup');
    } else {
      let newFieldAndSubscription = new FieldAndSubscription(name, field, subscription);
      this.content.push(newFieldAndSubscription);
    }
  }
  resetDynamicForm() {
    this.content.forEach(item => item.field.reset());
  }
  updateAllFieldConfigs(entireFormConfig) {
    this.content.forEach(item => {
      item.field.updateConfiguration(entireFormConfig);
    });
  }
  has(name) {
    return !!this.findFirstByName(name);
  }
  // in some cases empty values must be transferred
  getJson(ignoreEmptyValues = true) {
    let params = {};
    this.content.forEach(item => {
      let value = item.field.getControlValue();
      if (value || value === 0 || !ignoreEmptyValues && value !== null && value !== undefined) {
        params[item.field.name] = value;
      }
    });
    return params;
  }
  findFirstByName(name) {
    return this.content.find(item => item.isNamed(name));
  }
  findFirstByType(type) {
    let fieldAndSub = this.content.find(item => item.field instanceof type);
    return fieldAndSub ? fieldAndSub.field : null;
  }
  remove(name) {
    let itemToRemove = this.findFirstByName(name);
    if (itemToRemove) {
      itemToRemove.subscription.unsubscribe();
      this.content = this.content.filter(item => item.name !== name);
    }
  }
  clear() {
    this.content.forEach(item => item.subscription.unsubscribe());
    this.content = [];
  }
}
class FieldAndSubscription {
  constructor(name, field, subscription) {
    this.name = name;
    this.field = field;
    this.subscription = subscription;
  }
  isNamed(name) {
    return this.name === name;
  }
}
class HisValueGroup {
  constructor(totalNumberOfFields) {
    this.totalNumberOfFields = totalNumberOfFields;
    this.fieldChangeSubject = new Subject();
    /**
     * Observable that emits name (identifier) of a dynamic field
     * in case of a value change on that field.
     */
    this.nameOfChangedField = this.fieldChangeSubject.asObservable();
    this.fieldsAndSubscriptions = new FieldsAndSubscriptions();
    this.currentNumberOfFields = 0;
    this.valueGroupReady = new EventEmitter();
  }
  resetDynamicForm() {
    this.fieldsAndSubscriptions.resetDynamicForm();
  }
  updateConfiguration(entireFormConfig) {
    this.fieldsAndSubscriptions.updateAllFieldConfigs(entireFormConfig);
  }
  /**
   * Allows a dynamic field component to register itself with a HisValueGroup.
   * Once all expected fields have registered, the container will emit
   * an event, signaling that it is ready to be used by other components
   *
   * @param dynamicField dynamic field component to be registered
   */
  registerDynamicField(dynamicField, valueChanges) {
    let name = dynamicField.name;
    let subscription = valueChanges.pipe(tap(_ => this.fieldChangeSubject.next(name))).subscribe();
    this.fieldsAndSubscriptions.add(dynamicField, subscription);
    this.currentNumberOfFields++;
    if (this.currentNumberOfFields === this.totalNumberOfFields) {
      this.valueGroupReady.emit(true);
    }
  }
  getFirstByType(type) {
    return this.fieldsAndSubscriptions.findFirstByType(type);
  }
  unregisterDynamicField(name) {
    this.fieldsAndSubscriptions.remove(name);
  }
  getJson(ignoreEmptyValues = true) {
    let params = this.fieldsAndSubscriptions.getJson(ignoreEmptyValues);
    return params;
  }
  dropDynamicFields() {
    this.fieldsAndSubscriptions.clear();
    this.currentNumberOfFields = 0;
  }
}
let FieldDirective = /*#__PURE__*/(() => {
  class FieldDirective {
    constructor() {
      this.viewContainerRef = inject(ViewContainerRef);
    }
    static {
      this.ɵfac = function FieldDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FieldDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: FieldDirective,
        selectors: [["", "hisDynamicFieldHost", ""]],
        standalone: false
      });
    }
  }
  return FieldDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputNotImplementedComponent = /*#__PURE__*/(() => {
  class InputNotImplementedComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    updateConfiguration(entireFormConfig) {}
    ngOnInit() {
      super.initFormControl(null);
    }
    getControlValue() {
      return this.formControl.value;
    }
    static {
      this.ɵfac = function InputNotImplementedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputNotImplementedComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: InputNotImplementedComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 4,
        consts: [["content", ""], [3, "label", "helptext"], ["pInputText", "", 3, "hisDdKey", "formControl"], ["color", "red"]],
        template: function InputNotImplementedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "input", 2, 0);
            i0.ɵɵelementStart(3, "font", 3)(4, "strong");
            i0.ɵɵtext(5, " This Type of input is not ready yet ");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hisDdKey", ctx.options.ddKey)("formControl", ctx.formControl);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlDirective, i7$1.InputText, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective],
        encapsulation: 2
      });
    }
  }
  return InputNotImplementedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The component registry manages the mapping of HisDynamicFieldTypes to Angular components.
 *
 * Non standard components can be added via the <code>register</code> method.
 */
let HisComponentRegistryService = /*#__PURE__*/(() => {
  class HisComponentRegistryService {
    constructor() {
      this.registry = new Map();
    }
    /**
     * returns a reference to the Angular component class which handles
     * the requested field type.
     *
     * @param hisDynamicFieldType HisDynamicFieldType to handle
     */
    getComponentClass(hisDynamicFieldType) {
      let component = this.registry.get(hisDynamicFieldType);
      if (!component) {
        component = InputNotImplementedComponent;
      }
      return component;
    }
    /**
     * registers a component for use in dynamic forms.
     *
     * @param hisDynamicFieldType HisDynamicFieldType to handle
     * @param component Angular component
     */
    register(hisDynamicFieldType, component) {
      this.registry.set(hisDynamicFieldType, component);
    }
    static {
      this.ɵfac = function HisComponentRegistryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisComponentRegistryService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisComponentRegistryService,
        factory: HisComponentRegistryService.ɵfac
      });
    }
  }
  return HisComponentRegistryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$k = ["newOldContainerRef"];
function OldNewFieldContainerComponent_ng_template_0_Template(rf, ctx) {}
let OldNewFieldContainerComponent = /*#__PURE__*/(() => {
  class OldNewFieldContainerComponent {
    constructor() {
      this.hisComponentRegistryService = inject(HisComponentRegistryService);
      this.hisUiService = inject(HisUiService);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      const injectedData = inject('injectedData');
      this.injectedDataOld = {
        ...injectedData,
        options: {
          ...injectedData.options
        }
      };
      this.injectedDataOld.options.label = this.getlabel(this.injectedDataOld, true);
      this.injectedDataOld.options.disabled = true;
      this.injectedDataOld.options.name += 'Old';
      this.injectedDataOld.options.defaultValue = this.injectedDataOld.options.oldValue;
      this.injectedDataNew = {
        ...injectedData,
        options: {
          ...injectedData.options
        }
      };
      this.injectedDataNew.options.label = this.getlabel(this.injectedDataNew, false);
    }
    ngOnInit() {
      let comp = this.hisComponentRegistryService.getComponentClass(this.injectedDataOld.options.controlType);
      const myInjectorOld = this.createInjectorOld();
      const myInjectorNew = this.createInjectorNew();
      this.vcr.createComponent(comp, {
        index: 0,
        injector: myInjectorNew
      });
      this.vcr.createComponent(comp, {
        index: 1,
        injector: myInjectorOld
      });
    }
    getlabel(data, oldVal) {
      let translatedLabeltextIdentifier = this.hisUiService.translate(this.getLabeltextIdentifier(data.options.ddKey));
      const label = data.options.label ? this.hisUiService.translate(data.options.label) : translatedLabeltextIdentifier ? translatedLabeltextIdentifier : this.hisUiService.translate(data.options.ddKey);
      const oldLabel = this.hisUiService.translate('I18nValue.old');
      const newLabel = this.hisUiService.translate('I18nValue.new');
      return label + (oldVal ? ` (${oldLabel})` : ` (${newLabel})`);
    }
    createInjectorOld() {
      return Injector.create({
        providers: [{
          provide: 'injectedData',
          useValue: this.injectedDataOld
        }]
      });
    }
    createInjectorNew() {
      return Injector.create({
        providers: [{
          provide: 'injectedData',
          useValue: this.injectedDataNew
        }]
      });
    }
    getLabeltextIdentifier(dDKey) {
      return this.hisBaseGlobalsService.getDd(dDKey)?.labeltextIdentifier;
    }
    static {
      this.ɵfac = function OldNewFieldContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OldNewFieldContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: OldNewFieldContainerComponent,
        selectors: [["ng-component"]],
        viewQuery: function OldNewFieldContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$k, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
          }
        },
        standalone: false,
        decls: 2,
        vars: 0,
        consts: [["newOldContainerRef", ""]],
        template: function OldNewFieldContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, OldNewFieldContainerComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
        },
        encapsulation: 2
      });
    }
  }
  return OldNewFieldContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisUrlUtils {
  /**
   * @returns the base url like http://localhost:8080/qisserver
   */
  static getBaseUrl() {
    let url = window.location.href;
    let ixd = url.indexOf('/a/');
    let baseUrl = url.substring(0, ixd);
    //expected url like http://localhost:8080/qisserver
    return baseUrl;
  }
  /**
   * Entfernt einen URL-Parameter aus der gegebenen url.
   * @param url die zu bearbeitende URL
   * @param param Der zu entfernende URL-Parameter, üblicherweise in der Form <key>=<value>
   * @return url ohne den param falls ursprünglich vorhanden, ansonsten die originale url
   */
  static removeUrlParam(url, param) {
    if (url.indexOf('&' + param) >= 0) {
      // param ist nicht der erste URL-Parameter.
      return url.replace('&' + param, '');
    }
    if (url.indexOf('?' + param + '&') >= 0) {
      // param ist der erste URL-Parameter, aber es gibt noch weitere. Das ? muss erhalten bleiben.
      return url.replace(param + '&', '');
    }
    if (url.indexOf('?' + param) >= 0) {
      // param ist der einzige URL-Parameter. Das ? kann dann ebenfalls weg.
      return url.replace('?' + param, '');
    }
    console.log('HisUrlUtils: url ' + url + ' does not contain url parameter ' + param + '. The url is returned unchanged.');
    return url;
  }
}
function HisDynamicFieldComponent_ng_template_0_Template(rf, ctx) {}
function HisDynamicFieldComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "a", 1);
    i0.ɵɵtext(2, "Link zum Ruleset-Editor");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r0.getLinkToPageRulesetEditor(), i0.ɵɵsanitizeUrl);
  }
}
let HisDynamicFieldComponent = /*#__PURE__*/(() => {
  class HisDynamicFieldComponent {
    constructor() {
      this.hisComponentRegistryService = inject(HisComponentRegistryService);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    get isValid() {
      return this.form.controls[this.dynamicFieldConfig.name].valid;
    }
    ngOnInit() {
      console.log('INIT ' + this.dynamicFieldConfig.name);
      this.loadComponent();
    }
    loadComponent() {
      const myInjector = this.createInjector();
      if (this.dynamicFieldConfig.useOldValue) {
        this.dynamicFieldHost.viewContainerRef.createComponent(OldNewFieldContainerComponent, {
          index: 0,
          injector: myInjector
        });
      } else {
        // Determine Component for input field type
        let comp = this.hisComponentRegistryService.getComponentClass(this.dynamicFieldConfig.controlType);
        // Use Component factory to create the Component instance and a Reference to it
        this.dynamicFieldHost.viewContainerRef.createComponent(comp, {
          index: 0,
          injector: myInjector
        });
      }
    }
    createInjector() {
      return Injector.create({
        providers: [{
          provide: 'injectedData',
          useValue: {
            formGroup: this.form,
            options: this.dynamicFieldConfig,
            valueGroup: this.valueGroup
          }
        }]
      });
    }
    // Mögliche URL-Params, root ist erforderlich
    //&root=fs.res.project.project.editComponentRoot
    //&tab=fs.res.common.dynamicContent.tab.dynamicFields
    //&fieldset=fs.res.project.Accounting
    //&field = ''
    //&anchorPosition=3
    //&sortorder=2
    getLinkToPageRulesetEditor() {
      let baseUrl = HisUrlUtils.getBaseUrl();
      let linktToRulesetEditor = '/a/cs.sys.adminutils.frontend/ruleseteditor';
      console.log('dynamicFieldConfig #dynamicFieldConfig', this.dynamicFieldConfig);
      console.log('dynamicFieldConfig #dynamicFieldConfig.children', this.dynamicFieldConfig.children);
      console.log('dynamicFieldConfig #valueGroup', this.valueGroup);
      console.log('dynamicFieldConfig #valueGroup.getJson()', this.valueGroup.getJson());
      console.log('dynamicFieldConfig #form', this.form);
      // let root =
      // let tab =
      // dynamic.fs.res.project.Accounting.accountingRecordSource
      // hier kann man nicht ddKey verwenden, es ist optional
      let field = this.dynamicFieldConfig.name;
      // let anchorPosition =
      // let sortorder =
      console.log('getLinkToPageRulesetEditor() #field', field);
      // fieldset kann man nicht ableiten aus dynamic.fs.res.project.Accounting.accountingRecordSource
      //let fieldset =
      return baseUrl + linktToRulesetEditor;
    }
    static {
      this.ɵfac = function HisDynamicFieldComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicFieldComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDynamicFieldComponent,
        selectors: [["his-dynamicfield"]],
        viewQuery: function HisDynamicFieldComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(FieldDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicFieldHost = _t.first);
          }
        },
        inputs: {
          dynamicFieldConfig: "dynamicFieldConfig",
          form: "form",
          valueGroup: "valueGroup"
        },
        standalone: false,
        decls: 2,
        vars: 1,
        consts: [["hisDynamicFieldHost", ""], [3, "href"]],
        template: function HisDynamicFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisDynamicFieldComponent_ng_template_0_Template, 0, 0, "ng-template", 0)(1, HisDynamicFieldComponent_Conditional_1_Template, 3, 1, "span");
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hisBaseGlobalsService.dataDictionaryEditMode ? 1 : -1);
          }
        },
        dependencies: [FieldDirective],
        encapsulation: 2
      });
    }
  }
  return HisDynamicFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDynamicContainerInnerComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "his-dynamicfield", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicFieldConfig", field_r1)("form", ctx_r1.form)("valueGroup", ctx_r1.valueGroup);
  }
}
let HisDynamicContainerInnerComponent = /*#__PURE__*/(() => {
  class HisDynamicContainerInnerComponent {
    /**
     * @deprecated
     * Will be deleted shortly. Use getJson instead.
     */
    etStringRepresentation() {
      return this.valueGroup.getJson();
    }
    getJson(ignoreEmptyValues = true) {
      return this.valueGroup.getJson(ignoreEmptyValues);
    }
    resetDynamicForm() {
      this.valueGroup.resetDynamicForm();
    }
    dropDynamicForms() {
      this.valueGroup.dropDynamicFields();
    }
    static {
      this.ɵfac = function HisDynamicContainerInnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicContainerInnerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDynamicContainerInnerComponent,
        selectors: [["his-dynamic-container-inner"]],
        inputs: {
          dynamicFieldConfig: "dynamicFieldConfig",
          valueGroup: "valueGroup",
          form: "form"
        },
        standalone: false,
        decls: 2,
        vars: 0,
        consts: [[1, "form-row"], [3, "dynamicFieldConfig", "form", "valueGroup"]],
        template: function HisDynamicContainerInnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, HisDynamicContainerInnerComponent_For_1_Template, 2, 3, "div", 0, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.dynamicFieldConfig.children);
          }
        },
        dependencies: [HisDynamicFieldComponent],
        encapsulation: 2
      });
    }
  }
  return HisDynamicContainerInnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDynamicContainerComponent = /*#__PURE__*/(() => {
  class HisDynamicContainerComponent {
    constructor() {
      this.readyToUse = new EventEmitter();
      this.form = new UntypedFormGroup({});
    }
    ngOnInit() {
      this.valueGroup = new HisValueGroup(this.dynamicFieldConfig.children.length);
      this.valueGroup.valueGroupReady.pipe(tap(_ => this.readyToUse.emit('HisDynamicContainerComponent is ready'))).subscribe();
    }
    updateConfiguration(entireFormConfig) {
      this.valueGroup.updateConfiguration(entireFormConfig);
    }
    /**
     * @deprecated
     * Will be deleted shortly. Use getJson instead.
     */
    getStringRepresentation() {
      return this.valueGroup.getJson();
    }
    getJson(ignoreEmptyValues = true) {
      return this.valueGroup.getJson(ignoreEmptyValues);
    }
    resetDynamicForm() {
      this.valueGroup.resetDynamicForm();
    }
    dropDynamicForms() {
      this.valueGroup.dropDynamicFields();
    }
    static {
      this.ɵfac = function HisDynamicContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDynamicContainerComponent,
        selectors: [["his-dynamic-container"]],
        inputs: {
          dynamicFieldConfig: "dynamicFieldConfig"
        },
        outputs: {
          readyToUse: "readyToUse"
        },
        standalone: false,
        decls: 1,
        vars: 3,
        consts: [[3, "dynamicFieldConfig", "form", "valueGroup"]],
        template: function HisDynamicContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "his-dynamic-container-inner", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("dynamicFieldConfig", ctx.dynamicFieldConfig)("form", ctx.form)("valueGroup", ctx.valueGroup);
          }
        },
        dependencies: [HisDynamicContainerInnerComponent],
        encapsulation: 2
      });
    }
  }
  return HisDynamicContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function FieldsetComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-panel", 0)(1, "his-dynamic-container", 1);
    i0.ɵɵlistener("readyToUse", function FieldsetComponent_Conditional_0_Template_his_dynamic_container_readyToUse_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.containerDone());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("header", ctx_r1.label);
    i0.ɵɵproperty("hisDdKey", ctx_r1.config.ddKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicFieldConfig", ctx_r1.config);
  }
}
let FieldsetComponent = /*#__PURE__*/(() => {
  class FieldsetComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      const hisUi = inject(HisUiService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.label = '';
      this.hbgs = hbgs;
      this.config = injectedData.options;
      this.label = hisUi.translate(this.config.label).replace(/\?\?\?/g, '');
      this.setPanelVisibilty();
    }
    containerDone() {
      this.changeDetectorRef.detectChanges();
      this.localFormGroup = this.dynamicContainerComponent.form;
      this.formGroup.registerControl(this.name, this.localFormGroup);
      this.valueGroup.registerDynamicField(this, this.localFormGroup.valueChanges);
    }
    reset() {
      this.dynamicContainerComponent.resetDynamicForm();
    }
    updateConfiguration(entireFormConfig) {
      this.setPanelVisibilty();
      this.dynamicContainerComponent.updateConfiguration(entireFormConfig);
    }
    getControlValue() {
      return this.dynamicContainerComponent.getJson();
    }
    setPanelVisibilty() {
      // check if p-panel has at least one visible child element
      let atLeastOneChildVisible = this.config.children.filter(child => {
        let dDEntry = this.hbgs.getDd(child.ddKey);
        console.log('HisDynamicFieldConfig has existing data dictionary entry: ', dDEntry);
        return dDEntry == null || !dDEntry.hidden;
      });
      this.isFieldSetVisible = atLeastOneChildVisible.length > 0 ? true : false;
    }
    static {
      this.ɵfac = function FieldsetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FieldsetComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: FieldsetComponent,
        selectors: [["ng-component"]],
        viewQuery: function FieldsetComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(HisDynamicContainerComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicContainerComponent = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "header", "hisDdKey"], [3, "readyToUse", "dynamicFieldConfig"]],
        template: function FieldsetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FieldsetComponent_Conditional_0_Template, 2, 3, "p-panel", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isFieldSetVisible ? 0 : -1);
          }
        },
        dependencies: [i4$1.Panel, HisDdDirective, HisDdValidator, HisButtonTitleDirective, HisPanelDirective, HisDynamicContainerComponent],
        encapsulation: 2
      });
    }
  }
  return FieldsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YesNoWithTextAreaComponent = /*#__PURE__*/(() => {
  class YesNoWithTextAreaComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      const hisUi = inject(HisUiService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.label = '';
      this.config = injectedData.options;
      this.label = hisUi.translate(this.config.label);
    }
    containerDone() {
      this.changeDetectorRef.detectChanges();
      this.localFormGroup = this.dynamicContainerComponent.form;
      this.formGroup.registerControl(this.name, this.localFormGroup);
      this.valueGroup.registerDynamicField(this, this.dynamicContainerComponent.valueGroup.nameOfChangedField);
      this.yesNo = this.dynamicContainerComponent.valueGroup.getFirstByType(YesNoSelectComponent);
      this.textArea = this.dynamicContainerComponent.valueGroup.getFirstByType(TextAreaComponent);
      this.yesNo.valueChangeEvent.pipe(tap(state => state == null ? this.textArea?.setRequired(false) : this.textArea?.setRequired(!state))).subscribe();
    }
    reset() {
      this.dynamicContainerComponent.resetDynamicForm();
    }
    updateConfiguration(entireFormConfig) {
      this.dynamicContainerComponent.updateConfiguration(entireFormConfig);
    }
    getControlValue() {
      return this.dynamicContainerComponent.getJson();
    }
    static {
      this.ɵfac = function YesNoWithTextAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || YesNoWithTextAreaComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: YesNoWithTextAreaComponent,
        selectors: [["ng-component"]],
        viewQuery: function YesNoWithTextAreaComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(HisDynamicContainerComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicContainerComponent = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "header", "hisDdKey"], [3, "readyToUse", "dynamicFieldConfig"]],
        template: function YesNoWithTextAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p-panel", 0)(1, "his-dynamic-container", 1);
            i0.ɵɵlistener("readyToUse", function YesNoWithTextAreaComponent_Template_his_dynamic_container_readyToUse_1_listener() {
              return ctx.containerDone();
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("header", ctx.label);
            i0.ɵɵproperty("hisDdKey", ctx.config.ddKey);
            i0.ɵɵadvance();
            i0.ɵɵproperty("dynamicFieldConfig", ctx.config);
          }
        },
        dependencies: [i4$1.Panel, HisDdDirective, HisDdValidator, HisButtonTitleDirective, HisPanelDirective, HisDynamicContainerComponent],
        encapsulation: 2
      });
    }
  }
  return YesNoWithTextAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Diese Klasse enthält alle Werte eines
 * generischen Eintrages in einer Schlüsseltabelle. */
class GenericValue {
  constructor(id, text, hiskeyId, shorttext, defaulttext, uniquename, longtext) {
    this.id = id;
    this.text = text;
    this.hiskeyId = hiskeyId;
    this.shorttext = shorttext;
    this.defaulttext = defaulttext;
    this.uniquename = uniquename;
    this.longtext = longtext;
  }
}
let HisChipsDirective = /*#__PURE__*/(() => {
  class HisChipsDirective {
    constructor() {
      this.chipsComponent = inject(Chips);
      this.parentPlamComponent = inject(HisPlamComponent);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.addOnSeparators = [',', ';'];
      this.chipsChange = new EventEmitter();
      this.COMMA = ',';
    }
    ngOnChanges(changes) {
      if (this.chips) {
        this.chipsComponent.value = this.chips.map(chip => chip.defaulttext);
      }
      if (this.parentPlamComponent && !this.hisBaseGlobalsService.getDd(this.hisDdKey)?.helptextIdentifier) {
        this.parentPlamComponent.helptext = 'cs.sys.common.chips.component.helptext';
      }
    }
    /**
     * host listener for paste-Event
     *
     * @param event ClipboardEvent to check if pasted text contains defined separator
     */
    onExtendedPaste(event) {
      if (this.addOnSeparators && this.addOnSeparators.length > 0) {
        let text = event.clipboardData.getData('Text');
        // replace all separators to COMMA ...
        this.addOnSeparators.forEach(s => {
          text = text.replace(s, this.COMMA);
        });
        // ... split by replaced comma
        text.split(this.COMMA).forEach(value => {
          this.addValue(event, value.trim());
        });
        event.preventDefault();
      }
    }
    /**
     * host listener for keydown-Event
     *
     * @param event KeyboardEvent relevant for keyCode 188 (Comma and Semicolon)
     */
    onExtendedKeyDown(event) {
      // add value, if KeyboardEvent key was one of the defined add separators
      if (this.addOnSeparators.indexOf(event.key) > -1) {
        this.addValue(event, document.getElementById(this.chipsComponent.inputId).value.trim());
        event.preventDefault();
      }
    }
    /**
     * add new value to model of <p-chips>-component
     *
     * @param value to add
     */
    addValue(event, value) {
      // cause with current PrimeNG Version 5.2.0 ViewChild is not defined to access inputField
      this.chipsComponent.addItem(event, value, false);
      // reset #inputtext value child element of chipsComponent
      document.getElementById(this.chipsComponent.inputId).value = '';
    }
    /* override of <p-chips> onAdd() to set chips as GenericValue */
    onExtendedAdd(event) {
      if (!this.chips) {
        this.chips = [];
      }
      this.chips.push(new GenericValue(null, null, null, null, event.value, null));
      this.chipsChange.emit(this.chips);
    }
    /* override of <p-chips> onRemove() to remove chip from chips - GenerivValue[] */
    onExtendedRemove(event) {
      if (this.chips) {
        let index = this.chips.findIndex(chip => {
          return chip.defaulttext === event.value;
        });
        this.chips.splice(index, 1);
      }
    }
    static {
      this.ɵfac = function HisChipsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisChipsDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisChipsDirective,
        selectors: [["p-chips"]],
        hostBindings: function HisChipsDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("paste", function HisChipsDirective_paste_HostBindingHandler($event) {
              return ctx.onExtendedPaste($event);
            })("keydown", function HisChipsDirective_keydown_HostBindingHandler($event) {
              return ctx.onExtendedKeyDown($event);
            })("onAdd", function HisChipsDirective_onAdd_HostBindingHandler($event) {
              return ctx.onExtendedAdd($event);
            })("onRemove", function HisChipsDirective_onRemove_HostBindingHandler($event) {
              return ctx.onExtendedRemove($event);
            });
          }
        },
        inputs: {
          chips: "chips",
          hisDdKey: "hisDdKey",
          addOnSeparators: "addOnSeparators"
        },
        outputs: {
          chipsChange: "chipsChange"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisChipsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChipsComponent = /*#__PURE__*/(() => {
  class ChipsComponent extends HisDynamicFieldBase {
    constructor() {
      const injectedData = inject('injectedData');
      const hbgs = inject(HisBaseGlobalsService);
      super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
      this.options = injectedData.options;
    }
    ngOnInit() {
      super.initFormControl(this.value?.length ? this.value.split(',') : []);
    }
    updateConfiguration(entireFormConfig) {
      let matchingConfig = this.searchFieldConfig(entireFormConfig);
      if (matchingConfig !== null) {
        this.formControl.setValue(matchingConfig.defaultValue?.length ? matchingConfig.defaultValue.split(',') : [], {
          emitEvent: false
        });
      }
    }
    getControlValue() {
      return this.formControl.value.join(',');
    }
    static {
      this.ɵfac = function ChipsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChipsComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: ChipsComponent,
        selectors: [["ng-component"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 8,
        consts: [["content", ""], [3, "label", "helptext"], ["separator", ",", 3, "formControl", "hisDdKey", "allowDuplicate", "addOnBlur"]],
        template: function ChipsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "his-plam", 1);
            i0.ɵɵelement(1, "p-chips", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.options.label)("helptext", ctx.options.helptext);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.options.disabled ? "hideInput" : "");
            i0.ɵɵproperty("formControl", ctx.formControl)("hisDdKey", ctx.options.ddKey)("allowDuplicate", false)("addOnBlur", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.FormControlDirective, i2$5.Chips, HisPlamComponent, HisDdDirective, HisDdValidator, HisChipsDirective, HisModificationDetectionDirective, HisButtonTitleDirective],
        styles: ["[_nghost-%COMP%]     .hideInput>div>ul>li>input{display:none}"]
      });
    }
  }
  return ChipsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The component registry manages the mapping of HisDynamicFieldTypes to Angular components.
 *
 * Non standard components can be added via the <code>register</code> method.
 */
let HisComponentRegistryServiceInitilizer = /*#__PURE__*/(() => {
  class HisComponentRegistryServiceInitilizer {
    constructor() {
      this.hisComponentRegistryService = inject(HisComponentRegistryService);
    }
    registerStandardComponents() {
      this.hisComponentRegistryService.register(HisDynamicFieldType.Text, TextComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.Select, SelectComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.KeytableSelect, KeytableSelectComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.KeytableMultiSelect, KeytableMultiSelectComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.Chips, ChipsComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.YesNoSelect, YesNoSelectComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.MultiSelect, MultiSelectComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.Label, LabelComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.Checkbox, CheckboxComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.Password, PasswordComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.DatePicker, DateComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.TextArea, TextAreaComponent);
      // register radiobutton, but overwrite with select, as it does not quite seem to work!?
      this.hisComponentRegistryService.register(HisDynamicFieldType.RadioButton, RadioButtonComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.RadioButton, SelectComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.Fieldset, FieldsetComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.YesNoWithTextArea, YesNoWithTextAreaComponent);
      this.hisComponentRegistryService.register(HisDynamicFieldType.DeclarationFieldset, YesNoWithTextAreaComponent);
    }
    static {
      this.ɵfac = function HisComponentRegistryServiceInitilizer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisComponentRegistryServiceInitilizer)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisComponentRegistryServiceInitilizer,
        factory: HisComponentRegistryServiceInitilizer.ɵfac
      });
    }
  }
  return HisComponentRegistryServiceInitilizer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * initializes a HIS Angular application.
 */
let HisBootstrapService = /*#__PURE__*/(() => {
  class HisBootstrapService {
    constructor() {
      this.hisCacheService = inject(HisCacheService);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisBackendService = inject(HisBackendService);
      this.hisUserProfileService = inject(HisUserProfileService);
      this.uiLoaded = false;
      this.ddLoaded = false;
    }
    resolve(route, state) {
      console.log('HisBootstrapService.resolve()');
      return this.boot();
    }
    /**
     * Starts the HISinOne Angular Application.
     *
     * @return a promise that returns true, when the user interface should start to render
     */
    boot() {
      // IMPORTANT: This code is executed before the user interface is rendered,
      //            therefore it should be as fast as possible. Please think twice
      //            before adding code here: Does it really need to run before
      //            the user interface starts rendering?
      if (this.promise) {
        return this.promise;
      }
      this.promise = new Promise(resolvePromise => {
        let globalProperties = this.readGlobalPropertiesFromHtml();
        this.hisBaseGlobalsService.setGlobalProperties(globalProperties);
        this.hisCacheService.setServerVersions(globalProperties.serverVersions);
        // get uitexts for the found language
        let url = 'api/v1/cs/sys/uitexts/' + globalProperties.user.language;
        let clientVersionKey = 'version:' + url;
        this.hisCacheService.getDataCachedByIndexedDB2(url, clientVersionKey, HisCacheService.UITEXTS_SERVER_VERSION_KEY).subscribe(ui => {
          if (Object.keys(ui).length !== 0) {
            this.hisBaseGlobalsService.setUi(ui);
            this.uiLoaded = true;
            this.checkDone(resolvePromise);
          }
        });
        this.hisBackendService.getData('api/v1/cs/sys/datadictionary/allContexts').subscribe(dd => {
          if (Object.keys(dd).length !== 0) {
            this.hisBaseGlobalsService.setDd(dd);
            this.ddLoaded = true;
            this.checkDone(resolvePromise);
          }
        });
        /**
         * UserProfile Enhancement #338030
         * Initially fetches the complete userprofile and caches it in a variable when page loads
         * to prevent multiple requests from individual components to backend.
         */
        this.hisUserProfileService.preloadUserProfile().subscribe(() => {});
      });
      return this.promise;
    }
    checkDone(resolvePromise) {
      if (this.uiLoaded && this.ddLoaded) {
        console.log('HisBootstrapService done');
        resolvePromise(true);
      }
    }
    readGlobalPropertiesFromHtml() {
      let element = document.getElementById('hisglobalproperties');
      if (!element) {
        console.warn('cannot retrieve global properties, the Angular extension seems not to be called from within HISinOne.');
        return {
          user: {
            language: 'de'
          }
        };
      }
      let json = element.textContent;
      return JSON.parse(json);
    }
    static {
      this.ɵfac = function HisBootstrapService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisBootstrapService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisBootstrapService,
        factory: HisBootstrapService.ɵfac
      });
    }
  }
  return HisBootstrapService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** eslint-disable @typescript-eslint/naming-convention */
function NotificationComponent_Conditional_10_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const msg_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(msg_r1);
  }
}
function NotificationComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "ul", 9);
    i0.ɵɵrepeaterCreate(2, NotificationComponent_Conditional_10_For_3_Template, 2, 1, "li", 10, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.notification.messages);
  }
}
function NotificationComponent_Conditional_11_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const msg_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(msg_r3);
  }
}
function NotificationComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵrepeaterCreate(1, NotificationComponent_Conditional_11_For_2_Template, 2, 1, "div", 10, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.notification.messages);
  }
}
let NotificationComponent = /*#__PURE__*/(() => {
  class NotificationComponent {
    constructor() {
      this.closed = new EventEmitter();
      this.animationDone = new EventEmitter();
      // eslint-disable-next-line @typescript-eslint/naming-convention
      this.NotificationType = NotificationType;
    }
    ngOnInit() {
      this.startTimeOut();
      setTimeout(() => {
        this.animationDone.emit(false);
      });
    }
    hideNotification() {
      this.closed.emit(this.notification);
      this.notification.state = 'hidden';
    }
    startTimeOut() {
      if (this.notification.timeOut && this.notification.state === 'new') {
        window.setTimeout(() => {
          console.log('timer');
          this.hideNotification();
        }, this.notification.timeOut);
      }
    }
    onAnimationEnd() {
      setTimeout(() => {
        this.animationDone.emit(true);
      });
    }
    // If the notification is present for the first time
    firstTime() {
      return this.notification.state === 'new';
    }
    /**
     * Listen to keyboard events and hide all notifications if "Escape" has been pressed.
     *
     * @param event pressed key event
     */
    handleKeyboardEvent(event) {
      event.stopPropagation();
      if (event.key === 'Escape') {
        console.log('close notification...');
        this.hideNotification();
      }
    }
    static {
      this.ɵfac = function NotificationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: NotificationComponent,
        selectors: [["his-simple-notification"]],
        hostBindings: function NotificationComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function NotificationComponent_keydown_HostBindingHandler($event) {
              return ctx.handleKeyboardEvent($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          notification: "notification"
        },
        outputs: {
          closed: "closed",
          animationDone: "animationDone"
        },
        standalone: false,
        decls: 19,
        vars: 18,
        consts: [["aria-live", "assertive", 1, "notification", "infobox", "warning_infobox", 3, "ngClass"], [1, "notification-header"], [1, "exclamationIcon", 3, "ngClass"], [1, "notificationHeaderText"], ["title", "Hinweis schlie\u00DFen", 1, "image", "infobox_close", 3, "click"], ["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", "fill", "#ffffff", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 1000 1000", 0, "xml", "space", "preserve"], ["d", "M638.6,500l322.7-322.7c38.3-38.3,38.3-100.3,0-138.6C923,0.4,861,0.4,822.7,38.7L500,361.4L177.3,38.7C139,0.4,77,0.4,38.7,38.7C0.4,77,0.4,139,38.7,177.3L361.4,500L38.7,822.7C0.4,861,0.4,923,38.7,961.3C57.9,980.4,82.9,990,108,990s50.1-9.6,69.3-28.7L500,638.6l322.7,322.7c19.1,19.1,44.2,28.7,69.3,28.7c25.1,0,50.1-9.6,69.3-28.7c38.3-38.3,38.3-100.3,0-138.6L638.6,500z"], [1, "notification-content"], [1, "closeButtonMessagesESC", 3, "click", "title"], [1, "notification-list"], [1, ""]],
        template: function NotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("@notificationTrigger.done", function NotificationComponent_Template_div_animation_notificationTrigger_done_0_listener() {
              return ctx.onAnimationEnd();
            });
            i0.ɵɵelementStart(1, "div", 1)(2, "h2");
            i0.ɵɵelement(3, "span", 2);
            i0.ɵɵelementStart(4, "span", 3);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵlistener("click", function NotificationComponent_Template_button_click_6_listener() {
              return ctx.hideNotification();
            });
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(7, "svg", 5)(8, "g");
            i0.ɵɵelement(9, "path", 6);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(10, NotificationComponent_Conditional_10_Template, 4, 0, "div", 7)(11, NotificationComponent_Conditional_11_Template, 3, 0, "div", 7);
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(12, "div")(13, "button", 8);
            i0.ɵɵpipe(14, "hisUi");
            i0.ɵɵpipe(15, "hisUi");
            i0.ɵɵlistener("click", function NotificationComponent_Template_button_click_13_listener() {
              return ctx.hideNotification();
            });
            i0.ɵɵelementStart(16, "span");
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "hisUi");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.NotificationType[ctx.notification.type])("@notificationTrigger", ctx.notification.state);
            i0.ɵɵattribute("data-maximum-severity", ctx.NotificationType[ctx.notification.type])("role", ctx.firstTime() ? "alert" : "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", ctx.NotificationType[ctx.notification.type]);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.notification.header);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.notification.messages.length >= 2 ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.notification.messages.length < 2 ? 11 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate2("title", "", i0.ɵɵpipeBind1(14, 12, "view.controls.clipboard_close"), " ", i0.ɵɵpipeBind1(15, 14, "messagebox.close.helptext"), "");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 16, "view.controls.clipboard_close_esc"));
          }
        },
        dependencies: [i1$2.NgClass, HisModificationDetectionDirective, HisFocusableButtonDirective, HisUiPipe],
        styles: [".notification[_ngcontent-%COMP%]{float:left;width:90%;margin:10px 5%;display:block;background:#fff;overflow:hidden;box-sizing:border-box;pointer-events:initial;color:#fff;padding:25px;border-radius:var(--popupRadius);position:relative}.notification[_ngcontent-%COMP%]{box-shadow:3px 3px 15px #aaa}.notification-header[_ngcontent-%COMP%], .notification-content[_ngcontent-%COMP%]{margin:0;padding:18px}.notification-header[_ngcontent-%COMP%]   .inlineicon[_ngcontent-%COMP%]{height:28px;width:28px;margin:0}.notification-content[_ngcontent-%COMP%]{padding-top:0}.notification.Error[_ngcontent-%COMP%], .notification.Error[_ngcontent-%COMP%]   .progressbar[_ngcontent-%COMP%]{background:var(--backgroundColor6)}.notification.Success[_ngcontent-%COMP%], .notification.Success[_ngcontent-%COMP%]   .progressbar[_ngcontent-%COMP%]{background:var(--backgroundColor13)}.notification.Info[_ngcontent-%COMP%], .notification.Info[_ngcontent-%COMP%]   .progressbar[_ngcontent-%COMP%]{background:var(--backgroundColor11)}.notification.Warning[_ngcontent-%COMP%], .notification.Warning[_ngcontent-%COMP%]   .progressbar[_ngcontent-%COMP%]{background:var(--backgroundColor7)}.exclamationIcon.Error[_ngcontent-%COMP%], .exclamationIcon.Success[_ngcontent-%COMP%], .exclamationIcon.Info[_ngcontent-%COMP%], .exclamationIcon.Warning[_ngcontent-%COMP%]{font-family:HISinOneIcons!important;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;font-size:120%}.exclamationIcon.Error[_ngcontent-%COMP%]:after{content:\"\\e93c\" / \"\"}.exclamationIcon.Info[_ngcontent-%COMP%]:after{content:\"\\e93c\" / \"\"}.exclamationIcon.Success[_ngcontent-%COMP%]:after{content:\"\\e93c\" / \"\"}.exclamationIcon.Warning[_ngcontent-%COMP%]:after{content:\"\\e93c\" / \"\"}.notification-header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.notification-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin:0;color:#fff!important;font-weight:700;font-size:18px;flex:1}.notification-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]   .notificationHeaderText[_ngcontent-%COMP%]{margin:0 0 0 5px}.notification-header[_ngcontent-%COMP%]   button.image[_ngcontent-%COMP%]{border:none!important;background:none!important;padding:0!important;margin:0!important;transition:transform .2s ease;color:#fff!important;fill:#fff!important}.notification-header[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{height:18px;width:18px;justify-content:end}.notification-content[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0;padding-left:18px}"],
        data: {
          animation: [trigger('notificationTrigger', [transition(':leave', [style({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'margin-top': '*',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'margin-bottom': '*',
            height: '*',
            opacity: '1',
            transform: 'translateX(0)'
          }), sequence([animate('.55s ease', style({
            height: '*',
            opacity: '0',
            transform: 'translateX(100%)'
          })), animate('.2s ease', style({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'margin-top': '0',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'margin-bottom': '0',
            height: '0',
            opacity: 0
          }))])]), transition('void => showagain', [style({
            visibility: 'visible',
            height: '0',
            opacity: 0,
            transform: 'translateX(100%)'
          }), sequence([
          // eslint-disable-next-line @typescript-eslint/naming-convention
          animate('0.2s ease', style({
            height: '*',
            'margin-top': '*',
            'margin-bottom': '*'
          })), animate('.35s ease', style({
            height: '*',
            opacity: 1,
            transform: 'translateX(0)'
          }))])]), transition('void => new', [style({
            height: '0',
            opacity: '0',
            transform: 'translateY(0%)'
          }), sequence([animate('0.2s ease', style({
            height: '*'
          })), animate('.35s ease', style({
            height: '*',
            opacity: 1,
            transform: 'translateY(0)'
          }))])])])]
        }
      });
    }
  }
  return NotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function NotificationsComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-simple-notification", 4);
    i0.ɵɵlistener("closed", function NotificationsComponent_For_3_Template_his_simple_notification_closed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showNotificationButton());
    })("animationDone", function NotificationsComponent_For_3_Template_his_simple_notification_animationDone_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAnimationStatus($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r3 = ctx.$implicit;
    i0.ɵɵproperty("@notificationTriggerParent", undefined)("notification", notification_r3);
  }
}
function NotificationsComponent_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("@notificationCounterTrigger", ctx_r1.countOfHiddenNotifications());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.countOfHiddenNotifications());
  }
}
function NotificationsComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 5);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function NotificationsComponent_Conditional_4_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showAll());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NotificationsComponent_Conditional_4_Conditional_3_Template, 3, 2, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@notificationButtonTrigger", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 3, "de.his.component.messages-infobox.restore.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isCounterVisible() ? 3 : -1);
  }
}
let NotificationsComponent = /*#__PURE__*/(() => {
  class NotificationsComponent {
    constructor() {
      this.notificationService = inject(HisNotificationService);
      this.router = inject(Router);
      this.notifications = new Array();
      this.isNotificationButtonActive = false;
      this.animationStatus = false;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      this.NotificationType = NotificationType;
      // delete all Notifications if the route changes?
      this.clearOnRouteChange = true;
      if (this.clearOnRouteChange) {
        // subscribe to ervery router event
        this.router.events.subscribe(event => {
          // if route changes remove all notifications
          if (this.isEventValid(event)) {
            this.removeAllNotifications();
          }
        });
      }
    }
    ngOnInit() {
      // subscribe to notifications
      this.notificationService.getNotification().subscribe(notification => {
        if (!notification) {
          // clear notfications when an empty notification is received
          this.notifications = [];
          return;
        }
        // add notification to array
        this.notifications.push(notification);
      });
    }
    onAnimationStatus(status) {
      this.animationStatus = status;
    }
    showNotificationButton() {
      this.isNotificationButtonActive = true;
    }
    hideNotificationButton() {
      this.isNotificationButtonActive = false;
    }
    // hide Notification on Screen and display the Button to show again
    hideNotification(notification) {
      notification.state = 'hidden';
      this.showNotificationButton();
    }
    // remove Notification completly
    removeNotification(notification) {
      this.notifications.splice(this.notifications.indexOf(notification), 1);
    }
    removeAllNotifications() {
      this.notificationService.clear();
      this.hideNotificationButton();
    }
    // get all Notifications, which are not hidden
    getNotifications() {
      return this.notifications.filter(notification => {
        return notification.state !== 'hidden';
      });
    }
    // show every notification (set all hidden notificatoins to 'showagain')
    showAll() {
      this.notifications.forEach(notification => {
        if (notification.state === 'hidden') {
          notification.state = 'showagain';
        }
      });
      this.hideNotificationButton();
    }
    // get the number of hidden Notifications
    countOfHiddenNotifications() {
      return this.notifications.filter(notification => {
        return notification.state === 'hidden';
      }).length;
    }
    // get the visibility state of the counter
    isCounterVisible() {
      return this.countOfHiddenNotifications() > 0;
    }
    // filter ScrollEvents
    isEventValid(event) {
      return !(event instanceof Scroll);
    }
    static {
      this.ɵfac = function NotificationsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: NotificationsComponent,
        selectors: [["his-notification"]],
        inputs: {
          clearOnRouteChange: "clearOnRouteChange"
        },
        standalone: false,
        decls: 5,
        vars: 2,
        consts: [[1, "notification-wrapper"], [1, "notifications"], [3, "notification"], [1, "notificationcenter-button-wrapper"], [3, "closed", "animationDone", "notification"], ["hisImage", "bell", 1, "notificationcenter-button", "icon", 3, "click", "title"], ["id", "notification-counter", 1, "notification-counter"]],
        template: function NotificationsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵrepeaterCreate(2, NotificationsComponent_For_3_Template, 1, 2, "his-simple-notification", 2, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, NotificationsComponent_Conditional_4_Template, 4, 5, "div", 3);
          }
          if (rf & 2) {
            i0.ɵɵattribute("animationEnd", ctx.animationStatus);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.getNotifications().reverse());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isNotificationButtonActive ? 4 : -1);
          }
        },
        dependencies: [NotificationComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisUiPipe],
        styles: [".notification-wrapper[_ngcontent-%COMP%]{position:fixed;right:0;top:80px;z-index:1300;width:500px;max-height:calc(100vh - 80px);overflow:hidden;overflow-y:auto}.notification-wrapper[_ngcontent-%COMP%]   .notifications[_ngcontent-%COMP%]{padding:0 70px 0 0}.notificationcenter-button-wrapper[_ngcontent-%COMP%]{position:fixed;top:100px;right:0;background:none;z-index:1000;transform:translate(47%);z-index:1300}.notificationcenter-button[_ngcontent-%COMP%]{width:60px;height:60px;padding:0 0 0 6px;margin:0;border:0;background:var(--backgroundColor7);border-radius:50%;overflow:hidden;transition:all .2s ease;border:1px solid #cccccc;pointer-events:initial;box-shadow:4px 4px 25px #aaa}.notificationcenter-button[_ngcontent-%COMP%]:hover, .notificationcenter-button[_ngcontent-%COMP%]:focus{transition:var(--highlightTransition)!important;background:var(--backgroundColor14)!important}.notificationcenter-button[_ngcontent-%COMP%]:hover, .notificationcenter-button[_ngcontent-%COMP%]:hover + .notification-counter[_ngcontent-%COMP%]{transform:translate(-4px);transition:all .2s ease}.notificationcenter-button[_ngcontent-%COMP%]:hover + .notification-counter[_ngcontent-%COMP%], .notificationcenter-button[_ngcontent-%COMP%]:focus + .notification-counter[_ngcontent-%COMP%]{transition:var(--highlightTransition);background:var(--backgroundColor14)}.notificationcenter-button[_ngcontent-%COMP%]:active{background:#f5e0a8;transition:all .2s ease}.notificationcenter-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:100%;height:100%}.notificationcenter-button-wrapper[_ngcontent-%COMP%]   .notification-counter[_ngcontent-%COMP%]{position:absolute;left:0;top:0;background:var(--backgroundColor7);width:18px;height:18px;border-radius:18px;border:2px solid #ffff;line-height:18px;text-align:center;z-index:1;backface-visibility:hidden;transition:all .2s ease}.notificationcenter-button-wrapper[_ngcontent-%COMP%]   .notification-counter[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff;line-height:16px;font-size:80%}.notificationcenter-button[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;top:50%;left:4%;height:25%;transform:translateY(-50%)}.notificationcenter-button-wrapper[_ngcontent-%COMP%] > button.notificationcenter-button[_ngcontent-%COMP%] > svg[_ngcontent-%COMP%] > g[_ngcontent-%COMP%] > g[_ngcontent-%COMP%] > path[_ngcontent-%COMP%]{fill:green!important}@media screen and (max-width : 40em){.notification-wrapper[_ngcontent-%COMP%]{width:100%}.notification-wrapper[_ngcontent-%COMP%]   .notifications[_ngcontent-%COMP%]{padding:0}}"],
        data: {
          animation: [trigger('notificationTriggerParent', [transition('* => *', [query('@*', animateChild(), {
            optional: true
          })])]), trigger('notificationButtonTrigger', [transition(':enter', [style({
            transform: 'translateX(100%)'
          }), animate('250ms 300ms cubic-bezier(0.175, 0.885, 0.32, 1.375)', style({
            transform: 'translateX(47%)'
          }))]), transition(':leave', [style({
            transform: 'translateX(47%)'
          }), animate('300ms ease', style({
            transform: 'translateX(100%)'
          }))])]), trigger('notificationCounterTrigger', [transition('* => *', [style({
            transform: 'scale(1)'
          }), sequence([animate('200ms 300ms ease', style({
            transform: 'scale(1.2)'
          })), animate('200ms ease', style({
            transform: 'scale(1)'
          }))])])])]
        }
      });
    }
  }
  return NotificationsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$j = ["*"];
function HisPageComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-page-option-panel");
  }
}
function HisPageComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "his-notification");
    i0.ɵɵtemplate(2, HisPageComponent_Conditional_0_Conditional_2_Template, 1, 0, "his-page-option-panel");
    i0.ɵɵelement(3, "his-breadcrumb");
    i0.ɵɵelementStart(4, "div", 1);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.hisBaseGlobalsService.system.hisDevelopmentMode || ctx_r0.hisBaseGlobalsService.system.operationMode === "cust" ? 2 : -1);
  }
}
/**
 * a HISinOne page frame with header and footer.
 */
let HisPageComponent = /*#__PURE__*/(() => {
  class HisPageComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisBootstrapService = inject(HisBootstrapService);
      this.hisComponentRegistryServiceInitilizer = inject(HisComponentRegistryServiceInitilizer);
      this.elementRef = inject(ElementRef);
      this.renderer = inject(Renderer2);
      this.httpStatus = inject(HTTPStatus);
      this.opened = false;
      this.menuButtonText = 'de.his.portal.navieinblenden';
    }
    ngOnInit() {
      console.log('HisPageComponent: booting...');
      this.booted = this.hisBootstrapService.boot();
      this.booted.then(() => {
        this.hisComponentRegistryServiceInitilizer.registerStandardComponents();
        this.isMobile = this.hisBaseGlobalsService.getCurrentDevice() === 'mobile';
      });
      this.setMenu(false);
      this.httpStatus.getHttpStatus().subscribe(loading => {
        if (!loading && !this.isMobile) {
          this.getFocusTitleElements();
        }
      });
    }
    ngDoCheck() {
      if (!this.isMobile) {
        this.getFocusTitleElements();
      }
    }
    getFocusTitleElements() {
      let all = this.elementRef.nativeElement.querySelectorAll('button, a:not(.p-tabview-nav-link, .p-menuitem-link), inlineicon:not(a *), .textTooltip, span[title], p-sorticon[title], p-treetablesorticon[title], p-autocomplete[title]');
      for (const element of all) {
        if (element.getAttribute('focusTitle') !== 'true') {
          element.addEventListener('keyup', this.onKeyup.bind(this));
          element.addEventListener('focusout', this.onFocusout.bind(this));
          element.addEventListener('focus', this.onFocus.bind(this));
          element.addEventListener('mouseenter', this.onMouseenter.bind(this));
          element.addEventListener('mouseleave', this.onMouseleave.bind(this));
          element.addEventListener('click', this.onClickElement.bind(this));
        }
        element.setAttribute('focusTitle', 'true');
      }
    }
    onScroll(event) {
      if (this.focusTitle != null) {
        this.renderer.removeChild(document.body, this.focusTitle);
        this.focusTitle = null;
      }
    }
    onClickElement(event) {
      let focusTooltips = document.querySelectorAll('.focusTooltip');
      if (focusTooltips.length > 0) {
        focusTooltips.forEach(focusTooltip => {
          this.renderer.removeChild(document.body, focusTooltip);
        });
      }
      if (event.clientX !== 0 && event.clientY !== 0) {
        let element = event.currentTarget; // From MDN: currentTarget always refers to the element to which the event handler has been attached, as opposed to Event.target, which identifies the element on which the event occurred and which may be its descendant. E.g. a <g> inside a svg in a button.         
        let newTitle = element.title;
        if (!newTitle || newTitle?.trim?.().length === 0) {
          if (element.getAttribute('data-title') && element.getAttribute('data-title').length !== 0) {
            newTitle = element.getAttribute('data-title');
          }
        }
        // check if element is treeTableToggler in dialog and bind listeners #312308
        if (this.isTreeTabelTogglerInDialog(element)) {
          this.rebindListenersInDialog();
        }
        // check if element still exists, needs timeout to wait for overlays to close or open for example
        // todo: find better solution
        setTimeout(() => {
          if (document.body.contains(element)) {
            // only need to update tooltip if mouse is still over the element
            if (this.isMouseover && newTitle && newTitle.trim?.().length !== 0) {
              this.setCustomTooltip(event, element, newTitle);
            }
          }
        }, 200);
      } else {
        // event.clientX or Y might be zero if treetable is in dialog and navigated by tabs #312308
        // make sure event.target is treeTableToggler in dialog and bind listeners
        if (this.isTreeTabelTogglerInDialog(event.target)) {
          this.rebindListenersInDialog();
        }
      }
    }
    onMouseenter(event) {
      this.isMouseover = true;
      let element = event.target;
      this.title = element.title;
      if (this.title.trim().length !== 0) {
        this.setCustomTooltip(event, element);
      }
    }
    onMouseleave(event) {
      this.isMouseover = false;
      let element = event.target;
      if (element.getAttribute('data-title') && element.getAttribute('data-title').length !== 0) {
        this.renderer.setAttribute(element, 'title', element.getAttribute('data-title'));
        this.renderer.removeAttribute(element, 'data-title');
      }
      let focusTooltips = document.querySelectorAll('.focusTooltip');
      focusTooltips.forEach(focusTooltip => {
        this.renderer.removeChild(document.body, focusTooltip);
      });
      clearTimeout(this.timeout);
    }
    onKeyup(event) {
      const code = event.keyCode || event.which;
      const element = event.target;
      const title = element.title;
      if (code === 27) {
        if (title && title.length !== 0) {
          if (this.focusTitle != null) {
            this.renderer.removeChild(document.body, this.focusTitle);
            this.focusTitle = null;
            window.removeEventListener('scroll', this.onScroll.bind(this));
          }
        }
      } else if (code === 13 || code === 32) {
        if (/Edg/.test(navigator.userAgent)) {
          console.log('no focus tooltip for edge');
          return;
        }
        // necessary for p-panel for example #312308
        if (title && title.length !== 0) {
          this.setCustomTooltip(event, element, title);
          window.removeEventListener('scroll', this.onScroll.bind(this));
        }
      }
    }
    onFocus(event) {
      if (/Edg/.test(navigator.userAgent)) {
        console.log('no focus tooltip for edge');
        return;
      }
      //treeTable fix for #312308
      const element = event.target;
      if (element.title && element.title.length !== 0) {
        this.setCustomTooltip(event, element, element.title, true);
        window.removeEventListener('scroll', this.onScroll.bind(this));
      }
    }
    onFocusout(event) {
      const element = event.target;
      // check for mouseover, fix for #323758#c2
      if (this.focusTitle != null && !this.isMouseover) {
        // re-add title attribute, fix for #312308
        if (element.title.length === 0 && element.getAttribute('data-title') && element.getAttribute('data-title').length !== 0) {
          this.renderer.setAttribute(element, 'title', element.getAttribute('data-title'));
          this.renderer.removeAttribute(element, 'data-title');
        }
        // remove all currently open tooltips 
        let focusTooltips = document.querySelectorAll('.focusTooltip');
        focusTooltips.forEach(focusTooltip => {
          this.renderer.removeChild(document.body, focusTooltip);
        });
        this.focusTitle = null;
        window.removeEventListener('scroll', this.onScroll.bind(this));
      }
    }
    setCustomTooltip(event, element, newTitle, keepTitle) {
      // remove all currently open tooltips before set new one
      let focusTooltips = document.querySelectorAll('.focusTooltip');
      focusTooltips.forEach(focusTooltip => {
        this.renderer.removeChild(document.body, focusTooltip);
      });
      // remove title attr to prevent opening browser tooltip, but keep it for seleniumtests and onFocus (fix for #318853)
      if (this.isMouseover && keepTitle != true && navigator.webdriver != true) this.renderer.removeAttribute(element, 'title');
      this.focusTitle = this.renderer.createElement('div');
      let text = this.renderer.createText(this.title);
      if (newTitle) {
        text = this.renderer.createText(newTitle);
        this.title = newTitle;
      }
      // fallback for navigation with tabs to be able to re-add the title after on focus out
      this.renderer.setAttribute(element, 'data-title', this.title);
      this.renderer.appendChild(document.body, this.focusTitle);
      this.renderer.appendChild(this.focusTitle, text);
      this.renderer.addClass(this.focusTitle, 'focusTooltip');
      const rect = element.getBoundingClientRect();
      this.renderer.setStyle(this.focusTitle, 'left', (event.clientX || rect.left) + 'px');
      this.renderer.setStyle(this.focusTitle, 'top', rect.top + element.offsetHeight + 'px');
      if (rect.bottom + this.focusTitle.offsetHeight + element.offsetHeight > (window.innerHeight || document.documentElement.clientHeight)) {
        this.renderer.setStyle(this.focusTitle, 'top', rect.top - this.focusTitle.offsetHeight + 'px');
      }
      const rightPosition = this.focusTitle.offsetWidth + rect.left;
      const winWidth = window.innerWidth;
      const newLeftPosition = rect.left - (rightPosition - winWidth) - 20;
      if (rightPosition >= winWidth) {
        this.renderer.setStyle(this.focusTitle, 'left', newLeftPosition + 'px');
      }
    }
    toggleSidebar() {
      this.setMenu(!this.opened);
    }
    setMenu(status) {
      if (status) {
        this.opened = true;
        this.menuButtonText = 'de.his.portal.naviausblenden';
      } else {
        this.opened = false;
        this.menuButtonText = 'de.his.portal.navieinblenden';
      }
    }
    // fix for treeTables in p-dialog #312308
    isTreeTabelTogglerInDialog(clickedElement) {
      const curElement = clickedElement;
      if (!curElement || !curElement.parentElement) return false;
      const treetabletogglerElement = curElement.parentElement;
      return !!(curElement && curElement.classList.contains('p-treetable-toggler') && treetabletogglerElement && treetabletogglerElement.tagName === 'P-TREETABLETOGGLER' && treetabletogglerElement.parentElement && treetabletogglerElement.parentElement.classList.contains('treeTableTogglerContainer--inDialog'));
    }
    // fix for treeTables in p-dialog #312308
    rebindListenersInDialog() {
      const dialog = document.querySelector('.p-dialog-content');
      if (!dialog) return;
      let all = dialog.querySelectorAll('button, a:not(.p-tabview-nav-link, .p-menuitem-link), inlineicon:not(a *), .textTooltip, span[title], p-sorticon[title], p-treetablesorticon[title]');
      all.forEach(element => {
        if (element.getAttribute('focusTitle') !== 'true') {
          element.addEventListener('keyup', this.onKeyup.bind(this));
          element.addEventListener('focusout', this.onFocusout.bind(this));
          element.addEventListener('focus', this.onFocus.bind(this));
          element.addEventListener('mouseenter', this.onMouseenter.bind(this));
          element.addEventListener('mouseleave', this.onMouseleave.bind(this));
          element.addEventListener('click', this.onClickElement.bind(this));
        }
        element.setAttribute('focusTitle', 'true');
      });
    }
    static {
      this.ɵfac = function HisPageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisPageComponent,
        selectors: [["his-page"]],
        standalone: false,
        ngContentSelectors: _c0$j,
        decls: 3,
        vars: 3,
        consts: [[1, "xhisng_wrapper"], [1, "maincontent"]],
        template: function HisPageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HisPageComponent_Conditional_0_Template, 6, 1, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "his-httplistener");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.booted) ? 0 : -1);
          }
        },
        dependencies: [HisPageOptionPanelComponent, HisBreadcrumbComponent, NotificationsComponent, HisHttplistenerComponent, i1$2.AsyncPipe],
        styles: [".maincontent[_ngcontent-%COMP%]{width:100%}"]
      });
    }
  }
  return HisPageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisTableConfigComponent_For_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "his-plam", 9);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "input", 8, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisTableConfigComponent_For_23_Template_input_ngModelChange_3_listener($event) {
      const col_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      i0.ɵɵtwoWayBindingSet(col_r3.checked, $event) || (col_r3.checked = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const col_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 2, col_r3.title));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", col_r3.checked);
  }
}
let HisTableConfigComponent = /*#__PURE__*/(() => {
  class HisTableConfigComponent {
    constructor() {
      this.notificationService = inject(HisNotificationService);
      this.uiService = inject(HisUiService);
      // Auswahl aller Spalten und die Spalten, welche ein-/ausgeblendet werden können sollen (Müssen zwei verschiedene Listen sein)
      this.selectableColumns = [];
      this.configuratedColumns = [];
      this.originalSelectedColumns = [];
      this.showEditTableDialog = false;
      this.saved = new EventEmitter();
    }
    ngOnInit() {
      for (let col of this.configuratedColumns) {
        col.checked = true;
      }
      this.reorderableModel = this.reorderable;
    }
    showTableConfigDialog() {
      this.originalSelectedColumns = _.cloneDeep(this.selectableColumns);
      this.showEditTableDialog = true;
    }
    applyTableConfig() {
      this.notificationService.clear();
      this.selectionChange();
      if (this.configuratedColumns.length > 0) {
        this.reorderable = this.reorderableModel;
        this.saved.emit(new HisTableConfigResults(this.configuratedColumns, this.reorderable));
        this.hideEditTableDialog();
      } else {
        this.notificationService.error(this.uiService.translate('select.one.column'), this.uiService.translate('view.messages.error'));
        return;
      }
    }
    selectionChange() {
      for (let col of this.selectableColumns) {
        if (!col.checked) {
          let uncheckedColumn = this.configuratedColumns.find(configurationColumn => configurationColumn.title === col.title);
          if (uncheckedColumn) {
            this.configuratedColumns = this.configuratedColumns.filter(column => column.title !== col.title);
          }
        } else if (col.checked && !this.configuratedColumns.find(column => column.title === col.title)) {
          let indexOfCheckedItem = this.selectableColumns.indexOf(col);
          for (let i = indexOfCheckedItem; i < this.selectableColumns.length - 1; i++) {
            let successor = this.selectableColumns[indexOfCheckedItem + i];
            if (!successor) {
              successor = this.selectableColumns[this.selectableColumns.length - 1];
            }
            if (this.configuratedColumns.find(configuratedSuccessor => configuratedSuccessor.title === successor.title)) {
              this.configuratedColumns.splice(this.configuratedColumns.indexOf(successor), 0, col);
              break;
            } else {
              this.configuratedColumns.splice(indexOfCheckedItem, 0, col);
              break;
            }
          }
          if (indexOfCheckedItem === this.selectableColumns.length - 1) {
            this.configuratedColumns.push(col);
          }
        }
      }
    }
    cancel() {
      this.selectableColumns = _.cloneDeep(this.originalSelectedColumns);
      this.reorderableModel = this.reorderable;
    }
    hideEditTableDialog() {
      this.showEditTableDialog = false;
    }
    static {
      this.ɵfac = function HisTableConfigComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTableConfigComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTableConfigComponent,
        selectors: [["his-table-config"]],
        inputs: {
          reorderable: "reorderable",
          selectableColumns: "selectableColumns",
          configuratedColumns: "configuratedColumns"
        },
        outputs: {
          saved: "saved"
        },
        standalone: false,
        decls: 31,
        vars: 30,
        consts: [["content", ""], [1, "hideOnMobile"], ["hisImage", "brush", 1, "floatRight", "transparent", 3, "click"], ["styleClass", "fieldsetBgYellow", 3, "visibleChange", "onHide", "responsive", "modal", "blockScroll", "closable", "visible"], ["type", "button", 3, "click"], [1, "columnHalf"], [3, "header"], [1, "reorderableColumnsPanel", 3, "label"], ["type", "checkbox", "binary", "true", 3, "ngModelChange", "ngModel"], [1, "columnSelectPanel", 3, "label"]],
        template: function HisTableConfigComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "span", 1)(1, "button", 2);
            i0.ɵɵlistener("click", function HisTableConfigComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showTableConfigDialog());
            });
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "p-dialog", 3);
            i0.ɵɵtwoWayListener("visibleChange", function HisTableConfigComponent_Template_p_dialog_visibleChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.showEditTableDialog, $event) || (ctx.showEditTableDialog = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onHide", function HisTableConfigComponent_Template_p_dialog_onHide_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hideEditTableDialog());
            });
            i0.ɵɵelementStart(6, "p-header")(7, "h2");
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div")(11, "button", 4);
            i0.ɵɵlistener("click", function HisTableConfigComponent_Template_button_click_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.applyTableConfig());
            });
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "button", 4);
            i0.ɵɵlistener("click", function HisTableConfigComponent_Template_button_click_14_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.hideEditTableDialog();
              return i0.ɵɵresetView(ctx.cancel());
            });
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 5)(18, "p-panel", 6);
            i0.ɵɵpipe(19, "hisUi");
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "hisUi");
            i0.ɵɵrepeaterCreate(22, HisTableConfigComponent_For_23_Template, 5, 4, "div", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "div", 5)(25, "p-panel", 6);
            i0.ɵɵpipe(26, "hisUi");
            i0.ɵɵelementStart(27, "his-plam", 7);
            i0.ɵɵpipe(28, "hisUi");
            i0.ɵɵelementStart(29, "input", 8, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisTableConfigComponent_Template_input_ngModelChange_29_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.reorderableModel, $event) || (ctx.reorderableModel = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 14, "de.his.javang.edit.table"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("responsive", true)("modal", true)("blockScroll", true)("closable", false);
            i0.ɵɵtwoWayProperty("visible", ctx.showEditTableDialog);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 16, "tableConfig.title"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 18, "common.apply"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 20, "common.cancel"));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(19, 22, "tableConfig.chooseColumns"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 24, "tableConfig.chooseColumnsSubtitle"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.selectableColumns);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(26, 26, "tableConfig.columnMove"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(28, 28, "tableConfig.columnMoveBtns"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.reorderableModel);
          }
        },
        dependencies: [i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.Header, i3.Dialog, i4$1.Panel, HisPlamComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisPanelDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisTableConfigComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisTableConfigResults {
  constructor(columResults, isReorderable) {
    this.columResults = columResults;
    this.isReorderable = isReorderable;
  }
}

/**
 * Easy way to load a key table into an p-autoComplete component.
 * Also sets default values for p-autoComplete that are universally used in H1.
 */
let HisAutoCompleteLazyDataSourceDirective = /*#__PURE__*/(() => {
  class HisAutoCompleteLazyDataSourceDirective extends HisAutoCompleteDefaults {
    constructor() {
      super(...arguments);
      this.backendService = inject(HisBackendService);
      this.autoCompleteRef = inject(AutoComplete, {
        host: true
      });
      this.dropdown = false;
    }
    ngAfterContentInit() {
      this.initDefaults(this.autoCompleteRef);
      this.autoCompleteRef.dropdown = this.dropdown;
      // make name of data source available to debug panel
      // (needs some trickery to convince the compiler that AutoComplete has a field hisDataSource)
      this.autoCompleteRef.hisDataSource = this.dataSource;
    }
    // filter the list of objects on the server based on user input in text field
    filterValue(event) {
      let query = event.query;
      this.filterValueTypes(query).subscribe(data => {
        this.refreshSuggestions(data);
      });
    }
    filterValueTypes(query) {
      let resultTypes = this.backendService.getData(this.expandBackendUrl(this.dataSource) + '?q=' + encodeURI(query));
      return resultTypes;
    }
    refreshSuggestions(suggestions) {
      this.autoCompleteRef.suggestions = suggestions;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisAutoCompleteLazyDataSourceDirective_BaseFactory;
        return function HisAutoCompleteLazyDataSourceDirective_Factory(__ngFactoryType__) {
          return (ɵHisAutoCompleteLazyDataSourceDirective_BaseFactory || (ɵHisAutoCompleteLazyDataSourceDirective_BaseFactory = i0.ɵɵgetInheritedFactory(HisAutoCompleteLazyDataSourceDirective)))(__ngFactoryType__ || HisAutoCompleteLazyDataSourceDirective);
        };
      })();
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisAutoCompleteLazyDataSourceDirective,
        selectors: [["p-autoComplete", "hisLazyDataSource", ""]],
        hostBindings: function HisAutoCompleteLazyDataSourceDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("completeMethod", function HisAutoCompleteLazyDataSourceDirective_completeMethod_HostBindingHandler($event) {
              return ctx.filterValue($event);
            });
          }
        },
        inputs: {
          dataSource: [0, "hisLazyDataSource", "dataSource"],
          dropdown: "dropdown"
        },
        exportAs: ["hisLazyDataSource"],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return HisAutoCompleteLazyDataSourceDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisUploadFile {
  constructor() {
    this.downloadUrl = '';
  }
}
class FilesChangedEvent {
  constructor(oldFiles, newFiles) {
    this.oldFiles = oldFiles;
    this.newFiles = newFiles;
  }
}
class FilesMutatedEvent {
  constructor(file, newFiles) {
    this.file = file;
    this.newFiles = newFiles;
  }
}
class UploadFieldConfigResponse {}
class UploadFieldRequest {}
let HisFileUploadService = /*#__PURE__*/(() => {
  class HisFileUploadService {
    constructor() {
      this.backendService = inject(HisBackendService);
      this.ongoingFeedbackRequests = new Map();
    }
    getUploadFieldConfig(configKey, javascriptcontext, contextobject) {
      let request = new UploadFieldRequest();
      request.configKey = configKey;
      request.javascriptContext = javascriptcontext;
      request.contextObject = contextobject;
      return this.backendService.postData('api/v1/cs/sys/fileupload/getUploadFieldConfig', request).pipe(map(this.transformToInternalModel));
    }
    transformToInternalModel(data) {
      if (!data) {
        return null;
      }
      let result = new UploadFieldConfigResponse();
      result.allowComment = data.allowComment;
      result.configKey = data.configKey;
      result.documentMetadataCategoryIds = data.documentMetadataCategoryIds;
      result.fileLimit = data.fileLimit;
      result.helptextAbove = data.helptextAbove;
      result.helptextBelow = data.helptextBelow;
      result.helptextIcon = data.helptextIcon;
      result.label = data.label;
      result.multipleUpload = data.multipleUpload;
      result.readonly = data.readonly;
      result.required = data.required;
      result.showCategoryIfUnique = data.showCategoryIfUnique;
      result.sizeLimit = data.sizeLimit;
      result.css = data.css;
      let allowedExtensions = [...(data.allowedExtensions || [])].map(s => {
        if (!s || s.startsWith('.')) {
          return s;
        }
        return '.' + s;
      });
      const separator = ', ';
      result.accept = [...(data.allowedContentTypes || []), allowedExtensions].join(separator);
      return result;
    }
    getUploadFiles(files) {
      if (!files) {
        return of([]);
      }
      if (files && files.length === 0) {
        return of([]);
      }
      // Vorsicht: ein Array von Observables, für jedes uploadFile eines: [Obs1<HisUploadFile>, Obs2<HisUploadFile>]
      // let constArray: Observable<HisUploadFile>[] = [];
      let fileObservables = files.map(this.fileToHisUploadFile);
      const filesArrayObservable = forkJoin(fileObservables);
      return filesArrayObservable.pipe(last());
    }
    fileToHisUploadFile(file) {
      let reader = new FileReader();
      let obs = new BehaviorSubject(null);
      reader.onload = () => {
        // You'll get the base64 string here
        let uploadFile = new HisUploadFile();
        uploadFile.uuid = v4();
        // Das Problem ist, dass wenn wir des Bytearray von HisResource nach HisFileUpload übertragen,
        // wird nur das Byte-Array übertragen, ohne den Header.
        // Dadurch bekommen wir eine Inkonsistenz.
        // Lösung: wir halten HisUploadFile.base64 auch ohne Header.
        // Zum Anzeigen und Herunterladen rufen wir HisUploadFile.dataUrl auf.
        let readerResult = reader.result;
        let [, base64Data] = readerResult.split(',');
        uploadFile.base64 = base64Data;
        uploadFile.name = file.name;
        uploadFile.lastModified = file.lastModified ? file.lastModified.toString() : null;
        uploadFile.contentType = file.type;
        obs.next(uploadFile);
        obs.complete();
      };
      reader.onerror = error => {
        console.log('Error reading file :', error);
      };
      reader.readAsDataURL(file);
      return obs;
    }
    getUploadFieldInstances(configKey, javascriptcontext, contextobject) {
      let request = new UploadFieldRequest();
      request.configKey = configKey;
      request.javascriptContext = javascriptcontext;
      request.contextObject = contextobject;
      return this.backendService.postData('api/v1/cs/sys/fileupload/getUploadFieldInstances', request);
    }
    getIsMaxUploadsReached(multiple, fileLimit, model) {
      if (!model) {
        return false;
      }
      if (multiple && !fileLimit) {
        return false;
      }
      if (multiple && fileLimit && model.length >= fileLimit) {
        return true;
      }
      if (!multiple && model.length >= 1) {
        return true;
      }
      return false;
    }
    /**
     * @param currentFiles
     * @param configuration
     * @param model
     */
    limitNumberOfFilesToTheConfuguredFileLimit(currentFiles, configuration, model) {
      let uploadedFiles = [];
      if (!currentFiles || !configuration || !model) {
        return uploadedFiles;
      }
      if (configuration.getFileLimit()) {
        // wenn es ein FileLimit gibt und wenn die gerade hochgeladenen Files (z. B. 3 Files auf einmal)
        // größer als das FileLimit sind
        // oder wenn model plus currentFiles größer als das FileLimit sind
        const currentFilesExceedFileLimit = Array.from(currentFiles).length > configuration.getFileLimit();
        const totalNumberOfFilesExceedFileLimit = model.length + currentFiles.length;
        if (currentFilesExceedFileLimit || totalNumberOfFilesExceedFileLimit) {
          // Frage: könnte man mit fileLimit an p-uploadFiles diesen Fall verhindern? Nein
          // In JSF wird das letzte, also überzählige File abgeschnitten.
          // Es gibt keine Fehlermeldung. Die Eingabemöglichkt verschwindet.
          // Die files rutschen nach oben, es sieht so aus als würde die ganze Komponente ausgebledet werden.
          // wir nicht gerendert, wenn cc.maxUploadsReached
          const max = configuration.getFileLimit() - model.length;
          uploadedFiles = Array.from(currentFiles).splice(0, max);
          return uploadedFiles;
        }
      }
      uploadedFiles = Array.from(currentFiles);
      return uploadedFiles;
    }
    getDownloadUrl(uploadFile) {
      if (!uploadFile.id || uploadFile.base64 !== null) {
        return of(`data:${uploadFile.contentType};base64,${uploadFile.base64}`);
      }
      return this.backendService.getData(`api/v1/cs/sys/filemanagement/docDownloadURL/${uploadFile.uuid}`);
    }
    provideFeedback(configKey, uploadFile, javascriptcontext, contextobject) {
      const request = {
        uploadFieldConfigKey: configKey,
        resource: uploadFile,
        contextObjects: contextobject,
        javascriptContext: javascriptcontext
      };
      return this.backendService.postData('api/v1/cs/sys/fileupload/validation/provideFeedback', request, {
        blockUI: false
      });
    }
    batchProvideFeedback(configKey, uploadFiles, javascriptcontext, contextobject) {
      const request = {
        uploadFieldConfigKey: configKey,
        resources: uploadFiles,
        contextObjects: contextobject,
        javascriptContext: javascriptcontext
      };
      return this.backendService.postData('api/v1/cs/sys/fileupload/validation/batchProvideFeedback', request, {
        blockUI: false
      }).pipe(map(data => {
        if (!data) {
          return new Map();
        }
        return new Map(Object.entries(data));
      }));
    }
    registerFeedbackRequest(uploadFileUuid, feedbackRequestSubscription) {
      this.ongoingFeedbackRequests.set(uploadFileUuid, feedbackRequestSubscription);
    }
    abortFeedbackRequest(uploadFileUuid) {
      if (!this.ongoingFeedbackRequests.get(uploadFileUuid)?.closed) {
        this.ongoingFeedbackRequests.get(uploadFileUuid)?.unsubscribe();
      }
      this.ongoingFeedbackRequests.delete(uploadFileUuid);
    }
    cleanupFeedback(currentModel) {
      const currentUuids = new Set(_.isEmpty(currentModel) ? [] : currentModel.map(file => file.uuid));
      [...this.ongoingFeedbackRequests.keys()].filter(uuid => !currentUuids.has(uuid)).forEach(uploadFileUuid => this.abortFeedbackRequest(uploadFileUuid));
    }
    abortAllOnGoingFeedbackRequests() {
      this.ongoingFeedbackRequests.forEach(request => request.unsubscribe());
      this.ongoingFeedbackRequests.clear();
    }
    static {
      this.ɵfac = function HisFileUploadService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisFileUploadService,
        factory: HisFileUploadService.ɵfac
      });
    }
  }
  return HisFileUploadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisUploadConfiguration {
  constructor(response) {
    // Eine readonly-Eigenschaft muss entweder im Konstruktor oder bei der Deklaration selbst zugewiesen werden.
    /** the document metadata ids */
    this.documentMetadataCategoryIds = [];
    if (!response.configKey) {
      throw new Error('response.confKey must not be null or undefined');
    }
    this.configKey = response.configKey;
    this.fileLimit = response.fileLimit;
    this.label = response.label;
    this.multiple = response.multipleUpload;
    this.maxFileSize = response.sizeLimit;
    this.showDescription = response.allowComment;
    this.helptextAbove = response.helptextAbove;
    this.helptextBelow = response.helptextBelow;
    this.helptextIcon = response.helptextIcon;
    this.showCategoryIfUnique = response.showCategoryIfUnique;
    this.accept = response.accept;
    this.readonly = response.readonly;
    this.css = response.css;
    this.documentMetadataCategoryIds = response.documentMetadataCategoryIds ? Array.from(response.documentMetadataCategoryIds) : [];
    this.required = response.required ? response.required : false;
  }
  getMultiple() {
    return this.multiple;
  }
  /** a i18n key for specifying a label at the on the enclosing PLAM */
  getLabel() {
    return this.label;
  }
  getRequired() {
    return this.required;
  }
  getReadonly() {
    return this.readonly;
  }
  /** a i18n key for the plam helptext icon  */
  getHelptextIcon() {
    return this.helptextIcon;
  }
  /** the helptext above the file upload field*/
  getHelptextAbove() {
    return this.helptextAbove;
  }
  /** the helptext below the file upload field*/
  getHelptextBelow() {
    return this.helptextBelow;
  }
  /** Maximum number of files that can be uploaded. */
  getFileLimit() {
    return this.fileLimit;
  }
  /** Maximum file size allowed in bytes. */
  getMaxFileSize() {
    return this.maxFileSize;
  }
  /**  Ein Merge aus eventuell vorhandenen Dateierweiterungen z. B. *.png und/oder Content Types/mimetypes, z. B. accept */
  getAccept() {
    return this.accept;
  }
  /** shows the category as readonly if true */
  getShowCategoryIfUnique() {
    return this.showCategoryIfUnique;
  }
  getShowDescription() {
    return this.showDescription;
  }
  /** the document metadata ids */
  getDocumentMetadataCategoryIds() {
    return this.documentMetadataCategoryIds;
  }
  getConfigKey() {
    return this.configKey;
  }
  getCss() {
    return this.css;
  }
}
class HisFileUtil {
  /**
   * Removes the file from the files array
   *
   * @param files the files array
   * @param file the file to remove
   * @return an array of files
   */
  static removeFile(files, file) {
    for (let aFile of files) {
      //console.log('removeFile #uploadFile', uploadFile);
      if (aFile === file) {
        console.log('removeFile #file #foundFile', file);
        let index = files.indexOf(aFile);
        if (index !== -1) {
          files.splice(index, 1);
          return files;
        }
      }
    }
    return files;
  }
  static removeHisUploadFile(files, hisUploadFile) {
    for (let file of files) {
      //console.log('removeFile #uploadFile', uploadFile);
      if (file.name === hisUploadFile.name && file.type === hisUploadFile.contentType) {
        console.log('removeFile #file #foundFile', hisUploadFile);
        let index = files.indexOf(file);
        if (index !== -1) {
          files.splice(index, 1);
          return files;
        }
      }
    }
    return files;
  }
}
class HisUploadFileUtil {
  /**
   * Removes the file from the files array
   *
   * @param files the files array
   * @param file the file to remove
   * @return an array of {@code HisUploadFile}s
   */
  static removeHisUploadFile(files, file) {
    for (let uploadFile of files) {
      //console.log('removeFile #uploadFile', uploadFile);
      if (uploadFile.name === file.name && uploadFile.base64 === file.base64) {
        //console.log('removeFile #uploadFile #foundFile', uploadFile);
        let index = files.indexOf(uploadFile);
        if (index !== -1) {
          files.splice(index, 1);
          return files;
        }
      }
    }
    return files;
  }
  /**
   * Checks, if all element of files2 are contained in files1
   *
   * @returns true, if all elements of files2 are contained in files1, false otheweise
   */
  static containsFiles(files1, files2) {
    if (files1.every(r => files2.includes(r))) {
      return true;
    }
    return false;
  }
  /**
   * Checks, if all elements of files1 are contained in files.
   *
   * @param files1
   * @param files2
   *
   * @returns an array of missing files as {@code HisUploadFile}
   * */
  static getNotContainedFiles(files1, files2) {
    if (!files1 || !files2) {
      return [];
    }
    let missing = files2.filter(item => files1.indexOf(item) < 0);
    console.log('missing', missing);
    return missing;
  }
}
const _c0$i = ["pFileUpload"];
const _c1$7 = ["feedbackPanel"];
/**
 * Abstract component with the implementation of the two way value binding.
 */
let HisAbstractFileUploadComponent = /*#__PURE__*/(() => {
  class HisAbstractFileUploadComponent extends HisControlValueAccessor {
    get value() {
      return this.model;
    }
    set value(v) {
      if (v !== this.model) {
        this.model = v;
        this.onModelChange(v);
      }
      this.onValidationChange();
    }
    constructor(uploadService, notificationService, hisUiService, controlDirective, parentPlam) {
      super();
      this.uploadService = uploadService;
      this.notificationService = notificationService;
      this.hisUiService = hisUiService;
      this.controlDirective = controlDirective;
      this.parentPlam = parentPlam;
      this.disableUploadOnly = false;
      this.filesChanged = new EventEmitter();
      this.fileAdded = new EventEmitter();
      this.fileRemoved = new EventEmitter();
      /** two way value binding */
      this.model = [];
      this.oldModel = [];
      this.files = [];
      this.isMaxUploadsReached = false;
      this.feedback = new Map();
      this.uploading = false;
      this.onValidationChange = () => {};
      controlDirective.valueAccessor = this;
    }
    ngOnInit() {
      this.control = this.controlDirective.control;
      this.control.setValidators([this.validateMetadatacategory.bind(this), this.validateRequired.bind(this)]);
      console.log('ngOnInit() #this.configKey', this.configKey);
      this.uploadService.getUploadFieldConfig(this.configKey, this.javascriptContext, this.contextObjects).subscribe(response => {
        if (!response) {
          return;
        }
        console.log('ngOnInit() #response', response);
        this.configuration = new HisUploadConfiguration(response);
        this.ddLabeltext = this.configuration.getLabel();
        this.ddHelptext = this.configuration.getHelptextIcon();
        this.required = this.configuration.getRequired();
        this.triggerValidation();
      });
    }
    ngDoCheck() {
      if (!this.model || !this.oldModel) {
        return;
      }
      if (this.model.length === this.oldModel.length) {
        return;
      }
      console.log('ngDoCheck() #modelChanged #this.model', this.model);
      this.oldModel = cloneDeep$1(this.model);
      // model has changed!
      // update isMaxUploadsReached; but only if the configuration is already loaded
      if (this.configuration) {
        this.isMaxUploadsReached = this.uploadService.getIsMaxUploadsReached(this.configuration?.getMultiple(), this.configuration?.getFileLimit(), this.model);
      }
    }
    triggerValidation() {
      this.control.updateValueAndValidity();
    }
    initializeFeedback() {
      if (isEmpty$1(this.model)) {
        return;
      }
      this.ongoingBatchFeedback?.unsubscribe();
      this.ongoingBatchFeedback = this.uploadService.batchProvideFeedback(this.configKey, this.model, this.javascriptContext, this.contextObjects).subscribe(feedbackMap => {
        this.ongoingBatchFeedback = null;
        feedbackMap.forEach((feedback, uuid) => {
          this.feedback.set(uuid, feedback);
        });
      });
    }
    getFeedbackForFile(file) {
      if (this.feedback.has(file.uuid)) {
        return;
      }
      const uploadFeedback = this.uploadService.provideFeedback(this.configKey, file, this.javascriptContext, this.contextObjects).subscribe(aFeedback => {
        this.feedback.set(file.uuid, aFeedback);
        this.uploadService.abortFeedbackRequest(file.uuid);
      });
      this.uploadService.registerFeedbackRequest(file.uuid, uploadFeedback);
    }
    validateRequired(control) {
      if (!this.configuration?.getRequired()) {
        return null;
      }
      if (this.disabledIntern) {
        return null;
      }
      if (this.model?.length > 0) {
        return null;
      }
      let error = {
        filesMissing: {
          message: this.hisUiService.translate('validation.required')
        }
      };
      return error;
    }
    showValidationMessage() {
      if (this.parentPlam) {
        return false;
      }
      return this.control?.hasError('filesMissing');
    }
    get deleteDisabled() {
      return this.disabledIntern || this.configuration?.getReadonly();
    }
    get downloadDisabled() {
      // download should be possible, even if the field is disabled see https://hiszilla.his.de/hiszilla/show_bug.cgi?id=309356#c8 for details
      return false;
    }
    get commentDisabled() {
      return this.disabledIntern || this.configuration?.getReadonly();
    }
    get categoryDisabled() {
      return this.disabledIntern || this.configuration?.getReadonly();
    }
    // *** Implementation of ControlValueAccessor start
    setDisabledState(isDisabled) {
      this.disabledIntern = isDisabled;
    }
    registerOnValidatorChange(fn) {
      this.onValidationChange = fn;
    }
    writeValue(value) {
      this.model = value;
      this.uploadService.cleanupFeedback(this.model);
      this.initializeFeedback();
    }
    // *** Implementation of ControlValueAccessor end
    validateMetadatacategory(control) {
      if (!this.model) {
        return null;
      }
      if (!this.configuration?.getDocumentMetadataCategoryIds().length) {
        return null;
      }
      for (let file of this.model) {
        if (!file.documentMetadataCategoryId) {
          let error = {
            categoryMissing: {
              message: this.hisUiService.translate('cs.sys.hisng.upload.documentMetadataCategory.requiredMessage')
            }
          };
          return error;
        }
      }
      return null;
    }
    isShowUpload() {
      if (this.disabledIntern || this.disableUploadOnly) {
        return false;
      }
      if (this.isMaxUploadsReached) {
        return false;
      }
      if (this.model.length === this.configuration?.getFileLimit()) {
        return false;
      }
      if (this.configuration?.getMultiple() === false && this.model.length > 0) {
        return false;
      }
      if (this.configuration?.getReadonly() === true) {
        return false;
      }
      return true;
    }
    /**
     * Wird beim Hinzufügen (onSelect) eines oderer mehrer Files ausgelöst
     * <p>Async ist der Preis für das Eliminieren der Nebenläufigkeit,
     * das spielt in diesem Fall jedoch keine Rolle, da es keine Rückgabe gibt.
     *
     */
    async selectFileForUpload(event) {
      // wird ausgelöst, wenn ein File ausgewählt wird
      let currentFiles = event.currentFiles;
      console.log('selectFileForUpload() #fileList', currentFiles);
      if (!this.model) {
        this.model = [];
      }
      const oldFiles = cloneDeep$1(this.model);
      let limitedUploadedFiles = this.uploadService.limitNumberOfFilesToTheConfuguredFileLimit(currentFiles, this.configuration, this.model);
      // hätte den Vorteil, dass man synchron arbeiten kann
      // geht hier nur in verarbeitetn Methoden
      let selectedUploadFiles = await lastValueFrom(this.uploadService.getUploadFiles(limitedUploadedFiles));
      let newUploadFiles = HisUploadFileUtil.getNotContainedFiles(this.model, selectedUploadFiles);
      this.model.push(...newUploadFiles);
      this.filesChanged.emit(new FilesChangedEvent(oldFiles, cloneDeep$1(this.model)));
      newUploadFiles?.forEach(file => {
        this.fileAdded.emit(new FilesMutatedEvent(newUploadFiles[0], cloneDeep$1(this.model)));
        this.getFeedbackForFile(file);
      });
      this.onModelChange(this.model);
      this.triggerValidation();
      // Setzt das p-fileupload zurück. Das ist notwendig für die Möglichkeit,
      // falls multiple=true mehrere Auswahlen nacheinander durchzuführen
      if (this.pFileUpload) {
        this.pFileUpload.clear();
      }
      this.uploading = false;
    }
    onBeforeUpload() {
      this.uploading = true;
      this.triggerValidation();
    }
    remove(uploadFile) {
      console.log('changes #remove #file', uploadFile);
      const oldFiles = cloneDeep$1(this.model);
      this.model = HisUploadFileUtil.removeHisUploadFile(this.model, uploadFile);
      console.log('changes #remove #afteRemove #this.model', this.model);
      this.files = HisFileUtil.removeHisUploadFile(this.files, uploadFile);
      console.log('changes #remove #afteRemove #this.files', this.files);
      this.isMaxUploadsReached = false;
      this.filesChanged.emit(new FilesChangedEvent(oldFiles, cloneDeep$1(this.model)));
      this.fileRemoved.emit(new FilesMutatedEvent(uploadFile, cloneDeep$1(this.model)));
      this.removeFeedback(uploadFile.uuid);
      this.onModelChange(this.model);
      this.triggerValidation();
    }
    removeFeedback(uploadFileUuid) {
      this.uploadService.abortFeedbackRequest(uploadFileUuid);
      this.feedback.delete(uploadFileUuid);
    }
    setDocumentMetadataCategoryId(category) {
      console.log('setDocumentMetadataCategoryId #category', category);
      if (!category) {
        this.triggerValidation();
        return;
      }
      const oldFiles = cloneDeep$1(this.model);
      for (let uploadFile of this.model) {
        uploadFile.documentMetadataCategoryId = category.id;
      }
      this.triggerValidation();
      this.filesChanged.emit(new FilesChangedEvent(oldFiles, cloneDeep$1(this.model)));
    }
    onCommentChanged(file, comment) {
      const oldFiles = cloneDeep$1(this.model);
      file.comment = comment;
      this.filesChanged.emit(new FilesChangedEvent(oldFiles, cloneDeep$1(this.model)));
    }
    fileUploadCss() {
      let styleClasses = [];
      styleClasses.push('file_upload');
      if (!isEmpty$1(this.configuration?.getCss())) {
        styleClasses.push(this.configuration?.getCss());
      } else {
        styleClasses.push(this.getStyleClassesIntern());
      }
      if (this.disabledIntern) {
        styleClasses.push('file_upload_disabled');
      }
      if (this.configuration?.getReadonly()) {
        styleClasses.push('file_upload_readonly');
      }
      return styleClasses.join(' ');
    }
    getStyleClassesIntern() {
      if (this.styleClass) {
        return this.styleClass;
      } else if (this.pFileUpload && this.pFileUpload.styleClass) {
        return this.pFileUpload.styleClass;
      } else {
        return 'file_upload_standard';
      }
    }
    isDisableFileUpload() {
      if (this.disabledIntern) {
        return true;
      }
      if (this.configuration?.getReadonly()) {
        return true;
      }
      return false;
    }
    showFilesSeparatorLine() {
      if (this.configuration?.getDocumentMetadataCategoryIds().length === 1 && this.configuration?.getShowCategoryIfUnique()) {
        return true;
      }
      if (this.configuration?.getDocumentMetadataCategoryIds().length > 1 && !this.configuration?.getShowCategoryIfUnique()) {
        return true;
      }
      return false;
    }
    onDragEnter(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    onDragLeave(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    onDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      const files = event.dataTransfer?.files;
      if (files) {
        this.selectFileForUpload(event);
      }
    }
    onDragOver(event) {
      event.preventDefault();
    }
    chooseFile() {
      this.pFileUpload.choose();
    }
    getInternalUploadFieldLabel() {
      if (!isEmpty$1(this.placeholder)) {
        return this.placeholder;
      }
      if (this.configuration?.getMultiple()) {
        if (this.configuration?.getFileLimit() == null) {
          return this.hisUiService.translate('common.components.inputFile.chooseLabel.multipleUnbounded');
        }
        return this.hisUiService.translate('common.components.inputFile.chooseLabel.multipleBounded', this.configuration?.getFileLimit());
      }
      return this.hisUiService.translate('common.components.inputFile.chooseLabel.single');
    }
    invalidFileTypeMessage() {
      return this.hisUiService.translate('common.components.inputFile.invalidFileMessage', this.configuration?.getAccept().replaceAll(',', ', ')) + ' {0}';
    }
    formatFileSize(bytes) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        minimumIntegerDigits: 1
      });
      if (bytes === 0) {
        return '0 Bytes';
      }
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return formatter.format(bytes / Math.pow(k, i)) + ' ' + sizes[i];
    }
    invalidFileSizeMessage() {
      const maxSizeForUI = this.formatFileSize(this.configuration?.getMaxFileSize());
      return this.hisUiService.translate('common.components.inputFile.invalidSizeMessage', maxSizeForUI) + '{0}';
    }
    getFeedback(file) {
      if (!this.feedback.has(file.uuid)) {
        return [];
      }
      return this.feedback.get(file.uuid);
    }
    showFeedback(event, feedback) {
      const translated = this.hisUiService.translate(feedback.feedbackMessageKey, ...feedback.feedbackMessageParams);
      this.feedbackPanelContent = translated;
      this.feedbackPanel.show(event);
    }
    static {
      this.ɵfac = function HisAbstractFileUploadComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAbstractFileUploadComponent)(i0.ɵɵdirectiveInject(HisFileUploadService), i0.ɵɵdirectiveInject(HisNotificationService), i0.ɵɵdirectiveInject(HisUiService), i0.ɵɵdirectiveInject(i1$1.NgControl, 2), i0.ɵɵdirectiveInject(HisPlamComponent, 8));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisAbstractFileUploadComponent,
        selectors: [["ng-component"]],
        viewQuery: function HisAbstractFileUploadComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$i, 5);
            i0.ɵɵviewQuery(_c1$7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pFileUpload = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.feedbackPanel = _t.first);
          }
        },
        inputs: {
          configKey: "configKey",
          javascriptContext: "javascriptContext",
          contextObjects: "contextObjects",
          styleClass: "styleClass",
          placeholder: "placeholder",
          disableUploadOnly: "disableUploadOnly"
        },
        outputs: {
          filesChanged: "filesChanged",
          fileAdded: "fileAdded",
          fileRemoved: "fileRemoved"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HisAbstractFileUploadComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => HisAbstractFileUploadComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function HisAbstractFileUploadComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return HisAbstractFileUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDocumentMetadataCategoryService = /*#__PURE__*/(() => {
  class HisDocumentMetadataCategoryService {
    constructor() {
      this.backendService = inject(HisBackendService);
    }
    /**
     * @returns an observable of GenericValue[]
     */
    getDocumentMetadataCategories() {
      return this.backendService.getData('api/v1/cs/sys/fileupload/documentMetadataCategories');
    }
    static {
      this.ɵfac = function HisDocumentMetadataCategoryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDocumentMetadataCategoryService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDocumentMetadataCategoryService,
        factory: HisDocumentMetadataCategoryService.ɵfac
      });
    }
  }
  return HisDocumentMetadataCategoryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "p-autoComplete", 3, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_2_Template_p_autoComplete_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedDocumentMetadataCategory, $event) || (ctx_r1.selectedDocumentMetadataCategory = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("completeMethod", function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_2_Template_p_autoComplete_completeMethod_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.filterDocumentMetadataCategories($event));
    })("onSelect", function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_2_Template_p_autoComplete_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectDocumentMetadataCategory($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("required", true)("dropdown", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedDocumentMetadataCategory);
    i0.ɵɵproperty("suggestions", ctx_r1.filteredDocumentMetadataCategories);
  }
}
function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 1)(2, "span", 4, 1);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const category_r3 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(category_r3.text);
  }
}
function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵrepeaterCreate(1, HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_3_For_2_Template, 5, 1, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.allConfigurationDmcValues);
  }
}
function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "his-plam", 2);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵtemplate(2, HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_2_Template, 4, 4, "div")(3, HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Conditional_3_Template, 3, 0, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 4, "common.components.inputFile.commonCategory"));
    i0.ɵɵproperty("required", true);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.disabled ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.disabled ? 3 : -1);
  }
}
function HisFileUploadCategorySelectComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "his-plam", 2);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "span", 4, 1);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 3, "common.components.inputFile.commonCategory"));
    i0.ɵɵproperty("required", true);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.allConfigurationDmcValues[0].text);
  }
}
function HisFileUploadCategorySelectComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisFileUploadCategorySelectComponent_Conditional_0_Conditional_0_Template, 4, 6, "his-plam", 2)(1, HisFileUploadCategorySelectComponent_Conditional_0_Conditional_1_Template, 5, 5, "his-plam", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.allConfigurationDmcValues.length > 1 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showCategoryIfUnique && ctx_r1.allConfigurationDmcValues.length === 1 ? 1 : -1);
  }
}
let HisFileUploadCategorySelectComponent = /*#__PURE__*/(() => {
  class HisFileUploadCategorySelectComponent {
    constructor() {
      this.dmcService = inject(HisDocumentMetadataCategoryService);
      this.uploadFiles = [];
      /** the documentMetadataCategoryIds which are defined in the configuration */
      this.configurationDmcIds = [];
      this.selectedDocumentMetadataCategoryChanged = new EventEmitter();
      this.allConfigurationDmcValues = [];
      this.filteredDocumentMetadataCategories = [];
    }
    ngOnInit() {
      console.log('#ngOnInit() #documentMetadataCategory #this.configurationDmcIds', this.configurationDmcIds);
      if (this.configurationDmcIds && this.configurationDmcIds.length > 0) {
        this.dmcService.getDocumentMetadataCategories().subscribe(result => {
          if (result) {
            console.log('#ngOnInit() #documentMetadataCategory #result', result);
            this.allConfigurationDmcValues = result.filter(c => this.configurationDmcIds.includes(c.id));
            console.log('#ngOnInit() #documentMetadataCategory #this.allConfigurationDmcValues', this.allConfigurationDmcValues);
            if (!_.isEmpty(this.uploadFiles)) {
              // Dokumentenkategorie aus Files auswerten: Hiszilla 307635
              if (this.fileHasdocumentMetadataCategory() && !this.selectedDocumentMetadataCategory) {
                console.log('#ngOnInit() #set selectedDocumentMetadataCategory');
                for (let category of this.allConfigurationDmcValues) {
                  if (category.id === this.uploadFiles[0].documentMetadataCategoryId) {
                    this.selectedDocumentMetadataCategory = category;
                  }
                }
              }
              // Hiszilla 313413: wenn das File eine Kategorie hat, die es in der Konfiguration nicht mehr gibt
              // dann soll diese trotzdem angezeigt werden.
              // Da die Kategorien für alle files gleich sind, kann man das so machen
              let fileDmcId = this.uploadFiles[0].documentMetadataCategoryId;
              if (!this.configurationDmcIds.includes(fileDmcId)) {
                const missingDmcFromFile = result.find(c => c.id === fileDmcId);
                console.log('#ngOnInit() #documentMetadataCategory #missingDmcFromFile', missingDmcFromFile);
                if (missingDmcFromFile) {
                  this.allConfigurationDmcValues.push(missingDmcFromFile);
                  this.selectedDocumentMetadataCategory = missingDmcFromFile;
                }
              }
            }
          }
        });
      }
    }
    fileHasdocumentMetadataCategory() {
      if (this.uploadFiles && this.uploadFiles.length > 0 && this.uploadFiles[0].documentMetadataCategoryId) {
        return true;
      }
      return false;
    }
    filterDocumentMetadataCategories(event) {
      console.log('filterDocumentMetadataCategories #query: string', event.query);
      //console.log('sys-entity-explorer-domainselect#filterDomains() #query', event.query);
      let categories = new Set();
      for (let dmc of this.allConfigurationDmcValues) {
        if (dmc && dmc.defaulttext.toLowerCase().includes(event.query.toLowerCase())) {
          categories.add(dmc);
        }
      }
      this.filteredDocumentMetadataCategories = Array.from(categories);
      // TODO evtl. sort
      console.log('filterDocumentMetadataCategories() #filteredDocumentMetadataCategories', this.filteredDocumentMetadataCategories);
    }
    selectDocumentMetadataCategory(event) {
      console.log('selectDocumentMetadataCategory() #category', event);
      this.selectedDocumentMetadataCategoryChanged.emit(this.selectedDocumentMetadataCategory);
    }
    isShowDocumentMetadataCategories() {
      // Notlösung, das hier zu verorten, falls showCategoryIfUnique=true,
      // damit die Kategorie auch vergeben wird, auch wenn das Auswahlfeld nicht angezeigt wird
      this.emitCategory();
      //console.log('isShowDocumentMetadataCategories() #this.uploadFiles', this.uploadFiles);
      if (this.uploadFiles) {
        let isFile = this.uploadFiles.length > 0;
        let isCategory = this.allConfigurationDmcValues.length > 0;
        return isCategory && isFile;
      } else {
        return false;
      }
    }
    emitCategory() {
      console.log('emitCategory #selectedDocumentMetadataCategory', this.selectedDocumentMetadataCategory);
      console.log('emitCategory #this.allConfigurationDmcValues[0]', this.allConfigurationDmcValues[0]);
      if (!this.uploadFiles) {
        return;
      }
      let isFile = this.uploadFiles.length > 0;
      if (!isFile) {
        return;
      }
      let isUniqueCategory = this.allConfigurationDmcValues.length === 1;
      // Erst wenn files ausgewählt sind darf die Kategorie gesetzt werden
      if (isUniqueCategory) {
        console.log('emitCategory #emited category #1', this.allConfigurationDmcValues[0]);
        this.uploadFiles[0].documentMetadataCategoryId = this.allConfigurationDmcValues[0].id;
        this.selectedDocumentMetadataCategoryChanged.emit(this.allConfigurationDmcValues[0]);
        return;
      }
      if (this.selectedDocumentMetadataCategory) {
        console.log('emitCategory #emited category #2', this.selectedDocumentMetadataCategory);
        for (let uploadFile of this.uploadFiles) {
          uploadFile.documentMetadataCategoryId = this.selectedDocumentMetadataCategory.id;
        }
        this.selectedDocumentMetadataCategoryChanged.emit(this.selectedDocumentMetadataCategory);
      }
    }
    static {
      this.ɵfac = function HisFileUploadCategorySelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadCategorySelectComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisFileUploadCategorySelectComponent,
        selectors: [["his-file-upload-category-select"]],
        inputs: {
          uploadFiles: "uploadFiles",
          configurationDmcIds: "configurationDmcIds",
          showCategoryIfUnique: "showCategoryIfUnique",
          disabled: "disabled"
        },
        outputs: {
          selectedDocumentMetadataCategoryChanged: "selectedDocumentMetadataCategoryChanged"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["content", "", "autocomplete", ""], ["content", ""], [3, "required", "label"], ["field", "defaulttext", 3, "ngModelChange", "completeMethod", "onSelect", "required", "dropdown", "ngModel", "suggestions"], [1, "plamContentText"]],
        template: function HisFileUploadCategorySelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisFileUploadCategorySelectComponent_Conditional_0_Template, 2, 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isShowDocumentMetadataCategories() ? 0 : -1);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.NgModel, i2$1.AutoComplete, HisPlamComponent, HisModificationDetectionDirective, HisButtonTitleDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisFileUploadCategorySelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisUploadFileDownloadComponent = /*#__PURE__*/(() => {
  class HisUploadFileDownloadComponent {
    constructor() {
      this.fileUploadService = inject(HisFileUploadService);
      this.disabled = false;
    }
    download() {
      this.fileUploadService.getDownloadUrl(this.value).subscribe(url => {
        const link = document.createElement('a');
        link.href = url;
        link.download = this.value.name;
        link.click();
      });
    }
    static {
      this.ɵfac = function HisUploadFileDownloadComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUploadFileDownloadComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisUploadFileDownloadComponent,
        selectors: [["his-upload-file-download"]],
        inputs: {
          value: "value",
          disabled: "disabled"
        },
        standalone: false,
        decls: 2,
        vars: 5,
        consts: [["type", "button", "hisImage", "DOWNLOAD", 1, "transparent", 3, "click", "title", "disabled"]],
        template: function HisUploadFileDownloadComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵlistener("click", function HisUploadFileDownloadComponent_Template_button_click_0_listener() {
              return ctx.download();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind2(1, 2, "common.downloadOf", ctx.value.name))("disabled", ctx.disabled);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisUploadFileDownloadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$h = ["configKey", ""];
function HisFileUploadComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.configuration.getHelptextAbove()), i0.ɵɵsanitizeHtml);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_4_Template(rf, ctx) {}
function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.chooseFile());
    })("blur", function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Conditional_0_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.triggerValidation());
    });
    i0.ɵɵelement(1, "em", 14)(2, "img", 15);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("title", ctx_r0.uploadButtonTitle)("ariaLabel", ctx_r0.uploadButtonAriaLabel);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.getInternalUploadFieldLabel());
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "validation.required"), " ");
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Conditional_0_Template, 5, 3, "button", 11)(1, HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Conditional_1_Template, 5, 3, "div", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r0.uploading ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showValidationMessage() ? 1 : -1);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "p-fileUpload", 6, 0);
    i0.ɵɵlistener("onBeforeUpload", function HisFileUploadComponent_Conditional_0_Conditional_2_Template_p_fileUpload_onBeforeUpload_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onBeforeUpload());
    })("onSelect", function HisFileUploadComponent_Conditional_0_Conditional_2_Template_p_fileUpload_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectFileForUpload($event));
    })("onDragOver", function HisFileUploadComponent_Conditional_0_Conditional_2_Template_p_fileUpload_onDragOver_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragOver($event));
    })("drop", function HisFileUploadComponent_Conditional_0_Conditional_2_Template_p_fileUpload_drop_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDrop($event));
    })("dragenter", function HisFileUploadComponent_Conditional_0_Conditional_2_Template_p_fileUpload_dragenter_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragEnter($event));
    })("dragleave", function HisFileUploadComponent_Conditional_0_Conditional_2_Template_p_fileUpload_dragleave_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragLeave($event));
    });
    i0.ɵɵtemplate(3, HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_3_Template, 1, 0, "ng-template", 7)(4, HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_4_Template, 0, 0, "ng-template", 8)(5, HisFileUploadComponent_Conditional_0_Conditional_2_ng_template_5_Template, 2, 2, "ng-template", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("showUploadButton", false)("showCancelButton", false)("auto", true)("disabled", ctx_r0.isDisableFileUpload())("multiple", ctx_r0.configuration.getMultiple())("maxFileSize", ctx_r0.configuration.getMaxFileSize())("accept", ctx_r0.configuration.getAccept())("invalidFileTypeMessageSummary", ctx_r0.invalidFileTypeMessage())("invalidFileTypeMessageDetail", "")("invalidFileSizeMessageSummary", ctx_r0.invalidFileSizeMessage());
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.components.inputFile.uploadInProgress"), " ");
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_6_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 25);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_6_For_2_Template_button_click_1_listener($event) {
      const feedback_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r0.showFeedback($event, feedback_r8));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const feedback_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("hisImage", feedback_r8.icon)("title", i0.ɵɵpipeBind1(2, 2, feedback_r8.iconMessageKey));
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 22);
    i0.ɵɵrepeaterCreate(1, HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_6_For_2_Template, 3, 4, "li", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const uploadFile_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.getFeedback(uploadFile_r6));
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", ctx_r0.feedbackPanelContent, i0.ɵɵsanitizeHtml);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "his-plam", 27);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementStart(3, "textarea", 28, 2);
    i0.ɵɵlistener("ngModelChange", function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_10_Template_textarea_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const uploadFile_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onCommentChanged(uploadFile_r6, $event));
    });
    i0.ɵɵtext(5, "                    ");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const uploadFile_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 4, "common.components.inputFile.resourceComment"));
    i0.ɵɵproperty("showLabelTop", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", uploadFile_r6.comment)("disabled", ctx_r0.commentDisabled);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "button", 20);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Template_button_click_2_listener() {
      const uploadFile_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.remove(uploadFile_r6));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "his-upload-file-download", 21);
    i0.ɵɵtemplate(6, HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_6_Template, 3, 0, "ul", 22);
    i0.ɵɵelementStart(7, "p-overlayPanel", 23, 1);
    i0.ɵɵtemplate(9, HisFileUploadComponent_Conditional_0_Conditional_3_For_5_ng_template_9_Template, 1, 1, "ng-template", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Conditional_10_Template, 6, 6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const uploadFile_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(3, 9, "common.removeOf", uploadFile_r6.name))("disabled", ctx_r0.deleteDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", uploadFile_r6.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", uploadFile_r6)("disabled", ctx_r0.downloadDisabled);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.getFeedback(uploadFile_r6) ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("showCloseIcon", true)("dismissable", true);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.configuration.getShowDescription() ? 10 : -1);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HisFileUploadComponent_Conditional_0_Conditional_3_Conditional_1_Template, 3, 3, "div", 18);
    i0.ɵɵelementStart(2, "his-file-upload-category-select", 19);
    i0.ɵɵlistener("selectedDocumentMetadataCategoryChanged", function HisFileUploadComponent_Conditional_0_Conditional_3_Template_his_file_upload_category_select_selectedDocumentMetadataCategoryChanged_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.setDocumentMetadataCategoryId($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵrepeaterCreate(4, HisFileUploadComponent_Conditional_0_Conditional_3_For_5_Template, 11, 12, "div", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.uploading ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("uploadFiles", ctx_r0.model)("configurationDmcIds", ctx_r0.configuration.getDocumentMetadataCategoryIds())("showCategoryIfUnique", ctx_r0.configuration.getShowCategoryIfUnique())("disabled", ctx_r0.categoryDisabled);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.showFilesSeparatorLine() ? "uploaded-files-separator-line" : "");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.model);
  }
}
function HisFileUploadComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.configuration.getHelptextBelow()), i0.ɵɵsanitizeHtml);
  }
}
function HisFileUploadComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisFileUploadComponent_Conditional_0_Conditional_1_Template, 2, 3, "div", 4)(2, HisFileUploadComponent_Conditional_0_Conditional_2_Template, 6, 10, "div")(3, HisFileUploadComponent_Conditional_0_Conditional_3_Template, 6, 8, "div", 5)(4, HisFileUploadComponent_Conditional_0_Conditional_4_Template, 2, 3, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.fileUploadCss());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.configuration.getHelptextAbove() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isShowUpload() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.model && ctx_r0.model.length || ctx_r0.uploading ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.configuration.getHelptextBelow() ? 4 : -1);
  }
}
/**
 *
 * {@link https://stackoverflow.com/questions/50618050/how-to-create-custom-input-component-with-ngmodel-working-in-angular-6}
 */
let HisFileUploadComponent = /*#__PURE__*/(() => {
  class HisFileUploadComponent extends HisAbstractFileUploadComponent {
    // ngModel, two way binding
    // https://stackoverflow.com/questions/35149535/how-to-implement-ngmodel-on-custom-elements
    constructor() {
      const uploadService = inject(HisFileUploadService);
      const notificationService = inject(HisNotificationService);
      const hisUiService = inject(HisUiService);
      const controlDirective = inject(NgControl, {
        self: true
      });
      const plam = inject(HisPlamComponent, {
        optional: true
      });
      super(uploadService, notificationService, hisUiService, controlDirective, plam);
      this.model = [];
      this.plam = plam;
    }
    ngOnInit() {
      super.ngOnInit();
      if (this.label) {
        this.plam.label = this.label;
      }
    }
    get uploadButtonTitle() {
      if (this.label) {
        return this.label;
      }
      const label = this.hisUiService.translate(this.ddLabeltext);
      if (!this.required) {
        return label;
      }
      return HisPlamComponent.REQUIRED_INDICATOR + ' ' + label;
    }
    get uploadButtonAriaLabel() {
      return this.uploadButtonTitle + ' ' + this.getInternalUploadFieldLabel();
    }
    get plamRef() {
      return this.plam;
    }
    static {
      this.ɵfac = function HisFileUploadComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisFileUploadComponent,
        selectors: [["his-file-upload", "configKey", ""]],
        inputs: {
          configKey: "configKey",
          model: "model",
          label: "label"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        attrs: _c0$h,
        decls: 1,
        vars: 1,
        consts: [["pFileUpload", ""], ["feedbackPanel", ""], ["content", ""], [3, "class"], [1, "infoMessage", 3, "innerHTML"], ["id", "uploadedFiles", 1, "uploaded-files-frame"], ["mode", "advanced", "required", "true", "invalidFileSizeMessageDetail", "", 3, "onBeforeUpload", "onSelect", "onDragOver", "drop", "dragenter", "dragleave", "showUploadButton", "showCancelButton", "auto", "disabled", "multiple", "maxFileSize", "accept", "invalidFileTypeMessageSummary", "invalidFileTypeMessageDetail", "invalidFileSizeMessageSummary"], ["pTemplate", "buttonbar"], ["pTemplate", "file"], ["pTemplate", "content"], [1, "ui-fileupload-buttonbar"], ["type", "button", 1, "upload-button", 3, "title", "ariaLabel"], [1, "plamRow", "plamWarningtextContainer", "ui-g"], ["type", "button", 1, "upload-button", 3, "click", "blur", "title", "ariaLabel"], [1, "pi", "pi-cloud-upload"], ["hisImage", "CHOOSE_FILE", 1, "inlineicon"], [1, "plamWarningtextSpacer", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-4"], ["role", "alert", 1, "plamWarningtext", "ui-g-12", "ui-md-12", "ui-lg-11", "ui-xl-7"], [1, "upload-in-progress"], [3, "selectedDocumentMetadataCategoryChanged", "uploadFiles", "configurationDmcIds", "showCategoryIfUnique", "disabled"], ["id", "delete", "hisImage", "PANEL_CLOSE", 1, "transparent", 3, "click", "title", "disabled"], [3, "value", "disabled"], [1, "upload-feedback"], [3, "showCloseIcon", "dismissable"], ["pTemplate", ""], ["type", "button", 1, "icon", 3, "click", "hisImage", "title"], [1, "upload-feedback-content", 3, "innerHTML"], [3, "label", "showLabelTop"], [1, "textareaWidth100", 3, "ngModelChange", "ngModel", "disabled"]],
        template: function HisFileUploadComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisFileUploadComponent_Conditional_0_Template, 5, 6, "div", 3);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.configuration ? 0 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2.PrimeTemplate, i3$2.FileUpload, i4$3.OverlayPanel, HisPlamComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisFileUploadCategorySelectComponent, HisUploadFileDownloadComponent, HisUiPipe],
        styles: ["his-file-upload .uploaded-files-frame{border:1px solid #cfd8dc;padding:20px}his-file-upload .uploaded-files-frame{border:1px solid #cfd8dc;border-radius:4px;padding:10px}his-file-upload .uploaded-files-separator-line{border-top:1px solid #cfd8dc;padding-top:10px}his-file-upload .upload-button{width:100%;background-color:var(--backgroundColor39);border:2px dashed var(--backgroundColor47);text-align:center;padding:2px}his-file-upload .upload-in-progress{width:100%;text-align:center;padding:2px}his-file-upload .drop-container:hover{background-color:var(--highlightBackgroundColor);border:2px dashed var(--basicFontColor)}his-file-upload .p-fileupload-buttonbar{display:none}his-file-upload .p-fileupload .p-fileupload-content{display:flex;flex-direction:column-reverse}his-file-upload .large-droparea .upload-button{min-height:10em}his-file-upload ul.upload-feedback{list-style-type:\"\";padding:0;margin:auto 0;display:inline-block;vertical-align:middle}his-file-upload ul.upload-feedback li{margin:0;padding:0;display:inline-block}\n"],
        encapsulation: 2
      });
    }
  }
  return HisFileUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisFileUploadDirective = /*#__PURE__*/(() => {
  class HisFileUploadDirective {
    constructor() {
      this.fileupload = inject(HisFileUploadComponent, {
        optional: true
      });
      this.hisPlamRef = inject(HisPlamComponent, {
        host: true,
        optional: true,
        self: true
      });
    }
    ngAfterContentChecked() {
      if (this.fileupload) {
        if (this.fileupload != undefined && this.fileupload.pFileUpload != undefined) {
          this.hisPlamRef = this.fileupload.plamRef;
          if (this.fileupload.pFileUpload.msgs != undefined) {
            this.msg = this.fileupload.pFileUpload.msgs[0]?.summary;
            this.hisPlamRef.setErrorMessageBeforeSave(this.msg);
          }
        }
      }
    }
    static {
      this.ɵfac = function HisFileUploadDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisFileUploadDirective,
        selectors: [["his-file-upload"]],
        standalone: false
      });
    }
  }
  return HisFileUploadDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisFrozenColDirective = /*#__PURE__*/(() => {
  class HisFrozenColDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.renderer = inject(Renderer2);
    }
    ngAfterViewInit() {
      const element = this.el.nativeElement;
      if (this.frozenCols === '3') {
        this.renderer.addClass(element, 'frozenCol_3');
        let width = element.querySelector('th:nth-child(1)').offsetWidth;
        let tds = element.querySelectorAll('td:nth-child(2), th:nth-child(2), td:nth-child(3), th:nth-child(3)');
        tds.forEach(el => {
          this.renderer.setStyle(el, 'width', width + 'px');
        });
      } else if (this.frozenCols === '2') {
        this.renderer.addClass(element, 'frozenCol_2');
        let width = element.querySelector('th:nth-child(1)').offsetWidth;
        let tds = element.querySelectorAll('td:nth-child(2), th:nth-child(2)');
        tds.forEach(el => {
          this.renderer.setStyle(el, 'width', width + 'px');
        });
      } else {
        this.renderer.addClass(element, 'frozenCol');
      }
    }
    static {
      this.ɵfac = function HisFrozenColDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFrozenColDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisFrozenColDirective,
        selectors: [["", "hisFrozencol", ""]],
        inputs: {
          frozenCols: [0, "hisFrozencol", "frozenCols"]
        },
        standalone: false
      });
    }
  }
  return HisFrozenColDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Sets default values for p-multiSelect component bindings that are universally used in H1.
 *
 * Default values are as follows:
 * defaultLabel:
 */
let HisMultiselectDefaultsDirective = /*#__PURE__*/(() => {
  class HisMultiselectDefaultsDirective {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisUiService = inject(HisUiService);
      this.multiSelectRef = inject(MultiSelect);
    }
    ngAfterContentInit() {
      if (this.multiSelectRef) {
        this.multiSelectRef.defaultLabel = this.hisUiService.translate('common.pleaseChoose');
        this.multiSelectRef.ngOnInit();
      }
    }
    static {
      this.ɵfac = function HisMultiselectDefaultsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisMultiselectDefaultsDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisMultiselectDefaultsDirective,
        selectors: [["p-multiSelect"]],
        standalone: false
      });
    }
  }
  return HisMultiselectDefaultsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisPlamDirective = /*#__PURE__*/(() => {
  class HisPlamDirective {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisPlamRef = inject(HisPlamComponent, {
        optional: true
      });
    }
    ngOnInit() {
      if (this.hisPlamRef) {
        this.hisPlamRef.noPlamStyle = true;
      }
    }
    static {
      this.ɵfac = function HisPlamDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPlamDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisPlamDirective,
        selectors: [["", 8, "noplamstyle"]],
        exportAs: [".noPlamStyle"],
        standalone: false
      });
    }
  }
  return HisPlamDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisStepsDirective = /*#__PURE__*/(() => {
  class HisStepsDirective {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.steps = inject(Steps, {
        optional: true
      });
    }
    ngOnChanges(changes) {
      if (changes && this.steps) {
        let index = this.activeIndex;
        setTimeout(() => {
          this.elementRef.nativeElement.children[0].children[0].children[index].focus();
        }, 5);
      }
    }
    static {
      this.ɵfac = function HisStepsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisStepsDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisStepsDirective,
        selectors: [["p-steps"]],
        inputs: {
          activeIndex: "activeIndex"
        },
        exportAs: ["p-steps"],
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisStepsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * a pipe which does string replacing
 */
let HisReplacePipe = /*#__PURE__*/(() => {
  class HisReplacePipe {
    transform(value, ...params) {
      if (value) {
        return value.toString().replace(params[0], params[1]);
      }
      return '';
    }
    static {
      this.ɵfac = function HisReplacePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisReplacePipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisReplace",
        type: HisReplacePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisReplacePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * looks up uitext for entities with support for the Data Dictionary.
 */
let HisUiddPipe = /*#__PURE__*/(() => {
  class HisUiddPipe {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    transform(key) {
      // TODO: lookup key in DataDictionary to check if the ui key was redefined
      return key ? this.hisBaseGlobalsService.getUi(key) : key;
    }
    static {
      this.ɵfac = function HisUiddPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUiddPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisUidd",
        type: HisUiddPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisUiddPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Komponente zum Abfangen und blockiren der Benutzung des Browser-Zurück-Buttons
 */
let HisBrowserBackButtonLockComponent = /*#__PURE__*/(() => {
  class HisBrowserBackButtonLockComponent {
    constructor() {
      this.notificationService = inject(HisNotificationService);
      this.hisUiService = inject(HisUiService);
    }
    /**
     * Verhindert die Möglichkeit den Browser-Back-Button zu verwenden
     */
    unloadHandler(event) {
      console.log('unloadHandler #event', event);
      event.stopImmediatePropagation();
      event.preventDefault(); // Verhindert das Schließen oder Verlassen der Seite
      //'Benutzerdefinierte Nachricht'
      let warningMessageTitle = this.hisUiService.translate('cs.sys.notification.Notification.warningType');
      let warningMessageText = this.hisUiService.translate('gui.dontUseBackBtnErrorMsg');
      this.notificationService.clear();
      this.notificationService.warn(warningMessageText, warningMessageTitle);
      event.returnValue = warningMessageText; // Setzt die benutzerdefinierte Nachricht für das Ereignisobjekt
      history.pushState(null, null, location.href); // Navigiert zur aktuellen Seite, um den Zurück-Button zu deaktivieren
    }
    static {
      this.ɵfac = function HisBrowserBackButtonLockComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisBrowserBackButtonLockComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisBrowserBackButtonLockComponent,
        selectors: [["his-browser-back-button-lock"]],
        hostBindings: function HisBrowserBackButtonLockComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("beforeunload", function HisBrowserBackButtonLockComponent_beforeunload_HostBindingHandler($event) {
              return ctx.unloadHandler($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        standalone: false,
        decls: 1,
        vars: 0,
        template: function HisBrowserBackButtonLockComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "span");
          }
        },
        encapsulation: 2
      });
    }
  }
  return HisBrowserBackButtonLockComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This directive detects when the user scrolled to the end of the page, respecting the threshold
 *
 * usage: <my-component appScrollNearEnd (nearEnd)="myMethod()"></my-component>
 * myMethod() will be called each time the current window is scrolled to the end of the page
 *
 * see https://dev.to/krivanek06/angular-infinite-scrolling-2jab
 */
let HisScrollNearEndDirective = /*#__PURE__*/(() => {
  class HisScrollNearEndDirective {
    constructor() {
      this.el = inject(ElementRef);
      this.nearEnd = new EventEmitter();
      /**
       * threshold in PX when to emit before page end scroll
       */
      this.threshold = 120;
      this.minEmitDistance = 100;
      this.lastEmitPosition = 0;
    }
    ngOnInit() {
      this.window = window;
    }
    windowScrollEvent(event) {
      // height of whole window page
      const heightOfWholePage = this.window.document.documentElement.scrollHeight;
      // how big in pixels the element is
      const heightOfElement = this.el.nativeElement.scrollHeight;
      // currently scrolled Y position
      const currentScrolledY = this.window.scrollY;
      // height of opened window - shrinks if console is opened
      const innerHeight = this.window.innerHeight;
      /**
       * the area between the start of the page and when this element is visible
       * in the parent component
       */
      const spaceOfElementAndPage = heightOfWholePage - heightOfElement;
      // calculated whether we are near the end
      const scrollToBottom = heightOfElement - innerHeight - currentScrolledY + spaceOfElementAndPage;
      //distance-based approach: only emit if we have moved from the previous position
      const distanceToLastEmit = Math.abs(currentScrolledY - this.lastEmitPosition);
      // if the user is near end
      if (this.endPositionReached(scrollToBottom) && this.hasMovedSignificantly(distanceToLastEmit)) {
        this.nearEnd.emit();
        this.lastEmitPosition = currentScrolledY;
      }
    }
    hasMovedSignificantly(distanceToLastEmit) {
      return distanceToLastEmit > this.minEmitDistance;
    }
    endPositionReached(scrollToBottom) {
      return scrollToBottom < this.threshold;
    }
    static {
      this.ɵfac = function HisScrollNearEndDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisScrollNearEndDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisScrollNearEndDirective,
        selectors: [["", "appScrollNearEnd", ""]],
        hostBindings: function HisScrollNearEndDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("scroll", function HisScrollNearEndDirective_scroll_HostBindingHandler($event) {
              return ctx.windowScrollEvent($event.target);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          threshold: "threshold",
          minEmitDistance: "minEmitDistance"
        },
        outputs: {
          nearEnd: "nearEnd"
        },
        standalone: false
      });
    }
  }
  return HisScrollNearEndDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisAmountPipe = /*#__PURE__*/(() => {
  class HisAmountPipe {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.decimalSplitter = ',';
      this.thousandSplitter = '.';
      this.currencySymbol = '€';
      this.locale = this.hisBaseGlobalsService.getLanguage();
    }
    transform(value, symbol) {
      // check if locale was set as parameter
      switch (this.locale) {
        case 'de':
          break;
        case 'en':
          this.setDecimalSplitter('.');
          this.setThousandSplitter(',');
          break;
        default:
          break;
      }
      let sign = value < 0 ? '-' : '';
      let formatted = parseFloat('' + Math.round(Math.abs(value) * 100) / 100).toFixed(2);
      let split = formatted.split('.');
      let formattedAmount = '';
      let index = split[0].length;
      while (index >= 0) {
        if (index >= 3) {
          let separator = index - 3 > 0 ? this.getThousandSplitter() : '';
          formattedAmount = separator + split[0].substring(index - 3, index) + formattedAmount;
        } else {
          formattedAmount = split[0].substring(0, index) + formattedAmount;
          index = 0;
        }
        index -= 3;
      }
      formattedAmount = sign + formattedAmount;
      let showSymbol = symbol === 'symbol' ? ' ' + this.getCurrencySymbol() : '';
      formattedAmount = formattedAmount + this.getDecimalSplitter() + split[1] + showSymbol;
      return formattedAmount;
    }
    // setter
    /* set decimal splitter */
    setDecimalSplitter(decimalSplitter) {
      this.decimalSplitter = decimalSplitter;
    }
    /* set thousand splitter */
    setThousandSplitter(thousandSplitter) {
      this.thousandSplitter = thousandSplitter;
    }
    /* set currency symbol */
    setCurrencySymbol(currencySymbol) {
      this.currencySymbol = currencySymbol;
    }
    // getter
    /* get configured decimal splitter */
    getDecimalSplitter() {
      return this.decimalSplitter;
    }
    /* get configured thousand splitter */
    getThousandSplitter() {
      return this.thousandSplitter;
    }
    /* get configured currency symbol */
    getCurrencySymbol() {
      return this.currencySymbol;
    }
    static {
      this.ɵfac = function HisAmountPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAmountPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisAmount",
        type: HisAmountPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisAmountPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisLowercasefirstletterPipe = /*#__PURE__*/(() => {
  class HisLowercasefirstletterPipe {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    transform(text) {
      if (text && this.hisBaseGlobalsService.getLanguage().toLowerCase() !== 'de') {
        return text.substring(0, 1).toLowerCase() + text.substring(1);
      } else {
        return text;
      }
    }
    static {
      this.ɵfac = function HisLowercasefirstletterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisLowercasefirstletterPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisLowerCaseFirstLetter",
        type: HisLowercasefirstletterPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisLowercasefirstletterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisUppercasefirstletterPipe = /*#__PURE__*/(() => {
  class HisUppercasefirstletterPipe {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    transform(text) {
      if (text && this.hisBaseGlobalsService.getLanguage().toLowerCase() !== 'de') {
        return text.substring(0, 1).toUpperCase() + text.substring(1);
      } else {
        return text;
      }
    }
    static {
      this.ɵfac = function HisUppercasefirstletterPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUppercasefirstletterPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisUpperCaseFirstLetter",
        type: HisUppercasefirstletterPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisUppercasefirstletterPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * directive to trim inputs on blur or enter. Usable on input fields within forms.
 */
let HisTrimInputDirective = /*#__PURE__*/(() => {
  class HisTrimInputDirective {
    constructor() {
      this.formControlDir = inject(FormControlDirective, {
        optional: true,
        host: true
      });
      this.formControlName = inject(FormControlName, {
        optional: true,
        host: true
      });
      this.ngModel = inject(NgModel, {
        optional: true,
        host: true
      });
    }
    static {
      this.allowedInputTypes = ['text', 'textarea'];
    }
    get control() {
      return this.formControlDir?.control || this.formControlName?.control || this.ngModel?.control;
    }
    trimOnBlur(event) {
      if (event.target instanceof HTMLTextAreaElement) {
        return this.trim(event.target);
      }
      if (event.target instanceof HTMLInputElement) {
        return this.trim(event.target);
      }
    }
    /**
     * event handling for keydown.enter - textareas will be excluded to allow multiline input
     * @param event
     * @returns
     */
    trimOnEnter(event) {
      if (!(event.target instanceof HTMLInputElement)) {
        return;
      }
      this.trim(event.target);
    }
    trim(target) {
      if (!HisTrimInputDirective.allowedInputTypes.includes(target.type)) {
        return;
      }
      target.value = target.value.trim();
    }
    static {
      this.ɵfac = function HisTrimInputDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTrimInputDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisTrimInputDirective,
        selectors: [["", "hisTrimInput", ""]],
        hostBindings: function HisTrimInputDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function HisTrimInputDirective_blur_HostBindingHandler($event) {
              return ctx.trimOnBlur($event);
            })("keydown.enter", function HisTrimInputDirective_keydown_enter_HostBindingHandler($event) {
              return ctx.trimOnEnter($event);
            });
          }
        },
        standalone: false
      });
    }
  }
  return HisTrimInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDialogHeaderPaginatorService = /*#__PURE__*/(() => {
  class HisDialogHeaderPaginatorService {
    constructor() {
      this.data$ = new BehaviorSubject({
        ids: [],
        changeSearchUrl: '',
        newSearchUrl: '',
        index: 0
      });
    }
    publishData(data) {
      this.data$.next(data);
    }
    getData() {
      return this.data$.asObservable();
    }
    clear() {
      this.data$.next({
        ids: [],
        changeSearchUrl: '',
        newSearchUrl: '',
        index: 0
      });
    }
    static {
      this.ɵfac = function HisDialogHeaderPaginatorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDialogHeaderPaginatorService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDialogHeaderPaginatorService,
        factory: HisDialogHeaderPaginatorService.ɵfac
      });
    }
  }
  return HisDialogHeaderPaginatorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisSearchResultHeaderContextProviderDirective = /*#__PURE__*/(() => {
  class HisSearchResultHeaderContextProviderDirective {
    constructor() {
      this.dialogHeaderPaginatorService = inject(HisDialogHeaderPaginatorService);
    }
    onClick(_) {
      if (!this.searchResultComponent) {
        return;
      }
      this.searchResultComponent.prepareNavigationContext().subscribe(dialogHeaderContext => this.dialogHeaderPaginatorService.publishData({
        ids: dialogHeaderContext.ids,
        changeSearchUrl: dialogHeaderContext.changeSearchUrl,
        newSearchUrl: dialogHeaderContext.newSearchUrl,
        index: this.selectedIndex ?? 0
      }));
    }
    static {
      this.ɵfac = function HisSearchResultHeaderContextProviderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultHeaderContextProviderDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisSearchResultHeaderContextProviderDirective,
        selectors: [["", "hisSearchResult", ""]],
        hostBindings: function HisSearchResultHeaderContextProviderDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function HisSearchResultHeaderContextProviderDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
        },
        inputs: {
          searchResultComponent: [0, "hisSearchResult", "searchResultComponent"],
          selectedIndex: "selectedIndex"
        },
        standalone: false
      });
    }
  }
  return HisSearchResultHeaderContextProviderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with very basic components, directives, and pipes to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisCoreSharedModule = /*#__PURE__*/(() => {
  class HisCoreSharedModule {
    static {
      this.ɵfac = function HisCoreSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCoreSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCoreSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule,
        // required for HisFooterComponent
        BreadcrumbModule, ConfirmDialogModule, DialogModule, PanelModule, EditorModule, OrderListModule]
      });
    }
  }
  return HisCoreSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCoreSharedModule, {
    declarations: [
    // Components
    HisHeaderComponent, HisPageComponent, HisPageOptionPanelComponent, HisBreadcrumbComponent, NotificationComponent, NotificationsComponent, HisHttplistenerComponent, HisConfirmDialogComponent, HisBrowserBackButtonLockComponent, HisTableConfigComponent, HisPlamComponent,
    // Directives
    HisImageDirective, HisDdDirective, HisPlamDirective, HisDdValidator, HisAutoCompleteEagerDataSourceDirective, HisAutoCompleteLazyDataSourceDirective, HisCalendarDefaultsDirective, HisChipsDirective, HisFormDefaultsDirective, HisPageTitleDirective, HisModificationDetectionDirective, HisMultiselectDefaultsDirective, HisFocusableButtonDirective, HisScrollwithmeDirective, HisFrozenColDirective, HisButtonTitleDirective, HisDeleteActionDirective, HisStepsDirective, HisScrollNearEndDirective, HisTrimInputDirective, HisFileUploadDirective, HisPanelDirective, HisSearchResultHeaderContextProviderDirective,
    // Pipes
    HisAmountPipe, HisHtmlUnsafePipe, HisReplacePipe, HisUiPipe, HisUiddPipe, HisDatePipe, HisLowercasefirstletterPipe, HisUppercasefirstletterPipe],
    imports: [CommonModule, FormsModule,
    // required for HisFooterComponent
    BreadcrumbModule, ConfirmDialogModule, DialogModule, PanelModule, EditorModule, OrderListModule],
    exports: [
    // Components
    HisPageComponent, NotificationsComponent, HisConfirmDialogComponent, HisBrowserBackButtonLockComponent, HisTableConfigComponent, HisPlamComponent,
    // Directives
    HisImageDirective, HisDdDirective, HisPlamDirective, HisDdValidator, HisAutoCompleteEagerDataSourceDirective, HisAutoCompleteLazyDataSourceDirective, HisCalendarDefaultsDirective, HisChipsDirective, HisFormDefaultsDirective, HisPageTitleDirective, HisModificationDetectionDirective, HisMultiselectDefaultsDirective, HisFocusableButtonDirective, HisScrollwithmeDirective, HisFrozenColDirective, HisButtonTitleDirective, HisDeleteActionDirective, HisStepsDirective, HisScrollNearEndDirective, HisTrimInputDirective, HisFileUploadDirective, HisPanelDirective, HisSearchResultHeaderContextProviderDirective,
    // Pipes
    HisAmountPipe, HisHtmlUnsafePipe, HisReplacePipe, HisUiPipe, HisUiddPipe, HisDatePipe, HisLowercasefirstletterPipe, HisUppercasefirstletterPipe]
  });
})();

/**
 * SharedModule for authentication and authorization
 */
let HisAuthSharedModule = /*#__PURE__*/(() => {
  class HisAuthSharedModule {
    static {
      this.ɵfac = function HisAuthSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAuthSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisAuthSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [HisCoreSharedModule]
      });
    }
  }
  return HisAuthSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisAuthSharedModule, {
    imports: [HisCoreSharedModule]
  });
})();

/**
 * CoreModule for authentication and authorization
 */
let HisAuthCoreModule = /*#__PURE__*/(() => {
  class HisAuthCoreModule {
    static {
      this.ɵfac = function HisAuthCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAuthCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisAuthCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisAuthGuard, HisAuthService],
        imports: [HisAuthSharedModule, HisAuthSharedModule]
      });
    }
  }
  return HisAuthCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisAuthCoreModule, {
    imports: [HisAuthSharedModule],
    exports: [HisAuthSharedModule]
  });
})();

/* eslint-disable prefer-arrow/prefer-arrow-functions */
const _c0$g = (a0, a1, a2) => ({
  customConfig: a0,
  toolbarGroups: a1,
  removeButtons: a2
});
let HisCkeditorComponent = /*#__PURE__*/(() => {
  class HisCkeditorComponent {
    constructor() {
      this.hisNavigationService = inject(HisNavigationService);
      this.editorUrl = '/pub/ckeditor/ckeditor.js';
      this.configUrl = '/pub/ckeditor_his/hisconfiguration.js';
      // eslint-disable-next-line max-len
      this.documentationUrl = '/pages/cs/sys/portal/documentation/documentation.faces?navigationPosition=documentation&site=Grundlagen%2C_Bedienung%2C_erste_Schritte-HISinOne.html#Arbeiten_mit_dem_Richtext-Editor';
      this.dataChange = new EventEmitter();
      this.config = {
        editorUrl: this.getEditorUrl(),
        configUrl: this.getConfigUrl(),
        documentationUrl: this.getDocumentationUrl()
      };
    }
    getEditorUrl() {
      let ckeditorUrl = this.hisNavigationService.getQisserverUrl() + this.editorUrl;
      console.log('ckeditor url:', ckeditorUrl);
      return ckeditorUrl;
    }
    getConfigUrl() {
      let ckconfigUrl = this.hisNavigationService.getQisserverUrl() + this.configUrl;
      console.log('ckconfig url:', ckconfigUrl);
      return ckconfigUrl;
    }
    getDocumentationUrl() {
      let ckeditorUrl = this.hisNavigationService.getQisserverUrl() + this.documentationUrl;
      console.log('ckeditor url:', ckeditorUrl);
      return ckeditorUrl;
    }
    getToolbarConfig() {
      console.log('ckeditor toolbar:', this.toolbar);
      let array = [];
      switch (this.toolbar) {
        case 'basic':
          array.toolbarGroups = [{
            name: 'document',
            groups: ['mode', 'document', 'doctools']
          }, {
            name: 'basicstyles',
            groups: ['basicstyles', 'cleanup']
          }, {
            name: 'paragraph',
            groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']
          }, {
            name: 'colors',
            groups: ['colors']
          }, {
            name: 'links',
            groups: ['links']
          }, {
            name: 'others',
            groups: ['others']
          }, {
            name: 'tools',
            groups: ['tools']
          }, {
            name: 'about',
            groups: ['about']
          }];
          // eslint-disable-next-line max-len
          array.removeButtons = 'About,Format,AutoComplete,UncommentSelectedRange,CommentSelectedRange,autoFormat,searchCode,Indent,Outdent,Blockquote';
          break;
        case 'slim':
          array.toolbarGroups = [{
            name: 'basicstyles',
            groups: ['basicstyles', 'cleanup']
          }, {
            name: 'colors',
            groups: ['colors']
          }, {
            name: 'links',
            groups: ['links']
          }, {
            name: 'others',
            groups: ['others']
          }, {
            name: 'about',
            groups: ['about']
          }];
          // eslint-disable-next-line max-len
          array.removeButtons = 'About,Format,AutoComplete,UncommentSelectedRange,CommentSelectedRange,autoFormat,searchCode,Indent,Outdent,Blockquote,Subscript,Superscript';
          break;
        default:
          // same as full, so case full was deleted because nobody likes redundancy.
          array.toolbarGroups = [{
            name: 'document',
            groups: ['mode', 'document', 'doctools']
          }, {
            name: 'clipboard',
            groups: ['clipboard', 'undo']
          }, {
            name: 'editing',
            groups: ['find', 'selection', 'spellchecker', 'editing']
          }, {
            name: 'links',
            groups: ['links']
          }, {
            name: 'insert',
            groups: ['insert']
          }, {
            name: 'forms',
            groups: ['forms']
          }, {
            name: 'others',
            groups: ['others']
          }, {
            name: 'tools',
            groups: ['tools']
          }, '/', {
            name: 'styles',
            groups: ['styles']
          }, {
            name: 'basicstyles',
            groups: ['basicstyles', 'cleanup']
          }, {
            name: 'paragraph',
            groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']
          }, {
            name: 'colors',
            groups: ['colors']
          }, {
            name: 'about',
            groups: ['about']
          }];
          // eslint-disable-next-line max-len
          array.removeButtons = 'About,Format,AutoComplete,UncommentSelectedRange,CommentSelectedRange,autoFormat,searchCode,Indent,Outdent';
      }
      return array;
    }
    onDataChange(event) {
      console.log('ckeditor data changed:', event);
      this.dataChange.emit(event);
    }
    static {
      this.ɵfac = function HisCkeditorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCkeditorComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisCkeditorComponent,
        selectors: [["his-ckeditor"]],
        inputs: {
          ddKey: "ddKey",
          data: "data",
          toolbar: "toolbar"
        },
        outputs: {
          dataChange: "dataChange"
        },
        standalone: false,
        decls: 4,
        vars: 12,
        consts: [[3, "ngModelChange", "dataChange", "ngModel", "editorUrl", "config", "hisDdKey"], ["target", "_blank", "aria-label", "Dokumentation: Grundlagen, Bedienung, erste Schritte-HISinOne", "title", "Dokumentation: Grundlagen, Bedienung, erste Schritte-HISinOne", 1, "wikiDocumentation_link", "link_image_text", 3, "href"]],
        template: function HisCkeditorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ckeditor", 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisCkeditorComponent_Template_ckeditor_ngModelChange_0_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.data, $event) || (ctx.data = $event);
              return $event;
            });
            i0.ɵɵlistener("dataChange", function HisCkeditorComponent_Template_ckeditor_dataChange_0_listener($event) {
              return ctx.onDataChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "a", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "hisUi");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵtwoWayProperty("ngModel", ctx.data);
            i0.ɵɵproperty("editorUrl", ctx.config.editorUrl)("config", i0.ɵɵpureFunction3(8, _c0$g, ctx.config.configUrl, ctx.getToolbarConfig()["toolbarGroups"], ctx.getToolbarConfig()["removeButtons"]))("hisDdKey", ctx.ddKey);
            i0.ɵɵadvance();
            i0.ɵɵproperty("href", ctx.config.documentationUrl, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 6, "de.his.portal.doku"), ": Arbeiten mit dem Richtext-Editor ");
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2$6.CKEditorComponent, HisDdDirective, HisDdValidator, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisCkeditorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with generic ckeditor components
 */
let HisCkeditorSharedModule = /*#__PURE__*/(() => {
  class HisCkeditorSharedModule {
    static {
      this.ɵfac = function HisCkeditorSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCkeditorSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCkeditorSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, CKEditorModule,
        // HIS
        HisCoreSharedModule]
      });
    }
  }
  return HisCkeditorSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCkeditorSharedModule, {
    declarations: [HisCkeditorComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, CKEditorModule,
    // HIS
    HisCoreSharedModule],
    exports: [HisCkeditorComponent]
  });
})();

/**
 * The core module.
 */
let HisCkeditorModule = /*#__PURE__*/(() => {
  class HisCkeditorModule {
    static {
      this.ɵfac = function HisCkeditorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCkeditorModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCkeditorModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisNavigationService],
        imports: [HisCkeditorSharedModule, HisCkeditorSharedModule]
      });
    }
  }
  return HisCkeditorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCkeditorModule, {
    imports: [HisCkeditorSharedModule],
    exports: [HisCkeditorSharedModule]
  });
})();

/**
 * SharedModule with generic ckeditor components
 */
let HisSummernoteSharedModule = /*#__PURE__*/(() => {
  class HisSummernoteSharedModule {
    static {
      this.ɵfac = function HisSummernoteSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSummernoteSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisSummernoteSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgxSummernoteModule,
        // HIS
        HisCoreSharedModule]
      });
    }
  }
  return HisSummernoteSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisSummernoteSharedModule, {
    declarations: [HisSummernoteComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgxSummernoteModule,
    // HIS
    HisCoreSharedModule],
    exports: [HisSummernoteComponent]
  });
})();

/**
 * The core module.
 */
let HisSummernoteModule = /*#__PURE__*/(() => {
  class HisSummernoteModule {
    static {
      this.ɵfac = function HisSummernoteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSummernoteModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisSummernoteModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisNavigationService],
        imports: [HisSummernoteSharedModule, HisSummernoteSharedModule]
      });
    }
  }
  return HisSummernoteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisSummernoteModule, {
    imports: [HisSummernoteSharedModule],
    exports: [HisSummernoteSharedModule]
  });
})();

/**
 * Service that allows to navigate back to search page
 *
 */
let HisSearchNavigationService = /*#__PURE__*/(() => {
  class HisSearchNavigationService {
    constructor() {
      this.router = inject(Router);
    }
    static {
      this.ANGULAR_CONTEXT = 'a';
    }
    static {
      this.DYNAMIC_SEGMENT_OFFSET = 2;
    }
    static {
      this.ERROR_NO_PREVIOUS_SEARCH = 'HisNavigationService: Navigation to last search form requested, but there was no previous search.';
    }
    /**
     * Navigates to the specified URL with fallback options.
     *
     * @param primaryUrl - The primary URL to navigate to
     * @param fallbackUrl - The fallback URL if primary is unavailable
     * @param errorMessage - Error message to log if navigation fails
     */
    navigateToUrl(primaryUrl, fallbackUrl, errorMessage) {
      const targetUrl = primaryUrl ?? fallbackUrl;
      if (targetUrl) {
        this.tryNavigate(targetUrl);
      } else {
        console.error(errorMessage);
      }
    }
    /**
     * Attempts to navigate using Angular Router, with fallback to direct location change.
     *
     * @param url - The URL to navigate to
     */
    tryNavigate(url) {
      const shortUrl = this.extractShortUrl(url);
      console.log(`HisSearchNavigationService: navigate to ${shortUrl}`);
      this.router.navigateByUrl(shortUrl).catch(() => {
        console.log(`HisSearchNavigationService: route not found for ${shortUrl}, using redirect`);
        window.location.href = url;
      });
    }
    /**
     * Extracts the Angular-compatible route from a complete URL.
     *
     * This method handles extracting dynamic segments after the Angular context marker,
     * preserving query parameters if present.
     *
     * @param url - The complete URL to process
     * @return The extracted route path suitable for Angular routing
     */
    extractShortUrl(url) {
      const urlObj = new URL(url);
      // Split the pathname and remove empty segments
      const segments = urlObj.pathname.split('/').filter(segment => segment.length > 0);
      // Find the Angular context marker position
      const angularContextIndex = segments.indexOf(HisSearchNavigationService.ANGULAR_CONTEXT);
      // If no Angular context is found, use the full pathname
      if (angularContextIndex === -1) {
        return urlObj.pathname;
      }
      // Calculate where dynamic segments begin
      const startIndex = angularContextIndex + HisSearchNavigationService.DYNAMIC_SEGMENT_OFFSET;
      // If there are no segments after the offset, use the full pathname
      if (startIndex >= segments.length) {
        return urlObj.pathname;
      }
      // Extract the dynamic segments that form the Angular route
      const dynamicSegments = segments.slice(startIndex);
      // Create the path with dynamic segments
      const shortPath = `/${dynamicSegments.join('/')}`;
      // Append query parameters if present
      return urlObj.search ? `${shortPath}${urlObj.search}` : shortPath;
    }
    /** Navigate to the new search URL */
    navigateToNewSearch(newSearchUrl) {
      this.navigateToUrl(newSearchUrl, null, HisSearchNavigationService.ERROR_NO_PREVIOUS_SEARCH);
    }
    /** Navigate to the change search URL */
    navigateToChangeSearch(changeSearchUrl) {
      this.navigateToUrl(changeSearchUrl, null, HisSearchNavigationService.ERROR_NO_PREVIOUS_SEARCH);
    }
    static {
      this.ɵfac = function HisSearchNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchNavigationService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisSearchNavigationService,
        factory: HisSearchNavigationService.ɵfac
      });
    }
  }
  return HisSearchNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDialogHeaderPaginatorComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.currentPage(), " / ", ctx_r1.totalPages(), " ");
  }
}
function HisDialogHeaderPaginatorComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" > ", ctx_r1.MAX_ELEMENTS_TO_LOAD, " ");
  }
}
function HisDialogHeaderPaginatorComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDialogHeaderPaginatorComponent_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPreviousPage());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵtemplate(4, HisDialogHeaderPaginatorComponent_Conditional_1_Conditional_4_Template, 1, 2)(5, HisDialogHeaderPaginatorComponent_Conditional_1_Conditional_5_Template, 1, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 3);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵlistener("click", function HisDialogHeaderPaginatorComponent_Conditional_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNextPage());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate2("pTooltip", "", i0.ɵɵpipeBind1(1, 11, "cs.sys.genericSearch.pageBackward"), " ", ctx_r1.navigateBackwardKeys, "");
    i0.ɵɵproperty("disabled", ctx_r1.isFirstPage() || ctx_r1.showPaginator());
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind2(3, 13, "genericSearch.resultIterator.resultToBig", ctx_r1.MAX_ELEMENTS_TO_LOAD));
    i0.ɵɵproperty("tooltipDisabled", !ctx_r1.showPaginator());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.showPaginator() ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("pTooltip", "", i0.ɵɵpipeBind1(7, 16, "cs.sys.genericSearch.pageForward"), " ", ctx_r1.navigateForwardKeys, "");
    i0.ɵɵproperty("disabled", ctx_r1.isLastPage() || ctx_r1.showPaginator());
  }
}
var PaginatorKeybindings = /*#__PURE__*/function (PaginatorKeybindings) {
  PaginatorKeybindings["NavigateBackward"] = "Shift + Alt + V";
  PaginatorKeybindings["NavigateForward"] = "Shift + Alt + D";
  return PaginatorKeybindings;
}(PaginatorKeybindings || {});
let HisDialogHeaderPaginatorComponent = /*#__PURE__*/(() => {
  class HisDialogHeaderPaginatorComponent {
    constructor() {
      this.MAX_ELEMENTS_TO_LOAD = 500; // The maximum number of elements to load.
      this.INDEX_FIRST_PAGE = 1;
      //Event emitted when navigating to the previous element.
      this.previousElement = new EventEmitter();
      //Event emitted when navigating to the next element.
      this.nextElement = new EventEmitter();
      this.elements = input();
      this.initialIndex = 0;
      this.navigateBackwardKeys = PaginatorKeybindings.NavigateBackward;
      this.navigateForwardKeys = PaginatorKeybindings.NavigateForward;
    }
    ngOnChanges(changes) {
      if (changes.initialIndex && this.currentIndex !== undefined) {
        this.currentIndex.set(this.initialIndex);
      }
    }
    ngOnInit() {
      this.currentIndex = signal(this.initialIndex);
      this.currentPage = computed(() => this.currentIndex() + 1);
      this.totalPages = computed(() => this.elements()?.length); // The total number of pages. needs to be a signal as it is used in some `computed`
      this.showButtons = computed(() => !!this.elements()?.length);
      this.isFirstPage = computed(() => this.currentPage() === this.INDEX_FIRST_PAGE);
      this.isLastPage = computed(() => this.currentPage() === this.totalPages());
      this.showPaginator = computed(() => this.totalPages() > this.MAX_ELEMENTS_TO_LOAD);
    }
    onPreviousPage() {
      if (this.isFirstPage()) {
        return;
      }
      const current = this.currentIndex();
      this.currentIndex.update(value => value - 1);
      const next = this.currentIndex();
      this.navigateAndEmitPageChange(current, next, this.previousElement);
    }
    onNextPage() {
      if (this.isLastPage()) {
        return;
      }
      const current = this.currentIndex();
      this.currentIndex.update(value => value + 1);
      const next = this.currentIndex();
      this.navigateAndEmitPageChange(current, next, this.nextElement);
    }
    /**
    * Updates the current page and emits navigation event.
    * @private
    * @param {number} currentIndex - The current page index
    * @param {number} newIndex - The new page index to navigate to
    * @param {EventEmitter<PaginationEvent>} emitter - The event emitter to use
    */
    navigateAndEmitPageChange(currentIndex, newIndex, emitter) {
      this.initialIndex = newIndex;
      emitter.emit({
        currentIndex: currentIndex,
        newIndex: newIndex,
        currentObjectIdentifier: this.getElementIdAtIndex(currentIndex),
        newObjectIdentifier: this.getElementIdAtIndex(newIndex)
      });
    }
    getElementIdAtIndex(index) {
      return this.elements()[index] || null;
    }
    handleKeyboardEvent(event) {
      if (!(event.shiftKey && event.altKey)) {
        return;
      }
      switch (event.key.toUpperCase()) {
        case 'V':
          if (!this.isFirstPage()) {
            this.onPreviousPage();
          }
          break;
        case 'D':
          if (!this.isLastPage()) {
            this.onNextPage();
          }
          break;
      }
    }
    static {
      this.ɵfac = function HisDialogHeaderPaginatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDialogHeaderPaginatorComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDialogHeaderPaginatorComponent,
        selectors: [["his-dialog-header-paginator"]],
        hostBindings: function HisDialogHeaderPaginatorComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function HisDialogHeaderPaginatorComponent_keydown_HostBindingHandler($event) {
              return ctx.handleKeyboardEvent($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          elements: [1, "elements"],
          initialIndex: "initialIndex"
        },
        outputs: {
          previousElement: "previousElement",
          nextElement: "nextElement"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "paginator-container"], ["type", "submit", "iconPos", "left", "hisImage", "RESULTSET_BACKWARD", 1, "transparent", 3, "click", "disabled", "pTooltip"], ["tooltipPosition", "top", 3, "pTooltip", "tooltipDisabled"], ["type", "submit", "iconPos", "left", "hisImage", "RESULTSET_FORWARD", 1, "transparent", 3, "click", "disabled", "pTooltip"]],
        template: function HisDialogHeaderPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, HisDialogHeaderPaginatorComponent_Conditional_1_Template, 8, 18);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showButtons() ? 1 : -1);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, i4$4.Tooltip, HisUiPipe],
        styles: [".paginator-container[_ngcontent-%COMP%]{display:flex;align-items:center}"]
      });
    }
  }
  return HisDialogHeaderPaginatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$f = ["dataBox"];
const _c1$6 = [[["", "dataBox", ""]], [["", "customButtons", ""]], [["", "elementsRight", ""]]];
const _c2$2 = ["[dataBox]", "[customButtons]", "[elementsRight]"];
function HisDialogHeaderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCustomEvent($event));
    })("blur", function HisDialogHeaderComponent_Conditional_5_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.customButtonClass);
    i0.ɵɵpropertyInterpolate("hisImage", ctx_r1.customButtonImage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, ctx_r1.customButtonLabel));
  }
}
function HisDialogHeaderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSaveDraft($event));
    })("blur", function HisDialogHeaderComponent_Conditional_6_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.saveDraft"));
  }
}
function HisDialogHeaderComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_7_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDeleteDraft($event));
    })("blur", function HisDialogHeaderComponent_Conditional_7_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.deleteDraft"));
  }
}
function HisDialogHeaderComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_8_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSave($event));
    })("blur", function HisDialogHeaderComponent_Conditional_8_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.save"));
  }
}
function HisDialogHeaderComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_9_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSaveAndBack($event));
    })("blur", function HisDialogHeaderComponent_Conditional_9_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.saveAndGoBack"));
  }
}
function HisDialogHeaderComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onResetInputs($event));
    })("blur", function HisDialogHeaderComponent_Conditional_10_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.reset"));
  }
}
function HisDialogHeaderComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.backToSearchResult());
    })("blur", function HisDialogHeaderComponent_Conditional_11_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.backToSearchResult"));
  }
}
function HisDialogHeaderComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.backToSearch());
    })("blur", function HisDialogHeaderComponent_Conditional_12_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.backToSearchPage"));
  }
}
function HisDialogHeaderComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.back());
    })("blur", function HisDialogHeaderComponent_Conditional_13_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "common.back"));
  }
}
function HisDialogHeaderComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNewSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.newsearch"));
  }
}
function HisDialogHeaderComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function HisDialogHeaderComponent_Conditional_15_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.changesearch"));
  }
}
function HisDialogHeaderComponent_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-dialog-header-paginator", 19);
    i0.ɵɵlistener("nextElement", function HisDialogHeaderComponent_Conditional_17_Template_his_dialog_header_paginator_nextElement_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPaginatorNextElement($event));
    })("previousElement", function HisDialogHeaderComponent_Conditional_17_Template_his_dialog_header_paginator_previousElement_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPaginatorPreviousElement($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("elements", ctx_r1.paginatorElements)("initialIndex", ctx_r1.paginatorIndex);
  }
}
let HisDialogHeaderComponent = /*#__PURE__*/(() => {
  class HisDialogHeaderComponent {
    constructor() {
      this.cdRef = inject(ChangeDetectorRef);
      this.navigationService = inject(HisNavigationService);
      this.notificationService = inject(HisNotificationService);
      this.searchNavigationService = inject(HisSearchNavigationService);
      this.dialogHeaderPaginatorService = inject(HisDialogHeaderPaginatorService);
      this.showDataBox = false;
      this.showSaveButton = true;
      this.showDraftSaveButton = false;
      this.showDraftDeleteButton = false;
      this.showCustomButton = false;
      this.customButtonImage = '';
      this.customButtonClass = '';
      this.showSaveAndBackButton = false;
      this.showBackButton = true;
      this.showResetButton = true;
      this.showSearchButton = true;
      this.showChangeSearchButton = true;
      this.showNewSearchButton = true;
      // event emitter to notify the enveloping component that the "save" button was pressed
      this.save = new EventEmitter();
      this.saveDraft = new EventEmitter();
      this.deleteDraft = new EventEmitter();
      this.customEvent = new EventEmitter();
      // event emitter to notify the enveloping component that the "reset inputs" button was pressed
      this.resetInputs = new EventEmitter();
      /**
       * Event emitter to notify the enveloping component that the "paginator previous" button was pressed
       * IMPORTANT: result paginator will only be displayed if both paginatorPreviousElement and paginatorNextElement are observed
       */
      this.paginatorPreviousElement = new EventEmitter();
      /**
       * Event emitter to notify the enveloping component that the "paginator next" button was pressed
       * IMPORTANT: result paginator will only be displayed if both paginatorPreviousElement and paginatorNextElement are observed
       */
      this.paginatorNextElement = new EventEmitter();
      this.lastButtonClickTimestamp = 0;
      this.DOUBLE_CLICK_DELAY = 500;
      this.paginatorServiceSubscriptions$ = [];
      this.renderPaginator = false;
    }
    ngOnInit() {
      this.navigationService.startDirtyTracking();
      this.renderPaginator = this.paginatorPreviousElement.observed && this.paginatorNextElement.observed;
      this.initializeNavigationContextFromService();
    }
    ngOnDestroy() {
      this.navigationService.stopDirtyTracking();
      this.dialogHeaderPaginatorService.clear();
      this.paginatorServiceSubscriptions$.forEach(s => s.unsubscribe());
    }
    ngAfterViewInit() {
      // Die Datenbox soll nur angezeigt werden, wenn sie auch Inhalt hat. Die Implementierung der
      // Erkennung folgt https://stackoverflow.com/questions/38692881/how-to-check-whether-ng-content-exists
      this.showDataBox = this.dataBox.nativeElement && this.dataBox.nativeElement.children.length > 0;
      this.cdRef.detectChanges();
    }
    onSave($event) {
      if (Date.now() > this.lastButtonClickTimestamp + this.DOUBLE_CLICK_DELAY) {
        this.lastButtonClickTimestamp = Date.now();
        this.notificationService.clear();
        this.save.emit($event);
      }
      HisDdDirective.removeErrorIconInTab();
    }
    onSaveDraft($event) {
      if (Date.now() > this.lastButtonClickTimestamp + this.DOUBLE_CLICK_DELAY) {
        this.lastButtonClickTimestamp = Date.now();
        this.notificationService.clear();
        this.saveDraft.emit($event);
      }
      HisDdDirective.removeErrorIconInTab();
    }
    onDeleteDraft($event) {
      if (Date.now() > this.lastButtonClickTimestamp + this.DOUBLE_CLICK_DELAY) {
        this.lastButtonClickTimestamp = Date.now();
        this.notificationService.clear();
        this.deleteDraft.emit($event);
      }
    }
    onCustomEvent($event) {
      if (Date.now() > this.lastButtonClickTimestamp + this.DOUBLE_CLICK_DELAY) {
        this.lastButtonClickTimestamp = Date.now();
        this.notificationService.clear();
        this.customEvent.emit($event);
      }
    }
    onResetInputs($event) {
      // "reset inputs" means the page must be restored from the database.
      // So all we can do here is to pass the event to the enveloping component.
      if (Date.now() > this.lastButtonClickTimestamp + this.DOUBLE_CLICK_DELAY) {
        this.lastButtonClickTimestamp = Date.now();
        this.resetInputs.emit($event);
      }
      this.navigationService.dirty = false;
    }
    onBlur() {
      this.lastButtonClickTimestamp = 0;
    }
    back() {
      this.navigationService.navigateToLastBackUrl();
    }
    hasPreviousSearchPage() {
      return this.navigationService.hasPreviousSearchUrl();
    }
    backToSearch() {
      this.navigationService.navigateToLastSearchUrl();
    }
    hasPreviousSearchResultPage() {
      return this.navigationService.hasPreviousSearchResultUrl();
    }
    hasBackUrl() {
      return this.navigationService.hasLastBackUrl();
    }
    backToSearchResult() {
      this.navigationService.navigateToLastSearchResultUrl();
    }
    // called by save and back button - sends called as payload to inform parent component that
    // back() has to be called after saving is finished
    onSaveAndBack($event) {
      if (Date.now() > this.lastButtonClickTimestamp + this.DOUBLE_CLICK_DELAY) {
        this.lastButtonClickTimestamp = Date.now();
        let called = true;
        this.save.emit({
          $event,
          called
        });
      }
    }
    onNewSearch() {
      // navigate back to search page
      return this.searchNavigationService.navigateToNewSearch(this.newSearchUrl);
    }
    onChangeSearch() {
      sessionStorage.setItem(HisSessionStorageKeys.CS_SYS_LAST_SEARCH_BUTTON, 'CHANGE_SEARCH');
      return this.searchNavigationService.navigateToChangeSearch(this.changeSearchUrl);
    }
    hasNewSearchUrl() {
      return !!this.newSearchUrl;
    }
    hasChangeSearchUrl() {
      return !!this.changeSearchUrl;
    }
    onPaginatorNextElement(event) {
      this.paginatorIndex = event.newIndex;
      this.paginatorNextElement.emit(event);
    }
    onPaginatorPreviousElement(event) {
      this.paginatorIndex = event.newIndex;
      this.paginatorPreviousElement.emit(event);
    }
    initializeNavigationContextFromService() {
      this.paginatorServiceSubscriptions$.push(this.dialogHeaderPaginatorService.getData().subscribe(context => {
        if (this.renderPaginator) {
          this.paginatorElements = context.ids;
          this.paginatorIndex = context.index;
        }
        this.changeSearchUrl = context.changeSearchUrl;
        this.newSearchUrl = context.newSearchUrl;
      }));
    }
    static {
      this.ɵfac = function HisDialogHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDialogHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDialogHeaderComponent,
        selectors: [["his-dialog-header"]],
        viewQuery: function HisDialogHeaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$f, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataBox = _t.first);
          }
        },
        inputs: {
          showSaveButton: "showSaveButton",
          showDraftSaveButton: "showDraftSaveButton",
          showDraftDeleteButton: "showDraftDeleteButton",
          showCustomButton: "showCustomButton",
          customButtonLabel: "customButtonLabel",
          customButtonImage: "customButtonImage",
          customButtonClass: "customButtonClass",
          showSaveAndBackButton: "showSaveAndBackButton",
          showBackButton: "showBackButton",
          showResetButton: "showResetButton",
          showSearchButton: "showSearchButton",
          showChangeSearchButton: "showChangeSearchButton",
          showNewSearchButton: "showNewSearchButton"
        },
        outputs: {
          save: "save",
          saveDraft: "saveDraft",
          deleteDraft: "deleteDraft",
          customEvent: "customEvent",
          resetInputs: "resetInputs",
          paginatorPreviousElement: "paginatorPreviousElement",
          paginatorNextElement: "paginatorNextElement"
        },
        standalone: false,
        ngContentSelectors: _c2$2,
        decls: 21,
        vars: 13,
        consts: [["dataBox", ""], ["id", "dialogHeader", 1, "dialogHeaderContainer"], ["id", "dataBox", 1, "box_noheader_bg_yellow", "dataBox", 3, "hidden"], [1, "elementsLeftContainer"], ["default", "false", "name", "dialogHeaderButton", 3, "hisImage", "class"], ["default", "false", "name", "dialogHeaderButton"], ["default", "true", "name", "dialogHeaderButton"], ["name", "dialogHeaderButton"], ["type", "submit", "iconPos", "left", 1, "newSearchButton"], ["type", "submit", "iconPos", "left", 1, "changeSearchButton"], [3, "elements", "initialIndex"], [1, "elementsRightContainer"], [1, "clearer"], ["default", "false", "name", "dialogHeaderButton", 3, "click", "blur", "hisImage"], ["default", "false", "name", "dialogHeaderButton", 3, "click", "blur"], ["default", "true", "name", "dialogHeaderButton", 3, "click", "blur"], ["name", "dialogHeaderButton", 3, "click", "blur"], ["type", "submit", "iconPos", "left", 1, "newSearchButton", 3, "click"], ["type", "submit", "iconPos", "left", 1, "changeSearchButton", 3, "click"], [3, "nextElement", "previousElement", "elements", "initialIndex"]],
        template: function HisDialogHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1$6);
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵtemplate(5, HisDialogHeaderComponent_Conditional_5_Template, 4, 7, "button", 4)(6, HisDialogHeaderComponent_Conditional_6_Template, 4, 3, "button", 5)(7, HisDialogHeaderComponent_Conditional_7_Template, 4, 3, "button", 5)(8, HisDialogHeaderComponent_Conditional_8_Template, 4, 3, "button", 6)(9, HisDialogHeaderComponent_Conditional_9_Template, 4, 3, "button", 5)(10, HisDialogHeaderComponent_Conditional_10_Template, 4, 3, "button", 7)(11, HisDialogHeaderComponent_Conditional_11_Template, 4, 3, "button", 7)(12, HisDialogHeaderComponent_Conditional_12_Template, 4, 3, "button", 7)(13, HisDialogHeaderComponent_Conditional_13_Template, 4, 3, "button", 7)(14, HisDialogHeaderComponent_Conditional_14_Template, 4, 3, "button", 8)(15, HisDialogHeaderComponent_Conditional_15_Template, 4, 3, "button", 9);
            i0.ɵɵprojection(16, 1);
            i0.ɵɵtemplate(17, HisDialogHeaderComponent_Conditional_17_Template, 1, 2, "his-dialog-header-paginator", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div", 11);
            i0.ɵɵprojection(19, 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(20, "div", 12);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", !ctx.showDataBox);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showCustomButton ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDraftSaveButton ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDraftDeleteButton ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSaveButton ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSaveAndBackButton ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showResetButton ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSearchButton && ctx.hasPreviousSearchResultPage() ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSearchButton && !ctx.hasPreviousSearchResultPage() && ctx.hasPreviousSearchPage() ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showBackButton && ctx.hasBackUrl() ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showNewSearchButton && ctx.hasNewSearchUrl() ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showChangeSearchButton && ctx.hasChangeSearchUrl() ? 15 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.renderPaginator ? 17 : -1);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisDialogHeaderPaginatorComponent, HisUiPipe],
        styles: [".dialogHeaderContainer[_ngcontent-%COMP%]{margin-bottom:5px;margin-top:5px}.dataScrollerContainer[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;margin-top:3px}.dataBox[_ngcontent-%COMP%]{padding:.5em}@media screen and (max-width: 768px){.dialogHeaderContainer[_ngcontent-%COMP%]   .elementsLeftContainer[_ngcontent-%COMP%]{padding-left:0}}.dialogHeaderLabelCheckbox[_ngcontent-%COMP%]{float:right;white-space:nowrap}.box_noheader_bg_yellow[_ngcontent-%COMP%]{background-color:#fcf8e3;clear:left;box-sizing:border-box;margin-bottom:1px;padding:8px;border-radius:2px}.dialogHeaderContainer[_ngcontent-%COMP%]   .elementsRightContainer[_ngcontent-%COMP%]{float:right}his-dialog-header-paginator[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;margin-left:5px}"]
      });
    }
  }
  return HisDialogHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDocumentationLinkComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 0);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("href", "../../pages/cs/sys/portal/documentation/documentation.faces?\n\tnavigationPosition=documentation&site=", ctx_r0.target, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate3("title", "", i0.ɵɵpipeBind1(1, 7, "common.openInNewWindow"), ": ", i0.ɵɵpipeBind1(2, 9, "cs.sys.co.cc.export.help_6"), " ", i0.ɵɵpipeBind1(3, 11, ctx_r0.title), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 13, "de.his.portal.doku"));
  }
}
let HisDocumentationLinkComponent = /*#__PURE__*/(() => {
  class HisDocumentationLinkComponent {
    constructor() {
      this.auth = inject(HisAuthService);
      this.title = 'de.his.portal.doku';
    }
    static {
      this.ɵfac = function HisDocumentationLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDocumentationLinkComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDocumentationLinkComponent,
        selectors: [["his-documentation-link"]],
        inputs: {
          target: "target",
          title: "title"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["hisImage", "LINK_EXTERN", "target", "_blank", 1, "documentationLink", 3, "href", "title"]],
        template: function HisDocumentationLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisDocumentationLinkComponent_Conditional_0_Template, 6, 15, "a", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.auth.hasAll("RIGHT_CS_SYS_HELP_READ_DOCUMENTATION") && ctx.target ? 0 : -1);
          }
        },
        dependencies: [HisImageDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDocumentationLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisTranslatedTextComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "span", 1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "span", 2);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("hisImage", "FLAG_", ctx_r0.hisObjectLanguage.iso_639_1, "");
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 5, ctx_r0.hisAttribute) + " " + i0.ɵɵpipeBind1(3, 7, ctx_r0.hisObjectLanguageI18nKey));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("lang", ctx_r0.hisObjectLanguage.iso_639_1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hisobject[ctx_r0.attributeName]);
  }
}
function HisTranslatedTextComponent_Conditional_0_For_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
}
function HisTranslatedTextComponent_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "span", 1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementStart(4, "span", 2);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, HisTranslatedTextComponent_Conditional_0_For_2_Conditional_6_Template, 1, 0, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r2 = ctx.$implicit;
    const ɵ$index_14_r3 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("hisImage", "FLAG_", entry_r2[0], "");
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(3, 8, "cs.sys.hisng.translationLabel_" + entry_r2[0], i0.ɵɵpipeBind1(2, 6, ctx_r0.hisAttribute)));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("lang", entry_r2[0]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(entry_r2[1]);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_14_r3 < ctx_r0.translationEntries.length - 1 ? 6 : -1);
  }
}
function HisTranslatedTextComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisTranslatedTextComponent_Conditional_0_Conditional_0_Template, 7, 9, "div");
    i0.ɵɵrepeaterCreate(1, HisTranslatedTextComponent_Conditional_0_For_2_Template, 7, 11, "div", null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((ctx_r0.hisobject[ctx_r0.attributeName] == null ? null : ctx_r0.hisobject[ctx_r0.attributeName].length) > 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.translationEntries);
  }
}
function HisTranslatedTextComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("lang", ctx_r0.language);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.translatedText);
  }
}
let HisTranslatedTextComponent = /*#__PURE__*/(() => {
  class HisTranslatedTextComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisTranslationService = inject(HisTranslationService);
      this.viewAll = false;
      this.translatedText = '';
      this.translationEntries = [];
      this.language = this.hisBaseGlobalsService.getLanguage();
    }
    ngOnInit() {
      this.attributeName = this.hisAttribute.split('.').pop();
      if (!this.isHisObjectEmpty() && this.isPropertyOfObject()) {
        this.translatedText = this.getTranslatedText(this.hisobject, this.attributeName, this.language);
        if (this.viewAll) {
          this.readAllTranslations();
        }
      }
    }
    ngOnChanges(changes) {
      if (changes.hisobject || changes.hisAttribute) {
        if (!this.isHisObjectEmpty() && this.hisAttribute) {
          this.attributeName = this.hisAttribute.split('.').pop();
          if (this.isPropertyOfObject()) {
            this.translatedText = this.getTranslatedText(this.hisobject, this.attributeName, this.language);
            if (this.viewAll) {
              this.readAllTranslations();
            }
          }
        }
      }
    }
    getTranslatedText(hisobject, hisAttribute, language) {
      let translatedText = '';
      if (hisobject[hisAttribute] == null || hisobject[hisAttribute].length === 0) {
        console.warn('Value of attribute named \'', hisAttribute, '\' in object ', hisobject, ' is empty. Will now try to find a foreign text for it.');
      }
      if (this.hisTranslationService.isTranslationExisting(hisobject, hisAttribute, language)) {
        translatedText = this.hisTranslationService.translate(hisobject, hisAttribute, language);
      }
      if (translatedText.length === 0) {
        if (hisobject.language) {
          this.language = hisobject.language.iso_639_1;
        } else if (hisobject.languages && hisobject.languages.length > 0 && hisobject.languages[0]) {
          this.language = hisobject.languages[0].iso_639_1;
        }
        translatedText = this.hisTranslationService.translate(hisobject, hisAttribute, this.language);
      }
      if (this.maxLength && translatedText.length > this.maxLength) {
        return this.shortenText(translatedText);
      } else {
        return translatedText;
      }
    }
    /* substring text to maxLength or last full word */
    shortenText(text) {
      let textLength = this.maxLength;
      while ((text.charAt(textLength) !== ' ' || text?.charAt(textLength).match('\n')) && textLength !== 0) {
        textLength--;
      }
      return text.substring(0, textLength) + ' ...';
    }
    getLanguage() {
      return this.language;
    }
    isHisObjectEmpty() {
      if (this.hisobject == null || Object.values(this.hisobject).filter(v => !!v).length === 0) {
        console.warn('Hisobject is ', this.hisobject);
        return true;
      }
      return false;
    }
    isPropertyOfObject() {
      if (!this.attributeName) {
        console.warn('Attribute is ', this.attributeName);
        return false;
      }
      if (!Object.prototype.hasOwnProperty.call(this.hisobject, this.attributeName)) {
        console.warn('No attribute named \'', this.attributeName, '\' present in object ', this.hisobject);
        return false;
      }
      return true;
    }
    readAllTranslations() {
      let allTanslationsMap = new Map();
      this.hisObjectLanguage = this.hisobject.language ? this.hisobject.language : this.hisobject.languages?.length > 0 ? this.hisobject.languages[0] : null;
      this.hisObjectLanguageI18nKey = 'view.translate.' + this.hisObjectLanguage.iso_639_1;
      if (this.language !== this.hisObjectLanguage.iso_639_1 && this.translatedText?.length > 0 && !allTanslationsMap.has(this.language)) {
        allTanslationsMap.set(this.language, this.translatedText);
      }
      for (let lang in this.hisobject._foreigntext) {
        if (!allTanslationsMap.has(lang)) {
          let ft = this.hisobject._foreigntext[lang][this.attributeName];
          if (ft?.length > 0) {
            allTanslationsMap.set(lang, ft);
          }
        }
      }
      this.translationEntries = Array.from(allTanslationsMap.entries());
    }
    static {
      this.ɵfac = function HisTranslatedTextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslatedTextComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTranslatedTextComponent,
        selectors: [["his-translated-text"]],
        inputs: {
          hisobject: "hisobject",
          hisAttribute: "hisAttribute",
          maxLength: "maxLength",
          viewAll: "viewAll"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "wordBreak", 3, "lang"], [3, "hisImage", "title"], [1, "wordBreak", 2, "padding", "4px", 3, "lang"], [1, "clearerSpaceAboveHalfEm"]],
        template: function HisTranslatedTextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisTranslatedTextComponent_Conditional_0_Template, 3, 1)(1, HisTranslatedTextComponent_Conditional_1_Template, 2, 2, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.viewAll && ctx.translationEntries.length > 0 ? 0 : 1);
          }
        },
        dependencies: [HisImageDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisTranslatedTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$e = a0 => [a0];
const _c1$5 = () => ({
  showBackButton: true
});
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Conditional_0_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onBeforeNavigate());
    });
    i0.ɵɵelement(2, "his-translated-text", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", entry_r3.viewUrlTooltip ? ctx_r1.getTranslation("viewUrlTooltip", entry_r3) : i0.ɵɵpipeBind2(1, 5, "common.showOf", entry_r3.secondaryDetails ? ctx_r1.getSecondaryDetails(entry_r3) : ctx_r1.getTranslation("nameTitle", entry_r3).split(":")[0] + " " + ctx_r1.getTranslation("objectName", entry_r3)));
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(8, _c0$e, ctx_r1.getRouterLinkUrl(entry_r3.viewUrl)))("queryParams", i0.ɵɵpureFunction0(10, _c1$5));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hisobject", entry_r3)("hisAttribute", "objectName");
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Conditional_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onBeforeNavigate());
    });
    i0.ɵɵelement(2, "his-translated-text", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate2("href", "", entry_r3.viewUrl, "?showBackButton=true", ctx_r1.getQueryParamShowSearchButton(entry_r3), "", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("title", entry_r3.viewUrlTooltip ? ctx_r1.getTranslation("viewUrlTooltip", entry_r3) : i0.ɵɵpipeBind2(1, 6, "common.showOf", entry_r3.secondaryDetails ? ctx_r1.getSecondaryDetails(entry_r3) : ctx_r1.getTranslation("nameTitle", entry_r3).split(":")[0] + " " + ctx_r1.getTranslation("objectName", entry_r3)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hisobject", entry_r3)("hisAttribute", "objectName");
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Conditional_0_Template, 3, 11, "a", 11)(1, HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Conditional_1_Template, 3, 9, "a", 12);
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.isSameRouterContext(entry_r3.viewUrl) ? 0 : 1);
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-translated-text", 9);
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("hisobject", entry_r3)("hisAttribute", "objectName");
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getTranslation("details", entry_r3));
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getTranslation("prefix", entry_r3.detailsObject));
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getTranslation("suffix", entry_r3.detailsObject));
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, HisListviewEntryComponent_Conditional_0_For_12_Conditional_4_Conditional_1_Template, 2, 1, "span");
    i0.ɵɵelement(2, "his-translated-text", 9);
    i0.ɵɵtemplate(3, HisListviewEntryComponent_Conditional_0_For_12_Conditional_4_Conditional_3_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r3.detailsObject.prefix ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hisobject", entry_r3.detailsObject)("hisAttribute", "title");
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r3.detailsObject.suffix ? 3 : -1);
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.getTranslation("secondaryDetails", entry_r3), " ");
  }
}
function HisListviewEntryComponent_Conditional_0_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, HisListviewEntryComponent_Conditional_0_For_12_Conditional_1_Template, 2, 1)(2, HisListviewEntryComponent_Conditional_0_For_12_Conditional_2_Template, 1, 2, "his-translated-text", 9)(3, HisListviewEntryComponent_Conditional_0_For_12_Conditional_3_Template, 2, 1, "div", 10)(4, HisListviewEntryComponent_Conditional_0_For_12_Conditional_4_Template, 4, 4, "div", 10)(5, HisListviewEntryComponent_Conditional_0_For_12_Conditional_5_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r3.viewUrl ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(entry_r3.detailsObject == null ? null : entry_r3.detailsObject.title) ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((entry_r3.detailsObject == null ? null : entry_r3.detailsObject.title) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(entry_r3.secondaryDetails ? 5 : -1);
  }
}
function HisListviewEntryComponent_Conditional_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵpipe(1, "hisLowerCaseFirstLetter");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisListviewEntryComponent_Conditional_0_Conditional_13_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.moreEntriesClicked($event));
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate6("href", "", ctx_r1.listview.searchUrl, "?configFile=", ctx_r1.listview.searchQueryParams["configFile"], "\n\t\t\t\t\t&pageTitle=", ctx_r1.listview.searchQueryParams["pageTitle"], "\n\t\t\t\t\t&tableTitle=", ctx_r1.listview.searchQueryParams["tableTitle"], "\n\t\t\t\t\t&showChangeSearchButton=", ctx_r1.listview.searchQueryParams["showChangeSearchButton"], "\n\t\t\t\t\t&", ctx_r1.listview.searchQueryParams["objectIdFilter"], "\n\t\t\t\t\t&showBackButton=true&isNotActiveSearch=true", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(2, 11, "fs.res.common.showAllAssignedObjects", i0.ɵɵpipeBind1(1, 9, ctx_r1.getTranslation("title", ctx_r1.listview))));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 14, "common.more"));
  }
}
function HisListviewEntryComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div");
    i0.ɵɵelement(5, "img", 4);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "h2");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "ul", 7);
    i0.ɵɵrepeaterCreate(11, HisListviewEntryComponent_Conditional_0_For_12_Template, 6, 4, "li", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, HisListviewEntryComponent_Conditional_0_Conditional_13_Template, 6, 16, "a", 8);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("hisImage", ctx_r1.listview.icon);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.getTranslation("title", ctx_r1.listview));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r1.getTranslation("title", ctx_r1.listview), " (", ctx_r1.listview.totalCount, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.listview.listViewData);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.listview.totalCount > 3 && ctx_r1.listview.searchQueryParams ? 13 : -1);
  }
}
let HisListviewEntryComponent = /*#__PURE__*/(() => {
  class HisListviewEntryComponent {
    constructor() {
      this.hisTranslationService = inject(HisTranslationService);
      this.navigationService = inject(HisNavigationService);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.btnMoreClicked = new EventEmitter();
    }
    getSecondaryDetails(hisObject) {
      let details = this.getTranslation('secondaryDetails', hisObject);
      return details.substring(1, details.length - 1);
    }
    getTranslation(hisAttribute, hisObject) {
      return this.hisTranslationService.translate(hisObject, hisAttribute);
    }
    isSameRouterContext(entryViewUrl) {
      let routerContext = this.getExtensionRouterContext(entryViewUrl);
      if (window.location.href.includes(routerContext)) {
        // console.log( 'HisListviewEntryComponent using router link navigation to context:', routerContext );
        return true;
      }
      // console.log( 'HisListviewEntryComponent using href link navigation to context:', routerContext );
      return false;
    }
    getRouterLinkUrl(entryViewUrl) {
      return entryViewUrl.replace('../' + this.getExtensionRouterContext(entryViewUrl), '');
    }
    moreEntriesClicked(event) {
      if (this.customClickHandler) {
        event.preventDefault();
        this.btnMoreClicked.emit(true);
      } else {
        this.onBeforeNavigate();
      }
    }
    getQueryParamShowSearchButton(entry) {
      if (entry.viewQueryParams && typeof entry.viewQueryParams.showSearchButton !== 'undefined') {
        return `&showSearchButton=${entry.viewQueryParams.showSearchButton}`;
      } else {
        return '';
      }
    }
    getExtensionRouterContext(url) {
      let firstIndexSlash = url.indexOf('/') + 1;
      let secondIndexSlash = url.indexOf('/', url.indexOf('/') + 1);
      return url.substring(firstIndexSlash, secondIndexSlash);
    }
    /* leaving page action use onBeforeNavigate set last back url with navigationService */
    onBeforeNavigate() {
      this.navigationService.setLastBackUrl(window.location.href);
    }
    static {
      this.ɵfac = function HisListviewEntryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisListviewEntryComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisListviewEntryComponent,
        selectors: [["his-listviewentry"]],
        inputs: {
          listview: "listview",
          customClickHandler: "customClickHandler"
        },
        outputs: {
          btnMoreClicked: "btnMoreClicked"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "layoutBlock"], [1, "listviewBadgeLeft"], [1, "circleIconContainer"], [1, "circle-icon"], [1, "inlineicon", 3, "hisImage", "title"], [1, "listviewSideRight"], [1, "citation"], [1, "listSimple"], ["hisImage", "next", 1, "transparent", 3, "href", "title"], [3, "hisobject", "hisAttribute"], [1, "small"], [3, "routerLink", "queryParams", "title"], [3, "href", "title"], [3, "click", "routerLink", "queryParams", "title"], [3, "click", "href", "title"], ["hisImage", "next", 1, "transparent", 3, "click", "href", "title"]],
        template: function HisListviewEntryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisListviewEntryComponent_Conditional_0_Template, 14, 5, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.listview && ctx.listview.totalCount > 0 ? 0 : -1);
          }
        },
        dependencies: [i1$3.RouterLink, HisImageDirective, HisTranslatedTextComponent, HisUiPipe, HisLowercasefirstletterPipe],
        encapsulation: 2
      });
    }
  }
  return HisListviewEntryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisListviewComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-listviewentry", 6);
    i0.ɵɵlistener("btnMoreClicked", function HisListviewComponent_For_5_Template_his_listviewentry_btnMoreClicked_0_listener() {
      const listview_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.btnMoreClicked.emit(ctx_r2.getListviewKey(listview_r2)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const listview_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customClickHandler", ctx_r2.customClickHandler)("listview", listview_r2);
  }
}
let HisListviewComponent = /*#__PURE__*/(() => {
  class HisListviewComponent {
    constructor() {
      this.customClickHandler = false;
      this.btnMoreClicked = new EventEmitter();
      this.oneListviews = [];
    }
    ngOnChanges() {
      this.oneListviews = [];
      if (!_.isEmpty(this.listviewData) && !_.isEmpty(this.listviewKeys)) {
        for (let listviewKey of this.listviewKeys) {
          if (this.listviewData[listviewKey]?.totalCount && !this.listviewData[listviewKey].isHidden) {
            this.oneListviews.push(this.listviewData[listviewKey]);
          }
        }
      }
    }
    /***************** GUI Helper Methoden **********************/
    /* check if a listview column has content or not */
    isEmptyListviewArray(listviews) {
      if (listviews) {
        for (let listview of listviews) {
          if (listview && listview.listViewData && listview.listViewData.length > 0) {
            return false;
          }
        }
      }
      return true;
    }
    getListviewKey(listview) {
      return this.listviewKeys.find(lv => this.listviewData[lv] === listview);
    }
    static {
      this.ɵfac = function HisListviewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisListviewComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisListviewComponent,
        selectors: [["his-listview"]],
        inputs: {
          listviewData: "listviewData",
          listviewKeys: "listviewKeys",
          customClickHandler: "customClickHandler"
        },
        outputs: {
          btnMoreClicked: "btnMoreClicked"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 0,
        consts: [[1, "layoutBlock", "detailpage"], [1, "detailpageSideLeft"], [1, "detailpageCenter"], [1, "layoutBlock", "listviewentryWrap"], [3, "customClickHandler", "listview"], [1, "detailpageSideRight"], [3, "btnMoreClicked", "customClickHandler", "listview"]],
        template: function HisListviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵrepeaterCreate(4, HisListviewComponent_For_5_Template, 1, 2, "his-listviewentry", 4, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.oneListviews);
          }
        },
        dependencies: [HisListviewEntryComponent],
        encapsulation: 2
      });
    }
  }
  return HisListviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisRequestComponent = /*#__PURE__*/(() => {
  class HisRequestComponent {
    constructor() {
      this.requestChange = new EventEmitter();
      this.requestApprovalStatusList = ['Abgelehnt', 'Genehmigt', 'Vorläufig genehmigt', 'Storniert', 'Endgültig abgelehnt'];
      this.requestProcessingStatusList = ['Gestellt', 'In Bearbeitung', 'Inhaltlich falsch', 'Doppel abgewiesen', 'Neuantrag falsch', 'Widerrufen', 'Geprüft und abgelehnt', 'Dokumente fehlen', 'Angenommen', 'Angenommen geändert', 'Änderung fehlerhaft', 'Zustandegekommen', 'Änderung abgewiesen', 'Zurückgezogen', 'Gekündigt', 'Abgelaufen'];
      this.reasonsForRejection = [{
        text: 'Sonstige Gründe',
        id: 0
      }, {
        text: 'Unterschrift fehlt',
        id: 1
      }, {
        text: 'Fehlende Unterlagen',
        id: 2
      }, {
        text: 'Unvollständige Unterlagen',
        id: 3
      }];
      this.approvalResults = [];
      this.processingResults = [];
    }
    searchApproval(event) {
      let query = event.query;
      this.approvalResults = this.search(query, this.requestApprovalStatusList);
    }
    searchProcessing(event) {
      let query = event.query;
      this.processingResults = this.search(query, this.requestProcessingStatusList);
    }
    search(query, array) {
      let result = [];
      let queryInLowerCase = query.toLowerCase();
      if (array && array.length > 0) {
        for (let entry of array) {
          if (entry.toLowerCase().indexOf(queryInLowerCase) > -1) {
            result.push(entry);
          }
        }
      }
      return result;
    }
    static {
      this.ɵfac = function HisRequestComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisRequestComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisRequestComponent,
        selectors: [["his-request"]],
        inputs: {
          request: "request"
        },
        outputs: {
          requestChange: "requestChange"
        },
        standalone: false,
        decls: 35,
        vars: 35,
        consts: [["content", ""], ["header", "Basisdaten"], [3, "helptext"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.receiptdate", "disabled", "", 1, "inputWidth100", 3, "ngModelChange", "ngModel"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.changedate", "disabled", "", 1, "inputWidth100", 3, "ngModelChange", "ngModel"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.inboxdate", 3, "ngModelChange", "ngModel"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.signdate", 3, "ngModelChange", "ngModel"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.approvalStatusValue", 3, "ngModelChange", "completeMethod", "dropdown", "ngModel", "suggestions"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.reasonForRejection", "optionLabel", "text", 3, "ngModelChange", "options", "ngModel"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.processingStatusValue", 3, "ngModelChange", "completeMethod", "dropdown", "ngModel", "suggestions"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.commentaryInternal", "rows", "4", 1, "textareaWidth100", 3, "ngModelChange", "ngModel"], ["hisDdKey", "cm.stu.reqmanagement.AbstractRequest.commentaryApplicant", "rows", "4", 1, "textareaWidth100", 3, "ngModelChange", "ngModel"]],
        template: function HisRequestComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-panel", 1)(1, "his-plam", 2);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "input", 3, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_input_ngModelChange_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.receiptdate, $event) || (ctx.request.receiptdate = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "his-plam", 2);
            i0.ɵɵpipe(6, "hisUi");
            i0.ɵɵelementStart(7, "input", 4, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_input_ngModelChange_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.changedate, $event) || (ctx.request.changedate = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "his-plam", 2);
            i0.ɵɵpipe(10, "hisUi");
            i0.ɵɵelementStart(11, "p-calendar", 5, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_p_calendar_ngModelChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.inboxdate, $event) || (ctx.request.inboxdate = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "his-plam", 2);
            i0.ɵɵpipe(14, "hisUi");
            i0.ɵɵelementStart(15, "p-calendar", 6, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_p_calendar_ngModelChange_15_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.signdate, $event) || (ctx.request.signdate = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "his-plam", 2);
            i0.ɵɵpipe(18, "hisUi");
            i0.ɵɵelementStart(19, "p-autoComplete", 7, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_p_autoComplete_ngModelChange_19_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.approvalStatusValue, $event) || (ctx.request.approvalStatusValue = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisRequestComponent_Template_p_autoComplete_completeMethod_19_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchApproval($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(21, "his-plam", 2);
            i0.ɵɵpipe(22, "hisUi");
            i0.ɵɵelementStart(23, "p-multiSelect", 8, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_p_multiSelect_ngModelChange_23_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.reasonForRejection, $event) || (ctx.request.reasonForRejection = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "his-plam", 2);
            i0.ɵɵpipe(26, "hisUi");
            i0.ɵɵelementStart(27, "p-autoComplete", 9, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_p_autoComplete_ngModelChange_27_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.processingStatusValue, $event) || (ctx.request.processingStatusValue = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisRequestComponent_Template_p_autoComplete_completeMethod_27_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchProcessing($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(29, "his-plam")(30, "textarea", 10, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_textarea_ngModelChange_30_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.commentaryInternal, $event) || (ctx.request.commentaryInternal = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "his-plam")(33, "textarea", 11, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisRequestComponent_Template_textarea_ngModelChange_33_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.request.commentaryApplicant, $event) || (ctx.request.commentaryApplicant = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(2, 21, "cm.stu.reqmanagement.AbstractRequest.receiptdate.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.receiptdate);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(6, 23, "cm.stu.reqmanagement.AbstractRequest.changedate.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.changedate);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(10, 25, "cm.stu.reqmanagement.AbstractRequest.inboxdate.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.inboxdate);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(14, 27, "cm.stu.reqmanagement.AbstractRequest.signdate.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.signdate);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(18, 29, "cm.stu.reqmanagement.AbstractRequest.approvalStatusValue.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("dropdown", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.approvalStatusValue);
            i0.ɵɵproperty("suggestions", ctx.approvalResults);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(22, 31, "cm.stu.reqmanagement.AbstractRequest.reasonForRejection.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("options", ctx.reasonsForRejection);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.reasonForRejection);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("helptext", i0.ɵɵpipeBind1(26, 33, "cm.stu.reqmanagement.AbstractRequest.processingStatusValue.helptext"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("dropdown", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.processingStatusValue);
            i0.ɵɵproperty("suggestions", ctx.processingResults);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.commentaryInternal);
            i0.ɵɵadvance(3);
            i0.ɵɵtwoWayProperty("ngModel", ctx.request.commentaryApplicant);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, HisPlamComponent, HisDdDirective, HisDdValidator, HisCalendarDefaultsDirective, HisModificationDetectionDirective, HisMultiselectDefaultsDirective, HisButtonTitleDirective, HisPanelDirective, i4$1.Panel, i2$2.Calendar, i2$1.AutoComplete, i13.MultiSelect, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisRequestComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisTranslationSelectorComponent = /*#__PURE__*/(() => {
  class HisTranslationSelectorComponent {
    constructor() {
      this.hisTranslationService = inject(HisTranslationService);
      this.isHidden = true;
    }
    ngOnChanges(changes) {
      this.isHidden = !changes.defaultLanguage.currentValue;
      if (changes.defaultLanguage.currentValue && changes.defaultLanguage.currentValue?.id !== changes.defaultLanguage.previousValue?.id) {
        // get all possible translationLangages
        this.translationsLanguages = this.hisTranslationService.translationsLanguages(changes.defaultLanguage.currentValue);
        // set the initial value to manipulated defaultLanugage
        this.currentLanguage = this.translationsLanguages[0];
      }
    }
    ngOnDestroy() {
      this.hisTranslationService.setTranslationLanguage(undefined);
    }
    filterTranslationLanguages(event) {
      this.filteredTranslationLanguages = [];
      for (let lang of this.translationsLanguages) {
        if (lang.text.toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
          this.filteredTranslationLanguages.push(lang);
        }
      }
    }
    onTranslationLanguageSelect(event) {
      let selectedLanguage = event.value;
      if (!this.defaultLanguage || this.defaultLanguage.id === selectedLanguage.id) {
        this.hisTranslationService.setTranslationLanguage(undefined);
      } else {
        this.hisTranslationService.setTranslationLanguage(selectedLanguage);
      }
    }
    static {
      this.ɵfac = function HisTranslationSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslationSelectorComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTranslationSelectorComponent,
        selectors: [["his-translation-selector"]],
        inputs: {
          defaultLanguage: "defaultLanguage"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 3,
        vars: 6,
        consts: [["content", ""], [3, "hidden"], ["hisDdKey", "de.his.translate", "field", "text", 3, "ngModelChange", "completeMethod", "onSelect", "suggestions", "ngModel", "size", "minLength", "dropdown"]],
        template: function HisTranslationSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "p-autoComplete", 2, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisTranslationSelectorComponent_Template_p_autoComplete_ngModelChange_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.currentLanguage, $event) || (ctx.currentLanguage = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("completeMethod", function HisTranslationSelectorComponent_Template_p_autoComplete_completeMethod_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterTranslationLanguages($event));
            })("onSelect", function HisTranslationSelectorComponent_Template_p_autoComplete_onSelect_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTranslationLanguageSelect($event));
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", ctx.isHidden);
            i0.ɵɵadvance();
            i0.ɵɵproperty("suggestions", ctx.filteredTranslationLanguages);
            i0.ɵɵtwoWayProperty("ngModel", ctx.currentLanguage);
            i0.ɵɵproperty("size", 30)("minLength", 1)("dropdown", true);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, i2$1.AutoComplete, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective, HisButtonTitleDirective],
        encapsulation: 2
      });
    }
  }
  return HisTranslationSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 */
let HisInputTranslationDirective = /*#__PURE__*/(() => {
  class HisInputTranslationDirective {
    constructor() {
      this.elementRef = inject(ElementRef);
      this.hisTranslationService = inject(HisTranslationService);
      this.ddDirective = inject(HisDdDirective);
      this.hisEditorComponent = inject(HisSummernoteComponent, {
        host: true,
        optional: true,
        self: true
      });
      this.translationLanguageChanged = new EventEmitter();
    }
    ngOnInit() {
      if (this.hisEditorComponent) {
        this.hisEditorComponent.nativeElement = this.elementRef.nativeElement;
        this.hisEditorSubscription = this.hisEditorComponent.dataChange.subscribe(data => {
          this.hisTranslationService.setHisObjectActiveAttribute(this.hisObject, this.hisAttribute, this.hisEditorComponent.data);
        });
      }
      this.elementRef.nativeElement.isTranslatable = true;
      // listen to changes on the translationLanguage
      this.translationSubscription = this.hisTranslationService.translationLanguage$.subscribe(newTranslationLanguage => {
        this.onTranslationLanguageChanged(newTranslationLanguage);
      });
    }
    ngOnChanges(changes) {
      if (this.hisObject && this.hisAttribute) {
        // if the value of the given attribute change, pass the value to the element the directive is applied to
        this.updateElementValue();
      }
    }
    ngOnDestroy() {
      if (this.translationSubscription) {
        this.translationSubscription.unsubscribe();
        this.onTranslationLanguageChanged(undefined);
      }
      if (this.hisEditorSubscription) {
        this.hisEditorSubscription.unsubscribe();
      }
    }
    /** host listener sets the value of the hisObject[hisAttribute] when input is given */
    onInput(event) {
      if (!this.hisEditorComponent) {
        this.hisTranslationService.setHisObjectActiveAttribute(this.hisObject, this.hisAttribute, this.elementRef.nativeElement.value);
      }
    }
    /** Updates the value of the element the directive is applied to */
    updateElementValue() {
      // set the defaultLanguageValue (his-plam will read it)
      this.elementRef.nativeElement.defaultLanguageValue = this.hisObject[this.hisAttribute];
      // set value for current language field
      if (this.hisEditorComponent) {
        this.hisEditorComponent.data = this.hisTranslationService.getHisObjectActiveAttribute(this.hisObject, this.hisAttribute);
      } else {
        this.elementRef.nativeElement.value = this.hisTranslationService.getHisObjectActiveAttribute(this.hisObject, this.hisAttribute);
      }
    }
    onTranslationLanguageChanged(newTranslationLanguage) {
      // disabled ddProperty required for the translation input
      if (newTranslationLanguage) {
        this.ddDirective.forceNotRequired(true);
      } else {
        this.ddDirective.forceNotRequired(false);
      }
      this.translationLanguageChanged?.emit(newTranslationLanguage);
      this.updateElementValue();
    }
    static {
      this.ɵfac = function HisInputTranslationDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisInputTranslationDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisInputTranslationDirective,
        selectors: [["", "hisObject", ""]],
        hostBindings: function HisInputTranslationDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function HisInputTranslationDirective_input_HostBindingHandler($event) {
              return ctx.onInput($event);
            });
          }
        },
        inputs: {
          hisObject: "hisObject",
          hisAttribute: "hisAttribute"
        },
        outputs: {
          translationLanguageChanged: "translationLanguageChanged"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisInputTranslationDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisTranslationPipe = /*#__PURE__*/(() => {
  class HisTranslationPipe {
    constructor() {
      this.hisTranslationService = inject(HisTranslationService);
    }
    /**
     * Translates the attribute from an object to another language if the _foreigntext is correctly filled
     *
     * @param object - the object with translatable attributes
     * @param attributeName - name of the attribute
     * @param language - the language to translate to (if not given the currently selected language from HisBaseGlobalsService is used)
     */
    transform(hisObject, hisAttribute, language) {
      return this.hisTranslationService.translate(hisObject, hisAttribute, language);
    }
    static {
      this.ɵfac = function HisTranslationPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslationPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "hisTranslate",
        type: HisTranslationPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HisTranslationPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisTranslatedHtmlComponent = /*#__PURE__*/(() => {
  class HisTranslatedHtmlComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisTranslationService = inject(HisTranslationService);
      this.language = this.hisBaseGlobalsService.getLanguage();
    }
    ngOnChanges() {
      if (!this.isHisObjectEmpty() && this.hisAttribute) {
        this.translatedText = this.getTranslatedText(this.hisobject, this.hisAttribute, this.language);
      }
    }
    getTranslatedText(hisobject, hisAttribute, language) {
      let translatedText = '';
      if (!Object.prototype.hasOwnProperty.call(hisobject, hisAttribute)) {
        console.warn('No attribute named \'', hisAttribute, '\' present in object ', hisobject);
        return undefined;
      }
      if (hisobject[hisAttribute] == null || hisobject[hisAttribute].length === 0) {
        console.warn('Value of attribute named \'', hisAttribute, '\' in object ', hisobject, ' is empty. Will now try to find a foreign text for it.');
      }
      if (this.hisTranslationService.isTranslationExisting(hisobject, hisAttribute, language)) {
        translatedText = this.hisTranslationService.translate(hisobject, hisAttribute, language);
      }
      if (translatedText.length === 0) {
        if (hisobject.language) {
          this.language = hisobject.language.iso_639_1;
        } else if (hisobject.languages && hisobject.languages.length > 0 && hisobject.languages[0]) {
          this.language = hisobject.languages[0].iso_639_1;
        }
        translatedText = this.hisTranslationService.translate(hisobject, hisAttribute, this.language);
      }
      if (this.maxLength && translatedText.length > this.maxLength) {
        return this.shortenText(translatedText);
      } else {
        return translatedText;
      }
    }
    /* substring text to maxLength or last full word */
    shortenText(text) {
      let textLength = this.maxLength;
      while ((text.charAt(textLength) !== ' ' || text?.charAt(textLength).match('\n')) && textLength !== 0) {
        textLength--;
      }
      return text.substring(0, textLength) + ' ...';
    }
    getLanguage() {
      return this.language;
    }
    isHisObjectEmpty() {
      return this.hisobject == null || Object.values(this.hisobject).filter(v => !!v).length === 0;
    }
    static {
      this.ɵfac = function HisTranslatedHtmlComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslatedHtmlComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisTranslatedHtmlComponent,
        selectors: [["his-translated-html"]],
        inputs: {
          hisobject: "hisobject",
          hisAttribute: "hisAttribute",
          maxLength: "maxLength"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "innerHtml", "lang"]],
        template: function HisTranslatedHtmlComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("lang", ctx.language);
            i0.ɵɵproperty("innerHtml", ctx.translatedText, i0.ɵɵsanitizeHtml);
          }
        },
        encapsulation: 2
      });
    }
  }
  return HisTranslatedHtmlComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with very basic components, directives, and pipes to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisTranslationSharedModule = /*#__PURE__*/(() => {
  class HisTranslationSharedModule {
    static {
      this.ɵfac = function HisTranslationSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslationSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisTranslationSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [
        // Angular
        CommonModule, FormsModule, AutoCompleteModule,
        // HIS
        HisCoreSharedModule]
      });
    }
  }
  return HisTranslationSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisTranslationSharedModule, {
    declarations: [
    // Components
    HisTranslatedTextComponent, HisTranslatedHtmlComponent, HisTranslationSelectorComponent,
    // Directives
    HisInputTranslationDirective,
    // Pipes
    HisTranslationPipe],
    imports: [
    // Angular
    CommonModule, FormsModule, AutoCompleteModule,
    // HIS
    HisCoreSharedModule],
    exports: [
    // Components
    HisTranslatedTextComponent, HisTranslatedHtmlComponent, HisTranslationSelectorComponent,
    // Directives
    HisInputTranslationDirective,
    // Pipes
    HisTranslationPipe]
  });
})();

/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line max-len
const _c0$d = ["*"];
let HisWizardPageSummaryComponent = /*#__PURE__*/(() => {
  class HisWizardPageSummaryComponent {
    // eslint-disable-next-line max-len
    constructor() {
      this.changeDetector = inject(ChangeDetectorRef);
      const wizardPage = inject(HisWizardPageComponent);
      this.wizardPage = wizardPage;
    }
    ngAfterViewInit() {
      console.log('ngAfterViewInit not implemented');
    }
    ngAfterContentInit() {
      console.log('ngAfterContentInit not implemented');
    }
    static {
      this.ɵfac = function HisWizardPageSummaryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisWizardPageSummaryComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisWizardPageSummaryComponent,
        selectors: [["his-wizard-page-summary"]],
        inputs: {
          title: "title",
          pageKey: "pageKey"
        },
        standalone: false,
        ngContentSelectors: _c0$d,
        decls: 2,
        vars: 0,
        consts: [[1, "unsicht", "bar"]],
        template: function HisWizardPageSummaryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{--accordion-header-height: 50px;--accordion-header-bg: hsl(0, 0%, 95%);--accordion-disabled: hsl(0, 0%, 60%);--accordion-border-radius: 8px;width:100%}.his-wizard-page[_ngcontent-%COMP%]{padding:0 0rem 0 .2rem}.his-wizard-content[_ngcontent-%COMP%], .wizardButton[_ngcontent-%COMP%]{visibility:hidden}.his-wizard-page-active[_ngcontent-%COMP%]   .his-wizard-content[_ngcontent-%COMP%], .his-wizard-page-active[_ngcontent-%COMP%]   .his-wizard-content[_ngcontent-%COMP%]   .wizardButton[_ngcontent-%COMP%]{visibility:visible}.his-wizard-page-hidden[_ngcontent-%COMP%], .his-wizard-page-hidden[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:none}.his-wizard-header[_ngcontent-%COMP%]{justify-content:space-between;align-items:center;height:var(--accordion-header-height);cursor:pointer}.his-wizard-toggle-btn[_ngcontent-%COMP%]{border:none;transition:transform .3s ease-in;background:none}.his-wizard-page.disabled[_ngcontent-%COMP%]   .his-wizard-header[_ngcontent-%COMP%]   .his-wizard-header-link[_ngcontent-%COMP%]{color:var(--accordion-disabled);cursor:not-allowed}.his-wizard-page.disabled[_ngcontent-%COMP%]   .his-wizard-toggle-btn[_ngcontent-%COMP%]{filter:grayscale(100%)}.his-wizard-toggle-btn[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.his-wizard-toggle-btn[_ngcontent-%COMP%]:disabled   svg[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]:nth-child(2){fill:var(--accordion-disabled)}.his-wizard-page-active[_ngcontent-%COMP%]   .his-wizard-toggle-btn[_ngcontent-%COMP%]{transform:rotate(90deg)}.his-wizard-header-link[_ngcontent-%COMP%]{position:relative;cursor:pointer;display:block;align-items:center;-webkit-user-select:none;user-select:none;text-decoration:none}.his-wizard-header-link[_ngcontent-%COMP%]:focus{z-index:1}.his-wizard-header-text[_ngcontent-%COMP%]{line-height:1}.his-wizard[_ngcontent-%COMP%]   .p-toggleable-content[_ngcontent-%COMP%]{overflow:hidden}.his-wizard[_ngcontent-%COMP%]   .his-wizard-tab-active[_ngcontent-%COMP%] > .p-toggleable-content[_ngcontent-%COMP%]:not(.ng-animating){overflow:hidden}.his-wizard-toggle-icon-end[_ngcontent-%COMP%]{order:1;margin-left:auto}.his-wizard-toggle-icon[_ngcontent-%COMP%]{order:0}"]
      });
    }
  }
  return HisWizardPageSummaryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line max-len
const _c0$c = ["nextButton"];
const _c1$4 = ["submitButton"];
const _c2$1 = ["*", [["p-header"]]];
const _c3$1 = ["*", "p-header"];
const _c4$1 = a0 => ({
  $implicit: a0
});
const _c5 = a0 => ({
  transitionParams: a0
});
const _c6 = a0 => ({
  value: "visible",
  params: a0
});
const _c7 = a0 => ({
  value: "hidden",
  params: a0
});
function HisWizardPageComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 6);
  }
}
function HisWizardPageComponent_4_ng_template_0_Template(rf, ctx) {}
function HisWizardPageComponent_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisWizardPageComponent_4_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function HisWizardPageComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
  }
}
function HisWizardPageComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisWizardPageComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function HisWizardPageComponent_Conditional_11_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisWizardPageComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisWizardPageComponent_Conditional_11_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate);
  }
}
function HisWizardPageComponent_Conditional_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15, 0);
    i0.ɵɵlistener("click", function HisWizardPageComponent_Conditional_12_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.prevPage());
    });
    i0.ɵɵtext(2, "Zur\u00FCck");
    i0.ɵɵelementEnd();
  }
}
function HisWizardPageComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16, 1);
    i0.ɵɵlistener("click", function HisWizardPageComponent_Conditional_12_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.nextPage());
    });
    i0.ɵɵtext(2, "Weiter");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("disabled", true);
  }
}
function HisWizardPageComponent_Conditional_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17, 2);
    i0.ɵɵlistener("click", function HisWizardPageComponent_Conditional_12_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onWizardSubmit());
    });
    i0.ɵɵtext(2, "Absenden");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("disabled", true);
  }
}
function HisWizardPageComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisWizardPageComponent_Conditional_12_Conditional_1_Template, 3, 0, "button", 12)(2, HisWizardPageComponent_Conditional_12_Conditional_2_Template, 3, 1, "button", 13)(3, HisWizardPageComponent_Conditional_12_Conditional_3_Template, 3, 1, "button", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasPrevIndex() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasNextIndex() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.hasNextIndex() ? 3 : -1);
  }
}
let pageIdx = 0;
let HisWizardPageComponent = /*#__PURE__*/(() => {
  class HisWizardPageComponent {
    /**
     * The value that returns the selection.
     * @group Props
     */
    get selected() {
      return this._selected;
    }
    set selected(val) {
      this._selected = val;
      if (!this.loaded) {
        if (this._selected && this.cache) {
          this.loaded = true;
        }
        this.changeDetector.detectChanges();
      }
    }
    get iconClass() {
      if (this.iconPos === 'end') {
        return 'p-accordion-toggle-icon-end';
      } else {
        return 'p-accordion-toggle-icon';
      }
    }
    // eslint-disable-next-line max-len
    constructor() {
      this.changeDetector = inject(ChangeDetectorRef);
      /**
       * Whether the tab is disabled.
       * @group Props
       */
      this.disabled = false;
      /**
       * Whether the tab is visible.
       * @group Props
       */
      this.visible = true;
      /**
       * Whether a lazy loaded panel should avoid getting loaded again on reselection.
       * @group Props
       */
      // eslint-disable-next-line @typescript-eslint/no-inferrable-types
      this.cache = true;
      /**
       * Transition options of the animation.
       * @group Props
       */
      this.transitionOptions = '400ms cubic-bezier(0.86, 0, 0.07, 1)';
      /**
       * Position of the icon.
       * @group Props
       */
      this.iconPos = 'start';
      /**
       * Event triggered by changing the choice.
       * @param {boolean} value - Boolean value indicates that the option is changed.
       * @group Emits
       */
      this.selectedChange = new EventEmitter();
      this._selected = false;
      this.id = `p-accordiontab-${pageIdx++}`;
      this.loaded = false;
      this.noButtons = false;
      this.contentChange = new EventEmitter();
      this.statusChange = new EventEmitter();
      this.nextPageEvent = new EventEmitter();
      this.pageSelected = new EventEmitter();
      this.formValueChangesSubscription = null;
      const wizard = inject(HisWizardComponent);
      this.wizard = wizard;
    }
    ngAfterViewInit() {
      //throw new Error( 'Method not implemented.' );
      //console.log( 'formGroupChildren', this.formGroupChildren );
      // this.reactiveFormChildSubscription = ( this.reactiveFormChild as unknown as QueryList<FormGroup> ).changes.subscribe( ( _ ) => {
      //     console.log( 'reactiveFormChild', this.reactiveFormChild );
      //     this.localPagereactiveFormChild = this.reactiveFormChild;
      // } );
      console.log('templateFormChild', this.templateFormChild);
      console.log('reactiveFormChild', this.reactiveFormChild);
      if (!this.reactiveFormChild && !this.templateFormChild && this.nextButton) {
        console.log('enable next button', this.nextButton);
        this.nextButton.nativeElement.disabled = false;
        this.statusChange.emit({
          index: this.index,
          status: 'VALID'
        });
      }
      if (!this.reactiveFormChild && !this.templateFormChild && this.submitButton) {
        console.log('enable submit button', this.submitButton);
        this.submitButton.nativeElement.disabled = false;
        this.statusChange.emit({
          index: this.index,
          status: 'VALID'
        });
      }
      if (this.reactiveFormChild) {
        this.subscribeValueChanges(this.reactiveFormChild.form);
      } else if (this.templateFormChild) {
        console.log('template subscribe value changes', this.templateFormChild);
        this.subscribeValueChanges(this.templateFormChild.form);
        // this.formValueChangesSubscription = this.templateFormChild.controls.input.subscribe( () => {
        //     console.log( 'input valueChange', this.templateFormChild);
        // } );
        // Object.keys( this.templateFormChild.form.controls ).forEach(key => {
        //     console.log( 'add onChange to template formControl', key, this.templateFormChild.form.get( key ) );
        //     this.templateFormChild.form.get( key ).valueChanges.subscribe( () => {
        //         console.log( 'input valueChange', this.templateFormChild.form.get( key ) );
        //     } );
        // });
      }
      //console.log( 'localFormGroup', this.localFormGroup );
      //console.log( 'tempForm', this.tempForm );
      // this.contentChange.subscribe( resp => {
      //     console.log( 'wizard page reactiveFormChild change', resp );
      // } );
    }
    /**
     * activates next or submit button, if containing form is valid
     * @param formGroup
     */
    subscribeValueChanges(formGroup) {
      console.log('subscribe value changes', formGroup);
      if (formGroup) {
        this.formValueChangesSubscription = formGroup.valueChanges.subscribe(() => {
          console.log('wizard page localFormGroup change', formGroup);
          if (formGroup.status === 'VALID' && this.nextButton) {
            console.log('enable next button', this.nextButton);
            this.nextButton.nativeElement.disabled = false;
          }
          if (formGroup.status === 'VALID' && this.submitButton) {
            console.log('enable submit button', this.submitButton);
            this.submitButton.nativeElement.disabled = false;
          }
          if (formGroup.status === 'INVALID' && this.nextButton) {
            console.log('disable next button', this.nextButton);
            this.nextButton.nativeElement.disabled = true;
          }
          if (formGroup.status === 'INVALID' && this.submitButton) {
            console.log('disable submit button', this.submitButton);
            this.submitButton.nativeElement.disabled = true;
          }
          this.contentChange.emit(formGroup);
        });
      }
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'content':
            this.contentTemplate = item.template;
            break;
          case 'header':
            this.headerTemplate = item.template;
            break;
          case 'icon':
            this.iconTemplate = item.template;
            break;
          default:
            this.contentTemplate = item.template;
            break;
        }
      });
      //console.log( 'formGroupChildren', this.formGroupChildren, this.reactiveFormChild.length );
      //console.log( 'reactiveFormChild', this.reactiveFormChild );
    }
    // isContainingFormValid() {
    //     if ( ! this.reactiveFormChild ) return false;
    //     return this.reactiveFormChild.form.status === 'VALID' ? true : false;
    // }
    prevPage() {
      this.wizard.selectPrevPage();
    }
    nextPage() {
      console.log('clicked next...');
      //let index = this.findTabIndex();
      // this.wizard.selectPageIndex( index++ );
      //this.nextPageEvent.emit();
      this.wizard.selectNextPage();
    }
    showPageKey(pageKey) {
      console.log('wizard-page showPageKey', pageKey);
      this.wizard.enablePageKey(pageKey);
      this.statusChange.emit({
        index: this.index,
        status: 'SHOW_PAGE_KEY',
        pageKey: pageKey
      });
    }
    onWizardSubmit() {
      console.log('onPageSubmit reactiveFormChild', this.reactiveFormChild);
      this.statusChange.emit({
        index: this.index,
        status: 'WIZARD_SUBMIT'
      });
    }
    hasNextIndex() {
      return this.wizard.isIndexValid(this.findTabIndex() + 1);
    }
    hasPrevIndex() {
      return this.wizard.isIndexValid(this.findTabIndex() - 1);
    }
    toggle(event) {
      if (this.disabled) {
        return;
      }
      let index = this.findTabIndex();
      if (index > this.wizard.activeIndex) {
        return;
      }
      if (this.selected) {
        this.selected = false;
        // eslint-disable-next-line object-shorthand
        this.wizard.tabClose.emit({
          originalEvent: event,
          index: index
        });
      } else {
        // if ( !this.wizard.multiple ) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.wizard.pages.length; i++) {
          if (this.wizard.pages[i].selected) {
            this.wizard.pages[i].selected = false;
            this.wizard.pages[i].selectedChange.emit(false);
            this.wizard.pages[i].changeDetector.markForCheck();
          }
        }
        //}
        this.selected = true;
        this.loaded = true;
        this.wizard.tabOpen.emit({
          originalEvent: event,
          index
        });
      }
      this.selectedChange.emit(this.selected);
      this.wizard.selectPageIndex(index);
      this.changeDetector.markForCheck();
      // Index der ausgewählten Seite an his-wizard Komponente weiterreichen
      this.pageSelected.emit(index);
      event.preventDefault();
    }
    findTabIndex() {
      let index = -1;
      for (let i = 0; i < this.wizard.pages.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (this.wizard.pages[i] == this) {
          index = i;
          break;
        }
      }
      return index;
    }
    get hasHeaderFacet() {
      return this.headerFacet && this.headerFacet.length > 0;
    }
    onKeydown(event) {
      if (event.which === 32 || event.which === 13) {
        this.toggle(event);
        event.preventDefault();
      }
    }
    onChanges() {
      this.changeDetector.detectChanges();
    }
    ngOnDestroy() {
      if (this.formValueChangesSubscription) {
        this.formValueChangesSubscription.unsubscribe();
      }
      this.wizard.pages.splice(this.findTabIndex(), 1);
    }
    static {
      this.ɵfac = function HisWizardPageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisWizardPageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisWizardPageComponent,
        selectors: [["his-wizard-page"]],
        contentQueries: function HisWizardPageComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, FormGroupDirective, 7);
            i0.ɵɵcontentQuery(dirIndex, NgForm, 7);
            i0.ɵɵcontentQuery(dirIndex, HisWizardPageSummaryComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, Header, 4);
            i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
            i0.ɵɵcontentQuery(dirIndex, FormGroup, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reactiveFormChild = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateFormChild = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pageSummary = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerFacet = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentForms = _t);
          }
        },
        viewQuery: function HisWizardPageComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$c, 5);
            i0.ɵɵviewQuery(_c1$4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submitButton = _t.first);
          }
        },
        inputs: {
          title: "title",
          pageKey: "pageKey",
          formGroup: "formGroup",
          headerStyle: "headerStyle",
          tabStyle: "tabStyle",
          contentStyle: "contentStyle",
          tabStyleClass: "tabStyleClass",
          headerStyleClass: "headerStyleClass",
          contentStyleClass: "contentStyleClass",
          disabled: "disabled",
          visible: "visible",
          cache: "cache",
          transitionOptions: "transitionOptions",
          iconPos: "iconPos",
          selected: "selected",
          index: "index",
          noButtons: "noButtons"
        },
        outputs: {
          selectedChange: "selectedChange",
          contentChange: "contentChange",
          statusChange: "statusChange",
          nextPageEvent: "nextPageEvent",
          pageSelected: "pageSelected"
        },
        standalone: false,
        ngContentSelectors: _c3$1,
        decls: 13,
        vars: 41,
        consts: [["prevButton", ""], ["nextButton", ""], ["submitButton", ""], [1, "his-wizard-page", "p-accordion-tab", 3, "ngClass", "ngStyle"], [1, "p-accordion-header", "his-wizard-header"], ["role", "tab", 1, "p-accordion-header-link", "his-wizard-header-link", 3, "click", "keydown", "ngClass"], ["hisImage", "RESULTSET_NEXT", 1, "inlineicon", "his-wizard-toggle-btn"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-accordion-header-text", "his-wizard-header-text"], [4, "ngTemplateOutlet"], ["role", "region", 1, "p-toggleable-content"], [1, "p-accordion-content", "his-wizard-content", 3, "ngClass", "ngStyle"], ["hisImage", "arrow_left_fat", 1, "button_highlighted_dark_green", "wizardButton", "wizardButtonBack"], ["hisImage", "arrow_right_fat", 1, "button_highlighted_dark_green", "wizardButton", "wizardButtonNext", 3, "disabled"], ["hisImage", "arrow_up_fat", 1, "button_highlighted_dark_green", "wizardButton", "wizardButtonNext", 3, "disabled"], ["hisImage", "arrow_left_fat", 1, "button_highlighted_dark_green", "wizardButton", "wizardButtonBack", 3, "click"], ["hisImage", "arrow_right_fat", 1, "button_highlighted_dark_green", "wizardButton", "wizardButtonNext", 3, "click", "disabled"], ["hisImage", "arrow_up_fat", 1, "button_highlighted_dark_green", "wizardButton", "wizardButtonNext", 3, "click", "disabled"]],
        template: function HisWizardPageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$1);
            i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "a", 5);
            i0.ɵɵlistener("click", function HisWizardPageComponent_Template_a_click_2_listener($event) {
              return ctx.toggle($event);
            })("keydown", function HisWizardPageComponent_Template_a_keydown_2_listener($event) {
              return ctx.onKeydown($event);
            });
            i0.ɵɵtemplate(3, HisWizardPageComponent_Conditional_3_Template, 1, 0, "img", 6)(4, HisWizardPageComponent_4_Template, 1, 0, null, 7)(5, HisWizardPageComponent_Conditional_5_Template, 2, 1, "span", 8)(6, HisWizardPageComponent_ng_container_6_Template, 1, 0, "ng-container", 9)(7, HisWizardPageComponent_Conditional_7_Template, 1, 0);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 10)(9, "div", 11);
            i0.ɵɵprojection(10);
            i0.ɵɵtemplate(11, HisWizardPageComponent_Conditional_11_Template, 1, 1, "ng-container")(12, HisWizardPageComponent_Conditional_12_Template, 4, 3, "div");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.disabled)("his-wizard-page-active", ctx.selected)("his-wizard-page-hidden", !ctx.visible);
            i0.ɵɵproperty("ngClass", ctx.tabStyleClass)("ngStyle", ctx.tabStyle);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("p-highlight", ctx.selected);
            i0.ɵɵadvance();
            i0.ɵɵstyleMap(ctx.headerStyle);
            i0.ɵɵproperty("ngClass", ctx.headerStyleClass);
            i0.ɵɵattribute("tabindex", ctx.disabled ? null : 0)("id", ctx.id)("aria-controls", ctx.id + "-content")("aria-expanded", ctx.selected);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.iconTemplate ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.iconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(31, _c4$1, ctx.selected));
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.hasHeaderFacet ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasHeaderFacet ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("@tabContent", ctx.selected ? i0.ɵɵpureFunction1(35, _c6, i0.ɵɵpureFunction1(33, _c5, ctx.transitionOptions)) : i0.ɵɵpureFunction1(39, _c7, i0.ɵɵpureFunction1(37, _c5, ctx.transitionOptions)));
            i0.ɵɵattribute("id", ctx.id + "-content")("aria-hidden", !ctx.selected)("aria-labelledby", ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.contentStyleClass)("ngStyle", ctx.contentStyle);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.contentTemplate && (ctx.cache ? ctx.loaded : ctx.selected) ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.noButtons ? 12 : -1);
          }
        },
        dependencies: [i1$2.NgClass, i1$2.NgTemplateOutlet, i1$2.NgStyle, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective],
        styles: [":host{--accordion-header-height: 50px;--accordion-header-bg: hsl(0, 0%, 95%);--accordion-disabled: hsl(0, 0%, 60%);--accordion-border-radius: 8px;width:100%}.his-wizard-page{padding:0 0rem 0 .2rem}.his-wizard-content,.wizardButton{visibility:hidden}.his-wizard-page-active .his-wizard-content,.his-wizard-page-active .his-wizard-content .wizardButton{visibility:visible}.his-wizard-page-hidden,.his-wizard-page-hidden button{display:none}.his-wizard-header{justify-content:space-between;align-items:center;height:var(--accordion-header-height);cursor:pointer}.his-wizard-toggle-btn{border:none;transition:transform .3s ease-in;background:none}.his-wizard-page.disabled .his-wizard-header .his-wizard-header-link{color:var(--accordion-disabled);cursor:not-allowed}.his-wizard-page.disabled .his-wizard-toggle-btn{filter:grayscale(100%)}.his-wizard-toggle-btn:disabled{cursor:not-allowed}.his-wizard-toggle-btn:disabled svg path:nth-child(2){fill:var(--accordion-disabled)}.his-wizard-page-active .his-wizard-toggle-btn{transform:rotate(90deg)}.his-wizard-header-link{position:relative;cursor:pointer;display:block;align-items:center;-webkit-user-select:none;user-select:none;text-decoration:none}.his-wizard-header-link:focus{z-index:1}.his-wizard-header-text{line-height:1}.his-wizard .p-toggleable-content{overflow:hidden}.his-wizard .his-wizard-tab-active>.p-toggleable-content:not(.ng-animating){overflow:hidden}.his-wizard-toggle-icon-end{order:1;margin-left:auto}.his-wizard-toggle-icon{order:0}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('tabContent', [state('hidden', style({
            height: '0',
            opacity: '0'
          })), state('visible', style({
            height: '*',
            opacity: '1'
          })), transition('visible <=> hidden', [animate('{{transitionParams}}')]), transition('void => *', animate(0))])]
        },
        changeDetection: 0
      });
    }
  }
  return HisWizardPageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-underscore-dangle */
const _c0$b = ["*"];
function HisWizardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-menu", 3, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("model", ctx_r0.menuItems);
  }
}
let HisWizardComponent = /*#__PURE__*/(() => {
  class HisWizardComponent {
    constructor() {
      this.el = inject(ElementRef);
      this.changeDetector = inject(ChangeDetectorRef);
      /**
       * Is sidebar visible?
       * @group Props
       */
      this.sidebarVisible = true;
      /**
       * Callback to invoke when an active tab is collapsed by clicking on the header.
       * @param {HisWizardPageCloseEvent} event - Custom tab close event.
       * @group Emits
       */
      this.tabClose = new EventEmitter();
      /**
       * Callback to invoke when a tab gets expanded.
       * @param {HisWizardPageOpenEvent} event - Custom tab open event.
       * @group Emits
       */
      this.tabOpen = new EventEmitter();
      /**
       * Returns the active index.
       * @param {number | number[]} value - New index.
       * @group Emits
       */
      this.activeIndexChange = new EventEmitter();
      /**
       * Callback to invoke when a tab gets expanded.
       * @param {HisWizardPageOpenEvent} event - Custom tab open event.
       * @group Emits
       */
      this.wizardFinished = new EventEmitter();
      this.tabListSubscription = null;
      this.preventActiveIndexPropagation = false;
      this.preventActivePagePropagation = false;
      this.pages = [];
      this.menuItems = [];
      this.wizardItems = [];
    }
    /**
     * Icon of a collapsed tab.
     * @group Props
     */
    //@Input() expandIcon: string | undefined;
    /**
     * Icon of an expanded tab.
     * @group Props
     */
    //@Input() collapseIcon: string | undefined;
    /**
     * Index of the active tab or an array of indexes in multiple mode.
     * @group Props
     */
    get activeIndex() {
      return this._activeIndex;
    }
    set activeIndex(val) {
      this._activeIndex = val;
      if (this.preventActiveIndexPropagation) {
        this.preventActiveIndexPropagation = false;
        return;
      }
      this.updateSelectionState();
    }
    /**
     *
     */
    get activePage() {
      return this._activePage;
    }
    set activePage(val) {
      this._activePage = val;
      if (this.preventActivePagePropagation) {
        this.preventActivePagePropagation = false;
        return;
      }
      this.updateSelectionState();
    }
    ngAfterContentInit() {
      this.initTabs();
      // subscribe to tab changes
      this.tabListSubscription = this.tabList.changes.subscribe(_ => {
        this.initTabs();
      });
      for (let i = 0; i < this.pages.length; i++) {
        this.pages[i].statusChange.subscribe(event => {
          console.log('status changed index', event.index);
          console.log('status changed status', event.status);
          if (event === 'VALID') {
            //enable next page
          }
          if (event === 'WIZARD_SUBMIT') {
            this.wizardFinished.emit();
          }
          if (event.status == 'SHOW_PAGE_KEY') {
            console.log('wizard status: SHOW_PAGE_KEY');
            this.showPageKey(event.pageKey);
          }
        });
        // Fix für visuelles Hervorheben der aktiven Wizard Seite im Menü, wenn
        // direkt auf Reiter statt über Next/Prev Button navigiert wird
        this.pages[i].pageSelected.subscribe(selectedIndex => {
          this.updateMenuItemsStyle(selectedIndex);
        });
      }
    }
    initTabs() {
      this.pages = this.tabList.toArray();
      this.updateSelectionState();
      this.changeDetector.markForCheck();
      this.initItemModels();
    }
    initItemModels() {
      // Fix für das Duplizieren von Menüeinträgen
      this.menuItems = [];
      for (let i = 0; i < this.pages.length; i++) {
        this.pages[i].index = i;
        if (i != 0) {
          // disable tabs initially
          //this.pages[i].disabled = true;
        }
        let menuItem = {
          label: this.pages[i].title,
          disabled: this.pages[i].disabled,
          icon: 'iconfont-bullet_mono',
          // Visuelles Hervorheben der ersten Seite beim Wizard Menü Init
          styleClass: this.pages[i].selected ? 'his-wizard-menu-item-selected' : '',
          command: event => {
            this.selectPageIndex(i);
          }
        };
        let wizardItem = {
          index: i,
          pageKey: this.pages[i].id
        };
        if (this.pages[i].pageKey !== undefined) {
          wizardItem.pageKey = this.pages[i].pageKey;
          console.log('pageKey: ' + this.pages[i].pageKey);
        }
        if (this.pages[i].visible) {
          this.menuItems.push(menuItem);
        }
        this.wizardItems.push(wizardItem);
        console.log('menuItems: ', menuItem);
      }
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    set selectPage(pageKey) {
      for (let item of this.wizardItems) {
        if (pageKey === item.pageKey) {
          this.selectPageIndex(item.index);
        }
      }
    }
    selectPrevPage() {
      console.log('_activeIndex', this._activeIndex);
      let index = this._activeIndex - 1;
      if (this.isPageVisible(index) && !this.isPageDisabled(index)) {
        this.selectPageIndex(index);
      } else {
        // select next visible active page
        for (let i = index; 0 <= i; i--) {
          if (this.isPageVisible(i) && !this.isPageDisabled(i)) {
            this.selectPageIndex(i);
            break;
          }
        }
      }
    }
    selectNextPage() {
      console.log('_activeIndex', this._activeIndex);
      let index = this._activeIndex + 1;
      if (this.isPageVisible(index) && !this.isPageDisabled(index)) {
        this.selectPageIndex(index);
      } else {
        // select next visible active page
        for (let i = index; this.pages.length > i; i++) {
          if (this.isPageVisible(i) && !this.isPageDisabled(i)) {
            this.selectPageIndex(i);
            break;
          }
        }
      }
      this.updateSelectionState();
    }
    isPageVisible(index) {
      return this.pages[index].visible;
    }
    isPageDisabled(index) {
      return this.pages[index].disabled;
    }
    isIndexValid(index) {
      if (index >= 0 && index < this.wizardItems.length && this.isPageVisible(index)) {
        return true;
      } else {
        return false;
      }
    }
    disablePage(index) {
      this.pages[index].disabled = true;
    }
    enablePage(index) {
      this.pages[index].disabled = false;
    }
    /**
     * disables a given page by pageKey
     * @param pageKey
     * @returns
     */
    disablePageKey(pageKey) {
      if (this.pages && this.pages.length) {
        for (let i = 0; i < this.pages.length; i++) {
          if (this.pages[i].pageKey === pageKey) {
            this.pages[i].disabled = true;
            return;
          }
        }
        console.warn('pageKey not available', pageKey);
      }
    }
    /**
     * enables a given page by pageKey
     * @param pageKey
     * @returns
     */
    enablePageKey(pageKey) {
      if (this.pages && this.pages.length) {
        for (let i = 0; i < this.pages.length; i++) {
          if (this.pages[i].pageKey === pageKey) {
            this.pages[i].disabled = false;
            return;
          }
        }
        console.warn('pageKey not available', pageKey);
      }
    }
    /**
     * hides and disables a page
     * @param pageKey pagekey of the page to hide
     * @returns void
     */
    hidePageKey(pageKey) {
      if (this.pages && this.pages.length) {
        for (let i = 0; i < this.pages.length; i++) {
          if (this.pages[i].pageKey === pageKey) {
            this.pages[i].disabled = true;
            this.pages[i].visible = false;
            return;
          }
        }
        console.warn('pageKey not available', pageKey);
      }
    }
    /**
     * makes a page visible and enabled
     * @param pageKey
     * @returns
     */
    showPageKey(pageKey) {
      console.warn('wizard show pageKey:', pageKey);
      if (this.pages && this.pages.length) {
        for (let i = 0; i < this.pages.length; i++) {
          if (this.pages[i].pageKey === pageKey) {
            this.pages[i].disabled = false;
            this.pages[i].visible = true;
            this.pages[i].changeDetector.markForCheck();
            this.initItemModels();
            return;
          }
        }
        console.warn('pageKey not available', pageKey);
      } else {
        console.warn('no pages available', pageKey);
      }
    }
    selectPageKey(pageKey) {
      console.log('change pageKey to: ', pageKey);
      if (this.pages && this.pages.length) {
        for (let i = 0; i < this.pages.length; i++) {
          if (this.pages[i].pageKey === pageKey) {
            this.selectPageIndex(i);
            return;
          }
        }
        console.warn('pageKey not available', pageKey);
      }
    }
    selectPageIndex(index) {
      console.log('change index to: ', index);
      if (this.pages[index].disabled) {
        return;
      }
      this._activeIndex = index;
      if (this.preventActiveIndexPropagation) {
        this.preventActiveIndexPropagation = false;
        return;
      }
      this.updateSelectionState();
    }
    updateSelectionState() {
      if (this.pages && this.pages.length && this._activeIndex != null) {
        for (let i = 0; i < this.pages.length; i++) {
          let selected = i === this._activeIndex;
          let changed = selected !== this.pages[i].selected;
          if (changed) {
            this.pages[i].selected = selected;
            this.pages[i].selectedChange.emit(selected);
            this.pages[i].changeDetector.markForCheck();
            this.updateMenuItemsStyle(this._activeIndex);
          }
        }
      }
    }
    // Visuelles Hervorheben der aktiven Seite im Menü anhand von Styling
    updateMenuItemsStyle(index) {
      const updatedMenuItems = [...this.menuItems]; // Erstelle eine neue Referenz
      // Alle Elemente zurücksetzen
      for (let i = 0; i < updatedMenuItems.length; i++) {
        updatedMenuItems[i].styleClass = updatedMenuItems[i].styleClass.replace('his-wizard-menu-item-selected', '').trim();
      }
      // Das Element mit dem übergebenen Index auswählen und markieren
      if (updatedMenuItems[index] && !updatedMenuItems[index].styleClass.includes('his-wizard-menu-item-selected')) {
        updatedMenuItems[index].styleClass += ' his-wizard-menu-item-selected';
      }
      this.menuItems = updatedMenuItems; // Neue Referenz zuweisen
      this.changeDetector.markForCheck();
    }
    updateActiveIndex() {
      let index;
      this.pages.forEach((page, i) => {
        if (page.selected) {
          // if ( this.multiple ) {
          //     ( index as number[] ).push( i );
          // } else {
          index = i;
          return;
          // }
        }
      });
      this.preventActiveIndexPropagation = true;
      this.activeIndexChange.emit(index);
    }
    ngOnDestroy() {
      if (this.tabListSubscription) {
        this.tabListSubscription.unsubscribe();
      }
      if (this.pages) {
        this.pages.forEach(function (page) {
          page.statusChange.unsubscribe();
        });
      }
    }
    static {
      this.ɵfac = function HisWizardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisWizardComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisWizardComponent,
        selectors: [["his-wizard"]],
        contentQueries: function HisWizardComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, HisWizardPageComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabList = _t);
          }
        },
        inputs: {
          sidebarVisible: "sidebarVisible",
          style: "style",
          styleClass: "styleClass",
          activeIndex: "activeIndex",
          activePage: "activePage"
        },
        outputs: {
          tabClose: "tabClose",
          tabOpen: "tabOpen",
          activeIndexChange: "activeIndexChange",
          wizardFinished: "wizardFinished"
        },
        standalone: false,
        ngContentSelectors: _c0$b,
        decls: 6,
        vars: 5,
        consts: [["menu", ""], [1, "his-wizard"], [1, "his-wizard-menu"], [3, "model"], ["role", "tablist", 3, "ngClass", "ngStyle"], [1, "his-wizard-summary"]],
        template: function HisWizardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, HisWizardComponent_Conditional_2_Template, 2, 1, "p-menu", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(5, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.sidebarVisible ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", "his-wizard-accordion p-accordion p-component")("ngStyle", ctx.style);
          }
        },
        dependencies: [i1$2.NgClass, i1$2.NgStyle, i2$7.Menu],
        styles: ["[_nghost-%COMP%]{--accordion-header-height: 50px;--accordion-header-bg: hsl(0, 0%, 95%);--accordion-disabled: hsl(0, 0%, 60%);--accordion-border-radius: 8px;width:100%}.his-wizard[_ngcontent-%COMP%]{display:flex}.his-wizard-accordion[_ngcontent-%COMP%]{flex-grow:3}.his-wizard-accordion[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:.5em}@media screen and (max-width: 1024px){.his-wizard-menu[_ngcontent-%COMP%]{display:none}}"],
        data: {
          animation: [trigger('contentExpansion', [state('expanded', style({
            height: '*',
            opacity: 1,
            visibility: 'visible'
          })), state('collapsed', style({
            height: '0px',
            opacity: 0,
            visibility: 'hidden'
          })), transition('expanded <=> collapsed', animate('200ms cubic-bezier(.37,1.04,.68,.98)'))])]
        },
        changeDetection: 0
      });
    }
  }
  return HisWizardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisInfoPanelComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 2)(2, "p-panel", 3);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelement(4, "div", 1);
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("header", i0.ɵɵpipeBind1(3, 3, ctx_r0.infoHeader));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getInfoLevelClass())("innerHTML", i0.ɵɵpipeBind1(5, 5, ctx_r0.infoMessage), i0.ɵɵsanitizeHtml);
  }
}
function HisInfoPanelComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getInfoLevelClass())("innerHTML", i0.ɵɵpipeBind1(1, 2, ctx_r0.infoMessage), i0.ɵɵsanitizeHtml);
  }
}
function HisInfoPanelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisInfoPanelComponent_Conditional_0_Conditional_0_Template, 7, 7, "div", 0)(1, HisInfoPanelComponent_Conditional_0_Conditional_1_Template, 2, 4, "div", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.showPanel ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.showPanel ? 1 : -1);
  }
}
let HisInfoPanelComponent = /*#__PURE__*/(() => {
  class HisInfoPanelComponent {
    constructor() {
      this.messageLevel = 'info';
      this.showPanel = false;
    }
    ngOnInit() {
      this.infoHeader = 'common.infoHeader.notes';
      if (this.target) {
        let prefix = this.i18nKey.replace('.common.', '.' + this.target + '.').replace('.tab', '');
        this.infoMessage = prefix + '.infoMessage';
      } else {
        this.infoMessage = this.i18nKey;
      }
    }
    getInfoLevelClass() {
      switch (this.messageLevel) {
        case 'warn':
          return 'warnMessage';
        case 'success':
          return 'successMessage';
        case 'require':
          return 'requireMessage';
        default:
          return 'infoMessage';
      }
    }
    static {
      this.ɵfac = function HisInfoPanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisInfoPanelComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisInfoPanelComponent,
        selectors: [["his-info-panel"]],
        inputs: {
          i18nKey: "i18nKey",
          target: "target",
          messageLevel: "messageLevel",
          showPanel: "showPanel"
        },
        standalone: false,
        decls: 3,
        vars: 5,
        consts: [[1, "layoutBlock"], [3, "ngClass", "innerHTML"], [1, "columnFullWidth"], [3, "header"]],
        template: function HisInfoPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisInfoPanelComponent_Conditional_0_Template, 2, 2);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵpipe(2, "hisUi");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.infoMessage) && i0.ɵɵpipeBind1(2, 3, ctx.infoMessage).charAt(0) !== "?" ? 0 : -1);
          }
        },
        dependencies: [i1$2.NgClass, HisButtonTitleDirective, HisPanelDirective, i4$1.Panel, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisInfoPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisStructureSharedModule = /*#__PURE__*/(() => {
  class HisStructureSharedModule {
    static {
      this.ɵfac = function HisStructureSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisStructureSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisStructureSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, HisCoreSharedModule, HisTranslationSharedModule,
        // PrimeNg
        PanelModule, CalendarModule, AutoCompleteModule, InputTextareaModule, MultiSelectModule, AccordionModule, MenuModule, StepsModule]
      });
    }
  }
  return HisStructureSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisStructureSharedModule, {
    declarations: [HisDialogHeaderComponent, HisDialogHeaderPaginatorComponent, HisDocumentationLinkComponent, HisRequestComponent, HisListviewComponent, HisListviewEntryComponent, HisHelptextComponent, HisInfoPanelComponent, HisWizardComponent, HisWizardPageComponent, HisHeadingComponent],
    imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, HisCoreSharedModule, HisTranslationSharedModule,
    // PrimeNg
    PanelModule, CalendarModule, AutoCompleteModule, InputTextareaModule, MultiSelectModule, AccordionModule, MenuModule, StepsModule],
    exports: [HisDialogHeaderComponent, HisDialogHeaderPaginatorComponent, HisDocumentationLinkComponent, HisRequestComponent, HisListviewComponent, HisListviewEntryComponent, HisHelptextComponent, HisInfoPanelComponent, HisWizardComponent, HisWizardPageComponent, HisHeadingComponent]
  });
})();
let HisMultiselectPlamComponent = /*#__PURE__*/(() => {
  class HisMultiselectPlamComponent extends HisMultiselectComponent {
    constructor() {
      super(...arguments);
      this.selectedOptionsChange = new EventEmitter();
      this.selected = new EventEmitter();
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵHisMultiselectPlamComponent_BaseFactory;
        return function HisMultiselectPlamComponent_Factory(__ngFactoryType__) {
          return (ɵHisMultiselectPlamComponent_BaseFactory || (ɵHisMultiselectPlamComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HisMultiselectPlamComponent)))(__ngFactoryType__ || HisMultiselectPlamComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisMultiselectPlamComponent,
        selectors: [["his-multiselect-plam"]],
        outputs: {
          selectedOptionsChange: "selectedOptionsChange",
          selected: "selected"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HisMultiselectPlamComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 20,
        consts: [["content", ""], [3, "label"], [3, "selectedOptionsChange", "selected", "ngModel", "hisDdKey", "dataSource", "field", "customOptionsMethod", "label", "limit", "showDropdownIcon", "showNullItem", "showDeleteButton", "showSelectButton", "editMode", "selectButtonImage", "selectButtonTooltip", "selectedOptions", "removeSelectedOptionsFromDropdown", "resultRowsPerPage", "maxRows", "maxSelectedOptions"]],
        template: function HisMultiselectPlamComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 1)(1, "his-multiselect", 2, 0);
            i0.ɵɵlistener("selectedOptionsChange", function HisMultiselectPlamComponent_Template_his_multiselect_selectedOptionsChange_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selectedOptionsChange.emit($event));
            })("selected", function HisMultiselectPlamComponent_Template_his_multiselect_selected_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selected.emit($event));
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("label", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngModel", ctx._selectedOptions)("hisDdKey", ctx.ddKey)("dataSource", ctx.dataSource)("field", ctx.field)("customOptionsMethod", ctx.customOptionsMethod)("label", ctx.label)("limit", ctx.limit)("showDropdownIcon", ctx.showDropdownIcon)("showNullItem", ctx.showNullItem)("showDeleteButton", ctx.showDeleteButton)("showSelectButton", ctx.showSelectButton)("editMode", ctx.editMode)("selectButtonImage", ctx.selectButtonImage)("selectButtonTooltip", ctx.selectButtonTooltip)("selectedOptions", ctx.selectedOptions)("removeSelectedOptionsFromDropdown", ctx.removeSelectedOptionsFromDropdown)("resultRowsPerPage", ctx.resultRowsPerPage)("maxRows", ctx.maxRows)("maxSelectedOptions", ctx.maxSelectedOptions);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective, HisMultiselectComponent],
        encapsulation: 2
      });
    }
  }
  return HisMultiselectPlamComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisInputSharedModule = /*#__PURE__*/(() => {
  class HisInputSharedModule {
    static {
      this.ɵfac = function HisInputSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisInputSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisInputSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
        // primeng
        TableModule, DataViewModule, DialogModule, AutoCompleteModule,
        // HIS
        HisCoreSharedModule, HisStructureSharedModule]
      });
    }
  }
  return HisInputSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisInputSharedModule, {
    declarations: [HisMultiselectPlamComponent, HisMultiselectComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
    // primeng
    TableModule, DataViewModule, DialogModule, AutoCompleteModule,
    // HIS
    HisCoreSharedModule, HisStructureSharedModule],
    exports: [HisMultiselectPlamComponent, HisMultiselectComponent]
  });
})();
i0.ɵɵsetComponentScope(HisMultiselectComponent, [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i3$1.Table, i2.Header, i2.Footer, i2.PrimeTemplate, i3$1.SortableColumn, i3$1.SortIcon, i3$1.TableCheckbox, i3$1.TableHeaderCheckbox, i2$3.DataView, i3.Dialog, i2$1.AutoComplete, HisImageDirective, HisDdDirective, HisDdValidator, HisAutoCompleteEagerDataSourceDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective], [HisUiPipe]);

/**
 * The core module for the generic search.
 */
let HisInputCoreModule = /*#__PURE__*/(() => {
  class HisInputCoreModule {
    static {
      this.ɵfac = function HisInputCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisInputCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisInputCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [HisInputSharedModule, HisInputSharedModule]
      });
    }
  }
  return HisInputCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisInputCoreModule, {
    imports: [HisInputSharedModule],
    exports: [HisInputSharedModule]
  });
})();
class CommunicationLogUiText {
  static {
    this.PAGE_TITLE = 'cs.sys.communicationlog.pageTitle';
  }
  static {
    this.FILTERS_ACTIVE_HINT = 'cs.sys.communicationlog.filter.activeHint';
  }
  static {
    this.DELETE_CONFIRMATION_HEADER = 'common.deleteNamedRecordQuestion.header';
  }
  static {
    this.DELETE_RECORD_QUESTION = 'common.deleteNamedRecordQuestion';
  }
  static {
    this.YES = 'de.his.javang.ja';
  }
  static {
    this.NO = 'de.his.javang.nein';
  }
  static {
    this.SUCCESS_SAVE = 'common.success.save';
  }
  static {
    this.SUCEESS_SAVE_NEW = 'common.success.saveNew';
  }
  static {
    this.SAVE = 'common.save';
  }
  static {
    this.CANCEL = 'common.cancel';
  }
  static {
    this.EDIT = 'common.edit';
  }
  static {
    this.EDIT_X = 'common.editOf';
  }
  static {
    this.CREATE_X = 'common.createOf';
  }
  static {
    this.DELETE_X = 'common.deleteOf';
  }
  static {
    this.DATE_TIME_FORMAT = 'common.dateTimeFormat';
  }
  static {
    this.DATE_FORMAT = 'common.dateFormat';
  }
  static {
    this.COMMUNICATION_LOG_CREATE_CONVERSATIONRECORD = 'cs.sys.communicationlog.createNewConversationRecord';
  }
  static {
    this.COMMUNICATION_LOG_CONVERSATIONRECORD = 'cs.sys.communicationlog.conversationrecord';
  }
  static {
    this.COMMUNICATION_LOG_ENTRIES = 'cs.sys.communicationlog.entries';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_EMPTY_MESSAGE = 'cs.sys.communicationlog.noEntries';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE = 'cs.sys.communicationlog.entry.';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_NOT_EDITABLE = CommunicationLogUiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + 'notEditbaleError';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_TITLE = CommunicationLogUiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + 'title';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_TEXT = CommunicationLogUiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + 'text';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_DOMAINS = CommunicationLogUiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + 'domains';
  }
  static {
    this.COMMUNICATION_LOG_ENTRY_FROM = CommunicationLogUiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + 'from';
  }
  static {
    this.FILTER_ENABLE = 'de.his.faces.tags.table.tableFilter.enable';
  }
  static {
    this.FILTER_DISABLE = 'de.his.faces.tags.table.tableFilter.disable';
  }
  static {
    this.FILTER_TITLE_DATE = 'cs.sys.communicationlog.filter.title.date';
  }
  static {
    this.FILTER_TITLE_OTHER = 'cs.sys.communicationlog.filter.title.other';
  }
  static {
    this.FILTER_SETTING_FROM = 'cs.sys.communicationlog.filter.settings.from';
  }
  static {
    this.FILTER_SETTING_TO = 'cs.sys.communicationlog.filter.settings.to';
  }
  static {
    this.FILTER_SETTING_CONVERSATION_RECORDS = 'cs.sys.communicationlog.filter.settings.conversationrecords';
  }
  static {
    this.FILTER_SETTING_PORTALMESSAGES = 'cs.sys.communicationlog.filter.settings.portalmessages';
  }
  static {
    this.FILTER_SETTING_MAIL = 'cs.sys.communicationlog.filter.settings.mail';
  }
  static {
    this.FILTER_SETTING_OWN_ACTIVITY = 'cs.sys.communicationlog.filter.settings.ownActivity';
  }
  static {
    this.FILTER_SETTING_OWNER_ACTIVITY = 'cs.sys.communicationlog.filter.settings.ownerActivity';
  }
  static {
    this.FILTER_SETTING_UNIVERSITY_ACTIVITY = 'cs.sys.communicationlog.filter.settings.universityActivity';
  }
  static {
    this.FILTER_SETTING_DOCUMENTS = 'cs.sys.communicationlog.filter.settings.documents';
  }
  static {
    this.FILTER_SETTING_PERSONAL_AGREEMENTS = 'cs.sys.communicationlog.filter.settings.personalAgreements';
  }
  static {
    this.DATA_LOADED_COMPLETELY = 'cs.sys.communicationlog.dataLoadedCompletely';
  }
  static {
    this.LOAD_MORE = 'cs.sys.communicationlog.loadMoreEntries';
  }
  static {
    this.VALIDATION_REQUIRED = 'validation.required';
  }
  static {
    this.VALIDATION_MAX_LENGTH = 'de.his.validator.LengthValidator.MAXIMUM';
  }
  static {
    this.VIEW_MESSAGES_ERROR = 'view.messages.error';
  }
}
function hasDisplayProperties(entry) {
  if (!entry.additionalAttributes) {
    return false;
  }
  const displayProperties = entry.additionalAttributes?.displayProperties;
  return typeof displayProperties === 'object' && displayProperties !== null;
}
const _c0$a = (a0, a1) => ({
  "incommingMessage": a0,
  "outgoingMessage": a1
});
function CommunicationLogEntryComponent_ng_template_5_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
  }
}
function CommunicationLogEntryComponent_ng_template_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "a", 9);
    i0.ɵɵtemplate(2, CommunicationLogEntryComponent_ng_template_5_Conditional_0_Conditional_2_Template, 2, 0, "span", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.displayData.linkUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.displayData.hasDownload ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayData.hasDownload ? "Download" : ctx_r0.displayData.contentString || ctx_r0.displayData.title, " ");
  }
}
function CommunicationLogEntryComponent_ng_template_5_Conditional_1_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dt");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "dd");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const property_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(property_r2.key);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(property_r2.value);
  }
}
function CommunicationLogEntryComponent_ng_template_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 8);
    i0.ɵɵrepeaterCreate(1, CommunicationLogEntryComponent_ng_template_5_Conditional_1_For_2_Template, 4, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.displayData.displayProperties);
  }
}
function CommunicationLogEntryComponent_ng_template_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.displayData.contentString);
  }
}
function CommunicationLogEntryComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CommunicationLogEntryComponent_ng_template_5_Conditional_0_Template, 4, 3, "div")(1, CommunicationLogEntryComponent_ng_template_5_Conditional_1_Template, 3, 0, "dl", 8)(2, CommunicationLogEntryComponent_ng_template_5_Conditional_2_Template, 2, 1, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.displayData.linkUrl ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.displayData.displayProperties ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.displayData.contentString && !ctx_r0.displayData.linkUrl ? 2 : -1);
  }
}
function CommunicationLogEntryComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function CommunicationLogEntryComponent_ng_template_6_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.editEntry.emit(ctx_r0.displayData.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(1, 1, ctx_r0.uiText.EDIT_X, ctx_r0.displayData.title));
  }
}
function CommunicationLogEntryComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
  }
}
function CommunicationLogEntryComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function CommunicationLogEntryComponent_ng_template_6_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.deleteEntry.emit(ctx_r0.displayData.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(1, 1, ctx_r0.uiText.DELETE_X, ctx_r0.displayData.title));
  }
}
function CommunicationLogEntryComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CommunicationLogEntryComponent_ng_template_6_Conditional_0_Template, 2, 4, "button", 11)(1, CommunicationLogEntryComponent_ng_template_6_Conditional_1_Template, 1, 0, "img", 12)(2, CommunicationLogEntryComponent_ng_template_6_Conditional_2_Template, 2, 4, "button", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.displayData.editable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.displayData.editable && ctx_r0.displayData.deletable ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.displayData.deletable ? 2 : -1);
  }
}
function CommunicationLogEntryComponent_For_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-chip")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const domain_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", domain_r5.longtext || domain_r5.uniquename, " ");
  }
}
let CommunicationLogEntryComponent = /*#__PURE__*/(() => {
  class CommunicationLogEntryComponent {
    constructor() {
      this.uiService = inject(HisUiService);
      this.navivationService = inject(HisNavigationService);
      this.deleteEntry = new EventEmitter();
      this.editEntry = new EventEmitter();
      this.uiText = CommunicationLogUiText;
    }
    get displayData() {
      return this.transformToDisplayData(this.entry);
    }
    ngOnInit() {
      this.baseUrl = this.navivationService.getQisserverUrl();
    }
    transformToDisplayData(entry) {
      return {
        id: entry.id,
        title: this.getHeaderString(entry),
        hasContent: this.hasContent(entry),
        createdAt: entry.createdAt,
        senderName: entry.senderName,
        isIncoming: entry.incomming,
        editable: entry.editable,
        deletable: entry.deletable,
        hasDownload: entry.isDocumentEntry,
        linkUrl: this.getLinkUrl(entry),
        contentString: this.getContentString(entry),
        displayProperties: this.getDisplayProperties(entry),
        domains: entry.domainIds?.map(id => this.domainsByIdMap?.get(id)).filter(Boolean).map(domain => ({
          id: domain.id,
          uniquename: domain.uniquename,
          longtext: domain.longtext
        }))
      };
    }
    getContentString(entry) {
      return entry.additionalAttributes?.text || undefined;
    }
    getDisplayProperties(entry) {
      if (!hasDisplayProperties(entry)) {
        return undefined;
      }
      const displayProperties = entry.additionalAttributes?.displayProperties;
      if (!displayProperties) {
        return undefined;
      }
      return Object.entries(displayProperties).map(([key, value]) => ({
        key: this.uiService.translate(key),
        value: value
      }));
    }
    getLinkUrl(entry) {
      if (entry.isDocumentEntry) {
        return this.getDocumentDownloadUrl(entry);
      }
      const linkUrl = entry.linkUrl;
      if (isEmpty$1(linkUrl)) {
        return undefined;
      }
      return `${this.baseUrl}/${linkUrl}`;
    }
    getDocumentDownloadUrl(entry) {
      if (isEmpty$1(entry.referenceId)) {
        return undefined;
      }
      return `${this.baseUrl}/rds?state=docdownload&docId=${entry.referenceId}`;
    }
    getHeaderString(entry) {
      return this.uiService.translate(`${this.uiText.COMMUNICATION_LOG_ENTRY_TITLE}.${entry.type}`, ...entry.titleMessageParams);
    }
    hasContent(entry) {
      if (entry.isDocumentEntry) {
        return true;
      }
      return !isEmpty$1(this.getLinkUrl(entry)) || !isEmpty$1(this.getContentString(entry));
    }
    static {
      this.ɵfac = function CommunicationLogEntryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommunicationLogEntryComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CommunicationLogEntryComponent,
        selectors: [["his-communication-log-entry"]],
        inputs: {
          entry: "entry",
          domainsByIdMap: "domainsByIdMap"
        },
        outputs: {
          deleteEntry: "deleteEntry",
          editEntry: "editEntry"
        },
        standalone: false,
        decls: 21,
        vars: 19,
        consts: [[1, "logEntry"], [3, "ngClass", "styleClass"], ["pTemplate", "content"], ["pTemplate", "icons"], [1, "creationDate"], [1, "senderName"], [1, "clearer"], [1, "entryDomainChips"], [1, "displayProperties"], ["target", "_blank", 3, "href"], [1, "iconfont-download_mono"], ["type", "button", "hisImage", "PENCIL", 1, "transparent", 3, "title"], ["hisImage", "HYPHEN", "styleClass", "spacerHyphenTable", 1, "inlineicon"], ["type", "button", "hisImage", "DELETE", 1, "transparent", 3, "title"], ["type", "button", "hisImage", "PENCIL", 1, "transparent", 3, "click", "title"], ["type", "button", "hisImage", "DELETE", 1, "transparent", 3, "click", "title"]],
        template: function CommunicationLogEntryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "p-panel", 1)(2, "p-header")(3, "h3");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, CommunicationLogEntryComponent_ng_template_5_Template, 3, 3, "ng-template", 2)(6, CommunicationLogEntryComponent_ng_template_6_Template, 3, 3, "ng-template", 3);
            i0.ɵɵelementStart(7, "p-footer")(8, "span", 4);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "hisUi");
            i0.ɵɵpipe(11, "hisDate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "span", 5);
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(15, "div", 6);
            i0.ɵɵelementStart(16, "span", 7);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "hisUi");
            i0.ɵɵrepeaterCreate(19, CommunicationLogEntryComponent_For_20_Template, 3, 1, "p-chip", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c0$a, ctx.displayData.isIncoming, !ctx.displayData.isIncoming))("styleClass", ctx.displayData.contentString || ctx.displayData.linkUrl || ctx.displayData.displayProperties ? "communicationContent" : "noContent");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.displayData.title, " ");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(11, 9, ctx.displayData.createdAt, i0.ɵɵpipeBind1(10, 7, ctx.uiText.DATE_TIME_FORMAT)), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(14, 12, ctx.uiText.COMMUNICATION_LOG_ENTRY_FROM), ": ", ctx.displayData.senderName, "");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 14, ctx.uiText.COMMUNICATION_LOG_ENTRY_DOMAINS), ": ");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.displayData.domains);
          }
        },
        dependencies: [i1$2.NgClass, i2.Header, i2.Footer, i2.PrimeTemplate, i4$1.Panel, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisDeleteActionDirective, HisPanelDirective, i10.Chip, HisUiPipe, HisDatePipe],
        styles: [".logEntry[_ngcontent-%COMP%]{margin-top:1em;margin-bottom:1em}.logEntry[_ngcontent-%COMP%]   p-chip[_ngcontent-%COMP%]     .p-chip{margin:1px}p-panel[_ngcontent-%COMP%]     .noContent .p-panel-content{display:none}p-panel[_ngcontent-%COMP%]     .p-panel-content{background:var(--backgroundColor2)}.logEntry[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]     .p-panel-content{background:var(--backgroundColor2);white-space:pre-wrap}.logEntry[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]     .p-panel-header{border-top-right-radius:2px;border-top-left-radius:2px}.logEntry[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]     .p-panel-footer{border-bottom-right-radius:2px;border-bottom-left-radius:2px}.logEntry[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]   .inlineicon[_ngcontent-%COMP%]{vertical-align:middle}.displayProperties[_ngcontent-%COMP%]{display:grid;grid-template-columns:max-content auto;margin-block-start:0;margin-block-end:0}.displayProperties[_ngcontent-%COMP%]   dt[_ngcontent-%COMP%]{font-weight:700}.displayProperties[_ngcontent-%COMP%]   dd[_ngcontent-%COMP%]{margin-inline-start:1em}.communicationContent[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]     .p-panel-header{border-top-right-radius:2px;border-top-left-radius:2px}.incommingMessage[_ngcontent-%COMP%]{display:block;border-left:4px solid var(--backgroundColor7)}.outgoingMessage[_ngcontent-%COMP%]{display:block;border-left:4px solid var(--backgroundColor11)}.outgoingMessage[_ngcontent-%COMP%]   .senderName[_ngcontent-%COMP%], .incommingMessage[_ngcontent-%COMP%]   .senderName[_ngcontent-%COMP%]{display:inline-block;padding-right:4px}.outgoingMessage[_ngcontent-%COMP%]   .creationDate[_ngcontent-%COMP%], .incommingMessage[_ngcontent-%COMP%]   .creationDate[_ngcontent-%COMP%]{float:right}.entryDomainChips[_ngcontent-%COMP%]{display:inline-block}.communicationContent[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]     .p-panel-footer{border-bottom-right-radius:2px;border-bottom-left-radius:2px}@media screen and (max-width: 768px){.incommingMessage[_ngcontent-%COMP%]   .senderName[_ngcontent-%COMP%]{float:none}}"],
        changeDetection: 0
      });
    }
  }
  return CommunicationLogEntryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$9 = ["logContainer"];
function CommunicationLogEntriesComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.uiText.COMMUNICATION_LOG_ENTRY_EMPTY_MESSAGE), " ");
  }
}
function CommunicationLogEntriesComponent_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-communication-log-entry", 8);
    i0.ɵɵlistener("editEntry", function CommunicationLogEntriesComponent_For_10_Template_his_communication_log_entry_editEntry_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.editEntryById($event));
    })("deleteEntry", function CommunicationLogEntriesComponent_For_10_Template_his_communication_log_entry_deleteEntry_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.deleteEntryById($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entry_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("entry", entry_r3)("domainsByIdMap", ctx_r0.domainsById);
  }
}
function CommunicationLogEntriesComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function CommunicationLogEntriesComponent_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.requestMoreEntries.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.uiText.LOAD_MORE), " ");
  }
}
function CommunicationLogEntriesComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.uiText.DATA_LOADED_COMPLETELY), " ");
  }
}
let CommunicationLogEntriesComponent = /*#__PURE__*/(() => {
  class CommunicationLogEntriesComponent {
    constructor() {
      this.deleteEntry = new EventEmitter();
      this.editEntry = new EventEmitter();
      this.requestMoreEntries = new EventEmitter();
      this.uiText = CommunicationLogUiText;
      this.domainsById = new Map();
    }
    entryId(index, entry) {
      return entry.id;
    }
    ngOnInit() {
      this.updateDomainCache();
    }
    ngOnChanges(changes) {
      if (changes.availableDomains) {
        this.updateDomainCache();
      }
    }
    updateDomainCache() {
      this.domainsById = new Map(this.availableDomains.map(domain => [domain.id, domain]));
    }
    deleteEntryById(id) {
      this.deleteEntry.emit(id);
    }
    editEntryById(id) {
      this.editEntry.emit(id);
    }
    scrollToLatestEntry() {
      this.logContainer.nativeElement.scrollTop = 0;
    }
    static {
      this.ɵfac = function CommunicationLogEntriesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommunicationLogEntriesComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CommunicationLogEntriesComponent,
        selectors: [["his-communication-log-entries"]],
        viewQuery: function CommunicationLogEntriesComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$9, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logContainer = _t.first);
          }
        },
        inputs: {
          logEntries: "logEntries",
          availableDomains: "availableDomains",
          ownerId: "ownerId",
          isDataComplete: "isDataComplete"
        },
        outputs: {
          deleteEntry: "deleteEntry",
          editEntry: "editEntry",
          requestMoreEntries: "requestMoreEntries"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 14,
        vars: 7,
        consts: [["logContainer", ""], [1, "logOuterContainer"], [3, "styleClass"], [1, "logInnerContainer"], [1, "infoMessage"], [3, "entry", "domainsByIdMap"], ["type", "button", "hisImage", "ARROW_ROTATE_CLOCKWISE", 1, "submit_linkLook"], [1, "communicationLogFooter"], [3, "editEntry", "deleteEntry", "entry", "domainsByIdMap"], ["type", "button", "hisImage", "ARROW_ROTATE_CLOCKWISE", 1, "submit_linkLook", 3, "click"]],
        template: function CommunicationLogEntriesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "p-panel", 2)(2, "p-header")(3, "h2");
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3, 0);
            i0.ɵɵtemplate(8, CommunicationLogEntriesComponent_Conditional_8_Template, 3, 3, "div", 4);
            i0.ɵɵrepeaterCreate(9, CommunicationLogEntriesComponent_For_10_Template, 1, 2, "his-communication-log-entry", 5, ctx.entryId, true);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "p-footer");
            i0.ɵɵtemplate(12, CommunicationLogEntriesComponent_Conditional_12_Template, 3, 3, "button", 6)(13, CommunicationLogEntriesComponent_Conditional_13_Template, 3, 3, "span", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("styleClass", "logFrame");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, ctx.uiText.COMMUNICATION_LOG_ENTRIES));
            i0.ɵɵadvance(4);
            i0.ɵɵconditional((ctx.logEntries == null ? null : ctx.logEntries.length) === 0 ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.logEntries);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.isDataComplete ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDataComplete ? 13 : -1);
          }
        },
        dependencies: [i2.Header, i2.Footer, i4$1.Panel, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisPanelDirective, CommunicationLogEntryComponent, HisUiPipe],
        styles: [".logOuterContainer[_ngcontent-%COMP%]   p-panel[_ngcontent-%COMP%]     .p-panel-content{background:var(--backgroundColor43)}"]
      });
    }
  }
  return CommunicationLogEntriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CommunicationLogFilterSettings {
  constructor() {
    this.filters = [];
    this.ownActivity = true;
    this.ownerActivity = true;
    this.universityActivity = true;
    this.domains = [];
  }
}
function CommunicationLogFilterComponent_For_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam")(1, "input", 11, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function CommunicationLogFilterComponent_For_18_Template_input_ngModelChange_1_listener($event) {
      const filter_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      i0.ɵɵtwoWayBindingSet(filter_r3.value, $event) || (filter_r3.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CommunicationLogFilterComponent_For_18_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.emitFilterSettingsChanged());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("hisDdKey", filter_r3.key);
    i0.ɵɵtwoWayProperty("ngModel", filter_r3.value);
  }
}
function CommunicationLogFilterComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam")(1, "input", 11, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function CommunicationLogFilterComponent_Conditional_19_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r3.filterSettings.ownerActivity, $event) || (ctx_r3.filterSettings.ownerActivity = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function CommunicationLogFilterComponent_Conditional_19_Template_input_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.emitFilterSettingsChanged());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hisDdKey", ctx_r3.uiText.FILTER_SETTING_OWNER_ACTIVITY);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.filterSettings.ownerActivity);
  }
}
function CommunicationLogFilterComponent_Conditional_27_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 14)(3, "his-multiselect-plam", 15);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵtwoWayListener("selectedOptionsChange", function CommunicationLogFilterComponent_Conditional_27_Template_his_multiselect_plam_selectedOptionsChange_3_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r3.domainSelection, $event) || (ctx_r3.domainSelection = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("selectedOptionsChange", function CommunicationLogFilterComponent_Conditional_27_Template_his_multiselect_plam_selectedOptionsChange_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.emitFilterSettingsChanged());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(4, 4, ctx_r3.uiText.COMMUNICATION_LOG_ENTRY_DOMAINS))("customOptionsMethod", ctx_r3.customDomainOptions.bind(ctx_r3))("removeSelectedOptionsFromDropdown", true);
    i0.ɵɵtwoWayProperty("selectedOptions", ctx_r3.domainSelection);
  }
}
let CommunicationLogFilterComponent = /*#__PURE__*/(() => {
  class CommunicationLogFilterComponent {
    constructor() {
      this.filterSettingsChanged = new EventEmitter();
      this.renderOwnerActivityFilter = false;
      this.filterSettings = new CommunicationLogFilterSettings();
      this.domainSelection = [];
      this.uiText = CommunicationLogUiText;
    }
    ngOnInit() {
      this.showFilterOptions = !isEmpty$1(this.domainPreselection);
    }
    ngOnChanges(changes) {
      if (changes.availableDomains) {
        this.applyDomainPreselection();
      }
    }
    applyDomainPreselection() {
      if (!isEmpty$1(this.domainPreselection)) {
        this.domainSelection = this.availableDomains.filter(domain => this.domainPreselection.includes(domain.id)).map(domain => this.convertToHisOption(domain));
      } else {
        this.domainSelection = this.availableDomains.map(domain => this.convertToHisOption(domain));
      }
      this.updateDomainSelection();
      this.emitFilterSettingsChanged();
    }
    toggleShowFilterOptions() {
      this.showFilterOptions = !this.showFilterOptions;
    }
    emitFilterSettingsChanged() {
      this.filterSettings.filters = this.filters.filter(filter => filter.value).map(filter => filter.key);
      this.updateDomainSelection();
      this.filterSettingsChanged.emit(structuredClone(this.filterSettings));
    }
    filterDomains(event) {
      const query = event.query;
      this.filteredDomains = this.availableDomains.filter(domain => !this.domainSelection?.includes(this.convertToHisOption(domain)) && domain.uniquename?.toLowerCase().includes(query.toLowerCase()));
    }
    updateDomainSelection() {
      this.filterSettings.domains = this.domainSelection.map(domain => parseInt(domain.id));
    }
    domainSelectionDisabled() {
      return this.domainPreselection?.length === 1 && !isEmpty$1(this.domainSelection);
    }
    customDomainOptions() {
      return of(this.availableDomains?.map(domain => this.convertToHisOption(domain)).sort((a, b) => a.label.localeCompare(b.label)));
    }
    convertToHisOption(domain) {
      return new HisOption(domain.longtext || domain.uniquename, `${domain.id}`);
    }
    static {
      this.ɵfac = function CommunicationLogFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommunicationLogFilterComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CommunicationLogFilterComponent,
        selectors: [["his-communication-log-filter"]],
        inputs: {
          availableDomains: "availableDomains",
          domainPreselection: "domainPreselection",
          filters: "filters",
          renderOwnerActivityFilter: "renderOwnerActivityFilter"
        },
        outputs: {
          filterSettingsChanged: "filterSettingsChanged"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 29,
        vars: 31,
        consts: [["content", ""], [1, "layoutBlock"], [1, "columnHalf"], [3, "multiple"], [3, "header"], [1, "communicationDateContainer"], [1, "noPlamButtonContainer"], ["styleClass", "calendarWidth40", "placeholder", "TT.MM.JJJJ", 3, "ngModelChange", "hisDdKey", "showIcon", "dateFormat", "monthNavigator", "yearNavigator", "maxDate", "ngModel"], ["styleClass", "noPlamButtonContainer"], ["styleClass", "calendarWidth40", "placeholder", "TT.MM.JJJJ", 3, "ngModelChange", "hisDdKey", "showIcon", "dateFormat", "monthNavigator", "yearNavigator", "minDate", "ngModel"], [1, "communicationFilterContainer"], ["type", "checkbox", 3, "ngModelChange", "hisDdKey", "ngModel"], [1, "clearer"], [1, "clearerSpaceAboveHalfEm"], [1, "columnThreeQuarter"], [3, "selectedOptionsChange", "label", "customOptionsMethod", "removeSelectedOptionsFromDropdown", "selectedOptions"]],
        template: function CommunicationLogFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "p-accordion", 3)(3, "p-accordionTab", 4);
            i0.ɵɵpipe(4, "hisUi");
            i0.ɵɵelementStart(5, "div", 5)(6, "his-plam", 6)(7, "p-calendar", 7, 0);
            i0.ɵɵpipe(9, "hisUi");
            i0.ɵɵtwoWayListener("ngModelChange", function CommunicationLogFilterComponent_Template_p_calendar_ngModelChange_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.filterSettings.from, $event) || (ctx.filterSettings.from = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function CommunicationLogFilterComponent_Template_p_calendar_ngModelChange_7_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitFilterSettingsChanged());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "his-plam", 8)(11, "p-calendar", 9, 0);
            i0.ɵɵpipe(13, "hisUi");
            i0.ɵɵtwoWayListener("ngModelChange", function CommunicationLogFilterComponent_Template_p_calendar_ngModelChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.filterSettings.to, $event) || (ctx.filterSettings.to = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function CommunicationLogFilterComponent_Template_p_calendar_ngModelChange_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitFilterSettingsChanged());
            });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(14, "p-accordionTab", 4);
            i0.ɵɵpipe(15, "hisUi");
            i0.ɵɵelementStart(16, "div", 10);
            i0.ɵɵrepeaterCreate(17, CommunicationLogFilterComponent_For_18_Template, 3, 2, "his-plam", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵtemplate(19, CommunicationLogFilterComponent_Conditional_19_Template, 3, 2, "his-plam");
            i0.ɵɵelementStart(20, "his-plam")(21, "input", 11, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function CommunicationLogFilterComponent_Template_input_ngModelChange_21_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.filterSettings.ownActivity, $event) || (ctx.filterSettings.ownActivity = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function CommunicationLogFilterComponent_Template_input_ngModelChange_21_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitFilterSettingsChanged());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(23, "his-plam")(24, "input", 11, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function CommunicationLogFilterComponent_Template_input_ngModelChange_24_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.filterSettings.universityActivity, $event) || (ctx.filterSettings.universityActivity = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function CommunicationLogFilterComponent_Template_input_ngModelChange_24_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitFilterSettingsChanged());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(26, "div", 12);
            i0.ɵɵtemplate(27, CommunicationLogFilterComponent_Conditional_27_Template, 6, 6);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelement(28, "div", 12);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("multiple", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("header", i0.ɵɵpipeBind1(4, 23, ctx.uiText.FILTER_TITLE_DATE));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("hisDdKey", ctx.uiText.FILTER_SETTING_FROM)("showIcon", true)("dateFormat", i0.ɵɵpipeBind1(9, 25, ctx.uiText.DATE_FORMAT))("monthNavigator", true)("yearNavigator", true)("maxDate", ctx.filterSettings.to);
            i0.ɵɵtwoWayProperty("ngModel", ctx.filterSettings.from);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("hisDdKey", ctx.uiText.FILTER_SETTING_TO)("showIcon", true)("dateFormat", i0.ɵɵpipeBind1(13, 27, ctx.uiText.DATE_FORMAT))("monthNavigator", true)("yearNavigator", true)("minDate", ctx.filterSettings.from);
            i0.ɵɵtwoWayProperty("ngModel", ctx.filterSettings.to);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("header", i0.ɵɵpipeBind1(15, 29, ctx.uiText.FILTER_TITLE_OTHER));
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.filters);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.renderOwnerActivityFilter ? 19 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hisDdKey", ctx.uiText.FILTER_SETTING_OWN_ACTIVITY);
            i0.ɵɵtwoWayProperty("ngModel", ctx.filterSettings.ownActivity);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hisDdKey", ctx.uiText.FILTER_SETTING_UNIVERSITY_ACTIVITY);
            i0.ɵɵtwoWayProperty("ngModel", ctx.filterSettings.universityActivity);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((ctx.availableDomains == null ? null : ctx.availableDomains.length) > 1 ? 27 : -1);
          }
        },
        dependencies: [i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i2$2.Calendar, HisPlamComponent, HisDdDirective, HisDdValidator, HisCalendarDefaultsDirective, HisModificationDetectionDirective, HisMultiselectPlamComponent, i9.Accordion, i9.AccordionTab, HisUiPipe],
        styles: [".communicationDateContainer[_ngcontent-%COMP%]{display:flex}@media screen and (max-width: 320px){div.communicationDateContainer[_ngcontent-%COMP%]{display:initial}}"]
      });
    }
  }
  return CommunicationLogFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ConversationRecordEditData {
  constructor() {
    this.id = undefined;
  }
}
class CommunicationLogEntry {
  constructor(id, title, createdAt, domainIds, senderId, senderName, recipientId, recipientName, type, subtype, editable, deletable, incomming, additionalAttributes) {
    this.id = id;
    this.title = title;
    this.createdAt = createdAt;
    this.domainIds = domainIds;
    this.senderId = senderId;
    this.senderName = senderName;
    this.recipientId = recipientId;
    this.recipientName = recipientName;
    this.type = type;
    this.subtype = subtype;
    this.editable = editable;
    this.deletable = deletable;
    this.incomming = incomming;
    this.additionalAttributes = additionalAttributes;
  }
  get referenceId() {
    return this.additionalAttributes?.referenceObjectIdentifier;
  }
  get referenceType() {
    return this.additionalAttributes?.referenceObjectType;
  }
  get linkUrl() {
    return this.additionalAttributes?.url;
  }
  get isDocumentEntry() {
    return this.referenceType === 'DocumentMetadata';
  }
  get titleMessageParams() {
    if (!this.additionalAttributes) {
      return [];
    }
    return [this.title, this.createdAt, this.senderName, this.recipientName, this.type, this.subtype, ...Object.values(this.additionalAttributes)];
  }
}
class CommunicationLogParticipant {
  constructor(id, displayname) {
    this.id = id;
    this.displayname = displayname;
  }
}
function byTimeNewestFirst(a, b) {
  return b?.createdAt.getTime() - a?.createdAt.getTime();
}
let HisCommunicationlogService = /*#__PURE__*/(() => {
  class HisCommunicationlogService {
    constructor() {
      this.backendService = inject(HisBackendService);
      this.genericValueService = inject(HisGenericValueService);
      this.uiService = inject(HisUiService);
      this.navigationService = inject(HisNavigationService);
      this.auth = inject(HisAuthService);
      this.apiBase = 'api/v1/cs/sys/communicationlog';
      this.allowedDomainIds$ = this.backendService.getData(`${this.apiBase}/alloweddomains`).pipe(shareReplay$1(1));
      this.allDomainsCached$ = this.genericValueService.getValueTypes('domainValue').pipe(map$1(domains => {
        return domains.sort((a, b) => {
          return a.defaulttext?.localeCompare(b.defaulttext) ?? a.uniquename.localeCompare(b.uniquename);
        });
      }), shareReplay$1(1));
      this.allowedDomains$ = forkJoin({
        allowedIds: this.allowedDomainIds$,
        domains: this.allDomainsCached$
      }).pipe(map$1(result => {
        return result.domains.filter(domain => result.allowedIds.includes(domain.id));
      }), shareReplay$1(1));
      this.pageSize$ = this.backendService.getData(`${this.apiBase}/config/pagesize`).pipe(shareReplay$1(1));
      this.personCache = new Map();
    }
    findByOwnerId(id, olderThan = new Date('2100-12-31')) {
      const requestOptions = {
        showPermissionError: false
      };
      let restParams = new HttpParams().set('olderThan', olderThan?.toISOString());
      const apiUrl = `${this.apiBase}/${id}?${restParams.toString()}`;
      return this.backendService.getData(apiUrl, requestOptions).pipe(catchError(error => {
        if (error.status === 401 || error.status === 403) {
          this.navigationService.navigateToAccessDenied();
        }
        return throwError(() => error);
      }), tap$1(response => this.personCache.set(id, new CommunicationLogParticipant(id, response.ownerName))), map$1(response => response.entries), map$1(rawEntries => rawEntries.map(entry => this.convertToModel(entry, id))), map$1(entries => entries.filter(Boolean)), map$1(entries => entries.sort(byTimeNewestFirst)), tap$1(entries => entries.forEach(entry => this.addToPersonCacheIfNotExists(entry))));
    }
    addToPersonCacheIfNotExists(entry) {
      if (!this.personCache.has(entry.senderId)) {
        this.personCache.set(entry.senderId, new CommunicationLogParticipant(entry.senderId, entry.senderName));
      }
      if (!this.personCache.has(entry.recipientId)) {
        this.personCache.set(entry.recipientId, new CommunicationLogParticipant(entry.recipientId, entry.recipientName));
      }
    }
    getNameOrTranslation(name) {
      if (name?.includes('.')) {
        return this.uiService.translate(name);
      }
      return name;
    }
    isOutgoing(entry, ownerId) {
      if (ownerId === this.auth.personId) {
        return entry.senderId === ownerId;
      }
      return entry.senderId !== ownerId;
    }
    convertToModel(raw, ownerId) {
      const id = raw.id;
      const title = raw.title;
      const createdAt = new Date(raw.createdAt);
      const domainIds = raw.domainIds;
      const senderId = raw.senderId;
      const senderName = this.getNameOrTranslation(raw.senderName);
      const recipientId = raw.recipientId;
      const recipientName = this.getNameOrTranslation(raw.recipientName);
      const type = raw.type;
      const subtype = raw.subtype;
      const editable = raw.editable;
      const deletable = raw.deletable;
      const incomming = !this.isOutgoing(raw, ownerId);
      const additionalAttributes = raw.additionalAttributes;
      return new CommunicationLogEntry(id, title, createdAt, domainIds, senderId, senderName, recipientId, recipientName, type, subtype, editable, deletable, incomming, additionalAttributes);
    }
    createConversationRecord(ownerId, conversationRecord) {
      return this.backendService.postData(`${this.apiBase}/${ownerId}/createconversationrecord`, conversationRecord);
    }
    updateConversationRecord(conversationRecord) {
      return this.backendService.putData(`${this.apiBase}/update`, conversationRecord);
    }
    getAllDomains(logOwnerId) {
      if (this.auth.personId === logOwnerId) {
        return this.allDomainsCached$;
      }
      return this.allowedDomains$;
    }
    deleteEntry(id) {
      return this.backendService.delete(`${this.apiBase}/delete/${id}`);
    }
    getParticipantName(id) {
      if (id && this.personCache.has(id)) {
        return this.personCache.get(id);
      }
      return new CommunicationLogParticipant(id, '');
    }
    getPageSize() {
      return this.pageSize$;
    }
    getFilterDefinitions() {
      return this.backendService.getData(`${this.apiBase}/filterdefinitions`);
    }
    static {
      this.ɵfac = function HisCommunicationlogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCommunicationlogService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisCommunicationlogService,
        factory: HisCommunicationlogService.ɵfac
      });
    }
  }
  return HisCommunicationlogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$8 = ["creationDialog"];
const _c1$3 = ["logEntries"];
function HisCommunicationlogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-header")(1, "h1");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r0.uiText.PAGE_TITLE));
  }
}
function HisCommunicationlogComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "his-dialog-header", 2);
    i0.ɵɵelementContainerStart(1, 8);
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("showBackButton", false)("showResetButton", false)("showSaveButton", false);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.getPersonName(ctx_r0.ownerId));
  }
}
function HisCommunicationlogComponent_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function HisCommunicationlogComponent_Conditional_1_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      i0.ɵɵnextContext();
      const creationDialog_r4 = i0.ɵɵreference(9);
      return i0.ɵɵresetView(creationDialog_r4.showDialog());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, ctx_r0.uiText.CREATE_X, i0.ɵɵpipeBind1(2, 1, ctx_r0.uiText.COMMUNICATION_LOG_CONVERSATIONRECORD)), " ");
  }
}
function HisCommunicationlogComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "his-confirm-dialog");
    i0.ɵɵtemplate(2, HisCommunicationlogComponent_Conditional_1_Conditional_2_Template, 4, 4, "his-dialog-header", 2);
    i0.ɵɵelement(3, "div", 3);
    i0.ɵɵelementStart(4, "his-communication-log-filter", 4);
    i0.ɵɵlistener("filterSettingsChanged", function HisCommunicationlogComponent_Conditional_1_Template_his_communication_log_filter_filterSettingsChanged_4_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.applyFilterSettings($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, HisCommunicationlogComponent_Conditional_1_Conditional_5_Template, 4, 6, "button", 5);
    i0.ɵɵelementStart(6, "his-communication-log-entries", 6, 0);
    i0.ɵɵlistener("editEntry", function HisCommunicationlogComponent_Conditional_1_Template_his_communication_log_entries_editEntry_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.editEntryById($event));
    })("deleteEntry", function HisCommunicationlogComponent_Conditional_1_Template_his_communication_log_entries_deleteEntry_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.deleteEntryById($event));
    })("requestMoreEntries", function HisCommunicationlogComponent_Conditional_1_Template_his_communication_log_entries_requestMoreEntries_6_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.loadMoreEntries());
    })("nearEnd", function HisCommunicationlogComponent_Conditional_1_Template_his_communication_log_entries_nearEnd_6_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.loadMoreEntries());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "his-conversation-record-edit", 7, 1);
    i0.ɵɵlistener("conversationRecord", function HisCommunicationlogComponent_Conditional_1_Template_his_conversation_record_edit_conversationRecord_8_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.saveConversationRecord($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.shouldRenderDialogHeader() ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("availableDomains", ctx_r0.allDomains)("domainPreselection", ctx_r0.domainRestriction)("filters", ctx_r0.filters)("renderOwnerActivityFilter", ctx_r0.ownerActivityFilterActive);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.canCreateConversationRecord ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("logEntries", ctx_r0.filteredLogEntries)("ownerId", ctx_r0.ownerId)("isDataComplete", ctx_r0.allEntriesLoaded)("availableDomains", ctx_r0.allDomains);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("availableDomains", ctx_r0.allDomains);
  }
}
class CommunicationLogFilterValue {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}
let HisCommunicationlogComponent = /*#__PURE__*/(() => {
  class HisCommunicationlogComponent {
    constructor() {
      this.communicationlogService = inject(HisCommunicationlogService);
      this.confirmationService = inject(HisConfirmationService);
      this.notificationService = inject(HisNotificationService);
      this.hisUiService = inject(HisUiService);
      this.auth = inject(HisAuthService);
      this.renderTitle = true;
      this.renderDialogHeader = true;
      this.logEntries = null;
      this.filteredLogEntries = null;
      this.allDomains = [];
      this.availableDomains = [];
      this.uiText = CommunicationLogUiText;
      this.renderSelf = false;
      this.allEntriesLoaded = false;
      this.filters = [];
      this.filterSettings = null;
      this.initialized = false;
      this.filterDefinitions = [];
      this.canCreateConversationRecord = this.auth.hasAny('RIGHT_CS_SYS_APPLOG_CREATE_COMMUNICATION_NOTES');
    }
    ngOnInit() {
      this.initData();
    }
    ngAfterViewChecked() {
      if (!this.initialized && this.logEntriesComponent) {
        this.logEntriesComponent.scrollToLatestEntry();
        this.initialized = true;
      }
    }
    ngOnDestroy() {
      this.notificationService.clear();
    }
    initData() {
      const allDomains$ = this.communicationlogService.getAllDomains(this.ownerId).pipe(tap$1(domains => {
        this.allDomains = domains;
      }));
      const logEntires$ = this.communicationlogService.findByOwnerId(this.ownerId).pipe(tap$1(entries => {
        this.logEntries = entries;
        this.filteredLogEntries = entries;
        this.checkIfAllEntriesAreLoaded(entries);
      }));
      this.communicationlogService.getPageSize().subscribe(pageSize => this.pageSize = pageSize);
      this.communicationlogService.getFilterDefinitions().subscribe(filterDefinitions => {
        this.filterDefinitions = filterDefinitions;
        this.filters = filterDefinitions.map(definition => new CommunicationLogFilterValue(definition.key, true));
      });
      forkJoin([allDomains$, logEntires$]).subscribe(() => {
        this.initAvailableDomains();
        this.initDomainRestriction();
        this.applyFilterSettings(this.filterSettings);
        this.initialized = false;
        this.renderSelf = true;
      });
    }
    checkIfAllEntriesAreLoaded(entries) {
      if (entries.length < this.pageSize) {
        this.allEntriesLoaded = true;
      }
    }
    initDomainRestriction() {
      if (!isEmpty$1(this.domainRestriction) && !this.filterSettings) {
        this.filterSettings ??= new CommunicationLogFilterSettings();
        this.filterSettings.domains = [...new Set(this.domainRestriction)];
        this.applyFilterSettings(this.filterSettings);
      }
    }
    applyFilterSettings(filterSettings) {
      this.filterSettings = filterSettings;
      const filteredEntries = [...this.logEntries].filter(entry => {
        return this.filterByDateRange(entry) && this.filterBySender(entry) && this.filterByType(entry) && this.fitlerByDomain(entry);
      });
      this.filteredLogEntries = filteredEntries;
    }
    truncatedCreationDateMeetsPredicate(entry, predicate) {
      const creationDate = new Date(entry.createdAt);
      creationDate.setHours(0, 0, 0, 0);
      return predicate(creationDate);
    }
    filterByDateRange(entry) {
      if (!this.filterSettings) {
        return true;
      }
      if (this.filterSettings.from && this.filterSettings.to) {
        return this.truncatedCreationDateMeetsPredicate(entry, date => {
          return date >= this.filterSettings.from && date <= this.filterSettings.to;
        });
      }
      if (this.filterSettings.from) {
        return this.truncatedCreationDateMeetsPredicate(entry, date => {
          return date >= this.filterSettings.from;
        });
      }
      if (this.filterSettings.to) {
        return this.truncatedCreationDateMeetsPredicate(entry, date => {
          return date <= this.filterSettings.to;
        });
      }
      return true;
    }
    filterBySender(entry) {
      if (!this.filterSettings) {
        return true;
      }
      const filterByOwnerActivity = this.ownerActivityFilterActive && this.filterSettings.ownerActivity;
      if (!this.filterSettings.ownActivity && !this.filterSettings.universityActivity && !filterByOwnerActivity) {
        return true;
      }
      if (this.filterSettings.ownActivity && entry.senderId === this.auth.personId) {
        return true;
      }
      if (filterByOwnerActivity && entry.senderId === this.ownerId) {
        return true;
      }
      if (this.filterSettings.universityActivity && entry.senderId !== this.ownerId) {
        return true;
      }
      return false;
    }
    filterByType(entry) {
      if (this.filterDefinitions && this.filterDefinitions.length > 0) {
        for (let definition of this.filterDefinitions) {
          if (this.isFilterActive(definition.key) && this.filterDefinitionMatchesEntry(definition, entry)) {
            return true;
          }
        }
      }
      return false;
    }
    fitlerByDomain(entry) {
      if (!this.filterSettings) {
        return true;
      }
      if (isEmpty$1(this.filterSettings.domains)) {
        return true;
      }
      return entry.domainIds.some(domainId => {
        return this.filterSettings.domains.includes(domainId);
      });
    }
    filterDefinitionMatchesEntry(definition, entry) {
      const isType = this.matches(entry.type, definition.config.type);
      const isSubtype = this.matches(entry.subtype, definition.config.subtype);
      if (isType && isSubtype) {
        return true;
      }
      return false;
    }
    matches(valueToMatch, pattern) {
      if (isEmpty$1(pattern)) {
        return true;
      }
      return !!valueToMatch.match(pattern);
    }
    isFilterActive(key) {
      // Note: this.filterSettings may be null
      if (this.filterSettings) {
        return this.filterSettings.filters.includes(key);
      }
      return false;
    }
    initAvailableDomains() {
      const usedDomainIds = [...new Set(this.logEntries.flatMap(entry => entry.domainIds))];
      this.availableDomains = this.allDomains.filter(domain => usedDomainIds.includes(domain.id));
    }
    saveConversationRecord(logEntry) {
      if (!logEntry.id) {
        this.createNewConversationRecord(logEntry);
      } else {
        this.updateConversationRecord(logEntry);
      }
    }
    updateConversationRecord(logEntry) {
      this.communicationlogService.updateConversationRecord(logEntry).subscribe(() => {
        this.creationDialog.hideDialog();
        const oldEntry = this.logEntries.find(entry => entry.id === logEntry.id);
        const editedEntry = cloneDeep$1(oldEntry);
        editedEntry.title = logEntry.title;
        editedEntry.domainIds = logEntry.domainIds;
        editedEntry.additionalAttributes.text = logEntry.text;
        const index = this.logEntries.findIndex(entry => entry.id === logEntry.id);
        this.logEntries.splice(index, 1, editedEntry);
        this.applyFilterSettings(this.filterSettings);
        this.notificationService.successI18n(this.uiText.SUCCESS_SAVE);
      });
    }
    createNewConversationRecord(newLogEntry) {
      this.communicationlogService.createConversationRecord(this.ownerId, newLogEntry).subscribe(() => {
        this.notificationService.clear();
        this.communicationlogService.findByOwnerId(this.ownerId).pipe(tap$1(this.checkIfAllEntriesAreLoaded.bind(this))).subscribe(entries => {
          //entries may contain data, that has been updated -> replace "old" data
          const notUpdatedEntries = this.logEntries.filter(entry => !entries.some(other => other.id === entry.id));
          //merge and sort by creation date
          this.logEntries = [...entries, ...notUpdatedEntries].sort(byTimeNewestFirst);
          this.applyFilterSettings(this.filterSettings);
          this.creationDialog.hideDialog();
          this.notificationService.successI18n(this.uiText.SUCEESS_SAVE_NEW);
        });
      });
    }
    deleteEntryById(id) {
      const entryToDelete = this.logEntries.find(entry => entry.id === id);
      this.confirmationService.confirm({
        header: this.hisUiService.translate(this.uiText.DELETE_CONFIRMATION_HEADER),
        message: this.hisUiService.translate(this.uiText.DELETE_RECORD_QUESTION, entryToDelete.title),
        accept: () => {
          this.communicationlogService.deleteEntry(id).subscribe(() => {
            this.logEntries = this.logEntries.filter(entry => entry.id !== id);
            this.applyFilterSettings(this.filterSettings);
            this.notificationService.deleteSuccessI18n();
          });
        }
      });
    }
    editEntryById(id) {
      const entryToEdit = this.logEntries.find(entry => entry.id === id);
      const data = new ConversationRecordEditData();
      data.id = id;
      data.title = entryToEdit.title;
      data.text = entryToEdit.additionalAttributes?.text;
      data.domainIds = [...entryToEdit.domainIds];
      this.creationDialog.editEntry(data);
    }
    loggedInPersonId() {
      return this.auth.personId;
    }
    getPersonName(id) {
      return this.communicationlogService.getParticipantName(id)?.displayname;
    }
    shouldRenderDialogHeader() {
      if (!this.renderDialogHeader) {
        return false;
      }
      return this.auth.personId !== this.ownerId;
    }
    loadMoreEntries() {
      if (!this.canLoadMoreEntries()) {
        return;
      }
      const lastEntry = this.logEntries[this.logEntries.length - 1];
      this.communicationlogService.findByOwnerId(this.ownerId, lastEntry.createdAt).subscribe(entries => {
        const newEntries = entries.filter(entry => !this.logEntries.some(existingEntry => existingEntry.id === entry.id));
        this.logEntries = [...this.logEntries, ...newEntries];
        this.checkIfAllEntriesAreLoaded(entries);
        if (this.canLoadMoreEntries() && !this.hasScrollbar()) {
          this.loadMoreEntries();
        }
        this.applyFilterSettings(this.filterSettings);
      });
    }
    canLoadMoreEntries() {
      return !this.allEntriesLoaded;
    }
    hasScrollbar() {
      return document.documentElement.scrollHeight - document.documentElement.clientHeight > 0;
    }
    get ownerActivityFilterActive() {
      return this.auth.personId !== this.ownerId;
    }
    static {
      this.ɵfac = function HisCommunicationlogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCommunicationlogComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisCommunicationlogComponent,
        selectors: [["his-communicationlog"]],
        viewQuery: function HisCommunicationlogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$8, 5);
            i0.ɵɵviewQuery(_c1$3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.creationDialog = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logEntriesComponent = _t.first);
          }
        },
        inputs: {
          ownerId: "ownerId",
          domainRestriction: "domainRestriction",
          renderTitle: "renderTitle",
          renderDialogHeader: "renderDialogHeader"
        },
        standalone: false,
        decls: 2,
        vars: 2,
        consts: [["logEntries", ""], ["creationDialog", ""], [3, "showBackButton", "showResetButton", "showSaveButton"], [1, "clearAndSpace"], [3, "filterSettingsChanged", "availableDomains", "domainPreselection", "filters", "renderOwnerActivityFilter"], ["type", "button", "hisImage", "plus_circ_green", 1, "transparent"], ["appScrollNearEnd", "250", 3, "editEntry", "deleteEntry", "requestMoreEntries", "nearEnd", "logEntries", "ownerId", "isDataComplete", "availableDomains"], [3, "conversationRecord", "availableDomains"], ["dataBox", ""], ["type", "button", "hisImage", "plus_circ_green", 1, "transparent", 3, "click"]],
        template: function HisCommunicationlogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisCommunicationlogComponent_Conditional_0_Template, 4, 3, "p-header")(1, HisCommunicationlogComponent_Conditional_1_Template, 10, 11, "div");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.renderTitle ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.renderSelf ? 1 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return HisCommunicationlogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class HisFormUtils {
  /**
   *
   * @param form triggers form validation fo all controls without waiting for pending controls (i.e. for async validators)
   */
  static triggerFormValidation(form) {
    Object.keys(form.controls).forEach(control => form.controls[control].markAsDirty());
  }
  /**
   * triggers validation of form and waits for pending controls
   * @param form
   * @param checkIntervalInMs (default = 250) interval to check the pending state of the form controls
   * @param maxRetries (default = 12) maximum number of retries to check the pending state of the form controls. Interval is multiplied by the retry number for each subsequent try
   * @returns true, if all form controls complete pending state within the waiting time (default = 19.5s), false otherwise
   */
  static async triggerFormValidationAsync(form, checkIntervalInMs = 250, maxRetries = 12) {
    HisFormUtils.triggerFormValidation(form);
    return HisFormUtils.until(() => !form.pending, checkIntervalInMs, maxRetries);
  }
  static until(conditionFunction, checkIntervalInMs, maxRetries) {
    let currentTry = 0;
    const poll = resolve => {
      if (conditionFunction()) {
        resolve(true);
      } else if (currentTry >= maxRetries) {
        resolve(false);
      } else {
        currentTry++;
        setTimeout(_ => poll(resolve), checkIntervalInMs * (currentTry + 1));
      }
    };
    return new Promise(poll);
  }
}
function ConversationRecordEditComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "his-plam");
    i0.ɵɵelement(1, "his-multiselect", 7, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ddKey", ctx_r1.uiText.COMMUNICATION_LOG_ENTRY_DOMAINS)("hisDdKey", ctx_r1.uiText.COMMUNICATION_LOG_ENTRY_DOMAINS)("customOptionsMethod", ctx_r1.customDomainOptions.bind(ctx_r1))("removeSelectedOptionsFromDropdown", true);
  }
}
let ConversationRecordEditComponent = /*#__PURE__*/(() => {
  class ConversationRecordEditComponent {
    constructor() {
      this.uiService = inject(HisUiService);
      this.notificationService = inject(HisNotificationService);
      this.formBuilder = inject(FormBuilder);
      this.conversationRecord = new EventEmitter();
      this.visible = false;
      this.cancel = this.hideDialog;
      this.uiText = CommunicationLogUiText;
    }
    get editedEntryId() {
      return this._editedEntryId;
    }
    set editedEntryId(value) {
      this._editedEntryId = value;
      this.overlayTitle = this.getOverlayTitle(!!value);
    }
    ngOnInit() {
      this.form = this.formBuilder.group({
        title: ['', Validators.required],
        text: [''],
        domains: [null, Validators.required]
      });
    }
    saveConversationRecord() {
      HisFormUtils.triggerFormValidation(this.form);
      if (!this.form.valid) {
        this.showValidationMessages();
        return;
      }
      const conversationRecord = new ConversationRecordEditData();
      conversationRecord.id = this.editedEntryId ?? undefined;
      conversationRecord.text = this.form.value.text;
      conversationRecord.title = this.form.value.title;
      conversationRecord.domainIds = this.form.value.domains?.map(domain => parseInt(domain.id));
      this.conversationRecord.emit(conversationRecord);
    }
    showValidationMessages() {
      const errorMessages = [];
      Object.keys(this.form.controls).forEach(controlName => {
        const formControl = this.form.controls[controlName];
        if (formControl.errors?.required) {
          errorMessages.push(this.uiService.translate(this.uiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + controlName) + ': ' + this.uiService.translate(this.uiText.VALIDATION_REQUIRED));
        }
        if (formControl.errors?.maxlength) {
          errorMessages.push(this.uiService.translate(this.uiText.VALIDATION_MAX_LENGTH, this.uiService.translate(this.uiText.COMMUNICATION_LOG_ENTRY_ATTRIBUTE_BASE + controlName), formControl.errors.maxlength.requiredLength));
        }
      });
      this.notificationService.clear();
      this.notificationService.error(errorMessages, this.uiService.translate(this.uiText.VIEW_MESSAGES_ERROR));
    }
    hideDialog() {
      this.visible = false;
      this.editedEntryId = null;
      this.form.reset();
    }
    showDialog() {
      this.form.reset();
      this.editedEntryId = null;
      if (this.availableDomains?.length === 1) {
        this.form.setValue({
          title: '',
          text: '',
          domains: this.availableDomains.map(domain => this.convertToHisOption(domain))
        });
      }
      this.visible = true;
    }
    editEntry(data) {
      this.form.reset();
      const selectedDomains = data.domainIds.map(id => this.availableDomains.find(domain => domain.id === id)).map(domain => this.convertToHisOption(domain));
      this.form.setValue({
        title: data.title ?? '',
        text: data.text ?? '',
        domains: selectedDomains
      });
      this.editedEntryId = data.id;
      this.visible = true;
    }
    filterDomains(event) {
      const query = event.query;
      this.filteredDomains = this.availableDomains.filter(domain => !this.form.value.domains?.includes(domain) && domain.uniquename?.toLowerCase().includes(query.toLowerCase()));
    }
    getOverlayTitle(isEditMode) {
      const communicationRecord = this.uiService.translate(this.uiText.COMMUNICATION_LOG_CONVERSATIONRECORD);
      if (isEditMode) {
        return this.uiService.translate(this.uiText.EDIT_X, communicationRecord);
      }
      return this.uiService.translate(this.uiText.CREATE_X, communicationRecord);
    }
    customDomainOptions() {
      return of(this.availableDomains?.map(domain => this.convertToHisOption(domain)).sort((a, b) => a.label.localeCompare(b.label)));
    }
    convertToHisOption(domain) {
      return new HisOption(domain.longtext || domain.uniquename, `${domain.id}`);
    }
    static {
      this.ɵfac = function ConversationRecordEditComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConversationRecordEditComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: ConversationRecordEditComponent,
        selectors: [["his-conversation-record-edit"]],
        inputs: {
          availableDomains: "availableDomains"
        },
        outputs: {
          conversationRecord: "conversationRecord"
        },
        standalone: false,
        decls: 19,
        vars: 16,
        consts: [["content", ""], [3, "visibleChange", "modal", "blockScroll", "visible", "title"], [3, "ngSubmit", "formGroup"], ["type", "text", "formControlName", "title", "required", "", "hisTrimInput", "", 1, "inputWidth100", 3, "hisDdKey"], ["type", "text", "formControlName", "text", "hisTrimInput", "", 1, "textareaWidth100", 3, "hisDdKey", "rows"], ["type", "submit"], ["type", "button", 3, "click"], ["required", "", "formControlName", "domains", 3, "ddKey", "hisDdKey", "customOptionsMethod", "removeSelectedOptionsFromDropdown"]],
        template: function ConversationRecordEditComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-dialog", 1);
            i0.ɵɵtwoWayListener("visibleChange", function ConversationRecordEditComponent_Template_p_dialog_visibleChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.visible, $event) || (ctx.visible = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementStart(1, "p-header")(2, "h2");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "form", 2);
            i0.ɵɵlistener("ngSubmit", function ConversationRecordEditComponent_Template_form_ngSubmit_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.saveConversationRecord());
            });
            i0.ɵɵelementStart(5, "his-plam");
            i0.ɵɵelement(6, "input", 3, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "his-plam")(9, "textarea", 4, 0);
            i0.ɵɵtext(11, "      ");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, ConversationRecordEditComponent_Conditional_12_Template, 3, 4, "his-plam");
            i0.ɵɵelementStart(13, "button", 5);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "button", 6);
            i0.ɵɵlistener("click", function ConversationRecordEditComponent_Template_button_click_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.cancel());
            });
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "hisUi");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("modal", true)("blockScroll", true);
            i0.ɵɵtwoWayProperty("visible", ctx.visible);
            i0.ɵɵproperty("title", ctx.overlayTitle);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.overlayTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hisDdKey", ctx.uiText.COMMUNICATION_LOG_ENTRY_TITLE);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("hisDdKey", ctx.uiText.COMMUNICATION_LOG_ENTRY_TEXT)("rows", 10);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((ctx.availableDomains == null ? null : ctx.availableDomains.length) > 1 ? 12 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 12, ctx.uiText.SAVE));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 14, ctx.uiText.CANCEL));
          }
        },
        dependencies: [i1$1.ɵNgNoValidate, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.RequiredValidator, i1$1.FormGroupDirective, i1$1.FormControlName, i2.Header, i3.Dialog, HisPlamComponent, HisDdDirective, HisDdValidator, HisFormDefaultsDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisTrimInputDirective, HisMultiselectComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return ConversationRecordEditComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule for Communicationlog.
 */
let HisCommunicationlogSharedModule = /*#__PURE__*/(() => {
  class HisCommunicationlogSharedModule {
    static {
      this.ɵfac = function HisCommunicationlogSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCommunicationlogSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCommunicationlogSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, AutoCompleteModule, CalendarModule, InputNumberModule, PanelModule, TableModule, TabViewModule, DialogModule, ConfirmDialogModule, HisCoreSharedModule, HisStructureSharedModule, HisInputCoreModule, ChipModule, AccordionModule]
      });
    }
  }
  return HisCommunicationlogSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCommunicationlogSharedModule, {
    declarations: [HisCommunicationlogComponent, CommunicationLogFilterComponent, CommunicationLogEntriesComponent, CommunicationLogEntryComponent, ConversationRecordEditComponent],
    imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, AutoCompleteModule, CalendarModule, InputNumberModule, PanelModule, TableModule, TabViewModule, DialogModule, ConfirmDialogModule, HisCoreSharedModule, HisStructureSharedModule, HisInputCoreModule, ChipModule, AccordionModule],
    exports: [HisCommunicationlogComponent]
  });
})();
i0.ɵɵsetComponentScope(HisCommunicationlogComponent, [i2.Header, HisConfirmDialogComponent, HisImageDirective, HisPageTitleDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisScrollNearEndDirective, HisDialogHeaderComponent, CommunicationLogFilterComponent, CommunicationLogEntriesComponent, ConversationRecordEditComponent], [HisUiPipe]);

/**
 * CoreModule for Communicationlog.
 */
let HisCommunicationlogCoreModule = /*#__PURE__*/(() => {
  class HisCommunicationlogCoreModule {
    static {
      this.ɵfac = function HisCommunicationlogCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCommunicationlogCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCommunicationlogCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisCommunicationlogService],
        imports: [HisCommunicationlogSharedModule, HisCommunicationlogSharedModule]
      });
    }
  }
  return HisCommunicationlogCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCommunicationlogCoreModule, {
    imports: [HisCommunicationlogSharedModule],
    exports: [HisCommunicationlogSharedModule]
  });
})();
class ServerLogEntry {}
let HisErrorHandler = /*#__PURE__*/(() => {
  class HisErrorHandler {
    constructor() {
      this.hisBackendService = inject(HisBackendService);
      this.errorCounter = 0;
    }
    handleError(error) {
      console.error(error);
      // 422: Validation Error, 409: Conflict
      if (error.status === 422 || error.status === 409) {
        return;
      }
      // Limit number of error reports because the same error might
      // occur hundreds of times during change detection (anfrage 328763)
      if (this.errorCounter > 5) {
        return;
      }
      let data = {
        fileName: error.fileName,
        message: error.message,
        stack: error.stack
      };
      if (this.lastError === data) {
        return;
      }
      this.lastError = data;
      this.errorCounter++;
      this.hisBackendService.postData('api/v1/cs/sys/log/error', data).subscribe(answer => {
        console.log(answer);
      });
    }
    static {
      this.ɵfac = function HisErrorHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisErrorHandler)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisErrorHandler,
        factory: HisErrorHandler.ɵfac
      });
    }
  }
  return HisErrorHandler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisReorderTableService = /*#__PURE__*/(() => {
  class HisReorderTableService {
    /**
     * Reorderable rows or columns by button click
     * direction = -1 = left, up; direction = 1 = right, down
     *
     */
    moveRowOrColumn(elements, element, direction) {
      let indexOfCar = elements.findIndex(el => el === element);
      moveItemInArray(elements, indexOfCar, indexOfCar + direction);
    }
    static {
      this.ɵfac = function HisReorderTableService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisReorderTableService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisReorderTableService,
        factory: HisReorderTableService.ɵfac
      });
    }
  }
  return HisReorderTableService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisRouteService = /*#__PURE__*/(() => {
  class HisRouteService {
    constructor() {}
    /**
     * clean up parameter suffixes.
     *
     * Workaround for https://github.com/angular/angular/issues/14137
     */
    cleanupParamSuffixes(params) {
      let res = {};
      for (let key in params) {
        if (key.indexOf('{') === 0) {
          let pos = key.indexOf('}');
          let suffixLength = key.length - pos - 1;
          let realKey = key.substring(1, pos);
          let realValue = params[key].substring(0, params[key].length - suffixLength);
          res[realKey] = realValue;
        } else {
          res[key] = params[key];
        }
      }
      return res;
    }
    static {
      this.ɵfac = function HisRouteService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisRouteService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisRouteService,
        factory: HisRouteService.ɵfac
      });
    }
  }
  return HisRouteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Initialisierungen, die für alle HIS Angualar-Apps einheitlich sein sollen
 */
let HisCoreInitializerService = /*#__PURE__*/(() => {
  class HisCoreInitializerService {
    constructor() {}
    /*
     * Zusätzlich zu en_us weitere Locales registrieren, die z.B. für die DatePipe verfügbar sein sollen
     */
    initializeLocaleData() {
      return new Promise((resolve, reject) => {
        registerLocaleData(localeEN, 'en');
        registerLocaleData(localeDE, 'de');
        resolve(true);
      });
    }
    static {
      this.ɵfac = function HisCoreInitializerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCoreInitializerService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisCoreInitializerService,
        factory: HisCoreInitializerService.ɵfac
      });
    }
  }
  return HisCoreInitializerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Zusätzlich zu en-US unterstützte Locales für Lokalisierung (z.B. in DatePipe)
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function initializeLocaleData(initializer) {
  const x = () => initializer.initializeLocaleData();
  return x;
}
let HisCoreCoreModule = /*#__PURE__*/(() => {
  class HisCoreCoreModule {
    static {
      this.ɵfac = function HisCoreCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCoreCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCoreCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [ConfirmationService, HisBackendService, HisCacheService, HisBaseGlobalsService, HisBrowserDetectionService, {
          provide: ErrorHandler,
          useClass: HisErrorHandler
        }, HisDdDirectiveRegistryService, HisNavigationMenuService, HisNavigationService, HisBootstrapService, HisUiService, HisReorderTableService, HisDdService, HisDdValidatorFactory, HisRouteService, SvgService, HisNotificationService, HisGlobalDataService, HisGenericValueService, HisUserProfileService, HisCoreInitializerService, provideAppInitializer(() => {
          const initializerFn = initializeLocaleData(inject(HisCoreInitializerService));
          return initializerFn();
        }), HisSessionStorageService, HisConfirmationService, HisControlValueAccessor, HisDynamicFormGroupUtils, HisDialogHeaderPaginatorService],
        imports: [HisCoreSharedModule, HisCoreSharedModule]
      });
    }
  }
  return HisCoreCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCoreCoreModule, {
    imports: [HisCoreSharedModule],
    exports: [HisCoreSharedModule]
  });
})();
function hisCanActivate(route, _state) {
  let hisNavigationService = inject(HisNavigationService);
  let router = inject(Router);
  if (!route.data || !route.data.modules || !route.data.hasAll && !route.data.hasAny) {
    router.navigate(['/hisng/access-disabled'], {
      skipLocationChange: true
    });
    alert('Entwicklungsfehler: In jeder Route für eine Komponente müssen modules und hasAny/hasAll definiert werden.');
    return false;
  }
  let enabled = isEnabled(route);
  if (!enabled) {
    router.navigate(['/hisng/access-disabled'], {
      skipLocationChange: true
    });
  }
  let granted = isGranted(route);
  if (!granted) {
    hisNavigationService.navigateToAccessDenied();
  }
  return enabled && granted;
}
function isEnabled(route) {
  let hisAuthService = inject(HisAuthService);
  let hisBaseGlobalsService = inject(HisBaseGlobalsService);
  let data = route.data;
  if (hisAuthService.isAnonymous && data.anonmodules) {
    return hisBaseGlobalsService.isAnyModuleActive(...data.anonmodules);
  }
  return hisBaseGlobalsService.isAnyModuleActive(...data.modules);
}
function isGranted(route) {
  let hisAuthService = inject(HisAuthService);
  let data = route.data;
  // check hasAll
  if (data.hasAll) {
    let granted = hisAuthService.hasAll(...data.hasAll);
    if (!granted) {
      return false;
    }
  }
  // check hasAny
  if (data.hasAny) {
    return hisAuthService.hasAny(...data.hasAny);
  }
  // check hasAll was true, and hasAny was not defined
  return true;
}
function hisCanDeactivate() {
  let navigationService = inject(HisNavigationService);
  if (!navigationService.dirtyTracking || !navigationService.dirty) {
    return of(true);
  }
  let uiService = inject(HisUiService);
  let message = uiService.translate('common.unsavedDataContinue');
  let start = Date.now();
  if (confirm(message)) {
    return true;
  } else {
    // if the confirm dialog was rejected within 10 milliseconds
    // it is safe to assume that the dialog was suppressed. 
    return Date.now() - start < 10;
  }
}

/**
 * creates a router module for the root of the application
 */
function hisRootRoutes(routes, config) {
  const defaultConfig = {
    scrollPositionRestoration: 'enabled'
  };
  const mergedConfig = config ? {
    ...defaultConfig,
    ...config
  } : defaultConfig;
  return RouterModule.forRoot(hisRoute(routes, true), mergedConfig);
}
/**
 * creates a router module for child modules
 */
function hisChildRoutes(routes) {
  return RouterModule.forChild(hisRoute(routes, false));
}
function hisRoute(routes, root) {
  for (let route of routes) {
    if (root) {
      route.resolve = {
        boot: HisBootstrapService
      };
    }
    // add guard for authentication and module-check
    if (route.component || route.data && (route.data.hasAll || route.data.hasAny)) {
      if (route.canActivate) {
        route.canActivate = [...route.canActivate, hisCanActivate];
      } else {
        route.canActivate = [hisCanActivate];
      }
    }
    // add warning about unsaved changes
    if (route.component) {
      if (route.canDeactivate) {
        route.canDeactivate = [...route.canDeactivate, hisCanDeactivate];
      } else {
        route.canDeactivate = [hisCanDeactivate];
      }
    }
    // recurse into static non-lazy child-routes
    if (route.children) {
      hisRoute(route.children, root);
    }
    // workaround for Vite not being able to handle "." in path
    // https://github.com/angular/angular/issues/56211
    if (route.path && route.path.indexOf('.') > -1 && isDevMode()) {
      let clone = Object.assign({}, route);
      clone.path = route.path.replace(/\./g, '___');
      routes.push(clone);
    }
  }
  return routes;
}

/**
 * a generic service to load, save and delete an entity.
 */
class HisGenericEntityService {
  // This is the implementation which cannot be invoked directly.
  // The above declarations ensure that this constructor is either called with only one argument of type string
  // or at least two arguments.
  constructor(first, second, _navigationService) {
    this.hisBackendService = inject(HisBackendService);
    this.hisNavigationService = inject(HisNavigationService);
    if (second) {
      this.apiPrefix = second;
    } else {
      this.apiPrefix = first;
    }
  }
  /**
   *
   * @param navigationService
   * @returns an operator function to be used in Observable.pipe() to redirect to the access denied page if the user has no permission to view the entity.
   */
  redirectToAccessDenied(navigationService) {
    return catchError(error => {
      // navigate to access denied page if the user has no permission to view the entity
      if (error.status === 401 || error.status === 403) {
        navigationService.navigateToAccessDenied();
        return of();
      }
      //propagate the error if it is not a permission error
      return throwError(() => error);
    });
  }
  /**
   * loads the entity from the backend. May display errors to users.
   */
  load(id, redirectAccessDenied = true) {
    return this.getData(id, redirectAccessDenied);
  }
  /**
   * loads the entity from the backend with all details. May display errors to users.
   */
  loadWithDetails(id, redirectAccessDenied = true) {
    return this.getData(id, redirectAccessDenied, '/details');
  }
  getData(id, redirectAccessDenied, apiSuffix) {
    const requestOptions = {
      showPermissionError: !redirectAccessDenied
    };
    const url = apiSuffix ? `${this.apiPrefix}/${id}${apiSuffix}` : `${this.apiPrefix}/${id}`;
    const apiCall = this.hisBackendService.getData(url, requestOptions);
    if (redirectAccessDenied) {
      return apiCall.pipe(this.redirectToAccessDenied(this.hisNavigationService));
    }
    return apiCall;
  }
  /**
   * saves the entity to the backend. May display errors to users.
   */
  save(t) {
    return this.hisBackendService.saveData(this.apiPrefix, t);
  }
  /**
   * verifies that the entity may be deleted (e. g. not referenced by other objects).
   * May display errors to users.
   */
  ensureDeletable(id) {
    return this.hisBackendService.getData(`${this.apiPrefix}/${id}/ensureDeletable`);
  }
  /**
   * does the current user have permission to edit this entity?
   */
  mayEdit(id) {
    return this.hisBackendService.getData(`${this.apiPrefix}/${id}/mayEdit`);
  }
  /**
   * deletes the entity on the backend. May display errors to users.
   */
  delete(id) {
    return this.hisBackendService.delete(`${this.apiPrefix}/${id}`);
  }
  /**
   * list entities matching the searchText. May display errors to users.
   */
  list(searchText) {
    return this.hisBackendService.getData(`${this.apiPrefix}?q=${encodeURI(searchText)}`);
  }
}

/**
 * Hilfsmethoden in Karma-Tests
 */
class HisTestUtils {
  static tickAndDetectChanges(fixture) {
    tick();
    fixture.detectChanges();
    tick();
    fixture.detectChanges();
  }
  static isObject(jsonDataKey) {
    return typeof jsonDataKey === 'object' && jsonDataKey !== null;
  }
  static getMergedKeys(nameOfObject, theKey) {
    return nameOfObject ? nameOfObject + '.' + theKey : theKey;
  }
  static matchContent(oldVersionJson, newVersionJson, objectName, toIgnoreKeys) {
    let arrayOfErrors = [];
    const keysToIgnore = toIgnoreKeys.concat(['lockVersion', 'objGuid', 'cvLockVersion']);
    for (let key in oldVersionJson) {
      let keysPath = this.getMergedKeys(objectName, key);
      if (keysToIgnore.includes(key) || keysToIgnore.includes(keysPath)) {
        continue;
      }
      if (!(key in newVersionJson)) {
        arrayOfErrors.push('\nThe Key ' + keysPath + ' exists in the old version, but not in the new version!\n The old Version:"' + oldVersionJson[key] + '", \n The new Version:"' + newVersionJson[key] + '"\n');
        continue;
      }
      let oldValue = oldVersionJson[key];
      oldValue = typeof oldValue === 'string' ? oldValue.trim() : oldValue;
      let newValue = newVersionJson[key];
      newValue = typeof newValue === 'string' ? newValue.trim() : newValue;
      if (this.isObject(oldValue)) {
        arrayOfErrors = arrayOfErrors.concat(this.matchContent(oldValue, newValue, keysPath, keysToIgnore));
      } else {
        if (oldValue !== newValue) {
          arrayOfErrors.push('\nThe contents of the key ' + keysPath + ' differ between the old and the new version!\n The old Version :"' + oldValue + '", \n The new Version :"' + newValue + '"\n');
        }
      }
    }
    return arrayOfErrors;
  }
}
class Month {
  constructor(days, monthId, year, monthOfYear) {
    this.days = days;
    this.monthId = monthId;
    this.year = year;
    this.monthOfYear = monthOfYear;
  }
}
class DayAttribute {
  constructor(identifier, css, abbreviation, description, mustBeDisplayed) {
    this.identifier = identifier;
    this.css = css;
    this.abbreviation = abbreviation;
    this.description = description;
    this.mustBeDisplayed = mustBeDisplayed;
  }
}
// static attributes
const DAY_ATTRIBUTE_SELECTED_DAY = new DayAttribute('SELECTED_DAY', 'selectedDayOverlay', 'cs.sys.hisng.gridcalendar.dayattribute.selectedDay.abbreviation', 'cs.sys.hisng.gridcalendar.dayattribute.selectedDay');
const DAY_ATTRIBUTE_CURRENT_DAY = new DayAttribute('CURRENT_DAY', 'currentDayOverlay', 'cs.sys.hisng.gridcalendar.dayattribute.currentDay.abbreviation', 'cs.sys.hisng.gridcalendar.dayattribute.currentDay');
// date with day of week fields - german date format
const GERMAN_DATE_WITH_DAYOFWEEK_PIPE_FORMAT = 'EEEE, d. MMMM yyyy';
// date with day of week fields - english date format
const ENGLISH_DATE_WITH_DAYOFWEEK_PIPE_FORMAT = 'EEEE, MMMM d, yyyy';
let GridCalendarUtils = /*#__PURE__*/(() => {
  class GridCalendarUtils {
    constructor() {
      this.hisUiService = inject(HisUiService);
    }
    createMonthByString(monthYear) {
      if (!monthYear || monthYear.length !== 6) {
        return null;
      }
      const year = Number(monthYear.substring(0, 4));
      const month = Number(monthYear.substring(4));
      return new Month([], month, year, '');
    }
    createMonthByDate(date) {
      return new Month([], date.getMonth() + 1, date.getFullYear(), '');
    }
    getCurrentMonth() {
      const today = new Date();
      return this.createMonthByDate(today);
    }
    getDatesBetween(from, to) {
      const dates = [];
      let date = from;
      while (date <= to) {
        dates.push(date);
        date = new Date(date);
        date.setDate(date.getDate() + 1);
      }
      return dates;
    }
    /**
     * Liefert den Monat im Format yyyyMM
     */
    getAsString(month) {
      return String(month.year) + formatNumber(month.monthId, 'de-DE', '2.0');
    }
    incrementMonth(month) {
      return this.calcMonth(month, true);
    }
    decrementMonth(month) {
      return this.calcMonth(month, false);
    }
    getDate(month) {
      return new Date(month.year, month.monthId - 1);
    }
    calcMonth(month, increment) {
      const date = this.getDate(month);
      if (increment) {
        date.setMonth(date.getMonth() + 1);
      } else {
        date.setMonth(date.getMonth() - 1);
      }
      return new Month(month.days, date.getMonth() + 1, date.getFullYear(), month.monthOfYear);
    }
    /**
     * Wenn @param input ein I18n-Schlüssel ist, dann wird er übersetzt.
     * Ist es einfacher Text, so wird dieser zurückgegeben
     */
    getText(input) {
      // Leerstring bei falsy values 
      if (!input) {
        return '';
      }
      let translation = this.hisUiService.translate(input);
      if (translation.startsWith('???') && translation.endsWith('???')) {
        return input;
      }
      return translation;
    }
    static {
      this.ɵfac = function GridCalendarUtils_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GridCalendarUtils)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: GridCalendarUtils,
        factory: GridCalendarUtils.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GridCalendarUtils;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$7 = ["dayoverlay"];
const _c1$2 = ["grid-calendar-day", ""];
function HisDisplayGridCalendarDayComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
  }
}
function HisDisplayGridCalendarDayComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.gridCalendarUtils.getText(ctx_r0.day.events[0].abbreviation), " ");
  }
}
function HisDisplayGridCalendarDayComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.gridCalendarUtils.getText(ctx_r0.day.dayAttributes[0].abbreviation), " ");
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_13_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " \u2022 ");
    i0.ɵɵelementEnd();
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_13_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_13_For_1_Conditional_2_Template, 2, 0, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const attribute_r3 = ctx.$implicit;
    const ɵ$index_44_r4 = ctx.$index;
    const ɵ$count_44_r5 = ctx.$count;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.gridCalendarUtils.getText(attribute_r3.description), "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ɵ$index_44_r4 === ɵ$count_44_r5 - 1) ? 2 : -1);
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_13_For_1_Template, 3, 2, "span", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelement(2, "hr");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r0.getAllDayAttributes());
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_15_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.gridCalendarUtils.getText(event_r6.description));
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "ul");
    i0.ɵɵrepeaterCreate(3, HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_15_For_4_Template, 2, 1, "li", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "cs.sys.hisng.gridcalendar.events.heading"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r0.day.events);
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "cs.sys.hisng.gridcalendar.events.noEvents"));
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "cs.sys.hisng.gridcalendar.events.noEvents"));
  }
}
function HisDisplayGridCalendarDayComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11)(3, "button", 12);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarDayComponent_ng_template_11_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectDay(true));
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 12);
    i0.ɵɵpipe(8, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarDayComponent_ng_template_11_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.selectDay(false));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "hr");
    i0.ɵɵelementStart(12, "div", 13);
    i0.ɵɵtemplate(13, HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_13_Template, 3, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 14);
    i0.ɵɵtemplate(15, HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_15_Template, 5, 3)(16, HisDisplayGridCalendarDayComponent_ng_template_11_Conditional_16_Template, 3, 3, "span")(17, HisDisplayGridCalendarDayComponent_ng_template_11_ng_template_17_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 15)(20, "div", 16)(21, "span", 17);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 18)(25, "div", 19)(26, "span", 20);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "div", 19)(30, "span", 21);
    i0.ɵɵtext(31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 19)(33, "span", 22);
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 10, "cs.sys.hisng.gridcalendar.button.text.timeinterval.from"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 12, "cs.sys.hisng.gridcalendar.button.text.timeinterval.from"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(8, 14, "cs.sys.hisng.gridcalendar.button.text.timeinterval.to"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 16, "cs.sys.hisng.gridcalendar.button.text.timeinterval.to"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.getAllDayAttributes().length > 0 ? 13 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.day && ctx_r0.day.events.length > 0 ? 15 : 16);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 18, ctx_r0.day.dayOfWeek));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 20, ctx_r0.monthOfYear));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.day.dayId);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.year);
  }
}
let HisDisplayGridCalendarDayComponent = /*#__PURE__*/(() => {
  class HisDisplayGridCalendarDayComponent {
    constructor() {
      this.gridCalendarUtils = inject(GridCalendarUtils);
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.monthOfYear = '';
      this.year = '';
      this.dateSelected = new EventEmitter();
      this.selectedDay = DAY_ATTRIBUTE_SELECTED_DAY;
      this.currentDay = DAY_ATTRIBUTE_CURRENT_DAY;
      this.currentDate = new Date();
      this.tooltipDateFormat = this.hisBaseGlobalsService.getLanguage() === 'de' ? GERMAN_DATE_WITH_DAYOFWEEK_PIPE_FORMAT : ENGLISH_DATE_WITH_DAYOFWEEK_PIPE_FORMAT;
    }
    ngOnInit() {
      this.currentDate.setFullYear(Number(this.year));
      this.currentDate.setMonth(this.monthId - 1);
      this.currentDate.setDate(this.day.dayId);
    }
    toggleOverlayPanel($event) {
      this.overlayPanel.toggle($event);
    }
    selectDay(isFrom) {
      this.dateSelected.emit({
        day: this.day,
        isFrom: isFrom
      });
    }
    determineCssClass() {
      if (this.day.events[0]?.css && !this.day.dayAttributes[0]?.mustBeDisplayed) {
        return this.day.events[0].css;
      }
      if (this.day.dayAttributes[0]?.css) {
        return this.day.dayAttributes[0].css;
      }
      return '';
    }
    getAllDayAttributes() {
      const attributes = [...this.day.dayAttributes];
      if (this.day.isSelected) {
        attributes.push(this.selectedDay);
      }
      if (this.day.isToday) {
        attributes.push(this.currentDay);
      }
      return attributes.reverse();
    }
    getButtonTitle(date, eventDescription) {
      let tooltip = date;
      if (eventDescription) {
        tooltip += ' : ';
        tooltip += this.gridCalendarUtils.getText(eventDescription);
      }
      return tooltip;
    }
    static {
      this.ɵfac = function HisDisplayGridCalendarDayComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayGridCalendarDayComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayGridCalendarDayComponent,
        selectors: [["td", "grid-calendar-day", ""]],
        viewQuery: function HisDisplayGridCalendarDayComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$7, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayPanel = _t.first);
          }
        },
        inputs: {
          day: "day",
          monthId: "monthId",
          monthOfYear: "monthOfYear",
          year: "year"
        },
        outputs: {
          dateSelected: "dateSelected"
        },
        standalone: false,
        attrs: _c1$2,
        decls: 12,
        vars: 12,
        consts: [["dayoverlay", ""], ["noEvents", ""], [1, "dayButton", 3, "title"], [1, "dayCell", 3, "ngClass"], [1, "displayInlineBlock", "markerMultipleEventTriangle"], [3, "ngClass"], [1, "dayContent"], [3, "showCloseIcon", "dismissable"], ["pTemplate", "content"], [1, "dayoverlay"], [1, "overlayContent"], [1, "overlayContentButton"], [1, "button_highlighted", "overlayContentButton", 3, "click", "title"], [1, "overlayContentAttributes"], [1, "overlayContentEvents"], [1, "overlayDay"], [1, "overlayDayTop"], [1, "overlayDayBottomDayOfWeek"], [1, "overlayDayBottom"], [1, "overlayDayBottomElement"], [1, "overlayDayBottomMonth"], [1, "overlayDayBottomDay"], [1, "overlayDayBottomYear"]],
        template: function HisDisplayGridCalendarDayComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 2);
            i0.ɵɵpipe(1, "hisDate");
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, HisDisplayGridCalendarDayComponent_Conditional_3_Template, 1, 0, "div", 4);
            i0.ɵɵelement(4, "span", 5)(5, "span", 5);
            i0.ɵɵelementStart(6, "span", 6);
            i0.ɵɵtemplate(7, HisDisplayGridCalendarDayComponent_Conditional_7_Template, 1, 1)(8, HisDisplayGridCalendarDayComponent_Conditional_8_Template, 1, 1);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "p-overlayPanel", 7, 0);
            i0.ɵɵtemplate(11, HisDisplayGridCalendarDayComponent_ng_template_11_Template, 35, 22, "ng-template", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", ctx.getButtonTitle(i0.ɵɵpipeBind2(1, 9, ctx.currentDate, ctx.tooltipDateFormat), ctx.day.events[0] == null ? null : ctx.day.events[0].description));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.determineCssClass());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.day && ctx.day.events.length > 1 ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.day.isToday ? ctx.currentDay.css : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.day.isSelected ? ctx.selectedDay.css : "");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.day && ctx.day.events.length > 0 && (ctx.day.dayAttributes.length === 0 || !ctx.day.dayAttributes[0].mustBeDisplayed) ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.day && ctx.day.dayAttributes.length > 0 && (ctx.day.events.length === 0 || ctx.day.dayAttributes[0].mustBeDisplayed) ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("showCloseIcon", true)("dismissable", true);
          }
        },
        dependencies: [i1$2.NgClass, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, i4$3.OverlayPanel, i2.PrimeTemplate, HisUiPipe, HisDatePipe],
        styles: ["button.dayButton[_ngcontent-%COMP%]{background:none;color:inherit;border:none;padding:0;margin:0;font:inherit;outline:inherit}button.dayButton[_ngcontent-%COMP%]:focus{outline:orange solid 3px}button.dayButton[_ngcontent-%COMP%]:focus   div.dayCell[_ngcontent-%COMP%]{background-color:var(--highlightBackgroundColor)!important}button.dayButton[_ngcontent-%COMP%]:focus   div.dayCell[_ngcontent-%COMP%]   .dayContent[_ngcontent-%COMP%]{color:var(--basicFontColor)!important}div.dayCell[_ngcontent-%COMP%]{width:30px;height:30px;position:relative}@media screen and (max-width: 768px){button.dayButton[_ngcontent-%COMP%]{width:60%;border:1px solid var(--borderColor2)}.dayButton[_ngcontent-%COMP%]   div.dayCell[_ngcontent-%COMP%]{width:auto!important;height:auto!important}}span.dayContent[_ngcontent-%COMP%]{display:flex;height:30px;justify-content:center;flex-direction:column;text-align:center}div.dayoverlay[_ngcontent-%COMP%]{display:grid;grid:\"overlayContent overlayDay\" 100% / 50% 50%;gap:8px}div.overlayContent[_ngcontent-%COMP%]{grid-area:overlayContent}div.overlayContentButton[_ngcontent-%COMP%]{text-align:center}button.overlayContentButton[_ngcontent-%COMP%]{min-width:70px;margin:0 10px;text-align:center}div.overlayDay[_ngcontent-%COMP%]{grid-area:overlayDay;color:#fff;text-align:center}div.overlayDayTop[_ngcontent-%COMP%]{background:var(--backgroundColor1);padding:15px}div.overlayDayBottom[_ngcontent-%COMP%]{background:var(--accentFontColor)}div.overlayDayBottomElement[_ngcontent-%COMP%]{padding:20px}span.overlayDayBottomDayOfWeek[_ngcontent-%COMP%]{font-weight:700}span.overlayDayBottomMonth[_ngcontent-%COMP%]{font-weight:lighter}span.overlayDayBottomDay[_ngcontent-%COMP%]{font-size:70px;font-weight:700}span.overlayDayBottomYear[_ngcontent-%COMP%]{font-weight:lighter}"]
      });
    }
  }
  return HisDisplayGridCalendarDayComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$6 = ["grid-calendar-month", ""];
function HisDisplayGridCalendarMonthComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 3, 0);
    i0.ɵɵlistener("click", function HisDisplayGridCalendarMonthComponent_For_4_Template_td_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const gridcalendarday_r2 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(gridcalendarday_r2.toggleOverlayPanel($event));
    })("dateSelected", function HisDisplayGridCalendarMonthComponent_For_4_Template_td_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectMonth($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("day", day_r4)("monthId", ctx_r2.month.monthId)("monthOfYear", ctx_r2.month.monthOfYear)("year", ctx_r2.month.year.toString());
  }
}
let HisDisplayGridCalendarMonthComponent = /*#__PURE__*/(() => {
  class HisDisplayGridCalendarMonthComponent {
    constructor() {
      this.dateSelected = new EventEmitter();
    }
    ngOnInit() {
      return;
    }
    selectMonth(selected) {
      this.dateSelected.emit({
        day: selected.day,
        month: this.month,
        isFrom: selected.isFrom
      });
    }
    static {
      this.ɵfac = function HisDisplayGridCalendarMonthComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayGridCalendarMonthComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayGridCalendarMonthComponent,
        selectors: [["tr", "grid-calendar-month", ""]],
        inputs: {
          month: "month"
        },
        outputs: {
          dateSelected: "dateSelected"
        },
        standalone: false,
        attrs: _c0$6,
        decls: 5,
        vars: 4,
        consts: [["gridcalendarday", ""], [1, "monthsTitleColumn"], ["grid-calendar-day", "", 1, "positionCenter", 3, "day", "monthId", "monthOfYear", "year"], ["grid-calendar-day", "", 1, "positionCenter", 3, "click", "dateSelected", "day", "monthId", "monthOfYear", "year"]],
        template: function HisDisplayGridCalendarMonthComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "td", 1);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵrepeaterCreate(3, HisDisplayGridCalendarMonthComponent_For_4_Template, 2, 4, "td", 2, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, ctx.month.monthOfYear), " ", ctx.month.year, "");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.month == null ? null : ctx.month.days);
          }
        },
        dependencies: [HisDisplayGridCalendarDayComponent, HisUiPipe],
        styles: ["td.monthsTitleColumn[_ngcontent-%COMP%]{font-weight:700;vertical-align:middle;padding:0 10px!important}td[_ngcontent-%COMP%]:not(.monthsTitleColumn){padding:0!important}"]
      });
    }
  }
  return HisDisplayGridCalendarMonthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const hasTargetThatCanBeDisabled = event => {
  return typeof event === 'object' && event != null && typeof event.target === 'object' && event.target != null && 'disabled' in event.target && typeof event.target.disabled === 'boolean';
};
const _c0$5 = () => ({
  width: "unset"
});
function HisDisplayGridCalendarLegendComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "cs.sys.hisng.gridcalendar.legend.column.event"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "cs.sys.hisng.gridcalendar.legend.column.description"));
  }
}
function HisDisplayGridCalendarLegendComponent_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 12)(2, "div", 13)(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const legendEntry_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", legendEntry_r1.css);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.gridCalendarUtil.getText(legendEntry_r1.abbreviation), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.gridCalendarUtil.getText(legendEntry_r1.description));
  }
}
let HisDisplayGridCalendarLegendComponent = /*#__PURE__*/(() => {
  class HisDisplayGridCalendarLegendComponent {
    constructor() {
      this.gridCalendarUtil = inject(GridCalendarUtils);
      this.firstMonth = '';
      this.lastMonth = '';
      this.showLegend = false;
      this.legendEntries = [];
    }
    ngOnInit() {
      let firstMonth = this.gridCalendarUtil.createMonthByString(this.firstMonth);
      let lastMonth = this.gridCalendarUtil.createMonthByString(this.lastMonth);
      this.gridCalendarLegendDataProvider.getGridCalendarLegendData(firstMonth, lastMonth).subscribe(legendEtries => {
        if (legendEtries) {
          this.legendEntries = legendEtries;
        }
      });
    }
    static {
      this.ɵfac = function HisDisplayGridCalendarLegendComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayGridCalendarLegendComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayGridCalendarLegendComponent,
        selectors: [["his-display-grid-calendar-legend"]],
        inputs: {
          firstMonth: "firstMonth",
          lastMonth: "lastMonth",
          gridCalendarLegendDataProvider: "gridCalendarLegendDataProvider"
        },
        standalone: false,
        decls: 22,
        vars: 17,
        consts: [["hisImage", "INFORMATION", 1, "button_highlighted", "cyan", "floatRight", 3, "click", "title"], ["position", "right", 3, "visibleChange", "visible"], [1, "clearAndSpace"], [1, "listNoStyle"], [1, "gridCalendarlegendList"], ["ng-reflect-ng-class", "absenceAE", 1, "legendCell", "absenceAE", "displayInlineBlock", "markerMultipleEvent"], [1, "displayInlineBlock", "markerMultipleEventTriangle"], [1, "legendAbbreviation"], [1, "displayInlineBlock", "gridCalendarlegendDesc"], [3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], [2, "padding", "0.2rem 0.4rem"], [1, "legendCell", 3, "ngClass"]],
        template: function HisDisplayGridCalendarLegendComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵlistener("click", function HisDisplayGridCalendarLegendComponent_Template_button_click_0_listener() {
              return ctx.showLegend = true;
            });
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "p-sidebar", 1);
            i0.ɵɵtwoWayListener("visibleChange", function HisDisplayGridCalendarLegendComponent_Template_p_sidebar_visibleChange_4_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.showLegend, $event) || (ctx.showLegend = $event);
              return $event;
            });
            i0.ɵɵelementStart(5, "p-header")(6, "h2");
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(9, "div", 2);
            i0.ɵɵelementStart(10, "ul", 3)(11, "li", 4)(12, "div", 5);
            i0.ɵɵelement(13, "div", 6);
            i0.ɵɵelementStart(14, "span", 7);
            i0.ɵɵtext(15, "E");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 8);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "hisUi");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "p-table", 9);
            i0.ɵɵtemplate(20, HisDisplayGridCalendarLegendComponent_ng_template_20_Template, 7, 6, "ng-template", 10)(21, HisDisplayGridCalendarLegendComponent_ng_template_21_Template, 7, 3, "ng-template", 11);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 8, "cs.sys.hisng.gridcalendar.legend.button.title.openLegend"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 10, "cs.sys.hisng.gridcalendar.legend.button.text.openLegend"), "\n");
            i0.ɵɵadvance(2);
            i0.ɵɵstyleMap(i0.ɵɵpureFunction0(16, _c0$5));
            i0.ɵɵtwoWayProperty("visible", ctx.showLegend);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 12, "cs.sys.hisng.gridcalendar.legend.header"));
            i0.ɵɵadvance(10);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 14, "cs.sys.hisng.gridcalendar.legend.hint.multiple.events"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.legendEntries);
          }
        },
        dependencies: [i1$2.NgClass, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, i2.Header, i2.PrimeTemplate, i7$2.Sidebar, i3$1.Table, HisUiPipe],
        styles: ["div.legendCell[_ngcontent-%COMP%]{width:30px;height:30px;position:relative}span.legendAbbreviation[_ngcontent-%COMP%]{display:flex;height:30px;justify-content:center;flex-direction:column;text-align:center}.gridCalendarlegendDesc[_ngcontent-%COMP%]{margin-left:10px;margin-top:3px}.gridCalendarlegendList[_ngcontent-%COMP%]{margin-bottom:5px}"]
      });
    }
  }
  return HisDisplayGridCalendarLegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$4 = () => [];
function HisDisplayGridCalendarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollBackward($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.scrollBackward"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.scrollBackward"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addPreviousMonth($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.addPreviousMonth"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.addPreviousMonth"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeFirstMonth());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.removeFirstMonth"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.removeFirstMonth"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resetSelectedDays());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.resetInterval"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.resetInterval"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-display-grid-calendar-legend", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gridCalendarLegendDataProvider", ctx_r1.gridCalendarLegendDataProvider)("firstMonth", ctx_r1.firstMonth)("lastMonth", ctx_r1.lastMonth);
  }
}
function HisDisplayGridCalendarComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-calendar", 16, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisDisplayGridCalendarComponent_Conditional_6_Template_p_calendar_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedYear, $event) || (ctx_r1.selectedYear = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function HisDisplayGridCalendarComponent_Conditional_6_Template_p_calendar_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.loadYear($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedYear);
    i0.ɵɵproperty("readonlyInput", true);
  }
}
function HisDisplayGridCalendarComponent_ng_template_8_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_41_r7 = ctx.$index;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ɵ$index_41_r7 + 1);
  }
}
function HisDisplayGridCalendarComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th");
    i0.ɵɵrepeaterCreate(2, HisDisplayGridCalendarComponent_ng_template_8_For_3_Template, 2, 1, "th", 17, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(0, _c0$4).constructor(31));
  }
}
function HisDisplayGridCalendarComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 18);
    i0.ɵɵlistener("dateSelected", function HisDisplayGridCalendarComponent_ng_template_9_Template_tr_dateSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectDate($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r9 = ctx.$implicit;
    i0.ɵɵproperty("month", month_r9);
  }
}
function HisDisplayGridCalendarComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_10_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollForward($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.scrollForward"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.scrollForward"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_11_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addFollowingMonth($event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.addFollowingMonth"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.addFollowingMonth"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeLastMonth());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.removeLastMonth"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.removeLastMonth"), " ");
  }
}
function HisDisplayGridCalendarComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayGridCalendarComponent_Conditional_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resetSelectedDays());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "cs.sys.hisng.gridcalendar.button.title.resetInterval"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "cs.sys.hisng.gridcalendar.button.text.resetInterval"), " ");
  }
}
let HisDisplayGridCalendarComponent = /*#__PURE__*/(() => {
  class HisDisplayGridCalendarComponent {
    constructor() {
      this.gridCalendarUtil = inject(GridCalendarUtils);
      this.firstMonth = '';
      this.lastMonth = '';
      this.showButtonRemoveFirstMonth = false;
      this.showButtonRemoveLastMonth = false;
      this.showButtonAddPreviousMonth = false;
      this.showButtonAddFollowingMonth = false;
      this.showButtonScrollBackward = false;
      this.showButtonScrollForward = false;
      this.showYearPicker = false;
      this.showLegend = false;
      this.startDateSelected = new EventEmitter();
      this.endDateSelected = new EventEmitter();
      this.months = [];
      this.startDate = null;
      this.endDate = null;
      this.selectedYear = null;
      this.minimumYear = 1900;
      this.maximumYear = 2100;
    }
    ngOnInit() {
      let firstMonth = this.gridCalendarUtil.createMonthByString(this.firstMonth);
      let lastMonth = this.gridCalendarUtil.createMonthByString(this.lastMonth);
      this.loadCalendar(firstMonth, lastMonth);
    }
    loadCalendar(firstMonth, lastMonth) {
      this.gridCalendarDataProvider.getGridCalendarData(firstMonth, lastMonth).subscribe(gridCalendar => {
        if (gridCalendar.months !== undefined) {
          this.months = gridCalendar.months;
          this.markSelectedRange(this.startDate, this.endDate);
        }
        if (gridCalendar.minimumTimestamp) {
          this.minimumYear = new Date(gridCalendar.minimumTimestamp).getFullYear();
        }
        if (gridCalendar.maximumTimestamp) {
          this.maximumYear = new Date(gridCalendar.maximumTimestamp).getFullYear();
        }
      });
    }
    loadYear(selectedYear) {
      if (selectedYear) {
        let firstMonth = this.gridCalendarUtil.createMonthByDate(selectedYear);
        selectedYear.setMonth(selectedYear.getMonth() + 11);
        let lastMonth = this.gridCalendarUtil.createMonthByDate(selectedYear);
        this.loadCalendar(firstMonth, lastMonth);
      }
    }
    calendarContainsDate(date) {
      const isYearMonth = month => month.year === date.getFullYear() && month.monthId === date.getMonth() + 1;
      const isDay = day => day.dayId === date.getDate();
      const result = this.months.filter(isYearMonth).map(month => month.days.find(isDay));
      return result.length === 1;
    }
    selectDate(selected) {
      let date = new Date(selected.month.year, selected.month.monthId - 1, selected.day.dayId);
      if (selected.isFrom) {
        this.setStartDate(date);
      } else {
        this.setEndDate(date);
      }
    }
    setStartDate(date) {
      let tempEndDate = this.endDate;
      this.resetSelectedDays();
      if (tempEndDate && tempEndDate.getTime() > date.getTime()) {
        this.endDate = tempEndDate;
      } else {
        this.endDate = date;
      }
      this.startDate = date;
      this.markSelectedRange(this.startDate, this.endDate);
    }
    setEndDate(date) {
      if (this.startDate && this.startDate.getTime() > date.getTime()) {
        return;
      }
      let tempStartDate = this.startDate;
      this.resetSelectedDays();
      this.startDate = tempStartDate;
      this.endDate = date;
      this.markSelectedRange(this.startDate, this.endDate);
    }
    appendAttribute(date, attribute) {
      this.append(date, null, attribute);
    }
    appendEvent(date, event) {
      this.append(date, event, null);
    }
    resetSelectedDays() {
      this.startDate = null;
      this.endDate = null;
      this.startDateSelected.emit(null);
      this.endDateSelected.emit(null);
      this.months.forEach(month => month.days.forEach(day => day.isSelected = false));
    }
    markSelectedRange(from, to) {
      this.resetSelectedDays();
      let dates = [];
      if (from && to) {
        dates = this.gridCalendarUtil.getDatesBetween(from, to);
      } else if (!from && to) {
        dates.push(to);
      } else if (from && !to) {
        dates.push(from);
      } else {
        return;
      }
      dates.forEach(date => this.markDay(date));
      if (dates.length > 0) {
        this.startDate = from;
        this.endDate = to;
        this.startDateSelected.emit(from);
        this.endDateSelected.emit(to);
      }
    }
    markDay(date) {
      const isDay = day => day.dayId === date.getDate();
      const isYearMonth = month => month.year === date.getFullYear() && month.monthId === date.getMonth() + 1;
      this.months.filter(isYearMonth).map(month => {
        let day = month.days.find(isDay);
        if (day) {
          day.isSelected = true;
        }
      });
    }
    append(date, event, attribute) {
      const isYearMonth = month => month.year === date.getFullYear() && month.monthId === date.getMonth() + 1;
      const isDay = day => day.dayId === date.getDate();
      if (event) {
        this.months.filter(isYearMonth).map(month => month.days.find(isDay)?.events.push(event));
      } else if (attribute) {
        this.months.filter(isYearMonth).map(month => month.days.find(isDay)?.dayAttributes.push(attribute));
      } else {
        console.error('Weder ein Event noch ein Attribut wurde angegeben!');
      }
    }
    removeFirstMonth() {
      this.months.shift();
    }
    removeLastMonth() {
      this.months.pop();
    }
    addPreviousMonth(event) {
      this.addMonth(event, true);
    }
    addFollowingMonth(event) {
      this.addMonth(event, false);
    }
    scrollBackward(event) {
      this.addPreviousMonth(event);
      this.removeLastMonth();
    }
    scrollForward(event) {
      this.addFollowingMonth(event);
      this.removeFirstMonth();
    }
    addMonth(event, onTop) {
      if (!hasTargetThatCanBeDisabled(event)) {
        return;
      }
      event.target.disabled = true;
      let basedMonth = this.getBasedMonth(onTop);
      let requestedMonth = this.getRequestedMonth(basedMonth, onTop);
      this.gridCalendarDataProvider.getGridCalendarData(requestedMonth, null).subscribe({
        next: gridCalendar => {
          if (gridCalendar.months && gridCalendar.months.length > 0) {
            let loadedMonth = gridCalendar.months.at(0);
            if (loadedMonth) {
              if (onTop) {
                this.months.unshift(loadedMonth);
              } else {
                this.months.push(loadedMonth);
              }
              this.markSelectedRange(this.startDate, this.endDate);
            }
          }
          event.target.disabled = false;
        },
        error: () => {
          event.target.disabled = false;
        }
      });
    }
    getBasedMonth(onTop) {
      if (this.months && this.months.length > 0) {
        if (onTop) {
          return this.months.at(0);
        } else {
          return this.months.at(-1);
        }
      }
      return null;
    }
    getRequestedMonth(basedMonth, onTop) {
      if (!basedMonth) {
        return this.gridCalendarUtil.getCurrentMonth();
      } else if (onTop) {
        return this.gridCalendarUtil.decrementMonth(basedMonth);
      } else {
        return this.gridCalendarUtil.incrementMonth(basedMonth);
      }
    }
    reloadCalendar() {
      this.loadCalendar(this.months.at(0), this.months.at(-1));
    }
    static {
      this.ɵfac = function HisDisplayGridCalendarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayGridCalendarComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayGridCalendarComponent,
        selectors: [["his-display-grid-calendar"]],
        inputs: {
          firstMonth: "firstMonth",
          lastMonth: "lastMonth",
          showButtonRemoveFirstMonth: "showButtonRemoveFirstMonth",
          showButtonRemoveLastMonth: "showButtonRemoveLastMonth",
          showButtonAddPreviousMonth: "showButtonAddPreviousMonth",
          showButtonAddFollowingMonth: "showButtonAddFollowingMonth",
          showButtonScrollBackward: "showButtonScrollBackward",
          showButtonScrollForward: "showButtonScrollForward",
          showYearPicker: "showYearPicker",
          showLegend: "showLegend",
          gridCalendarDataProvider: "gridCalendarDataProvider",
          gridCalendarLegendDataProvider: "gridCalendarLegendDataProvider"
        },
        outputs: {
          startDateSelected: "startDateSelected",
          endDateSelected: "endDateSelected"
        },
        standalone: false,
        decls: 14,
        vars: 11,
        consts: [["yearpicker", ""], [1, "gridCalendarActions"], ["hisImage", "ARROW_UP_FAT", 1, "button_highlighted", "grey", 3, "title"], ["hisImage", "PLUS_CIRC", 1, "button_highlighted", "grey", 3, "title"], ["hisImage", "MINUS_CIRC", 1, "button_highlighted", "grey", 3, "title"], ["hisImage", "ARROW_ROTATE_BACK", 1, "button_highlighted", "orange", 3, "title"], [3, "gridCalendarLegendDataProvider", "firstMonth", "lastMonth"], ["view", "year", "dateFormat", "yy", "styleClass", "calendarWidth40 gridCalendarYearPicker", 3, "ngModel", "readonlyInput"], ["hisFrozencol", "", 1, "tableStickyHeader", "calendarGridTable", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["hisImage", "ARROW_DOWN_FAT", 1, "button_highlighted", "grey", 3, "title"], ["hisImage", "ARROW_UP_FAT", 1, "button_highlighted", "grey", 3, "click", "title"], ["hisImage", "PLUS_CIRC", 1, "button_highlighted", "grey", 3, "click", "title"], ["hisImage", "MINUS_CIRC", 1, "button_highlighted", "grey", 3, "click", "title"], ["hisImage", "ARROW_ROTATE_BACK", 1, "button_highlighted", "orange", 3, "click", "title"], ["view", "year", "dateFormat", "yy", "styleClass", "calendarWidth40 gridCalendarYearPicker", 3, "ngModelChange", "ngModel", "readonlyInput"], [1, "dayTitleRow"], ["grid-calendar-month", "", 3, "dateSelected", "month"], ["hisImage", "ARROW_DOWN_FAT", 1, "button_highlighted", "grey", 3, "click", "title"]],
        template: function HisDisplayGridCalendarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HisDisplayGridCalendarComponent_Conditional_1_Template, 4, 6, "button", 2)(2, HisDisplayGridCalendarComponent_Conditional_2_Template, 4, 6, "button", 3)(3, HisDisplayGridCalendarComponent_Conditional_3_Template, 4, 6, "button", 4)(4, HisDisplayGridCalendarComponent_Conditional_4_Template, 4, 6, "button", 5)(5, HisDisplayGridCalendarComponent_Conditional_5_Template, 1, 3, "his-display-grid-calendar-legend", 6)(6, HisDisplayGridCalendarComponent_Conditional_6_Template, 2, 2, "p-calendar", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "p-table", 8);
            i0.ɵɵtemplate(8, HisDisplayGridCalendarComponent_ng_template_8_Template, 4, 1, "ng-template", 9)(9, HisDisplayGridCalendarComponent_ng_template_9_Template, 1, 1, "ng-template", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, HisDisplayGridCalendarComponent_Conditional_10_Template, 4, 6, "button", 11)(11, HisDisplayGridCalendarComponent_Conditional_11_Template, 4, 6, "button", 3)(12, HisDisplayGridCalendarComponent_Conditional_12_Template, 4, 6, "button", 4)(13, HisDisplayGridCalendarComponent_Conditional_13_Template, 4, 6, "button", 5);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showButtonScrollBackward ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showButtonAddPreviousMonth ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showButtonRemoveFirstMonth ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.startDate || ctx.endDate ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showLegend ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showYearPicker ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.months);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.showButtonScrollForward ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showButtonAddFollowingMonth ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showButtonRemoveLastMonth ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.startDate || ctx.endDate ? 13 : -1);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.NgModel, HisImageDirective, HisCalendarDefaultsDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisFrozenColDirective, HisButtonTitleDirective, i2.PrimeTemplate, i3$1.Table, i2$2.Calendar, HisDisplayGridCalendarMonthComponent, HisDisplayGridCalendarLegendComponent, HisUiPipe],
        styles: ["th[_ngcontent-%COMP%]{padding:0!important;min-width:30px;height:32px}th.dayTitleRow[_ngcontent-%COMP%]{vertical-align:middle;text-align:center!important}tr[_ngcontent-%COMP%]{white-space:nowrap}div.gridCalendarActions[_ngcontent-%COMP%]{margin-bottom:4px}"]
      });
    }
  }
  return HisDisplayGridCalendarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getMaxTextLength(ctx_r0.text));
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_5_Conditional_1_Template, 2, 1, "span", 1)(2, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_5_Conditional_2_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.showFullText && ctx_r0.isMaxTextLength() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showFullText || !ctx_r0.isMaxTextLength() ? 2 : -1);
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-translated-text", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hisobject", ctx_r0.hisobject)("hisAttribute", ctx_r0.hisAttribute)("maxLength", ctx_r0.maxLength);
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-translated-text", 3)(1, "br");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hisobject", ctx_r0.hisobject)("hisAttribute", ctx_r0.hisAttribute);
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_6_Conditional_1_Template, 1, 3, "his-translated-text", 2)(2, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_6_Conditional_2_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.showFullText && ctx_r0.isMaxTextLength() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showFullText || !ctx_r0.isMaxTextLength() ? 2 : -1);
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.setShowFullText(true));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, ctx_r0.expandToolTip));
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.setShowFullText(false));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, ctx_r0.collapseToolTip));
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Conditional_0_Template, 2, 3, "button", 4)(1, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Conditional_1_Template, 2, 3, "button", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r0.showFullText ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showFullText ? 1 : -1);
  }
}
function HisDisplayCollapsibleTextViewComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em");
    i0.ɵɵtemplate(5, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_5_Template, 3, 2, "div")(6, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_6_Template, 3, 2, "div")(7, HisDisplayCollapsibleTextViewComponent_Conditional_0_Conditional_7_Template, 2, 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, ctx_r0.header));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!ctx_r0.hisobject || !ctx_r0.hisAttribute ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hisobject && ctx_r0.hisAttribute ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.isMaxTextLength() ? 7 : -1);
  }
}
let HisDisplayCollapsibleTextViewComponent = /*#__PURE__*/(() => {
  class HisDisplayCollapsibleTextViewComponent {
    constructor() {
      this.header = '';
      this.expandToolTip = '';
      this.collapseToolTip = '';
      this.showFullText = false;
      this.maxLength = HisDisplayCollapsibleTextViewComponent.MAX_TEXT_LENGTH;
    }
    static {
      this.MAX_TEXT_LENGTH = 620;
    }
    /* set to show the full/shortened text */
    setShowFullText(showFullText) {
      this.showFullText = showFullText;
    }
    /* compares the text.length to the specified maximum */
    isMaxTextLength() {
      return this.text && this.text.length > HisDisplayCollapsibleTextViewComponent.MAX_TEXT_LENGTH;
    }
    /* substring text to max 620 or last full word */
    getMaxTextLength(text) {
      let textLength = HisDisplayCollapsibleTextViewComponent.MAX_TEXT_LENGTH;
      while ((text.charAt(textLength) !== ' ' || text?.charAt(textLength).match('\n')) && textLength !== 0) {
        textLength--;
      }
      return text.substring(0, textLength) + ' ...';
    }
    static {
      this.ɵfac = function HisDisplayCollapsibleTextViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayCollapsibleTextViewComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayCollapsibleTextViewComponent,
        selectors: [["his-display-collapsible-text-view"]],
        inputs: {
          text: "text",
          header: "header",
          expandToolTip: "expandToolTip",
          collapseToolTip: "collapseToolTip",
          hisobject: "hisobject",
          hisAttribute: "hisAttribute"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[1, "description"], [1, "wordBreak"], [3, "hisobject", "hisAttribute", "maxLength"], [3, "hisobject", "hisAttribute"], ["hisImage", "ARROW_DOWN_V", 1, "icon", 3, "title"], ["hisImage", "ARROW_UP_V", 1, "icon", 3, "title"], ["hisImage", "ARROW_DOWN_V", 1, "icon", 3, "click", "title"], ["hisImage", "ARROW_UP_V", 1, "icon", 3, "click", "title"]],
        template: function HisDisplayCollapsibleTextViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisDisplayCollapsibleTextViewComponent_Conditional_0_Template, 8, 6, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.text && !!ctx.text.length ? 0 : -1);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisTranslatedTextComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDisplayCollapsibleTextViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDisplayEmailComponent = /*#__PURE__*/(() => {
  class HisDisplayEmailComponent {
    static {
      this.ɵfac = function HisDisplayEmailComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayEmailComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayEmailComponent,
        selectors: [["his-display-email"]],
        inputs: {
          value: "value"
        },
        standalone: false,
        decls: 5,
        vars: 9,
        consts: [["hisImage", "email", 1, "inlineicon", 3, "alt", "title"], [3, "href"]],
        template: function HisDisplayEmailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "a", 1);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("alt", i0.ɵɵpipeBind1(1, 5, "cm.stu.email"));
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 7, "cm.stu.email"));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx.value, "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.value);
          }
        },
        dependencies: [HisImageDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDisplayEmailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDisplayExpandableComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function HisDisplayExpandableComponent_Conditional_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggle($event));
    });
    i0.ɵɵtext(1, "...");
    i0.ɵɵelementEnd();
  }
}
let HisDisplayExpandableComponent = /*#__PURE__*/(() => {
  class HisDisplayExpandableComponent {
    constructor() {
      this.value = '';
      this.display = '';
      this.expanded = false;
      this.limit = 100;
    }
    set _value_(val) {
      this.value = val;
      this.update();
    }
    set _expanded_(val) {
      this.expanded = val;
      this.update();
    }
    set _limit_(val) {
      this.limit = val;
      this.update();
    }
    toggle(e) {
      this.expanded = !this.expanded;
      this.update();
    }
    update() {
      if (this.expanded) {
        this.display = this.value;
      } else {
        this.display = this.value.substring(0, this.limit);
      }
    }
    static {
      this.ɵfac = function HisDisplayExpandableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayExpandableComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayExpandableComponent,
        selectors: [["his-display-expandable"]],
        inputs: {
          _value_: [0, "value", "_value_"],
          _expanded_: [0, "expanded", "_expanded_"],
          _limit_: [0, "limit", "_limit_"]
        },
        standalone: false,
        decls: 2,
        vars: 2,
        consts: [[1, "icon"], [1, "icon", 3, "click"]],
        template: function HisDisplayExpandableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0);
            i0.ɵɵtemplate(1, HisDisplayExpandableComponent_Conditional_1_Template, 2, 0, "button", 0);
          }
          if (rf & 2) {
            i0.ɵɵtextInterpolate(ctx.display);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.expanded && ctx.display.length < ctx.value.length ? 1 : -1);
          }
        },
        dependencies: [HisModificationDetectionDirective, HisFocusableButtonDirective],
        encapsulation: 2
      });
    }
  }
  return HisDisplayExpandableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDisplayPhoneComponent = /*#__PURE__*/(() => {
  class HisDisplayPhoneComponent {
    set _value_(val) {
      this.value = val;
      if (!val) {
        this.url = null;
        return;
      }
      this.url = 'tel://' + val.replace(/[ ()/-]/g, '').replace(/^[+]/, '00');
    }
    static {
      this.ɵfac = function HisDisplayPhoneComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayPhoneComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayPhoneComponent,
        selectors: [["his-display-phone"]],
        inputs: {
          _value_: [0, "value", "_value_"]
        },
        standalone: false,
        decls: 5,
        vars: 8,
        consts: [["hisImage", "telephone", 1, "inlineicon", 3, "alt", "title"], [3, "href"]],
        template: function HisDisplayPhoneComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "a", 1);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("alt", i0.ɵɵpipeBind1(1, 4, "cm.stu.phone"));
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 6, "cm.stu.phone"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("href", ctx.url, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.value);
          }
        },
        dependencies: [HisImageDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDisplayPhoneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDisplayTextComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.text, ctx_r0.params));
  }
}
function HisDisplayTextComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.text, ctx_r0.params), i0.ɵɵsanitizeHtml);
  }
}
function HisDisplayTextComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisHtmlUnsafe");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind2(1, 1, ctx_r0.text, ctx_r0.params)), i0.ɵɵsanitizeHtml);
  }
}
let HisDisplayTextComponent = /*#__PURE__*/(() => {
  class HisDisplayTextComponent {
    constructor() {
      this.text = '';
      this.params = [];
      this.format = 'text'; // Formats: 'text' | 'html' | 'html-unsafe'
    }
    ngOnInit() {
      // Convert text parameters to HTML (except for format 'html-unsafe')
      if (this.params && this.params.length > 0 && this.format !== 'html-unsafe') {
        let params = [];
        for (let param of this.params) {
          params.push(this.toHTML(param || ''));
        }
        this.params = params;
      }
    }
    toHTML(s) {
      const entityMap = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '&': '&amp;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '<': '&lt;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '>': '&gt;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '"': '&quot;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '\'': '&#39;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '/': '&#x2F;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '`': '&#x60;',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '=': '&#x3D;'
      };
      return String(s).replace(/[&<>"'`=\/]/g, t => {
        return entityMap[t];
      });
    }
    static {
      this.ɵfac = function HisDisplayTextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayTextComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayTextComponent,
        selectors: [["his-display-text"]],
        inputs: {
          text: "text",
          params: "params",
          format: "format"
        },
        standalone: false,
        decls: 3,
        vars: 3,
        consts: [[3, "innerHTML"]],
        template: function HisDisplayTextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisDisplayTextComponent_Conditional_0_Template, 3, 4, "span")(1, HisDisplayTextComponent_Conditional_1_Template, 2, 4, "span", 0)(2, HisDisplayTextComponent_Conditional_2_Template, 3, 6, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.format === "text" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.format === "html" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.format === "html-unsafe" ? 2 : -1);
          }
        },
        dependencies: [HisHtmlUnsafePipe, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDisplayTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDisplayWeblinkComponent = /*#__PURE__*/(() => {
  class HisDisplayWeblinkComponent {
    set _value_(val) {
      this.value = val;
      if (!val) {
        this.url = null;
        return;
      }
      // Substring der Übergebenen Adresse, getrennt da https und http unterschiedlich betrachtet
      let startOfValueHttp = val.substring(0, 7);
      let startOfValueHttps = val.substring(0, 8);
      // Ueberprueft ob http:// oder https:// am Anfang des Link stehen.
      if (!(startOfValueHttp === 'http://' || startOfValueHttps === 'https://')) {
        // Wenn nicht wird https:// hinzugefuegt
        this.url = 'https://' + val;
      } else {
        // Besitzt der Link bereits http:// oder https:// dann wird dieser so uebernommen
        this.url = val;
      }
    }
    static {
      this.ɵfac = function HisDisplayWeblinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayWeblinkComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayWeblinkComponent,
        selectors: [["his-display-weblink"]],
        inputs: {
          _value_: [0, "value", "_value_"]
        },
        standalone: false,
        decls: 5,
        vars: 8,
        consts: [["hisImage", "link", 1, "inlineicon", 3, "alt", "title"], [3, "href"]],
        template: function HisDisplayWeblinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
            i0.ɵɵpipe(1, "hisUi");
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "a", 1);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("alt", i0.ɵɵpipeBind1(1, 4, "psv.Ekontakt.webseite"));
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 6, "psv.Ekontakt.webseite"));
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("href", ctx.url, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.value);
          }
        },
        dependencies: [HisImageDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDisplayWeblinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisDisplayWebShareComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisDisplayWebShareComponent_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.share());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, ctx_r1.btnTitle));
  }
}
let HisDisplayWebShareComponent = /*#__PURE__*/(() => {
  class HisDisplayWebShareComponent {
    constructor() {
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.showShareBtn = true;
      this.navigator = null;
      this.navigator = window.navigator;
    }
    ngAfterViewInit() {
      // if browser doesn't support Web Share API, don't show button
      if (this.navigator === null || this.navigator.share === undefined) {
        this.showShareBtn = false;
      }
      // call change detection to prevent ElementChangeAfterChecked-Error
      this.changeDetectorRef.detectChanges();
    }
    share() {
      // check if browser supports Web Share API
      if (this.navigator !== null && this.navigator.share !== undefined) {
        try {
          // call Web Share API
          this.navigator.share({
            title: this.title,
            text: this.text + '\n',
            url: this.url || window.location.href
          }).then(() => {
            console.log('Shared: ' + this.title);
          }).catch(error => {
            console.log(error);
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
    static {
      this.ɵfac = function HisDisplayWebShareComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplayWebShareComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisDisplayWebShareComponent,
        selectors: [["his-display-webshare"]],
        inputs: {
          title: "title",
          url: "url",
          text: "text",
          btnTitle: "btnTitle"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["hisImage", "WEBSHARE", 1, "transparent", 3, "title"], ["hisImage", "WEBSHARE", 1, "transparent", 3, "click", "title"]],
        template: function HisDisplayWebShareComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisDisplayWebShareComponent_Conditional_0_Template, 2, 3, "button", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.showShareBtn ? 0 : -1);
          }
        },
        dependencies: [HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisDisplayWebShareComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDisplaySharedModule = /*#__PURE__*/(() => {
  class HisDisplaySharedModule {
    static {
      this.ɵfac = function HisDisplaySharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDisplaySharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisDisplaySharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, HisCoreSharedModule, HisTranslationSharedModule,
        // PrimeNG
        OverlayPanelModule, SidebarModule, TableModule, CalendarModule]
      });
    }
  }
  return HisDisplaySharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisDisplaySharedModule, {
    declarations: [HisDisplayCollapsibleTextViewComponent, HisDisplayEmailComponent, HisDisplayExpandableComponent, HisDisplayPhoneComponent, HisDisplayTextComponent, HisDisplayWeblinkComponent, HisDisplayWebShareComponent, HisDisplayGridCalendarComponent, HisDisplayGridCalendarMonthComponent, HisDisplayGridCalendarDayComponent, HisDisplayGridCalendarLegendComponent],
    imports: [CommonModule, FormsModule, HisCoreSharedModule, HisTranslationSharedModule,
    // PrimeNG
    OverlayPanelModule, SidebarModule, TableModule, CalendarModule],
    exports: [HisDisplayCollapsibleTextViewComponent, HisDisplayEmailComponent, HisDisplayExpandableComponent, HisDisplayPhoneComponent, HisDisplayTextComponent, HisDisplayWeblinkComponent, HisDisplayWebShareComponent, HisDisplayGridCalendarComponent, HisDisplayGridCalendarMonthComponent, HisDisplayGridCalendarDayComponent, HisDisplayGridCalendarLegendComponent]
  });
})();
class GUIComponentField {}
class GUIComponent extends GUIComponentField {}
class DynamicComponent {}
class DynamicValue {}
// eslint-disable-next-line @typescript-eslint/naming-convention
class DynamicObjects {}
class DynamicContent {}
let HisDynamicContentUtils = /*#__PURE__*/(() => {
  class HisDynamicContentUtils {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
    }
    /* check if guiComponent is combined yesNoSelect and textfield */
    checkForYesNoWithTextArea(guiComponent, dynamicObjects, dynamicApprovalResults) {
      if (guiComponent.fields && guiComponent.fields.length === 2 || guiComponent.controlType === HisDynamicFieldType.DeclarationFieldset) {
        let yesNoSelectField = guiComponent.fields.find(field => field.controlType === HisDynamicFieldType.YesNoSelect);
        let textField = guiComponent.fields.find(field => field.controlType === HisDynamicFieldType.Text || field.controlType === HisDynamicFieldType.TextArea);
        if (yesNoSelectField && textField) {
          guiComponent.controlType = HisDynamicFieldType.YesNoWithTextArea;
          // check if attributeName for YesNoSelectField and TextField contain number
          let numberRegex = RegExp(/\d+/g);
          if (yesNoSelectField.attributeName.match(numberRegex) && textField.attributeName.match(numberRegex)) {
            // check if DD configuration for both is not hidden
            let yesNoSelectDdEntry = this.hisBaseGlobalsService.getDd(yesNoSelectField.ddKey);
            let textDdEntry = this.hisBaseGlobalsService.getDd(textField.ddKey);
            // if yesNoSelect is hidden, the ddKey of the textField will be replaced to hide the complete component (DeclarationField)
            if (yesNoSelectDdEntry.hidden && !textDdEntry.hidden) {
              textField.ddKey = yesNoSelectField.ddKey;
            }
            if ((!yesNoSelectDdEntry || !yesNoSelectDdEntry.hidden) && (!textDdEntry || !textDdEntry.hidden) || dynamicApprovalResults && dynamicApprovalResults.find(dynamicApprovalResult => dynamicApprovalResult.dynamicObject.dynamicClass.className === guiComponent.name)) {
              if (this.getDynamicObjectAttribute(dynamicObjects, yesNoSelectField.objectUID, yesNoSelectField.attributeName, 'value') === '0') {
                this.hisBaseGlobalsService.setRequiredToDdEntry(textField.ddKey, true);
              }
              return true;
            }
          }
        }
      }
      return false;
    }
    /* get referenced dynamic object value */
    getDynamicObjectAttribute(dynamicObjects, objectUID, attributeName, attribute) {
      if (dynamicObjects) {
        let dynamicObject = dynamicObjects.find(dO => dO.objGuid === objectUID);
        if (dynamicObject) {
          let dynamicObjectValue = dynamicObject.values.find(dV => dV.attributeName === attributeName);
          if (dynamicObjectValue) {
            return dynamicObjectValue[attribute];
          }
        }
      }
      return null;
    }
    /* function to check visbility of fields and fieldsets from DD-Keys */
    atLeatOneTabChildFieldNotHidden(fieldsetChildren, contexts) {
      let atLeastOnNotHidden = false;
      fieldsetChildren.forEach(fieldset => {
        if (fieldset.controlType === HisDynamicFieldType.YesNoWithTextArea || fieldset.controlType === HisDynamicFieldType.DeclarationFieldset) {
          let yesNoSelectField = fieldset.fields.find(field => field.controlType === HisDynamicFieldType.YesNoSelect);
          if (yesNoSelectField && !this.hisBaseGlobalsService.getDd(yesNoSelectField.ddKey, contexts)?.hidden) {
            atLeastOnNotHidden = true;
          }
        } else {
          fieldset.fields.forEach(field => {
            if (!this.hisBaseGlobalsService.getDd(field.ddKey ? field.ddKey : field.name, contexts)?.hidden) {
              atLeastOnNotHidden = true;
            }
          });
        }
      });
      return atLeastOnNotHidden;
    }
    isDynamicContentVisible(tabKey, dynamicComponent, contexts) {
      let personTabChildren = dynamicComponent.guiComponent.children.find(tabChild => tabChild.name === tabKey);
      return this.atLeatOneTabChildFieldNotHidden(personTabChildren ? personTabChildren.children : [], contexts ? contexts : dynamicComponent.conditions.contexts);
    }
    isStaticContentVisible(dDKeys, dynamicComponent, contexts) {
      let isStaticContentVisible = false;
      dDKeys.forEach(key => {
        let dDEntry = this.hisBaseGlobalsService.getDd(key, contexts ? contexts : dynamicComponent?.conditions.contexts);
        if (!dDEntry || dDEntry && !dDEntry.hidden) {
          isStaticContentVisible = true;
        }
      });
      return isStaticContentVisible;
    }
    /* merge dynamicContent of two objects */
    getCombinedDynamicContent(_dynamicComponentObjectOne, _dynamicComponentObjectTwo) {
      if (_dynamicComponentObjectOne._dynamicComponent.guiComponent.visibleAttributes) {
        let combinedDynamicContent = new DynamicContent();
        combinedDynamicContent._dynamicComponent = JSON.parse(JSON.stringify(_dynamicComponentObjectOne._dynamicComponent));
        _dynamicComponentObjectTwo._dynamicComponent.guiComponent.children.forEach(tabChildTwo => {
          let sameTabDefinition = combinedDynamicContent._dynamicComponent.guiComponent.children.find(tabChildOne => tabChildOne.name === tabChildTwo.name);
          if (sameTabDefinition) {
            sameTabDefinition.children.push(...tabChildTwo.children);
          } else {
            combinedDynamicContent._dynamicComponent.guiComponent.children.push(tabChildTwo);
          }
        });
        _dynamicComponentObjectTwo._dynamicComponent.dynamicObjects.forEach(dynamicObject => {
          combinedDynamicContent._dynamicComponent.dynamicObjects.push(dynamicObject);
        });
        return combinedDynamicContent;
      }
      return _dynamicComponentObjectTwo;
    }
    static {
      this.ɵfac = function HisDynamicContentUtils_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicContentUtils)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: HisDynamicContentUtils,
        factory: HisDynamicContentUtils.ɵfac
      });
    }
  }
  return HisDynamicContentUtils;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* common interface for components that allow dynamic fields between static content */
const COMPONENT_BASE = new InjectionToken('IComponentBase');
function DynamicFormContainerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-dynamic-container", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dynamicFieldConfig", ctx_r0.dynamicFieldConfig);
  }
}
let DynamicFormContainerComponent = /*#__PURE__*/(() => {
  class DynamicFormContainerComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisDynamicContentUtils = inject(HisDynamicContentUtils);
      this.outputEvent = new EventEmitter();
      this.formGroupValue = {};
    }
    ngAfterContentInit() {
      this.setupDynamicContainerComponent();
    }
    ngDoCheck() {
      if (this.dynamicObjects && this.componentId) {
        let newFormGroupValue = this.dynamicContainerComponent ? this.dynamicContainerComponent.getJson() : {};
        // if dynamicFieldConfig is type of field
        if (this.componentId.includes('field_') && newFormGroupValue && this.dynamicFieldConfig.children[0] && !newFormGroupValue[this.dynamicFieldConfig.children[0].name]) {
          newFormGroupValue[this.dynamicFieldConfig.children[0].name] = null;
        }
        // check formGroupValue object for changes
        if (JSON.stringify(this.formGroupValue) !== JSON.stringify(newFormGroupValue)) {
          this.outputEvent.emit(newFormGroupValue);
        }
      }
    }
    setupDynamicContainerComponent() {
      if (this.dynamicFieldConfig == null && this.dynamicComponent) {
        this.createDynamicFieldConfig(this.dynamicComponent);
      }
      this.formGroupValue = this.dynamicContainerComponent ? this.dynamicContainerComponent.getJson() : {};
    }
    createDynamicFieldConfig(dynamicComponent, fieldComponent, dynamicObjects) {
      this.dynamicObjects = dynamicObjects ? dynamicObjects : dynamicComponent.dynamicObjects;
      this.guiComponent = fieldComponent;
      this.dynamicFieldConfig = {
        name: this.componentId + 'DynamicForm',
        controlType: HisDynamicFieldType.Form,
        label: this.componentId + 'DynamicForm',
        children: []
      };
      let dynamicTabChild = null;
      if (dynamicObjects) {
        this.addFieldToConfig(fieldComponent);
      } else {
        dynamicTabChild = dynamicComponent.guiComponent.children.find(tabChild => tabChild.name === this.dynamicComponentTabName);
        if (dynamicTabChild) {
          dynamicTabChild.children.forEach(guiComponent => {
            this.addFieldToConfig(guiComponent);
          });
        }
      }
    }
    addFieldToConfig(guiComponent) {
      let fieldToAdd = null;
      if (this.hisDynamicContentUtils.checkForYesNoWithTextArea(guiComponent, this.dynamicObjects)) {
        fieldToAdd = this.generateFieldConfig(guiComponent);
        let orderedChildren = [];
        orderedChildren[0] = fieldToAdd.children.find(child => {
          return child.controlType === HisDynamicFieldType.YesNoSelect;
        });
        orderedChildren[0].showLabelTop = true;
        orderedChildren[1] = fieldToAdd.children.find(child => {
          // set field type to TextArea
          if (child.controlType === HisDynamicFieldType.Text) {
            child.controlType = HisDynamicFieldType.TextArea;
            return child;
          } else {
            return child.controlType === HisDynamicFieldType.TextArea;
          }
        });
        orderedChildren[1].showLabelTop = true;
        fieldToAdd.children = orderedChildren;
      } else if (this.isNotTypedFieldsetAndNotEmpty(guiComponent)) {
        fieldToAdd = this.generateFieldConfig(guiComponent);
      }
      if (fieldToAdd != null) {
        this.dynamicFieldConfig.children.push(fieldToAdd);
      }
    }
    generateFieldConfig(field) {
      let dynamicField = {
        name: field.name,
        controlType: HisDynamicFieldType[field.controlType],
        label: field.controlType === HisDynamicFieldType.Fieldset || field.controlType === HisDynamicFieldType.YesNoWithTextArea ? field.name : null,
        required: this.hisBaseGlobalsService.getDd(field.ddKey) ? this.hisBaseGlobalsService.getDd(field.ddKey).required : false,
        ddKey: field.controlType === HisDynamicFieldType.Fieldset || field.controlType === HisDynamicFieldType.YesNoWithTextArea ? field.name : field.ddKey,
        typeAheadUrl: field.controlType === HisDynamicFieldType.KeytableSelect || field.controlType === HisDynamicFieldType.KeytableMultiSelect ? this.hisDynamicContentUtils.getDynamicObjectAttribute(this.dynamicObjects, field.objectUID, field.attributeName, 'source') : null,
        children: field.fields && field.fields.length !== 0 ? this.getFieldsArray(field.fields) : [],
        defaultValue: this.hisDynamicContentUtils.getDynamicObjectAttribute(this.dynamicObjects, field.objectUID, field.attributeName, 'value'),
        oldValue: this.hisDynamicContentUtils.getDynamicObjectAttribute(this.dynamicObjects, field.objectUID, field.attributeName, 'oldValue'),
        useOldValue: this.hisDynamicContentUtils.getDynamicObjectAttribute(this.dynamicObjects, field.objectUID, field.attributeName, 'useOldValue'),
        disabled: field.rightLevel !== 1 ? true : false
      };
      return dynamicField;
    }
    getFieldsArray(fieldsetFields) {
      let fields = [];
      fieldsetFields.forEach(field => {
        let childFieldToAdd = this.generateFieldConfig(field);
        if (childFieldToAdd != null) {
          fields.push(this.generateFieldConfig(field));
        }
      });
      return fields;
    }
    isNotTypedFieldsetAndNotEmpty(guiComponent) {
      return (guiComponent.controlType === HisDynamicFieldType.DeclarationFieldset || guiComponent.controlType === HisDynamicFieldType.YesNoWithTextArea) && guiComponent.fields.length === 2 || guiComponent.controlType !== HisDynamicFieldType.DeclarationFieldset && guiComponent.controlType !== HisDynamicFieldType.YesNoWithTextArea;
    }
    updateFieldComponent(dynamicFieldsComponent, dynamicObjects) {
      if (this.dynamicContainerComponent) {
        this.dynamicFieldConfig.children[0].defaultValue = this.hisDynamicContentUtils.getDynamicObjectAttribute(dynamicObjects, dynamicFieldsComponent.objectUID, dynamicFieldsComponent.attributeName, 'value');
        this.dynamicContainerComponent.updateConfiguration(this.dynamicFieldConfig);
      }
    }
    static {
      this.ɵfac = function DynamicFormContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFormContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: DynamicFormContainerComponent,
        selectors: [["his-dynamic-form-container"]],
        viewQuery: function DynamicFormContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(HisDynamicContainerComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicContainerComponent = _t.first);
          }
        },
        inputs: {
          dynamicComponent: "dynamicComponent",
          dynamicComponentTabName: "dynamicComponentTabName"
        },
        outputs: {
          outputEvent: "outputEvent"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[3, "dynamicFieldConfig"]],
        template: function DynamicFormContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormContainerComponent_Conditional_0_Template, 1, 1, "his-dynamic-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.dynamicFieldConfig ? 0 : -1);
          }
        },
        dependencies: [HisDynamicContainerComponent],
        encapsulation: 2
      });
    }
  }
  return DynamicFormContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisDynamicContentDirective = /*#__PURE__*/(() => {
  class HisDynamicContentDirective {
    constructor() {
      this.hostComponent = inject(COMPONENT_BASE);
      this.hostViewContainerRef = inject(ViewContainerRef);
      this.globalDataService = inject(HisGlobalDataService);
      // Keep track of list of generated components for removal purposes
      this.components = [];
      this.queryListOfContainer = new QueryList();
    }
    static {
      this.FORMGROUPVALUE = 'dynamicformGroupValue';
    }
    static {
      this.QUERYLIST_FIELD_CONTAINER = 'fieldViewContainerList';
    }
    static {
      this.QUERYLIST_FIELDSET_CONTAINER = 'fieldsetViewContainerList';
    }
    ngOnChanges(changes) {
      if (changes.dynamicComponent) {
        // reset formGroupValues
        if (!this.dynamicComponent) {
          this.globalDataService.setData(HisDynamicContentDirective.FORMGROUPVALUE, null);
          // this.components = [];
        }
        if (this.hostComponent[HisDynamicContentDirective.QUERYLIST_FIELDSET_CONTAINER]) {
          this.queryListOfContainer = this.hostComponent[HisDynamicContentDirective.QUERYLIST_FIELDSET_CONTAINER];
          if (this.queryListOfContainer && this.dynamicComponent) {
            let fieldsetsOfTab = this.getFieldsetsOfTab();
            // if dynamic component configuration contains fields for given hisPanel
            if (fieldsetsOfTab) {
              this.setUpDynamicComponentFieldsets(fieldsetsOfTab.children);
            }
          }
        } else {
          this.queryListOfContainer = this.hostComponent[HisDynamicContentDirective.QUERYLIST_FIELD_CONTAINER];
          if (this.queryListOfContainer && this.dynamicComponent && this.hisDynamicContent) {
            let fieldsOfFieldset = this.getFieldsOfFieldset();
            // console.log( 'dynamic content fieldset: ', fieldsOfFieldset );
            // if dynamic component configuration contains fields for given hisPanel
            if (fieldsOfFieldset) {
              this.setUpDynamicComponentFields(fieldsOfFieldset.fields);
            }
          }
        }
      }
    }
    /* find tab and field-set children for hisPanel in dynamicComponent */
    getFieldsetsOfTab() {
      this.hostViewContainerRef.element.nativeElement.tabHisDynamicContentKey = this.hisDynamicContent;
      return this.dynamicComponent.guiComponent?.children.find(tabChild => tabChild.name === this.hisDynamicContent);
    }
    /* find tab and field-set children for hisPanel in dynamicComponent */
    getFieldsOfFieldset() {
      let fieldsetChildren = [];
      // console.log( '#HisDynamicContentDirective.getFieldsOfFieldset() - ( this.hostViewContainerRef as any )._lContainer: ', ( this.hostViewContainerRef as any )._lContainer );
      let tabHisDynamicContentKey = this.hostViewContainerRef._lContainer[3][0].tabHisDynamicContentKey;
      if (tabHisDynamicContentKey) {
        this.setFieldsetChildrenFromHostViewContainerRef(tabHisDynamicContentKey, fieldsetChildren);
        // console.log('#HisDynamicContentDirective.getFieldsOfFieldset() - ( this.hostViewContainerRef as any )._lContainer[3][3][0].attributes: ', ( this.hostViewContainerRef as any )._lContainer[3][3][0].attributes );
      } else {
        tabHisDynamicContentKey = this.hostViewContainerRef._lContainer[3].find(viewContainerRefElement => viewContainerRefElement !== null && Array.isArray(viewContainerRefElement) && viewContainerRefElement[0]?.tabHisDynamicContentKey)?.tabHisDynamicContentKey;
        if (tabHisDynamicContentKey) {
          this.setFieldsetChildrenFromHostViewContainerRef(tabHisDynamicContentKey, fieldsetChildren);
        } else {
          this.dynamicComponent.guiComponent?.children.forEach(tabChild => fieldsetChildren = [...fieldsetChildren, ...tabChild.children]);
        }
      }
      return fieldsetChildren.find(fieldsetChild => fieldsetChild.name === this.hisDynamicContent);
    }
    setFieldsetChildrenFromHostViewContainerRef(tabHisDynamicContentKey, fieldsetChildren) {
      this.dynamicComponent.guiComponent?.children.find(tabChild => {
        if (tabChild.name === tabHisDynamicContentKey) {
          fieldsetChildren.push(...tabChild.children);
        }
      });
    }
    /* create dynamic field-set components inside the ng-template */
    setUpDynamicComponentFieldsets(fieldsets) {
      this.queryListOfContainer.forEach((viewContainerRef, viewContainerIndex) => {
        this.clearViewContainerRefComponent(viewContainerRef); // clear viewContainerRef and component array
        fieldsets.sort((fieldset1, fieldset2) => fieldset1.sortorder - fieldset2.sortorder);
        fieldsets.forEach(fieldset => {
          fieldset.fields.sort((f1, f2) => f1.sortorder - f2.sortorder);
          let componentId = 'fieldset_' + fieldset.name;
          if (viewContainerIndex === fieldset.position) {
            let component = this.createComponent(viewContainerRef, componentId);
            component.instance.dynamicComponentTabName = this.hisDynamicContent;
            component.instance.createDynamicFieldConfig(null, fieldset, this.dynamicComponent.dynamicObjects);
            // subscribe to child output event
            component.instance.outputEvent.subscribe(formGroupValue => {
              fieldset.fields.forEach(field => {
                this.setGlobalDataService(formGroupValue[fieldset.name], field.name, fieldset.name);
              });
            });
          }
        });
      });
    }
    /* create dynamic field components inside the ng-template */
    setUpDynamicComponentFields(fields) {
      this.queryListOfContainer.forEach((viewContainerRef, viewContainerIndex) => {
        this.clearViewContainerRefComponent(viewContainerRef); // clear viewContainerRef and component array
        fields.sort((f1, f2) => f1.sortorder - f2.sortorder);
        fields.forEach(field => {
          let componentId = 'field_' + field.attributeName;
          if (viewContainerIndex === field.position) {
            console.log('#HisDynamicContentDirective.setUpDynamicComponentFields - this.dynamicComponent.dynamicObject: ', this.dynamicComponent.dynamicObjects);
            let component = this.createComponent(viewContainerRef, componentId);
            component.instance.createDynamicFieldConfig(null, field, this.dynamicComponent.dynamicObjects);
            // subscribe to child output event
            component.instance.outputEvent.subscribe(formGroupValue => {
              this.setGlobalDataService(formGroupValue, field.name, this.hisDynamicContent);
            });
          }
        });
      });
    }
    /* clear viewContainerRef and components array */
    clearViewContainerRefComponent(viewContainerRef) {
      viewContainerRef.clear();
      this.components = [];
    }
    /* create component for view container reference with id */
    createComponent(viewContainerRef, componentId) {
      let component = viewContainerRef.createComponent(DynamicFormContainerComponent);
      component.instance.componentId = componentId;
      this.components.push(component);
      return component;
    }
    /* store form group values in global data service */
    setGlobalDataService(formGroupValue, fieldName, fieldSetName) {
      let globalDataServiceFormGroupValues = this.globalDataService.getData(HisDynamicContentDirective.FORMGROUPVALUE);
      if (globalDataServiceFormGroupValues) {
        if (globalDataServiceFormGroupValues[fieldSetName]) {
          globalDataServiceFormGroupValues[fieldSetName][fieldName] = formGroupValue[fieldName];
        } else {
          Object.assign(globalDataServiceFormGroupValues, {
            [fieldSetName]: formGroupValue
          });
        }
      } else {
        this.globalDataService.setData(HisDynamicContentDirective.FORMGROUPVALUE, {
          [fieldSetName]: formGroupValue
        });
      }
    }
    static {
      this.ɵfac = function HisDynamicContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicContentDirective)();
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: HisDynamicContentDirective,
        selectors: [["", "hisDynamicContent", ""]],
        inputs: {
          hisDynamicContent: "hisDynamicContent",
          dynamicComponent: "dynamicComponent"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return HisDynamicContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule for common components.
 */
let HisDynamicFormSharedModule = /*#__PURE__*/(() => {
  class HisDynamicFormSharedModule {
    static {
      this.ɵfac = function HisDynamicFormSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicFormSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisDynamicFormSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule,
        // primeNG
        AutoCompleteModule, CalendarModule, ConfirmDialogModule, DataViewModule, DialogModule, FileUploadModule, InputMaskModule, PanelModule, TableModule, MultiSelectModule, ChipsModule, CalendarModule, RadioButtonModule, InputTextModule, InputTextareaModule,
        // HIS
        HisCoreSharedModule, HisStructureSharedModule]
      });
    }
  }
  return HisDynamicFormSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisDynamicFormSharedModule, {
    declarations: [CheckboxComponent, ChipsComponent, DateComponent, HisDynamicFieldComponent, FieldDirective, HisDynamicContainerComponent, HisDynamicContainerInnerComponent, HisDynamicContentDirective, InputNotImplementedComponent, LabelComponent, MultiSelectComponent, PasswordComponent, RadioButtonComponent, SelectComponent, TextAreaComponent, TextComponent, KeytableSelectComponent, KeytableMultiSelectComponent, YesNoSelectComponent, YesNoWithTextAreaComponent, FieldsetComponent, OldNewFieldContainerComponent, DynamicFormContainerComponent //
    ],
    imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule,
    // primeNG
    AutoCompleteModule, CalendarModule, ConfirmDialogModule, DataViewModule, DialogModule, FileUploadModule, InputMaskModule, PanelModule, TableModule, MultiSelectModule, ChipsModule, CalendarModule, RadioButtonModule, InputTextModule, InputTextareaModule,
    // HIS
    HisCoreSharedModule, HisStructureSharedModule],
    exports: [HisDynamicFieldComponent, HisDynamicContainerComponent, HisDynamicContentDirective]
  });
})();
let HisJobsSharedModule = /*#__PURE__*/(() => {
  class HisJobsSharedModule {
    static {
      this.ɵfac = function HisJobsSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobsSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisJobsSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, HisCoreSharedModule, HisStructureSharedModule,
        // PrimeNg
        PanelModule, CalendarModule, AutoCompleteModule, InputTextareaModule, ProgressSpinnerModule, DialogModule, TableModule, EditorModule]
      });
    }
  }
  return HisJobsSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisJobsSharedModule, {
    declarations: [HisJobStarterComponent, HisJobDetailsComponent, HisJobSettingComponent, HisJobConfigurationComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, HisCoreSharedModule, HisStructureSharedModule,
    // PrimeNg
    PanelModule, CalendarModule, AutoCompleteModule, InputTextareaModule, ProgressSpinnerModule, DialogModule, TableModule, EditorModule],
    exports: [HisJobStarterComponent]
  });
})();

/**
 * Metadata about a column in a search result
 */
class HisColumnMetadata {
  constructor() {
    this.visible = true;
  }
}
const _c0$3 = [[["", "customResultButtons", ""]], [["", "customContentAboveTable", ""]], [["", "customResultButtonsAfterJobStarter", ""]], [["", "customContentBelowTable", ""]], [["", "customBottomResultButtons", ""]]];
const _c1$1 = ["[customResultButtons]", "[customContentAboveTable]", "[customResultButtonsAfterJobStarter]", "[customContentBelowTable]", "[customBottomResultButtons]"];
const _c2 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  first: a1,
  totalRecords: a2,
  rowsPerPage: a3
});
const _c3 = a0 => ({
  numberOfVisibleDataColumns: a0
});
const _c4 = (a0, a1) => ({
  index: a0,
  row: a1
});
function HisSearchResultTestComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 3);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("level", ctx_r0.headingLevelPageTitle)("value", i0.ɵɵpipeBind1(1, 2, ctx_r0.pageTitle));
  }
}
function HisSearchResultTestComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.newSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.newsearch"));
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.changeSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.changesearch"));
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_Conditional_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.showPrintview());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, "de.his.javang.printview"));
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-job-starter", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("key", ctx_r0.jobStarterKey)("search", ctx_r0.search)("searchConfigFile", ctx_r0.searchConfigFile)("selectedOptions", ctx_r0.selectedOptions);
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "his-search-result-selected-items", 27);
    i0.ɵɵlistener("updateSelectedItems", function HisSearchResultTestComponent_ng_template_3_Conditional_7_Template_his_search_result_selected_items_updateSelectedItems_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleUpdateSelectedItems($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "his-search-result-select-buttons", 28);
    i0.ɵɵlistener("selectAllItems", function HisSearchResultTestComponent_ng_template_3_Conditional_7_Template_his_search_result_select_buttons_selectAllItems_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleSelectAllItems());
    })("clearSelectedItems", function HisSearchResultTestComponent_ng_template_3_Conditional_7_Template_his_search_result_select_buttons_clearSelectedItems_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleClearSelectedItems());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("currentSearch", ctx_r0.searchToUseOverlay)("columns", ctx_r0.columns)("selectedOptions", ctx_r0.selectedOptions)("selectedOptionsIdColumn", ctx_r0.selectedOptionsIdColumn)("idColumn", ctx_r0.idColumn);
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "his-heading", 3);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(1, 2, ctx_r0.tableTitle));
    i0.ɵɵproperty("level", ctx_r0.headingLevelTableTitle);
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 29);
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_Conditional_12_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      ctx_r0.toggleFilter();
      return i0.ɵɵresetView($event.preventDefault());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵpipe(5, "hisUi");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.toggleTableFilter ? i0.ɵɵpipeBind1(4, 1, "de.his.faces.tags.table.tableFilter.disable") : i0.ɵɵpipeBind1(5, 3, "de.his.faces.tags.table.tableFilter.enable"));
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 13)(1, "his-search-result-config", 30);
    i0.ɵɵlistener("saved", function HisSearchResultTestComponent_ng_template_3_Conditional_13_Template_his_search_result_config_saved_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.reloadPage($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("configColumns", ctx_r0.configColumns)("showPaginator", ctx_r0.showPaginator)("paginatorPosition", ctx_r0.paginatorPosition)("defaultTablePageSize", ctx_r0.defaultTablePageSize)("minRows", ctx_r0.minRows)("maxRows", ctx_r0.maxRows)("userProfileKeyBasePath", ctx_r0.userProfileKeyBasePath);
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.resultRowsLimitedMessage, ctx_r0.maxResultRows));
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "his-search-result-search-info", 31)(2, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("queryParams", ctx_r0.queryParams)("searchConfigFile", ctx_r0.searchConfigFile);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "genericSearch.rowselect"));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 33)(1, "p-tableHeaderCheckbox", 35);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_2_Template_p_tableHeaderCheckbox_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.tableHeaderSelectedAll = !ctx_r0.tableHeaderSelectedAll);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 36);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r0.tableHeaderSelectedAll ? i0.ɵɵpipeBind1(2, 2, "genericSearch.deselectAllOfPage") : i0.ɵɵpipeBind1(3, 4, "genericSearch.selectAllOfPage"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, "genericSearch.rowselect"));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 37);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onFilterTable());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 38);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onResetFilter());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 4, "genericSearch.resultTable.tableFilter.resetFilter"));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_3_Conditional_3_Template, 5, 6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "de.his.javang.aktionen"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.toggleTableFilter ? 3 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "p-sortIcon", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("field", column_r12.sortPath);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 42);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵtwoWayListener("ngModelChange", function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const column_r12 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.filter[column_r12.filterPath], $event) || (ctx_r0.filter[column_r12.filterPath] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const column_r12 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onFilter($event, column_r12));
    })("keydown.enter", function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(6);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.onFilterTable());
    })("click", function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template_input_click_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.filter[column_r12.filterPath]);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Conditional_1_Template, 2, 4, "input", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r12.visible ? 1 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 39);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_3_Template, 2, 1, "span")(4, HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Conditional_4_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("pSortableColumnDisabled", !column_r12.sortable)("pSortableColumn", column_r12.sortPath)("id", column_r12.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 6, column_r12.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(column_r12.sortable ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.toggleTableFilter ? 4 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Conditional_0_Template, 5, 8, "th", 39);
  }
  if (rf & 2) {
    const column_r12 = ctx.$implicit;
    i0.ɵɵconditional(column_r12.visible ? 0 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 37);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onFilterTable());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 38);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onResetFilter());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 2, "genericSearch.resultTable.tableFilter.applyFilter"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 4, "genericSearch.resultTable.tableFilter.resetFilter"));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtemplate(3, HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_6_Conditional_3_Template, 5, 6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "de.his.javang.aktionen"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.toggleTableFilter ? 3 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_1_Template, 3, 3, "th", 32)(2, HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_2_Template, 7, 8, "th", 33)(3, HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_3_Template, 4, 4, "th", 34);
    i0.ɵɵrepeaterCreate(4, HisSearchResultTestComponent_ng_template_3_ng_template_22_For_5_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(6, HisSearchResultTestComponent_ng_template_3_ng_template_22_Conditional_6_Template, 4, 4, "th");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.SingleSelect ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.MultiSelect || ctx_r0.doShowJobStarter ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsBefore ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsAfter ? 6 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customResultRowsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, ctx_r0.numberOfVisibleDataColumns));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 32)(1, "button", 45);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r15);
      const row_r16 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.doSingleSelect(row_r16));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(2, 2, "common.assignOf", ctx_r0.getTooltipParam(row_r16)));
    i0.ɵɵproperty("hisImage", ctx_r0.hisIcon);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 33);
    i0.ɵɵelement(1, "p-tableCheckbox", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ariaLabel", ctx_r0.getTableCheckboxTitleForRow(row_r16));
    i0.ɵɵpropertyInterpolate("title", ctx_r0.getTableCheckboxTitleForRow(row_r16));
    i0.ɵɵproperty("value", row_r16);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 43);
    i0.ɵɵtemplate(1, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const row_r16 = ctx_r16.$implicit;
    const ri_r18 = ctx_r16.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rowAction)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, ri_r18, row_r16));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_For_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "his-search-result-table-cell", 47);
    i0.ɵɵlistener("beforeNavigateDefaultRoute", function HisSearchResultTestComponent_ng_template_3_ng_template_23_For_6_Conditional_0_Template_his_search_result_table_cell_beforeNavigateDefaultRoute_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.onBeforeNavigateDefaultRoute());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const column_r21 = ctx_r19.$implicit;
    const ɵ$index_184_r22 = ctx_r19.$index;
    const ctx_r16 = i0.ɵɵnextContext();
    const row_r16 = ctx_r16.$implicit;
    const ri_r18 = ctx_r16.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rowId", row_r16.getAt(ctx_r0.idColumnIndex))("row", row_r16)("column", column_r21)("columnIndex", ɵ$index_184_r22)("ri", ri_r18)("defaultActionRoute", ctx_r0.defaultActionRoute)("defaultActionUrl", ctx_r0.defaultActionUrl)("showBackButton", ctx_r0.showBackButton)("isDefaultColumn", column_r21.id === ctx_r0.defaultColumn)("defaultActionToolTip", ctx_r0.defaultActionToolTip)("defaultActionRowRight", ctx_r0.defaultActionRowRight);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_23_For_6_Conditional_0_Template, 2, 11, "td");
  }
  if (rf & 2) {
    const column_r21 = ctx.$implicit;
    i0.ɵɵconditional(column_r21.visible ? 0 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 44);
    i0.ɵɵtemplate(1, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_7_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const row_r16 = ctx_r16.$implicit;
    const ri_r18 = ctx_r16.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.rowAction)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, ri_r18, row_r16));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_0_Template, 1, 4, "ng-container");
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_2_Template, 3, 5, "td", 32)(3, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_3_Template, 2, 3, "td", 33)(4, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_4_Template, 2, 5, "td", 43);
    i0.ɵɵrepeaterCreate(5, HisSearchResultTestComponent_ng_template_3_ng_template_23_For_6_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(7, HisSearchResultTestComponent_ng_template_3_ng_template_23_Conditional_7_Template, 2, 5, "td", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ri_r18 = ctx.rowIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ri_r18 === 0 ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.SingleSelect ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.MultiSelect || ctx_r0.doShowJobStarter ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsBefore ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.rowAction && ctx_r0.showActionsAfter ? 7 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customResultRowsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, ctx_r0.numberOfVisibleDataColumns));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("colspan", 99);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "genericSearch.emptyResultPageAfterDelete"));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("colspan", 99);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "genericSearch.emptyResult"));
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_1_Template, 3, 4, "td")(2, HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_1_Conditional_2_Template, 3, 4, "td");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.currentPageNumber > 1 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.currentPageNumber === 1 ? 2 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_0_Template, 1, 4, "ng-container")(1, HisSearchResultTestComponent_ng_template_3_ng_template_24_Conditional_1_Template, 3, 2, "tr");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.initialLoadFinished && ctx_r0.customResultRowsTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.initialLoadFinished && !ctx_r0.customResultRowsTemplate ? 1 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_25_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "his-search-result-rows-per-page", 48, 2);
    i0.ɵɵlistener("rowsPerPageInputChanged", function HisSearchResultTestComponent_ng_template_3_ng_template_25_Conditional_0_Template_his_search_result_rows_per_page_rowsPerPageInputChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.rowsPerPageChanged($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("resultRowsPerPage", ctx_r0.resultRowsPerPage)("rowsPerPage", ctx_r0.rowsPerPage)("maxRows", ctx_r0.maxRows)("resultRowsPerPage", ctx_r0.resultRowsPerPage)("totalRowCount", ctx_r0.totalRowCount)("currentPageNumber", ctx_r0.currentPageNumber)("totalNumberOfPages", ctx_r0.totalNumberOfPages);
  }
}
function HisSearchResultTestComponent_ng_template_3_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSearchResultTestComponent_ng_template_3_ng_template_25_Conditional_0_Template, 3, 7, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.totalRowCount > 0 ? 0 : -1);
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_29_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_Conditional_29_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.newSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.newsearch"));
  }
}
function HisSearchResultTestComponent_ng_template_3_Conditional_30_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function HisSearchResultTestComponent_ng_template_3_Conditional_30_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.changeSearch());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "de.his.javang.changesearch"));
  }
}
function HisSearchResultTestComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HisSearchResultTestComponent_ng_template_3_Conditional_1_Template, 4, 3, "button", 6)(2, HisSearchResultTestComponent_ng_template_3_Conditional_2_Template, 4, 3, "button", 7);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HisSearchResultTestComponent_ng_template_3_Conditional_4_Template, 2, 3, "button", 8);
    i0.ɵɵprojection(5, 1);
    i0.ɵɵtemplate(6, HisSearchResultTestComponent_ng_template_3_Conditional_6_Template, 1, 4, "his-job-starter", 9)(7, HisSearchResultTestComponent_ng_template_3_Conditional_7_Template, 3, 5, "div", 10);
    i0.ɵɵelementStart(8, "div")(9, "div", 11);
    i0.ɵɵtemplate(10, HisSearchResultTestComponent_ng_template_3_Conditional_10_Template, 2, 4, "his-heading", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵtemplate(12, HisSearchResultTestComponent_ng_template_3_Conditional_12_Template, 6, 5, "span")(13, HisSearchResultTestComponent_ng_template_3_Conditional_13_Template, 2, 7, "span", 13);
    i0.ɵɵprojection(14, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "div", 15);
    i0.ɵɵtemplate(17, HisSearchResultTestComponent_ng_template_3_Conditional_17_Template, 3, 4, "div", 16);
    i0.ɵɵelement(18, "div", 15);
    i0.ɵɵtemplate(19, HisSearchResultTestComponent_ng_template_3_Conditional_19_Template, 3, 2, "div");
    i0.ɵɵelementStart(20, "p-table", 17, 1);
    i0.ɵɵtwoWayListener("firstChange", function HisSearchResultTestComponent_ng_template_3_Template_p_table_firstChange_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.firstResultRow, $event) || (ctx_r0.firstResultRow = $event);
      return i0.ɵɵresetView($event);
    })("selectionChange", function HisSearchResultTestComponent_ng_template_3_Template_p_table_selectionChange_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.selectedRows, $event) || (ctx_r0.selectedRows = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onRowSelect", function HisSearchResultTestComponent_ng_template_3_Template_p_table_onRowSelect_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onRowSelect($event));
    })("onRowUnselect", function HisSearchResultTestComponent_ng_template_3_Template_p_table_onRowUnselect_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onRowUnselect($event));
    })("onHeaderCheckboxToggle", function HisSearchResultTestComponent_ng_template_3_Template_p_table_onHeaderCheckboxToggle_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onHeaderCheckboxToggle($event));
    })("onLazyLoad", function HisSearchResultTestComponent_ng_template_3_Template_p_table_onLazyLoad_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.load($event));
    })("onPage", function HisSearchResultTestComponent_ng_template_3_Template_p_table_onPage_20_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const searchResultTable_r9 = i0.ɵɵreference(21);
      const ctx_r0 = i0.ɵɵnextContext();
      ctx_r0.onPage($event);
      return i0.ɵɵresetView(searchResultTable_r9 == null ? null : searchResultTable_r9.el == null ? null : searchResultTable_r9.el.nativeElement == null ? null : searchResultTable_r9.el.nativeElement.scrollIntoView({
        block: "start",
        behavior: "smooth"
      }));
    });
    i0.ɵɵtemplate(22, HisSearchResultTestComponent_ng_template_3_ng_template_22_Template, 7, 4, "ng-template", 18)(23, HisSearchResultTestComponent_ng_template_3_ng_template_23_Template, 8, 5, "ng-template", 19)(24, HisSearchResultTestComponent_ng_template_3_ng_template_24_Template, 2, 2, "ng-template", 20)(25, HisSearchResultTestComponent_ng_template_3_ng_template_25_Template, 1, 1, "ng-template", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(26, 3);
    i0.ɵɵprojection(27, 4);
    i0.ɵɵelementStart(28, "div", 22);
    i0.ɵɵtemplate(29, HisSearchResultTestComponent_ng_template_3_Conditional_29_Template, 4, 3, "button", 23)(30, HisSearchResultTestComponent_ng_template_3_Conditional_30_Template, 4, 3, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showNewSearchButton ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showChangeSearchButton ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.searchShowPrintviewButton ? 4 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.doShowJobStarter ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectionSetting === ctx_r0.selectionSettingEnum.MultiSelect || ctx_r0.doShowJobStarter ? 7 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.tableTitle ? 10 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showTableFilter ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showTableConfig ? 13 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.resultRowsLimitedMessage ? 17 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.showSearchInfo ? 19 : -1);
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(ctx_r0.resultTableStyle);
    i0.ɵɵproperty("value", ctx_r0.rows)("paginator", ctx_r0.showPaginator)("paginatorPosition", ctx_r0.paginatorPosition)("totalRecords", ctx_r0.totalRowCount)("lazy", true)("rowHover", true)("compareSelectionBy", "equals")("rows", ctx_r0.rowsPerPage);
    i0.ɵɵtwoWayProperty("first", ctx_r0.firstResultRow)("selection", ctx_r0.selectedRows);
    i0.ɵɵproperty("lazyLoadOnInit", !ctx_r0.isSearchPopup);
    i0.ɵɵadvance(9);
    i0.ɵɵconditional(ctx_r0.showNewSearchButton ? 29 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showChangeSearchButton ? 30 : -1);
  }
}
let HisSearchResultTestComponent = /*#__PURE__*/(() => {
  class HisSearchResultTestComponent extends HisSearchResultComponent {
    constructor() {
      super();
      this.newColumnStart = new HisColumnMetadata();
      this.newColumnStart.id = 'DynColumnFirst';
      this.newColumnStart.label = this.newColumnStart.id;
      this.newColumnStart.dataType = 'html-unsafe';
      this.newColumnEnd = new HisColumnMetadata();
      this.newColumnEnd.id = 'DynColumnLast';
      this.newColumnEnd.label = this.newColumnEnd.id;
      this.newColumnEnd.dataType = 'number';
    }
    configureColumnMetadata(columns, searchConfigFile) {
      columns = _.clone(columns);
      columns.unshift(this.newColumnStart);
      columns.push(this.newColumnEnd);
      return columns;
    }
    configureRow(index, row, columns, searchConfigFile) {
      row = _.clone(row);
      let templateFirstRow = `<button onclick="alert('First Button on Row '+(${index}+1))">Button ${index + 1}</button>`;
      row.values.unshift(templateFirstRow);
      row.values.push(100 * row.values[10]);
      return row;
    }
    static {
      this.ɵfac = function HisSearchResultTestComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchResultTestComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchResultTestComponent,
        selectors: [["his-search-result-test"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c1$1,
        decls: 5,
        vars: 8,
        consts: [["defaultResultTable", ""], ["searchResultTable", ""], ["resultRowsPerPageComponent", ""], [3, "level", "value"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["appScrollwithme", "", 1, "genericSearchButtons"], ["type", "submit", "iconPos", "left", 1, "newSearchButton"], ["type", "submit", "iconPos", "left", 1, "changeSearchButton"], ["id", "showPrintview", "hisImage", "PRINTER_L", "iconPos", "left", 1, "submitLookImage", 3, "title"], [3, "key", "search", "searchConfigFile", "selectedOptions"], [1, "tableSelectItemsButtonBlock"], [1, "floatLeft"], [1, "tableFilterEditBlock"], [1, "hideOnMobile"], [1, "clearer"], [1, "clearerSpaceAboveHalfEm"], [1, "infoMessage"], ["sortMode", "multiple", 3, "firstChange", "selectionChange", "onRowSelect", "onRowUnselect", "onHeaderCheckboxToggle", "onLazyLoad", "onPage", "value", "paginator", "paginatorPosition", "totalRecords", "lazy", "rowHover", "compareSelectionBy", "rows", "first", "selection", "lazyLoadOnInit"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["pTemplate", "paginatorright"], [1, "genericSearchButtons"], ["type", "submit", "iconPos", "left"], ["type", "submit", "iconPos", "left", 1, "newSearchButton", 3, "click"], ["type", "submit", "iconPos", "left", 1, "changeSearchButton", 3, "click"], ["id", "showPrintview", "hisImage", "PRINTER_L", "iconPos", "left", 1, "submitLookImage", 3, "click", "title"], [3, "updateSelectedItems", "currentSearch", "columns", "selectedOptions", "selectedOptionsIdColumn", "idColumn"], [3, "selectAllItems", "clearSelectedItems"], ["hisImage", "FILTER", 1, "transparent", "hideOnMobile", 3, "click"], [3, "saved", "configColumns", "showPaginator", "paginatorPosition", "defaultTablePageSize", "minRows", "maxRows", "userProfileKeyBasePath"], [3, "queryParams", "searchConfigFile"], [1, "singleSelectColumn"], [1, "multiSelectColumn"], [1, "actionsBeforeColumn"], [1, "hideOnBreakpointSmall", 3, "click", "title"], [1, "hideOnBreakpointLarge"], ["hisImage", "filter", 1, "icon", 3, "click", "title"], ["hisImage", "filter_reset", 1, "icon", 3, "click", "title"], [3, "pSortableColumnDisabled", "pSortableColumn", "id"], [3, "field"], ["pInputText", "", "type", "text", 3, "title", "ngModel"], ["pInputText", "", "type", "text", 3, "ngModelChange", "keydown.enter", "click", "title", "ngModel"], ["ngClass", "singleLine", 1, "actionsBeforeColumn"], ["ngClass", "singleLine", 1, "actionsAfterColumn"], [1, "icon", 3, "click", "hisImage", "title"], [3, "value", "ariaLabel", "title"], [3, "beforeNavigateDefaultRoute", "rowId", "row", "column", "columnIndex", "ri", "defaultActionRoute", "defaultActionUrl", "showBackButton", "isDefaultColumn", "defaultActionToolTip", "defaultActionRowRight"], [3, "rowsPerPageInputChanged", "resultRowsPerPage", "rowsPerPage", "maxRows", "totalRowCount", "currentPageNumber", "totalNumberOfPages"], ["type", "submit", "iconPos", "left", 3, "click"]],
        template: function HisSearchResultTestComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0$3);
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, HisSearchResultTestComponent_Conditional_1_Template, 2, 4, "his-heading", 3)(2, HisSearchResultTestComponent_ng_container_2_Template, 1, 0, "ng-container", 4)(3, HisSearchResultTestComponent_ng_template_3_Template, 31, 25, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const defaultResultTable_r26 = i0.ɵɵreference(4);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.pageTitle && ctx.showTitle ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.resultListTemplate ? ctx.resultListTemplate : defaultResultTable_r26)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c2, ctx.rows, ctx.firstResultRow, ctx.totalRowCount, ctx.rowsPerPage));
          }
        },
        dependencies: [i1$2.NgClass, i1$2.NgTemplateOutlet, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i3$1.Table, i2.PrimeTemplate, i3$1.SortableColumn, i3$1.SortIcon, i3$1.TableCheckbox, i3$1.TableHeaderCheckbox, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisScrollwithmeDirective, HisButtonTitleDirective, HisHeadingComponent, HisJobStarterComponent, HisSearchResultSearchInfoComponent, HisSearchResultConfigComponent, HisSearchResultRowsPerPageComponent, HisSearchResultTableCellComponent, HisSearchResultSelectedItemsComponent, HisSearchResultSelectButtonsComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchResultTestComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with tree components.
 */
let HisTreeSharedModule = /*#__PURE__*/(() => {
  class HisTreeSharedModule {
    static {
      this.ɵfac = function HisTreeSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTreeSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisTreeSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule,
        // primeng
        DialogModule, TreeTableModule, AutoCompleteModule, DataViewModule,
        // HIS
        HisCoreSharedModule,
        // ui-pipe
        HisStructureSharedModule // plam
        ]
      });
    }
  }
  return HisTreeSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisTreeSharedModule, {
    declarations: [HisTreeSelectComponent, HisTreeSelectPopupComponent, HisTreeSelectAutocompleteComponent],
    imports: [CommonModule, FormsModule,
    // primeng
    DialogModule, TreeTableModule, AutoCompleteModule, DataViewModule,
    // HIS
    HisCoreSharedModule,
    // ui-pipe
    HisStructureSharedModule // plam
    ],
    exports: [HisTreeSelectComponent, HisTreeSelectPopupComponent, HisTreeSelectAutocompleteComponent]
  });
})();
function HisSearchPrintviewComponent_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "his-search-result-search-info", 3)(2, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("queryParams", ctx_r1.printViewData.queryParams)("searchConfigFile", ctx_r1.printViewData.searchConfigFile);
  }
}
function HisSearchPrintviewComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h1");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 1);
    i0.ɵɵlistener("click", function HisSearchPrintviewComponent_Conditional_0_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.backToSearchResult());
    });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "button", 1);
    i0.ɵɵlistener("click", function HisSearchPrintviewComponent_Conditional_0_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.printPage());
    });
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "hisUi");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, HisSearchPrintviewComponent_Conditional_0_Conditional_12_Template, 3, 2, "div");
    i0.ɵɵelement(13, "his-search-result", 2, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 16, ctx_r1.printViewData.pageTitle));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 18, "common.backToSearchResult"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 20, "common.print"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.printViewData.showSearchInfo ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("showTitle", true)("showNewSearchButton", false)("showChangeSearchButton", false)("showTableConfig", false)("showSearchInfo", false)("searchShowPrintviewButton", false)("ignoreForBackToSearchResultNavigation", true)("showActionsBefore", false)("showActionsAfter", false)("showPaginator", false)("maxRows", ctx_r1.printViewData.searchResultSize)("resultRowsPerPage", ctx_r1.printViewData.searchResultSize);
  }
}
let HisSearchPrintviewComponent = /*#__PURE__*/(() => {
  class HisSearchPrintviewComponent {
    constructor() {
      this.navigationService = inject(HisNavigationService);
      this.router = inject(Router);
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        const navigation = this.router.getCurrentNavigation();
        if (navigation && navigation.extras.state) {
          this.printViewData = navigation.extras.state.data;
        } else {
          // Handle when data is not passed
        }
      });
    }
    backToSearchResult() {
      this.navigationService.navigateToLastSearchResultUrl();
    }
    printPage() {
      window.print();
    }
    static {
      this.ɵfac = function HisSearchPrintviewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSearchPrintviewComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSearchPrintviewComponent,
        selectors: [["his-search-printview"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["SearchResultComponent", ""], ["iconPos", "left", 3, "click"], [3, "showTitle", "showNewSearchButton", "showChangeSearchButton", "showTableConfig", "showSearchInfo", "searchShowPrintviewButton", "ignoreForBackToSearchResultNavigation", "showActionsBefore", "showActionsAfter", "showPaginator", "maxRows", "resultRowsPerPage"], [3, "queryParams", "searchConfigFile"], [1, "clearerSpaceAboveHalfEm"]],
        template: function HisSearchPrintviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSearchPrintviewComponent_Conditional_0_Template, 15, 22, "div");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.printViewData ? 0 : -1);
          }
        },
        dependencies: [HisPageTitleDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisSearchResultComponent, HisSearchResultSearchInfoComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSearchPrintviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisGenericsearchSharedModule = /*#__PURE__*/(() => {
  class HisGenericsearchSharedModule {
    static {
      this.ɵfac = function HisGenericsearchSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisGenericsearchSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisGenericsearchSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
        // primeng
        TableModule, DataViewModule, DialogModule, PanelModule, TreeTableModule, RadioButtonModule, OverlayPanelModule, AutoCompleteModule, CalendarModule, FocusTrapModule,
        // HIS
        HisCoreSharedModule, HisDisplaySharedModule, HisTreeSharedModule, HisInputSharedModule, HisStructureSharedModule, HisJobsSharedModule]
      });
    }
  }
  return HisGenericsearchSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisGenericsearchSharedModule, {
    declarations: [HisSearchFormComponent, HisSearchFormWidgetComponent, HisSearchCriteriagroupComponent, HisSearchResultComponent, HisSearchResultTestComponent, HisSearchFormResultComponent, HisSearchInputComponent, HisSearchCheckboxComponent, HisSearchCalendarComponent, HisSearchAutocompleteComponent, HisSearchMultiselectComponent, HisSearchSelectComponent, HisSearchTreeSelectComponent, HisSearchSelectPopupComponent, HisSearchSelectAutocompleteComponent, HisSearchSaveParamsComponent, HisSearchSelectOperatorComponent, HisSearchResultSearchInfoComponent, HisSearchResultConfigComponent, HisSearchResultRowsPerPageComponent, HisSearchPrintviewComponent, HisSearchResultTableCellComponent, HisSearchResultSelectedItemsComponent, HisSearchResultSelectButtonsComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
    // primeng
    TableModule, DataViewModule, DialogModule, PanelModule, TreeTableModule, RadioButtonModule, OverlayPanelModule, AutoCompleteModule, CalendarModule, FocusTrapModule,
    // HIS
    HisCoreSharedModule, HisDisplaySharedModule, HisTreeSharedModule, HisInputSharedModule, HisStructureSharedModule, HisJobsSharedModule],
    exports: [HisSearchFormComponent, HisSearchResultComponent, HisSearchFormResultComponent, HisSearchSelectComponent, HisSearchSelectPopupComponent, HisSearchTreeSelectComponent, HisSearchResultSearchInfoComponent, HisSearchResultConfigComponent, HisSearchResultRowsPerPageComponent, HisSearchResultTableCellComponent]
  });
})();
i0.ɵɵsetComponentScope(HisSearchCheckboxComponent, [i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, HisDdDirective, HisDdValidator, HisModificationDetectionDirective], [HisUiPipe]);
const _c0$2 = ["configKey", ""];
let HisFileUploadPlamComponent = /*#__PURE__*/(() => {
  class HisFileUploadPlamComponent extends HisAbstractFileUploadComponent {
    constructor() {
      const uploadService = inject(HisFileUploadService);
      const notificationService = inject(HisNotificationService);
      const hisUiService = inject(HisUiService);
      const controlDirective = inject(NgControl, {
        self: true
      });
      super(uploadService, notificationService, hisUiService, controlDirective, null);
      this.model = [];
      this.label = '';
    }
    showValidationMessage() {
      return false;
    }
    static {
      this.ɵfac = function HisFileUploadPlamComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadPlamComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisFileUploadPlamComponent,
        selectors: [["his-file-upload-plam", "configKey", ""]],
        inputs: {
          configKey: "configKey",
          model: "model"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        attrs: _c0$2,
        decls: 6,
        vars: 11,
        consts: [["internalPlam", ""], ["content", ""], [3, "label", "helptext", "required"], [3, "ngModelChange", "configKey", "ngModel", "disabled", "required"]],
        template: function HisFileUploadPlamComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "his-plam", 2, 0);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵpipe(3, "hisUi");
            i0.ɵɵelementStart(4, "his-file-upload", 3, 1);
            i0.ɵɵtwoWayListener("ngModelChange", function HisFileUploadPlamComponent_Template_his_file_upload_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.model, $event) || (ctx.model = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 7, ctx.label));
            i0.ɵɵproperty("helptext", i0.ɵɵpipeBind1(3, 9, ctx.configuration.getHelptextIcon()))("required", ctx.required);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("configKey", ctx.configKey);
            i0.ɵɵtwoWayProperty("ngModel", ctx.model);
            i0.ɵɵproperty("disabled", ctx.configuration == null ? null : ctx.configuration.getReadonly())("required", ctx.required);
          }
        },
        dependencies: [i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.NgModel, HisPlamComponent, HisFileUploadDirective, HisFileUploadComponent, HisUiPipe],
        styles: ["his-file-upload .uploaded-files-frame{border:1px solid #cfd8dc;padding:20px}his-file-upload .uploaded-files-frame{border:1px solid #cfd8dc;border-radius:4px;padding:10px}his-file-upload .uploaded-files-separator-line{border-top:1px solid #cfd8dc;padding-top:10px}his-file-upload .upload-button{width:100%;background-color:var(--backgroundColor39);border:2px dashed var(--backgroundColor47);text-align:center;padding:2px}his-file-upload .upload-in-progress{width:100%;text-align:center;padding:2px}his-file-upload .drop-container:hover{background-color:var(--highlightBackgroundColor);border:2px dashed var(--basicFontColor)}his-file-upload .p-fileupload-buttonbar{display:none}his-file-upload .p-fileupload .p-fileupload-content{display:flex;flex-direction:column-reverse}his-file-upload .large-droparea .upload-button{min-height:10em}his-file-upload ul.upload-feedback{list-style-type:\"\";padding:0;margin:auto 0;display:inline-block;vertical-align:middle}his-file-upload ul.upload-feedback li{margin:0;padding:0;display:inline-block}\n"],
        encapsulation: 2
      });
    }
  }
  return HisFileUploadPlamComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisUploadFileImageComponent = /*#__PURE__*/(() => {
  class HisUploadFileImageComponent {
    constructor() {
      this.fileUploadService = inject(HisFileUploadService);
    }
    imageTitle() {
      if (this.title) {
        return this.title;
      }
      return this.value.name;
    }
    imageUrl() {
      return this.fileUploadService.getDownloadUrl(this.value);
    }
    static {
      this.ɵfac = function HisUploadFileImageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUploadFileImageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisUploadFileImageComponent,
        selectors: [["his-upload-file-image"]],
        inputs: {
          value: "value",
          style: "style",
          title: "title"
        },
        standalone: false,
        decls: 2,
        vars: 6,
        consts: [[3, "src", "title"]],
        template: function HisUploadFileImageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
            i0.ɵɵproperty("src", i0.ɵɵpipeBind1(1, 4, ctx.imageUrl()), i0.ɵɵsanitizeUrl)("title", ctx.title);
          }
        },
        dependencies: [i1$2.AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return HisUploadFileImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0$1 = ["addFileInput"];
const _c1 = ["addFilePlam"];
function HisUploadListComponent_Conditional_3_ng_template_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "common.components.inputFile.resourceComment"));
  }
}
function HisUploadListComponent_Conditional_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HisUploadListComponent_Conditional_3_ng_template_1_Conditional_4_Template, 3, 3, "th");
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "hisUi");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, "common.components.inputFile.filename"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.showCommentColumn() ? 4 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 7, "common.components.inputFile.commonCategory"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 9, "common.components.inputFile.createdAt"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 11, "de.his.javang.aktionen"), " ");
  }
}
function HisUploadListComponent_Conditional_3_ng_template_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(file_r4.comment);
  }
}
function HisUploadListComponent_Conditional_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, HisUploadListComponent_Conditional_3_ng_template_2_Conditional_3_Template, 2, 1, "td");
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td")(10, "button", 12);
    i0.ɵɵpipe(11, "hisUi");
    i0.ɵɵlistener("click", function HisUploadListComponent_Conditional_3_ng_template_2_Template_button_click_10_listener() {
      const file_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.showEditFileDialog(file_r4));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 13);
    i0.ɵɵpipe(13, "hisUi");
    i0.ɵɵlistener("click", function HisUploadListComponent_Conditional_3_ng_template_2_Template_button_click_12_listener() {
      const file_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteFile(file_r4));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "his-upload-file-download", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showCommentColumn() ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.category(file_r4.documentMetadataCategoryId, false));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 7, file_r4.createdAt, "dd.MM.yyyy HH:mm"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(11, 10, "common.editOf", file_r4.name));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(13, 13, "common.deleteOf", file_r4.name));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", file_r4);
  }
}
function HisUploadListComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 4);
    i0.ɵɵtemplate(1, HisUploadListComponent_Conditional_3_ng_template_1_Template, 14, 13, "ng-template", 10)(2, HisUploadListComponent_Conditional_3_ng_template_2_Template, 15, 16, "ng-template", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.documents);
  }
}
function HisUploadListComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 9);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "p-autoComplete", 14, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function HisUploadListComponent_Conditional_16_Template_p_autoComplete_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.editCategory, $event) || (ctx_r1.editCategory = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("completeMethod", function HisUploadListComponent_Conditional_16_Template_p_autoComplete_completeMethod_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.filterCategories($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showLabelTop", true)("label", i0.ɵɵpipeBind1(1, 6, "common.components.inputFile.commonCategory"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dropdown", true)("forceSelection", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.editCategory);
    i0.ɵɵproperty("suggestions", ctx_r1.filteredCategories);
  }
}
function HisUploadListComponent_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam", 9);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "textarea", 15, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function HisUploadListComponent_Conditional_17_Template_textarea_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.editComment, $event) || (ctx_r1.editComment = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtext(4, "      ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("showLabelTop", true)("label", i0.ɵɵpipeBind1(1, 4, "common.components.inputFile.resourceComment"));
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.editComment);
    i0.ɵɵproperty("disabled", ctx_r1.editCommentDisabled());
  }
}
/**
 * Company: HIS
 * @author Jan Bauer <jan.bauer-extern@his.de>
 */
let HisUploadListComponent = /*#__PURE__*/(() => {
  class HisUploadListComponent {
    constructor() {
      this.notificationService = inject(HisNotificationService);
      this.valueService = inject(HisGenericValueService);
      this.uploadService = inject(HisFileUploadService);
      this.uiService = inject(HisUiService);
      this.documents = [];
      this.displayAddFileDialog = false;
      this.newFiles = [];
      this.displayEditFileDialog = false;
      this.allCategories = [];
      this.filteredCategories = [];
    }
    ngOnInit() {
      this.uploadService.getUploadFieldConfig(this.configKey).subscribe(response => this.uploadConfiguration = new HisUploadConfiguration(response));
      this.valueService.getValueTypes('documentMetadataCategoryValue').subscribe(response => this.allCategories = response);
    }
    showAddFileDialog() {
      this.displayAddFileDialog = true;
      this.newFiles = [];
    }
    addFile() {
      // validate
      this.addFileInput.triggerValidation();
      if (this.addFilePlam.hasErrors()) {
        const errors = this.addFilePlam.getErrors();
        let errorMessages = [];
        for (const errorKey of Object.keys(errors)) {
          errorMessages.push(this.uiService.translate(errors[errorKey].message));
        }
        this.notificationService.errorI18n(errorMessages.join('\n'));
        return;
      }
      if (this.documents === null) {
        this.documents = [];
      }
      // add to documents
      this.documents.push(this.newFiles[0]);
      // close dialog and show notification
      this.displayAddFileDialog = false;
      this.notificationService.infoI18n('de.his.javang.gefunden.change');
      this.uploadService.abortAllOnGoingFeedbackRequests();
    }
    hideAddFileDialog() {
      this.displayAddFileDialog = false;
      this.uploadService.abortAllOnGoingFeedbackRequests();
    }
    showEditFileDialog($event) {
      // init edit properties
      this.editUui = $event.uuid;
      this.editCategoryIdOriginal = $event.documentMetadataCategoryId;
      this.editCategory = this.allCategories.find(cat => cat.id === this.editCategoryIdOriginal);
      this.editComment = $event.comment;
      // show dialog
      this.displayEditFileDialog = true;
    }
    showEditCategory() {
      if (!this.uploadConfiguration) {
        return false;
      }
      if (this.uploadConfiguration.getDocumentMetadataCategoryIds().length > 1) {
        return true;
      }
      if (!_.includes(this.uploadConfiguration.getDocumentMetadataCategoryIds(), this.editCategoryIdOriginal)) {
        return true;
      }
      return this.uploadConfiguration.getShowCategoryIfUnique();
    }
    showEditComment() {
      if (!this.uploadConfiguration) {
        return false;
      }
      if (!_.isEmpty(this.editComment)) {
        return true;
      }
      return this.uploadConfiguration.getShowDescription();
    }
    editCommentDisabled() {
      if (!this.uploadConfiguration) {
        return true;
      }
      return !this.uploadConfiguration.getShowDescription();
    }
    filterCategories(event) {
      let categories = new Set();
      for (let dmc of this.allCategories) {
        if (dmc.defaulttext.toLowerCase().includes(event.query.toLowerCase()) && (_.includes(this.uploadConfiguration.getDocumentMetadataCategoryIds(), dmc.id) || dmc.id === this.editCategoryIdOriginal)) {
          categories.add(dmc);
        }
      }
      this.filteredCategories = [...categories];
    }
    updateFile() {
      const docIndex = this.documents.findIndex(doc => doc.uuid === this.editUui);
      if (docIndex > -1) {
        // change detection requires a workaround to function properly
        // first we remove the old instance from documents and than add
        // a copy of the updated instance at the same index
        const docToUpdate = structuredClone(this.documents[docIndex]);
        docToUpdate.documentMetadataCategoryId = this.editCategory.id;
        docToUpdate.comment = this.editComment;
        docToUpdate.documentMetadataCategoryHiskeyId = this.editCategory.hiskeyId;
        this.documents.splice(docIndex, 1);
        this.documents.splice(docIndex, 0, docToUpdate);
      }
      //  close dialog and show notification
      this.displayEditFileDialog = false;
      this.notificationService.infoI18n('de.his.javang.gefunden.change');
    }
    deleteFile($event) {
      const deleteIndex = this.documents.findIndex(file => file.uuid === $event.uuid);
      if (deleteIndex > -1) {
        this.documents.splice(deleteIndex, 1);
        this.notificationService.infoI18n('de.his.javang.gefunden.change');
      }
    }
    showDocumentsTable() {
      return this.documents && this.documents.length > 0;
    }
    showCommentColumn() {
      if (!this.uploadConfiguration) {
        return false;
      }
      return this.uploadConfiguration.getShowDescription();
    }
    category(documentMetadataCategoryId, compareHisKeyId) {
      if (!documentMetadataCategoryId) {
        return null;
      }
      let category;
      if (compareHisKeyId === true) {
        category = this.allCategories.find(c => c.hiskeyId === documentMetadataCategoryId);
      } else {
        category = this.allCategories.find(c => c.id === documentMetadataCategoryId);
      }
      return category?.defaulttext;
    }
    static {
      this.ɵfac = function HisUploadListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisUploadListComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisUploadListComponent,
        selectors: [["his-upload-list"]],
        viewQuery: function HisUploadListComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5);
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addFileInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addFilePlam = _t.first);
          }
        },
        inputs: {
          documents: "documents",
          configKey: "configKey"
        },
        standalone: false,
        decls: 21,
        vars: 30,
        consts: [["addFilePlam", ""], ["content", "", "addFileInput", ""], ["content", ""], ["type", "button", "id", "display", "type", "text", "hisImage", "plus_circ_green", 1, "transparent", 3, "click"], [3, "value"], [3, "visibleChange", "onHide", "header", "visible", "responsive", "modal", "dismissableMask", "blockScroll"], [3, "ngModelChange", "configKey", "ngModel"], ["type", "button", 3, "click"], [3, "visibleChange", "header", "visible", "responsive", "modal", "dismissableMask", "blockScroll"], [3, "showLabelTop", "label"], ["pTemplate", "header"], ["pTemplate", "body"], ["type", "button", "hisImage", "PENCIL", 1, "icon", 3, "click", "title"], ["type", "button", "hisImage", "DELETE", 1, "icon", 3, "click", "title"], ["field", "defaulttext", 3, "ngModelChange", "completeMethod", "dropdown", "forceSelection", "ngModel", "suggestions"], [1, "textareaWidth100", 3, "ngModelChange", "ngModel", "disabled"]],
        template: function HisUploadListComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 3);
            i0.ɵɵlistener("click", function HisUploadListComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showAddFileDialog());
            });
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, HisUploadListComponent_Conditional_3_Template, 3, 1, "p-table", 4);
            i0.ɵɵelementStart(4, "p-dialog", 5);
            i0.ɵɵpipe(5, "hisUi");
            i0.ɵɵtwoWayListener("visibleChange", function HisUploadListComponent_Template_p_dialog_visibleChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.displayAddFileDialog, $event) || (ctx.displayAddFileDialog = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onHide", function HisUploadListComponent_Template_p_dialog_onHide_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hideAddFileDialog());
            });
            i0.ɵɵelementStart(6, "his-plam", null, 0)(8, "his-file-upload", 6, 1);
            i0.ɵɵtwoWayListener("ngModelChange", function HisUploadListComponent_Template_his_file_upload_ngModelChange_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.newFiles, $event) || (ctx.newFiles = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "button", 7);
            i0.ɵɵlistener("click", function HisUploadListComponent_Template_button_click_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.addFile());
            });
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "hisUi");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "p-dialog", 8);
            i0.ɵɵpipe(15, "hisUi");
            i0.ɵɵtwoWayListener("visibleChange", function HisUploadListComponent_Template_p_dialog_visibleChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.displayEditFileDialog, $event) || (ctx.displayEditFileDialog = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵtemplate(16, HisUploadListComponent_Conditional_16_Template, 4, 8, "his-plam", 9)(17, HisUploadListComponent_Conditional_17_Template, 5, 6, "his-plam", 9);
            i0.ɵɵelementStart(18, "button", 7);
            i0.ɵɵlistener("click", function HisUploadListComponent_Template_button_click_18_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.updateFile());
            });
            i0.ɵɵtext(19);
            i0.ɵɵpipe(20, "hisUi");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 20, "cs.sys.filemanagement.newDocument"), "\n");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showDocumentsTable() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("header", i0.ɵɵpipeBind1(5, 22, "common.components.inputFile.addFile"));
            i0.ɵɵtwoWayProperty("visible", ctx.displayAddFileDialog);
            i0.ɵɵproperty("responsive", true)("modal", true)("dismissableMask", false)("blockScroll", true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("configKey", ctx.configKey);
            i0.ɵɵtwoWayProperty("ngModel", ctx.newFiles);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 24, "common.apply"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("header", i0.ɵɵpipeBind1(15, 26, "common.components.inputFile.addEdit"));
            i0.ɵɵtwoWayProperty("visible", ctx.displayEditFileDialog);
            i0.ɵɵproperty("responsive", true)("modal", true)("dismissableMask", false)("blockScroll", true);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showEditCategory() ? 16 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showEditComment() ? 17 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 28, "common.apply"));
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgModel, i3$1.Table, i2.PrimeTemplate, i3.Dialog, i2$1.AutoComplete, HisPlamComponent, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisDeleteActionDirective, HisFileUploadDirective, HisFileUploadComponent, HisUploadFileDownloadComponent, i1$2.DatePipe, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisUploadListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisFileUploadSharedModule = /*#__PURE__*/(() => {
  class HisFileUploadSharedModule {
    static {
      this.ɵfac = function HisFileUploadSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisFileUploadSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
        // primeng
        TableModule, DataViewModule, DialogModule, AutoCompleteModule, FileUploadModule, DragDropModule, OverlayPanelModule,
        // HIS
        HisCoreSharedModule, HisStructureSharedModule]
      });
    }
  }
  return HisFileUploadSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisFileUploadSharedModule, {
    declarations: [HisFileUploadComponent, HisFileUploadCategorySelectComponent, HisFileUploadPlamComponent, HisUploadFileDownloadComponent, HisUploadFileImageComponent, HisUploadListComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
    // primeng
    TableModule, DataViewModule, DialogModule, AutoCompleteModule, FileUploadModule, DragDropModule, OverlayPanelModule,
    // HIS
    HisCoreSharedModule, HisStructureSharedModule],
    exports: [HisFileUploadComponent, HisFileUploadCategorySelectComponent, HisFileUploadPlamComponent, HisUploadFileDownloadComponent, HisUploadFileImageComponent, HisUploadListComponent]
  });
})();
function HisLinkComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵlistener("click", function HisLinkComponent_Conditional_0_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBeforeNavigate());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.route)("queryParams", ctx_r1.queryParams)("state", ctx_r1.state)("hisImage", ctx_r1.img)("title", ctx_r1.title)("ariaLabel", ctx_r1.title)("hisSearchResult", ctx_r1.genericSearchResult)("selectedIndex", ctx_r1.genericSearchResultIndex);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_9_0 = ctx_r1.text) !== null && tmp_9_0 !== undefined ? tmp_9_0 : "");
  }
}
function HisLinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵlistener("click", function HisLinkComponent_Conditional_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBeforeNavigate());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r1.href, i0.ɵɵsanitizeUrl)("hisImage", ctx_r1.img)("title", ctx_r1.title)("ariaLabel", ctx_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_5_0 = ctx_r1.text) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "");
  }
}
function HisLinkComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 5);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hisImage", ctx_r1.img + "_i")("title", ctx_r1.title)("ariaLabel", ctx_r1.title + " " + i0.ɵɵpipeBind1(1, 3, "cs.sys.common.linkInactive"));
  }
}
function HisLinkComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtemplate(1, HisLinkComponent_Conditional_2_Conditional_1_Template, 2, 5, "img", 5);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.img ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_2_0 = ctx_r1.text) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "");
  }
}
/**
 * Komponente für Links (egal ob routerLink oder href) mit Icon und/oder Text.
 */
let HisLinkComponent = /*#__PURE__*/(() => {
  class HisLinkComponent {
    constructor() {
      this.navigationService = inject(HisNavigationService);
      this.elementRef = inject(ElementRef);
      /** Der häufigste Use case einer Aktion vor dem Navigieren */
      this.setLastBackUrl = false;
    }
    ngOnInit() {
      // tabIndex=0 am his-icon-link entfernen damit man nicht 2x tabben muss um zum nächsten Element zu kommen
      this.elementRef.nativeElement.tabIndex = -1;
    }
    /**
     * Aktionen bevor der Link aufgerufen wird.
     *
     * (Da Javascript single-threaded ist sollte das hier immer ausgeführt werden bevor der Link aufgerufen wird.)
     * (Die Funktion onBeforeNavigateFunction darf bloss keine asynchrone Ausführung beinhalten.                 )
     */
    onBeforeNavigate() {
      if (this.setLastBackUrl === true) {
        this.navigationService.setLastBackUrl(window.location.href);
      }
      if (this.onBeforeNavigateFunction) {
        this.onBeforeNavigateFunction();
      }
    }
    static {
      this.ɵfac = function HisLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisLinkComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisLinkComponent,
        selectors: [["his-link"]],
        inputs: {
          route: "route",
          queryParams: "queryParams",
          state: "state",
          href: "href",
          img: "img",
          text: "text",
          disabled: "disabled",
          title: "title",
          setLastBackUrl: "setLastBackUrl",
          onBeforeNavigateFunction: "onBeforeNavigateFunction",
          genericSearchResult: "genericSearchResult",
          genericSearchResultIndex: "genericSearchResultIndex"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => HisLinkComponent),
          multi: true
        }])],
        decls: 3,
        vars: 3,
        consts: [[3, "routerLink", "queryParams", "state", "hisImage", "title", "ariaLabel", "hisSearchResult", "selectedIndex"], [3, "href", "hisImage", "title", "ariaLabel"], [1, "hisLinkDisabled"], [3, "click", "routerLink", "queryParams", "state", "hisImage", "title", "ariaLabel", "hisSearchResult", "selectedIndex"], [3, "click", "href", "hisImage", "title", "ariaLabel"], [1, "inlineicon", "imggrey", 3, "hisImage", "title", "ariaLabel"], [1, "hisLinkDisabledText"]],
        template: function HisLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisLinkComponent_Conditional_0_Template, 2, 9, "a", 0)(1, HisLinkComponent_Conditional_1_Template, 2, 5, "a", 1)(2, HisLinkComponent_Conditional_2_Template, 4, 2, "span", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.route && !ctx.disabled ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.href && !ctx.disabled ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.disabled ? 2 : -1);
          }
        },
        dependencies: [i1$3.RouterLink, HisImageDirective, HisSearchResultHeaderContextProviderDirective, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisNavigationSharedModule = /*#__PURE__*/(() => {
  class HisNavigationSharedModule {
    static {
      this.ɵfac = function HisNavigationSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisNavigationSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisNavigationSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
        // primeng
        TableModule, DataViewModule, DialogModule, AutoCompleteModule,
        // HIS
        HisCoreSharedModule, HisStructureSharedModule]
      });
    }
  }
  return HisNavigationSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisNavigationSharedModule, {
    declarations: [HisLinkComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
    // primeng
    TableModule, DataViewModule, DialogModule, AutoCompleteModule,
    // HIS
    HisCoreSharedModule, HisStructureSharedModule],
    exports: [HisLinkComponent]
  });
})();
let ProblemCaseService = /*#__PURE__*/(() => {
  class ProblemCaseService {
    constructor() {
      this.backendService = inject(HisBackendService);
      this.apiBase = 'api/v1/cs/psv/problemCase';
    }
    newInstance(template, recipientIds, searchEntityIds) {
      const theTemplate = this.trimToNull(template);
      const theRecipientIds = this.asCsvStringOrUndefined(recipientIds);
      const theSearchEntityIds = this.asCsvStringOrUndefined(searchEntityIds);
      if (!theTemplate) {
        throw new Error('template is required');
      }
      const baseRequestUrl = `${this.apiBase}/new/${theTemplate}`;
      const params = [];
      if (theRecipientIds) {
        params.push({
          name: 'recipientIds',
          value: theRecipientIds
        });
      }
      if (theSearchEntityIds) {
        params.push({
          name: 'searchEntityIds',
          value: theSearchEntityIds
        });
      }
      if (params.length > 0) {
        const queryString = params.map(param => `${param.name}=${param.value}`).join('&');
        return this.backendService.getData(`${baseRequestUrl}?${queryString}`);
      }
      return this.backendService.getData(baseRequestUrl);
    }
    asCsvStringOrUndefined(values) {
      if (values && values.length > 0) {
        return values.join(',').trim();
      }
      return undefined;
    }
    send(problemCase) {
      return this.backendService.postData(`${this.apiBase}/send`, problemCase);
    }
    findAllRecipients(template, autocompleteQuery) {
      const theTemplate = this.trimToNull(template);
      const baseRequestUrl = `${this.apiBase}/findRecipientsSet/${theTemplate}`;
      const q = this.trimToNull(autocompleteQuery);
      if (!q) {
        return this.backendService.getData(baseRequestUrl);
      }
      return this.backendService.getData(`${baseRequestUrl}?q=${q}`);
    }
    trimToNull(value) {
      return value?.trim() || null;
    }
    static {
      this.ɵfac = function ProblemCaseService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProblemCaseService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ProblemCaseService,
        factory: ProblemCaseService.ɵfac
      });
    }
  }
  return ProblemCaseService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class ProblemCase {
  constructor(problemCaseTemplateUniquename, searchEntityIds, senderEmailId, recipientIds, subject, content) {
    this.problemCaseTemplateUniquename = problemCaseTemplateUniquename;
    this.searchEntityIds = searchEntityIds;
    this.senderEmailId = senderEmailId;
    this.recipientIds = recipientIds;
    this.subject = subject;
    this.content = content;
  }
}
let HisProblemCaseSharedModuleOptions = /*#__PURE__*/(() => {
  class HisProblemCaseSharedModuleOptions {
    static {
      this.RIGHT_CREATE_PROBLEM_CASE = ['RIGHT_CS_PSV_PROBLEM_CASE_PROCESSING_CREATE_PROBLEM_CASE'];
    }
  }
  return HisProblemCaseSharedModuleOptions;
})();
const _forTrack0 = ($index, $item) => $item.id;
function HisProblemCaseFormComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-panel", 1);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelement(2, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("header", i0.ɵɵpipeBind1(1, 2, "de.his.javang.infos"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.infotext, i0.ɵɵsanitizeHtml);
  }
}
function HisProblemCaseFormComponent_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-multiselect-plam", 13);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵlistener("selectedOptionsChange", function HisProblemCaseFormComponent_Conditional_7_Conditional_0_Template_his_multiselect_plam_selectedOptionsChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSelectedRecipientsChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 6, "cs.psv.problemcase.ProblemCase.recipientIds"))("customOptionsMethod", ctx_r1.getRecipientOptions())("removeSelectedOptionsFromDropdown", true)("showDeleteButton", true)("showSelectButton", true)("selectedOptions", ctx_r1.pcSelectedRecipients);
  }
}
function HisProblemCaseFormComponent_Conditional_7_Conditional_1_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const recipient_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(recipient_r4.label);
  }
}
function HisProblemCaseFormComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "his-plam", 12);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵelementStart(2, "ul", null, 0);
    i0.ɵɵrepeaterCreate(4, HisProblemCaseFormComponent_Conditional_7_Conditional_1_For_5_Template, 2, 1, "li", null, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 2, "cs.psv.problemcase.ProblemCase.recipientIds"))("required", true);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.pcSelectedRecipients);
  }
}
function HisProblemCaseFormComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisProblemCaseFormComponent_Conditional_7_Conditional_0_Template, 2, 8, "his-multiselect-plam", 11)(1, HisProblemCaseFormComponent_Conditional_7_Conditional_1_Template, 6, 4, "his-plam", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.recipientsEditable && !ctx_r1.disabled ? 0 : 1);
  }
}
function HisProblemCaseFormComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-plam")(1, "input", 14, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function HisProblemCaseFormComponent_Conditional_8_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.pcSubject, $event) || (ctx_r1.pcSubject = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("required", true);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.pcSubject);
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
  }
}
function HisProblemCaseFormComponent_Conditional_13_ng_template_7_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const header_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, header_r6));
  }
}
function HisProblemCaseFormComponent_Conditional_13_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, HisProblemCaseFormComponent_Conditional_13_ng_template_7_For_2_Template, 3, 3, "th", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.contextInformation.headers);
  }
}
function HisProblemCaseFormComponent_Conditional_13_ng_template_8_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r7);
  }
}
function HisProblemCaseFormComponent_Conditional_13_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, HisProblemCaseFormComponent_Conditional_13_ng_template_8_For_2_Template, 2, 1, "td", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(row_r8);
  }
}
function HisProblemCaseFormComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵelementStart(1, "p-panel", 1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelement(3, "div", 9);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelement(5, "div", 10);
    i0.ɵɵelementStart(6, "p-table", 15);
    i0.ɵɵtemplate(7, HisProblemCaseFormComponent_Conditional_13_ng_template_7_Template, 3, 0, "ng-template", 16)(8, HisProblemCaseFormComponent_Conditional_13_ng_template_8_Template, 3, 0, "ng-template", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("header", i0.ɵɵpipeBind1(2, 3, "cs.psv.problemcase.ProblemCase.contextInformation"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, "cs.psv.problemcase.ProblemCase.contextInformation.helptext"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r1.contextInformation.data);
  }
}
function HisProblemCaseFormComponent_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function HisProblemCaseFormComponent_Conditional_22_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCancelProblemCase());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "cs.psv.problemcase.action.cancel"), " ");
  }
}
let HisProblemCaseFormComponent = /*#__PURE__*/(() => {
  class HisProblemCaseFormComponent {
    constructor() {
      this.initialSenderEmail = undefined;
      this.recipientsVisible = true;
      this.recipientsEditable = false;
      this.initialRecipients = [];
      this.subjectVisible = true;
      this.initialSubject = undefined;
      this.initialContent = undefined;
      this.showCancelButton = true;
      this.disabled = false;
      this.submitProblemCaseForm = new EventEmitter();
      this.cancelProblemCaseFrom = new EventEmitter();
      this.filteredSenders = [];
      this.pcSenderEmail = undefined;
      this.pcSubject = '';
      this.pcContent = '';
      this.consentDataProcessing = false;
      this.pcSelectedRecipients = [];
    }
    reset() {
      this.pcSenderEmail = this.initialSenderEmail;
      this.pcSubject = this.initialSubject;
      this.pcContent = this.initialContent;
      this.pcSelectedRecipients = this.initialRecipients.map(e => this.recipientToHisOption(e));
    }
    filterSender(event) {
      if (!this.senderEmails || this.senderEmails.length === 0) {
        return;
      }
      this.filteredSenders = [...this.senderEmails].filter(e => e.label.toLowerCase().includes(event.query.toLowerCase()));
    }
    onSubmitProblemCase() {
      if (!this.consentDataProcessing) {
        return;
      }
      const senderEmailId = this.pcSenderEmail?.emailId;
      const subject = this.pcSubject;
      const content = this.pcContent;
      const recipientIds = this.pcSelectedRecipients.map(e => +e.id);
      this.submitProblemCaseForm.emit({
        senderEmailId,
        recipientIds,
        subject,
        content
      });
    }
    onCancelProblemCase() {
      this.cancelProblemCaseFrom.emit();
    }
    onSelectedRecipientsChange(event) {
      this.pcSelectedRecipients = event;
    }
    getRecipientOptions() {
      if (!this.recipients) {
        return autocompleteQuery => of([]);
      }
      return autocompleteQuery => this.recipients(autocompleteQuery).pipe(map$1(recipients => recipients.map(e => this.recipientToHisOption(e))));
    }
    recipientToHisOption(recipient) {
      return new HisOption(recipient.label, recipient.personId + '');
    }
    static {
      this.ɵfac = function HisProblemCaseFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisProblemCaseFormComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisProblemCaseFormComponent,
        selectors: [["his-send-problem-case-form"]],
        inputs: {
          infotext: "infotext",
          senderEmails: "senderEmails",
          initialSenderEmail: "initialSenderEmail",
          recipientsVisible: "recipientsVisible",
          recipientsEditable: "recipientsEditable",
          recipients: "recipients",
          initialRecipients: "initialRecipients",
          subjectVisible: "subjectVisible",
          initialSubject: "initialSubject",
          initialContent: "initialContent",
          contextInformation: "contextInformation",
          showCancelButton: "showCancelButton",
          disabled: "disabled"
        },
        outputs: {
          submitProblemCaseForm: "submitProblemCaseForm",
          cancelProblemCaseFrom: "cancelProblemCaseFrom"
        },
        standalone: false,
        decls: 23,
        vars: 30,
        consts: [["content", ""], [3, "header"], ["hisDdKey", "cs.psv.problemcase.ProblemCase.senderEmailId", 3, "completeMethod", "ngModelChange", "title", "dropdown", "forceSelection", "suggestions", "required", "ngModel", "disabled"], ["pInputTextarea", "", "hisDdKey", "cs.psv.problemcase.ProblemCase.content", "rows", "10", 1, "textareaWidth100", 3, "ngModelChange", "required", "ngModel", "disabled"], [1, "consentDataProcessingContainer"], [1, "leftAlignedCheckbox", 3, "label"], ["type", "checkbox", 3, "ngModelChange", "required", "ngModel", "disabled"], ["type", "button", 1, "submit_highlighted", 3, "click", "disabled"], ["type", "button", 3, "disabled"], [3, "innerHTML"], [1, "spaceAboveHalfEm"], ["ddKey", "cs.psv.problemcase.ProblemCase.recipientIds", "field", "text", 3, "label", "customOptionsMethod", "removeSelectedOptionsFromDropdown", "showDeleteButton", "showSelectButton", "selectedOptions"], ["hisDdKey", "cs.psv.problemcase.ProblemCase.recipientIds", 3, "label", "required"], ["ddKey", "cs.psv.problemcase.ProblemCase.recipientIds", "field", "text", 3, "selectedOptionsChange", "label", "customOptionsMethod", "removeSelectedOptionsFromDropdown", "showDeleteButton", "showSelectButton", "selectedOptions"], ["pInputText", "", "hisDdKey", "cs.psv.problemcase.ProblemCase.subject", 1, "inputWidth100", 3, "ngModelChange", "required", "ngModel", "disabled"], [3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["type", "button", 3, "click", "disabled"]],
        template: function HisProblemCaseFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, HisProblemCaseFormComponent_Conditional_0_Template, 4, 4);
            i0.ɵɵelementStart(1, "p-panel", 1);
            i0.ɵɵpipe(2, "hisUi");
            i0.ɵɵelementStart(3, "his-plam")(4, "p-autoComplete", 2, 0);
            i0.ɵɵpipe(6, "hisUi");
            i0.ɵɵlistener("completeMethod", function HisProblemCaseFormComponent_Template_p_autoComplete_completeMethod_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.filterSender($event));
            });
            i0.ɵɵtwoWayListener("ngModelChange", function HisProblemCaseFormComponent_Template_p_autoComplete_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.pcSenderEmail, $event) || (ctx.pcSenderEmail = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, HisProblemCaseFormComponent_Conditional_7_Template, 2, 1)(8, HisProblemCaseFormComponent_Conditional_8_Template, 3, 3, "his-plam");
            i0.ɵɵelementStart(9, "his-plam")(10, "textarea", 3, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisProblemCaseFormComponent_Template_textarea_ngModelChange_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.pcContent, $event) || (ctx.pcContent = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵtext(12, "        ");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(13, HisProblemCaseFormComponent_Conditional_13_Template, 9, 7);
            i0.ɵɵelementStart(14, "div", 4)(15, "his-plam", 5);
            i0.ɵɵpipe(16, "hisUi");
            i0.ɵɵelementStart(17, "input", 6, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function HisProblemCaseFormComponent_Template_input_ngModelChange_17_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.consentDataProcessing, $event) || (ctx.consentDataProcessing = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(19, "button", 7);
            i0.ɵɵlistener("click", function HisProblemCaseFormComponent_Template_button_click_19_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmitProblemCase());
            });
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "hisUi");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, HisProblemCaseFormComponent_Conditional_22_Template, 3, 4, "button", 8);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.infotext ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("header", i0.ɵɵpipeBind1(2, 22, "cs.psv.problemcase.ProblemCase.userdataFieldsetHeader"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(6, 24, "cs.psv.problemcase.ProblemCase.senderEmailId"))("dropdown", true)("forceSelection", true)("suggestions", ctx.filteredSenders)("required", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.pcSenderEmail);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.recipientsVisible ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.subjectVisible ? 8 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.pcContent);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional((ctx.contextInformation == null ? null : ctx.contextInformation.data == null ? null : ctx.contextInformation.data.length) > 0 ? 13 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(16, 26, "cs.psv.problemcase.notice.consentDataProcessing"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.consentDataProcessing);
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.consentDataProcessing || ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 28, "cs.psv.problemcase.action.send"), "\n");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showCancelButton ? 22 : -1);
          }
        },
        dependencies: [i1$1.DefaultValueAccessor, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.RequiredValidator, i1$1.CheckboxRequiredValidator, i1$1.NgModel, i2$1.AutoComplete, i2.PrimeTemplate, i4$1.Panel, i3$1.Table, HisPlamComponent, HisDdDirective, HisDdValidator, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisPanelDirective, HisMultiselectPlamComponent, HisUiPipe],
        styles: [".consentDataProcessingContainer[_ngcontent-%COMP%]{margin:1em 0}"]
      });
    }
  }
  return HisProblemCaseFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const _c0 = ["formComponent"];
function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dialog", 3);
    i0.ɵɵpipe(1, "hisUi");
    i0.ɵɵpipe(2, "hisUi");
    i0.ɵɵtwoWayListener("visibleChange", function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_0_Template_p_dialog_visibleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r2.dialogVisible, $event) || (ctx_r2.dialogVisible = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onHide", function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_0_Template_p_dialog_onHide_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onCancelProblemCase());
    });
    i0.ɵɵelementStart(3, "his-send-problem-case-form", 4, 0);
    i0.ɵɵlistener("submitProblemCaseForm", function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_0_Template_his_send_problem_case_form_submitProblemCaseForm_3_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onSubmitProblemCase($event));
    })("cancelProblemCaseFrom", function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_0_Template_his_send_problem_case_form_cancelProblemCaseFrom_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onCancelProblemCase());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("visible", ctx_r2.dialogVisible);
    i0.ɵɵproperty("header", i0.ɵɵpipeBind3(2, 17, "cs.psv.problemcase.dialogHeader", i0.ɵɵpipeBind1(1, 15, ctx_r2.buttonText), ctx_r2.creationInfo.problemCaseDefaulttext))("modal", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("infotext", ctx_r2.creationInfo.infotext)("senderEmails", ctx_r2.senderEmails)("initialSenderEmail", ctx_r2.senderEmails ? ctx_r2.senderEmails[0] : undefined)("recipientsVisible", ctx_r2.recipientsVisible)("recipientsEditable", ctx_r2.recipientsEditable)("recipients", ctx_r2.findAllRecipients())("initialRecipients", ctx_r2.creationInfo.recipients)("subjectVisible", ctx_r2.creationInfo.subjectVisible)("initialSubject", ctx_r2.creationInfo.problemCase.subject)("initialContent", ctx_r2.creationInfo.problemCase.content)("contextInformation", ctx_r2.creationInfo.contextInformation)("disabled", ctx_r2.disableForm);
  }
}
function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r2.buttonText), " ");
  }
}
function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_0_Template, 5, 21, "p-dialog", 1);
    i0.ɵɵelementStart(1, "button", 2);
    i0.ɵɵlistener("click", function HisSendProblemCaseComponent_Conditional_0_Conditional_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onShowDialog());
    });
    i0.ɵɵtemplate(2, HisSendProblemCaseComponent_Conditional_0_Conditional_0_Conditional_2_Template, 2, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\u00A0");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.creationInfo ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hisImage", ctx_r2.buttonIcon)("ngClass", ctx_r2.buttonClass);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.buttonText ? 2 : -1);
  }
}
function HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "hisUi");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.inlineSuccessMessageKey), i0.ɵɵsanitizeHtml);
  }
}
function HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "his-send-problem-case-form", 7, 0);
    i0.ɵɵlistener("submitProblemCaseForm", function HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_1_Template_his_send_problem_case_form_submitProblemCaseForm_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onSubmitProblemCase($event));
    })("cancelProblemCaseFrom", function HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_1_Template_his_send_problem_case_form_cancelProblemCaseFrom_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onCancelProblemCase());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("infotext", ctx_r2.creationInfo.infotext)("senderEmails", ctx_r2.senderEmails)("initialSenderEmail", ctx_r2.senderEmails ? ctx_r2.senderEmails[0] : undefined)("recipientsVisible", ctx_r2.recipientsVisible)("recipientsEditable", ctx_r2.recipientsEditable)("initialRecipients", ctx_r2.creationInfo.recipients)("recipients", ctx_r2.findAllRecipients())("subjectVisible", ctx_r2.creationInfo.subjectVisible)("initialSubject", ctx_r2.creationInfo.problemCase.subject)("initialContent", ctx_r2.creationInfo.problemCase.content)("contextInformation", ctx_r2.creationInfo.contextInformation)("showCancelButton", ctx_r2.showCancelButton)("disabled", ctx_r2.disableForm);
  }
}
function HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_0_Template, 2, 3, "div", 5)(1, HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_1_Template, 2, 13, "his-send-problem-case-form", 6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r2.showSuccess ? 0 : 1);
  }
}
function HisSendProblemCaseComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSendProblemCaseComponent_Conditional_0_Conditional_1_Conditional_0_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.creationInfo ? 0 : -1);
  }
}
function HisSendProblemCaseComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HisSendProblemCaseComponent_Conditional_0_Conditional_0_Template, 4, 4)(1, HisSendProblemCaseComponent_Conditional_0_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.displayBehaviour !== "inline" ? 0 : 1);
  }
}
const DISPLAY_BEHAVIOUR = ['inline', 'textOnly', 'iconOnly', 'iconAndText'];
let HisSendProblemCaseComponent = /*#__PURE__*/(() => {
  class HisSendProblemCaseComponent {
    constructor() {
      this.hisBaseGlobalsService = inject(HisBaseGlobalsService);
      this.hisAuthService = inject(HisAuthService);
      this.problemCaseService = inject(ProblemCaseService);
      this.notificationService = inject(HisNotificationService);
      this.inlineSuccessMessageKey = 'cs.psv.problemcase.send.successfulInlineMessageKey';
      this.successMessageKey = 'cs.psv.problemcase.send.successful';
      this.partialSuccessWithoutDetailsMessageKey = 'cs.psv.problemcase.send.partiallySuccessfulWithoutDetails';
      this.partialSuccessWithDetailsMessageKey = 'cs.psv.problemcase.send.partiallySuccessfulWithDetails';
      this.newProblemCaseMessageKey = 'cs.psv.problemcase.action.newProblemCase';
      this.displayBehaviour = 'iconAndText';
      this.renderAsButton = false;
      /**
       * Whether to display the cancel button; Only applicable if `asDialog` is `false` Default is `true`.
       */
      this.showCancelButton = true;
      this.sendProblemCase = new EventEmitter();
      this.cancelProblemCase = new EventEmitter();
      this.dialogVisible = false;
      this.creationInfo = undefined;
      this.senderEmails = []; // TODO get from creationInfo
      this.recipientsVisible = false;
      this.recipientsEditable = false;
      this.showSuccess = false;
      this.accessGranted = false;
      this.buttonText = this.newProblemCaseMessageKey;
      this.buttonClass = 'transparent';
      this.buttonIcon = 'COMMENT';
      this.disableForm = false;
    }
    ngOnInit() {
      this.accessGranted = this.hisAuthService.hasAll(...HisProblemCaseSharedModuleOptions.RIGHT_CREATE_PROBLEM_CASE);
      // don't try to initialize anything if the user has no access
      if (!this.accessGranted) {
        return;
      }
      switch (this.displayBehaviour) {
        case 'iconOnly':
          {
            this.buttonClass = this.renderAsButton ? undefined : 'icon';
            this.buttonText = undefined;
            this.buttonIcon = 'COMMENT';
            break;
          }
        case 'textOnly':
          {
            this.buttonClass = this.renderAsButton ? undefined : 'transparent';
            this.buttonText = this.newProblemCaseMessageKey;
            this.buttonIcon = undefined;
            break;
          }
        case 'iconAndText':
          {
            this.buttonClass = this.renderAsButton ? undefined : 'transparent';
            this.buttonText = this.newProblemCaseMessageKey;
            this.buttonIcon = 'COMMENT';
            break;
          }
      }
      if (this.displayBehaviour === 'inline') {
        this.updateCreationInfo().subscribe();
      }
    }
    updateCreationInfo() {
      // reset old values
      this.creationInfo = undefined;
      this.senderEmails = [];
      // query new values
      return this.problemCaseService.newInstance(this.template, this.recipientIds ?? [], this.searchEntityIds).pipe(tap$1(e => {
        this.creationInfo = e;
        this.senderEmails = this.asSenderEmails(this.creationInfo.senderEMailAddresses);
        this.recipientsVisible = this.creationInfo.recipientVisibility !== 0;
        this.recipientsEditable = this.recipientsVisible && this.creationInfo.recipientVisibility === 2;
        // This needs to delayed as otherwise the formComponents will not yet be visible
        // and thus no single form will be resetted.
        // ~Perhaps there is a better way to do this, but as of now this is the best solution I can think of.~
        // Nope, there isn't. I tried a subscription based approach, but that caused an ExpressionChangedAfterItHasBeenCheckedError.
        setTimeout(() => this.resetFormComponents());
      }), map$1(_e => undefined));
    }
    asSenderEmails(senderEMailAddresses) {
      return Object.keys(senderEMailAddresses).map(key => ({
        emailId: parseInt(key, 10),
        label: senderEMailAddresses[+key]
      }));
    }
    resetFormComponents() {
      this.formComponents.forEach(formComponent => formComponent.reset());
    }
    onShowDialog() {
      this.updateCreationInfo().subscribe(() => {
        this.dialogVisible = true;
      });
    }
    onSubmitProblemCase(formValues) {
      this.disableForm = true;
      const problemCase = new ProblemCase(this.template, this.searchEntityIds, formValues.senderEmailId, formValues.recipientIds, formValues.subject, formValues.content);
      this.problemCaseService.send(problemCase).pipe(finalize$1(() => this.disableForm = false)).subscribe(sendResult => this.onSendSuccess(sendResult));
    }
    onSendSuccess(sendResult) {
      if (this.displayBehaviour === 'inline') {
        this.showSuccess = true;
        this.showSuccessMessages(sendResult);
      } else {
        this.dialogVisible = false;
        this.showSuccessMessages(sendResult);
      }
      this.sendProblemCase.emit(true);
    }
    showSuccessMessages(sendResult) {
      if (sendResult.sendToAllRecipientsSuccessful) {
        this.notificationService.successI18n(this.successMessageKey);
        return;
      }
      if (!this.recipientsVisible) {
        this.notificationService.infoI18n(this.partialSuccessWithoutDetailsMessageKey);
        return;
      }
      const unsentRecipientPersons = sendResult.unsentRecipientPersons.map(person => person.name).join(', ');
      this.notificationService.infoI18n(this.partialSuccessWithDetailsMessageKey, unsentRecipientPersons);
    }
    onCancelProblemCase() {
      this.resetFormComponents();
      this.dialogVisible = false;
      this.cancelProblemCase.emit();
    }
    findAllRecipients() {
      return autocompleteQuery => this.problemCaseService.findAllRecipients(this.template, autocompleteQuery);
    }
    static {
      this.ɵfac = function HisSendProblemCaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSendProblemCaseComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSendProblemCaseComponent,
        selectors: [["his-send-problem-case"]],
        viewQuery: function HisSendProblemCaseComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formComponents = _t);
          }
        },
        inputs: {
          template: "template",
          recipientIds: "recipientIds",
          searchEntityIds: "searchEntityIds",
          inlineSuccessMessageKey: "inlineSuccessMessageKey",
          successMessageKey: "successMessageKey",
          partialSuccessWithoutDetailsMessageKey: "partialSuccessWithoutDetailsMessageKey",
          partialSuccessWithDetailsMessageKey: "partialSuccessWithDetailsMessageKey",
          newProblemCaseMessageKey: "newProblemCaseMessageKey",
          displayBehaviour: "displayBehaviour",
          renderAsButton: "renderAsButton",
          showCancelButton: "showCancelButton"
        },
        outputs: {
          sendProblemCase: "sendProblemCase",
          cancelProblemCase: "cancelProblemCase"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["formComponent", ""], [3, "visible", "header", "modal"], ["type", "button", 3, "click", "hisImage", "ngClass"], [3, "visibleChange", "onHide", "visible", "header", "modal"], [3, "submitProblemCaseForm", "cancelProblemCaseFrom", "infotext", "senderEmails", "initialSenderEmail", "recipientsVisible", "recipientsEditable", "recipients", "initialRecipients", "subjectVisible", "initialSubject", "initialContent", "contextInformation", "disabled"], ["ngClass", "successMessage", 3, "innerHTML"], [3, "infotext", "senderEmails", "initialSenderEmail", "recipientsVisible", "recipientsEditable", "initialRecipients", "recipients", "subjectVisible", "initialSubject", "initialContent", "contextInformation", "showCancelButton", "disabled"], [3, "submitProblemCaseForm", "cancelProblemCaseFrom", "infotext", "senderEmails", "initialSenderEmail", "recipientsVisible", "recipientsEditable", "initialRecipients", "recipients", "subjectVisible", "initialSubject", "initialContent", "contextInformation", "showCancelButton", "disabled"]],
        template: function HisSendProblemCaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSendProblemCaseComponent_Conditional_0_Template, 2, 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.accessGranted ? 0 : -1);
          }
        },
        dependencies: [i1$2.NgClass, i3.Dialog, HisImageDirective, HisModificationDetectionDirective, HisFocusableButtonDirective, HisButtonTitleDirective, HisProblemCaseFormComponent, HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisSendProblemCaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// canActivate: [HisAuthGuard],
const GENERIC_SEARCH_ROUTES = [{
  path: 'print-view',
  component: HisSearchPrintviewComponent,
  data: {
    hasAll: ['RIGHT_EVERYONE']
  }
}];
// eslint-disable-next-line @typescript-eslint/naming-convention
const HisGenericsearchRoutesModule = RouterModule.forChild(GENERIC_SEARCH_ROUTES);

/**
 * The core module for the generic search.
 */
let HisGenericsearchCoreModule = /*#__PURE__*/(() => {
  class HisGenericsearchCoreModule {
    static {
      this.ɵfac = function HisGenericsearchCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisGenericsearchCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisGenericsearchCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisConfirmationService, HisSearchService, HisSearchSelectfromService, HisWidgetService, HisSearchCriteriaSetService, HisSearchRowsPerPageService, HisSearchNavigationService],
        imports: [HisGenericsearchSharedModule, HisGenericsearchRoutesModule, HisGenericsearchSharedModule]
      });
    }
  }
  return HisGenericsearchCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisGenericsearchCoreModule, {
    imports: [HisGenericsearchSharedModule, i1$3.RouterModule],
    exports: [HisGenericsearchSharedModule]
  });
})();

/**
 * SharedModule for problem case .
 */
let HisProblemCaseSharedModule = /*#__PURE__*/(() => {
  class HisProblemCaseSharedModule {
    static {
      this.ɵfac = function HisProblemCaseSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisProblemCaseSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisProblemCaseSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, AutoCompleteModule, CalendarModule, InputNumberModule, PanelModule, TableModule, TabViewModule, DialogModule, ConfirmDialogModule, HisCoreSharedModule, HisStructureSharedModule, HisInputCoreModule, ChipModule, AccordionModule, HisSummernoteModule, HisGenericsearchCoreModule]
      });
    }
  }
  return HisProblemCaseSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisProblemCaseSharedModule, {
    declarations: [HisSendProblemCaseComponent, HisProblemCaseFormComponent],
    imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, AutoCompleteModule, CalendarModule, InputNumberModule, PanelModule, TableModule, TabViewModule, DialogModule, ConfirmDialogModule, HisCoreSharedModule, HisStructureSharedModule, HisInputCoreModule, ChipModule, AccordionModule, HisSummernoteModule, HisGenericsearchCoreModule],
    exports: [HisSendProblemCaseComponent]
  });
})();

/**
 * SharedModule with the components, directives, and pipes to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
let HisSharedModule = /*#__PURE__*/(() => {
  class HisSharedModule {
    static {
      this.ɵfac = function HisSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [HisAuthSharedModule, HisCoreSharedModule, HisDisplaySharedModule, HisDynamicFormSharedModule, HisGenericsearchSharedModule, HisInputSharedModule, HisJobsSharedModule, HisStructureSharedModule, HisTreeSharedModule, HisTranslationSharedModule, HisFileUploadSharedModule, HisCkeditorSharedModule, HisSummernoteSharedModule, HisCommunicationlogSharedModule, HisNavigationSharedModule, HisProblemCaseSharedModule, HisAuthSharedModule, HisCoreSharedModule, HisDisplaySharedModule, HisDynamicFormSharedModule, HisGenericsearchSharedModule, HisInputSharedModule, HisJobsSharedModule, HisStructureSharedModule, HisTreeSharedModule, HisTranslationSharedModule, HisFileUploadSharedModule, HisCkeditorSharedModule, HisSummernoteSharedModule, HisCommunicationlogSharedModule, HisNavigationSharedModule, HisProblemCaseSharedModule]
      });
    }
  }
  return HisSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisSharedModule, {
    imports: [HisAuthSharedModule, HisCoreSharedModule, HisDisplaySharedModule, HisDynamicFormSharedModule, HisGenericsearchSharedModule, HisInputSharedModule, HisJobsSharedModule, HisStructureSharedModule, HisTreeSharedModule, HisTranslationSharedModule, HisFileUploadSharedModule, HisCkeditorSharedModule, HisSummernoteSharedModule, HisCommunicationlogSharedModule, HisNavigationSharedModule, HisProblemCaseSharedModule],
    exports: [HisAuthSharedModule, HisCoreSharedModule, HisDisplaySharedModule, HisDynamicFormSharedModule, HisGenericsearchSharedModule, HisInputSharedModule, HisJobsSharedModule, HisStructureSharedModule, HisTreeSharedModule, HisTranslationSharedModule, HisFileUploadSharedModule, HisCkeditorSharedModule, HisSummernoteSharedModule, HisCommunicationlogSharedModule, HisNavigationSharedModule, HisProblemCaseSharedModule]
  });
})();

/**
 * CoreModule for common components.
 */
let HisDynamicFormCoreModule = /*#__PURE__*/(() => {
  class HisDynamicFormCoreModule {
    static {
      this.ɵfac = function HisDynamicFormCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisDynamicFormCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisDynamicFormCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisComponentRegistryService, HisComponentRegistryServiceInitilizer, HisDynamicContentUtils],
        imports: [HisDynamicFormSharedModule, HisDynamicFormSharedModule]
      });
    }
  }
  return HisDynamicFormCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisDynamicFormCoreModule, {
    imports: [HisDynamicFormSharedModule],
    exports: [HisDynamicFormSharedModule]
  });
})();

/**
 * Library of tree components.
 */
let HisTreeCoreModule = /*#__PURE__*/(() => {
  class HisTreeCoreModule {
    static {
      this.ɵfac = function HisTreeCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTreeCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisTreeCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisTreeService],
        imports: [HisTreeSharedModule, HisTreeSharedModule]
      });
    }
  }
  return HisTreeCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisTreeCoreModule, {
    imports: [HisTreeSharedModule],
    exports: [HisTreeSharedModule]
  });
})();
let HisAccessDisabledPageComponent = /*#__PURE__*/(() => {
  class HisAccessDisabledPageComponent {
    static {
      this.ɵfac = function HisAccessDisabledPageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisAccessDisabledPageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisAccessDisabledPageComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 2,
        vars: 3,
        template: function HisAccessDisabledPageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0);
            i0.ɵɵpipe(1, "hisUi");
          }
          if (rf & 2) {
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(1, 1, "common.service.accessDisabled"));
          }
        },
        dependencies: [HisUiPipe],
        encapsulation: 2
      });
    }
  }
  return HisAccessDisabledPageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function HisSubmenuComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.activeItem.label);
  }
}
function HisSubmenuComponent_For_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("hisImage", "next");
  }
}
function HisSubmenuComponent_For_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r2.routerLink)("queryParams", item_r2.queryParams);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.label);
  }
}
function HisSubmenuComponent_For_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", item_r2.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r2.label);
  }
}
function HisSubmenuComponent_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, HisSubmenuComponent_For_6_Conditional_1_Template, 1, 1, "img", 4)(2, HisSubmenuComponent_For_6_Conditional_2_Template, 2, 3, "a", 5)(3, HisSubmenuComponent_For_6_Conditional_3_Template, 2, 2, "a", 6);
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r2.items ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r2.routerLink ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r2.routerLink ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.title);
  }
}
function HisSubmenuComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 7)(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "hisUi");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "cm.alu.common.boxes.informationTitle"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.activeItem.title);
  }
}
let HisSubmenuComponent = /*#__PURE__*/(() => {
  class HisSubmenuComponent {
    constructor() {
      this.route = inject(ActivatedRoute);
      this.navigationService = inject(HisNavigationService);
      this.navigationMenuService = inject(HisNavigationMenuService);
      this.sessionStorageService = inject(HisSessionStorageService);
      this.children = new Array();
    }
    ngOnInit() {
      this.route.queryParams.pipe(filter(params => params.navigationPosition)).subscribe(() => {
        this.activeItem = this.navigationMenuService.getActiveMenuItem();
        console.log('submenu: activeItem =', this.activeItem);
        this.findChildren(this.activeItem);
      });
      this.sessionStorageService.removeSearchKeys();
    }
    findChildren(menuItem) {
      if (menuItem) {
        if (menuItem.items && menuItem.items.length > 0) {
          this.children = menuItem.items;
        }
      } else {
        console.log('submenu: menuItem is null -> access denied!');
        this.navigationService.navigateToAccessDenied();
      }
    }
    static {
      this.ɵfac = function HisSubmenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisSubmenuComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisSubmenuComponent,
        selectors: [["his-submenu"]],
        standalone: false,
        decls: 8,
        vars: 3,
        consts: [[1, "ui-g", "submenuPage"], [3, "ngClass"], [1, "submenuContainerLeft"], [1, "ui-g-12", "ui-md-5", "ui-lg-4", "ui-xl-4", "columnLayout"], [1, "inlineicon", 3, "hisImage"], [3, "routerLink", "queryParams"], [3, "href"], [1, "submenuContainerRight"]],
        template: function HisSubmenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HisSubmenuComponent_Conditional_0_Template, 2, 1, "h1");
            i0.ɵɵelementStart(1, "div", 0)(2, "div", 1)(3, "div", 2)(4, "ul");
            i0.ɵɵrepeaterCreate(5, HisSubmenuComponent_For_6_Template, 6, 4, "li", null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(7, HisSubmenuComponent_Conditional_7_Template, 7, 4, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.activeItem ? 0 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.activeItem && ctx.activeItem.title ? "ui-g-12 ui-md-7 ui-lg-8 ui-xl-8 columnLayout" : "ui-g-12 columnLayout");
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.children);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.activeItem && ctx.activeItem.title ? 7 : -1);
          }
        },
        dependencies: [i1$2.NgClass, i1$3.RouterLink, HisImageDirective, HisPageTitleDirective, HisUiPipe],
        styles: [".submenuContainerRight[_ngcontent-%COMP%]{padding:5px}.submenuPage[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-left:10px;margin-right:6px;margin-bottom:0;padding-left:1em;padding-right:1em;font-weight:400;list-style-type:\"\"}.submenuPage[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:2px;margin-top:0;margin-bottom:5px;list-style-type:\"\";position:relative}.submenuPage[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-weight:700;text-decoration:underline;text-decoration:underline dotted #000000;line-height:1.4em;padding:0}.submenuPage[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0;color:#555;margin-top:3px;padding-bottom:.5em;padding-right:10px;text-align:justify;line-height:1.3em}.submenuPage[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .submenuPage[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding-left:20px}.submenuPage[_ngcontent-%COMP%]   .inlineicon[_ngcontent-%COMP%]{position:absolute}"]
      });
    }
  }
  return HisSubmenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HisPagesSharedModule = /*#__PURE__*/(() => {
  class HisPagesSharedModule {
    static {
      this.ɵfac = function HisPagesSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPagesSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisPagesSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, HisSharedModule, FieldsetModule]
      });
    }
  }
  return HisPagesSharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisPagesSharedModule, {
    declarations: [HisAccessDisabledPageComponent, HisSubmenuComponent],
    imports: [CommonModule, RouterModule, HisSharedModule, FieldsetModule]
  });
})();
const ROUTES$1 = [{
  path: 'submenu',
  component: HisSubmenuComponent,
  data: {
    hasAny: ['RIGHT_EVERYONE'],
    modules: ['HISINONE']
  }
}, {
  path: 'access-disabled',
  pathMatch: 'full',
  component: HisAccessDisabledPageComponent,
  data: {
    hasAny: ['RIGHT_EVERYONE'],
    modules: ['HISINONE']
  }
}];
let HisPagesCoreModule = /*#__PURE__*/(() => {
  class HisPagesCoreModule {
    static {
      this.ɵfac = function HisPagesCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisPagesCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisPagesCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [HisPagesSharedModule, hisChildRoutes(ROUTES$1)]
      });
    }
  }
  return HisPagesCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisPagesCoreModule, {
    imports: [HisPagesSharedModule, i1$3.RouterModule]
  });
})();
var hisPagesCore_module = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HisPagesCoreModule: HisPagesCoreModule,
  ROUTES: ROUTES$1
});

/**
 * The core module for jobs
 */
let HisJobsCoreModule = /*#__PURE__*/(() => {
  class HisJobsCoreModule {
    static {
      this.ɵfac = function HisJobsCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisJobsCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisJobsCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisJobService],
        imports: [HisJobsSharedModule, HisJobsSharedModule]
      });
    }
  }
  return HisJobsCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisJobsCoreModule, {
    imports: [HisJobsSharedModule],
    exports: [HisJobsSharedModule]
  });
})();
let HisTranslationCoreModule = /*#__PURE__*/(() => {
  class HisTranslationCoreModule {
    static {
      this.ɵfac = function HisTranslationCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisTranslationCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisTranslationCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisTranslationService],
        imports: [HisTranslationSharedModule, HisTranslationSharedModule]
      });
    }
  }
  return HisTranslationCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisTranslationCoreModule, {
    imports: [HisTranslationSharedModule],
    exports: [HisTranslationSharedModule]
  });
})();

/**
 * The core module for the generic search.
 */
let HisFileUploadCoreModule = /*#__PURE__*/(() => {
  class HisFileUploadCoreModule {
    static {
      this.ɵfac = function HisFileUploadCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisFileUploadCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisFileUploadCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [HisFileUploadService, HisDocumentMetadataCategoryService],
        imports: [HisFileUploadSharedModule, HisFileUploadSharedModule]
      });
    }
  }
  return HisFileUploadCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisFileUploadCoreModule, {
    imports: [HisFileUploadSharedModule],
    exports: [HisFileUploadSharedModule]
  });
})();

/**
 * redirect root page to HISinOne portal
 */
let HisStartpageComponent = /*#__PURE__*/(() => {
  class HisStartpageComponent {
    ngOnInit() {
      window.location.href = '../../pages/cs/sys/portal/hisinoneStartPage.faces';
    }
    static {
      this.ɵfac = function HisStartpageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisStartpageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: HisStartpageComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 0,
        vars: 0,
        template: function HisStartpageComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return HisStartpageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * CoreModule for problem case (a.k.a. Kommunikationstool).
 */
let HisProblemCaseCoreModule = /*#__PURE__*/(() => {
  class HisProblemCaseCoreModule {
    static {
      this.ɵfac = function HisProblemCaseCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisProblemCaseCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisProblemCaseCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [ProblemCaseService],
        imports: [HisProblemCaseSharedModule, HisProblemCaseSharedModule]
      });
    }
  }
  return HisProblemCaseCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisProblemCaseCoreModule, {
    imports: [HisProblemCaseSharedModule],
    exports: [HisProblemCaseSharedModule]
  });
})();
const ROUTES = [{
  path: '',
  pathMatch: 'full',
  component: HisStartpageComponent,
  resolve: {
    boot: HisBootstrapService
  }
}, {
  path: 'hisng',
  loadChildren: () => Promise.resolve().then(function () {
    return hisPagesCore_module;
  }).then(m => m.HisPagesCoreModule),
  resolve: {
    boot: HisBootstrapService
  }
}];
/**
 * The HIS Angular library. Import HisCoreModule in the root module of
 * all HIS Angular projects.
 */
let HisCoreModule = /*#__PURE__*/(() => {
  class HisCoreModule {
    constructor() {
      const parentModule = inject(HisCoreModule, {
        optional: true,
        skipSelf: true
      });
      if (parentModule) {
        throw new Error('HisCoreModule may be imported in AppModule only. Use HisSharedModule instead.');
      }
    }
    static {
      this.ɵfac = function HisCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HisCoreModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: HisCoreModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [Title, HTTPListener, HTTPStatus, {
          provide: HTTP_INTERCEPTORS,
          useClass: HTTPListener,
          multi: true
        }],
        imports: [HttpClientModule, HisSharedModule, HisAuthCoreModule, HisCoreCoreModule, HisDynamicFormCoreModule, HisGenericsearchCoreModule, HisJobsCoreModule, HisPagesCoreModule, HisTreeCoreModule, HisTranslationCoreModule, HisFileUploadCoreModule, HisCommunicationlogCoreModule, RouterModule.forChild(ROUTES), HisProblemCaseCoreModule, HisSharedModule, HisAuthCoreModule, HisCoreCoreModule, HisDynamicFormCoreModule, HisGenericsearchCoreModule, HisJobsCoreModule, HisTreeCoreModule, HisTranslationCoreModule, HisFileUploadCoreModule, HisCommunicationlogCoreModule, HisProblemCaseCoreModule]
      });
    }
  }
  return HisCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HisCoreModule, {
    imports: [HttpClientModule, HisSharedModule, HisAuthCoreModule, HisCoreCoreModule, HisDynamicFormCoreModule, HisGenericsearchCoreModule, HisJobsCoreModule, HisPagesCoreModule, HisTreeCoreModule, HisTranslationCoreModule, HisFileUploadCoreModule, HisCommunicationlogCoreModule, i1$3.RouterModule, HisProblemCaseCoreModule],
    exports: [HisSharedModule, HisAuthCoreModule, HisCoreCoreModule, HisDynamicFormCoreModule, HisGenericsearchCoreModule, HisJobsCoreModule, HisTreeCoreModule, HisTranslationCoreModule, HisFileUploadCoreModule, HisCommunicationlogCoreModule, HisProblemCaseCoreModule]
  });
})();
class HisDynamicFormTestBase {
  static getTestbedConfiguration(config, additionalProviders, additionalImports) {
    const result = () => {
      let baseConfig = {
        name: 'Form',
        controlType: HisDynamicFieldType.Form,
        label: 'Form',
        children: [config]
      };
      let providers = [{
        provide: ComponentFixtureAutoDetect,
        useValue: true
      }, {
        provide: 'injectedData',
        useValue: {
          formGroup: new UntypedFormGroup({}),
          options: config,
          valueGroup: new HisValueGroup(baseConfig.children.length)
        }
      }];
      let imports = [
      // Angular
      BrowserAnimationsModule,
      // HIS
      HisCoreModule];
      if (additionalProviders) {
        providers = providers.concat(additionalProviders);
      }
      if (additionalImports) {
        imports = imports.concat(additionalImports);
      }
      TestBed.configureTestingModule({
        imports,
        declarations: [],
        providers,
        teardown: {
          destroyAfterEach: false
        }
      }).compileComponents();
    };
    return result;
  }
}
class HisJobStatus {}
class TreeNodeData {}

/*
 * Public API Surface of hisng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { COMPONENT_BASE, CONFIRM_PDIALOG_KEY, CommunicationLogFilterValue, DAY_ATTRIBUTE_CURRENT_DAY, DAY_ATTRIBUTE_SELECTED_DAY, DISPLAY_BEHAVIOUR, DataDictionary, DayAttribute, DdContextEntriesMap, DdEntryMerged, DynamicComponent, DynamicContent, DynamicObjects, DynamicValue, ENGLISH_DATE_WITH_DAYOFWEEK_PIPE_FORMAT, ErrorMessage, ExceptionResponse, FilesChangedEvent, FilesMutatedEvent, GERMAN_DATE_WITH_DAYOFWEEK_PIPE_FORMAT, GUIComponent, GUIComponentField, GenericValue, GridCalendarUtils, HISSEARCHSELECTPOPUPCOMPONENT_VALUE_ACCESSOR, HISTREESELECTCOMPONENT_VALUE_ACCESSOR, HisAccessDisabledPageComponent, HisAmountPipe, HisAuthCoreModule, HisAuthGuard, HisAuthService, HisAuthSharedModule, HisAutoCompleteEagerDataSourceDirective, HisAutoCompleteLazyDataSourceDirective, HisBackendRequestOptions, HisBackendService, HisBaseGlobalsService, HisBootstrapService, HisBrowserBackButtonLockComponent, HisButtonTitleDirective, HisCacheService, HisCalendarDefaultsDirective, HisChipsDirective, HisCkeditorComponent, HisCkeditorModule, HisCkeditorSharedModule, HisCommunicationlogComponent, HisCommunicationlogCoreModule, HisCommunicationlogSharedModule, HisComponentRegistryService, HisComponentRegistryServiceInitilizer, HisConfirmDialogComponent, HisConfirmationService, HisControlValueAccessor, HisCoreCoreModule, HisCoreModule, HisCoreSharedModule, HisDatePipe, HisDdDirective, HisDdDirectiveRegistryService, HisDdService, HisDdValidator, HisDeleteActionDirective, HisDialogHeaderComponent, HisDialogHeaderPaginatorComponent, HisDisplayCollapsibleTextViewComponent, HisDisplayEmailComponent, HisDisplayExpandableComponent, HisDisplayGridCalendarComponent, HisDisplayGridCalendarDayComponent, HisDisplayGridCalendarLegendComponent, HisDisplayGridCalendarMonthComponent, HisDisplayPhoneComponent, HisDisplaySharedModule, HisDisplayTextComponent, HisDisplayWebShareComponent, HisDisplayWeblinkComponent, HisDocumentMetadataCategoryService, HisDocumentationLinkComponent, HisDynamicContainerComponent, HisDynamicContentDirective, HisDynamicContentUtils, HisDynamicFieldBase, HisDynamicFieldComponent, HisDynamicFieldConfig, HisDynamicFieldType, HisDynamicFormCoreModule, HisDynamicFormGroupUtils, HisDynamicFormSharedModule, HisDynamicFormTestBase, HisFileUploadCategorySelectComponent, HisFileUploadComponent, HisFileUploadCoreModule, HisFileUploadDirective, HisFileUploadPlamComponent, HisFileUploadService, HisFileUploadSharedModule, HisFocusableButtonDirective, HisFormDefaultsDirective, HisFormUtils, HisFrozenColDirective, HisGenericEntityService, HisGenericValueService, HisGenericsearchCoreModule, HisGenericsearchSharedModule, HisGlobalDataService, HisHeadingComponent, HisHelptextComponent, HisHtmlUnsafePipe, HisImageDirective, HisInfoPanelComponent, HisInputSharedModule, HisInputTranslationDirective, HisJobService, HisJobStarterComponent, HisJobStatus, HisJobsCoreModule, HisJobsSharedModule, HisLinkComponent, HisListviewComponent, HisListviewEntryComponent, HisLowercasefirstletterPipe, HisModificationDetectionDirective, HisMultiselectComponent, HisMultiselectDefaultsDirective, HisMultiselectPlamComponent, HisNavigationService, HisNavigationSharedModule, HisNotificationService, HisPageComponent, HisPageTitleDirective, HisPanelDirective, HisPlamComponent, HisPlamDirective, HisProblemCaseCoreModule, HisProblemCaseSharedModule, HisReorderTableService, HisReplacePipe, HisRequestComponent, HisRouteService, HisScrollNearEndDirective, HisScrollwithmeDirective, HisSearch, HisSearchCriteria$1 as HisSearchCriteria, HisSearchCriteriaGroup, HisSearchCriteriaOperator, HisSearchCriteriagroupComponent, HisSearchFormComponent, HisSearchFormComponentBase, HisSearchFormResultComponent, HisSearchFormResultComponentBase, HisSearchFormWidgetComponent, HisSearchGroup$1 as HisSearchGroup, HisSearchGroupInfo, HisSearchInfoCriteriaGroup, HisSearchInfoItem, HisSearchResult, HisSearchResultComponent, HisSearchResultConfigComponent, HisSearchResultHeaderContextProviderDirective, HisSearchResultRow, HisSearchResultRowsPerPageComponent, HisSearchResultSearchInfoComponent, HisSearchResultTableCellComponent, HisSearchSaveParamsComponent, HisSearchSelectComponent, HisSearchSelectComponentBase, HisSearchSelectPopupComponent, HisSearchSelectPopupComponentBase, HisSearchSelectionSetting, HisSearchService, HisSearchTreeSelectComponent, HisSendProblemCaseComponent, HisSharedModule, HisStepsDirective, HisStructureSharedModule, HisSummernoteComponent, HisSummernoteModule, HisSummernoteSharedModule, HisTableConfigComponent, HisTableConfigResults, HisTestUtils, HisTranslatedHtmlComponent, HisTranslatedTextComponent, HisTranslationCoreModule, HisTranslationPipe, HisTranslationSelectorComponent, HisTranslationService, HisTranslationSharedModule, HisTreeCoreModule, HisTreeSelectAutocompleteComponent, HisTreeSelectComponent, HisTreeSelectPopupComponent, HisTreeService, HisTreeSharedModule, HisTrimInputDirective, HisUiPipe, HisUiService, HisUiddPipe, HisUploadConfiguration, HisUploadFile, HisUploadFileDownloadComponent, HisUploadFileImageComponent, HisUploadListComponent, HisUppercasefirstletterPipe, HisUrlUtils, HisUserProfileService, HisValueGroup, HisWizardComponent, HisWizardPageComponent, Language, Month, Notification, NotificationType, NotificationsComponent, RestSearchResult, SvgService, TreeNodeData, UploadFieldConfigResponse, hisChildRoutes, hisRootRoutes, initializeLocaleData, searchFieldConfig };
